export const stores = [
  {
    店號: 112879,
    店名: '碇內',
    地址: '基隆市暖暖區源遠路158號160號',
    縣市: '基隆市'
  },
  {
    店號: 117140,
    店名: '德信',
    地址: '基隆市信義區東信路50號52號',
    縣市: '基隆市'
  },
  {
    店號: 117896,
    店名: '深澳坑',
    地址: '基隆市信義區深澳坑路2-6號2-7號',
    縣市: '基隆市'
  },
  {
    店號: 118419,
    店名: '聖心',
    地址: '基隆市中山區西定路38號40號',
    縣市: '基隆市'
  },
  {
    店號: 119216,
    店名: '篤鑫',
    地址: '基隆市七堵區堵南街22-1號1樓',
    縣市: '基隆市'
  },
  {
    店號: 119788,
    店名: '富華',
    地址: '基隆市中山區中華路9號',
    縣市: '基隆市'
  },
  {
    店號: 123525,
    店名: '滿福',
    地址: '基隆市信義區深澳坑路166之30號1樓',
    縣市: '基隆市'
  },
  {
    店號: 127103,
    店名: '暖鑫',
    地址: '基隆市暖暖區暖暖街554號',
    縣市: '基隆市'
  },
  {
    店號: 127114,
    店名: '新五福',
    地址: '基隆市七堵區福五街80號82號1樓',
    縣市: '基隆市'
  },
  {
    店號: 132415,
    店名: '正光',
    地址: '基隆市七堵區自治街9號11號',
    縣市: '基隆市'
  },
  {
    店號: 138697,
    店名: '新福樂',
    地址: '基隆市信義區深溪路43號45號1樓',
    縣市: '基隆市'
  },
  {
    店號: 139313,
    店名: '新武嶺',
    地址: '基隆市安樂區基金一路168之26號',
    縣市: '基隆市'
  },
  {
    店號: 140597,
    店名: '和平島',
    地址: '基隆市中正區和一路125號127號',
    縣市: '基隆市'
  },
  {
    店號: 141338,
    店名: '福聚',
    地址: '基隆市七堵區實踐路286號福二街229號1樓',
    縣市: '基隆市'
  },
  {
    店號: 143699,
    店名: '崁頂',
    地址: '基隆市仁愛區仁四路60號62號1樓',
    縣市: '基隆市'
  },
  {
    店號: 144670,
    店名: '華新一',
    地址: '基隆市七堵區華新一路22號26號1樓',
    縣市: '基隆市'
  },
  {
    店號: 151830,
    店名: '大武嶺',
    地址: '基隆市安樂區大武嶺里基金一路135巷21弄2-1號',
    縣市: '基隆市'
  },
  {
    店號: 154840,
    店名: '武訓',
    地址: '基隆市安樂區武訓街102號1樓',
    縣市: '基隆市'
  },
  {
    店號: 155522,
    店名: '和豐',
    地址: '基隆市中正區新豐街203號1樓',
    縣市: '基隆市'
  },
  {
    店號: 155625,
    店名: '極上',
    地址: '基隆市仁愛區仁三路66號愛二路54巷10號1樓',
    縣市: '基隆市'
  },
  {
    店號: 159177,
    店名: '愛鑫',
    地址: '基隆市仁愛區愛二路65號',
    縣市: '基隆市'
  },
  {
    店號: 161295,
    店名: '漁港',
    地址: '基隆市中正區中正路672號',
    縣市: '基隆市'
  },
  {
    店號: 163512,
    店名: '六工',
    地址: '基隆市七堵區工建路1之22號1之23號1樓',
    縣市: '基隆市'
  },
  {
    店號: 164065,
    店名: '新財發',
    地址: '基隆市中正區新豐街303巷11弄1號3號1樓',
    縣市: '基隆市'
  },
  {
    店號: 164593,
    店名: '新長基',
    地址: '基隆市安樂區安樂路二段161號',
    縣市: '基隆市'
  },
  {
    店號: 170255,
    店名: '德復',
    地址: '基隆市中山區復興路193號195號197號1樓',
    縣市: '基隆市'
  },
  {
    店號: 170886,
    店名: '基金',
    地址: '基隆市安樂區麥金路197號1樓',
    縣市: '基隆市'
  },
  {
    店號: 171007,
    店名: '七堵',
    地址: '基隆市七堵區明德一路174號',
    縣市: '基隆市'
  },
  {
    店號: 171155,
    店名: '新福成',
    地址: '基隆市仁愛區仁二路84號86號1樓',
    縣市: '基隆市'
  },
  {
    店號: 174040,
    店名: '基醫',
    地址: '基隆市信義區信二路268號1樓',
    縣市: '基隆市'
  },
  {
    店號: 179827,
    店名: '新仁二',
    地址: '基隆市仁愛區仁二路11號13號1樓',
    縣市: '基隆市'
  },
  {
    店號: 180986,
    店名: '基隆',
    地址: '基隆市仁愛區仁二路236號',
    縣市: '基隆市'
  },
  {
    店號: 183284,
    店名: '晨曦',
    地址: '基隆市暖暖區東勢街6之52號6之53號1樓',
    縣市: '基隆市'
  },
  {
    店號: 184874,
    店名: '新廟口',
    地址: '基隆市仁愛區仁二路228號1樓',
    縣市: '基隆市'
  },
  {
    店號: 186320,
    店名: '安一',
    地址: '基隆市安樂區安一路172及174號',
    縣市: '基隆市'
  },
  {
    店號: 187530,
    店名: '麥金',
    地址: '基隆市安樂區基金三路80號80-1號',
    縣市: '基隆市'
  },
  {
    店號: 189075,
    店名: '永富',
    地址: '基隆市七堵區永富路99號101號103號1樓',
    縣市: '基隆市'
  },
  {
    店號: 194538,
    店名: '基隆南',
    地址: '基隆市仁愛區港西街5號1樓',
    縣市: '基隆市'
  },
  {
    店號: 196279,
    店名: '美的',
    地址: '基隆市信義區教孝街28號1樓',
    縣市: '基隆市'
  },
  {
    店號: 196707,
    店名: '港隆',
    地址: '基隆市仁愛區孝四路23號1樓',
    縣市: '基隆市'
  },
  {
    店號: 197412,
    店名: '忠三',
    地址: '基隆市仁愛區忠三路52之1號54號1樓',
    縣市: '基隆市'
  },
  {
    店號: 197777,
    店名: '旭東',
    地址: '基隆市中正區中正路54號',
    縣市: '基隆市'
  },
  {
    店號: 197984,
    店名: '瑞金',
    地址: '基隆市安樂區基金三路75-1號',
    縣市: '基隆市'
  },
  {
    店號: 200941,
    店名: '海洋',
    地址: '基隆市中正區中正路609號1樓',
    縣市: '基隆市'
  },
  {
    店號: 207425,
    店名: '港都',
    地址: '基隆市中正區義二路8號1樓',
    縣市: '基隆市'
  },
  {
    店號: 208082,
    店名: '港富',
    地址: '基隆市中山區中華路93號',
    縣市: '基隆市'
  },
  {
    店號: 209122,
    店名: '篤勝',
    地址: '基隆市七堵區大德路103號',
    縣市: '基隆市'
  },
  {
    店號: 210535,
    店名: '福二',
    地址: '基隆市七堵區福二街157號1樓',
    縣市: '基隆市'
  },
  {
    店號: 210720,
    店名: '七堵站',
    地址: '基隆市七堵區東新街2號1樓',
    縣市: '基隆市'
  },
  {
    店號: 211398,
    店名: '極緻',
    地址: '基隆市仁愛區仁二路211號1樓',
    縣市: '基隆市'
  },
  {
    店號: 214825,
    店名: '新華成',
    地址: '基隆市仁愛區成功一路115號117號',
    縣市: '基隆市'
  },
  {
    店號: 215297,
    店名: '翔濱',
    地址: '基隆市中正區建國里祥豐街339號',
    縣市: '基隆市'
  },
  {
    店號: 217444,
    店名: '哨船頭',
    地址: '基隆市中正區義一路43號1樓',
    縣市: '基隆市'
  },
  {
    店號: 227625,
    店名: '東明',
    地址: '基隆市信義區東明路181號183號1樓',
    縣市: '基隆市'
  },
  {
    店號: 228190,
    店名: '新和慶',
    地址: '基隆市安樂區中和路166之5號166之6號1樓',
    縣市: '基隆市'
  },
  {
    店號: 228639,
    店名: '武晴',
    地址: '基隆市安樂區基金一路214之17號',
    縣市: '基隆市'
  },
  {
    店號: 230849,
    店名: '樂三',
    地址: '基隆市安樂區樂利三街257號259號1樓',
    縣市: '基隆市'
  },
  {
    店號: 231989,
    店名: '觀山海',
    地址: '基隆市中正區砂子里觀海街49號51號1樓',
    縣市: '基隆市'
  },
  {
    店號: 232650,
    店名: '基義',
    地址: '基隆市中正區義二路181號185號1樓',
    縣市: '基隆市'
  },
  {
    店號: 236696,
    店名: '愛六',
    地址: '基隆市仁愛區仁一路281號1樓',
    縣市: '基隆市'
  },
  {
    店號: 236788,
    店名: '深瑞',
    地址: '基隆市信義區深澳坑路129號1樓',
    縣市: '基隆市'
  },
  {
    店號: 238278,
    店名: '新壯觀',
    地址: '基隆市安樂區麥金路64號66號1樓',
    縣市: '基隆市'
  },
  {
    店號: 239271,
    店名: '德欣',
    地址: '基隆市中山區復興路328號之6號之7號1樓',
    縣市: '基隆市'
  },
  {
    店號: 240167,
    店名: '新暖東',
    地址: '基隆市暖暖區暖暖街177號1樓',
    縣市: '基隆市'
  },
  {
    店號: 240983,
    店名: '新大慶',
    地址: '基隆市中山區中和路168巷7弄13號15號1樓',
    縣市: '基隆市'
  },
  {
    店號: 249186,
    店名: '暖碇',
    地址: '基隆市暖暖區碇內街9號11號',
    縣市: '基隆市'
  },
  {
    店號: 249348,
    店名: '崇信',
    地址: '基隆市信義區東信路212-4,214號1F',
    縣市: '基隆市'
  },
  {
    店號: 249496,
    店名: '杰昕',
    地址: '基隆市信義區信二路243號245號',
    縣市: '基隆市'
  },
  {
    店號: 249511,
    店名: '孝三',
    地址: '基隆市仁愛區孝三路89號91號1樓',
    縣市: '基隆市'
  },
  {
    店號: 249599,
    店名: '八斗子',
    地址: '基隆市中正區北寧路327號1樓',
    縣市: '基隆市'
  },
  {
    店號: 250452,
    店名: '財豐',
    地址: '基隆市中正區新豐街389號1樓',
    縣市: '基隆市'
  },
  {
    店號: 250728,
    店名: '樂添',
    地址: '基隆市安樂區樂利二街62巷291號2樓292號293號1樓',
    縣市: '基隆市'
  },
  {
    店號: 886303,
    店名: '龍騰',
    地址: '基隆市中正區義一路22號24號',
    縣市: '基隆市'
  },
  {
    店號: 891246,
    店名: '巧龍',
    地址: '基隆市七堵區百三街61號',
    縣市: '基隆市'
  },
  {
    店號: 892272,
    店名: '信二',
    地址: '基隆市信義區信二路167號',
    縣市: '基隆市'
  },
  {
    店號: 906553,
    店名: '正濱',
    地址: '基隆市中正區豐稔街27號29號',
    縣市: '基隆市'
  },
  {
    店號: 906759,
    店名: '北寧',
    地址: '基隆市中正區北寧路382號382-5號',
    縣市: '基隆市'
  },
  {
    店號: 928368,
    店名: '豐勝',
    地址: '基隆市中正區中正路322號',
    縣市: '基隆市'
  },
  {
    店號: 942478,
    店名: '新金樂',
    地址: '基隆市安樂區麥金路427號',
    縣市: '基隆市'
  },
  {
    店號: 951003,
    店名: '深美',
    地址: '基隆市信義區深美街196號',
    縣市: '基隆市'
  },
  {
    店號: 962313,
    店名: '坤海',
    地址: '基隆市信義區東明路69號',
    縣市: '基隆市'
  },
  {
    店號: 970738,
    店名: '慶龍',
    地址: '基隆市仁愛區南榮路187號1樓',
    縣市: '基隆市'
  },
  {
    店號: 977142,
    店名: '源遠',
    地址: '基隆市暖暖區源遠路294號296號298號1樓',
    縣市: '基隆市'
  },
  {
    店號: 981233,
    店名: '極品',
    地址: '基隆市仁愛區仁三路19號21號1,2樓',
    縣市: '基隆市'
  },
  {
    店號: 989086,
    店名: '仁五',
    地址: '基隆市仁愛區仁五路63號1樓',
    縣市: '基隆市'
  },
  {
    店號: 990879,
    店名: '大武崙',
    地址: '基隆市安樂區基金一路381號383號1樓',
    縣市: '基隆市'
  },
  {
    店號: 110817,
    店名: '千翔',
    地址: '台北市中正區許昌街17號1樓',
    縣市: '台北市'
  },
  {
    店號: 111278,
    店名: '前港',
    地址: '台北市士林區後港街98之1號2號1樓',
    縣市: '台北市'
  },
  {
    店號: 111636,
    店名: '江東',
    地址: '台北市中山區長安東路二段43號45-1號1樓',
    縣市: '台北市'
  },
  {
    店號: 113089,
    店名: '秀湖',
    地址: '台北市內湖區成功路四段359號1樓',
    縣市: '台北市'
  },
  {
    店號: 113160,
    店名: '指南',
    地址: '台北市文山區指南路一段34號36號1樓',
    縣市: '台北市'
  },
  {
    店號: 114510,
    店名: '松錦',
    地址: '台北市中山區松江路295號295-1號1樓',
    縣市: '台北市'
  },
  {
    店號: 114554,
    店名: '敦北',
    地址: '台北市松山區敦化北路149號1樓',
    縣市: '台北市'
  },
  {
    店號: 114772,
    店名: '環金',
    地址: '台北市內湖區環山路二段81號83號1樓',
    縣市: '台北市'
  },
  {
    店號: 117748,
    店名: '富帆',
    地址: '台北市萬華區華中里萬大路464號一樓',
    縣市: '台北市'
  },
  {
    店號: 118420,
    店名: '鑫重寧',
    地址: '台北市中正區寧波西街86號1樓',
    縣市: '台北市'
  },
  {
    店號: 118899,
    店名: '掬華',
    地址: '台北市中正區中華路二段407號',
    縣市: '台北市'
  },
  {
    店號: 118970,
    店名: '松山',
    地址: '台北市信義區忠孝東路五段386號',
    縣市: '台北市'
  },
  {
    店號: 119146,
    店名: '漢寧',
    地址: '台北市萬華區西寧南路85號',
    縣市: '台北市'
  },
  {
    店號: 119445,
    店名: '權東',
    地址: '台北市中山區民權東路三段71號73號1樓',
    縣市: '台北市'
  },
  {
    店號: 119478,
    店名: '醫學',
    地址: '台北市信義區吳興街257號259號',
    縣市: '台北市'
  },
  {
    店號: 119489,
    店名: '興岩',
    地址: '台北市文山區興隆路二段244巷20號1樓',
    縣市: '台北市'
  },
  {
    店號: 119582,
    店名: '新格蘭',
    地址: '台北市中正區衡陽路27號',
    縣市: '台北市'
  },
  {
    店號: 119711,
    店名: '文山',
    地址: '台北市文山區永安街22巷23號25號1樓',
    縣市: '台北市'
  },
  {
    店號: 120353,
    店名: '福中',
    地址: '台北市信義區福德街159號161號1樓',
    縣市: '台北市'
  },
  {
    店號: 120515,
    店名: '喬治',
    地址: '台北市信義區基隆路二段155號1樓',
    縣市: '台北市'
  },
  {
    店號: 120526,
    店名: '圓泉',
    地址: '台北市大同區酒泉街25號27號1樓',
    縣市: '台北市'
  },
  {
    店號: 121068,
    店名: '新秀',
    地址: '台北市文山區秀明路二段8號10號',
    縣市: '台北市'
  },
  {
    店號: 121079,
    店名: '新三連',
    地址: '台北市信義區逸仙路42巷25號1樓',
    縣市: '台北市'
  },
  {
    店號: 121127,
    店名: '承河',
    地址: '台北市士林區基河路132號1樓',
    縣市: '台北市'
  },
  {
    店號: 121275,
    店名: '樂隆',
    地址: '台北市大安區敦化南路二段331巷14號',
    縣市: '台北市'
  },
  {
    店號: 121356,
    店名: '溫州',
    地址: '台北市大安區羅斯福路三段245號',
    縣市: '台北市'
  },
  {
    店號: 121600,
    店名: '麟光',
    地址: '台北市大安區臥龍街252號及252-1號',
    縣市: '台北市'
  },
  {
    店號: 121622,
    店名: '玉德',
    地址: '台北市南港區玉成街150號1樓',
    縣市: '台北市'
  },
  {
    店號: 121655,
    店名: '福權',
    地址: '台北市中山區民權東路二段96號98號1樓',
    縣市: '台北市'
  },
  {
    店號: 121770,
    店名: '國館',
    地址: '台北市大安區光復南路240巷25號',
    縣市: '台北市'
  },
  {
    店號: 122186,
    店名: '總部',
    地址: '台北市信義區東興路67號1樓',
    縣市: '台北市'
  },
  {
    店號: 122212,
    店名: '崇德',
    地址: '台北市信義區崇德街104號106號1樓',
    縣市: '台北市'
  },
  {
    店號: 122430,
    店名: '金龍',
    地址: '台北市內湖區內湖路二段407號409號411號1樓',
    縣市: '台北市'
  },
  {
    店號: 122463,
    店名: '三德',
    地址: '台北市大同區承德路三段55號57號1樓',
    縣市: '台北市'
  },
  {
    店號: 123123,
    店名: '清圳',
    地址: '台北市內湖區東湖路113巷88號',
    縣市: '台北市'
  },
  {
    店號: 123260,
    店名: '柯鑫',
    地址: '台北市中山區中山北路二段11巷3號1樓',
    縣市: '台北市'
  },
  {
    店號: 125967,
    店名: '龍廣',
    地址: '台北市萬華區廣州街148號',
    縣市: '台北市'
  },
  {
    店號: 127505,
    店名: '福湖',
    地址: '台北市內湖區內湖路一段411巷17號19弄1號',
    縣市: '台北市'
  },
  {
    店號: 127550,
    店名: '辛亥站',
    地址: '台北市文山區辛亥路四段132號',
    縣市: '台北市'
  },
  {
    店號: 127620,
    店名: '建安',
    地址: '台北市大安區敦化南路一段187巷29號',
    縣市: '台北市'
  },
  {
    店號: 127723,
    店名: '東暉',
    地址: '台北市信義區忠孝東路四段514號',
    縣市: '台北市'
  },
  {
    店號: 127790,
    店名: '重南',
    地址: '台北市中正區武昌街一段1-2號1樓',
    縣市: '台北市'
  },
  {
    店號: 128025,
    店名: '鑫越',
    地址: '台北市中山區南京西路12巷9號1樓',
    縣市: '台北市'
  },
  {
    店號: 128036,
    店名: '新工農',
    地址: '台北市信義區忠孝東路五段236巷6-3號8號1樓',
    縣市: '台北市'
  },
  {
    店號: 128058,
    店名: '技安',
    地址: '台北市大安區和平東路三段97號97之1號1樓',
    縣市: '台北市'
  },
  {
    店號: 128069,
    店名: '歡唱',
    地址: '台北市中山區林森北路310巷10號1樓',
    縣市: '台北市'
  },
  {
    店號: 128302,
    店名: '丹陽',
    地址: '台北市中正區杭州南路一段83號',
    縣市: '台北市'
  },
  {
    店號: 128335,
    店名: '統勝',
    地址: '台北市北投區自強街82號',
    縣市: '台北市'
  },
  {
    店號: 128494,
    店名: '稻埕',
    地址: '台北市大同區南京西路436號1F',
    縣市: '台北市'
  },
  {
    店號: 128807,
    店名: '德行',
    地址: '台北市士林區忠誠路二段7號1樓',
    縣市: '台北市'
  },
  {
    店號: 128818,
    店名: '安遠',
    地址: '台北市北投區致遠二路149號',
    縣市: '台北市'
  },
  {
    店號: 128874,
    店名: '中陽',
    地址: '台北市北投區中央北路三段55號57號1樓',
    縣市: '台北市'
  },
  {
    店號: 129095,
    店名: '寶昌',
    地址: '台北市萬華區寶興街184號186號',
    縣市: '台北市'
  },
  {
    店號: 129350,
    店名: '黎元',
    地址: '台北市大安區臥龍街188巷1號',
    縣市: '台北市'
  },
  {
    店號: 129372,
    店名: '天美',
    地址: '台北市士林區天母東路8巷96號98號',
    縣市: '台北市'
  },
  {
    店號: 130132,
    店名: '敦厚',
    地址: '台北市信義區永吉路30巷168弄1號1樓',
    縣市: '台北市'
  },
  {
    店號: 130361,
    店名: '昆福',
    地址: '台北市萬華區昆明街30-1號30-2號1樓',
    縣市: '台北市'
  },
  {
    店號: 130394,
    店名: '吉林',
    地址: '台北市中山區吉林路209號1樓2樓',
    縣市: '台北市'
  },
  {
    店號: 130637,
    店名: '振興醫',
    地址: '台北市北投區振興街45號B1',
    縣市: '台北市'
  },
  {
    店號: 131401,
    店名: '士正',
    地址: '台北市士林區中正路301號1樓',
    縣市: '台北市'
  },
  {
    店號: 131799,
    店名: '成都',
    地址: '台北市萬華區成都路96號1樓',
    縣市: '台北市'
  },
  {
    店號: 131984,
    店名: '三樂',
    地址: '台北市士林區劍潭路21號1樓',
    縣市: '台北市'
  },
  {
    店號: 131995,
    店名: '六條通',
    地址: '台北市中山區林森北路107巷15號1樓',
    縣市: '台北市'
  },
  {
    店號: 132574,
    店名: '新士林',
    地址: '台北市士林區大東路123號125號1樓',
    縣市: '台北市'
  },
  {
    店號: 132909,
    店名: '太學',
    地址: '台北市士林區華岡路45之1號1樓',
    縣市: '台北市'
  },
  {
    店號: 132998,
    店名: '胡適',
    地址: '台北市南港區研究院路二段94號96號98巷1號',
    縣市: '台北市'
  },
  {
    店號: 135012,
    店名: '統誠',
    地址: '台北市信義區松高路11號B2樓',
    縣市: '台北市'
  },
  {
    店號: 135078,
    店名: '凱松',
    地址: '台北市南港區八德路四段778號780號',
    縣市: '台北市'
  },
  {
    店號: 135089,
    店名: '明塑',
    地址: '台北市松山區民生東路四段54號之2一樓',
    縣市: '台北市'
  },
  {
    店號: 135104,
    店名: '碧綠',
    地址: '台北市內湖區內湖路三段59巷1號61號63號',
    縣市: '台北市'
  },
  {
    店號: 135241,
    店名: '永信',
    地址: '台北市信義區永吉路30巷103號',
    縣市: '台北市'
  },
  {
    店號: 135296,
    店名: '仁金',
    地址: '台北市中正區仁愛路二段39號39-1號',
    縣市: '台北市'
  },
  {
    店號: 135414,
    店名: '承富',
    地址: '台北市士林區承德路四段39號',
    縣市: '台北市'
  },
  {
    店號: 135425,
    店名: '松捷',
    地址: '台北市信義區忠孝東路五段1之6號',
    縣市: '台北市'
  },
  {
    店號: 135492,
    店名: '信安',
    地址: '台北市大安區大安路一段218號',
    縣市: '台北市'
  },
  {
    店號: 135528,
    店名: '興北',
    地址: '台北市文山區興隆路三段108號',
    縣市: '台北市'
  },
  {
    店號: 135562,
    店名: '麟運',
    地址: '台北市信義區和平東路三段461號461之1號1樓',
    縣市: '台北市'
  },
  {
    店號: 135610,
    店名: '福源',
    地址: '台北市松山區新東街60巷16號18號1樓',
    縣市: '台北市'
  },
  {
    店號: 135643,
    店名: '松航',
    地址: '台北市松山區敦化北路340-9號',
    縣市: '台北市'
  },
  {
    店號: 135872,
    店名: '漢慶',
    地址: '台北市中正區漢口街一段82號1樓',
    縣市: '台北市'
  },
  {
    店號: 135942,
    店名: '萊福',
    地址: '台北市信義區林口街48號',
    縣市: '台北市'
  },
  {
    店號: 136129,
    店名: '江陵',
    地址: '台北市中山區一江街23號1樓',
    縣市: '台北市'
  },
  {
    店號: 136222,
    店名: '金湖',
    地址: '台北市內湖區文湖街83號85號1樓',
    縣市: '台北市'
  },
  {
    店號: 136406,
    店名: '六福',
    地址: '台北市萬華區漢口街二段73號1樓',
    縣市: '台北市'
  },
  {
    店號: 136565,
    店名: '濟新',
    地址: '台北市中正區濟南路二段50號',
    縣市: '台北市'
  },
  {
    店號: 136716,
    店名: '光復',
    地址: '台北市信義區光復南路471號',
    縣市: '台北市'
  },
  {
    店號: 136831,
    店名: '雙連',
    地址: '台北市大同區民生西路176號',
    縣市: '台北市'
  },
  {
    店號: 136842,
    店名: '長新',
    地址: '台北市中山區長安東路一段75號1樓',
    縣市: '台北市'
  },
  {
    店號: 137052,
    店名: '延年',
    地址: '台北市大同區延平北路三段61-5號',
    縣市: '台北市'
  },
  {
    店號: 137144,
    店名: '麥田',
    地址: '台北市中山區晴光里中山北路三段47號',
    縣市: '台北市'
  },
  {
    店號: 138170,
    店名: '泉源',
    地址: '台北市北投區泉源路30號地下一樓',
    縣市: '台北市'
  },
  {
    店號: 138206,
    店名: '國旺',
    地址: '台北市中山區南京東路一段132巷8號',
    縣市: '台北市'
  },
  {
    店號: 138583,
    店名: '市大',
    地址: '台北市松山區市民大道路四段105號',
    縣市: '台北市'
  },
  {
    店號: 138815,
    店名: '聯成',
    地址: '台北市南港區聯成里昆陽街150-1號150-3號',
    縣市: '台北市'
  },
  {
    店號: 139140,
    店名: '知心',
    地址: '台北市北投區知行路185號1樓',
    縣市: '台北市'
  },
  {
    店號: 140210,
    店名: '中坡',
    地址: '台北市南港區中坡南路47號1樓',
    縣市: '台北市'
  },
  {
    店號: 140276,
    店名: '征東',
    地址: '台北市松山區新東街15巷1號',
    縣市: '台北市'
  },
  {
    店號: 140416,
    店名: '新承德',
    地址: '台北市士林區承德路四段30號',
    縣市: '台北市'
  },
  {
    店號: 141051,
    店名: '佳佳',
    地址: '台北市中山區民生東路二段157號',
    縣市: '台北市'
  },
  {
    店號: 142814,
    店名: '龍京',
    地址: '台北市中山區龍江路104號1樓',
    縣市: '台北市'
  },
  {
    店號: 142870,
    店名: '華技',
    地址: '台北市南港區研究院路三段72號74號1樓',
    縣市: '台北市'
  },
  {
    店號: 142917,
    店名: '鑫貿',
    地址: '台北市南港區經貿二路168號4樓',
    縣市: '台北市'
  },
  {
    店號: 143172,
    店名: '環湖',
    地址: '台北市內湖區環山路一段70號',
    縣市: '台北市'
  },
  {
    店號: 143253,
    店名: '頂好',
    地址: '台北市大安區仁愛路四段79號1號',
    縣市: '台北市'
  },
  {
    店號: 143666,
    店名: '明日',
    地址: '台北市萬華區成都路27巷1號1樓',
    縣市: '台北市'
  },
  {
    店號: 143677,
    店名: '長峰',
    地址: '台北市大同區長安西路45之2號47號1樓',
    縣市: '台北市'
  },
  {
    店號: 143965,
    店名: '延民',
    地址: '台北市大同區民族西路246號248號1樓',
    縣市: '台北市'
  },
  {
    店號: 144290,
    店名: '富陽',
    地址: '台北市大安區和平東路三段298號300號1樓',
    縣市: '台北市'
  },
  {
    店號: 144315,
    店名: '忠林',
    地址: '台北市信義區忠孝東路五段470號1樓',
    縣市: '台北市'
  },
  {
    店號: 144326,
    店名: '港泰',
    地址: '台北市南港區忠孝東路七段359號1樓',
    縣市: '台北市'
  },
  {
    店號: 144636,
    店名: '新光',
    地址: '台北市信義區松高路12號B1樓',
    縣市: '台北市'
  },
  {
    店號: 144795,
    店名: '中貿',
    地址: '台北市南港區經貿二路186號2樓',
    縣市: '台北市'
  },
  {
    店號: 146850,
    店名: '建錦',
    地址: '台北市中山區建國北路二段127號1樓B1樓',
    縣市: '台北市'
  },
  {
    店號: 146931,
    店名: '濟南',
    地址: '台北市大安區濟南路三段12號1樓',
    縣市: '台北市'
  },
  {
    店號: 147141,
    店名: '敦信',
    地址: '台北市大安區仁愛路四段122巷50號1樓',
    縣市: '台北市'
  },
  {
    店號: 147299,
    店名: '松義',
    地址: '台北市信義區松德路271號',
    縣市: '台北市'
  },
  {
    店號: 148052,
    店名: '青園',
    地址: '台北市萬華區青年路18號1樓',
    縣市: '台北市'
  },
  {
    店號: 148100,
    店名: '向揚',
    地址: '台北市南港區向陽路166號1樓',
    縣市: '台北市'
  },
  {
    店號: 148133,
    店名: '鑫安江',
    地址: '台北市中山區長安東路二段178號178-1號1樓',
    縣市: '台北市'
  },
  {
    店號: 148144,
    店名: '松盛',
    地址: '台北市中山區南京東路二段115巷1號',
    縣市: '台北市'
  },
  {
    店號: 148236,
    店名: '新南',
    地址: '台北市中正區新生南路一段126-7號',
    縣市: '台北市'
  },
  {
    店號: 148292,
    店名: '權松',
    地址: '台北市中山區松江路363號',
    縣市: '台北市'
  },
  {
    店號: 148524,
    店名: '丹樺',
    地址: '台北市士林區文林路530號',
    縣市: '台北市'
  },
  {
    店號: 148579,
    店名: '東吉',
    地址: '台北市松山區民生東路五段100號',
    縣市: '台北市'
  },
  {
    店號: 148591,
    店名: '新廈門',
    地址: '台北市中正區廈門街46號1樓',
    縣市: '台北市'
  },
  {
    店號: 148683,
    店名: '萬隆站',
    地址: '台北市文山區羅斯福路五段249號1樓',
    縣市: '台北市'
  },
  {
    店號: 149125,
    店名: '華電',
    地址: '台北市大安區通化街177號',
    縣市: '台北市'
  },
  {
    店號: 149321,
    店名: '新起',
    地址: '台北市萬華區長沙街二段87號1樓',
    縣市: '台北市'
  },
  {
    店號: 149446,
    店名: '中寧',
    地址: '台北市萬華區中華路二段602-1、602-2號1樓',
    縣市: '台北市'
  },
  {
    店號: 149583,
    店名: '鑫台北',
    地址: '台北市中正區黎明里忠孝西路一段35號一樓',
    縣市: '台北市'
  },
  {
    店號: 149594,
    店名: '新萬盛',
    地址: '台北市文山區羅斯福路五段21號1樓',
    縣市: '台北市'
  },
  {
    店號: 149675,
    店名: '園舺',
    地址: '台北市萬華區西園路二段140巷52號',
    縣市: '台北市'
  },
  {
    店號: 149697,
    店名: '三興',
    地址: '台北市信義區吳興街156巷2弄2號4號1樓',
    縣市: '台北市'
  },
  {
    店號: 149789,
    店名: '森北',
    地址: '台北市中山區林森北路108號1樓2樓',
    縣市: '台北市'
  },
  {
    店號: 151335,
    店名: '仁和',
    地址: '台北市信義區正和里光復南路419巷41號',
    縣市: '台北市'
  },
  {
    店號: 151416,
    店名: '葫蘆',
    地址: '台北市士林區延平北路五段134號134-2號1樓',
    縣市: '台北市'
  },
  {
    店號: 153250,
    店名: '鑫寶',
    地址: '台北市萬華區寶興街 43號45號1樓',
    縣市: '台北市'
  },
  {
    店號: 153261,
    店名: '華齡',
    地址: '台北市士林區華齡街17巷2號4號1樓',
    縣市: '台北市'
  },
  {
    店號: 154297,
    店名: '葫東',
    地址: '台北市士林區延平北路五段228號1樓230號1樓2樓',
    縣市: '台北市'
  },
  {
    店號: 154482,
    店名: '羅館',
    地址: '台北市中正區羅斯福路三段316巷16號1樓',
    縣市: '台北市'
  },
  {
    店號: 154507,
    店名: '民東',
    地址: '台北市內湖區民權東路六段82號1樓',
    縣市: '台北市'
  },
  {
    店號: 155083,
    店名: '鑫復',
    地址: '台北市大安區信義路三段178號1樓',
    縣市: '台北市'
  },
  {
    店號: 155223,
    店名: '蘭雅',
    地址: '台北市士林區德行東路6之2號1樓',
    縣市: '台北市'
  },
  {
    店號: 155418,
    店名: '延華',
    地址: '台北市大同區延平北路一段89號91號93號1樓',
    縣市: '台北市'
  },
  {
    店號: 155496,
    店名: '公岩',
    地址: '台北市北投區公館路259號1樓',
    縣市: '台北市'
  },
  {
    店號: 158118,
    店名: '國醫',
    地址: '台北市內湖區成功路二段325號1樓',
    縣市: '台北市'
  },
  {
    店號: 158509,
    店名: '信義',
    地址: '台北市大安區信義路四段265巷12弄1號',
    縣市: '台北市'
  },
  {
    店號: 158657,
    店名: '鑫輝煌',
    地址: '台北市內湖區東湖路119巷49弄2號1樓',
    縣市: '台北市'
  },
  {
    店號: 158738,
    店名: '信林',
    地址: '台北市信義區虎林街222巷7號9號1樓',
    縣市: '台北市'
  },
  {
    店號: 158772,
    店名: '萬芳醫',
    地址: '台北市文山區興隆路三段111號',
    縣市: '台北市'
  },
  {
    店號: 158853,
    店名: '龍山',
    地址: '台北市萬華區康定路203號205號1樓',
    縣市: '台北市'
  },
  {
    店號: 158864,
    店名: '千成',
    地址: '台北市中正區林森南路4號之3',
    縣市: '台北市'
  },
  {
    店號: 158956,
    店名: '泰利',
    地址: '台北市大安區仁愛路四段266巷15弄22號',
    縣市: '台北市'
  },
  {
    店號: 159269,
    店名: '松錢',
    地址: '台北市信義區松隆路192號194號1樓',
    縣市: '台北市'
  },
  {
    店號: 159384,
    店名: '港興',
    地址: '台北市南港區興華路117號119號121號123號125號',
    縣市: '台北市'
  },
  {
    店號: 159454,
    店名: '瑞東',
    地址: '台北市內湖區洲子街102號1樓',
    縣市: '台北市'
  },
  {
    店號: 159513,
    店名: '成美',
    地址: '台北市內湖區新明路317號',
    縣市: '台北市'
  },
  {
    店號: 160074,
    店名: '東勢',
    地址: '台北市松山區南京東路四段133巷6弄1號',
    縣市: '台北市'
  },
  {
    店號: 160247,
    店名: '大永',
    地址: '台北市中山區明水路581巷15號1樓',
    縣市: '台北市'
  },
  {
    店號: 161549,
    店名: '福陽',
    地址: '台北市士林區延平北路五段269號271號1樓',
    縣市: '台北市'
  },
  {
    店號: 162977,
    店名: '萬大',
    地址: '台北市萬華區萬大路245號247號1樓',
    縣市: '台北市'
  },
  {
    店號: 163707,
    店名: '芝玉',
    地址: '台北市士林區忠義街121號',
    縣市: '台北市'
  },
  {
    店號: 163822,
    店名: '瑞湖',
    地址: '台北市內湖區江南街128號',
    縣市: '台北市'
  },
  {
    店號: 164216,
    店名: '凱悅',
    地址: '台北市信義區基隆路一段398號1樓',
    縣市: '台北市'
  },
  {
    店號: 164490,
    店名: '吳興',
    地址: '台北市信義區吳興街284巷18弄2號',
    縣市: '台北市'
  },
  {
    店號: 164618,
    店名: '影城',
    地址: '台北市松山區八德路四段245巷35號',
    縣市: '台北市'
  },
  {
    店號: 164641,
    店名: '新福玉',
    地址: '台北市南港區成福路145號147號',
    縣市: '台北市'
  },
  {
    店號: 164733,
    店名: '瓏馬',
    地址: '台北市內湖區康樂街213號',
    縣市: '台北市'
  },
  {
    店號: 164777,
    店名: '春龍',
    地址: '台北市中山區長春路257號',
    縣市: '台北市'
  },
  {
    店號: 164803,
    店名: '東鑫',
    地址: '台北市松山區民生東路四段55巷10號',
    縣市: '台北市'
  },
  {
    店號: 164939,
    店名: '萬光',
    地址: '台北市中正區中華路二段157號',
    縣市: '台北市'
  },
  {
    店號: 165172,
    店名: '勝權',
    地址: '台北市中山區民權東路二段26號',
    縣市: '台北市'
  },
  {
    店號: 165183,
    店名: '直安',
    地址: '台北市中山區北安路649號',
    縣市: '台北市'
  },
  {
    店號: 165334,
    店名: '康雲',
    地址: '台北市內湖區康寧路一段160號',
    縣市: '台北市'
  },
  {
    店號: 165839,
    店名: '立農',
    地址: '台北市北投區承德路七段378號',
    縣市: '台北市'
  },
  {
    店號: 165943,
    店名: '萬美',
    地址: '台北市文山區萬和街6號2樓之1',
    縣市: '台北市'
  },
  {
    店號: 165976,
    店名: '新育商',
    地址: '台北市松山區寧安街3巷11號1樓',
    縣市: '台北市'
  },
  {
    店號: 165987,
    店名: '國貿',
    地址: '台北市信義區基隆路一段333號B3',
    縣市: '台北市'
  },
  {
    店號: 166049,
    店名: '慶吉',
    地址: '台北市大同區重慶北路三段47號49號1樓',
    縣市: '台北市'
  },
  {
    店號: 166094,
    店名: '瑞富',
    地址: '台北市內湖區瑞光路188巷51號1樓',
    縣市: '台北市'
  },
  {
    店號: 166175,
    店名: '合江',
    地址: '台北市中山區合江街60號',
    縣市: '台北市'
  },
  {
    店號: 166359,
    店名: '興信鑫',
    地址: '台北市中正區館前路59號1樓',
    縣市: '台北市'
  },
  {
    店號: 166474,
    店名: '樂陽',
    地址: '台北市內湖區陽光街349號1樓',
    縣市: '台北市'
  },
  {
    店號: 166614,
    店名: '樂湖',
    地址: '台北市內湖區東湖路120號1樓',
    縣市: '台北市'
  },
  {
    店號: 166739,
    店名: '金華',
    地址: '台北市大安區金華街140號1樓',
    縣市: '台北市'
  },
  {
    店號: 166832,
    店名: '吉仁',
    地址: '台北市松山區延吉街27-1號1樓',
    縣市: '台北市'
  },
  {
    店號: 166865,
    店名: '港環球',
    地址: '台北市南港區忠孝東路七段371號B2',
    縣市: '台北市'
  },
  {
    店號: 166876,
    店名: '萬東',
    地址: '台北市萬華區萬大路486巷61號63號65號1樓',
    縣市: '台北市'
  },
  {
    店號: 167190,
    店名: '誠安',
    地址: '台北市大安區敦化南路一段247巷12號1樓',
    縣市: '台北市'
  },
  {
    店號: 167260,
    店名: '吉鑫',
    地址: '台北市中山區南京東路二段11號1樓',
    縣市: '台北市'
  },
  {
    店號: 167433,
    店名: '直福',
    地址: '台北市中山區樂群三路218號1樓',
    縣市: '台北市'
  },
  {
    店號: 167466,
    店名: '福瀛',
    地址: '台北市北投區西安街二段345號1樓',
    縣市: '台北市'
  },
  {
    店號: 167581,
    店名: '安松',
    地址: '台北市大安區安東街50之2號50之3號50之4號',
    縣市: '台北市'
  },
  {
    店號: 167950,
    店名: '東門',
    地址: '台北市大安區信義路二段198巷6號1樓',
    縣市: '台北市'
  },
  {
    店號: 169864,
    店名: '港運',
    地址: '台北市南港區玉成街69號1樓',
    縣市: '台北市'
  },
  {
    店號: 170071,
    店名: '東華',
    地址: '台北市北投區裕民一路40巷1號',
    縣市: '台北市'
  },
  {
    店號: 170130,
    店名: '福氣',
    地址: '台北市士林區延平北路六段122號124號1樓',
    縣市: '台北市'
  },
  {
    店號: 170196,
    店名: '鑫櫃',
    地址: '台北市中山區松江路183號183-1號1樓',
    縣市: '台北市'
  },
  {
    店號: 170299,
    店名: '開博',
    地址: '台北市中正區開封街一段40號42號1樓',
    縣市: '台北市'
  },
  {
    店號: 170314,
    店名: '洲子',
    地址: '台北市內湖區瑞光路517號1樓',
    縣市: '台北市'
  },
  {
    店號: 170325,
    店名: '長通',
    地址: '台北市中山區長安東路二段101號',
    縣市: '台北市'
  },
  {
    店號: 170392,
    店名: '復昌',
    地址: '台北市大安區通化里光復南路616號',
    縣市: '台北市'
  },
  {
    店號: 170473,
    店名: '文學',
    地址: '台北市士林區光華路26巷10號1樓',
    縣市: '台北市'
  },
  {
    店號: 170587,
    店名: '天北',
    地址: '台北市士林區天母里天母西路39-1號1樓',
    縣市: '台北市'
  },
  {
    店號: 170819,
    店名: '溫東',
    地址: '台北市大安區和平東路一段266號',
    縣市: '台北市'
  },
  {
    店號: 170864,
    店名: '鵬馳',
    地址: '台北市南港區南港路三段49-1號',
    縣市: '台北市'
  },
  {
    店號: 170945,
    店名: '上弘',
    地址: '台北市松山區敦化北路168號B2',
    縣市: '台北市'
  },
  {
    店號: 170978,
    店名: '中航',
    地址: '台北市中正區林森南路12號',
    縣市: '台北市'
  },
  {
    店號: 170989,
    店名: '天津',
    地址: '台北市中山區天津街65號',
    縣市: '台北市'
  },
  {
    店號: 171063,
    店名: '和金',
    地址: '台北市大安區和平東路一段91號',
    縣市: '台北市'
  },
  {
    店號: 171085,
    店名: '西武',
    地址: '台北市內湖區內湖路一段285巷65弄3號5號1樓',
    縣市: '台北市'
  },
  {
    店號: 171166,
    店名: '秀山',
    地址: '台北市北投區中和街476號478號480號1樓',
    縣市: '台北市'
  },
  {
    店號: 171199,
    店名: '瑞和',
    地址: '台北市內湖區瑞光路316巷56號1樓',
    縣市: '台北市'
  },
  {
    店號: 171421,
    店名: '統威',
    地址: '台北市松山區東興路13-1號1樓15巷3號1樓',
    縣市: '台北市'
  },
  {
    店號: 171683,
    店名: '永明',
    地址: '台北市中山區明水路397巷7弄25號1樓',
    縣市: '台北市'
  },
  {
    店號: 171720,
    店名: '欣福',
    地址: '台北市內湖區民權東路六段120巷7弄8號',
    縣市: '台北市'
  },
  {
    店號: 171764,
    店名: '福榮',
    地址: '台北市士林區中正路220號222號',
    縣市: '台北市'
  },
  {
    店號: 173531,
    店名: '婦聯',
    地址: '台北市松山區健康路224號',
    縣市: '台北市'
  },
  {
    店號: 173874,
    店名: '權金',
    地址: '台北市內湖區金湖路405號1樓',
    縣市: '台北市'
  },
  {
    店號: 173988,
    店名: '延壽',
    地址: '台北市松山區延壽街422號',
    縣市: '台北市'
  },
  {
    店號: 174006,
    店名: '東光',
    地址: '台北市松山區南京東路五段15號1樓',
    縣市: '台北市'
  },
  {
    店號: 174028,
    店名: '三玉',
    地址: '台北市士林區天母東路88之1號1樓',
    縣市: '台北市'
  },
  {
    店號: 174796,
    店名: '龍淵',
    地址: '台北市大安區和平東路二段118巷33號',
    縣市: '台北市'
  },
  {
    店號: 174888,
    店名: '景高',
    地址: '台北市文山區景華里景興路14號',
    縣市: '台北市'
  },
  {
    店號: 174970,
    店名: '松智',
    地址: '台北市信義區莊敬路325巷43號',
    縣市: '台北市'
  },
  {
    店號: 175032,
    店名: '中廣',
    地址: '台北市大安區仁愛路三段25-1號27號',
    縣市: '台北市'
  },
  {
    店號: 175043,
    店名: '庫德',
    地址: '台北市松山區八德路二段366巷7號1樓',
    縣市: '台北市'
  },
  {
    店號: 177463,
    店名: '天福',
    地址: '台北市士林區天福里天母東路８巷39號天母東路8巷41弄1號',
    縣市: '台北市'
  },
  {
    店號: 177485,
    店名: '明湖',
    地址: '台北市內湖區東湖路45號',
    縣市: '台北市'
  },
  {
    店號: 180056,
    店名: '京站',
    地址: '台北市大同區華陰街91號',
    縣市: '台北市'
  },
  {
    店號: 180540,
    店名: '西寧南',
    地址: '台北市萬華區西寧南路141號1樓2樓',
    縣市: '台北市'
  },
  {
    店號: 180595,
    店名: '博嘉',
    地址: '台北市文山區木柵路四段117號119號1樓',
    縣市: '台北市'
  },
  {
    店號: 180687,
    店名: '景星',
    地址: '台北市大同區延平北路三段19之5號21號1樓',
    縣市: '台北市'
  },
  {
    店號: 180861,
    店名: '德芝',
    地址: '台北市士林區士東路266巷5弄18號20號1樓',
    縣市: '台北市'
  },
  {
    店號: 180920,
    店名: '龍泉',
    地址: '台北市大安區羅斯福路三段193號1樓',
    縣市: '台北市'
  },
  {
    店號: 181060,
    店名: '光寶',
    地址: '台北市北投區光明路132之2號1.2樓',
    縣市: '台北市'
  },
  {
    店號: 181118,
    店名: '德寶',
    地址: '台北市士林區忠誠路2段50巷12號',
    縣市: '台北市'
  },
  {
    店號: 181200,
    店名: '堤頂',
    地址: '台北市內湖區堤頂大道二段411號1樓',
    縣市: '台北市'
  },
  {
    店號: 181451,
    店名: '湖光',
    地址: '台北市內湖區基湖路35巷13號1樓',
    縣市: '台北市'
  },
  {
    店號: 181680,
    店名: '松慶',
    地址: '台北市松山區慶城街1號1樓',
    縣市: '台北市'
  },
  {
    店號: 181808,
    店名: '萬運',
    地址: '台北市萬華區西園路一段153號地下室',
    縣市: '台北市'
  },
  {
    店號: 182258,
    店名: '復忠',
    地址: '台北市大安區光復南路98之3號98之5號',
    縣市: '台北市'
  },
  {
    店號: 182269,
    店名: '光忠',
    地址: '台北市大安區復興南路一段107巷5弄1號1樓',
    縣市: '台北市'
  },
  {
    店號: 183309,
    店名: '鑫國語',
    地址: '台北市中正區南昌路一段135號1樓',
    縣市: '台北市'
  },
  {
    店號: 183572,
    店名: '華興',
    地址: '台北市文山區木柵路一段284號286號1樓',
    縣市: '台北市'
  },
  {
    店號: 183697,
    店名: '長城',
    地址: '台北市中山區中山北路二段56號1樓',
    縣市: '台北市'
  },
  {
    店號: 183848,
    店名: '仟瑞',
    地址: '台北市大同區民生西路84號1樓',
    縣市: '台北市'
  },
  {
    店號: 183996,
    店名: '瑞景',
    地址: '台北市內湖區瑞光路583巷30號1樓',
    縣市: '台北市'
  },
  {
    店號: 184139,
    店名: '統新',
    地址: '台北市中正區臨沂街27巷10號1樓',
    縣市: '台北市'
  },
  {
    店號: 184405,
    店名: '集鑫',
    地址: '台北市士林區延平北路六段229號231號',
    縣市: '台北市'
  },
  {
    店號: 184472,
    店名: '墘運',
    地址: '台北市內湖區洲子街12號1樓',
    縣市: '台北市'
  },
  {
    店號: 184494,
    店名: '成昆',
    地址: '台北市萬華區成都路68號1樓',
    縣市: '台北市'
  },
  {
    店號: 184508,
    店名: '大饌',
    地址: '台北市士林區大東路35號1樓',
    縣市: '台北市'
  },
  {
    店號: 184737,
    店名: '大華',
    地址: '台北市萬華區萬大路495號497號',
    縣市: '台北市'
  },
  {
    店號: 184782,
    店名: '復春',
    地址: '台北市松山區復興北路179號',
    縣市: '台北市'
  },
  {
    店號: 184793,
    店名: '警廣',
    地址: '台北市中正區廣州街10-2號10-3號10-4部分號1樓',
    縣市: '台北市'
  },
  {
    店號: 184955,
    店名: '華慶',
    地址: '台北市中正區中華路一段59之16號',
    縣市: '台北市'
  },
  {
    店號: 184988,
    店名: '塔城',
    地址: '台北市大同區長安西路271號1樓及273巷2號1樓',
    縣市: '台北市'
  },
  {
    店號: 184999,
    店名: '鑫錦州',
    地址: '台北市中山區錦州街263號',
    縣市: '台北市'
  },
  {
    店號: 185051,
    店名: '新大直',
    地址: '台北市中山區北安路621巷48號',
    縣市: '台北市'
  },
  {
    店號: 185143,
    店名: '昌隆',
    地址: '台北市信義區基隆路二段131-4號',
    縣市: '台北市'
  },
  {
    店號: 185154,
    店名: '美麗華',
    地址: '台北市中山區北安路839-1號',
    縣市: '台北市'
  },
  {
    店號: 185165,
    店名: '新饒河',
    地址: '台北市松山區八德路四段697號1樓',
    縣市: '台北市'
  },
  {
    店號: 185213,
    店名: '忠陽',
    地址: '台北市南港區忠孝東路六段465號1樓',
    縣市: '台北市'
  },
  {
    店號: 185268,
    店名: '科技站',
    地址: '台北市大安區復興南路二段203號',
    縣市: '台北市'
  },
  {
    店號: 185279,
    店名: '新愛國',
    地址: '台北市中正區延平南路177號',
    縣市: '台北市'
  },
  {
    店號: 185327,
    店名: '保聖',
    地址: '台北市大同區酒泉街58號60號',
    縣市: '台北市'
  },
  {
    店號: 185338,
    店名: '富港',
    地址: '台北市內湖區港墘路46號48號1樓',
    縣市: '台北市'
  },
  {
    店號: 185394,
    店名: '木盛',
    地址: '台北市文山區木柵路三段88號',
    縣市: '台北市'
  },
  {
    店號: 185408,
    店名: '長中',
    地址: '台北市中山區中山北路二段40-1號',
    縣市: '台北市'
  },
  {
    店號: 185464,
    店名: '榮護',
    地址: '台北市北投區石牌路二段179號1樓',
    縣市: '台北市'
  },
  {
    店號: 185556,
    店名: '豐基',
    地址: '台北市士林區基河路368號370號',
    縣市: '台北市'
  },
  {
    店號: 185567,
    店名: '兒樂',
    地址: '台北市士林區承德路五段55號',
    縣市: '台北市'
  },
  {
    店號: 185604,
    店名: '民美',
    地址: '台北市中山區圓山里中山北路三段57號',
    縣市: '台北市'
  },
  {
    店號: 185659,
    店名: '建欣',
    地址: '台北市中山區建國北路二段13號1樓',
    縣市: '台北市'
  },
  {
    店號: 185682,
    店名: '吉盛',
    地址: '台北市松山區南京東路五段66巷3弄1號1樓',
    縣市: '台北市'
  },
  {
    店號: 185796,
    店名: '新錦祥',
    地址: '台北市中山區錦西街16號',
    縣市: '台北市'
  },
  {
    店號: 185822,
    店名: '研究',
    地址: '台北市南港區研究院路二段14號',
    縣市: '台北市'
  },
  {
    店號: 185833,
    店名: '昆寧',
    地址: '台北市萬華區西寧南路50巷3號5號',
    縣市: '台北市'
  },
  {
    店號: 185888,
    店名: '彩龍',
    地址: '台北市內湖區行善路35號1F',
    縣市: '台北市'
  },
  {
    店號: 186076,
    店名: '港德',
    地址: '台北市南港區福德街373巷25號',
    縣市: '台北市'
  },
  {
    店號: 186087,
    店名: '榮總',
    地址: '台北市北投區石牌路二段301號',
    縣市: '台北市'
  },
  {
    店號: 186157,
    店名: '大永博',
    地址: '台北市中正區博愛路97號1樓',
    縣市: '台北市'
  },
  {
    店號: 186168,
    店名: '通盈',
    地址: '台北市松山區南京東路五段315號',
    縣市: '台北市'
  },
  {
    店號: 186179,
    店名: '悅來',
    地址: '台北市內湖區五分街9號11號1樓',
    縣市: '台北市'
  },
  {
    店號: 186319,
    店名: '喜悅',
    地址: '台北市大安區復興南路二段82-1及82-2號',
    縣市: '台北市'
  },
  {
    店號: 186331,
    店名: '聰明',
    地址: '台北市松山區寶清街34號1樓',
    縣市: '台北市'
  },
  {
    店號: 186353,
    店名: '香城',
    地址: '台北市南港區南港路一段167號1樓',
    縣市: '台北市'
  },
  {
    店號: 186401,
    店名: '大眾',
    地址: '台北市內湖區港墘路221巷41號1樓',
    縣市: '台北市'
  },
  {
    店號: 186434,
    店名: '新泰順',
    地址: '台北市大安區泰順街13號',
    縣市: '台北市'
  },
  {
    店號: 186467,
    店名: '瑞升',
    地址: '台北市大安區杭州南路二段91號',
    縣市: '台北市'
  },
  {
    店號: 186489,
    店名: '鑫館',
    地址: '台北市中正區汀州路三段269號1樓2樓',
    縣市: '台北市'
  },
  {
    店號: 186526,
    店名: '行義',
    地址: '台北市北投區石牌路二段348巷1號3號1樓',
    縣市: '台北市'
  },
  {
    店號: 186537,
    店名: '敦頂',
    地址: '台北市大安區忠孝東路四段101巷7號',
    縣市: '台北市'
  },
  {
    店號: 186559,
    店名: '國學',
    地址: '台北市中山區長春路182號',
    縣市: '台北市'
  },
  {
    店號: 186663,
    店名: '實踐大',
    地址: '台北市中山區大直街70號1樓',
    縣市: '台北市'
  },
  {
    店號: 186696,
    店名: '鐏賢',
    地址: '台北市北投區尊賢街247號',
    縣市: '台北市'
  },
  {
    店號: 186711,
    店名: '興義',
    地址: '台北市萬華區興義街6號8號1樓',
    縣市: '台北市'
  },
  {
    店號: 187057,
    店名: '鑫泉州',
    地址: '台北市中正區汀州路一段285號一樓',
    縣市: '台北市'
  },
  {
    店號: 187286,
    店名: '西安',
    地址: '台北市北投區大興街44號46號1樓',
    縣市: '台北市'
  },
  {
    店號: 187389,
    店名: '廣明',
    地址: '台北市萬華區昆明街285號之3之4',
    縣市: '台北市'
  },
  {
    店號: 187541,
    店名: '德華',
    地址: '台北市士林區文林路669號1樓',
    縣市: '台北市'
  },
  {
    店號: 187552,
    店名: '大中',
    地址: '台北市北投區中央南路一段114號',
    縣市: '台北市'
  },
  {
    店號: 187758,
    店名: '東洋',
    地址: '台北市士林區中山北路七段14巷19號Ｂ1',
    縣市: '台北市'
  },
  {
    店號: 187781,
    店名: '華江',
    地址: '台北市萬華區華江里20鄰環河南路二段200號',
    縣市: '台北市'
  },
  {
    店號: 187806,
    店名: '征唐',
    地址: '台北市松山區新東街41-7號',
    縣市: '台北市'
  },
  {
    店號: 187817,
    店名: '萬福',
    地址: '台北市文山區萬年里羅斯福路五段170巷33及35號',
    縣市: '台北市'
  },
  {
    店號: 188326,
    店名: '雄強',
    地址: '台北市南港區忠孝東路六段276號',
    縣市: '台北市'
  },
  {
    店號: 188452,
    店名: '行龍',
    地址: '台北市內湖區行愛路128號',
    縣市: '台北市'
  },
  {
    店號: 188588,
    店名: '圓武',
    地址: '台北市中山區吉林路28號',
    縣市: '台北市'
  },
  {
    店號: 188599,
    店名: '鑫青天',
    地址: '台北市萬華區青年路144號',
    縣市: '台北市'
  },
  {
    店號: 188681,
    店名: '松民',
    地址: '台北市松山區三民路10號',
    縣市: '台北市'
  },
  {
    店號: 189178,
    店名: '軍總',
    地址: '台北市中正區汀州路三段129號',
    縣市: '台北市'
  },
  {
    店號: 189271,
    店名: '永康',
    地址: '台北市大安區永康街43號',
    縣市: '台北市'
  },
  {
    店號: 189400,
    店名: '星成',
    地址: '台北市內湖區星雲街17號17-1號',
    縣市: '台北市'
  },
  {
    店號: 189695,
    店名: '文忠',
    地址: '台北市文山區忠順街二段10號1樓',
    縣市: '台北市'
  },
  {
    店號: 190042,
    店名: '羅斯福',
    地址: '台北市文山區羅斯福路五段216號',
    縣市: '台北市'
  },
  {
    店號: 190123,
    店名: '世新大',
    地址: '台北市文山區木柵路一段17巷1號1樓',
    縣市: '台北市'
  },
  {
    店號: 190145,
    店名: '鑫壽',
    地址: '台北市松山區延壽街323號',
    縣市: '台北市'
  },
  {
    店號: 190156,
    店名: '新萬隆',
    地址: '台北市文山區羅斯福路六段20號22號',
    縣市: '台北市'
  },
  {
    店號: 190293,
    店名: '冬樂',
    地址: '台北市士林區美崙街112號一樓',
    縣市: '台北市'
  },
  {
    店號: 190330,
    店名: '必成',
    地址: '台北市信義區基隆路一段178號180號1樓',
    縣市: '台北市'
  },
  {
    店號: 190477,
    店名: '麗安',
    地址: '台北市內湖區內湖路一段445號1樓',
    縣市: '台北市'
  },
  {
    店號: 190570,
    店名: '敦隆',
    地址: '台北市大安區敦化南路二段182號',
    縣市: '台北市'
  },
  {
    店號: 190592,
    店名: '德天',
    地址: '台北市士林區德行西路52號1樓',
    縣市: '台北市'
  },
  {
    店號: 190617,
    店名: '凱立',
    地址: '台北市士林區忠義街68號',
    縣市: '台北市'
  },
  {
    店號: 190743,
    店名: '博源',
    地址: '台北市中正區思源街16號',
    縣市: '台北市'
  },
  {
    店號: 190891,
    店名: '天鑫',
    地址: '台北市士林區天玉街8號',
    縣市: '台北市'
  },
  {
    店號: 190905,
    店名: '興復',
    地址: '台北市中山區興安街112號一樓',
    縣市: '台北市'
  },
  {
    店號: 190916,
    店名: '南西',
    地址: '台北市大同區南京西路296號298號1樓',
    縣市: '台北市'
  },
  {
    店號: 190927,
    店名: '漢陽',
    地址: '台北市萬華區昆明街197號199號1樓',
    縣市: '台北市'
  },
  {
    店號: 190938,
    店名: '延埕',
    地址: '台北市大同區延平北路二段159號161號',
    縣市: '台北市'
  },
  {
    店號: 192576,
    店名: '鑫忠孝',
    地址: '台北市大安區忠孝東路四段313號1樓',
    縣市: '台北市'
  },
  {
    店號: 192875,
    店名: '港勝',
    地址: '台北市南港區經貿二路2號B1樓',
    縣市: '台北市'
  },
  {
    店號: 193236,
    店名: '京寶',
    地址: '台北市松山區南京東路五段291巷4之1號4之2號',
    縣市: '台北市'
  },
  {
    店號: 193247,
    店名: '慶林',
    地址: '台北市信義區虎林街151號153號1樓',
    縣市: '台北市'
  },
  {
    店號: 193384,
    店名: '建綸',
    地址: '台北市大安區仁愛路四段151巷33號忠孝東路四段216巷32弄19號21號',
    縣市: '台北市'
  },
  {
    店號: 193524,
    店名: '港麗',
    地址: '台北市南港區忠孝東路七段369號2樓',
    縣市: '台北市'
  },
  {
    店號: 193557,
    店名: '八德',
    地址: '台北市中正區臨沂街1號1樓',
    縣市: '台北市'
  },
  {
    店號: 193731,
    店名: '鑫成',
    地址: '台北市士林區至誠路二段82號1樓',
    縣市: '台北市'
  },
  {
    店號: 193960,
    店名: '科興',
    地址: '台北市大安區復興南路二段271巷2號1樓',
    縣市: '台北市'
  },
  {
    店號: 194077,
    店名: '萬濠',
    地址: '台北市中山區敬業四路1號1樓',
    縣市: '台北市'
  },
  {
    店號: 194572,
    店名: '復錦',
    地址: '台北市中山區復興北路348號1樓',
    縣市: '台北市'
  },
  {
    店號: 194723,
    店名: '世貿',
    地址: '台北市信義區信義路五段5號1樓',
    縣市: '台北市'
  },
  {
    店號: 194882,
    店名: '安美',
    地址: '台北市內湖區石潭里安康路32巷24弄22號1樓',
    縣市: '台北市'
  },
  {
    店號: 195438,
    店名: '華碩二',
    地址: '台北市北投區立德路115號3樓',
    縣市: '台北市'
  },
  {
    店號: 195704,
    店名: '金聯發',
    地址: '台北市內湖區金龍路137號1樓',
    縣市: '台北市'
  },
  {
    店號: 195760,
    店名: '森美',
    地址: '台北市大安區信義路三段65號1樓',
    縣市: '台北市'
  },
  {
    店號: 195807,
    店名: '富比世',
    地址: '台北市信義區松仁路246號248號1樓',
    縣市: '台北市'
  },
  {
    店號: 195900,
    店名: '珍饌',
    地址: '台北市士林區文林路126號1樓',
    縣市: '台北市'
  },
  {
    店號: 195955,
    店名: '忠隆',
    地址: '台北市信義區忠孝東路五段71巷6號1樓',
    縣市: '台北市'
  },
  {
    店號: 196039,
    店名: '昆明',
    地址: '台北市萬華區昆明街76之1號1樓',
    縣市: '台北市'
  },
  {
    店號: 196040,
    店名: '松聯',
    地址: '台北市信義區忠孝東路四段559巷24號1樓',
    縣市: '台北市'
  },
  {
    店號: 196246,
    店名: '羅昌',
    地址: '台北市中正區南昌路二段206號1樓',
    縣市: '台北市'
  },
  {
    店號: 196268,
    店名: '卓聯',
    地址: '台北市大安區羅斯福路四段1號1樓卓聯大樓',
    縣市: '台北市'
  },
  {
    店號: 196316,
    店名: '和樂',
    地址: '台北市大安區和平東路三段228巷45號1樓',
    縣市: '台北市'
  },
  {
    店號: 196464,
    店名: '港華',
    地址: '台北市內湖區港華街46號1樓',
    縣市: '台北市'
  },
  {
    店號: 196497,
    店名: '京磚',
    地址: '台北市大同區華陰街65號1樓',
    縣市: '台北市'
  },
  {
    店號: 196660,
    店名: '大吉',
    地址: '台北市中山區吉林路97號99號1樓',
    縣市: '台北市'
  },
  {
    店號: 197043,
    店名: '墘都',
    地址: '台北市內湖區內湖路一段669號',
    縣市: '台北市'
  },
  {
    店號: 197124,
    店名: '華藏',
    地址: '台北市萬華區西藏路107號107之1號1樓',
    縣市: '台北市'
  },
  {
    店號: 197157,
    店名: '大埔',
    地址: '台北市中正區和平西路二段152號152之1號154號154之1號',
    縣市: '台北市'
  },
  {
    店號: 197191,
    店名: '行天',
    地址: '台北市中山區農安街178號180號',
    縣市: '台北市'
  },
  {
    店號: 197205,
    店名: '雙全',
    地址: '台北市北投區中庸里大業路715-717號',
    縣市: '台北市'
  },
  {
    店號: 197227,
    店名: '瓏山林',
    地址: '台北市內湖區康樂街125巷2號2之1號',
    縣市: '台北市'
  },
  {
    店號: 197353,
    店名: '懷生',
    地址: '台北市大安區忠孝東路三段248巷9號',
    縣市: '台北市'
  },
  {
    店號: 197375,
    店名: '港捷',
    地址: '台北市南港區經貿二路1號',
    縣市: '台北市'
  },
  {
    店號: 197515,
    店名: '銘傳',
    地址: '台北市士林區中山北路五段250號',
    縣市: '台北市'
  },
  {
    店號: 197559,
    店名: '捷盟',
    地址: '台北市萬華區漢中街51號',
    縣市: '台北市'
  },
  {
    店號: 197560,
    店名: '統佳',
    地址: '台北市中山區松江路237號1樓',
    縣市: '台北市'
  },
  {
    店號: 197652,
    店名: '京佳',
    地址: '台北市松山區南京東路五段229號231號1樓',
    縣市: '台北市'
  },
  {
    店號: 197685,
    店名: '薇美',
    地址: '台北市中山區敬業三路11號1樓',
    縣市: '台北市'
  },
  {
    店號: 197733,
    店名: '鑫國泰',
    地址: '台北市信義區忠孝東路五段68號24樓',
    縣市: '台北市'
  },
  {
    店號: 197744,
    店名: '金信',
    地址: '台北市大安區金山南路二段18號1樓',
    縣市: '台北市'
  },
  {
    店號: 197755,
    店名: '毓鄰',
    地址: '台北市內湖區新湖二路160號162號1樓',
    縣市: '台北市'
  },
  {
    店號: 197766,
    店名: '金鑽',
    地址: '台北市中山區民權西路66號',
    縣市: '台北市'
  },
  {
    店號: 197940,
    店名: '安保',
    地址: '台北市內湖區安康路28號1樓',
    縣市: '台北市'
  },
  {
    店號: 197995,
    店名: '政戰',
    地址: '台北市北投區中央北路二段15號17號',
    縣市: '台北市'
  },
  {
    店號: 198057,
    店名: '至誠',
    地址: '台北市士林區至誠路二段31號',
    縣市: '台北市'
  },
  {
    店號: 198068,
    店名: '臨沂',
    地址: '台北市中正區文祥里臨沂街74號76號',
    縣市: '台北市'
  },
  {
    店號: 198079,
    店名: '康醫',
    地址: '台北市內湖區成功路五段420巷30號',
    縣市: '台北市'
  },
  {
    店號: 198091,
    店名: '東吳',
    地址: '台北市士林區臨溪路70號',
    縣市: '台北市'
  },
  {
    店號: 198116,
    店名: '瑞寶',
    地址: '台北市內湖區瑞光路583巷27號1樓',
    縣市: '台北市'
  },
  {
    店號: 198286,
    店名: '興隆',
    地址: '台北市文山區興隆路二段205號207號1樓',
    縣市: '台北市'
  },
  {
    店號: 198389,
    店名: '嘉馥',
    地址: '台北市信義區信義路六段21號23號1樓',
    縣市: '台北市'
  },
  {
    店號: 198677,
    店名: '承華',
    地址: '台北市大同區承德路一段22號',
    縣市: '台北市'
  },
  {
    店號: 198758,
    店名: '捷忠',
    地址: '台北市信義區忠孝東路五段617號',
    縣市: '台北市'
  },
  {
    店號: 198781,
    店名: '松信',
    地址: '台北市信義區松信路148號1樓',
    縣市: '台北市'
  },
  {
    店號: 198817,
    店名: '天真',
    地址: '台北市士林區中山北路七段141巷6之1號1樓',
    縣市: '台北市'
  },
  {
    店號: 199245,
    店名: '南海',
    地址: '台北市中正區南海路50號',
    縣市: '台北市'
  },
  {
    店號: 199267,
    店名: '敦化',
    地址: '台北市松山區民權東路三段160巷9號1樓',
    縣市: '台北市'
  },
  {
    店號: 199290,
    店名: '文新',
    地址: '台北市文山區樟新里木新路三段276號',
    縣市: '台北市'
  },
  {
    店號: 199441,
    店名: '汀州',
    地址: '台北市中正區汀州路一段127號129號',
    縣市: '台北市'
  },
  {
    店號: 199669,
    店名: '鑫碁泰',
    地址: '台北市內湖區康寧路三段63號65號67號',
    縣市: '台北市'
  },
  {
    店號: 199670,
    店名: '景華',
    地址: '台北市文山區興東里景華街130號',
    縣市: '台北市'
  },
  {
    店號: 199876,
    店名: '統合',
    地址: '台北市大安區忠孝東路四段181巷7弄11之1號11之2號',
    縣市: '台北市'
  },
  {
    店號: 199980,
    店名: '興忠',
    地址: '台北市中正區紹興北街3號1樓,B1',
    縣市: '台北市'
  },
  {
    店號: 200044,
    店名: '世貿二',
    地址: '台北市信義區信義路五段5號2樓',
    縣市: '台北市'
  },
  {
    店號: 200066,
    店名: '參龍',
    地址: '台北市內湖區新湖一路95號1樓',
    縣市: '台北市'
  },
  {
    店號: 200251,
    店名: '康明',
    地址: '台北市內湖區康寧路三段189巷21弄26號1樓',
    縣市: '台北市'
  },
  {
    店號: 200309,
    店名: '羅盛',
    地址: '台北市文山區羅斯福路六段235號237號1樓2樓',
    縣市: '台北市'
  },
  {
    店號: 200376,
    店名: '小巨蛋',
    地址: '台北市松山區南京東路四段2號1樓',
    縣市: '台北市'
  },
  {
    店號: 200480,
    店名: '中研',
    地址: '台北市南港區研究院路二段128號1樓(學術活動中心)',
    縣市: '台北市'
  },
  {
    店號: 200804,
    店名: '鑫德惠',
    地址: '台北市中山區德惠街15號1樓',
    縣市: '台北市'
  },
  {
    店號: 200815,
    店名: '天東',
    地址: '台北市士林區中山北路七段14巷2-1號',
    縣市: '台北市'
  },
  {
    店號: 200871,
    店名: '革新',
    地址: '台北市信義區永吉路32號34號',
    縣市: '台北市'
  },
  {
    店號: 200907,
    店名: '新東宮',
    地址: '台北市信義區松山路455號',
    縣市: '台北市'
  },
  {
    店號: 200929,
    店名: '誠義',
    地址: '台北市士林區忠誠路一段126號',
    縣市: '台北市'
  },
  {
    店號: 200930,
    店名: '洲美',
    地址: '台北市士林區延平北路六段505號',
    縣市: '台北市'
  },
  {
    店號: 200963,
    店名: '林森北',
    地址: '台北市中山區林森北路380之1號1樓',
    縣市: '台北市'
  },
  {
    店號: 201014,
    店名: '寶湖',
    地址: '台北市內湖區民權東路六段180巷6號1樓',
    縣市: '台北市'
  },
  {
    店號: 201287,
    店名: '樂和',
    地址: '台北市大安區樂利路29號29-1號',
    縣市: '台北市'
  },
  {
    店號: 201302,
    店名: '台場',
    地址: '台北市松山區八德路三段20-2號',
    縣市: '台北市'
  },
  {
    店號: 201427,
    店名: '昆嵋',
    地址: '台北市萬華區峨嵋街74號1樓',
    縣市: '台北市'
  },
  {
    店號: 201586,
    店名: '博美',
    地址: '台北市中正區武昌街一段45號1樓',
    縣市: '台北市'
  },
  {
    店號: 201704,
    店名: '龍普',
    地址: '台北市大安區敦化南路一段233巷25號',
    縣市: '台北市'
  },
  {
    店號: 201715,
    店名: '翔運',
    地址: '台北市中山區中山北路二段44巷2號1樓',
    縣市: '台北市'
  },
  {
    店號: 201829,
    店名: '政大',
    地址: '台北市文山區指南路二段99號101號',
    縣市: '台北市'
  },
  {
    店號: 201841,
    店名: '日內瓦',
    地址: '台北市內湖區瑞光路76巷59號1樓',
    縣市: '台北市'
  },
  {
    店號: 202006,
    店名: '北車',
    地址: '台北市中正區忠孝西路一段49號B1樓',
    縣市: '台北市'
  },
  {
    店號: 202017,
    店名: '康福',
    地址: '台北市大安區永康街12之2號1樓',
    縣市: '台北市'
  },
  {
    店號: 202110,
    店名: '仁信',
    地址: '台北市信義區松仁路130號',
    縣市: '台北市'
  },
  {
    店號: 202280,
    店名: '慶寧',
    地址: '台北市大同區寧夏路23號23之1號',
    縣市: '台北市'
  },
  {
    店號: 202291,
    店名: '泰樂',
    地址: '台北市內湖區安泰街26號28號',
    縣市: '台北市'
  },
  {
    店號: 202350,
    店名: '崧站',
    地址: '台北市信義區松隆路329巷4號',
    縣市: '台北市'
  },
  {
    店號: 202420,
    店名: '玉成',
    地址: '台北市南港區西新里南港路三段3號1樓',
    縣市: '台北市'
  },
  {
    店號: 202431,
    店名: '康喜',
    地址: '台北市文山區興隆路三段42號',
    縣市: '台北市'
  },
  {
    店號: 202453,
    店名: '統家',
    地址: '台北市大安區忠孝東路四段216巷27弄1號1樓',
    縣市: '台北市'
  },
  {
    店號: 202464,
    店名: '留公',
    地址: '台北市信義區福德街247號249號',
    縣市: '台北市'
  },
  {
    店號: 202497,
    店名: '鑫衡陽',
    地址: '台北市中正區衡陽路6號1樓',
    縣市: '台北市'
  },
  {
    店號: 202501,
    店名: '佳樂',
    地址: '台北市南港區南港路一段303號305號307號1樓',
    縣市: '台北市'
  },
  {
    店號: 202512,
    店名: '英雄館',
    地址: '台北市中正區長沙街一段20號1樓',
    縣市: '台北市'
  },
  {
    店號: 206684,
    店名: '微風南',
    地址: '台北市信義區松智路17號B2樓',
    縣市: '台北市'
  },
  {
    店號: 206695,
    店名: '後山埤',
    地址: '台北市信義區中坡北路11號1樓',
    縣市: '台北市'
  },
  {
    店號: 206710,
    店名: '文饌',
    地址: '台北市士林區福德路12號14號1樓',
    縣市: '台北市'
  },
  {
    店號: 206879,
    店名: '德育',
    地址: '台北市松山區八德路三段171號173號1樓',
    縣市: '台北市'
  },
  {
    店號: 207012,
    店名: '羅鑫',
    地址: '台北市大安區羅斯福路三段29號31號1樓',
    縣市: '台北市'
  },
  {
    店號: 207056,
    店名: '敦仁',
    地址: '台北市大安區忠孝東路四段148號部份',
    縣市: '台北市'
  },
  {
    店號: 207137,
    店名: '阿波羅',
    地址: '台北市大安區忠孝東路四段222號224號1樓',
    縣市: '台北市'
  },
  {
    店號: 207171,
    店名: '忠泰',
    地址: '台北市中正區忠孝西路一段78號1樓',
    縣市: '台北市'
  },
  {
    店號: 207610,
    店名: '復惠',
    地址: '台北市松山區復興北路335號1樓',
    縣市: '台北市'
  },
  {
    店號: 207850,
    店名: '松機',
    地址: '台北市松山區敦化北路340之10號1樓',
    縣市: '台北市'
  },
  {
    店號: 208794,
    店名: '成竹',
    地址: '台北市內湖區成功路四段173號1樓',
    縣市: '台北市'
  },
  {
    店號: 208819,
    店名: '忠孝東',
    地址: '台北市中正區忠孝東路一段72號76號1樓',
    縣市: '台北市'
  },
  {
    店號: 208853,
    店名: '上饌',
    地址: '台北市士林區基河路125號127號',
    縣市: '台北市'
  },
  {
    店號: 208967,
    店名: '新景美',
    地址: '台北市文山區木新路三段147號149號',
    縣市: '台北市'
  },
  {
    店號: 209100,
    店名: '京運',
    地址: '台北市松山區南京東路三段262號1樓',
    縣市: '台北市'
  },
  {
    店號: 209269,
    店名: '重陽',
    地址: '台北市南港區重陽路179號181號1樓',
    縣市: '台北市'
  },
  {
    店號: 209339,
    店名: '松怡',
    地址: '台北市中山區民權東路二段146號1樓',
    縣市: '台北市'
  },
  {
    店號: 209409,
    店名: '德金',
    地址: '台北市中正區八德路一段29號',
    縣市: '台北市'
  },
  {
    店號: 209502,
    店名: '金碧',
    地址: '台北市內湖區金龍路219號217巷1號1樓',
    縣市: '台北市'
  },
  {
    店號: 209719,
    店名: '京旺',
    地址: '台北市中山區南京東路一段92號1樓',
    縣市: '台北市'
  },
  {
    店號: 209867,
    店名: '和平東',
    地址: '台北市大安區和平東路一段129之1號',
    縣市: '台北市'
  },
  {
    店號: 209904,
    店名: '森泰',
    地址: '台北市中山區林森北路358號360號',
    縣市: '台北市'
  },
  {
    店號: 210225,
    店名: '鼎盛',
    地址: '台北市文山區景文街79號',
    縣市: '台北市'
  },
  {
    店號: 210546,
    店名: '民醫',
    地址: '台北市內湖區民權東路六段123巷22號22之1號',
    縣市: '台北市'
  },
  {
    店號: 210694,
    店名: '松祐',
    地址: '台北市松山區饒河街90號1樓',
    縣市: '台北市'
  },
  {
    店號: 210764,
    店名: '鑫華福',
    地址: '台北市中正區漢口街1段36號1樓',
    縣市: '台北市'
  },
  {
    店號: 210823,
    店名: '齊德',
    地址: '台北市士林區天母西路85號1樓2樓',
    縣市: '台北市'
  },
  {
    店號: 211077,
    店名: '巨新',
    地址: '台北市文山區木新路二段212號及木新路二段218巷2號4號',
    縣市: '台北市'
  },
  {
    店號: 211170,
    店名: '北醫大',
    地址: '台北市信義區吳興街250號1樓',
    縣市: '台北市'
  },
  {
    店號: 211295,
    店名: '萬品',
    地址: '台北市文山區興隆路三段112巷2弄22號1樓',
    縣市: '台北市'
  },
  {
    店號: 211332,
    店名: '松茂',
    地址: '台北市信義區松山路11號B1樓',
    縣市: '台北市'
  },
  {
    店號: 211435,
    店名: '福亭',
    地址: '台北市大安區羅斯福路二段31號1樓',
    縣市: '台北市'
  },
  {
    店號: 211561,
    店名: '愛國',
    地址: '台北市大安區愛國東路75號',
    縣市: '台北市'
  },
  {
    店號: 211620,
    店名: '新文華',
    地址: '台北市中正區廈門街77號77之1號1樓',
    縣市: '台北市'
  },
  {
    店號: 211642,
    店名: '臨通',
    地址: '台北市大安區通安街64號1樓',
    縣市: '台北市'
  },
  {
    店號: 211686,
    店名: '慶陽',
    地址: '台北市中正區衡陽路93號1樓',
    縣市: '台北市'
  },
  {
    店號: 211804,
    店名: '敦巨',
    地址: '台北市松山區南京東路四段25號25之1號',
    縣市: '台北市'
  },
  {
    店號: 211963,
    店名: '台企',
    地址: '台北市內湖區新明路122之7號',
    縣市: '台北市'
  },
  {
    店號: 212139,
    店名: '民族西',
    地址: '台北市大同區民族西路151號153號155號',
    縣市: '台北市'
  },
  {
    店號: 212195,
    店名: '康葫',
    地址: '台北市內湖區民權東路六段296巷33號',
    縣市: '台北市'
  },
  {
    店號: 212232,
    店名: '永吉',
    地址: '台北市信義區永吉路217號1樓2樓及219號1樓',
    縣市: '台北市'
  },
  {
    店號: 212483,
    店名: '開懷',
    地址: '台北市中正區開封街一段15號17號1樓17號2樓',
    縣市: '台北市'
  },
  {
    店號: 212519,
    店名: '民龍',
    地址: '台北市內湖區新湖二路26號',
    縣市: '台北市'
  },
  {
    店號: 213567,
    店名: '福溢',
    地址: '台北市士林區德行西路96號',
    縣市: '台北市'
  },
  {
    店號: 213589,
    店名: '潤泰',
    地址: '台北市中山區八德路二段314號',
    縣市: '台北市'
  },
  {
    店號: 213626,
    店名: '敬群',
    地址: '台北市中山區樂群二路154號1樓',
    縣市: '台北市'
  },
  {
    店號: 213637,
    店名: '護專',
    地址: '台北市北投區振興街31號',
    縣市: '台北市'
  },
  {
    店號: 213707,
    店名: '信遠',
    地址: '台北市信義區松仁路58號B2樓',
    縣市: '台北市'
  },
  {
    店號: 213752,
    店名: '南昌',
    地址: '台北市中正區南昌路一段67號69號1樓',
    縣市: '台北市'
  },
  {
    店號: 213833,
    店名: '樂安',
    地址: '台北市大安區樂業街71號73號',
    縣市: '台北市'
  },
  {
    店號: 213844,
    店名: '萬華',
    地址: '台北市萬華區莒光路216號萬大路57號1樓',
    縣市: '台北市'
  },
  {
    店號: 213855,
    店名: '新劍潭',
    地址: '台北市士林區福港街246號248號',
    縣市: '台北市'
  },
  {
    店號: 213903,
    店名: '松鑽',
    地址: '台北市松山區八德路四段686號',
    縣市: '台北市'
  },
  {
    店號: 214054,
    店名: '中樂',
    地址: '台北市中正區延平南路47號',
    縣市: '台北市'
  },
  {
    店號: 214146,
    店名: '開源',
    地址: '台北市信義區松山路136號138號',
    縣市: '台北市'
  },
  {
    店號: 214179,
    店名: '瑞江',
    地址: '台北市內湖區瑞陽里江南街71巷16弄76號',
    縣市: '台北市'
  },
  {
    店號: 214283,
    店名: '文大',
    地址: '台北市士林區格致路57號',
    縣市: '台北市'
  },
  {
    店號: 214320,
    店名: '鑫日新',
    地址: '台北市萬華區武昌街二段122之1號',
    縣市: '台北市'
  },
  {
    店號: 214386,
    店名: '文一',
    地址: '台北市文山區木新路三段351號353號1樓',
    縣市: '台北市'
  },
  {
    店號: 214397,
    店名: '新峨嵋',
    地址: '台北市萬華區峨嵋街111之2號之3號',
    縣市: '台北市'
  },
  {
    店號: 214526,
    店名: '基河',
    地址: '台北市中山區樂群二路206號1樓',
    縣市: '台北市'
  },
  {
    店號: 214559,
    店名: '聯合',
    地址: '台北市信義區忠孝東路四段559巷6號',
    縣市: '台北市'
  },
  {
    店號: 214571,
    店名: '和泰',
    地址: '台北市大安區和平東路一段169號',
    縣市: '台北市'
  },
  {
    店號: 214582,
    店名: '新北科',
    地址: '台北市大安區新生南路一段3號B1樓',
    縣市: '台北市'
  },
  {
    店號: 214607,
    店名: '擎天崗',
    地址: '台北市北投區湖山路一段12號',
    縣市: '台北市'
  },
  {
    店號: 214722,
    店名: '古亭',
    地址: '台北市中正區汀州路二段210號',
    縣市: '台北市'
  },
  {
    店號: 214733,
    店名: '欣漢華',
    地址: '台北市中正區中華路一段41號1樓',
    縣市: '台北市'
  },
  {
    店號: 214766,
    店名: '新晴光',
    地址: '台北市中山區雙城街30號1樓',
    縣市: '台北市'
  },
  {
    店號: 214799,
    店名: '新復勢',
    地址: '台北市松山區八德路三段200號202號1樓',
    縣市: '台北市'
  },
  {
    店號: 214803,
    店名: '新寶清',
    地址: '台北市松山區南京東路五段334號336號1樓',
    縣市: '台北市'
  },
  {
    店號: 215253,
    店名: '鑫吉',
    地址: '台北市信義區虎林街85號',
    縣市: '台北市'
  },
  {
    店號: 215471,
    店名: '新天強',
    地址: '台北市士林區克強路11及11-1號1樓',
    縣市: '台北市'
  },
  {
    店號: 215530,
    店名: '敦禾',
    地址: '台北市大安區敦化南路二段265巷6號1樓',
    縣市: '台北市'
  },
  {
    店號: 215655,
    店名: '宏旭',
    地址: '台北市萬華區西園路一段238號1樓2樓',
    縣市: '台北市'
  },
  {
    店號: 215688,
    店名: '信吉',
    地址: '台北市信義區永吉路278巷58弄2號',
    縣市: '台北市'
  },
  {
    店號: 215758,
    店名: '朝福',
    地址: '台北市松山區三民路115號',
    縣市: '台北市'
  },
  {
    店號: 215851,
    店名: '東復',
    地址: '台北市松山區復興北路313巷25號',
    縣市: '台北市'
  },
  {
    店號: 215921,
    店名: '國雙',
    地址: '台北市萬華區西藏路125巷17號及129-9號',
    縣市: '台北市'
  },
  {
    店號: 215932,
    店名: '桂明',
    地址: '台北市萬華區桂林路55號',
    縣市: '台北市'
  },
  {
    店號: 215943,
    店名: '明美',
    地址: '台北市中山區敬業一路130號1樓',
    縣市: '台北市'
  },
  {
    店號: 216027,
    店名: '瑞德',
    地址: '台北市中正區新生南路一段170巷14之3號1樓',
    縣市: '台北市'
  },
  {
    店號: 216050,
    店名: '佑安',
    地址: '台北市大安區忠孝東路三段217巷1弄2號',
    縣市: '台北市'
  },
  {
    店號: 216072,
    店名: '新忠誠',
    地址: '台北市士林區中山北路六段18號20號1樓',
    縣市: '台北市'
  },
  {
    店號: 216108,
    店名: '復維',
    地址: '台北市大安區復興南路二段17號',
    縣市: '台北市'
  },
  {
    店號: 216119,
    店名: '芝山',
    地址: '台北市士林區福華路126號1樓',
    縣市: '台北市'
  },
  {
    店號: 216201,
    店名: '信福',
    地址: '台北市信義區福德街308號310巷1號',
    縣市: '台北市'
  },
  {
    店號: 216212,
    店名: '信嘉',
    地址: '台北市信義區嘉興街181巷21號',
    縣市: '台北市'
  },
  {
    店號: 216315,
    店名: '錦合',
    地址: '台北市中山區合江街117號',
    縣市: '台北市'
  },
  {
    店號: 216337,
    店名: '北體',
    地址: '台北市松山區北寧路66號',
    縣市: '台北市'
  },
  {
    店號: 216382,
    店名: '政新',
    地址: '台北市文山區新光路一段10號12號14號1樓及B1',
    縣市: '台北市'
  },
  {
    店號: 216430,
    店名: '萬長',
    地址: '台北市萬華區東園街78號1樓',
    縣市: '台北市'
  },
  {
    店號: 216463,
    店名: '信德',
    地址: '台北市信義區松德路200巷10號',
    縣市: '台北市'
  },
  {
    店號: 216485,
    店名: '紫陽',
    地址: '台北市內湖區紫陽里陽光街159號',
    縣市: '台北市'
  },
  {
    店號: 216692,
    店名: '鑫港',
    地址: '台北市士林區後港街210號',
    縣市: '台北市'
  },
  {
    店號: 216865,
    店名: '杭信',
    地址: '台北市中正區信義路二段15號1樓',
    縣市: '台北市'
  },
  {
    店號: 216876,
    店名: '萬和',
    地址: '台北市萬華區萬大路182號184號',
    縣市: '台北市'
  },
  {
    店號: 216935,
    店名: '東湖',
    地址: '台北市內湖區五分街62號',
    縣市: '台北市'
  },
  {
    店號: 216991,
    店名: '百齡',
    地址: '台北市北投區石牌路一段37號',
    縣市: '台北市'
  },
  {
    店號: 217008,
    店名: '泉北',
    地址: '台北市北投區溫泉路70號',
    縣市: '台北市'
  },
  {
    店號: 217271,
    店名: '延吉',
    地址: '台北市大安區延吉街237號',
    縣市: '台北市'
  },
  {
    店號: 217282,
    店名: '鑫仰德',
    地址: '台北市士林區仰德大道三段68號70號',
    縣市: '台北市'
  },
  {
    店號: 217330,
    店名: '森華',
    地址: '台北市中山區林森北路587號1樓',
    縣市: '台北市'
  },
  {
    店號: 217352,
    店名: '鑫寧',
    地址: '台北市大同區民生西路214號216號1樓',
    縣市: '台北市'
  },
  {
    店號: 217477,
    店名: '見晴',
    地址: '台北市內湖區瑞光路196號',
    縣市: '台北市'
  },
  {
    店號: 227658,
    店名: '藍天樓',
    地址: '台北市中山區北安路387號1樓',
    縣市: '台北市'
  },
  {
    店號: 227670,
    店名: '吉孝',
    地址: '台北市大安區忠孝東路四段299號',
    縣市: '台北市'
  },
  {
    店號: 227728,
    店名: '臺醫東',
    地址: '台北市中正區中山南路7號1樓',
    縣市: '台北市'
  },
  {
    店號: 228167,
    店名: '國賓',
    地址: '台北市中山區中山北路二段71號1樓',
    縣市: '台北市'
  },
  {
    店號: 228396,
    店名: '廣運',
    地址: '台北市萬華區廣州街170號1樓2樓部份',
    縣市: '台北市'
  },
  {
    店號: 228477,
    店名: '永錦',
    地址: '台北市中山區錦西街1號',
    縣市: '台北市'
  },
  {
    店號: 228592,
    店名: '永倫',
    地址: '台北市士林區社中街381號1樓',
    縣市: '台北市'
  },
  {
    店號: 228673,
    店名: '信富',
    地址: '台北市信義區吳興街156巷63號63之1號',
    縣市: '台北市'
  },
  {
    店號: 228776,
    店名: '陽明',
    地址: '台北市北投區立農街二段155號1樓',
    縣市: '台北市'
  },
  {
    店號: 229274,
    店名: '萬連',
    地址: '台北市大同區萬全街40巷4號6號1樓',
    縣市: '台北市'
  },
  {
    店號: 229517,
    店名: '墘麗',
    地址: '台北市內湖區港墘路37巷15號',
    縣市: '台北市'
  },
  {
    店號: 229610,
    店名: '滬江',
    地址: '台北市文山區羅斯福路六段270號',
    縣市: '台北市'
  },
  {
    店號: 230090,
    店名: '木鳴',
    地址: '台北市文山區木柵路三段115號117號1樓',
    縣市: '台北市'
  },
  {
    店號: 230159,
    店名: '鴻瑞',
    地址: '台北市內湖區瑞光路335號1樓',
    縣市: '台北市'
  },
  {
    店號: 230207,
    店名: '銳陽',
    地址: '台北市內湖區文德路22巷44弄6號8號1樓',
    縣市: '台北市'
  },
  {
    店號: 230355,
    店名: '松德',
    地址: '台北市松山區八德路四段755號1樓',
    縣市: '台北市'
  },
  {
    店號: 230436,
    店名: '國企',
    地址: '台北市內湖區行善路136號1樓',
    縣市: '台北市'
  },
  {
    店號: 230609,
    店名: '和碩',
    地址: '台北市北投區立德路15號1樓',
    縣市: '台北市'
  },
  {
    店號: 230654,
    店名: '慶城',
    地址: '台北市中正區武昌街一段18號1樓',
    縣市: '台北市'
  },
  {
    店號: 230757,
    店名: '中華賓',
    地址: '台北市北投區立功街9號1樓',
    縣市: '台北市'
  },
  {
    店號: 230816,
    店名: '榮陽',
    地址: '台北市北投區西安街一段345號1樓',
    縣市: '台北市'
  },
  {
    店號: 231059,
    店名: '大台',
    地址: '台北市大安區羅斯福路三段333巷18號1樓20號1樓(部分)',
    縣市: '台北市'
  },
  {
    店號: 231163,
    店名: '鑫麟',
    地址: '台北市信義區和平東路三段391巷22號24號1樓及地下室1樓',
    縣市: '台北市'
  },
  {
    店號: 231277,
    店名: '社鑫',
    地址: '台北市士林區社子街42號44號1樓',
    縣市: '台北市'
  },
  {
    店號: 231299,
    店名: '龍江',
    地址: '台北市中山區龍江路83號85號1樓B1',
    縣市: '台北市'
  },
  {
    店號: 231428,
    店名: '欣昌',
    地址: '台北市萬華區西昌街177號179號179-1號',
    縣市: '台北市'
  },
  {
    店號: 231462,
    店名: '春光',
    地址: '台北市信義區大道路9號11號1樓',
    縣市: '台北市'
  },
  {
    店號: 231783,
    店名: '廣慈',
    地址: '台北市信義區大道路115號117號1樓',
    縣市: '台北市'
  },
  {
    店號: 231864,
    店名: '環武',
    地址: '台北市內湖區環山路一段8號1樓',
    縣市: '台北市'
  },
  {
    店號: 231990,
    店名: '隆合',
    地址: '台北市文山區羅斯福路5段218巷28號30號',
    縣市: '台北市'
  },
  {
    店號: 232029,
    店名: '復興崗',
    地址: '台北市北投區中央北路二段68之2號68之3號',
    縣市: '台北市'
  },
  {
    店號: 232041,
    店名: '京育',
    地址: '台北市松山區南京東路四段66號寧安街68巷25號',
    縣市: '台北市'
  },
  {
    店號: 232269,
    店名: '新寧南',
    地址: '台北市萬華區西寧南路78號1樓',
    縣市: '台北市'
  },
  {
    店號: 232281,
    店名: '海光',
    地址: '台北市士林區延平北路五段35號37號39號',
    縣市: '台北市'
  },
  {
    店號: 232454,
    店名: '敦南',
    地址: '台北市大安區大安路一段83巷14號1樓',
    縣市: '台北市'
  },
  {
    店號: 232960,
    店名: '統領',
    地址: '台北市大安區忠孝東路四段223巷9號1樓',
    縣市: '台北市'
  },
  {
    店號: 233125,
    店名: '友華',
    地址: '台北市北投區承德路6段120號',
    縣市: '台北市'
  },
  {
    店號: 233192,
    店名: '忠順',
    地址: '台北市文山區忠順街一段26巷22號24號',
    縣市: '台北市'
  },
  {
    店號: 233365,
    店名: '空指部',
    地址: '台北市大安區羅斯福路4段113巷29號(空軍指揮作戰部)',
    縣市: '台北市'
  },
  {
    店號: 236607,
    店名: '錦捷',
    地址: '台北市中山區錦州街229號1樓',
    縣市: '台北市'
  },
  {
    店號: 236618,
    店名: '紹興',
    地址: '台北市中正區紹興北街37號1樓',
    縣市: '台北市'
  },
  {
    店號: 236629,
    店名: '青島',
    地址: '台北市中正區青島東路4號',
    縣市: '台北市'
  },
  {
    店號: 236803,
    店名: '北福興',
    地址: '台北市文山區興旺里福興路20號',
    縣市: '台北市'
  },
  {
    店號: 236825,
    店名: '吉祥',
    地址: '台北市松山區八德路四段245巷52弄31號',
    縣市: '台北市'
  },
  {
    店號: 236962,
    店名: '天裕',
    地址: '台北市士林區中山北路七段156號1樓',
    縣市: '台北市'
  },
  {
    店號: 236973,
    店名: '鑫通',
    地址: '台北市大安區信義路四段294巷7號1樓',
    縣市: '台北市'
  },
  {
    店號: 236984,
    店名: '懷得',
    地址: '台北市北投區懷德街85號1樓',
    縣市: '台北市'
  },
  {
    店號: 237149,
    店名: '濱江',
    地址: '台北市中山區龍江路356巷39及41號1樓',
    縣市: '台北市'
  },
  {
    店號: 237150,
    店名: '福致',
    地址: '台北市北投區致遠一路二段49號51號1樓',
    縣市: '台北市'
  },
  {
    店號: 237220,
    店名: '中愛',
    地址: '台北市中正區寧波東街17號1樓',
    縣市: '台北市'
  },
  {
    店號: 237242,
    店名: '京復',
    地址: '台北市松山區光復北路11巷44號',
    縣市: '台北市'
  },
  {
    店號: 237275,
    店名: '世成',
    地址: '台北市文山區木柵路一段111號1樓(世新大管院)',
    縣市: '台北市'
  },
  {
    店號: 237286,
    店名: '松京',
    地址: '台北市中山區南京東路二段144號1樓',
    縣市: '台北市'
  },
  {
    店號: 237301,
    店名: '民復',
    地址: '台北市松山區民生東路四段130號',
    縣市: '台北市'
  },
  {
    店號: 237389,
    店名: '台科一',
    地址: '台北市大安區基隆路四段43號1樓',
    縣市: '台北市'
  },
  {
    店號: 237404,
    店名: '金德',
    地址: '台北市內湖區金龍路5號1F',
    縣市: '台北市'
  },
  {
    店號: 237437,
    店名: '復星',
    地址: '台北市松山區復興北路15-6號1樓',
    縣市: '台北市'
  },
  {
    店號: 237459,
    店名: '信運',
    地址: '台北市信義區松勤街100號1樓',
    縣市: '台北市'
  },
  {
    店號: 237460,
    店名: '國圖',
    地址: '台北市中正區中山南路20號B1樓',
    縣市: '台北市'
  },
  {
    店號: 237482,
    店名: '鑫樂昇',
    地址: '台北市萬華區武昌街二段114之3號.之4號',
    縣市: '台北市'
  },
  {
    店號: 237530,
    店名: '朱崙',
    地址: '台北市中山區復興北路56號58號1樓',
    縣市: '台北市'
  },
  {
    店號: 237644,
    店名: '景中',
    地址: '台北市文山區景文里景文街96號98號',
    縣市: '台北市'
  },
  {
    店號: 237666,
    店名: '忠聯',
    地址: '台北市中正區忠孝東路二段100號1樓',
    縣市: '台北市'
  },
  {
    店號: 237688,
    店名: '東成',
    地址: '台北市中正區延平南路129巷3號1樓',
    縣市: '台北市'
  },
  {
    店號: 237699,
    店名: '一零一',
    地址: '台北市信義區信義路五段7號35樓',
    縣市: '台北市'
  },
  {
    店號: 237781,
    店名: '德成',
    地址: '台北市內湖區內湖路二段366號',
    縣市: '台北市'
  },
  {
    店號: 237840,
    店名: '福鑫',
    地址: '台北市士林區中正路324號',
    縣市: '台北市'
  },
  {
    店號: 237909,
    店名: '龍門',
    地址: '台北市大安區和平東路二段38之1號40號1樓',
    縣市: '台北市'
  },
  {
    店號: 237910,
    店名: '安居',
    地址: '台北市大安區安居街33號',
    縣市: '台北市'
  },
  {
    店號: 238016,
    店名: '敦親',
    地址: '台北市大安區辛亥路二段171巷8號',
    縣市: '台北市'
  },
  {
    店號: 238027,
    店名: '萬忠',
    地址: '台北市萬華區東園街28巷56號58號',
    縣市: '台北市'
  },
  {
    店號: 238038,
    店名: '湧久',
    地址: '台北市大同區延平北路四段157號159號',
    縣市: '台北市'
  },
  {
    店號: 238186,
    店名: '敦維',
    地址: '台北市大安區東豐街43號45號1樓',
    縣市: '台北市'
  },
  {
    店號: 238212,
    店名: '新慶陽',
    地址: '台北市大同區重慶北路二段60號',
    縣市: '台北市'
  },
  {
    店號: 238289,
    店名: '中興',
    地址: '台北市信義區基隆路二段22號',
    縣市: '台北市'
  },
  {
    店號: 238337,
    店名: '京城',
    地址: '台北市松山區南京東路四段75之2號1樓',
    縣市: '台北市'
  },
  {
    店號: 238360,
    店名: '德鄰',
    地址: '台北市信義區松德路127號129號1樓',
    縣市: '台北市'
  },
  {
    店號: 238371,
    店名: '行善',
    地址: '台北市內湖區行善路468號1樓新湖二路369號1樓',
    縣市: '台北市'
  },
  {
    店號: 238382,
    店名: '延龍',
    地址: '台北市大同區延平北路四段16號18號1樓',
    縣市: '台北市'
  },
  {
    店號: 238418,
    店名: '漢神',
    地址: '台北市文山區景中街45號1樓',
    縣市: '台北市'
  },
  {
    店號: 238463,
    店名: '新艋舺',
    地址: '台北市萬華區萬大路292號294號',
    縣市: '台北市'
  },
  {
    店號: 238500,
    店名: '恆安',
    地址: '台北市大安區永康街2巷12號1樓',
    縣市: '台北市'
  },
  {
    店號: 238511,
    店名: '德東',
    地址: '台北市士林區德行東路262號1樓',
    縣市: '台北市'
  },
  {
    店號: 238522,
    店名: '瑞安',
    地址: '台北市大安區瑞安街182號',
    縣市: '台北市'
  },
  {
    店號: 238533,
    店名: '合維',
    地址: '台北市大安區四維路170巷8號1樓',
    縣市: '台北市'
  },
  {
    店號: 238555,
    店名: '金和',
    地址: '台北市北投區中和街314號316號1樓',
    縣市: '台北市'
  },
  {
    店號: 238625,
    店名: '加賀屋',
    地址: '台北市北投區溫泉路73巷5號地下二樓之1',
    縣市: '台北市'
  },
  {
    店號: 238669,
    店名: '經貿',
    地址: '台北市南港區三重路19號1樓',
    縣市: '台北市'
  },
  {
    店號: 238670,
    店名: '京東',
    地址: '台北市松山區南京東路五段16號1樓',
    縣市: '台北市'
  },
  {
    店號: 238681,
    店名: '林北',
    地址: '台北市中山區民生東路一段46號46-1號1樓',
    縣市: '台北市'
  },
  {
    店號: 238739,
    店名: '青年',
    地址: '台北市萬華區青年路188號1樓',
    縣市: '台北市'
  },
  {
    店號: 238935,
    店名: '仕吉',
    地址: '台北市大安區忠孝東路四段223巷42號',
    縣市: '台北市'
  },
  {
    店號: 238957,
    店名: '伊東',
    地址: '台北市中山區伊通街30號1樓',
    縣市: '台北市'
  },
  {
    店號: 239145,
    店名: '北投',
    地址: '台北市北投區中和街222號',
    縣市: '台北市'
  },
  {
    店號: 239156,
    店名: '迪化',
    地址: '台北市大同區民生西路343號345號',
    縣市: '台北市'
  },
  {
    店號: 239167,
    店名: '建龍',
    地址: '台北市中山區龍江路239號1樓',
    縣市: '台北市'
  },
  {
    店號: 239215,
    店名: '森吉',
    地址: '台北市中山區林森北路624號626號1樓',
    縣市: '台北市'
  },
  {
    店號: 239226,
    店名: '錢忠',
    地址: '台北市大安區忠孝東路四段26巷5號',
    縣市: '台北市'
  },
  {
    店號: 239248,
    店名: '欣隆昌',
    地址: '台北市大安區基隆路二段142之1號及142之2號',
    縣市: '台北市'
  },
  {
    店號: 239385,
    店名: '金山',
    地址: '台北市中正區金山南路一段108號',
    縣市: '台北市'
  },
  {
    店號: 239411,
    店名: '凱富',
    地址: '台北市萬華區西園路一段278號1樓',
    縣市: '台北市'
  },
  {
    店號: 239455,
    店名: '北府',
    地址: '台北市信義區松仁路162號164號1樓',
    縣市: '台北市'
  },
  {
    店號: 239547,
    店名: '榮星',
    地址: '台北市中山區龍江路322號',
    縣市: '台北市'
  },
  {
    店號: 239628,
    店名: '里昂',
    地址: '台北市內湖區瑞光路406號1樓',
    縣市: '台北市'
  },
  {
    店號: 239684,
    店名: '商城',
    地址: '台北市北投區裕民六路111號113號1樓',
    縣市: '台北市'
  },
  {
    店號: 239695,
    店名: '達人',
    地址: '台北市內湖區內湖路二段249號251號',
    縣市: '台北市'
  },
  {
    店號: 239721,
    店名: '中崙',
    地址: '台北市松山區八德路三段27號',
    縣市: '台北市'
  },
  {
    店號: 239732,
    店名: '臨江',
    地址: '台北市大安區安和路二段67號',
    縣市: '台北市'
  },
  {
    店號: 239743,
    店名: '民有',
    地址: '台北市松山區民權東路三段108號',
    縣市: '台北市'
  },
  {
    店號: 239776,
    店名: '龍和',
    地址: '台北市大安區和平東路二段197號199號1樓',
    縣市: '台北市'
  },
  {
    店號: 239787,
    店名: '詠樂',
    地址: '台北市大同區迪化街一段13號全棟',
    縣市: '台北市'
  },
  {
    店號: 239813,
    店名: '京山',
    地址: '台北市中山區南京東路二段100號1樓',
    縣市: '台北市'
  },
  {
    店號: 239949,
    店名: '全球',
    地址: '台北市內湖區新湖二路329號1樓',
    縣市: '台北市'
  },
  {
    店號: 239972,
    店名: '京典',
    地址: '台北市中山區南京東路三段86號1樓',
    縣市: '台北市'
  },
  {
    店號: 240019,
    店名: '晶鑽',
    地址: '台北市中山區中山北路二段39巷8號1樓',
    縣市: '台北市'
  },
  {
    店號: 240020,
    店名: '金蓬',
    地址: '台北市中山區民權西路73號1樓',
    縣市: '台北市'
  },
  {
    店號: 240031,
    店名: '合旺',
    地址: '台北市大安區復興南路二段151巷41號',
    縣市: '台北市'
  },
  {
    店號: 240226,
    店名: '仟發',
    地址: '台北市大同區民生西路95號97號',
    縣市: '台北市'
  },
  {
    店號: 240237,
    店名: '庄研',
    地址: '台北市南港區研究院路二段152號',
    縣市: '台北市'
  },
  {
    店號: 240260,
    店名: '景興',
    地址: '台北市文山區景興路113號115號',
    縣市: '台北市'
  },
  {
    店號: 240411,
    店名: '同州',
    地址: '台北市中正區同安街62號1樓',
    縣市: '台北市'
  },
  {
    店號: 240536,
    店名: '德瑞',
    地址: '台北市內湖區洲子街70號1樓',
    縣市: '台北市'
  },
  {
    店號: 240558,
    店名: '德致',
    地址: '台北市北投區明德路87號89號1樓',
    縣市: '台北市'
  },
  {
    店號: 240569,
    店名: '總站',
    地址: '台北市信義區吳興街486號488號1樓',
    縣市: '台北市'
  },
  {
    店號: 240570,
    店名: '德馨',
    地址: '台北市內湖區洲子街46號',
    縣市: '台北市'
  },
  {
    店號: 240581,
    店名: '瑞鑽',
    地址: '台北市內湖區瑞光路478巷24號1樓',
    縣市: '台北市'
  },
  {
    店號: 240651,
    店名: '復安',
    地址: '台北市松山區民生東路三段130巷2之1號1樓',
    縣市: '台北市'
  },
  {
    店號: 240709,
    店名: '威京',
    地址: '台北市松山區八德路四段151號',
    縣市: '台北市'
  },
  {
    店號: 240743,
    店名: '森鑽',
    地址: '台北市中山區林森北路101號1樓',
    縣市: '台北市'
  },
  {
    店號: 240754,
    店名: '國京',
    地址: '台北市中山區南京東路三段21號1樓',
    縣市: '台北市'
  },
  {
    店號: 240787,
    店名: '樂利',
    地址: '台北市大安區樂利路76號78號1樓',
    縣市: '台北市'
  },
  {
    店號: 240824,
    店名: '涼州',
    地址: '台北市大同區延平北路二段232號234號1樓涼州街72巷11號1樓',
    縣市: '台北市'
  },
  {
    店號: 240916,
    店名: '慈愛',
    地址: '台北市南港區重陽路164號',
    縣市: '台北市'
  },
  {
    店號: 240927,
    店名: '昌吉',
    地址: '台北市大同區承德路三段60號60-1號',
    縣市: '台北市'
  },
  {
    店號: 240949,
    店名: '明水',
    地址: '台北市中山區明水路636號樂群三路1號',
    縣市: '台北市'
  },
  {
    店號: 240950,
    店名: '文林',
    地址: '台北市士林區大北路14號16號1樓',
    縣市: '台北市'
  },
  {
    店號: 241001,
    店名: '港鑫',
    地址: '台北市內湖區內湖路一段737巷35號',
    縣市: '台北市'
  },
  {
    店號: 241090,
    店名: '寶德',
    地址: '台北市松山區八德路四段295號297號1樓',
    縣市: '台北市'
  },
  {
    店號: 241137,
    店名: '紫新',
    地址: '台北市內湖區成功路三段201號1樓',
    縣市: '台北市'
  },
  {
    店號: 241148,
    店名: '松鐵',
    地址: '台北市信義區松山路11號B1樓',
    縣市: '台北市'
  },
  {
    店號: 241159,
    店名: '新西華',
    地址: '台北市中山區民生東路三段31號',
    縣市: '台北市'
  },
  {
    店號: 241160,
    店名: '友成',
    地址: '台北市士林區社中街211號1樓',
    縣市: '台北市'
  },
  {
    店號: 241171,
    店名: '哈蜜',
    地址: '台北市大同區重慶北路三段309、311號1樓',
    縣市: '台北市'
  },
  {
    店號: 241193,
    店名: '頂安',
    地址: '台北市大安區大安路一段67號1樓',
    縣市: '台北市'
  },
  {
    店號: 241207,
    店名: '錢京',
    地址: '台北市松山區敦化北路100號1樓',
    縣市: '台北市'
  },
  {
    店號: 241311,
    店名: '克難',
    地址: '台北市萬華區萬青街168號',
    縣市: '台北市'
  },
  {
    店號: 241399,
    店名: '權鑫',
    地址: '台北市大同區民權西路157之1號1樓',
    縣市: '台北市'
  },
  {
    店號: 241403,
    店名: '明華',
    地址: '台北市北投區明德路99號',
    縣市: '台北市'
  },
  {
    店號: 241425,
    店名: '復北',
    地址: '台北市中山區復興北路164號1樓',
    縣市: '台北市'
  },
  {
    店號: 241573,
    店名: '鑫富民',
    地址: '台北市大安區忠孝東路四段181巷40弄22號1樓',
    縣市: '台北市'
  },
  {
    店號: 241584,
    店名: '馥樺',
    地址: '台北市南港區三重路23號1樓',
    縣市: '台北市'
  },
  {
    店號: 241595,
    店名: '金宴',
    地址: '台北市中山區建國北路二段151巷8號1樓',
    縣市: '台北市'
  },
  {
    店號: 249108,
    店名: '關渡站',
    地址: '台北市北投區大度路三段270巷69號71號1樓',
    縣市: '台北市'
  },
  {
    店號: 249212,
    店名: '金雲',
    地址: '台北市內湖區星雲街136號',
    縣市: '台北市'
  },
  {
    店號: 249289,
    店名: '社鑽',
    地址: '台北市士林區中正路639號1樓',
    縣市: '台北市'
  },
  {
    店號: 249382,
    店名: '昇隆',
    地址: '台北市大安區敦化南路二段238號',
    縣市: '台北市'
  },
  {
    店號: 249669,
    店名: '牯嶺',
    地址: '台北市中正區廈門街99巷19-2號1樓',
    縣市: '台北市'
  },
  {
    店號: 249706,
    店名: '大敦',
    地址: '台北市大安區敦化南路二段63巷7號1樓',
    縣市: '台北市'
  },
  {
    店號: 249935,
    店名: '延新',
    地址: '台北市松山區延壽街99號1樓',
    縣市: '台北市'
  },
  {
    店號: 249968,
    店名: '新東帝',
    地址: '台北市大安區敦化南路二段99號1樓',
    縣市: '台北市'
  },
  {
    店號: 250038,
    店名: '名寶',
    地址: '台北市內湖區民權東路六段180巷17號19號',
    縣市: '台北市'
  },
  {
    店號: 250083,
    店名: '榮鑽',
    地址: '台北市中山區五常街23號25號民族東路410巷62號1樓',
    縣市: '台北市'
  },
  {
    店號: 250256,
    店名: '克里斯',
    地址: '台北市內湖區五分街33號35號1樓',
    縣市: '台北市'
  },
  {
    店號: 250359,
    店名: '健一',
    地址: '台北市松山區健康路11號',
    縣市: '台北市'
  },
  {
    店號: 250614,
    店名: '清江',
    地址: '台北市北投區公館路165號1樓.165-1號B1',
    縣市: '台北市'
  },
  {
    店號: 250647,
    店名: '塔優',
    地址: '台北市松山區撫遠街197號199號',
    縣市: '台北市'
  },
  {
    店號: 250832,
    店名: '試院',
    地址: '台北市文山區木柵路一段139號141號',
    縣市: '台北市'
  },
  {
    店號: 250957,
    店名: '鑫文德',
    地址: '台北市內湖區文德路99號1樓',
    縣市: '台北市'
  },
  {
    店號: 251189,
    店名: '林安',
    地址: '台北市中山區林森北路572號',
    縣市: '台北市'
  },
  {
    店號: 251293,
    店名: '德誠',
    地址: '台北市士林區德行東路106號108號1樓',
    縣市: '台北市'
  },
  {
    店號: 251307,
    店名: '南京',
    地址: '台北市松山區南京東路三段303巷5號',
    縣市: '台北市'
  },
  {
    店號: 833077,
    店名: '原中',
    地址: '台北市中山區中原街121號1樓、新生北路三段3巷41號2樓',
    縣市: '台北市'
  },
  {
    店號: 833332,
    店名: '關渡',
    地址: '台北市北投區知行路282號',
    縣市: '台北市'
  },
  {
    店號: 833468,
    店名: '農安',
    地址: '台北市中山區農安街28-1號1樓28-2號1樓',
    縣市: '台北市'
  },
  {
    店號: 844860,
    店名: '晉江',
    地址: '台北市中正區和平西路一段26號',
    縣市: '台北市'
  },
  {
    店號: 846604,
    店名: '雙環',
    地址: '台北市萬華區環河南路二段207號',
    縣市: '台北市'
  },
  {
    店號: 851721,
    店名: '一德',
    地址: '台北市北投區中央北路四段513號',
    縣市: '台北市'
  },
  {
    店號: 855354,
    店名: '添恩',
    地址: '台北市文山區指南路三段8號10號',
    縣市: '台北市'
  },
  {
    店號: 855398,
    店名: '木柵',
    地址: '台北市文山區木柵路二段157號',
    縣市: '台北市'
  },
  {
    店號: 855572,
    店名: '和安',
    地址: '台北市大安區和平東路三段230號',
    縣市: '台北市'
  },
  {
    店號: 860770,
    店名: '成功',
    地址: '台北市內湖區成功路二段252號',
    縣市: '台北市'
  },
  {
    店號: 863698,
    店名: '豫銘',
    地址: '台北市大安區大安路二段102號',
    縣市: '台北市'
  },
  {
    店號: 864864,
    店名: '錦龍',
    地址: '台北市中山區龍江路281-1號',
    縣市: '台北市'
  },
  {
    店號: 865362,
    店名: '師大',
    地址: '台北市大安區師大路87號',
    縣市: '台北市'
  },
  {
    店號: 865454,
    店名: '奇岩',
    地址: '台北市北投區崇仁路一段76號',
    縣市: '台北市'
  },
  {
    店號: 865694,
    店名: '晶華',
    地址: '台北市中山區林森北路262號',
    縣市: '台北市'
  },
  {
    店號: 865834,
    店名: '中福',
    地址: '台北市中山區民生東路二段113號',
    縣市: '台北市'
  },
  {
    店號: 865890,
    店名: '長北',
    地址: '台北市中山區長春路11號',
    縣市: '台北市'
  },
  {
    店號: 865926,
    店名: '稻江',
    地址: '台北市中山區新生北路三段35號農安街67號69號',
    縣市: '台北市'
  },
  {
    店號: 870504,
    店名: '道生',
    地址: '台北市信義區新仁里東興路57號',
    縣市: '台北市'
  },
  {
    店號: 872832,
    店名: '華岡',
    地址: '台北市士林區光華路26巷7-1號',
    縣市: '台北市'
  },
  {
    店號: 874230,
    店名: '林森',
    地址: '台北市中山區林森北路500號',
    縣市: '台北市'
  },
  {
    店號: 874252,
    店名: '華山',
    地址: '台北市中正區忠孝東路一段138號',
    縣市: '台北市'
  },
  {
    店號: 874388,
    店名: '曾德',
    地址: '台北市中山區錦州街21-2號',
    縣市: '台北市'
  },
  {
    店號: 874573,
    店名: '致遠',
    地址: '台北市北投區石牌路一段126號',
    縣市: '台北市'
  },
  {
    店號: 874872,
    店名: '統全',
    地址: '台北市中正區汀州路三段249號',
    縣市: '台北市'
  },
  {
    店號: 875200,
    店名: '木新',
    地址: '台北市文山區木新路二段255號',
    縣市: '台北市'
  },
  {
    店號: 882482,
    店名: '科建',
    地址: '台北市大安區建國南路一段28號30號',
    縣市: '台北市'
  },
  {
    店號: 882792,
    店名: '晏揚',
    地址: '台北市內湖區康寧路三段99巷14號康寧路三段99巷12弄2號',
    縣市: '台北市'
  },
  {
    店號: 883223,
    店名: '松饒',
    地址: '台北市松山區慈祐里八德路四段767號769號',
    縣市: '台北市'
  },
  {
    店號: 883544,
    店名: '金恩',
    地址: '台北市文山區指南路二段149號',
    縣市: '台北市'
  },
  {
    店號: 883865,
    店名: '新寶',
    地址: '台北市中山區建國北路一段136號',
    縣市: '台北市'
  },
  {
    店號: 885609,
    店名: '萬芳',
    地址: '台北市文山區萬安街23號25號27號27-1號1樓',
    縣市: '台北市'
  },
  {
    店號: 886059,
    店名: '東崙',
    地址: '台北市中山區八德路二段282號',
    縣市: '台北市'
  },
  {
    店號: 886222,
    店名: '桂林',
    地址: '台北市萬華區桂林路156號158號160號',
    縣市: '台北市'
  },
  {
    店號: 890900,
    店名: '福志',
    地址: '台北市士林區雨農路25號',
    縣市: '台北市'
  },
  {
    店號: 891176,
    店名: '靜中',
    地址: '台北市大同區寧夏路71號73號',
    縣市: '台北市'
  },
  {
    店號: 894359,
    店名: '辛亥',
    地址: '台北市大安區辛亥路二段57號',
    縣市: '台北市'
  },
  {
    店號: 895020,
    店名: '建南',
    地址: '台北市大安區建國南路二段151巷6之8號',
    縣市: '台北市'
  },
  {
    店號: 896067,
    店名: '統聯',
    地址: '台北市中正區忠孝東路二段130-2號130-3號',
    縣市: '台北市'
  },
  {
    店號: 896160,
    店名: '福芝',
    地址: '台北市士林區福國路94號',
    縣市: '台北市'
  },
  {
    店號: 896241,
    店名: '東榮',
    地址: '台北市松山區民生東路五段65號',
    縣市: '台北市'
  },
  {
    店號: 896458,
    店名: '耀港',
    地址: '台北市南港區研究院路一段99號1樓之14',
    縣市: '台北市'
  },
  {
    店號: 896539,
    店名: '昆陽',
    地址: '台北市南港區忠孝東路六段448號',
    縣市: '台北市'
  },
  {
    店號: 900474,
    店名: '萬翔',
    地址: '台北市中正區公園路13號',
    縣市: '台北市'
  },
  {
    店號: 900636,
    店名: '德福',
    地址: '台北市內湖區成功路四段30巷27號29號31號',
    縣市: '台北市'
  },
  {
    店號: 901293,
    店名: '立仁',
    地址: '台北市大安區安和路二段74巷1號',
    縣市: '台北市'
  },
  {
    店號: 902908,
    店名: '風復',
    地址: '台北市松山區復興南路一段43號',
    縣市: '台北市'
  },
  {
    店號: 906209,
    店名: '樂得',
    地址: '台北市松山區復興北路35號',
    縣市: '台北市'
  },
  {
    店號: 906564,
    店名: '松仁',
    地址: '台北市信義區松仁路213號',
    縣市: '台北市'
  },
  {
    店號: 906782,
    店名: '春城',
    地址: '台北市中山區長春路135號135之1號1樓',
    縣市: '台北市'
  },
  {
    店號: 913621,
    店名: '馨瑩',
    地址: '台北市內湖區內湖路一段91巷2號',
    縣市: '台北市'
  },
  {
    店號: 915270,
    店名: '復旦',
    地址: '台北市松山區敦化南路一段5號',
    縣市: '台北市'
  },
  {
    店號: 915568,
    店名: '龍延',
    地址: '台北市大安區師大路59巷13號',
    縣市: '台北市'
  },
  {
    店號: 916527,
    店名: '清愿',
    地址: '台北市松山區八德路二段439號',
    縣市: '台北市'
  },
  {
    店號: 916572,
    店名: '長松',
    地址: '台北市中山區松江路65號',
    縣市: '台北市'
  },
  {
    店號: 916712,
    店名: '敦安',
    地址: '台北市大安區安和路一段86號',
    縣市: '台北市'
  },
  {
    店號: 921633,
    店名: '大信',
    地址: '台北市大安區信義路三段33號',
    縣市: '台北市'
  },
  {
    店號: 921965,
    店名: '羅亭',
    地址: '台北市中正區羅斯福路二段68號',
    縣市: '台北市'
  },
  {
    店號: 922197,
    店名: '開寧',
    地址: '台北市萬華區西寧南路16號',
    縣市: '台北市'
  },
  {
    店號: 928357,
    店名: '吉安',
    地址: '台北市中山區吉林路365號367號農安街137號',
    縣市: '台北市'
  },
  {
    店號: 928531,
    店名: '振華',
    地址: '台北市北投區石牌路二段80號82號',
    縣市: '台北市'
  },
  {
    店號: 929006,
    店名: '欣旺',
    地址: '台北市中山區北安路606號',
    縣市: '台北市'
  },
  {
    店號: 929110,
    店名: '靜安',
    地址: '台北市大安區光復南路262號',
    縣市: '台北市'
  },
  {
    店號: 930637,
    店名: '光東',
    地址: '台北市信義區忠孝東路五段524巷1弄1號',
    縣市: '台北市'
  },
  {
    店號: 935805,
    店名: '光中',
    地址: '台北市北投區光明路122號',
    縣市: '台北市'
  },
  {
    店號: 936244,
    店名: '公館',
    地址: '台北市北投區公館路31號',
    縣市: '台北市'
  },
  {
    店號: 936255,
    店名: '薇閣',
    地址: '台北市北投區中央北路一段108號',
    縣市: '台北市'
  },
  {
    店號: 942722,
    店名: '新羅福',
    地址: '台北市中正區羅斯福路三段80號82號',
    縣市: '台北市'
  },
  {
    店號: 946230,
    店名: '京都',
    地址: '台北市中山區林森北路411號',
    縣市: '台北市'
  },
  {
    店號: 946919,
    店名: '崇光',
    地址: '台北市大安區復興南路一段135巷5號',
    縣市: '台北市'
  },
  {
    店號: 948502,
    店名: '康寧',
    地址: '台北市內湖區康寧路三段26巷1號',
    縣市: '台北市'
  },
  {
    店號: 948649,
    店名: '明德',
    地址: '台北市北投區明德路114號',
    縣市: '台北市'
  },
  {
    店號: 951195,
    店名: '榮鑫',
    地址: '台北市中山區建國北路三段89號91號1樓',
    縣市: '台北市'
  },
  {
    店號: 952615,
    店名: '新潭美',
    地址: '台北市內湖區新明路425號427號',
    縣市: '台北市'
  },
  {
    店號: 955348,
    店名: '士東',
    地址: '台北市士林區士東路48號',
    縣市: '台北市'
  },
  {
    店號: 956156,
    店名: '春森',
    地址: '台北市中山區長春路67號',
    縣市: '台北市'
  },
  {
    店號: 956248,
    店名: '頂東',
    地址: '台北市大安區大安路一段43號',
    縣市: '台北市'
  },
  {
    店號: 956260,
    店名: '寧波',
    地址: '台北市中正區寧波西街3號',
    縣市: '台北市'
  },
  {
    店號: 956673,
    店名: '榮金',
    地址: '台北市中山區龍江路384巷1號384巷3號',
    縣市: '台北市'
  },
  {
    店號: 956732,
    店名: '錦北',
    地址: '台北市中山區錦州街8號',
    縣市: '台北市'
  },
  {
    店號: 956743,
    店名: '華經',
    地址: '台北市內湖區行忠路30號',
    縣市: '台北市'
  },
  {
    店號: 957193,
    店名: '福捷',
    地址: '台北市士林區中正路235巷14號',
    縣市: '台北市'
  },
  {
    店號: 957285,
    店名: '吉忠',
    地址: '台北市大安區延吉街72號',
    縣市: '台北市'
  },
  {
    店號: 957366,
    店名: '新文',
    地址: '台北市士林區文昌路64號',
    縣市: '台北市'
  },
  {
    店號: 958107,
    店名: '撫順',
    地址: '台北市中山區中山北路三段23-6號',
    縣市: '台北市'
  },
  {
    店號: 959122,
    店名: '豐安',
    地址: '台北市大安區東豐街9號',
    縣市: '台北市'
  },
  {
    店號: 959155,
    店名: '信中',
    地址: '台北市大安區信義路三段101號',
    縣市: '台北市'
  },
  {
    店號: 960074,
    店名: '崑崙',
    地址: '台北市中山區中山北路一段105巷13號',
    縣市: '台北市'
  },
  {
    店號: 960096,
    店名: '長津',
    地址: '台北市中山區長安東路一段12號',
    縣市: '台北市'
  },
  {
    店號: 960513,
    店名: '至善天',
    地址: '台北市士林區至善路二段264號',
    縣市: '台北市'
  },
  {
    店號: 960753,
    店名: '富邦',
    地址: '台北市北投區實踐街22號24號',
    縣市: '台北市'
  },
  {
    店號: 960775,
    店名: '草山',
    地址: '台北市士林區格致路28號',
    縣市: '台北市'
  },
  {
    店號: 961000,
    店名: '惠安',
    地址: '台北市信義區惠安里吳興街520號',
    縣市: '台北市'
  },
  {
    店號: 961217,
    店名: '信興',
    地址: '台北市大安區信義路四段32號',
    縣市: '台北市'
  },
  {
    店號: 961424,
    店名: '羅捷',
    地址: '台北市文山區景行里羅斯福路六段391號',
    縣市: '台北市'
  },
  {
    店號: 961848,
    店名: '成湖',
    地址: '台北市內湖區成功路四段346號',
    縣市: '台北市'
  },
  {
    店號: 962184,
    店名: '新國聯',
    地址: '台北市大安區光復南路180巷12號',
    縣市: '台北市'
  },
  {
    店號: 962209,
    店名: '新豪美',
    地址: '台北市北投區文林北路98號100號',
    縣市: '台北市'
  },
  {
    店號: 962346,
    店名: '仙岩',
    地址: '台北市文山區仙岩路18號18-118號18-2號1樓',
    縣市: '台北市'
  },
  {
    店號: 962391,
    店名: '西湖',
    地址: '台北市內湖區內湖路一段321號',
    縣市: '台北市'
  },
  {
    店號: 962483,
    店名: '石捷',
    地址: '台北市北投區石牌路二段8號',
    縣市: '台北市'
  },
  {
    店號: 962542,
    店名: '大龍',
    地址: '台北市大同區昌吉街72號74號76號',
    縣市: '台北市'
  },
  {
    店號: 962601,
    店名: '花市',
    地址: '台北市大安區建國南路一段274號',
    縣市: '台北市'
  },
  {
    店號: 963305,
    店名: '義村',
    地址: '台北市大安區忠孝東路三段160號',
    縣市: '台北市'
  },
  {
    店號: 963556,
    店名: '興貿',
    地址: '台北市信義區景新里莊敬路178巷2號',
    縣市: '台北市'
  },
  {
    店號: 966164,
    店名: '中興醫',
    地址: '台北市大同區鄭州路145號B1',
    縣市: '台北市'
  },
  {
    店號: 966278,
    店名: '新福慶',
    地址: '台北市士林區基河路1號1樓(部份)',
    縣市: '台北市'
  },
  {
    店號: 968388,
    店名: '文儀',
    地址: '台北市文山區木新路三段54號56號',
    縣市: '台北市'
  },
  {
    店號: 968643,
    店名: '清湖',
    地址: '台北市內湖區金湖路49號1樓',
    縣市: '台北市'
  },
  {
    店號: 970288,
    店名: '教育大',
    地址: '台北市大安區敦南街38號',
    縣市: '台北市'
  },
  {
    店號: 970749,
    店名: '鑫長安',
    地址: '台北市中山區長安東路一段53巷1之3號',
    縣市: '台北市'
  },
  {
    店號: 970901,
    店名: '信醫',
    地址: '台北市信義區吳興街346號348號',
    縣市: '台北市'
  },
  {
    店號: 971672,
    店名: '鑫太原',
    地址: '台北市大同區太原路40號42號44號',
    縣市: '台北市'
  },
  {
    店號: 971867,
    店名: '鑫東一',
    地址: '台北市中山區一江街11號13號',
    縣市: '台北市'
  },
  {
    店號: 971890,
    店名: '鑫公信',
    地址: '台北市中正區信陽街2-1號',
    縣市: '台北市'
  },
  {
    店號: 972321,
    店名: '鑫杭',
    地址: '台北市中正區杭州南路一段23號',
    縣市: '台北市'
  },
  {
    店號: 972594,
    店名: '長星',
    地址: '台北市大安區基隆路三段85號',
    縣市: '台北市'
  },
  {
    店號: 972778,
    店名: '松運',
    地址: '台北市中山區松江路101號',
    縣市: '台北市'
  },
  {
    店號: 975054,
    店名: '興芳',
    地址: '台北市文山區興光里興隆路三段173-175號',
    縣市: '台北市'
  },
  {
    店號: 975630,
    店名: '通化',
    地址: '台北市大安區通化街26之8號',
    縣市: '台北市'
  },
  {
    店號: 975663,
    店名: '世運',
    地址: '台北市萬華區昆明街81號83號',
    縣市: '台北市'
  },
  {
    店號: 975788,
    店名: '台大',
    地址: '台北市中正區林森南路53號55號',
    縣市: '台北市'
  },
  {
    店號: 975869,
    店名: '建忠',
    地址: '台北市大安區忠孝東路三段249號',
    縣市: '台北市'
  },
  {
    店號: 975951,
    店名: '華雙',
    地址: '台北市萬華區環河南路二段252號1樓環河南路二段250巷1號1樓',
    縣市: '台北市'
  },
  {
    店號: 975962,
    店名: '仁安',
    地址: '台北市大安區仁愛路四段27巷1號',
    縣市: '台北市'
  },
  {
    店號: 975973,
    店名: '禾光',
    地址: '台北市大安區和平東路二段63號1樓',
    縣市: '台北市'
  },
  {
    店號: 976286,
    店名: '天越',
    地址: '台北市士林區天母東路50巷25號',
    縣市: '台北市'
  },
  {
    店號: 976633,
    店名: '聯坊',
    地址: '台北市南港區東新街118巷1號',
    縣市: '台北市'
  },
  {
    店號: 977290,
    店名: '圓慶',
    地址: '台北市大同區南京西路127號',
    縣市: '台北市'
  },
  {
    店號: 978628,
    店名: '林坊',
    地址: '台北市南港區東新街80巷1號',
    縣市: '台北市'
  },
  {
    店號: 978798,
    店名: '北醫',
    地址: '台北市信義區吳興街252號',
    縣市: '台北市'
  },
  {
    店號: 980355,
    店名: '鑫江南',
    地址: '台北市內湖區文德路6號1樓',
    縣市: '台北市'
  },
  {
    店號: 980436,
    店名: '天富',
    地址: '台北市北投區富貴一路3號1樓',
    縣市: '台北市'
  },
  {
    店號: 981901,
    店名: '宏泰',
    地址: '台北市信義區松仁路91-1號1樓',
    縣市: '台北市'
  },
  {
    店號: 985246,
    店名: '欣安和',
    地址: '台北市大安區安和路一段47號',
    縣市: '台北市'
  },
  {
    店號: 985279,
    店名: '松鑫',
    地址: '台北市中山區松江路208號',
    縣市: '台北市'
  },
  {
    店號: 985280,
    店名: '新雲',
    地址: '台北市中正區三愛里連雲街81號',
    縣市: '台北市'
  },
  {
    店號: 985707,
    店名: '瑞鑫',
    地址: '台北市內湖區瑞光路580號',
    縣市: '台北市'
  },
  {
    店號: 985718,
    店名: '景捷',
    地址: '台北市文山區景福街252號',
    縣市: '台北市'
  },
  {
    店號: 988326,
    店名: '豫鋒',
    地址: '台北市士林區大南路322號',
    縣市: '台北市'
  },
  {
    店號: 990053,
    店名: '新安康',
    地址: '台北市文山區木柵路二段88號90號1樓興隆路四段26號',
    縣市: '台北市'
  },
  {
    店號: 990352,
    店名: '松禾',
    地址: '台北市松山區塔悠路31號33號',
    縣市: '台北市'
  },
  {
    店號: 991551,
    店名: '京發',
    地址: '台北市松山區南京東路五段139之4及139之8號',
    縣市: '台北市'
  },
  {
    店號: 991562,
    店名: '中華電',
    地址: '台北市中正區信義路一段21-3號B1樓',
    縣市: '台北市'
  },
  {
    店號: 991584,
    店名: '威克',
    地址: '台北市中山區南京東路三段208號1樓',
    縣市: '台北市'
  },
  {
    店號: 991702,
    店名: '松家',
    地址: '台北市信義區松山路608號610號',
    縣市: '台北市'
  },
  {
    店號: 991850,
    店名: '長鴻',
    地址: '台北市內湖區大湖山莊街219巷6號8號1樓',
    縣市: '台北市'
  },
  {
    店號: 991894,
    店名: '台師大',
    地址: '台北市文山區汀州路四段88號行政大樓1樓',
    縣市: '台北市'
  },
  {
    店號: 992130,
    店名: '漢中',
    地址: '台北市萬華區漢中街185號187號',
    縣市: '台北市'
  },
  {
    店號: 992336,
    店名: '德倫',
    地址: '台北市大同區承德路三段240號242號1樓',
    縣市: '台北市'
  },
  {
    店號: 992370,
    店名: '福順',
    地址: '台北市士林區重慶北路四段149號151號1樓',
    縣市: '台北市'
  },
  {
    店號: 992381,
    店名: '福通',
    地址: '台北市士林區大南路400號402號1樓',
    縣市: '台北市'
  },
  {
    店號: 992945,
    店名: '社中',
    地址: '台北市士林區社中街320號322號1樓',
    縣市: '台北市'
  },
  {
    店號: 992967,
    店名: '酒泉',
    地址: '台北市大同區重慶北路3段258、260、262號1樓',
    縣市: '台北市'
  },
  {
    店號: 993041,
    店名: '松高',
    地址: '台北市信義區基隆路一段141號1樓',
    縣市: '台北市'
  },
  {
    店號: 993649,
    店名: '和信醫',
    地址: '台北市北投區立德路125號1樓',
    縣市: '台北市'
  },
  {
    店號: 996110,
    店名: '鑫大孝',
    地址: '台北市中正區黎明里重慶南路一段1-1號一樓',
    縣市: '台北市'
  },
  {
    店號: 996154,
    店名: '鳳翔',
    地址: '台北市大安區忠孝東路四段216巷68號',
    縣市: '台北市'
  },
  {
    店號: 996372,
    店名: '鑫武昌',
    地址: '台北市萬華區武昌街二段57號1樓',
    縣市: '台北市'
  },
  {
    店號: 996523,
    店名: '篷萊',
    地址: '台北市大同區寧夏路131-1號',
    縣市: '台北市'
  },
  {
    店號: 996637,
    店名: '和業',
    地址: '台北市北投區中和街10號',
    縣市: '台北市'
  },
  {
    店號: 996741,
    店名: '元大',
    地址: '台北市中山區遼寧街110號1樓',
    縣市: '台北市'
  },
  {
    店號: 997571,
    店名: '聚鑫',
    地址: '台北市士林區延平北路六段350號',
    縣市: '台北市'
  },
  {
    店號: 999083,
    店名: '匯陽',
    地址: '台北市內湖區陽光街383號',
    縣市: '台北市'
  },
  {
    店號: 110286,
    店名: '鴻成',
    地址: '新北市土城區學府路一段28號1樓',
    縣市: '新北市'
  },
  {
    店號: 110301,
    店名: '耀心',
    地址: '新北市板橋區中山路一段50巷22號1樓',
    縣市: '新北市'
  },
  {
    店號: 110507,
    店名: '雙建',
    地址: '新北市新店區二十張路64號64之1號1樓',
    縣市: '新北市'
  },
  {
    店號: 110552,
    店名: '蘆荻',
    地址: '新北市蘆洲區永康街1巷35號1樓',
    縣市: '新北市'
  },
  {
    店號: 110998,
    店名: '百豐',
    地址: '新北市新店區安康路一段168號1樓',
    縣市: '新北市'
  },
  {
    店號: 111371,
    店名: '俊安',
    地址: '新北市樹林區俊英街156號',
    縣市: '新北市'
  },
  {
    店號: 111647,
    店名: '德旺',
    地址: '新北市中和區壽德街22號1樓',
    縣市: '新北市'
  },
  {
    店號: 111913,
    店名: '天下',
    地址: '新北市三峽區中正路一段110號112號1樓',
    縣市: '新北市'
  },
  {
    店號: 111946,
    店名: '城雅',
    地址: '新北市樹林區學成路519號1樓',
    縣市: '新北市'
  },
  {
    店號: 112189,
    店名: '瑞芳',
    地址: '新北市瑞芳區明燈路三段52號54號',
    縣市: '新北市'
  },
  {
    店號: 112400,
    店名: '金崙',
    地址: '新北市淡水區沙崙路24號1樓',
    縣市: '新北市'
  },
  {
    店號: 112569,
    店名: '宏福',
    地址: '新北市新莊區公園一路34號36號1樓',
    縣市: '新北市'
  },
  {
    店號: 113182,
    店名: '後港',
    地址: '新北市新莊區後港一路76巷14弄1號1樓',
    縣市: '新北市'
  },
  {
    店號: 113285,
    店名: '民欣',
    地址: '新北市蘆洲區光榮路63號65號67號',
    縣市: '新北市'
  },
  {
    店號: 113377,
    店名: '飛龍',
    地址: '新北市蘆洲區永安南路二段356號環堤大道2號6號',
    縣市: '新北市'
  },
  {
    店號: 113388,
    店名: '華安',
    地址: '新北市蘆洲區長安街107號',
    縣市: '新北市'
  },
  {
    店號: 113458,
    店名: '莒光',
    地址: '新北市中和區莒光路138號1樓',
    縣市: '新北市'
  },
  {
    店號: 113539,
    店名: '虹諭',
    地址: '新北市三重區中正北路193巷21弄43號',
    縣市: '新北市'
  },
  {
    店號: 113609,
    店名: '和錦',
    地址: '新北市中和區錦和路402號404號',
    縣市: '新北市'
  },
  {
    店號: 113779,
    店名: '春秋',
    地址: '新北市板橋區莒光路40巷14號16號',
    縣市: '新北市'
  },
  {
    店號: 113894,
    店名: '凱園',
    地址: '新北市樹林區國凱街55號1樓',
    縣市: '新北市'
  },
  {
    店號: 113986,
    店名: '至富',
    地址: '新北市林口區中湖里14鄰中湖40號之9',
    縣市: '新北市'
  },
  {
    店號: 114174,
    店名: '慈佑',
    地址: '新北市三重區溪尾街189號191號',
    縣市: '新北市'
  },
  {
    店號: 114657,
    店名: '聖武',
    地址: '新北市中和區新生街48號50號1樓',
    縣市: '新北市'
  },
  {
    店號: 115823,
    店名: '雅盛',
    地址: '新北市板橋區漢生東路181號183號1樓',
    縣市: '新北市'
  },
  {
    店號: 116697,
    店名: '御昇',
    地址: '新北市樹林區佳園路二段34號1樓',
    縣市: '新北市'
  },
  {
    店號: 118349,
    店名: '新板橋',
    地址: '新北市板橋區文化路一段135號',
    縣市: '新北市'
  },
  {
    店號: 118408,
    店名: '重運',
    地址: '新北市三重區三和路四段111-1及111-2號1樓',
    縣市: '新北市'
  },
  {
    店號: 118475,
    店名: '俊興',
    地址: '新北市樹林區三俊街172號1樓',
    縣市: '新北市'
  },
  {
    店號: 118512,
    店名: '建茗',
    地址: '新北市板橋區四川路一段104號',
    縣市: '新北市'
  },
  {
    店號: 118785,
    店名: '忠信',
    地址: '新北市永和區中興街97號99號101號',
    縣市: '新北市'
  },
  {
    店號: 118914,
    店名: '白雲',
    地址: '新北市汐止區民權街二段79號1樓',
    縣市: '新北市'
  },
  {
    店號: 119021,
    店名: '新矽谷',
    地址: '新北市新店區北新路三段205-1號',
    縣市: '新北市'
  },
  {
    店號: 119032,
    店名: '幸亞',
    地址: '新北市三重區溪尾街29號',
    縣市: '新北市'
  },
  {
    店號: 119179,
    店名: '中南',
    地址: '新北市三重區中正南路248-1號248-2號',
    縣市: '新北市'
  },
  {
    店號: 119238,
    店名: '學林',
    地址: '新北市樹林區大雅路341號343號1樓',
    縣市: '新北市'
  },
  {
    店號: 119364,
    店名: '后福',
    地址: '新北市新莊區後港一路29號',
    縣市: '新北市'
  },
  {
    店號: 119397,
    店名: '館東',
    地址: '新北市板橋區館前東路15、15之1、17號1樓',
    縣市: '新北市'
  },
  {
    店號: 119571,
    店名: '香賓',
    地址: '新北市林口區忠孝路382號1樓',
    縣市: '新北市'
  },
  {
    店號: 119755,
    店名: '正南',
    地址: '新北市三重區正義南路67號69號',
    縣市: '新北市'
  },
  {
    店號: 119825,
    店名: '新巨蛋',
    地址: '新北市板橋區長江路一段419號421號423號',
    縣市: '新北市'
  },
  {
    店號: 120364,
    店名: '樹中',
    地址: '新北市板橋區溪城路105號1樓',
    縣市: '新北市'
  },
  {
    店號: 120700,
    店名: '分子尾',
    地址: '新北市三重區仁愛街479號479之1號',
    縣市: '新北市'
  },
  {
    店號: 120722,
    店名: '泰陽',
    地址: '新北市泰山區新北大道六段470號472號',
    縣市: '新北市'
  },
  {
    店號: 120744,
    店名: '金座',
    地址: '新北市新莊區長青街5號7號',
    縣市: '新北市'
  },
  {
    店號: 120755,
    店名: '傑出',
    地址: '新北市新莊區昌平街61號63號1樓',
    縣市: '新北市'
  },
  {
    店號: 121208,
    店名: '板慶',
    地址: '新北市板橋區忠孝路37號1樓2樓',
    縣市: '新北市'
  },
  {
    店號: 121323,
    店名: '秋雅',
    地址: '新北市板橋區南雅南路二段144巷14號1樓',
    縣市: '新北市'
  },
  {
    店號: 122245,
    店名: '福峽',
    地址: '新北市三峽區介壽路一段286號1樓',
    縣市: '新北市'
  },
  {
    店號: 122256,
    店名: '立征',
    地址: '新北市淡水區大義街16號1樓',
    縣市: '新北市'
  },
  {
    店號: 122360,
    店名: '三芝',
    地址: '新北市三芝區中正路一段61號63號1樓',
    縣市: '新北市'
  },
  {
    店號: 122773,
    店名: '重智',
    地址: '新北市三重區大智街195號',
    縣市: '新北市'
  },
  {
    店號: 122865,
    店名: '杰明',
    地址: '新北市中和區泰和街25號1樓',
    縣市: '新北市'
  },
  {
    店號: 122887,
    店名: '館慶',
    地址: '新北市板橋區館前東路26號1樓',
    縣市: '新北市'
  },
  {
    店號: 122924,
    店名: '溪州',
    地址: '新北市板橋區溪崑二街108.110號1樓',
    縣市: '新北市'
  },
  {
    店號: 122980,
    店名: '宇陽',
    地址: '新北市永和區永利路77號',
    縣市: '新北市'
  },
  {
    店號: 123477,
    店名: '歌德',
    地址: '新北市鶯歌區德昌二街77號之1',
    縣市: '新北市'
  },
  {
    店號: 123628,
    店名: '觀海',
    地址: '新北市八里區龍米路一段140號',
    縣市: '新北市'
  },
  {
    店號: 123639,
    店名: '金億',
    地址: '新北市鶯歌區建國路278號',
    縣市: '新北市'
  },
  {
    店號: 125613,
    店名: '新翠華',
    地址: '新北市板橋區三民路一段31巷14號16號',
    縣市: '新北市'
  },
  {
    店號: 126085,
    店名: '金源',
    地址: '新北市土城區水源街59號1樓、福仁街23號1樓',
    縣市: '新北市'
  },
  {
    店號: 126373,
    店名: '歌園',
    地址: '新北市鶯歌區國華路31號',
    縣市: '新北市'
  },
  {
    店號: 126432,
    店名: '岩昇',
    地址: '新北市三峽區溪東路300號',
    縣市: '新北市'
  },
  {
    店號: 126616,
    店名: '立行',
    地址: '新北市三重區力行路二段158號160號',
    縣市: '新北市'
  },
  {
    店號: 126775,
    店名: '水源',
    地址: '新北市中和區中山路二段62號',
    縣市: '新北市'
  },
  {
    店號: 126786,
    店名: '尖山',
    地址: '新北市鶯歌區國際二路6巷1號',
    縣市: '新北市'
  },
  {
    店號: 126797,
    店名: '福來',
    地址: '新北市新莊區五權一路8號',
    縣市: '新北市'
  },
  {
    店號: 126823,
    店名: '新紫城',
    地址: '新北市土城區福安街38號40號',
    縣市: '新北市'
  },
  {
    店號: 126890,
    店名: '瑞新',
    地址: '新北市板橋區瑞安街75號',
    縣市: '新北市'
  },
  {
    店號: 126959,
    店名: '三爪坑',
    地址: '新北市瑞芳區三爪子坑路15號17號',
    縣市: '新北市'
  },
  {
    店號: 127228,
    店名: '喜城',
    地址: '新北市八里區中華路二段562號',
    縣市: '新北市'
  },
  {
    店號: 127332,
    店名: '和和',
    地址: '新北市永和區秀朗路二段128號130號1樓',
    縣市: '新北市'
  },
  {
    店號: 127549,
    店名: '貢寮',
    地址: '新北市貢寮區仁和路9號',
    縣市: '新北市'
  },
  {
    店號: 127642,
    店名: '明志',
    地址: '新北市泰山區工專路68號70號1樓',
    縣市: '新北市'
  },
  {
    店號: 127930,
    店名: '天城',
    地址: '新北市中和區景平路240巷1弄4號',
    縣市: '新北市'
  },
  {
    店號: 128047,
    店名: '興板',
    地址: '新北市板橋區德興街20、22、24號',
    縣市: '新北市'
  },
  {
    店號: 128221,
    店名: '新陽光',
    地址: '新北市泰山區泰林路二段368號370號',
    縣市: '新北市'
  },
  {
    店號: 128520,
    店名: '天闊',
    地址: '新北市新店區環河路16號',
    縣市: '新北市'
  },
  {
    店號: 128689,
    店名: '五工',
    地址: '新北市新莊區福基里17鄰五工二路91號',
    縣市: '新北市'
  },
  {
    店號: 128737,
    店名: '富鄰',
    地址: '新北市汐止區宜興街8號',
    縣市: '新北市'
  },
  {
    店號: 128748,
    店名: '長樂',
    地址: '新北市蘆洲區長安街269號',
    縣市: '新北市'
  },
  {
    店號: 128863,
    店名: '三安',
    地址: '新北市三重區正義北路235號',
    縣市: '新北市'
  },
  {
    店號: 129383,
    店名: '徐匯',
    地址: '新北市蘆洲區中山一路6號1樓',
    縣市: '新北市'
  },
  {
    店號: 130143,
    店名: '大興',
    地址: '新北市三重區仁華街80巷27號1樓',
    縣市: '新北市'
  },
  {
    店號: 130268,
    店名: '昌聖',
    地址: '新北市樹林區文化街21號23號1樓',
    縣市: '新北市'
  },
  {
    店號: 130327,
    店名: '民仁',
    地址: '新北市蘆洲區仁愛街58號60號',
    縣市: '新北市'
  },
  {
    店號: 130350,
    店名: '新洛華',
    地址: '新北市三重區中華路113號115號',
    縣市: '新北市'
  },
  {
    店號: 130453,
    店名: '見欣',
    地址: '新北市淡水區中正東路一段三巷12號1樓',
    縣市: '新北市'
  },
  {
    店號: 130534,
    店名: '中山二',
    地址: '新北市土城區中山路3號B1樓',
    縣市: '新北市'
  },
  {
    店號: 130615,
    店名: '慶嶸',
    地址: '新北市樹林區保安街一段323號323-1號1樓',
    縣市: '新北市'
  },
  {
    店號: 131179,
    店名: '新市鎮',
    地址: '新北市淡水區新市一路三段18號1樓',
    縣市: '新北市'
  },
  {
    店號: 131490,
    店名: '樂福',
    地址: '新北市板橋區中山路二段304號306號1樓',
    縣市: '新北市'
  },
  {
    店號: 131515,
    店名: '蘆華',
    地址: '新北市蘆洲區長安街140號1樓',
    縣市: '新北市'
  },
  {
    店號: 131618,
    店名: '明泰',
    地址: '新北市泰山區明志路二段366號368號1樓',
    縣市: '新北市'
  },
  {
    店號: 131777,
    店名: '鳳祥',
    地址: '新北市新莊區中正路708-2號',
    縣市: '新北市'
  },
  {
    店號: 132002,
    店名: '勝福',
    地址: '新北市汐止區福德一路98號100號(夾層)樓',
    縣市: '新北市'
  },
  {
    店號: 132079,
    店名: '百壽',
    地址: '新北市板橋區文化路一段305號1樓',
    縣市: '新北市'
  },
  {
    店號: 132105,
    店名: '新和',
    地址: '新北市新店區新和街70號72號1樓',
    縣市: '新北市'
  },
  {
    店號: 132264,
    店名: '沅氣',
    地址: '新北市中和區中山路三段29號31號1樓',
    縣市: '新北市'
  },
  {
    店號: 132633,
    店名: '添祥',
    地址: '新北市新莊區天祥街22號24號1樓',
    縣市: '新北市'
  },
  {
    店號: 132747,
    店名: '興和',
    地址: '新北市中和區自立路187號189號1樓',
    縣市: '新北市'
  },
  {
    店號: 133108,
    店名: '太陽城',
    地址: '新北市土城區中央路四段281之8號281之9號',
    縣市: '新北市'
  },
  {
    店號: 135023,
    店名: '幸和',
    地址: '新北市新莊區中和街174號176號1樓',
    縣市: '新北市'
  },
  {
    店號: 135056,
    店名: '捷興',
    地址: '新北市中和區興南路一段81號',
    縣市: '新北市'
  },
  {
    店號: 135300,
    店名: '南勢角',
    地址: '新北市中和區興南路一段55號',
    縣市: '新北市'
  },
  {
    店號: 135388,
    店名: '正泰',
    地址: '新北市板橋區三民路二段202-20及21號1樓',
    縣市: '新北市'
  },
  {
    店號: 135540,
    店名: '紅樹林',
    地址: '新北市淡水區中正東路二段81號1樓',
    縣市: '新北市'
  },
  {
    店號: 135573,
    店名: '幸福市',
    地址: '新北市林口區文化三路二段302號1樓',
    縣市: '新北市'
  },
  {
    店號: 135768,
    店名: '汐科',
    地址: '新北市汐止區大同路二段167-1號1樓',
    縣市: '新北市'
  },
  {
    店號: 136037,
    店名: '金園',
    地址: '新北市板橋區金門街175號',
    縣市: '新北市'
  },
  {
    店號: 136163,
    店名: '建陽',
    地址: '新北市汐止區福德一路452號1樓',
    縣市: '新北市'
  },
  {
    店號: 136624,
    店名: '公園賞',
    地址: '新北市泰山區仁愛路66號',
    縣市: '新北市'
  },
  {
    店號: 136934,
    店名: '蘆權',
    地址: '新北市蘆洲區民權路136號138號1樓',
    縣市: '新北市'
  },
  {
    店號: 136967,
    店名: '中泰',
    地址: '新北市新莊區中港一街10號10-1號',
    縣市: '新北市'
  },
  {
    店號: 137591,
    店名: '嘉添',
    地址: '新北市三峽區嘉添路109-2號',
    縣市: '新北市'
  },
  {
    店號: 137720,
    店名: '百利',
    地址: '新北市三重區仁義街208號',
    縣市: '新北市'
  },
  {
    店號: 137764,
    店名: '真善美',
    地址: '新北市淡水區新市一路三段141號141之1號1樓',
    縣市: '新北市'
  },
  {
    店號: 137834,
    店名: '雙鳳',
    地址: '新北市新莊區雙鳳路114號1樓',
    縣市: '新北市'
  },
  {
    店號: 137904,
    店名: '家麒',
    地址: '新北市板橋區宏國路27號',
    縣市: '新北市'
  },
  {
    店號: 137959,
    店名: '椰城',
    地址: '新北市中和區安平路61號',
    縣市: '新北市'
  },
  {
    店號: 137982,
    店名: '橋安',
    地址: '新北市中和區橋安街20號1F',
    縣市: '新北市'
  },
  {
    店號: 138181,
    店名: '保健',
    地址: '新北市中和區保健路2巷1號1樓',
    縣市: '新北市'
  },
  {
    店號: 138457,
    店名: '和復',
    地址: '新北市中和區復興路19號',
    縣市: '新北市'
  },
  {
    店號: 138549,
    店名: '二橋',
    地址: '新北市鶯歌區中正三路93號',
    縣市: '新北市'
  },
  {
    店號: 138893,
    店名: '安民',
    地址: '新北市新店區安民街133巷9號11號',
    縣市: '新北市'
  },
  {
    店號: 140508,
    店名: '連勝',
    地址: '新北市中和區景平路513號連勝街1號',
    縣市: '新北市'
  },
  {
    店號: 141062,
    店名: '艾科卡',
    地址: '新北市汐止區茄苳路196號',
    縣市: '新北市'
  },
  {
    店號: 141073,
    店名: '康曜',
    地址: '新北市新店區安康路三段41號',
    縣市: '新北市'
  },
  {
    店號: 141202,
    店名: '吉客',
    地址: '新北市中和區德光路90號92號1樓',
    縣市: '新北市'
  },
  {
    店號: 141626,
    店名: '雙捷',
    地址: '新北市蘆洲區信義路162號166號168號1樓',
    縣市: '新北市'
  },
  {
    店號: 141729,
    店名: '景愛',
    地址: '新北市中和區仁愛街45號47號1樓',
    縣市: '新北市'
  },
  {
    店號: 141969,
    店名: '新亞洲',
    地址: '新北市土城區亞洲路110號112號1樓',
    縣市: '新北市'
  },
  {
    店號: 142135,
    店名: '重美',
    地址: '新北市三重區重新路四段100號102號1樓',
    縣市: '新北市'
  },
  {
    店號: 142168,
    店名: '鑫福',
    地址: '新北市新莊區幸福路727號1樓',
    縣市: '新北市'
  },
  {
    店號: 142331,
    店名: '汐湖',
    地址: '新北市汐止區康寧街141巷49號51號1樓',
    縣市: '新北市'
  },
  {
    店號: 142456,
    店名: '秀朗',
    地址: '新北市永和區得和路389號391號1樓',
    縣市: '新北市'
  },
  {
    店號: 143024,
    店名: '萬順',
    地址: '新北市深坑區北深路三段198號200號1樓',
    縣市: '新北市'
  },
  {
    店號: 143183,
    店名: '新展',
    地址: '新北市板橋區大觀路二段185號1樓',
    縣市: '新北市'
  },
  {
    店號: 143688,
    店名: '統客',
    地址: '新北市新店區寶興路49號',
    縣市: '新北市'
  },
  {
    店號: 144289,
    店名: '龍濱',
    地址: '新北市三重區龍濱路207號209號',
    縣市: '新北市'
  },
  {
    店號: 144359,
    店名: '平溪',
    地址: '新北市平溪區靜安路二段338號340號',
    縣市: '新北市'
  },
  {
    店號: 144360,
    店名: '二十張',
    地址: '新北市新店區二十張路5號1樓',
    縣市: '新北市'
  },
  {
    店號: 144393,
    店名: '松林',
    地址: '新北市板橋區松江街109巷1號松江街107號',
    縣市: '新北市'
  },
  {
    店號: 144511,
    店名: '文豪',
    地址: '新北市蘆洲區民族路402號406號1樓',
    縣市: '新北市'
  },
  {
    店號: 144692,
    店名: '新統義',
    地址: '新北市新莊區建中街91號93號1樓',
    縣市: '新北市'
  },
  {
    店號: 144706,
    店名: '民昇',
    地址: '新北市三峽區民生街136號',
    縣市: '新北市'
  },
  {
    店號: 144717,
    店名: '環冠',
    地址: '新北市中和區中山路三段118之6之7之8號',
    縣市: '新北市'
  },
  {
    店號: 146517,
    店名: '錠富',
    地址: '新北市石碇區隆盛里雙溪56號1樓',
    縣市: '新北市'
  },
  {
    店號: 147440,
    店名: '重華',
    地址: '新北市三重區五華街181號185號1樓',
    縣市: '新北市'
  },
  {
    店號: 147989,
    店名: '新兆圓',
    地址: '新北市板橋區實踐路34號34-1號1樓',
    縣市: '新北市'
  },
  {
    店號: 148155,
    店名: '福美',
    地址: '新北市中和區景平路756號756之1號758號758之1號',
    縣市: '新北市'
  },
  {
    店號: 148166,
    店名: '新和高',
    地址: '新北市中和區中正路502號1樓',
    縣市: '新北市'
  },
  {
    店號: 148177,
    店名: '致理',
    地址: '新北市板橋區陽明街23巷29號1樓',
    縣市: '新北市'
  },
  {
    店號: 148502,
    店名: '宏鑫',
    地址: '新北市中和區中正路837號',
    縣市: '新北市'
  },
  {
    店號: 148568,
    店名: '藝高',
    地址: '新北市新莊區中平路357號',
    縣市: '新北市'
  },
  {
    店號: 148627,
    店名: '光員',
    地址: '新北市土城區光明街15號',
    縣市: '新北市'
  },
  {
    店號: 148638,
    店名: '宏圖',
    地址: '新北市永和區永和路一段85號',
    縣市: '新北市'
  },
  {
    店號: 148719,
    店名: '碧興',
    地址: '新北市新店區北宜路一段120號122號1樓',
    縣市: '新北市'
  },
  {
    店號: 148753,
    店名: '社后',
    地址: '新北市汐止區中興里中興路190號',
    縣市: '新北市'
  },
  {
    店號: 148786,
    店名: '金祥',
    地址: '新北市金山區中正路145號',
    縣市: '新北市'
  },
  {
    店號: 148948,
    店名: '板權',
    地址: '新北市板橋區民權路198-200號',
    縣市: '新北市'
  },
  {
    店號: 148960,
    店名: '恩主',
    地址: '新北市三峽區鳶山里21鄰復興路447號',
    縣市: '新北市'
  },
  {
    店號: 148982,
    店名: '泰里',
    地址: '新北市五股區成泰路四段12號1樓',
    縣市: '新北市'
  },
  {
    店號: 149011,
    店名: '瑞信',
    地址: '新北市瑞芳區民生街23號',
    縣市: '新北市'
  },
  {
    店號: 149206,
    店名: '竹捷',
    地址: '新北市淡水區竹圍里民族路10號',
    縣市: '新北市'
  },
  {
    店號: 149239,
    店名: '佳福',
    地址: '新北市土城區青雲路152號',
    縣市: '新北市'
  },
  {
    店號: 149284,
    店名: '重新',
    地址: '新北市三重區重新路四段45號',
    縣市: '新北市'
  },
  {
    店號: 149309,
    店名: '泰山',
    地址: '新北市泰山區楓江路22號24號',
    縣市: '新北市'
  },
  {
    店號: 149538,
    店名: '福強',
    地址: '新北市新店區三民路147之1號149號1樓',
    縣市: '新北市'
  },
  {
    店號: 149723,
    店名: '藝寶',
    地址: '新北市新莊區立信三街8號',
    縣市: '新北市'
  },
  {
    店號: 149745,
    店名: '港義',
    地址: '新北市新莊區中港路527號1樓和中美街2號1樓',
    縣市: '新北市'
  },
  {
    店號: 149815,
    店名: '蘆永',
    地址: '新北市蘆洲區永安南路二段18號',
    縣市: '新北市'
  },
  {
    店號: 150804,
    店名: '品嘉',
    地址: '新北市新莊區新樹路69之4號之5號1樓',
    縣市: '新北市'
  },
  {
    店號: 150859,
    店名: '民德',
    地址: '新北市中和區民德路47號47-1號',
    縣市: '新北市'
  },
  {
    店號: 150860,
    店名: '鑫鑫',
    地址: '新北市淡水區水源街二段76號',
    縣市: '新北市'
  },
  {
    店號: 151003,
    店名: '大智通',
    地址: '新北市樹林區佳園路二段70-1號',
    縣市: '新北市'
  },
  {
    店號: 151092,
    店名: '延城',
    地址: '新北市土城區延和路203號1樓',
    縣市: '新北市'
  },
  {
    店號: 151128,
    店名: '健倫',
    地址: '新北市蘆洲區保新里4鄰三民路230號',
    縣市: '新北市'
  },
  {
    店號: 151380,
    店名: '觀泰',
    地址: '新北市板橋區大觀路二段174巷166弄2號4號',
    縣市: '新北市'
  },
  {
    店號: 151601,
    店名: '錦盛',
    地址: '新北市中和區錦盛里圓通路335巷三弄21號',
    縣市: '新北市'
  },
  {
    店號: 151841,
    店名: '新建興',
    地址: '新北市瑞芳區大埔路138號',
    縣市: '新北市'
  },
  {
    店號: 151852,
    店名: '東科大',
    地址: '新北市汐止區新台五路一段96號',
    縣市: '新北市'
  },
  {
    店號: 151988,
    店名: '榮和',
    地址: '新北市新莊區中和街191巷1號3號5號',
    縣市: '新北市'
  },
  {
    店號: 152006,
    店名: '漳和',
    地址: '新北市中和區中山路二段131-6號',
    縣市: '新北市'
  },
  {
    店號: 152062,
    店名: '元坊',
    地址: '新北市永和區保安路134號136號',
    縣市: '新北市'
  },
  {
    店號: 152132,
    店名: '寶福',
    地址: '新北市新店區寶橋路78巷3號1F',
    縣市: '新北市'
  },
  {
    店號: 153331,
    店名: '溫泉',
    地址: '新北市萬里區大鵬里萬里加投15鄰197號1樓',
    縣市: '新北市'
  },
  {
    店號: 153401,
    店名: '富旺',
    地址: '新北市新莊區自立街176號178號1樓',
    縣市: '新北市'
  },
  {
    店號: 153423,
    店名: '台藝大',
    地址: '新北市板橋區大觀路一段59號',
    縣市: '新北市'
  },
  {
    店號: 153526,
    店名: '旺來',
    地址: '新北市林口區文化三路二段20號1樓',
    縣市: '新北市'
  },
  {
    店號: 155393,
    店名: '雙華',
    地址: '新北市蘆洲區中華街39號、中華街35巷6號1樓',
    縣市: '新北市'
  },
  {
    店號: 155566,
    店名: '新順安',
    地址: '新北市新店區順安街51號53號1樓',
    縣市: '新北市'
  },
  {
    店號: 158336,
    店名: '歐洲',
    地址: '新北市三峽區三樹路199號',
    縣市: '新北市'
  },
  {
    店號: 158347,
    店名: '國慶',
    地址: '新北市板橋區國慶路153號',
    縣市: '新北市'
  },
  {
    店號: 158473,
    店名: '福多',
    地址: '新北市樹林區三福街39號41號',
    縣市: '新北市'
  },
  {
    店號: 158521,
    店名: '新積穗',
    地址: '新北市中和區民安街27號29號1樓',
    縣市: '新北市'
  },
  {
    店號: 158565,
    店名: '富營',
    地址: '新北市新莊區富國路20號1樓',
    縣市: '新北市'
  },
  {
    店號: 158602,
    店名: '英海',
    地址: '新北市板橋區雨農路50號',
    縣市: '新北市'
  },
  {
    店號: 158646,
    店名: '立金',
    地址: '新北市土城區立德路70號72號',
    縣市: '新北市'
  },
  {
    店號: 158691,
    店名: '瑞林',
    地址: '新北市板橋區龍翠里大同街52號',
    縣市: '新北市'
  },
  {
    店號: 158945,
    店名: '美慈',
    地址: '新北市三重區慈愛街52號',
    縣市: '新北市'
  },
  {
    店號: 158989,
    店名: '智華',
    地址: '新北市蘆洲區光華路72號',
    縣市: '新北市'
  },
  {
    店號: 158990,
    店名: '福營',
    地址: '新北市新莊區福營里建國一路50號52號',
    縣市: '新北市'
  },
  {
    店號: 159166,
    店名: '冠德',
    地址: '新北市中和區景平路71-5號',
    縣市: '新北市'
  },
  {
    店號: 159225,
    店名: '大坪林',
    地址: '新北市新店區民權路18號',
    縣市: '新北市'
  },
  {
    店號: 159328,
    店名: '安成',
    地址: '新北市新店區安成街35號29號',
    縣市: '新北市'
  },
  {
    店號: 159339,
    店名: '安城',
    地址: '新北市新店區安康路一段283號',
    縣市: '新北市'
  },
  {
    店號: 159432,
    店名: '中央',
    地址: '新北市新莊區中平路439號B1樓',
    縣市: '新北市'
  },
  {
    店號: 159465,
    店名: '三好',
    地址: '新北市三重區自強路四段102號104號1樓',
    縣市: '新北市'
  },
  {
    店號: 159476,
    店名: '長九',
    地址: '新北市蘆洲區九芎街92號94號1樓',
    縣市: '新北市'
  },
  {
    店號: 159487,
    店名: '保平',
    地址: '新北市永和區保平路135號',
    縣市: '新北市'
  },
  {
    店號: 160122,
    店名: '佳林',
    地址: '新北市林口區林口路197號',
    縣市: '新北市'
  },
  {
    店號: 160166,
    店名: '鷺江',
    地址: '新北市蘆洲區長榮路679號1樓',
    縣市: '新北市'
  },
  {
    店號: 161158,
    店名: '新真理',
    地址: '新北市淡水區新民街102號104號',
    縣市: '新北市'
  },
  {
    店號: 161572,
    店名: '埔運',
    地址: '新北市板橋區民生路三段40號42號1樓',
    縣市: '新北市'
  },
  {
    店號: 162162,
    店名: '忠柯',
    地址: '新北市林口區忠孝路642號',
    縣市: '新北市'
  },
  {
    店號: 162195,
    店名: '協元',
    地址: '新北市淡水區中山路176之2號1樓',
    縣市: '新北市'
  },
  {
    店號: 162313,
    店名: '深坑',
    地址: '新北市深坑區北深路三段145號',
    縣市: '新北市'
  },
  {
    店號: 162542,
    店名: '鶯歌',
    地址: '新北市鶯歌區國慶街139之1號1樓',
    縣市: '新北市'
  },
  {
    店號: 163730,
    店名: '戰國',
    地址: '新北市板橋區永豐街173號175號',
    縣市: '新北市'
  },
  {
    店號: 163800,
    店名: '建德',
    地址: '新北市汐止區福德一路399號1樓',
    縣市: '新北市'
  },
  {
    店號: 163866,
    店名: '華德',
    地址: '新北市板橋區四川路二段47巷3弄8號及8之1號',
    縣市: '新北市'
  },
  {
    店號: 163877,
    店名: '連通',
    地址: '新北市中和區圓通路293號',
    縣市: '新北市'
  },
  {
    店號: 163888,
    店名: '成洲',
    地址: '新北市五股區成泰路三段577巷92號94號96號',
    縣市: '新北市'
  },
  {
    店號: 163899,
    店名: '清和',
    地址: '新北市土城區清水路100號',
    縣市: '新北市'
  },
  {
    店號: 163903,
    店名: '福祥',
    地址: '新北市土城區中央路一段320號322號',
    縣市: '新北市'
  },
  {
    店號: 163947,
    店名: '鳳福',
    地址: '新北市鶯歌區鶯桃路二段48號50號1樓',
    縣市: '新北市'
  },
  {
    店號: 163981,
    店名: '新淡專',
    地址: '新北市淡水區新民街180巷18號20號1樓',
    縣市: '新北市'
  },
  {
    店號: 163992,
    店名: '潭安',
    地址: '新北市永和區中正路167號',
    縣市: '新北市'
  },
  {
    店號: 164009,
    店名: '界和',
    地址: '新北市永和區中和路339號339號之1',
    縣市: '新北市'
  },
  {
    店號: 164087,
    店名: '錦興',
    地址: '新北市新莊區思源路181號',
    縣市: '新北市'
  },
  {
    店號: 164180,
    店名: '登頂',
    地址: '新北市三重區光復路二段2號',
    縣市: '新北市'
  },
  {
    店號: 164227,
    店名: '弘安',
    地址: '新北市新莊區萬安街82號84號',
    縣市: '新北市'
  },
  {
    店號: 164238,
    店名: '正孝',
    地址: '新北市三重區中正北路151號153號',
    縣市: '新北市'
  },
  {
    店號: 164249,
    店名: '龍安',
    地址: '新北市新莊區龍安路256號',
    縣市: '新北市'
  },
  {
    店號: 164320,
    店名: '學府',
    地址: '新北市淡水區學府路39號41號1樓',
    縣市: '新北市'
  },
  {
    店號: 164375,
    店名: '忠華',
    地址: '新北市土城區中華路一段185號187號1樓',
    縣市: '新北市'
  },
  {
    店號: 164386,
    店名: '大東圓',
    地址: '新北市樹林區柑園街一段67號67-1號67-2號1樓',
    縣市: '新北市'
  },
  {
    店號: 164397,
    店名: '樹新',
    地址: '新北市樹林區樹新路245號',
    縣市: '新北市'
  },
  {
    店號: 164456,
    店名: '福仁',
    地址: '新北市汐止區仁愛路143號1樓福安街51號1樓',
    縣市: '新北市'
  },
  {
    店號: 164537,
    店名: '日揚',
    地址: '新北市三重區中正北路18之2號之3號之4號1樓',
    縣市: '新北市'
  },
  {
    店號: 164663,
    店名: '虹海',
    地址: '新北市土城區中央路四段109號111號1樓',
    縣市: '新北市'
  },
  {
    店號: 164685,
    店名: '凡賽絲',
    地址: '新北市新店區安民街290號1樓',
    縣市: '新北市'
  },
  {
    店號: 164696,
    店名: '興光',
    地址: '新北市三重區大同南路220號',
    縣市: '新北市'
  },
  {
    店號: 164755,
    店名: '學城',
    地址: '新北市土城區學府路一段118號',
    縣市: '新北市'
  },
  {
    店號: 164847,
    店名: '景順',
    地址: '新北市中和區中正路778號1樓',
    縣市: '新北市'
  },
  {
    店號: 164858,
    店名: '春吉',
    地址: '新北市中和區建一路148號',
    縣市: '新北市'
  },
  {
    店號: 164881,
    店名: '元龍',
    地址: '新北市中和區板南路655號1樓',
    縣市: '新北市'
  },
  {
    店號: 164892,
    店名: '未來',
    地址: '新北市林口區文化二路一段571號1樓2樓',
    縣市: '新北市'
  },
  {
    店號: 164917,
    店名: '新樹工',
    地址: '新北市樹林區保安街二段6號',
    縣市: '新北市'
  },
  {
    店號: 165390,
    店名: '西雅圖',
    地址: '新北市八里區中山路二段151號153號1樓',
    縣市: '新北市'
  },
  {
    店號: 165426,
    店名: '家美',
    地址: '新北市中和區中山路二段317號之1',
    縣市: '新北市'
  },
  {
    店號: 165448,
    店名: '光仁',
    地址: '新北市板橋區中山路二段273號',
    縣市: '新北市'
  },
  {
    店號: 165530,
    店名: '安佳',
    地址: '新北市新店區安祥路111號',
    縣市: '新北市'
  },
  {
    店號: 165541,
    店名: '豫溪',
    地址: '新北市永和區中正路702巷1號3號及中正路710號',
    縣市: '新北市'
  },
  {
    店號: 165552,
    店名: '園林',
    地址: '新北市板橋區南雅西路二段102號104號1樓',
    縣市: '新北市'
  },
  {
    店號: 165596,
    店名: '元町',
    地址: '新北市鶯歌區光明街128號130號1樓',
    縣市: '新北市'
  },
  {
    店號: 165611,
    店名: '福運',
    地址: '新北市三重區福德北路57號59號1樓',
    縣市: '新北市'
  },
  {
    店號: 165633,
    店名: '鶯桃',
    地址: '新北市鶯歌區鶯桃路二段7號',
    縣市: '新北市'
  },
  {
    店號: 165666,
    店名: '長元',
    地址: '新北市三重區長元街2-2號',
    縣市: '新北市'
  },
  {
    店號: 165688,
    店名: '馥都',
    地址: '新北市板橋區中山路二段399號401號',
    縣市: '新北市'
  },
  {
    店號: 165703,
    店名: '福泰',
    地址: '新北市五股區五福路49號51號1樓',
    縣市: '新北市'
  },
  {
    店號: 165725,
    店名: '立言',
    地址: '新北市中和區中正路872號',
    縣市: '新北市'
  },
  {
    店號: 165770,
    店名: '昌展',
    地址: '新北市樹林區復興路67號1樓',
    縣市: '新北市'
  },
  {
    店號: 165828,
    店名: '輔進',
    地址: '新北市新莊區中正路510號',
    縣市: '新北市'
  },
  {
    店號: 165998,
    店名: '學裕',
    地址: '新北市土城區學成路91巷2號93號1樓',
    縣市: '新北市'
  },
  {
    店號: 166038,
    店名: '新安',
    地址: '新北市新莊區民安東路185號187號部份1樓',
    縣市: '新北市'
  },
  {
    店號: 166072,
    店名: '麗興',
    地址: '新北市林口區麗園一街11巷1號1樓之2',
    縣市: '新北市'
  },
  {
    店號: 166120,
    店名: '樂鑫',
    地址: '新北市中和區新生街146號',
    縣市: '新北市'
  },
  {
    店號: 166131,
    店名: '新茂',
    地址: '新北市新莊區化成路118號120號',
    縣市: '新北市'
  },
  {
    店號: 166153,
    店名: '永中',
    地址: '新北市永和區中山路一段58號',
    縣市: '新北市'
  },
  {
    店號: 166164,
    店名: '大正',
    地址: '新北市永和區中正路559號561號1樓2樓',
    縣市: '新北市'
  },
  {
    店號: 166197,
    店名: '福愛',
    地址: '新北市永和區永平路274號仁愛路242號',
    縣市: '新北市'
  },
  {
    店號: 166201,
    店名: '原成',
    地址: '新北市新莊區化成路305號1樓',
    縣市: '新北市'
  },
  {
    店號: 166393,
    店名: '新猷',
    地址: '新北市新店區安和路三段81號83號1樓',
    縣市: '新北市'
  },
  {
    店號: 166441,
    店名: '板勝',
    地址: '新北市中和區連城路219巷6號8號',
    縣市: '新北市'
  },
  {
    店號: 166751,
    店名: '二甲',
    地址: '新北市鶯歌區中正三路165號167號',
    縣市: '新北市'
  },
  {
    店號: 166898,
    店名: '裕民',
    地址: '新北市板橋區裕民街110號',
    縣市: '新北市'
  },
  {
    店號: 167156,
    店名: '金聖',
    地址: '新北市淡水區淡金路四段493號',
    縣市: '新北市'
  },
  {
    店號: 167592,
    店名: '中平',
    地址: '新北市新莊區中平路76號1樓',
    縣市: '新北市'
  },
  {
    店號: 167732,
    店名: '湖前',
    地址: '新北市汐止區明峰街120號1樓',
    縣市: '新北市'
  },
  {
    店號: 167846,
    店名: '板維',
    地址: '新北市板橋區四維路345號347號1樓',
    縣市: '新北市'
  },
  {
    店號: 167938,
    店名: '瑞明',
    地址: '新北市瑞芳區明燈路三段86號1樓2樓',
    縣市: '新北市'
  },
  {
    店號: 167949,
    店名: '長壽',
    地址: '新北市三重區正義北路198號200號1樓',
    縣市: '新北市'
  },
  {
    店號: 168023,
    店名: '民視',
    地址: '新北市林口區信義路101號1樓',
    縣市: '新北市'
  },
  {
    店號: 169794,
    店名: '永振',
    地址: '新北市中和區南華路14號',
    縣市: '新北市'
  },
  {
    店號: 169897,
    店名: '昌原',
    地址: '新北市新莊區中原路137之1之2之3號1樓',
    縣市: '新北市'
  },
  {
    店號: 170107,
    店名: '金星',
    地址: '新北市淡水區北新路65號',
    縣市: '新北市'
  },
  {
    店號: 170200,
    店名: '集吉',
    地址: '新北市三重區三賢街61號63號1樓',
    縣市: '新北市'
  },
  {
    店號: 170222,
    店名: '雅東',
    地址: '新北市板橋區南雅東路31之1號5號6號7號1樓',
    縣市: '新北市'
  },
  {
    店號: 170244,
    店名: '國庭',
    地址: '新北市板橋區國光路1號3號1樓',
    縣市: '新北市'
  },
  {
    店號: 170509,
    店名: '滿泰',
    地址: '新北市泰山區明志路一段28、30號1樓',
    縣市: '新北市'
  },
  {
    店號: 170705,
    店名: '北新',
    地址: '新北市新店區北新路一段289號291號',
    縣市: '新北市'
  },
  {
    店號: 171111,
    店名: '加州',
    地址: '新北市新莊區中平路81巷2號',
    縣市: '新北市'
  },
  {
    店號: 171568,
    店名: '下竹圍',
    地址: '新北市三重區下竹圍街26號',
    縣市: '新北市'
  },
  {
    店號: 171580,
    店名: '汐忠',
    地址: '新北市汐止區忠孝東路282號',
    縣市: '新北市'
  },
  {
    店號: 173542,
    店名: '福德',
    地址: '新北市新店區三民路179號1樓',
    縣市: '新北市'
  },
  {
    店號: 173575,
    店名: '明園',
    地址: '新北市汐止區汐萬路二段62巷1號1樓',
    縣市: '新北市'
  },
  {
    店號: 173597,
    店名: '樹鳳',
    地址: '新北市樹林區中正路417號 1樓',
    縣市: '新北市'
  },
  {
    店號: 173612,
    店名: '金沙',
    地址: '新北市淡水區沙崙路133號',
    縣市: '新北市'
  },
  {
    店號: 173667,
    店名: '前瞻',
    地址: '新北市三重區新北大道二段258號',
    縣市: '新北市'
  },
  {
    店號: 173704,
    店名: '合喬',
    地址: '新北市樹林區三福街68號',
    縣市: '新北市'
  },
  {
    店號: 173715,
    店名: '觀景',
    地址: '新北市八里區觀海大道53號',
    縣市: '新北市'
  },
  {
    店號: 173737,
    店名: '家豐',
    地址: '新北市板橋區中山路二段137號1樓',
    縣市: '新北市'
  },
  {
    店號: 173760,
    店名: '永樂',
    地址: '新北市蘆洲區永樂街35號37號1樓',
    縣市: '新北市'
  },
  {
    店號: 173782,
    店名: '新廣',
    地址: '新北市新店區中正路542之5號1樓',
    縣市: '新北市'
  },
  {
    店號: 173793,
    店名: '一新',
    地址: '新北市中和區永和路56號58號1樓',
    縣市: '新北市'
  },
  {
    店號: 173841,
    店名: '寶強',
    地址: '新北市新店區寶中路88號1樓',
    縣市: '新北市'
  },
  {
    店號: 173999,
    店名: '重安',
    地址: '新北市三重區重安街60號及60-1號',
    縣市: '新北市'
  },
  {
    店號: 174039,
    店名: '新春',
    地址: '新北市淡水區新春街142號1樓',
    縣市: '新北市'
  },
  {
    店號: 174062,
    店名: '雙源',
    地址: '新北市板橋區雙十路二段47巷30號32號',
    縣市: '新北市'
  },
  {
    店號: 174121,
    店名: '汐峰',
    地址: '新北市汐止區仁愛路32號34號1樓',
    縣市: '新北市'
  },
  {
    店號: 174165,
    店名: '德聖',
    地址: '新北市林口區公園路17號',
    縣市: '新北市'
  },
  {
    店號: 174202,
    店名: '時安',
    地址: '新北市新莊區建安街95號97號1樓',
    縣市: '新北市'
  },
  {
    店號: 174213,
    店名: '修德',
    地址: '新北市三重區重陽路三段11號13號1樓',
    縣市: '新北市'
  },
  {
    店號: 174224,
    店名: '宏懋',
    地址: '新北市新莊區民安西路70號72號1樓',
    縣市: '新北市'
  },
  {
    店號: 174257,
    店名: '一級棒',
    地址: '新北市新莊區新北大道七段482號',
    縣市: '新北市'
  },
  {
    店號: 174419,
    店名: '股興',
    地址: '新北市五股區中興路一段3號、3-1號',
    縣市: '新北市'
  },
  {
    店號: 174523,
    店名: '登峰',
    地址: '新北市汐止區新台五路一段149號1樓',
    縣市: '新北市'
  },
  {
    店號: 174590,
    店名: '世紀',
    地址: '新北市中和區中正路710號1樓K棟',
    縣市: '新北市'
  },
  {
    店號: 174637,
    店名: '樹林',
    地址: '新北市樹林區保安街一段3號',
    縣市: '新北市'
  },
  {
    店號: 174730,
    店名: '智樂',
    地址: '新北市板橋區新生街89巷2號',
    縣市: '新北市'
  },
  {
    店號: 174763,
    店名: '慶祥',
    地址: '新北市土城區中華路二段126號1樓',
    縣市: '新北市'
  },
  {
    店號: 174785,
    店名: '新峽',
    地址: '新北市三峽區民權街184號186號1樓',
    縣市: '新北市'
  },
  {
    店號: 174833,
    店名: '建中',
    地址: '新北市新莊區建中街6號8號',
    縣市: '新北市'
  },
  {
    店號: 174925,
    店名: '東晴',
    地址: '新北市汐止區新台五路二段80號',
    縣市: '新北市'
  },
  {
    店號: 174992,
    店名: '金林',
    地址: '新北市板橋區金門街303號305號',
    縣市: '新北市'
  },
  {
    店號: 175065,
    店名: '御城',
    地址: '新北市五股區御史路3號5號1樓',
    縣市: '新北市'
  },
  {
    店號: 177061,
    店名: '旭昇',
    地址: '新北市汐止區大同路三段332號',
    縣市: '新北市'
  },
  {
    店號: 177418,
    店名: '新北大',
    地址: '新北市三峽區大學路156號1樓',
    縣市: '新北市'
  },
  {
    店號: 179632,
    店名: '合康',
    地址: '新北市三重區永福街179之1及179之2號1樓',
    縣市: '新北市'
  },
  {
    店號: 179724,
    店名: '正原',
    地址: '新北市中和區中山路二段530號1樓',
    縣市: '新北市'
  },
  {
    店號: 179849,
    店名: '遠東',
    地址: '新北市汐止區新台五路一段75號1樓之2',
    縣市: '新北市'
  },
  {
    店號: 179861,
    店名: '樂陶',
    地址: '新北市鶯歌區尖山路276號1樓',
    縣市: '新北市'
  },
  {
    店號: 180414,
    店名: '樹佳',
    地址: '新北市樹林區佳園路三段31之1號',
    縣市: '新北市'
  },
  {
    店號: 180506,
    店名: '鎮天',
    地址: '新北市汐止區大同路三段611之5號611之6號1樓',
    縣市: '新北市'
  },
  {
    店號: 180643,
    店名: '池田',
    地址: '新北市蘆洲區民族路224號226號1樓',
    縣市: '新北市'
  },
  {
    店號: 180816,
    店名: '觀龍',
    地址: '新北市板橋區龍興街39號41號1樓',
    縣市: '新北市'
  },
  {
    店號: 180953,
    店名: '川詠山',
    地址: '新北市三重區集賢路158號1樓',
    縣市: '新北市'
  },
  {
    店號: 180997,
    店名: '伯爵',
    地址: '新北市汐止區明峰街13號13之1號1樓',
    縣市: '新北市'
  },
  {
    店號: 181107,
    店名: '珈多',
    地址: '新北市泰山區台麗街5號7號9號1樓',
    縣市: '新北市'
  },
  {
    店號: 181211,
    店名: '景平',
    地址: '新北市中和區景平路149號1樓',
    縣市: '新北市'
  },
  {
    店號: 181358,
    店名: '荷運',
    地址: '新北市三重區三和路四段97號.97之1.97之2號1樓',
    縣市: '新北市'
  },
  {
    店號: 181417,
    店名: '峽北',
    地址: '新北市三峽區大同路9號1樓',
    縣市: '新北市'
  },
  {
    店號: 181473,
    店名: '永權',
    地址: '新北市永和區民權路32號34號1樓',
    縣市: '新北市'
  },
  {
    店號: 181716,
    店名: '維妮',
    地址: '新北市新莊區四維路23號1樓',
    縣市: '新北市'
  },
  {
    店號: 182317,
    店名: '燿福',
    地址: '新北市土城區中山路1-1號1樓',
    縣市: '新北市'
  },
  {
    店號: 182605,
    店名: '湯城',
    地址: '新北市三重區重新路5段609巷16之7 號1樓',
    縣市: '新北市'
  },
  {
    店號: 182812,
    店名: '復育',
    地址: '新北市樹林區復興路227號1樓',
    縣市: '新北市'
  },
  {
    店號: 183088,
    店名: '青山',
    地址: '新北市汐止區新興路83-2號',
    縣市: '新北市'
  },
  {
    店號: 183295,
    店名: '臣峰',
    地址: '新北市林口區文化北路一段62之1號',
    縣市: '新北市'
  },
  {
    店號: 183402,
    店名: '民揚',
    地址: '新北市五股區新五路二段572號1樓',
    縣市: '新北市'
  },
  {
    店號: 183413,
    店名: '八仙',
    地址: '新北市八里區中華路二段290號292號296號',
    縣市: '新北市'
  },
  {
    店號: 183491,
    店名: '海神',
    地址: '新北市八里區中山路二段6號8號',
    縣市: '新北市'
  },
  {
    店號: 183594,
    店名: '永竹',
    地址: '新北市永和區竹林路172號174號1樓',
    縣市: '新北市'
  },
  {
    店號: 183619,
    店名: 'TBI',
    地址: '新北市樹林區三多路139號1樓',
    縣市: '新北市'
  },
  {
    店號: 183631,
    店名: '廣美',
    地址: '新北市中和區中和路52號1.2樓',
    縣市: '新北市'
  },
  {
    店號: 183642,
    店名: '汐園',
    地址: '新北市汐止區大同路一段237之7號1樓',
    縣市: '新北市'
  },
  {
    店號: 183790,
    店名: '維禮',
    地址: '新北市板橋區四維路276號278號1樓',
    縣市: '新北市'
  },
  {
    店號: 184047,
    店名: '正鵬',
    地址: '新北市新店區中正路688號690號1樓',
    縣市: '新北市'
  },
  {
    店號: 184184,
    店名: '金裕',
    地址: '新北市土城區裕民路255號1樓',
    縣市: '新北市'
  },
  {
    店號: 184276,
    店名: '文正',
    地址: '新北市新莊區中正路188號1樓',
    縣市: '新北市'
  },
  {
    店號: 184841,
    店名: '新工建',
    地址: '新北市汐止區中興路60號',
    縣市: '新北市'
  },
  {
    店號: 184977,
    店名: '橋東',
    地址: '新北市汐止區建成路31號33號1樓',
    縣市: '新北市'
  },
  {
    店號: 185039,
    店名: '和華',
    地址: '新北市蘆洲區正和街28號',
    縣市: '新北市'
  },
  {
    店號: 185073,
    店名: '真莘',
    地址: '新北市新店區中正路362號',
    縣市: '新北市'
  },
  {
    店號: 185095,
    店名: '明日城',
    地址: '新北市泰山區信華六街17號19號1樓',
    縣市: '新北市'
  },
  {
    店號: 185121,
    店名: '遠來',
    地址: '新北市林口區仁愛路二段510號1樓',
    縣市: '新北市'
  },
  {
    店號: 185132,
    店名: '萬誠',
    地址: '新北市三峽區民生街25號',
    縣市: '新北市'
  },
  {
    店號: 185349,
    店名: '員新',
    地址: '新北市中和區員山路504號',
    縣市: '新北市'
  },
  {
    店號: 185420,
    店名: '偕成',
    地址: '新北市淡水區民生路54號',
    縣市: '新北市'
  },
  {
    店號: 185442,
    店名: '新福民',
    地址: '新北市新店區中央路135號1樓',
    縣市: '新北市'
  },
  {
    店號: 185534,
    店名: '南強',
    地址: '新北市新店區中興路三段168號1F',
    縣市: '新北市'
  },
  {
    店號: 185590,
    店名: '得勝',
    地址: '新北市蘆洲區得勝街67號1樓',
    縣市: '新北市'
  },
  {
    店號: 185671,
    店名: '豐成',
    地址: '新北市板橋區三民路一段31巷89弄10號12號1樓',
    縣市: '新北市'
  },
  {
    店號: 185785,
    店名: '府中',
    地址: '新北市板橋區府中路82號84號1樓',
    縣市: '新北市'
  },
  {
    店號: 185811,
    店名: '北宜',
    地址: '新北市新店區北宜路二段82號之2',
    縣市: '新北市'
  },
  {
    店號: 185877,
    店名: '成旺',
    地址: '新北市五股區成泰路三段212號216號218號1樓',
    縣市: '新北市'
  },
  {
    店號: 185899,
    店名: '溪崑',
    地址: '新北市板橋區大觀路三段212巷70號72號1樓',
    縣市: '新北市'
  },
  {
    店號: 185925,
    店名: '榮泰',
    地址: '新北市三峽區文化路63號65巷2號1樓',
    縣市: '新北市'
  },
  {
    店號: 185947,
    店名: '新贊',
    地址: '新北市新店區北新路一段14號1樓',
    縣市: '新北市'
  },
  {
    店號: 186010,
    店名: '台北灣',
    地址: '新北市淡水區新市一路一段108號1樓',
    縣市: '新北市'
  },
  {
    店號: 186191,
    店名: '洲子洋',
    地址: '新北市五股區芳洲八路107號109號111號1.2樓',
    縣市: '新北市'
  },
  {
    店號: 186386,
    店名: '新民享',
    地址: '新北市中和區民享街91號',
    縣市: '新北市'
  },
  {
    店號: 186412,
    店名: '富仟',
    地址: '新北市三重區五谷王北街139號',
    縣市: '新北市'
  },
  {
    店號: 186490,
    店名: '霖口',
    地址: '新北市林口區中山路250號250之3號1樓',
    縣市: '新北市'
  },
  {
    店號: 186629,
    店名: '昌福',
    地址: '新北市新莊區福壽街101號1樓',
    縣市: '新北市'
  },
  {
    店號: 186755,
    店名: '安林',
    地址: '新北市林口區文化二路一段24號26號',
    縣市: '新北市'
  },
  {
    店號: 186766,
    店名: '來峰',
    地址: '新北市五股區成泰路一段163號165號1樓',
    縣市: '新北市'
  },
  {
    店號: 186799,
    店名: '縣東',
    地址: '新北市板橋區縣民大道二段108號1樓',
    縣市: '新北市'
  },
  {
    店號: 186803,
    店名: '貝比',
    地址: '新北市林口區湖南村8鄰頭湖70-9號',
    縣市: '新北市'
  },
  {
    店號: 186825,
    店名: '頂新',
    地址: '新北市中和區興南路二段49號51號',
    縣市: '新北市'
  },
  {
    店號: 186869,
    店名: '汐政',
    地址: '新北市汐止區汐萬路一段222號1樓',
    縣市: '新北市'
  },
  {
    店號: 186870,
    店名: '中林',
    地址: '新北市土城區員林街14號',
    縣市: '新北市'
  },
  {
    店號: 186892,
    店名: '莒城',
    地址: '新北市中和區莒光路91號93號1樓',
    縣市: '新北市'
  },
  {
    店號: 186928,
    店名: '長坑',
    地址: '新北市八里區中華路三段168號',
    縣市: '新北市'
  },
  {
    店號: 186951,
    店名: '美禎',
    地址: '新北市蘆洲區復興路322號',
    縣市: '新北市'
  },
  {
    店號: 186995,
    店名: '頂埔',
    地址: '新北市土城區中央路四段274號276號1樓',
    縣市: '新北市'
  },
  {
    店號: 187013,
    店名: '艾德蒙',
    地址: '新北市中和區中正路738號1樓',
    縣市: '新北市'
  },
  {
    店號: 187035,
    店名: '竑嘉',
    地址: '新北市三重區仁愛街32號之1',
    縣市: '新北市'
  },
  {
    店號: 187046,
    店名: '泰星',
    地址: '新北市蘆洲區成功里長安街276號',
    縣市: '新北市'
  },
  {
    店號: 187138,
    店名: '太子',
    地址: '新北市土城區中山路47號',
    縣市: '新北市'
  },
  {
    店號: 187297,
    店名: '長揚',
    地址: '新北市三重區三和路二段6號之2',
    縣市: '新北市'
  },
  {
    店號: 187415,
    店名: '愛家',
    地址: '新北市三重區中興北街42巷11號',
    縣市: '新北市'
  },
  {
    店號: 187471,
    店名: '文青',
    地址: '新北市土城區青雲路243號245號',
    縣市: '新北市'
  },
  {
    店號: 187482,
    店名: '北大成',
    地址: '新北市三峽區學成路301號303號1樓',
    縣市: '新北市'
  },
  {
    店號: 187622,
    店名: '北深',
    地址: '新北市深坑區北深路二段183號',
    縣市: '新北市'
  },
  {
    店號: 187688,
    店名: '明峰',
    地址: '新北市汐止區明峰街179之1號',
    縣市: '新北市'
  },
  {
    店號: 187769,
    店名: '景大',
    地址: '新北市新店區安忠路69號1樓71巷1號1樓',
    縣市: '新北市'
  },
  {
    店號: 187839,
    店名: '泳豐',
    地址: '新北市土城區永豐路264之1號',
    縣市: '新北市'
  },
  {
    店號: 187910,
    店名: '福真',
    地址: '新北市中和區景平路679號681號',
    縣市: '新北市'
  },
  {
    店號: 187976,
    店名: '峽光',
    地址: '新北市三峽區光明路62號1樓',
    縣市: '新北市'
  },
  {
    店號: 188016,
    店名: '太順',
    地址: '新北市樹林區太順街49巷2號',
    縣市: '新北市'
  },
  {
    店號: 188175,
    店名: '金中',
    地址: '新北市金山區中山路305號307號',
    縣市: '新北市'
  },
  {
    店號: 188197,
    店名: '仁愛',
    地址: '新北市永和區仁愛路128號130號1樓',
    縣市: '新北市'
  },
  {
    店號: 188212,
    店名: '新學府',
    地址: '新北市土城區學府路一段223號225號1樓',
    縣市: '新北市'
  },
  {
    店號: 188245,
    店名: '興頂',
    地址: '新北市三重區中興北街177號',
    縣市: '新北市'
  },
  {
    店號: 188267,
    店名: '廣麗',
    地址: '新北市中和區廣福路87號89號91號1樓',
    縣市: '新北市'
  },
  {
    店號: 188278,
    店名: '百福',
    地址: '新北市新店區三民路50號52號1樓',
    縣市: '新北市'
  },
  {
    店號: 188371,
    店名: '僑一',
    地址: '新北市板橋區僑中一街104號106號',
    縣市: '新北市'
  },
  {
    店號: 188407,
    店名: '德玉',
    地址: '新北市新店區安康路三段195號',
    縣市: '新北市'
  },
  {
    店號: 188522,
    店名: '正林',
    地址: '新北市林口區中正路201號1樓',
    縣市: '新北市'
  },
  {
    店號: 188706,
    店名: '中行',
    地址: '新北市新店區中興路一段193號195號',
    縣市: '新北市'
  },
  {
    店號: 188728,
    店名: '新林口',
    地址: '新北市林口區中正路90號92號1樓',
    縣市: '新北市'
  },
  {
    店號: 188751,
    店名: '新化成',
    地址: '新北市新莊區化成路213號1樓',
    縣市: '新北市'
  },
  {
    店號: 188946,
    店名: '十八甲',
    地址: '新北市泰山區福興一街87號',
    縣市: '新北市'
  },
  {
    店號: 189086,
    店名: '景鑫',
    地址: '新北市中和區中正路683號',
    縣市: '新北市'
  },
  {
    店號: 189123,
    店名: '天台',
    地址: '新北市三重區仁德里正義南路13號15號1樓',
    縣市: '新北市'
  },
  {
    店號: 189189,
    店名: '三洋',
    地址: '新北市新莊區中正路677號679號',
    縣市: '新北市'
  },
  {
    店號: 189330,
    店名: '志城',
    地址: '新北市土城區金城路三段243號245號247號1樓',
    縣市: '新北市'
  },
  {
    店號: 189352,
    店名: '環德',
    地址: '新北市三重區福德南路38號1樓',
    縣市: '新北市'
  },
  {
    店號: 189466,
    店名: '立福',
    地址: '新北市三重區力行路一段60之1號60之2號1樓',
    縣市: '新北市'
  },
  {
    店號: 189499,
    店名: '幸運',
    地址: '新北市板橋區區運路21號',
    縣市: '新北市'
  },
  {
    店號: 189503,
    店名: '羚陽',
    地址: '新北市泰山區泰林路二段302號304號',
    縣市: '新北市'
  },
  {
    店號: 189765,
    店名: '永平',
    地址: '新北市永和區中山路一段149至153號',
    縣市: '新北市'
  },
  {
    店號: 189787,
    店名: '新中',
    地址: '新北市新店區中正路160號1樓',
    縣市: '新北市'
  },
  {
    店號: 189857,
    店名: '水鑫',
    地址: '新北市淡水區大忠街83號',
    縣市: '新北市'
  },
  {
    店號: 189868,
    店名: '得和',
    地址: '新北市永和區得和路113號1樓',
    縣市: '新北市'
  },
  {
    店號: 189905,
    店名: '正民',
    地址: '新北市新店區中正路508號1樓',
    縣市: '新北市'
  },
  {
    店號: 190008,
    店名: '淡水',
    地址: '新北市淡水區中正東路3號',
    縣市: '新北市'
  },
  {
    店號: 190190,
    店名: '新陽',
    地址: '新北市三重區三陽路62號64號',
    縣市: '新北市'
  },
  {
    店號: 190499,
    店名: '源德',
    地址: '新北市淡水區水源街一段75-2號1樓',
    縣市: '新北市'
  },
  {
    店號: 190558,
    店名: '和捷',
    地址: '新北市中和區和平街84號86號88號1樓',
    縣市: '新北市'
  },
  {
    店號: 190651,
    店名: '富新',
    地址: '新北市新莊區瓊林南路118-5號',
    縣市: '新北市'
  },
  {
    店號: 190662,
    店名: '汐旺',
    地址: '新北市汐止區中興里6鄰中興路105號',
    縣市: '新北市'
  },
  {
    店號: 190846,
    店名: '榮信',
    地址: '新北市新莊區中原里中榮街25鄰90號92號1樓',
    縣市: '新北市'
  },
  {
    店號: 192602,
    店名: '九州',
    地址: '新北市新莊區五工二路60號62巷1號',
    縣市: '新北市'
  },
  {
    店號: 192624,
    店名: '浮洲',
    地址: '新北市板橋區大觀路一段38巷22號1樓',
    縣市: '新北市'
  },
  {
    店號: 193018,
    店名: '川金',
    地址: '新北市淡水區淡金路一段567號569號571號1樓',
    縣市: '新北市'
  },
  {
    店號: 193203,
    店名: '集成',
    地址: '新北市三重區環河南路254巷43之1,43之2號',
    縣市: '新北市'
  },
  {
    店號: 193339,
    店名: '福興',
    地址: '新北市泰山區全興路165號',
    縣市: '新北市'
  },
  {
    店號: 193742,
    店名: '永騰',
    地址: '新北市永和區信義路7號1樓',
    縣市: '新北市'
  },
  {
    店號: 194000,
    店名: '君品',
    地址: '新北市淡水區北新路141巷56.58號1樓',
    縣市: '新北市'
  },
  {
    店號: 194011,
    店名: '日昇',
    地址: '新北市中和區中和路326號1樓',
    縣市: '新北市'
  },
  {
    店號: 194044,
    店名: '和億',
    地址: '新北市淡水區濱海路一段306巷60弄35.41號1樓',
    縣市: '新北市'
  },
  {
    店號: 194217,
    店名: '莊捷',
    地址: '新北市新莊區中華路一段37號37之1號39號39之1號1樓',
    縣市: '新北市'
  },
  {
    店號: 194402,
    店名: '員和',
    地址: '新北市中和區員山路118號120號1樓',
    縣市: '新北市'
  },
  {
    店號: 194435,
    店名: '德厚',
    地址: '新北市汐止區福德二路189號1樓',
    縣市: '新北市'
  },
  {
    店號: 194480,
    店名: '都峰苑',
    地址: '新北市新莊區中央路686號1樓',
    縣市: '新北市'
  },
  {
    店號: 194505,
    店名: '美福',
    地址: '新北市新莊區頭興街186號188號',
    縣市: '新北市'
  },
  {
    店號: 194594,
    店名: '加百列',
    地址: '新北市鶯歌區中正一路131號133號1樓',
    縣市: '新北市'
  },
  {
    店號: 194734,
    店名: '頂孝',
    地址: '新北市土城區中央路四段50-3.50-5號1樓',
    縣市: '新北市'
  },
  {
    店號: 194930,
    店名: '茄安',
    地址: '新北市汐止區茄苳路259號1樓',
    縣市: '新北市'
  },
  {
    店號: 195058,
    店名: '金澳底',
    地址: '新北市貢寮區仁和路218號1樓',
    縣市: '新北市'
  },
  {
    店號: 195151,
    店名: '義北',
    地址: '新北市三重區正義北路8號1樓',
    縣市: '新北市'
  },
  {
    店號: 195173,
    店名: '成曜',
    地址: '新北市五股區凌雲路一段87號89號91號1樓',
    縣市: '新北市'
  },
  {
    店號: 195302,
    店名: '大立',
    地址: '新北市三重區力行路一段184號186號1樓',
    縣市: '新北市'
  },
  {
    店號: 195449,
    店名: '華晟',
    地址: '新北市三峽區中華路38之1號38之2號1樓',
    縣市: '新北市'
  },
  {
    店號: 195564,
    店名: '新安和',
    地址: '新北市新店區安和路二段89號91號',
    縣市: '新北市'
  },
  {
    店號: 195601,
    店名: '大合宜',
    地址: '新北市板橋區合宜路151號1樓',
    縣市: '新北市'
  },
  {
    店號: 195645,
    店名: '城庚',
    地址: '新北市土城區金城路二段6號B1',
    縣市: '新北市'
  },
  {
    店號: 195689,
    店名: '禮萊',
    地址: '新北市淡水區中正路一段2號1樓',
    縣市: '新北市'
  },
  {
    店號: 195715,
    店名: '華貴',
    地址: '新北市板橋區貴興路85號87號1樓',
    縣市: '新北市'
  },
  {
    店號: 195852,
    店名: '保長坑',
    地址: '新北市汐止區大同路三段261號263號1樓',
    縣市: '新北市'
  },
  {
    店號: 195885,
    店名: '北霆',
    地址: '新北市三峽區大同路244號1樓',
    縣市: '新北市'
  },
  {
    店號: 195896,
    店名: '安博',
    地址: '新北市新店區安民街154號154-1號1樓',
    縣市: '新北市'
  },
  {
    店號: 195922,
    店名: '三田',
    地址: '新北市三重區福田里三民街274號276號1樓',
    縣市: '新北市'
  },
  {
    店號: 195977,
    店名: '育軒',
    地址: '新北市板橋區漢生東路268號270號1樓',
    縣市: '新北市'
  },
  {
    店號: 196051,
    店名: '武聖廟',
    地址: '新北市新莊區新莊路437號1樓',
    縣市: '新北市'
  },
  {
    店號: 196305,
    店名: '安峰',
    地址: '新北市新店區安康路二段350之3號',
    縣市: '新北市'
  },
  {
    店號: 196327,
    店名: '涵碧',
    地址: '新北市新店區永業路6號6之1號8號',
    縣市: '新北市'
  },
  {
    店號: 196420,
    店名: '新生',
    地址: '新北市中和區新生街243號245號1樓',
    縣市: '新北市'
  },
  {
    店號: 196648,
    店名: '登揚',
    地址: '新北市五股區登林路96號',
    縣市: '新北市'
  },
  {
    店號: 196877,
    店名: '央福',
    地址: '新北市新莊區中央路128號130號',
    縣市: '新北市'
  },
  {
    店號: 196981,
    店名: 'ES2',
    地址: '新北市樹林區佳園路二段70號-1號',
    縣市: '新北市'
  },
  {
    店號: 197102,
    店名: '金峰',
    地址: '新北市土城區明峰街9號11號',
    縣市: '新北市'
  },
  {
    店號: 197180,
    店名: '真親切',
    地址: '新北市新店區中央路212號214號',
    縣市: '新北市'
  },
  {
    店號: 197249,
    店名: '合安',
    地址: '新北市板橋區合宜路111號1樓',
    縣市: '新北市'
  },
  {
    店號: 197386,
    店名: '麗寶',
    地址: '新北市林口區文化北路一段301號1樓',
    縣市: '新北市'
  },
  {
    店號: 197401,
    店名: '義學',
    地址: '新北市泰山區明志路二段74號76號',
    縣市: '新北市'
  },
  {
    店號: 197434,
    店名: '安德',
    地址: '新北市新店區安德街8號10號12號1樓',
    縣市: '新北市'
  },
  {
    店號: 197490,
    店名: '興都',
    地址: '新北市林口區文化二路一段378號1樓之一之二之三',
    縣市: '新北市'
  },
  {
    店號: 197504,
    店名: '六張街',
    地址: '新北市三重區六張街255巷17弄1號1樓255巷15號',
    縣市: '新北市'
  },
  {
    店號: 197630,
    店名: '福德三',
    地址: '新北市新莊區福德三街70號72號1樓',
    縣市: '新北市'
  },
  {
    店號: 197788,
    店名: '全新',
    地址: '新北市新店區安康路二段147號1樓',
    縣市: '新北市'
  },
  {
    店號: 197836,
    店名: '安坑',
    地址: '新北市新店區安民街346號348號1樓',
    縣市: '新北市'
  },
  {
    店號: 198127,
    店名: '雙鑫',
    地址: '新北市新店區北新路二段169號',
    縣市: '新北市'
  },
  {
    店號: 198149,
    店名: '板信',
    地址: '新北市板橋區信義路142號144號146號1樓',
    縣市: '新北市'
  },
  {
    店號: 198208,
    店名: '瑞慈',
    地址: '新北市瑞芳區三爪子坑路64之39號64之40號1樓',
    縣市: '新北市'
  },
  {
    店號: 198334,
    店名: '芯建',
    地址: '新北市中和區建一路182號1樓',
    縣市: '新北市'
  },
  {
    店號: 198367,
    店名: '柳豐',
    地址: '新北市萬里區港東路162之11號162之12號',
    縣市: '新北市'
  },
  {
    店號: 198404,
    店名: '府中讚',
    地址: '新北市板橋區府中路41號1樓',
    縣市: '新北市'
  },
  {
    店號: 198585,
    店名: '金芝',
    地址: '新北市三芝區中興街一段2號6號1樓',
    縣市: '新北市'
  },
  {
    店號: 198596,
    店名: '武江',
    地址: '新北市板橋區光武街2巷2號',
    縣市: '新北市'
  },
  {
    店號: 198666,
    店名: '城政',
    地址: '新北市土城區中正路69號1樓',
    縣市: '新北市'
  },
  {
    店號: 198839,
    店名: '成泰',
    地址: '新北市五股區成泰路二段84號1樓',
    縣市: '新北市'
  },
  {
    店號: 198873,
    店名: '淺水灣',
    地址: '新北市三芝區中柳村北勢子42之11號1樓',
    縣市: '新北市'
  },
  {
    店號: 198884,
    店名: '連城',
    地址: '新北市中和區連城路89巷3之1號5之1號1樓',
    縣市: '新北市'
  },
  {
    店號: 198910,
    店名: '新海',
    地址: '新北市板橋區文德里新海路138號',
    縣市: '新北市'
  },
  {
    店號: 198954,
    店名: '重樂',
    地址: '新北市三重區三信路196號1樓',
    縣市: '新北市'
  },
  {
    店號: 199038,
    店名: '汐福',
    地址: '新北市汐止區福德一路243號',
    縣市: '新北市'
  },
  {
    店號: 199061,
    店名: '蘆讚',
    地址: '新北市蘆洲區中山二路184號',
    縣市: '新北市'
  },
  {
    店號: 199072,
    店名: '龍興',
    地址: '新北市樹林區三興里龍興街33號',
    縣市: '新北市'
  },
  {
    店號: 199418,
    店名: '美雅仕',
    地址: '新北市林口區文化二路一段262號1樓',
    縣市: '新北市'
  },
  {
    店號: 199463,
    店名: '馥竹',
    地址: '新北市淡水區民權路187巷19號1樓',
    縣市: '新北市'
  },
  {
    店號: 199474,
    店名: '江翠',
    地址: '新北市板橋區文化路二段417巷8號1樓10號1樓2樓',
    縣市: '新北市'
  },
  {
    店號: 199485,
    店名: '正果',
    地址: '新北市三重區中正北路122號124號1樓',
    縣市: '新北市'
  },
  {
    店號: 199496,
    店名: '慶斌',
    地址: '新北市樹林區中洲街51巷1號',
    縣市: '新北市'
  },
  {
    店號: 199614,
    店名: '樹龍',
    地址: '新北市樹林區中正路222號1樓',
    縣市: '新北市'
  },
  {
    店號: 199821,
    店名: '寶科',
    地址: '新北市新店區寶橋路235巷5號1樓',
    縣市: '新北市'
  },
  {
    店號: 199832,
    店名: '美吉',
    地址: '新北市三重區集美街223號225號',
    縣市: '新北市'
  },
  {
    店號: 199854,
    店名: '三角湧',
    地址: '新北市三峽區中正路二段200號',
    縣市: '新北市'
  },
  {
    店號: 199946,
    店名: '光環',
    地址: '新北市板橋區光環路二段68號70號1樓',
    縣市: '新北市'
  },
  {
    店號: 200457,
    店名: '民華',
    地址: '新北市中和區民德路270號272號',
    縣市: '新北市'
  },
  {
    店號: 200642,
    店名: '季欣',
    地址: '新北市泰山區全興路109號',
    縣市: '新北市'
  },
  {
    店號: 200697,
    店名: '嘉新',
    地址: '新北市中和區員山路419號421號1樓',
    縣市: '新北市'
  },
  {
    店號: 200837,
    店名: '德偉',
    地址: '新北市中和區中興街162號164號',
    縣市: '新北市'
  },
  {
    店號: 200859,
    店名: '樂華',
    地址: '新北市永和區永和路一段143之1號145號1至2樓',
    縣市: '新北市'
  },
  {
    店號: 201025,
    店名: '興園',
    地址: '新北市三重區重陽路一段132號134號1樓',
    縣市: '新北市'
  },
  {
    店號: 201379,
    店名: '埔西',
    地址: '新北市板橋區文化路一段419之5號1樓',
    縣市: '新北市'
  },
  {
    店號: 201520,
    店名: '藍山',
    地址: '新北市中和區南山路41號43號1樓及南山路37巷2號1樓',
    縣市: '新北市'
  },
  {
    店號: 201553,
    店名: '富朋',
    地址: '新北市永和區永和路二段116號',
    縣市: '新北市'
  },
  {
    店號: 201623,
    店名: '蘆安',
    地址: '新北市蘆洲區長安街64號1樓',
    縣市: '新北市'
  },
  {
    店號: 201667,
    店名: '坤耀',
    地址: '新北市板橋區南門街39號1F',
    縣市: '新北市'
  },
  {
    店號: 201863,
    店名: '思源',
    地址: '新北市新莊區幸福路40號42號',
    縣市: '新北市'
  },
  {
    店號: 202028,
    店名: '鑫左岸',
    地址: '新北市中和區中原街120號122號1樓',
    縣市: '新北市'
  },
  {
    店號: 202039,
    店名: '田豐',
    地址: '新北市三重區三民街150.152號',
    縣市: '新北市'
  },
  {
    店號: 202084,
    店名: '捷仕堡',
    地址: '新北市新莊區龍安路15號.龍安路69巷1號',
    縣市: '新北市'
  },
  {
    店號: 202442,
    店名: '興洲',
    地址: '新北市新莊區新泰路472號1樓',
    縣市: '新北市'
  },
  {
    店號: 206569,
    店名: '信義路',
    地址: '新北市蘆洲區信義路341號341之1號341之2號341之3號1樓',
    縣市: '新北市'
  },
  {
    店號: 206640,
    店名: '華峰',
    地址: '新北市林口區文化三路一段617巷51號',
    縣市: '新北市'
  },
  {
    店號: 206824,
    店名: '楓江',
    地址: '新北市泰山區楓江路39之1號39之2號1樓',
    縣市: '新北市'
  },
  {
    店號: 206938,
    店名: '橫科',
    地址: '新北市汐止區民權街二段28號1樓',
    縣市: '新北市'
  },
  {
    店號: 207104,
    店名: '金鶯鎮',
    地址: '新北市鶯歌區尖山路217之3號1樓',
    縣市: '新北市'
  },
  {
    店號: 207126,
    店名: '聖德',
    地址: '新北市土城區明德路二段207號1樓',
    縣市: '新北市'
  },
  {
    店號: 207160,
    店名: '楓華',
    地址: '新北市新店區中華路20號1樓',
    縣市: '新北市'
  },
  {
    店號: 207399,
    店名: '旺泰',
    地址: '新北市新莊區榮華路二段105號1樓.中信街151號1樓',
    縣市: '新北市'
  },
  {
    店號: 207403,
    店名: '延福',
    地址: '新北市土城區延平街36號1樓',
    縣市: '新北市'
  },
  {
    店號: 207735,
    店名: '板安',
    地址: '新北市板橋區長安街202.204號',
    縣市: '新北市'
  },
  {
    店號: 207746,
    店名: '浩瀚',
    地址: '新北市八里區龍形二街2-11號',
    縣市: '新北市'
  },
  {
    店號: 207768,
    店名: '美圳',
    地址: '新北市三重區過圳街14.16號1樓',
    縣市: '新北市'
  },
  {
    店號: 207919,
    店名: '吉翠',
    地址: '新北市板橋區裕民街53號1.2樓和55號',
    縣市: '新北市'
  },
  {
    店號: 207975,
    店名: '源福',
    地址: '新北市新莊區福壽街29.31號',
    縣市: '新北市'
  },
  {
    店號: 208026,
    店名: '伍泉',
    地址: '新北市三重區五華街52.54號1樓',
    縣市: '新北市'
  },
  {
    店號: 208266,
    店名: '民裕',
    地址: '新北市新莊區裕民街102.104號',
    縣市: '新北市'
  },
  {
    店號: 208440,
    店名: '佳翰',
    地址: '新北市板橋區中山路二段170號',
    縣市: '新北市'
  },
  {
    店號: 208473,
    店名: '義強',
    地址: '新北市三重區正義北路131.133號',
    縣市: '新北市'
  },
  {
    店號: 208705,
    店名: '南勢埔',
    地址: '新北市林口區忠福路169號',
    縣市: '新北市'
  },
  {
    店號: 208901,
    店名: '鶯湖',
    地址: '新北市鶯歌區大湖路374號',
    縣市: '新北市'
  },
  {
    店號: 208912,
    店名: '鳳鳴',
    地址: '新北市鶯歌區永和街115巷44.46號1樓',
    縣市: '新北市'
  },
  {
    店號: 209074,
    店名: '華川',
    地址: '新北市板橋區四川路二段245巷11.13號1樓',
    縣市: '新北市'
  },
  {
    店號: 209155,
    店名: '景陽',
    地址: '新北市中和區景新街29號31號33號',
    縣市: '新北市'
  },
  {
    店號: 209362,
    店名: '福同',
    地址: '新北市汐止區福德一路178號',
    縣市: '新北市'
  },
  {
    店號: 209524,
    店名: '華欣',
    地址: '新北市中和區華新街109巷1之2號1樓',
    縣市: '新北市'
  },
  {
    店號: 209616,
    店名: '利吉',
    地址: '新北市土城區延吉街261號',
    縣市: '新北市'
  },
  {
    店號: 209627,
    店名: '海廷',
    地址: '新北市土城區裕民路92巷22弄2號1樓',
    縣市: '新北市'
  },
  {
    店號: 209649,
    店名: '榮曜',
    地址: '新北市林口區文化三路二段156.158號',
    縣市: '新北市'
  },
  {
    店號: 209708,
    店名: '權強',
    地址: '新北市新店區民權路68號',
    縣市: '新北市'
  },
  {
    店號: 209812,
    店名: '富信',
    地址: '新北市新莊區自信街46.48號1樓',
    縣市: '新北市'
  },
  {
    店號: 209993,
    店名: '懷治',
    地址: '新北市板橋區民治街52巷1號.3號',
    縣市: '新北市'
  },
  {
    店號: 210018,
    店名: '金強',
    地址: '新北市三重區忠孝路一段181.183號',
    縣市: '新北市'
  },
  {
    店號: 210188,
    店名: '陽州',
    地址: '新北市蘆洲區重陽街92.96號1樓',
    縣市: '新北市'
  },
  {
    店號: 210199,
    店名: '江北',
    地址: '新北市汐止區長江街97號',
    縣市: '新北市'
  },
  {
    店號: 210281,
    店名: '城利',
    地址: '新北市土城區中央路二段223-13.223-15號',
    縣市: '新北市'
  },
  {
    店號: 210557,
    店名: '俊林',
    地址: '新北市樹林區三俊街216號',
    縣市: '新北市'
  },
  {
    店號: 210616,
    店名: '宜家',
    地址: '新北市新莊區化成路9-2.9-3號',
    縣市: '新北市'
  },
  {
    店號: 210649,
    店名: '捷南',
    地址: '新北市中和區捷運路69號71號1樓',
    縣市: '新北市'
  },
  {
    店號: 210742,
    店名: '新翡翠',
    地址: '新北市萬里區龜吼里美崙90號',
    縣市: '新北市'
  },
  {
    店號: 210775,
    店名: '菜寮站',
    地址: '新北市三重區重新路三段98號1+2樓.100號1樓',
    縣市: '新北市'
  },
  {
    店號: 210915,
    店名: '仁盛',
    地址: '新北市三重區仁興街39巷14之6.14之7.14之8號',
    縣市: '新北市'
  },
  {
    店號: 211044,
    店名: '保元',
    地址: '新北市新莊區中正路72號',
    縣市: '新北市'
  },
  {
    店號: 211147,
    店名: '百建',
    地址: '新北市新店區民族路239號241號1樓',
    縣市: '新北市'
  },
  {
    店號: 211169,
    店名: '園和',
    地址: '新北市永和區仁愛路267號269號',
    縣市: '新北市'
  },
  {
    店號: 211181,
    店名: '利穗',
    地址: '新北市中和區民利街38號1樓',
    縣市: '新北市'
  },
  {
    店號: 211262,
    店名: '樂林',
    地址: '新北市三重區永安北路二段15號',
    縣市: '新北市'
  },
  {
    店號: 211354,
    店名: '央和',
    地址: '新北市土城區中央路一段307.309號1樓',
    縣市: '新北市'
  },
  {
    店號: 211413,
    店名: '丁煌',
    地址: '新北市板橋區文化路二段227號、229號1樓',
    縣市: '新北市'
  },
  {
    店號: 211594,
    店名: '石錠',
    地址: '新北市石碇區碇坪路一段50之1號50之2號',
    縣市: '新北市'
  },
  {
    店號: 211608,
    店名: '正翔',
    地址: '新北市林口區中正路285.287號',
    縣市: '新北市'
  },
  {
    店號: 211723,
    店名: '龍莊',
    地址: '新北市新莊區中正路893巷38號',
    縣市: '新北市'
  },
  {
    店號: 211756,
    店名: '佳政',
    地址: '新北市樹林區中山路三段209-1號211號1樓',
    縣市: '新北市'
  },
  {
    店號: 211929,
    店名: '青新',
    地址: '新北市新店區中山路137號1樓',
    縣市: '新北市'
  },
  {
    店號: 211952,
    店名: '漢生東',
    地址: '新北市板橋區漢生東路45號1樓',
    縣市: '新北市'
  },
  {
    店號: 212036,
    店名: '丞展',
    地址: '新北市瑞芳區瑞濱路32之8號1樓',
    縣市: '新北市'
  },
  {
    店號: 212173,
    店名: '公崙',
    地址: '新北市新店區安民街13號安民街3巷6弄12號',
    縣市: '新北市'
  },
  {
    店號: 212243,
    店名: '大心',
    地址: '新北市三重區大同北路148巷2-1號1.2樓和2-2號',
    縣市: '新北市'
  },
  {
    店號: 212357,
    店名: '富佑',
    地址: '新北市五股區五工路112號1樓',
    縣市: '新北市'
  },
  {
    店號: 212438,
    店名: '鑫鋒',
    地址: '新北市新店區北新路一段90號1樓',
    縣市: '新北市'
  },
  {
    店號: 212461,
    店名: '銀河',
    地址: '新北市新店區北宜路二段269號271號',
    縣市: '新北市'
  },
  {
    店號: 212508,
    店名: '華富',
    地址: '新北市板橋區華江一路501號1.2樓.503號1.2樓',
    縣市: '新北市'
  },
  {
    店號: 212520,
    店名: '鴻運',
    地址: '新北市五股區水碓一路1號',
    縣市: '新北市'
  },
  {
    店號: 213659,
    店名: '福濱',
    地址: '新北市三重區龍濱路51號53號1樓',
    縣市: '新北市'
  },
  {
    店號: 213660,
    店名: '福泉',
    地址: '新北市中和區福祥路68號70號',
    縣市: '新北市'
  },
  {
    店號: 214065,
    店名: '新保捷',
    地址: '新北市永和區保生路22巷2號1樓',
    縣市: '新北市'
  },
  {
    店號: 214087,
    店名: '福基',
    地址: '新北市新莊區福基里五工路70號',
    縣市: '新北市'
  },
  {
    店號: 214113,
    店名: '新旭勝',
    地址: '新北市汐止區建成路160巷2號',
    縣市: '新北市'
  },
  {
    店號: 214135,
    店名: '學勤',
    地址: '新北市三峽區學勤路105號及大德路211號1樓',
    縣市: '新北市'
  },
  {
    店號: 214180,
    店名: '承天',
    地址: '新北市土城區承天路1號',
    縣市: '新北市'
  },
  {
    店號: 214456,
    店名: '先嗇宮',
    地址: '新北市三重區光復路一段25號27號1樓',
    縣市: '新北市'
  },
  {
    店號: 214478,
    店名: '萬里',
    地址: '新北市萬里區瑪鋉路49號51號',
    縣市: '新北市'
  },
  {
    店號: 214504,
    店名: '立竹',
    地址: '新北市淡水區民族路58號1樓2樓',
    縣市: '新北市'
  },
  {
    店號: 214548,
    店名: '貴鳳',
    地址: '新北市泰山區貴鳳街2號',
    縣市: '新北市'
  },
  {
    店號: 214641,
    店名: '新天際',
    地址: '新北市蘆洲區三民路575號',
    縣市: '新北市'
  },
  {
    店號: 214711,
    店名: '新滬站',
    地址: '新北市淡水區中正路1號',
    縣市: '新北市'
  },
  {
    店號: 214814,
    店名: '愛琴灣',
    地址: '新北市淡水區濱海路一段430號432號',
    縣市: '新北市'
  },
  {
    店號: 215068,
    店名: '仁泰',
    地址: '新北市泰山區明志路二段1號',
    縣市: '新北市'
  },
  {
    店號: 215079,
    店名: '傑元',
    地址: '新北市新莊區中正路929巷11號13號',
    縣市: '新北市'
  },
  {
    店號: 215080,
    店名: '湯旺',
    地址: '新北市三重區重新路五段609巷2之3號1樓',
    縣市: '新北市'
  },
  {
    店號: 215172,
    店名: '新汐農',
    地址: '新北市汐止區樟樹一路113號115號',
    縣市: '新北市'
  },
  {
    店號: 215208,
    店名: '建康',
    地址: '新北市中和區建康路270號',
    縣市: '新北市'
  },
  {
    店號: 215345,
    店名: '三重一',
    地址: '新北市三重區正義南路133號135號',
    縣市: '新北市'
  },
  {
    店號: 215437,
    店名: '重富',
    地址: '新北市三重區溪尾街321號323號1樓',
    縣市: '新北市'
  },
  {
    店號: 215448,
    店名: '佳辰',
    地址: '新北市樹林區佳園路三段488號',
    縣市: '新北市'
  },
  {
    店號: 215459,
    店名: '集德',
    地址: '新北市蘆洲區集賢路228號1樓',
    縣市: '新北市'
  },
  {
    店號: 215460,
    店名: '原億',
    地址: '新北市三重區仁和街95號97號1樓',
    縣市: '新北市'
  },
  {
    店號: 215482,
    店名: '景圓',
    地址: '新北市中和區圓通路162-1號162-2號1樓',
    縣市: '新北市'
  },
  {
    店號: 215541,
    店名: '復美',
    地址: '新北市永和區秀朗路一段146號',
    縣市: '新北市'
  },
  {
    店號: 215574,
    店名: '和建',
    地址: '新北市中和區建一路16號1樓',
    縣市: '新北市'
  },
  {
    店號: 215585,
    店名: '長坤',
    地址: '新北市林口區文化一路一段43號1樓',
    縣市: '新北市'
  },
  {
    店號: 215611,
    店名: '實萬',
    地址: '新北市汐止區汐萬路二段248號1樓',
    縣市: '新北市'
  },
  {
    店號: 215622,
    店名: '蘆正',
    地址: '新北市蘆洲區中正路261號',
    縣市: '新北市'
  },
  {
    店號: 215633,
    店名: '金福',
    地址: '新北市板橋區金門街330號1樓',
    縣市: '新北市'
  },
  {
    店號: 215644,
    店名: '福港',
    地址: '新北市新莊區中港路390號',
    縣市: '新北市'
  },
  {
    店號: 215699,
    店名: '大展',
    地址: '新北市樹林區俊英街232號234號1樓',
    縣市: '新北市'
  },
  {
    店號: 215703,
    店名: '懷民',
    地址: '新北市板橋區民治街111號',
    縣市: '新北市'
  },
  {
    店號: 215725,
    店名: '板民',
    地址: '新北市板橋區三民路二段77號1樓',
    縣市: '新北市'
  },
  {
    店號: 215769,
    店名: '歌亭',
    地址: '新北市鶯歌區尖山里尖山路150號',
    縣市: '新北市'
  },
  {
    店號: 215817,
    店名: '大盛',
    地址: '新北市新店區建國路167號169號1樓',
    縣市: '新北市'
  },
  {
    店號: 215862,
    店名: '立飛',
    地址: '新北市淡水區民生路126號128號1樓2樓',
    縣市: '新北市'
  },
  {
    店號: 215895,
    店名: '祥泰',
    地址: '新北市土城區中山路38號',
    縣市: '新北市'
  },
  {
    店號: 215976,
    店名: '明貴',
    地址: '新北市泰山區明志路三段44號46號1樓',
    縣市: '新北市'
  },
  {
    店號: 215998,
    店名: '新錦秀',
    地址: '新北市新店區錦秀路13號15號1樓',
    縣市: '新北市'
  },
  {
    店號: 216061,
    店名: '憲金',
    地址: '新北市蘆洲區光華路22巷1號',
    縣市: '新北市'
  },
  {
    店號: 216153,
    店名: '正華',
    地址: '新北市板橋區中正路274號276號',
    縣市: '新北市'
  },
  {
    店號: 216186,
    店名: '添丁',
    地址: '新北市永和區永貞路365號367號1樓',
    縣市: '新北市'
  },
  {
    店號: 216289,
    店名: '富安',
    地址: '新北市新莊區萬安街18-1號12-1號',
    縣市: '新北市'
  },
  {
    店號: 216304,
    店名: '大庭',
    地址: '新北市板橋區國光里6鄰國光路65號1樓',
    縣市: '新北市'
  },
  {
    店號: 216348,
    店名: '龍盛',
    地址: '新北市新莊區西盛街204巷1號1樓206號1樓',
    縣市: '新北市'
  },
  {
    店號: 216359,
    店名: '前進',
    地址: '新北市蘆洲區中正路185巷50號52號1樓',
    縣市: '新北市'
  },
  {
    店號: 216371,
    店名: '統和',
    地址: '新北市新店區安和里安民街335號337號',
    縣市: '新北市'
  },
  {
    店號: 216393,
    店名: '橋和',
    地址: '新北市中和區橋和路99號1樓',
    縣市: '新北市'
  },
  {
    店號: 216496,
    店名: '博林',
    地址: '新北市樹林區博愛街123號1樓',
    縣市: '新北市'
  },
  {
    店號: 216670,
    店名: '新義民',
    地址: '新北市蘆洲區民族路122號124號',
    縣市: '新北市'
  },
  {
    店號: 216681,
    店名: '鯊魚',
    地址: '新北市淡水區沙崙路196號',
    縣市: '新北市'
  },
  {
    店號: 216706,
    店名: '板耀',
    地址: '新北市板橋區自由路52號54號1樓',
    縣市: '新北市'
  },
  {
    店號: 216739,
    店名: '福和',
    地址: '新北市中和區秀明里大勇街25巷1號1樓',
    縣市: '新北市'
  },
  {
    店號: 216821,
    店名: '永華',
    地址: '新北市中和區南山路127巷18弄42號1樓',
    縣市: '新北市'
  },
  {
    店號: 216924,
    店名: '青潭',
    地址: '新北市新店區北宜路一段41-1號',
    縣市: '新北市'
  },
  {
    店號: 217190,
    店名: '盛發',
    地址: '新北市蘆洲區光復路10號',
    縣市: '新北市'
  },
  {
    店號: 217204,
    店名: '懷翠',
    地址: '新北市板橋區懷德街203號205號1樓',
    縣市: '新北市'
  },
  {
    店號: 217215,
    店名: '副都心',
    地址: '新北市新莊區中央路287號289號1樓',
    縣市: '新北市'
  },
  {
    店號: 217237,
    店名: '冠冠',
    地址: '新北市新店區北新路一段231號1樓新生街1號1樓',
    縣市: '新北市'
  },
  {
    店號: 217259,
    店名: '高峰',
    地址: '新北市土城區中央路二段187號',
    縣市: '新北市'
  },
  {
    店號: 217260,
    店名: '興觀',
    地址: '新北市板橋區大觀路二段37巷34號36號1樓',
    縣市: '新北市'
  },
  {
    店號: 217307,
    店名: '日勝',
    地址: '新北市泰山區山腳里泰林路二段515號517號',
    縣市: '新北市'
  },
  {
    店號: 217433,
    店名: '富得',
    地址: '新北市五股區五權路48號1樓',
    縣市: '新北市'
  },
  {
    店號: 217488,
    店名: '杰朋',
    地址: '新北市板橋區新海路385巷10弄11號',
    縣市: '新北市'
  },
  {
    店號: 228020,
    店名: '中和',
    地址: '新北市中和區橋和路9號1樓',
    縣市: '新北市'
  },
  {
    店號: 228112,
    店名: '墩璞',
    地址: '新北市板橋區中正路106號1樓',
    縣市: '新北市'
  },
  {
    店號: 228226,
    店名: '寶興',
    地址: '新北市新店區寶橋路88號1樓',
    縣市: '新北市'
  },
  {
    店號: 228259,
    店名: '板中',
    地址: '新北市板橋區府後街4.4-1.4-2號1樓',
    縣市: '新北市'
  },
  {
    店號: 228260,
    店名: '新府',
    地址: '新北市板橋區新府路75號B2樓',
    縣市: '新北市'
  },
  {
    店號: 228385,
    店名: '太元',
    地址: '新北市樹林區太元街31號33號1樓',
    縣市: '新北市'
  },
  {
    店號: 228422,
    店名: '康城',
    地址: '新北市新店區安康路一段222之1號',
    縣市: '新北市'
  },
  {
    店號: 228514,
    店名: '環河東',
    地址: '新北市永和區環河東路四段22號',
    縣市: '新北市'
  },
  {
    店號: 228558,
    店名: '鑫馬偕',
    地址: '新北市淡水區民權路47號',
    縣市: '新北市'
  },
  {
    店號: 228802,
    店名: '英專',
    地址: '新北市淡水區英專路91號',
    縣市: '新北市'
  },
  {
    店號: 228824,
    店名: '福安',
    地址: '新北市汐止區仁愛路178號180號1樓',
    縣市: '新北市'
  },
  {
    店號: 228927,
    店名: '圓德',
    地址: '新北市中和區圓通路391之3號391之4號391之5號1樓',
    縣市: '新北市'
  },
  {
    店號: 228983,
    店名: '林旺',
    地址: '新北市林口區仁愛路二段196號1樓',
    縣市: '新北市'
  },
  {
    店號: 229322,
    店名: '能仁',
    地址: '新北市新店區光明街38號',
    縣市: '新北市'
  },
  {
    店號: 229388,
    店名: '金滬',
    地址: '新北市淡水區中山路66號1.2樓.66-1號1樓',
    縣市: '新北市'
  },
  {
    店號: 229470,
    店名: '成雲',
    地址: '新北市五股區西雲路200.202號1樓',
    縣市: '新北市'
  },
  {
    店號: 229481,
    店名: '泰順',
    地址: '新北市三重區仁義街180.182號',
    縣市: '新北市'
  },
  {
    店號: 229492,
    店名: '雙福',
    地址: '新北市三重區雙園街57巷2.4號',
    縣市: '新北市'
  },
  {
    店號: 229632,
    店名: '金芳',
    地址: '新北市新店區永安街72號74巷2號1樓',
    縣市: '新北市'
  },
  {
    店號: 229746,
    店名: '永保',
    地址: '新北市永和區保平路197號199號1樓',
    縣市: '新北市'
  },
  {
    店號: 229757,
    店名: '新永愛',
    地址: '新北市永和區永平路314號316號1樓',
    縣市: '新北市'
  },
  {
    店號: 229931,
    店名: '府山',
    地址: '新北市板橋區中山路一段9.11號',
    縣市: '新北市'
  },
  {
    店號: 229964,
    店名: '俊盛',
    地址: '新北市樹林區俊興街156號',
    縣市: '新北市'
  },
  {
    店號: 229997,
    店名: '龍武',
    地址: '新北市鶯歌區龍五路89號',
    縣市: '新北市'
  },
  {
    店號: 230067,
    店名: '玫瑰',
    地址: '新北市新店區玫瑰路58巷4號地下室',
    縣市: '新北市'
  },
  {
    店號: 230126,
    店名: '華順',
    地址: '新北市中和區華安街16巷1號',
    縣市: '新北市'
  },
  {
    店號: 230148,
    店名: '樹東',
    地址: '新北市樹林區東榮街91巷2弄2、4號1樓',
    縣市: '新北市'
  },
  {
    店號: 230160,
    店名: '安溪',
    地址: '新北市三峽區大同路188、190號',
    縣市: '新北市'
  },
  {
    店號: 230182,
    店名: '埔站',
    地址: '新北市板橋區民生路二段237號1樓',
    縣市: '新北市'
  },
  {
    店號: 230285,
    店名: '亞昕',
    地址: '新北市林口區仁愛二路58號及民富街77號',
    縣市: '新北市'
  },
  {
    店號: 230296,
    店名: '勇福',
    地址: '新北市三重區永福街115、117號',
    縣市: '新北市'
  },
  {
    店號: 230506,
    店名: '華利',
    地址: '新北市板橋區華江一路209、211號',
    縣市: '新北市'
  },
  {
    店號: 230562,
    店名: '鑫東冠',
    地址: '新北市汐止區康寧街459巷3號1樓2樓5號1樓',
    縣市: '新北市'
  },
  {
    店號: 230573,
    店名: '蘆義',
    地址: '新北市蘆洲區民義街1.3.5號',
    縣市: '新北市'
  },
  {
    店號: 230610,
    店名: '汐東',
    地址: '新北市汐止區忠孝東路430號432號1樓',
    縣市: '新北市'
  },
  {
    店號: 230643,
    店名: '永美',
    地址: '新北市中和區中山路二段2巷45弄6號8號1樓',
    縣市: '新北市'
  },
  {
    店號: 230676,
    店名: '光明',
    地址: '新北市蘆洲區光明路71號',
    縣市: '新北市'
  },
  {
    店號: 230713,
    店名: '八重',
    地址: '新北市三重區重新路三段115巷18號',
    縣市: '新北市'
  },
  {
    店號: 230724,
    店名: '里春',
    地址: '新北市三重區中正南路125、127號1樓',
    縣市: '新北市'
  },
  {
    店號: 230908,
    店名: '財府',
    地址: '新北市淡水區學府路136巷36號、38號1樓',
    縣市: '新北市'
  },
  {
    店號: 230964,
    店名: '摩天灣',
    地址: '新北市淡水區中山北路一段257號1樓',
    縣市: '新北市'
  },
  {
    店號: 231004,
    店名: '泰福',
    地址: '新北市三重區安和路36、38號',
    縣市: '新北市'
  },
  {
    店號: 231130,
    店名: '旗開',
    地址: '新北市蘆洲區中央路181號1樓及復興路16號1樓',
    縣市: '新北市'
  },
  {
    店號: 231141,
    店名: '莊年',
    地址: '新北市新莊區豐年街55號之8、55之9號',
    縣市: '新北市'
  },
  {
    店號: 231303,
    店名: '全泰',
    地址: '新北市新莊區建中街139.141號1樓',
    縣市: '新北市'
  },
  {
    店號: 231325,
    店名: '揚心',
    地址: '新北市淡水區義山路二段299號',
    縣市: '新北市'
  },
  {
    店號: 231439,
    店名: '貴志',
    地址: '新北市泰山區貴子路13.13-1號1樓',
    縣市: '新北市'
  },
  {
    店號: 231451,
    店名: '渡船頭',
    地址: '新北市淡水區中正路號55號及55-1號',
    縣市: '新北市'
  },
  {
    店號: 231509,
    店名: '樹溪',
    地址: '新北市板橋區溪北路43.45號1樓',
    縣市: '新北市'
  },
  {
    店號: 231598,
    店名: '未央',
    地址: '新北市林口區文化三路二段283.283-1號',
    縣市: '新北市'
  },
  {
    店號: 231691,
    店名: '寶高',
    地址: '新北市新店區寶高路28之1號1樓',
    縣市: '新北市'
  },
  {
    店號: 231749,
    店名: '芝加灣',
    地址: '新北市三芝區錫板里海尾14-35號1樓2樓3樓',
    縣市: '新北市'
  },
  {
    店號: 231956,
    店名: '板宏',
    地址: '新北市板橋區宏國路109.111號',
    縣市: '新北市'
  },
  {
    店號: 231967,
    店名: '樟弘',
    地址: '新北市汐止區樟樹二路279號281號1樓',
    縣市: '新北市'
  },
  {
    店號: 232225,
    店名: '小碧潭',
    地址: '新北市新店區中央路157號1樓',
    縣市: '新北市'
  },
  {
    店號: 232258,
    店名: '富江',
    地址: '新北市板橋區長江路一段110.112號1樓',
    縣市: '新北市'
  },
  {
    店號: 232487,
    店名: '海晴',
    地址: '新北市淡水區濱海路二段202巷69.71號1樓',
    縣市: '新北市'
  },
  {
    店號: 232797,
    店名: '寶隆',
    地址: '新北市新店區寶橋路69號1樓',
    縣市: '新北市'
  },
  {
    店號: 232823,
    店名: '綺華',
    地址: '新北市樹林區復興路369.371號1樓',
    縣市: '新北市'
  },
  {
    店號: 232948,
    店名: '新北市',
    地址: '新北市板橋區中山路一段161號B1樓',
    縣市: '新北市'
  },
  {
    店號: 233217,
    店名: '鑫浦深',
    地址: '新北市深坑區文化街116號118號1樓',
    縣市: '新北市'
  },
  {
    店號: 233240,
    店名: '僑興',
    地址: '新北市板橋區僑中二街116巷2號.4號',
    縣市: '新北市'
  },
  {
    店號: 236733,
    店名: '慶中',
    地址: '新北市板橋區重慶路194號光明街91號1樓',
    縣市: '新北市'
  },
  {
    店號: 236766,
    店名: '大峽',
    地址: '新北市三峽區大學路13鄰147號1樓',
    縣市: '新北市'
  },
  {
    店號: 236777,
    店名: '建國',
    地址: '新北市新店區中正路236號',
    縣市: '新北市'
  },
  {
    店號: 236799,
    店名: '健華',
    地址: '新北市三重區忠孝路二段63號',
    縣市: '新北市'
  },
  {
    店號: 236847,
    店名: '港榮',
    地址: '新北市新莊區中港路597.599號.中榮街2號',
    縣市: '新北市'
  },
  {
    店號: 236917,
    店名: '新福隆',
    地址: '新北市貢寮區福隆里興隆街24之1號',
    縣市: '新北市'
  },
  {
    店號: 237068,
    店名: '新港原',
    地址: '新北市新莊區中原路201號203號1樓',
    縣市: '新北市'
  },
  {
    店號: 237080,
    店名: '文潭',
    地址: '新北市樹林區千歲街61巷44號1.2樓和46號',
    縣市: '新北市'
  },
  {
    店號: 237091,
    店名: '維陽',
    地址: '新北市板橋區陽明街158號160號1樓',
    縣市: '新北市'
  },
  {
    店號: 237105,
    店名: '隆城',
    地址: '新北市土城區學士路15巷2號17號1樓',
    縣市: '新北市'
  },
  {
    店號: 237138,
    店名: '復貴',
    地址: '新北市三重區光復路2段146號1樓',
    縣市: '新北市'
  },
  {
    店號: 237172,
    店名: '平埔',
    地址: '新北市深坑區文化街82號',
    縣市: '新北市'
  },
  {
    店號: 237183,
    店名: '南雅',
    地址: '新北市板橋區新興里南雅南路一段8號1樓',
    縣市: '新北市'
  },
  {
    店號: 237194,
    店名: '昌宏',
    地址: '新北市新莊區昌隆街29、31號1樓',
    縣市: '新北市'
  },
  {
    店號: 237219,
    店名: '紅林站',
    地址: '新北市淡水區中正東路二段65號',
    縣市: '新北市'
  },
  {
    店號: 237253,
    店名: '陡門頭',
    地址: '新北市三重區三民街329號',
    縣市: '新北市'
  },
  {
    店號: 237367,
    店名: '集賢',
    地址: '新北市蘆洲區集賢路271號',
    縣市: '新北市'
  },
  {
    店號: 237378,
    店名: '蘆三',
    地址: '新北市蘆洲區三民路6號8號',
    縣市: '新北市'
  },
  {
    店號: 237471,
    店名: '愛莘',
    地址: '新北市新店區民族路112號B1樓',
    縣市: '新北市'
  },
  {
    店號: 237507,
    店名: '新林',
    地址: '新北市林口區忠孝路128號130號',
    縣市: '新北市'
  },
  {
    店號: 237552,
    店名: '維群',
    地址: '新北市板橋區四維路139號',
    縣市: '新北市'
  },
  {
    店號: 237574,
    店名: '環和',
    地址: '新北市中和區中山路二段269號1樓2樓',
    縣市: '新北市'
  },
  {
    店號: 237611,
    店名: '福壽',
    地址: '新北市新莊區福壽街140號',
    縣市: '新北市'
  },
  {
    店號: 237736,
    店名: '板聖',
    地址: '新北市板橋區文化路二段472號',
    縣市: '新北市'
  },
  {
    店號: 237792,
    店名: '匯和',
    地址: '新北市三重區三和路四段390巷2號',
    縣市: '新北市'
  },
  {
    店號: 237895,
    店名: '鑫庫',
    地址: '新北市深坑區北深路一段118號120號',
    縣市: '新北市'
  },
  {
    店號: 237943,
    店名: '板府',
    地址: '新北市板橋區中山路一段158巷4號6號1樓',
    縣市: '新北市'
  },
  {
    店號: 237954,
    店名: '得福',
    地址: '新北市永和區得和路241號',
    縣市: '新北市'
  },
  {
    店號: 238072,
    店名: '復和',
    地址: '新北市新莊區復興路一段79號81號1樓',
    縣市: '新北市'
  },
  {
    店號: 238083,
    店名: '華鎮',
    地址: '新北市樹林區中華路381號1樓2樓',
    縣市: '新北市'
  },
  {
    店號: 238094,
    店名: '正龍',
    地址: '新北市三重區正義北路332號',
    縣市: '新北市'
  },
  {
    店號: 238234,
    店名: '宜增',
    地址: '新北市新莊區中平路158號1樓',
    縣市: '新北市'
  },
  {
    店號: 238245,
    店名: '景旺',
    地址: '新北市中和區成功路1號',
    縣市: '新北市'
  },
  {
    店號: 238326,
    店名: '友勤',
    地址: '新北市樹林區大有路65號1樓',
    縣市: '新北市'
  },
  {
    店號: 238429,
    店名: '建六',
    地址: '新北市中和區建六路62號',
    縣市: '新北市'
  },
  {
    店號: 238496,
    店名: '永藝',
    地址: '新北市永和區永和路二段272號274號1樓',
    縣市: '新北市'
  },
  {
    店號: 238566,
    店名: '寶元',
    地址: '新北市新店區寶橋路156之2號156之3號1樓',
    縣市: '新北市'
  },
  {
    店號: 238599,
    店名: '國府',
    地址: '新北市板橋區國光路184號186號1樓',
    縣市: '新北市'
  },
  {
    店號: 238603,
    店名: '布拉諾',
    地址: '新北市淡水區坪頂路56-8號56-9號1樓',
    縣市: '新北市'
  },
  {
    店號: 238706,
    店名: '芳榮',
    地址: '新北市三峽區中正路二段534號536號538號',
    縣市: '新北市'
  },
  {
    店號: 238740,
    店名: '林宏',
    地址: '新北市新莊區成功街1號',
    縣市: '新北市'
  },
  {
    店號: 238832,
    店名: '新埔站',
    地址: '新北市板橋區民生路2段232號1.2樓之14、232號1.2樓之15',
    縣市: '新北市'
  },
  {
    店號: 238865,
    店名: '福隆站',
    地址: '新北市貢寮區福隆里福隆街8號1樓',
    縣市: '新北市'
  },
  {
    店號: 238876,
    店名: '有民',
    地址: '新北市永和區民有街9號11號1樓',
    縣市: '新北市'
  },
  {
    店號: 238898,
    店名: '仁寶',
    地址: '新北市永和區仁愛路266號1樓',
    縣市: '新北市'
  },
  {
    店號: 238902,
    店名: '金美',
    地址: '新北市金山區中山路143號145號',
    縣市: '新北市'
  },
  {
    店號: 238913,
    店名: '縣道',
    地址: '新北市板橋區縣民大道二段200巷1號3號1樓',
    縣市: '新北市'
  },
  {
    店號: 238979,
    店名: '左岸',
    地址: '新北市八里區龍米路二段230號之1號之2號1樓',
    縣市: '新北市'
  },
  {
    店號: 238980,
    店名: '蘆興',
    地址: '新北市蘆洲區長樂路2之6號1樓',
    縣市: '新北市'
  },
  {
    店號: 238991,
    店名: '鑫城',
    地址: '新北市土城區中華路一段100號1樓',
    縣市: '新北市'
  },
  {
    店號: 239019,
    店名: '麗池',
    地址: '新北市林口區中山路583號1樓.文化二路二段120號1樓',
    縣市: '新北市'
  },
  {
    店號: 239020,
    店名: '新永元',
    地址: '新北市永和區永元路28號30號',
    縣市: '新北市'
  },
  {
    店號: 239075,
    店名: '德城',
    地址: '新北市土城區明德路一段139號141號',
    縣市: '新北市'
  },
  {
    店號: 239086,
    店名: '廷寮',
    地址: '新北市土城區清水路252號254號1樓',
    縣市: '新北市'
  },
  {
    店號: 239134,
    店名: '景鑽',
    地址: '新北市中和區景新街373號373之1號',
    縣市: '新北市'
  },
  {
    店號: 239260,
    店名: '新宜',
    地址: '新北市新店區北宜路二段4號6號',
    縣市: '新北市'
  },
  {
    店號: 239329,
    店名: '寶新',
    地址: '新北市新店區北新路二段57號',
    縣市: '新北市'
  },
  {
    店號: 239400,
    店名: '樟福',
    地址: '新北市汐止區樟樹一路256號258號1樓',
    縣市: '新北市'
  },
  {
    店號: 239433,
    店名: '摩漾',
    地址: '新北市土城區中央路二段61巷21號1樓',
    縣市: '新北市'
  },
  {
    店號: 239466,
    店名: '頂宏',
    地址: '新北市三重區頂崁街210巷23弄1號3號1樓',
    縣市: '新北市'
  },
  {
    店號: 239488,
    店名: '聖陶',
    地址: '新北市鶯歌區文化路407號411號',
    縣市: '新北市'
  },
  {
    店號: 239499,
    店名: '鶯瓷',
    地址: '新北市鶯歌區尖山埔路100號102號',
    縣市: '新北市'
  },
  {
    店號: 239503,
    店名: '康湖',
    地址: '新北市汐止區康寧街482-8號488號490號',
    縣市: '新北市'
  },
  {
    店號: 239570,
    店名: '源前',
    地址: '新北市新莊區思源路388.390號',
    縣市: '新北市'
  },
  {
    店號: 239640,
    店名: '莊鑫',
    地址: '新北市新店區中正路503之3號503之4號1樓2樓',
    縣市: '新北市'
  },
  {
    店號: 239651,
    店名: '青雲',
    地址: '新北市土城區青雲路499號501號',
    縣市: '新北市'
  },
  {
    店號: 239662,
    店名: '文聖',
    地址: '新北市板橋區文聖街64號1樓.松柏街96號1樓',
    縣市: '新北市'
  },
  {
    店號: 239754,
    店名: '茂源',
    地址: '新北市新莊區思源路40-1號',
    縣市: '新北市'
  },
  {
    店號: 239765,
    店名: '永利',
    地址: '新北市永和區永元里永元路93號',
    縣市: '新北市'
  },
  {
    店號: 239824,
    店名: '美新',
    地址: '新北市新莊區復興路二段141號143號',
    縣市: '新北市'
  },
  {
    店號: 239846,
    店名: '龍恩',
    地址: '新北市三峽區國學街13號',
    縣市: '新北市'
  },
  {
    店號: 239857,
    店名: '貴興',
    地址: '新北市板橋區貴興路25號27號1樓',
    縣市: '新北市'
  },
  {
    店號: 239879,
    店名: '漢西',
    地址: '新北市板橋區漢生西路64號66號1樓',
    縣市: '新北市'
  },
  {
    店號: 239927,
    店名: '金銘',
    地址: '新北市三峽區介壽路一段27號',
    縣市: '新北市'
  },
  {
    店號: 239994,
    店名: '宏禧',
    地址: '新北市中和區景平路429號1樓2樓',
    縣市: '新北市'
  },
  {
    店號: 240075,
    店名: '愛鄉',
    地址: '新北市林口區仁愛路二段140號142號1樓',
    縣市: '新北市'
  },
  {
    店號: 240134,
    店名: '永宜',
    地址: '新北市中和區宜安路118巷22號24號1樓',
    縣市: '新北市'
  },
  {
    店號: 240204,
    店名: '民悅',
    地址: '新北市蘆洲區民族路316.318號',
    縣市: '新北市'
  },
  {
    店號: 240329,
    店名: '中安',
    地址: '新北市中和區宜安路62號66號',
    縣市: '新北市'
  },
  {
    店號: 240330,
    店名: '安斌',
    地址: '新北市中和區中安街84號86號1樓',
    縣市: '新北市'
  },
  {
    店號: 240341,
    店名: '宜安',
    地址: '新北市中和區宜安路103號1樓',
    縣市: '新北市'
  },
  {
    店號: 240352,
    店名: '新樹',
    地址: '新北市新莊區新樹路166號及民安路461號',
    縣市: '新北市'
  },
  {
    店號: 240363,
    店名: '壽德',
    地址: '新北市中和區壽德街11號1樓',
    縣市: '新北市'
  },
  {
    店號: 240374,
    店名: '茄苳',
    地址: '新北市汐止區忠孝東路357號359號1樓',
    縣市: '新北市'
  },
  {
    店號: 240455,
    店名: '長洲',
    地址: '新北市蘆洲區長安街25.27號1樓',
    縣市: '新北市'
  },
  {
    店號: 240466,
    店名: '環永',
    地址: '新北市永和區環河西路二段231號233號1樓',
    縣市: '新北市'
  },
  {
    店號: 240477,
    店名: '榮富',
    地址: '新北市新莊區中榮街43號47號',
    縣市: '新北市'
  },
  {
    店號: 240547,
    店名: '鼻頭角',
    地址: '新北市瑞芳區鼻頭路227之4號1樓',
    縣市: '新北市'
  },
  {
    店號: 240617,
    店名: '大同南',
    地址: '新北市三重區大同南路102號106號',
    縣市: '新北市'
  },
  {
    店號: 240639,
    店名: '忠承',
    地址: '新北市土城區忠承路103號1樓',
    縣市: '新北市'
  },
  {
    店號: 240765,
    店名: '昇陽',
    地址: '新北市永和區雙和里1鄰中和路417號419號',
    縣市: '新北市'
  },
  {
    店號: 240798,
    店名: '意幼',
    地址: '新北市新莊區後港一路173號1樓',
    縣市: '新北市'
  },
  {
    店號: 240802,
    店名: '德園',
    地址: '新北市林口區文化二路一段120巷1之1號',
    縣市: '新北市'
  },
  {
    店號: 240905,
    店名: '峽太',
    地址: '新北市三峽區大同路90號92號94號',
    縣市: '新北市'
  },
  {
    店號: 240938,
    店名: '仁森',
    地址: '新北市林口區粉寮路1段62、64號1樓',
    縣市: '新北市'
  },
  {
    店號: 240972,
    店名: '鄉長',
    地址: '新北市汐止區鄉長路二段16號',
    縣市: '新北市'
  },
  {
    店號: 241034,
    店名: '油庫口',
    地址: '新北市板橋區文化路一段188巷38號40號1樓',
    縣市: '新北市'
  },
  {
    店號: 241045,
    店名: '石門',
    地址: '新北市石門區中山路78號',
    縣市: '新北市'
  },
  {
    店號: 241078,
    店名: '金昂',
    地址: '新北市淡水區新市一路一段99巷51.53號1樓',
    縣市: '新北市'
  },
  {
    店號: 241089,
    店名: '竹圍',
    地址: '新北市淡水區民權路109號111號',
    縣市: '新北市'
  },
  {
    店號: 241344,
    店名: '泰民',
    地址: '新北市板橋區民族路222巷13.15號1樓',
    縣市: '新北市'
  },
  {
    店號: 241436,
    店名: '新極景',
    地址: '新北市新店區北新路二段252-1號',
    縣市: '新北市'
  },
  {
    店號: 241469,
    店名: '星光美',
    地址: '新北市三重區重新路三段27號1樓',
    縣市: '新北市'
  },
  {
    店號: 241528,
    店名: '正福',
    地址: '新北市永和區中正路546號1樓',
    縣市: '新北市'
  },
  {
    店號: 244491,
    店名: '民生廠',
    地址: '新北市土城區民生街4號1樓',
    縣市: '新北市'
  },
  {
    店號: 249083,
    店名: '連發',
    地址: '新北市中和區連城路208號1樓2樓',
    縣市: '新北市'
  },
  {
    店號: 249175,
    店名: '民族',
    地址: '新北市板橋區福祿里民族路310號',
    縣市: '新北市'
  },
  {
    店號: 249234,
    店名: '三禾',
    地址: '新北市三重區大智街139號139之2號1樓',
    縣市: '新北市'
  },
  {
    店號: 249245,
    店名: '莊和',
    地址: '新北市新莊區中和街34.36號',
    縣市: '新北市'
  },
  {
    店號: 249429,
    店名: '海山',
    地址: '新北市板橋區漢生東路310號',
    縣市: '新北市'
  },
  {
    店號: 249500,
    店名: '承義',
    地址: '新北市土城區忠承路22號',
    縣市: '新北市'
  },
  {
    店號: 249544,
    店名: '頂崁',
    地址: '新北市三重區光復路一段82號1樓',
    縣市: '新北市'
  },
  {
    店號: 249625,
    店名: '龍米',
    地址: '新北市八里區龍米路二段46號48號50號',
    縣市: '新北市'
  },
  {
    店號: 249636,
    店名: '板南',
    地址: '新北市中和區板南路486號',
    縣市: '新北市'
  },
  {
    店號: 249865,
    店名: '新店',
    地址: '新北市新店區碧潭路14號1樓',
    縣市: '新北市'
  },
  {
    店號: 249957,
    店名: '智成',
    地址: '新北市三芝區中正路二段1號智成街79號',
    縣市: '新北市'
  },
  {
    店號: 249979,
    店名: '光谷',
    地址: '新北市三重區光復路一段61巷27-1號',
    縣市: '新北市'
  },
  {
    店號: 250061,
    店名: '藍天',
    地址: '新北市林口區公園路203號之1;203號之2',
    縣市: '新北市'
  },
  {
    店號: 250072,
    店名: '明躍',
    地址: '新北市泰山區明志路三段202號',
    縣市: '新北市'
  },
  {
    店號: 250289,
    店名: '國鶯',
    地址: '新北市鶯歌區中山路142號1F',
    縣市: '新北市'
  },
  {
    店號: 250290,
    店名: '安康',
    地址: '新北市新店區安德街70號72號1樓+2樓',
    縣市: '新北市'
  },
  {
    店號: 250393,
    店名: '碧潭',
    地址: '新北市新店區北宜路一段28號',
    縣市: '新北市'
  },
  {
    店號: 250407,
    店名: '德泰',
    地址: '新北市五股區成泰路一段10號',
    縣市: '新北市'
  },
  {
    店號: 250429,
    店名: '旭泰',
    地址: '新北市汐止區建成路57巷1號3號',
    縣市: '新北市'
  },
  {
    店號: 250430,
    店名: '板仁',
    地址: '新北市板橋區大智街93號.大仁街101號',
    縣市: '新北市'
  },
  {
    店號: 250463,
    店名: '莊勝',
    地址: '新北市新莊區八德街59號61號1樓',
    縣市: '新北市'
  },
  {
    店號: 250474,
    店名: '樹復',
    地址: '新北市樹林區復興路340號',
    縣市: '新北市'
  },
  {
    店號: 250496,
    店名: '秀杉',
    地址: '新北市中和區自立路129號131號',
    縣市: '新北市'
  },
  {
    店號: 250500,
    店名: '朗廷會',
    地址: '新北市林口區文化三路二段91號1樓',
    縣市: '新北市'
  },
  {
    店號: 250533,
    店名: '立軒',
    地址: '新北市林口區文化一路一段200號202號1樓2樓',
    縣市: '新北市'
  },
  {
    店號: 250603,
    店名: '冠綸',
    地址: '新北市三峽區中華路59號61號1樓',
    縣市: '新北市'
  },
  {
    店號: 250670,
    店名: '中園',
    地址: '新北市三峽區民權街235號1樓',
    縣市: '新北市'
  },
  {
    店號: 250706,
    店名: '新宏盛',
    地址: '新北市新莊區後港一路114號',
    縣市: '新北市'
  },
  {
    店號: 250740,
    店名: '美河',
    地址: '新北市新店區三民路35巷2號',
    縣市: '新北市'
  },
  {
    店號: 250887,
    店名: '天元',
    地址: '新北市淡水區北新路三段30號1樓2樓',
    縣市: '新北市'
  },
  {
    店號: 251042,
    店名: '樹樺',
    地址: '新北市樹林區中華路341之5號341之6號一樓',
    縣市: '新北市'
  },
  {
    店號: 251075,
    店名: '得晴',
    地址: '新北市中和區景平路239巷1號3-5號1樓',
    縣市: '新北市'
  },
  {
    店號: 251086,
    店名: '集興',
    地址: '新北市三重區光明里24鄰集美街202號',
    縣市: '新北市'
  },
  {
    店號: 251097,
    店名: '真旺',
    地址: '新北市三重區成功路50巷1號',
    縣市: '新北市'
  },
  {
    店號: 251123,
    店名: '萬鄰',
    地址: '新北市板橋區華江里民生路二段226巷46號1樓',
    縣市: '新北市'
  },
  {
    店號: 251204,
    店名: '迴龍站',
    地址: '新北市新莊區中正路895號895號之1號',
    縣市: '新北市'
  },
  {
    店號: 251215,
    店名: '樹豐',
    地址: '新北市新莊區豐盛一街6.8.10號',
    縣市: '新北市'
  },
  {
    店號: 251282,
    店名: '存德',
    地址: '新北市板橋區篤行路二段86號88號1樓',
    縣市: '新北市'
  },
  {
    店號: 251318,
    店名: '秀和',
    地址: '新北市永和區國中路99號101號',
    縣市: '新北市'
  },
  {
    店號: 251455,
    店名: '長泰',
    地址: '新北市三重區三和路2段125號127號1樓',
    縣市: '新北市'
  },
  {
    店號: 254502,
    店名: '矽功',
    地址: '新北市汐止區大同路一段284號',
    縣市: '新北市'
  },
  {
    店號: 254524,
    店名: '湖鑫',
    地址: '新北市汐止區湖前街37號39號1樓',
    縣市: '新北市'
  },
  {
    店號: 780399,
    店名: '中港',
    地址: '新北市新莊區中港路133號',
    縣市: '新北市'
  },
  {
    店號: 810410,
    店名: '永興',
    地址: '新北市永和區竹林路98號',
    縣市: '新北市'
  },
  {
    店號: 832498,
    店名: '幸福',
    地址: '新北市三重區自強路一段272號',
    縣市: '新北市'
  },
  {
    店號: 832502,
    店名: '安復',
    地址: '新北市新莊區復興路一段213號',
    縣市: '新北市'
  },
  {
    店號: 832605,
    店名: '景新',
    地址: '新北市中和區景新街436號',
    縣市: '新北市'
  },
  {
    店號: 833642,
    店名: '土城',
    地址: '新北市土城區中央路三段42號',
    縣市: '新北市'
  },
  {
    店號: 844310,
    店名: '新泰',
    地址: '新北市新莊區新泰路267號',
    縣市: '新北市'
  },
  {
    店號: 844712,
    店名: '員山',
    地址: '新北市中和區員山路163號、165號、167號1樓',
    縣市: '新北市'
  },
  {
    店號: 844907,
    店名: '龍翠',
    地址: '新北市板橋區雙十路二段138之1號138之2號',
    縣市: '新北市'
  },
  {
    店號: 845715,
    店名: '車路頭',
    地址: '新北市三重區車路頭街135號',
    縣市: '新北市'
  },
  {
    店號: 846235,
    店名: '千歲',
    地址: '新北市樹林區千歲街26-10號',
    縣市: '新北市'
  },
  {
    店號: 846420,
    店名: '高仁',
    地址: '新北市三重區仁愛街274號',
    縣市: '新北市'
  },
  {
    店號: 846660,
    店名: '埔墘',
    地址: '新北市板橋區永豐街87號',
    縣市: '新北市'
  },
  {
    店號: 852230,
    店名: '益彰',
    地址: '新北市八里區中山路二段409號411號',
    縣市: '新北市'
  },
  {
    店號: 855033,
    店名: '瑞濱',
    地址: '新北市瑞芳區海濱路157號',
    縣市: '新北市'
  },
  {
    店號: 855206,
    店名: '懷德',
    地址: '新北市板橋區懷德街55號57號',
    縣市: '新北市'
  },
  {
    店號: 855217,
    店名: '正陽',
    地址: '新北市三重區正義北路386號388號',
    縣市: '新北市'
  },
  {
    店號: 860655,
    店名: '保生',
    地址: '新北市永和區保安里保生路1號',
    縣市: '新北市'
  },
  {
    店號: 861131,
    店名: '綠洲',
    地址: '新北市三峽區鳶山里12鄰中山路186號1樓',
    縣市: '新北市'
  },
  {
    店號: 862374,
    店名: '景仁',
    地址: '新北市中和區忠孝街103號103之1號',
    縣市: '新北市'
  },
  {
    店號: 864613,
    店名: '延和',
    地址: '新北市土城區平和里延和路106號',
    縣市: '新北市'
  },
  {
    店號: 864749,
    店名: '景安',
    地址: '新北市中和區景安路210號',
    縣市: '新北市'
  },
  {
    店號: 864897,
    店名: '新年',
    地址: '新北市新莊區豐年街54號',
    縣市: '新北市'
  },
  {
    店號: 864901,
    店名: '圓通',
    地址: '新北市中和區圓通路280號282號',
    縣市: '新北市'
  },
  {
    店號: 865269,
    店名: '議會',
    地址: '新北市板橋區莊敬路60號',
    縣市: '新北市'
  },
  {
    店號: 871482,
    店名: '統吉',
    地址: '新北市蘆洲區永平街32巷12弄1號',
    縣市: '新北市'
  },
  {
    店號: 872061,
    店名: '孟揚',
    地址: '新北市永和區秀和里林森路62號',
    縣市: '新北市'
  },
  {
    店號: 872108,
    店名: '花旗',
    地址: '新北市新莊區中港路132巷26號',
    縣市: '新北市'
  },
  {
    店號: 872441,
    店名: '千群',
    地址: '新北市板橋區東丘里民享街53號',
    縣市: '新北市'
  },
  {
    店號: 874126,
    店名: '淡大',
    地址: '新北市淡水區北新路182巷5弄39號',
    縣市: '新北市'
  },
  {
    店號: 875060,
    店名: '清茂',
    地址: '新北市三重區成功路106號之2',
    縣市: '新北市'
  },
  {
    店號: 875646,
    店名: '民自',
    地址: '新北市中和區冠穗里民享街38號38之1號',
    縣市: '新北市'
  },
  {
    店號: 880268,
    店名: '祥吉',
    地址: '新北市土城區延吉街194號',
    縣市: '新北市'
  },
  {
    店號: 880833,
    店名: '真誠',
    地址: '新北市深坑區北深路三段263號',
    縣市: '新北市'
  },
  {
    店號: 880899,
    店名: '景福',
    地址: '新北市中和區景新街467巷22號',
    縣市: '新北市'
  },
  {
    店號: 883728,
    店名: '統友',
    地址: '新北市樹林區中山路一段86號',
    縣市: '新北市'
  },
  {
    店號: 883924,
    店名: '上北可',
    地址: '新北市土城區明德路一段232號',
    縣市: '新北市'
  },
  {
    店號: 885698,
    店名: '民光',
    地址: '新北市永和區中正路166號',
    縣市: '新北市'
  },
  {
    店號: 886082,
    店名: '頭前',
    地址: '新北市新莊區化成路429-4號',
    縣市: '新北市'
  },
  {
    店號: 886875,
    店名: '景禮',
    地址: '新北市中和區景安路100號1樓102號1樓104號1樓',
    縣市: '新北市'
  },
  {
    店號: 888147,
    店名: '金城',
    地址: '新北市土城區金城路三段71號',
    縣市: '新北市'
  },
  {
    店號: 888158,
    店名: '明益',
    地址: '新北市三重區忠孝路三段61號',
    縣市: '新北市'
  },
  {
    店號: 890092,
    店名: '丹鳳',
    地址: '新北市新莊區新北大道七段842號',
    縣市: '新北市'
  },
  {
    店號: 890184,
    店名: '神州',
    地址: '新北市八里區龍米路一段113號',
    縣市: '新北市'
  },
  {
    店號: 890601,
    店名: '水碓',
    地址: '新北市五股區水碓路14號',
    縣市: '新北市'
  },
  {
    店號: 890634,
    店名: '觀林',
    地址: '新北市林口區林口路78號80號',
    縣市: '新北市'
  },
  {
    店號: 891006,
    店名: '潤安',
    地址: '新北市汐止區龍安路32號',
    縣市: '新北市'
  },
  {
    店號: 891280,
    店名: '順興',
    地址: '新北市樹林區東興街41號',
    縣市: '新北市'
  },
  {
    店號: 891730,
    店名: '佑容',
    地址: '新北市板橋區五權里五權街49號51號',
    縣市: '新北市'
  },
  {
    店號: 892032,
    店名: '儷新',
    地址: '新北市新莊區新樹路451號',
    縣市: '新北市'
  },
  {
    店號: 893035,
    店名: '廣進',
    地址: '新北市新莊區四維路173號',
    縣市: '新北市'
  },
  {
    店號: 893448,
    店名: '采旺',
    地址: '新北市新莊區天祥街74號',
    縣市: '新北市'
  },
  {
    店號: 893873,
    店名: '文興',
    地址: '新北市三重區文化南路7號',
    縣市: '新北市'
  },
  {
    店號: 895710,
    店名: '富興',
    地址: '新北市中和區中興里復興路277-1號279號',
    縣市: '新北市'
  },
  {
    店號: 895787,
    店名: '日福',
    地址: '新北市中和區中和路380號',
    縣市: '新北市'
  },
  {
    店號: 895798,
    店名: '永和',
    地址: '新北市永和區文化路7號',
    縣市: '新北市'
  },
  {
    店號: 896366,
    店名: '五峰',
    地址: '新北市新店區中興路一段252號',
    縣市: '新北市'
  },
  {
    店號: 896447,
    店名: '福百',
    地址: '新北市汐止區福德一路161號',
    縣市: '新北市'
  },
  {
    店號: 897864,
    店名: '進益',
    地址: '新北市汐止區大同路二段314號',
    縣市: '新北市'
  },
  {
    店號: 900429,
    店名: '金寶',
    地址: '新北市淡水區中正路169號',
    縣市: '新北市'
  },
  {
    店號: 900924,
    店名: '頂華',
    地址: '新北市三重區頂崁街189號',
    縣市: '新北市'
  },
  {
    店號: 901260,
    店名: '萬全',
    地址: '新北市鶯歌區鶯桃路660號',
    縣市: '新北市'
  },
  {
    店號: 901307,
    店名: '新遠',
    地址: '新北市新莊區中正路651號之8號',
    縣市: '新北市'
  },
  {
    店號: 901363,
    店名: '秀景',
    地址: '新北市中和區成功路115號117號',
    縣市: '新北市'
  },
  {
    店號: 901710,
    店名: '偉嘉',
    地址: '新北市板橋區文化路一段270巷3弄2號',
    縣市: '新北市'
  },
  {
    店號: 902311,
    店名: '昇容',
    地址: '新北市板橋區重慶路346巷8號',
    縣市: '新北市'
  },
  {
    店號: 902931,
    店名: '禧緻',
    地址: '新北市中和區華新街156號',
    縣市: '新北市'
  },
  {
    店號: 902953,
    店名: '松旺',
    地址: '新北市中和區中山路三段108號',
    縣市: '新北市'
  },
  {
    店號: 903646,
    店名: '雙溪',
    地址: '新北市雙溪區自強路7號',
    縣市: '新北市'
  },
  {
    店號: 906748,
    店名: '同仁',
    地址: '新北市新店區民權路96號',
    縣市: '新北市'
  },
  {
    店號: 906841,
    店名: '尊爵',
    地址: '新北市汐止區伯爵街32號',
    縣市: '新北市'
  },
  {
    店號: 910552,
    店名: '那魯灣',
    地址: '新北市烏來區烏來里溫泉街80號',
    縣市: '新北市'
  },
  {
    店號: 910688,
    店名: '糧驛',
    地址: '新北市板橋區德翠里龍泉街93號、95號1樓',
    縣市: '新北市'
  },
  {
    店號: 911924,
    店名: '新連正',
    地址: '新北市中和區連城路347巷2號',
    縣市: '新北市'
  },
  {
    店號: 912271,
    店名: '金鶯',
    地址: '新北市鶯歌區鶯桃路131-133號',
    縣市: '新北市'
  },
  {
    店號: 912282,
    店名: '保鑽',
    地址: '新北市永和區潭墘里安樂路138號140號',
    縣市: '新北市'
  },
  {
    店號: 912891,
    店名: '霞關',
    地址: '新北市淡水區淡金路59-61號B1',
    縣市: '新北市'
  },
  {
    店號: 916284,
    店名: '領袖',
    地址: '新北市蘆洲區集賢路224巷60號62號',
    縣市: '新北市'
  },
  {
    店號: 916468,
    店名: '武林',
    地址: '新北市樹林區光華街2號4號6號',
    縣市: '新北市'
  },
  {
    店號: 916538,
    店名: '金紅',
    地址: '新北市淡水區淡金路三段2號2樓',
    縣市: '新北市'
  },
  {
    店號: 920249,
    店名: '坪林',
    地址: '新北市坪林區北宜路8段138號140號1樓',
    縣市: '新北市'
  },
  {
    店號: 921149,
    店名: '登福',
    地址: '新北市五股區登林路76之3號',
    縣市: '新北市'
  },
  {
    店號: 921714,
    店名: '西盛',
    地址: '新北市新莊區民安西路113號之1',
    縣市: '新北市'
  },
  {
    店號: 921976,
    店名: '龍五',
    地址: '新北市五股區凌雲路一段136號',
    縣市: '新北市'
  },
  {
    店號: 921998,
    店名: '緯中',
    地址: '新北市板橋區中正路21號23號',
    縣市: '新北市'
  },
  {
    店號: 922131,
    店名: '香雅',
    地址: '新北市板橋區南雅西路二段297號299號',
    縣市: '新北市'
  },
  {
    店號: 922348,
    店名: '新台',
    地址: '新北市五股區五工六路14號',
    縣市: '新北市'
  },
  {
    店號: 922533,
    店名: '建宗',
    地址: '新北市板橋區溪福里篤行路三段玉平巷76弄8號及10號',
    縣市: '新北市'
  },
  {
    店號: 922968,
    店名: '新盛昌',
    地址: '新北市汐止區長江街13巷1號',
    縣市: '新北市'
  },
  {
    店號: 923097,
    店名: '樹保',
    地址: '新北市樹林區保安街二段357號',
    縣市: '新北市'
  },
  {
    店號: 924665,
    店名: '國和',
    地址: '新北市板橋區和平路29號',
    縣市: '新北市'
  },
  {
    店號: 924757,
    店名: '信利',
    地址: '新北市土城區興城路96巷4號',
    縣市: '新北市'
  },
  {
    店號: 928151,
    店名: '雙泰',
    地址: '新北市新莊區新泰路330號',
    縣市: '新北市'
  },
  {
    店號: 930981,
    店名: '龍馬',
    地址: '新北市永和區文化路188號',
    縣市: '新北市'
  },
  {
    店號: 931054,
    店名: '山佳',
    地址: '新北市樹林區中山路三段87號',
    縣市: '新北市'
  },
  {
    店號: 931216,
    店名: '新寶橋',
    地址: '新北市新店區寶橋路192號',
    縣市: '新北市'
  },
  {
    店號: 931571,
    店名: '舊社',
    地址: '新北市板橋區中山路二段412號',
    縣市: '新北市'
  },
  {
    店號: 932482,
    店名: '榮德',
    地址: '新北市樹林區東榮街8-10號',
    縣市: '新北市'
  },
  {
    店號: 932851,
    店名: '武仁',
    地址: '新北市泰山區仁愛路100巷26號28號30號',
    縣市: '新北市'
  },
  {
    店號: 933120,
    店名: '吉發',
    地址: '新北市淡水區自強路275號',
    縣市: '新北市'
  },
  {
    店號: 934606,
    店名: '三暉',
    地址: '新北市樹林區樹福里復興路1號',
    縣市: '新北市'
  },
  {
    店號: 934776,
    店名: '光華',
    地址: '新北市新莊區民安西路388、388-1、390、390-1號',
    縣市: '新北市'
  },
  {
    店號: 936303,
    店名: '樹英',
    地址: '新北市樹林區大同里中華路120號',
    縣市: '新北市'
  },
  {
    店號: 940863,
    店名: '真豪',
    地址: '新北市新莊區中華路一段73號',
    縣市: '新北市'
  },
  {
    店號: 941567,
    店名: '佳宏',
    地址: '新北市樹林區太平路150巷1號',
    縣市: '新北市'
  },
  {
    店號: 942515,
    店名: '御成',
    地址: '新北市三峽區國光街35號',
    縣市: '新北市'
  },
  {
    店號: 942733,
    店名: '富美',
    地址: '新北市五股區五股工業區五權路23號',
    縣市: '新北市'
  },
  {
    店號: 944441,
    店名: '宏全',
    地址: '新北市新莊區中和街61號',
    縣市: '新北市'
  },
  {
    店號: 946528,
    店名: '南谷',
    地址: '新北市中和區中和路257號',
    縣市: '新北市'
  },
  {
    店號: 946551,
    店名: '建一',
    地址: '新北市中和區建康路101號',
    縣市: '新北市'
  },
  {
    店號: 947336,
    店名: '新龍',
    地址: '新北市新莊區光明里民安西路232號',
    縣市: '新北市'
  },
  {
    店號: 947369,
    店名: '銀座',
    地址: '新北市三重區信義西街4號',
    縣市: '新北市'
  },
  {
    店號: 947934,
    店名: '卿斳',
    地址: '新北市林口區竹林路48號',
    縣市: '新北市'
  },
  {
    店號: 948638,
    店名: '大智',
    地址: '新北市三重區大同北路63號',
    縣市: '新北市'
  },
  {
    店號: 950435,
    店名: '孝忠',
    地址: '新北市中和區忠孝街37巷2號',
    縣市: '新北市'
  },
  {
    店號: 950745,
    店名: '漢東',
    地址: '新北市板橋區漢生東路309號',
    縣市: '新北市'
  },
  {
    店號: 950907,
    店名: '三靖',
    地址: '新北市鶯歌區三鶯路52號一樓',
    縣市: '新北市'
  },
  {
    店號: 951313,
    店名: '福勝',
    地址: '新北市中和區福祥路156號158號',
    縣市: '新北市'
  },
  {
    店號: 951438,
    店名: '保順',
    地址: '新北市永和區保順路39號及保順路37巷2號',
    縣市: '新北市'
  },
  {
    店號: 953087,
    店名: '萬板',
    地址: '新北市板橋區莒光路221號223號',
    縣市: '新北市'
  },
  {
    店號: 953319,
    店名: '雙祥',
    地址: '新北市雙溪區雙溪村太平路65號67號',
    縣市: '新北市'
  },
  {
    店號: 953353,
    店名: '安忠',
    地址: '新北市新店區安忠路20號',
    縣市: '新北市'
  },
  {
    店號: 953663,
    店名: '青蘋果',
    地址: '新北市板橋區中山路二段531巷17弄20號',
    縣市: '新北市'
  },
  {
    店號: 953928,
    店名: '俊龍',
    地址: '新北市樹林區三俊街96號1樓',
    縣市: '新北市'
  },
  {
    店號: 956341,
    店名: '金旦',
    地址: '新北市淡水區淡金路三段254號256號258號',
    縣市: '新北市'
  },
  {
    店號: 956662,
    店名: '城運',
    地址: '新北市土城區承天路10號',
    縣市: '新北市'
  },
  {
    店號: 956835,
    店名: '福臨',
    地址: '新北市五股區工商路150號152號',
    縣市: '新北市'
  },
  {
    店號: 957333,
    店名: '天龍',
    地址: '新北市三重區龍門路217號219號221號',
    縣市: '新北市'
  },
  {
    店號: 957355,
    店名: '莊成',
    地址: '新北市新莊區化成路354號',
    縣市: '新北市'
  },
  {
    店號: 958901,
    店名: '寶中',
    地址: '新北市新店區寶慶街66號',
    縣市: '新北市'
  },
  {
    店號: 958934,
    店名: '佳客',
    地址: '新北市中和區民德路126號126之1號',
    縣市: '新北市'
  },
  {
    店號: 959270,
    店名: '邁群',
    地址: '新北市永和區民生路42號',
    縣市: '新北市'
  },
  {
    店號: 959292,
    店名: '智慧',
    地址: '新北市汐止區大同路二段281號',
    縣市: '新北市'
  },
  {
    店號: 959328,
    店名: '綠雅',
    地址: '新北市三峽區文化路122號',
    縣市: '新北市'
  },
  {
    店號: 959339,
    店名: '豐康',
    地址: '新北市三峽區成福路241號',
    縣市: '新北市'
  },
  {
    店號: 960166,
    店名: '蘆樂',
    地址: '新北市蘆洲區長樂路55號1樓',
    縣市: '新北市'
  },
  {
    店號: 960535,
    店名: '輔大',
    地址: '新北市新莊區中正路516-1號',
    縣市: '新北市'
  },
  {
    店號: 961354,
    店名: '新野柳',
    地址: '新北市萬里區野柳港東路158號',
    縣市: '新北市'
  },
  {
    店號: 961387,
    店名: '立德',
    地址: '新北市中和區立德街103號',
    縣市: '新北市'
  },
  {
    店號: 961778,
    店名: '淡欣',
    地址: '新北市淡水區水源街二段104號',
    縣市: '新北市'
  },
  {
    店號: 962069,
    店名: '皇裕',
    地址: '新北市土城區裕民路114巷16號1樓',
    縣市: '新北市'
  },
  {
    店號: 962380,
    店名: '大五股',
    地址: '新北市五股區成泰路二段81號',
    縣市: '新北市'
  },
  {
    店號: 962586,
    店名: '平安',
    地址: '新北市三重區正義北路51號',
    縣市: '新北市'
  },
  {
    店號: 963567,
    店名: '埔昇',
    地址: '新北市深坑區埔新街63號',
    縣市: '新北市'
  },
  {
    店號: 965220,
    店名: '輔明',
    地址: '新北市新莊區中正路514巷99號',
    縣市: '新北市'
  },
  {
    店號: 966603,
    店名: '興林',
    地址: '新北市林口區南勢村南勢街278號280號',
    縣市: '新北市'
  },
  {
    店號: 966898,
    店名: '維中',
    地址: '新北市五股區四維路120號',
    縣市: '新北市'
  },
  {
    店號: 967101,
    店名: '蘆揚',
    地址: '新北市蘆洲區民生街30號',
    縣市: '新北市'
  },
  {
    店號: 967983,
    店名: '弘龍',
    地址: '新北市五股區工商路16號',
    縣市: '新北市'
  },
  {
    店號: 968023,
    店名: '采鋺',
    地址: '新北市林口區文化三路一段368號',
    縣市: '新北市'
  },
  {
    店號: 968089,
    店名: '新僑中',
    地址: '新北市板橋區僑中一街124巷3弄3號',
    縣市: '新北市'
  },
  {
    店號: 968791,
    店名: '成合',
    地址: '新北市板橋區金門街40號',
    縣市: '新北市'
  },
  {
    店號: 968827,
    店名: '莊龍',
    地址: '新北市新莊區龍安路66號',
    縣市: '新北市'
  },
  {
    店號: 970222,
    店名: '莊泰',
    地址: '新北市新莊區新泰路21號',
    縣市: '新北市'
  },
  {
    店號: 970439,
    店名: '新保福',
    地址: '新北市永和區保安路220號',
    縣市: '新北市'
  },
  {
    店號: 971100,
    店名: '百義',
    地址: '新北市三重區仁義街232號',
    縣市: '新北市'
  },
  {
    店號: 971133,
    店名: '新宇鈞',
    地址: '新北市樹林區大安路115號117號1樓',
    縣市: '新北市'
  },
  {
    店號: 971144,
    店名: '新永寧',
    地址: '新北市土城區中央路三段191之1號及永寧路1號3號',
    縣市: '新北市'
  },
  {
    店號: 971203,
    店名: '新裕生',
    地址: '新北市土城區裕民路57號及55巷2號',
    縣市: '新北市'
  },
  {
    店號: 971775,
    店名: '和醫',
    地址: '新北市中和區中正路291號B1',
    縣市: '新北市'
  },
  {
    店號: 972273,
    店名: '博鑫',
    地址: '新北市鶯歌區中正三路283-1號283-2號1樓',
    縣市: '新北市'
  },
  {
    店號: 972918,
    店名: '皇后',
    地址: '新北市淡水區新春街87號',
    縣市: '新北市'
  },
  {
    店號: 975180,
    店名: '聖約翰',
    地址: '新北市淡水區淡金路四段532號',
    縣市: '新北市'
  },
  {
    店號: 975331,
    店名: '樹園',
    地址: '新北市樹林區佳園路一段52號1樓',
    縣市: '新北市'
  },
  {
    店號: 975456,
    店名: '興榮',
    地址: '新北市中和區福南里21鄰興南路二段90號1樓',
    縣市: '新北市'
  },
  {
    店號: 975537,
    店名: '勝多',
    地址: '新北市板橋區縣民大道三段270巷2-6號',
    縣市: '新北市'
  },
  {
    店號: 976024,
    店名: '粉寮',
    地址: '新北市林口區粉寮路二段36號',
    縣市: '新北市'
  },
  {
    店號: 976105,
    店名: '集美',
    地址: '新北市三重區集美街107號',
    縣市: '新北市'
  },
  {
    店號: 976426,
    店名: '及人',
    地址: '新北市新店區安民街72號',
    縣市: '新北市'
  },
  {
    店號: 976932,
    店名: '德正',
    地址: '新北市新店區德正街23巷1號',
    縣市: '新北市'
  },
  {
    店號: 977119,
    店名: '泰和',
    地址: '新北市三重區長安街71號1樓',
    縣市: '新北市'
  },
  {
    店號: 977485,
    店名: '心心',
    地址: '新北市板橋區實踐路105號107號',
    縣市: '新北市'
  },
  {
    店號: 977636,
    店名: '新圓山',
    地址: '新北市五股區成泰路一段191號、193號',
    縣市: '新北市'
  },
  {
    店號: 977913,
    店名: '濬家',
    地址: '新北市土城區廣明街2號',
    縣市: '新北市'
  },
  {
    店號: 977935,
    店名: '汐止站',
    地址: '新北市汐止區信義路1號',
    縣市: '新北市'
  },
  {
    店號: 978606,
    店名: '昇庚',
    地址: '新北市永和區永貞路182號184號',
    縣市: '新北市'
  },
  {
    店號: 978640,
    店名: '泰股',
    地址: '新北市五股區成泰路三段577巷24號',
    縣市: '新北市'
  },
  {
    店號: 978662,
    店名: '遠揚',
    地址: '新北市板橋區南雅南路2段124號及2段142巷12號1樓',
    縣市: '新北市'
  },
  {
    店號: 978802,
    店名: '安福',
    地址: '新北市永和區福和路213號',
    縣市: '新北市'
  },
  {
    店號: 979263,
    店名: '華翠',
    地址: '新北市板橋區莒光路63號',
    縣市: '新北市'
  },
  {
    店號: 980090,
    店名: '新燕',
    地址: '新北市新店區新烏路二段382號384號1樓',
    縣市: '新北市'
  },
  {
    店號: 980805,
    店名: '新展盛',
    地址: '新北市新莊區西盛街325號327號1樓',
    縣市: '新北市'
  },
  {
    店號: 980942,
    店名: '府運',
    地址: '新北市板橋區重慶路18號20號1樓',
    縣市: '新北市'
  },
  {
    店號: 981347,
    店名: '巧立',
    地址: '新北市淡水區北新路184巷57號59號1樓',
    縣市: '新北市'
  },
  {
    店號: 981794,
    店名: '嶄新',
    地址: '新北市新店區中正路57-2號1樓',
    縣市: '新北市'
  },
  {
    店號: 981990,
    店名: '全茂',
    地址: '新北市中和區連城路469巷9號11號',
    縣市: '新北市'
  },
  {
    店號: 982328,
    店名: '長虹',
    地址: '新北市鶯歌區鶯桃路432號1樓',
    縣市: '新北市'
  },
  {
    店號: 982579,
    店名: '新觀和',
    地址: '新北市板橋區大觀路二段55號57號1樓',
    縣市: '新北市'
  },
  {
    店號: 982627,
    店名: '新福圓',
    地址: '新北市新莊區五工三路93號1樓',
    縣市: '新北市'
  },
  {
    店號: 985349,
    店名: '鎮鑫',
    地址: '新北市新店區中興路一段289號',
    縣市: '新北市'
  },
  {
    店號: 985534,
    店名: '正隆',
    地址: '新北市板橋區民生路一段53號',
    縣市: '新北市'
  },
  {
    店號: 985545,
    店名: '鑫強',
    地址: '新北市三重區自強路三段30號32號',
    縣市: '新北市'
  },
  {
    店號: 985604,
    店名: '淡江',
    地址: '新北市淡水區學府路207號',
    縣市: '新北市'
  },
  {
    店號: 985615,
    店名: '竹林',
    地址: '新北市永和區竹林路211號',
    縣市: '新北市'
  },
  {
    店號: 985671,
    店名: '利客來',
    地址: '新北市五股區成泰路三段419號',
    縣市: '新北市'
  },
  {
    店號: 985682,
    店名: '泰隆',
    地址: '新北市中和區立德街102號',
    縣市: '新北市'
  },
  {
    店號: 985785,
    店名: '珈英',
    地址: '新北市蘆洲區復興路92號',
    縣市: '新北市'
  },
  {
    店號: 987769,
    店名: '工林',
    地址: '新北市林口區工六路76號',
    縣市: '新北市'
  },
  {
    店號: 987909,
    店名: '來鑫',
    地址: '新北市烏來區新烏路五段160號162號',
    縣市: '新北市'
  },
  {
    店號: 989411,
    店名: '三重',
    地址: '新北市三重區重新路三段18號',
    縣市: '新北市'
  },
  {
    店號: 990204,
    店名: '聯合報',
    地址: '新北市汐止區大同路一段369號1樓',
    縣市: '新北市'
  },
  {
    店號: 990639,
    店名: '新吉麗',
    地址: '新北市蘆洲區中山一路204號1樓',
    縣市: '新北市'
  },
  {
    店號: 991137,
    店名: '武強',
    地址: '新北市淡水區自強路375號1樓',
    縣市: '新北市'
  },
  {
    店號: 991333,
    店名: '新明',
    地址: '新北市新店區光明街140號',
    縣市: '新北市'
  },
  {
    店號: 991458,
    店名: '八里',
    地址: '新北市八里區中山路二段343號1樓',
    縣市: '新北市'
  },
  {
    店號: 991654,
    店名: '仁仁',
    地址: '新北市三重區仁愛街50號',
    縣市: '新北市'
  },
  {
    店號: 992037,
    店名: '中一',
    地址: '新北市板橋區中正路332之5號1樓',
    縣市: '新北市'
  },
  {
    店號: 992576,
    店名: '樹安',
    地址: '新北市樹林區大安路530號1樓',
    縣市: '新北市'
  },
  {
    店號: 992598,
    店名: '麗金',
    地址: '新北市永和區成功路一段83號85號1樓',
    縣市: '新北市'
  },
  {
    店號: 992624,
    店名: '北福',
    地址: '新北市永和區福和路121號1樓2樓',
    縣市: '新北市'
  },
  {
    店號: 992923,
    店名: '皇翔',
    地址: '新北市土城區中央路一段88號1樓、裕民路10-1號.10號.8-1號.8號',
    縣市: '新北市'
  },
  {
    店號: 993144,
    店名: '奕真',
    地址: '新北市泰山區明志路二段185號1樓(部份)',
    縣市: '新北市'
  },
  {
    店號: 993867,
    店名: '鶯育',
    地址: '新北市鶯歌區南雅路34號36號1樓',
    縣市: '新北市'
  },
  {
    店號: 996121,
    店名: '連豐',
    地址: '新北市新店區大豐路12號',
    縣市: '新北市'
  },
  {
    店號: 996132,
    店名: '五華',
    地址: '新北市三重區五華街148號1.2樓，150號1樓',
    縣市: '新北市'
  },
  {
    店號: 996202,
    店名: '聖運',
    地址: '新北市土城區明德路二段157.159號',
    縣市: '新北市'
  },
  {
    店號: 996235,
    店名: '新樟樹',
    地址: '新北市汐止區樟樹二路255號',
    縣市: '新北市'
  },
  {
    店號: 996338,
    店名: '正大',
    地址: '新北市三重區中正北路235號',
    縣市: '新北市'
  },
  {
    店號: 996903,
    店名: '百和',
    地址: '新北市新店區中正路306號308號',
    縣市: '新北市'
  },
  {
    店號: 996969,
    店名: '天勝',
    地址: '新北市三重區仁愛街687號',
    縣市: '新北市'
  },
  {
    店號: 997962,
    店名: '橫溪',
    地址: '新北市三峽區溪北街109號',
    縣市: '新北市'
  },
  {
    店號: 998105,
    店名: '國瑞',
    地址: '新北市新莊區新樹路300號之5',
    縣市: '新北市'
  },
  {
    店號: 999854,
    店名: '金全',
    地址: '新北市金山區清水路52號',
    縣市: '新北市'
  },
  {
    店號: 110080,
    店名: '千禧',
    地址: '桃園市龜山區光峰路千禧新城15號1樓',
    縣市: '桃園市'
  },
  {
    店號: 110390,
    店名: '福冠',
    地址: '桃園市中壢區福州一街242號1樓及2樓',
    縣市: '桃園市'
  },
  {
    店號: 110909,
    店名: '翁武',
    地址: '桃園市大溪區民權東路149號',
    縣市: '桃園市'
  },
  {
    店號: 111175,
    店名: '大享',
    地址: '桃園市中壢區中正路1262號1樓',
    縣市: '桃園市'
  },
  {
    店號: 111289,
    店名: '台達電',
    地址: '桃園市龜山區山鶯路252號B1樓',
    縣市: '桃園市'
  },
  {
    店號: 111418,
    店名: '中同',
    地址: '桃園市中壢區大同路141號143號1樓',
    縣市: '桃園市'
  },
  {
    店號: 111522,
    店名: '文城',
    地址: '桃園市桃園區龍壽街273巷1號1樓',
    縣市: '桃園市'
  },
  {
    店號: 111614,
    店名: '凱華',
    地址: '桃園市龜山區文化二路183號1樓',
    縣市: '桃園市'
  },
  {
    店號: 111795,
    店名: '亞文',
    地址: '桃園市中壢區龍川街108號110號112號1樓',
    縣市: '桃園市'
  },
  {
    店號: 112293,
    店名: '龍昌',
    地址: '桃園市龍潭區大昌路二段139之1號',
    縣市: '桃園市'
  },
  {
    店號: 112329,
    店名: '海湖',
    地址: '桃園市蘆竹區濱海路一段40號42號',
    縣市: '桃園市'
  },
  {
    店號: 112592,
    店名: '雙榮',
    地址: '桃園市平鎮區雙連里民族路雙連三段8號1樓',
    縣市: '桃園市'
  },
  {
    店號: 112617,
    店名: '得寶',
    地址: '桃園市桃園區春日路1344號1346號',
    縣市: '桃園市'
  },
  {
    店號: 113045,
    店名: '全鎮',
    地址: '桃園市桃園區春日路238號240號1樓',
    縣市: '桃園市'
  },
  {
    店號: 113078,
    店名: '濱海',
    地址: '桃園市大園區竹圍里五鄰竹圍街45-3號',
    縣市: '桃園市'
  },
  {
    店號: 113344,
    店名: '大和園',
    地址: '桃園市大園區中山南路272號及272-1號1樓',
    縣市: '桃園市'
  },
  {
    店號: 113573,
    店名: '果林',
    地址: '桃園市大園區?林里?林路97號1樓',
    縣市: '桃園市'
  },
  {
    店號: 113702,
    店名: '高城',
    地址: '桃園市八德區高城八街58巷5號1樓',
    縣市: '桃園市'
  },
  {
    店號: 113735,
    店名: '亞都',
    地址: '桃園市大溪區僑愛一街72巷15號',
    縣市: '桃園市'
  },
  {
    店號: 113919,
    店名: '觀群',
    地址: '桃園市大園區大工路106號',
    縣市: '桃園市'
  },
  {
    店號: 114071,
    店名: '復華',
    地址: '桃園市中壢區中華路一段670號672號1樓',
    縣市: '桃園市'
  },
  {
    店號: 115971,
    店名: '廣興',
    地址: '桃園市平鎮區忠孝路69號1樓',
    縣市: '桃園市'
  },
  {
    店號: 116044,
    店名: '明福',
    地址: '桃園市八德區大明街105號107號',
    縣市: '桃園市'
  },
  {
    店號: 116055,
    店名: '青埔',
    地址: '桃園市中壢區青昇路257號1樓',
    縣市: '桃園市'
  },
  {
    店號: 116479,
    店名: '榮興',
    地址: '桃園市八德區榮興路1139號',
    縣市: '桃園市'
  },
  {
    店號: 117151,
    店名: '廣瀨',
    地址: '桃園市龜山區忠義路二段13號',
    縣市: '桃園市'
  },
  {
    店號: 118523,
    店名: '和氣',
    地址: '桃園市大溪區仁和路二段51號1樓',
    縣市: '桃園市'
  },
  {
    店號: 118648,
    店名: '華勛',
    地址: '桃園市中壢區華勛街191號193號',
    縣市: '桃園市'
  },
  {
    店號: 118682,
    店名: '華信',
    地址: '桃園市桃園區成功路一段47號',
    縣市: '桃園市'
  },
  {
    店號: 118693,
    店名: '楊梅',
    地址: '桃園市楊梅區楊新路73號',
    縣市: '桃園市'
  },
  {
    店號: 118903,
    店名: '峰里',
    地址: '桃園市大溪區復興路二段782號',
    縣市: '桃園市'
  },
  {
    店號: 118936,
    店名: '凱達',
    地址: '桃園市龜山區精忠里長壽路153號155號157號',
    縣市: '桃園市'
  },
  {
    店號: 119010,
    店名: '過嶺',
    地址: '桃園市中壢區民族路五段451號453號1樓',
    縣市: '桃園市'
  },
  {
    店號: 119087,
    店名: '信陽',
    地址: '桃園市龜山區公西里12鄰復興一路86號',
    縣市: '桃園市'
  },
  {
    店號: 119881,
    店名: '新街',
    地址: '桃園市中壢區環北路543號',
    縣市: '桃園市'
  },
  {
    店號: 120571,
    店名: '八福',
    地址: '桃園市八德區福國街76-1號',
    縣市: '桃園市'
  },
  {
    店號: 120607,
    店名: '青溪',
    地址: '桃園市桃園區自強路2號1樓與中山東路153號1樓',
    縣市: '桃園市'
  },
  {
    店號: 120917,
    店名: '頂湖',
    地址: '桃園市龜山區新興街240號242號244號1樓',
    縣市: '桃園市'
  },
  {
    店號: 121046,
    店名: '開南',
    地址: '桃園市蘆竹區新興街136號1樓',
    縣市: '桃園市'
  },
  {
    店號: 121448,
    店名: '富中',
    地址: '桃園市觀音區中山路二段925號',
    縣市: '桃園市'
  },
  {
    店號: 121725,
    店名: '有寶',
    地址: '桃園市桃園區寶山街209號1樓',
    縣市: '桃園市'
  },
  {
    店號: 121817,
    店名: '文漢',
    地址: '桃園市大溪區文化路188號',
    縣市: '桃園市'
  },
  {
    店號: 122072,
    店名: '新福街',
    地址: '桃園市中壢區福州二街392號1樓',
    縣市: '桃園市'
  },
  {
    店號: 122119,
    店名: '榮安',
    地址: '桃園市中壢區榮安十三街297號1樓及榮安十四街2號1樓',
    縣市: '桃園市'
  },
  {
    店號: 122142,
    店名: '高屋',
    地址: '桃園市中壢區民族路二段150號152號',
    縣市: '桃園市'
  },
  {
    店號: 122326,
    店名: '福記',
    地址: '桃園市中壢區林森路164號166號168號',
    縣市: '桃園市'
  },
  {
    店號: 122393,
    店名: '湧北',
    地址: '桃園市八德區東勇街396-1號',
    縣市: '桃園市'
  },
  {
    店號: 122647,
    店名: '樂高',
    地址: '桃園市龜山區文化七路85號1樓',
    縣市: '桃園市'
  },
  {
    店號: 122681,
    店名: '龍岡',
    地址: '桃園市中壢區龍東路508號510號1樓',
    縣市: '桃園市'
  },
  {
    店號: 122692,
    店名: '龍德',
    地址: '桃園市龍潭區中興路460號462號',
    縣市: '桃園市'
  },
  {
    店號: 122784,
    店名: '春寶',
    地址: '桃園市桃園區春日路670號1樓',
    縣市: '桃園市'
  },
  {
    店號: 122821,
    店名: '平東',
    地址: '桃園市平鎮區平東路225號227號229號1樓',
    縣市: '桃園市'
  },
  {
    店號: 122898,
    店名: '台達二',
    地址: '桃園市中壢區東園路3號B1樓',
    縣市: '桃園市'
  },
  {
    店號: 123282,
    店名: '秀才',
    地址: '桃園市楊梅區秀才路313號315號1樓',
    縣市: '桃園市'
  },
  {
    店號: 123547,
    店名: '大佶',
    地址: '桃園市桃園區三民路三段490號',
    縣市: '桃園市'
  },
  {
    店號: 123581,
    店名: '新台茂',
    地址: '桃園市蘆竹區南崁路一段135號',
    縣市: '桃園市'
  },
  {
    店號: 124506,
    店名: '茶專',
    地址: '桃園市龜山區萬壽路二段353號1樓',
    縣市: '桃園市'
  },
  {
    店號: 125923,
    店名: '桃德',
    地址: '桃園市八德區介壽路一段794號1樓',
    縣市: '桃園市'
  },
  {
    店號: 126317,
    店名: '蘆海',
    地址: '桃園市蘆竹區坑口里海山路一段76號一樓',
    縣市: '桃園市'
  },
  {
    店號: 126328,
    店名: '永安港',
    地址: '桃園市新屋區中山西路三段1148號',
    縣市: '桃園市'
  },
  {
    店號: 126454,
    店名: '海利',
    地址: '桃園市平鎮區上海路115號',
    縣市: '桃園市'
  },
  {
    店號: 126638,
    店名: '沙崙',
    地址: '桃園市大園區沙崙里國際路二段759號761號763號1樓',
    縣市: '桃園市'
  },
  {
    店號: 126889,
    店名: '吉福',
    地址: '桃園市蘆竹區吉林路167號1樓',
    縣市: '桃園市'
  },
  {
    店號: 126926,
    店名: '渴望村',
    地址: '桃園市龍潭區三和里渴望路428號',
    縣市: '桃園市'
  },
  {
    店號: 128656,
    店名: '來來',
    地址: '桃園市中壢區中央東路62號',
    縣市: '桃園市'
  },
  {
    店號: 129062,
    店名: '航興',
    地址: '桃園市蘆竹區中福里大興路233號1樓',
    縣市: '桃園市'
  },
  {
    店號: 129305,
    店名: '新壢',
    地址: '桃園市中壢區日新路66號68號',
    縣市: '桃園市'
  },
  {
    店號: 130006,
    店名: '楊展',
    地址: '桃園市楊梅區校前路312號316號1樓',
    縣市: '桃園市'
  },
  {
    店號: 130017,
    店名: '慈德',
    地址: '桃園市桃園區慈德街53號55號57號',
    縣市: '桃園市'
  },
  {
    店號: 130039,
    店名: '龜山銘',
    地址: '桃園市龜山區德明路152號154號1樓',
    縣市: '桃園市'
  },
  {
    店號: 130176,
    店名: '原大',
    地址: '桃園市中壢區實踐路46號',
    縣市: '桃園市'
  },
  {
    店號: 130213,
    店名: '國航',
    地址: '桃園市大園區國際路一段300-1號1樓',
    縣市: '桃園市'
  },
  {
    店號: 130257,
    店名: '金陵',
    地址: '桃園市平鎮區金陵路76號78號1樓',
    縣市: '桃園市'
  },
  {
    店號: 130556,
    店名: '立莊',
    地址: '桃園市中壢區莊敬路805號',
    縣市: '桃園市'
  },
  {
    店號: 130648,
    店名: '學央',
    地址: '桃園市平鎮區中央路187號',
    縣市: '桃園市'
  },
  {
    店號: 130659,
    店名: '金帝寶',
    地址: '桃園市新屋區中山東路一段106號',
    縣市: '桃園市'
  },
  {
    店號: 130729,
    店名: '韻翔',
    地址: '桃園市平鎮區文化街71號1樓',
    縣市: '桃園市'
  },
  {
    店號: 130741,
    店名: '崴正',
    地址: '桃園市桃園區中正五街137號139號1樓',
    縣市: '桃園市'
  },
  {
    店號: 130822,
    店名: '統壢',
    地址: '桃園市中壢區定寧路15號',
    縣市: '桃園市'
  },
  {
    店號: 130899,
    店名: '文中',
    地址: '桃園市桃園區文中路65號1樓',
    縣市: '桃園市'
  },
  {
    店號: 130903,
    店名: '盧長',
    地址: '桃園市蘆竹區南山路二段183號1樓',
    縣市: '桃園市'
  },
  {
    店號: 131076,
    店名: '新梅',
    地址: '桃園市楊梅區新農街469-8號469-9號1樓',
    縣市: '桃園市'
  },
  {
    店號: 131168,
    店名: '民大',
    地址: '桃園市桃園區大興路221號1樓',
    縣市: '桃園市'
  },
  {
    店號: 131467,
    店名: '大傳',
    地址: '桃園市龜山區大同路357號357-1號1樓及壽山段926地號',
    縣市: '桃園市'
  },
  {
    店號: 131607,
    店名: '體育大',
    地址: '桃園市龜山區文化一路250號',
    縣市: '桃園市'
  },
  {
    店號: 131700,
    店名: '海華',
    地址: '桃園市中壢區慈惠三街152號154號',
    縣市: '桃園市'
  },
  {
    店號: 131906,
    店名: '富崗',
    地址: '桃園市楊梅區新明街450號',
    縣市: '桃園市'
  },
  {
    店號: 132323,
    店名: '速達',
    地址: '桃園市中壢區新生路二段378之2號',
    縣市: '桃園市'
  },
  {
    店號: 132378,
    店名: '長榮航',
    地址: '桃園市蘆竹區新南路一段376號',
    縣市: '桃園市'
  },
  {
    店號: 132437,
    店名: '慶和',
    地址: '桃園市中壢區後寮一路140號142號1樓',
    縣市: '桃園市'
  },
  {
    店號: 133061,
    店名: '景竹',
    地址: '桃園市蘆竹區南竹路五段200號1樓',
    縣市: '桃園市'
  },
  {
    店號: 135252,
    店名: '新莊伯',
    地址: '桃園市桃園區莊敬路一段175號177號1樓',
    縣市: '桃園市'
  },
  {
    店號: 135713,
    店名: '勝壢',
    地址: '桃園市中壢區中央西路一段一號一樓',
    縣市: '桃園市'
  },
  {
    店號: 136314,
    店名: '錦明',
    地址: '桃園市蘆竹區光明路二段102號1樓',
    縣市: '桃園市'
  },
  {
    店號: 136495,
    店名: '立國',
    地址: '桃園市桃園區中山東路51號1樓',
    縣市: '桃園市'
  },
  {
    店號: 136864,
    店名: '祥鋐',
    地址: '桃園市平鎮區金陵路三段74號76號',
    縣市: '桃園市'
  },
  {
    店號: 137661,
    店名: '新屋山',
    地址: '桃園市新屋區新屋里中山路288號',
    縣市: '桃園市'
  },
  {
    店號: 137867,
    店名: '紅蕃茄',
    地址: '桃園市桃園區復興路83號85號',
    縣市: '桃園市'
  },
  {
    店號: 137948,
    店名: '美壢',
    地址: '桃園市中壢區中美路二段72號',
    縣市: '桃園市'
  },
  {
    店號: 138000,
    店名: '鴻臣',
    地址: '桃園市龜山區楓樹里忠義路一段870-1號',
    縣市: '桃園市'
  },
  {
    店號: 138103,
    店名: '國仲',
    地址: '桃園市桃園區中德里國際路一段538號',
    縣市: '桃園市'
  },
  {
    店號: 138192,
    店名: '蘆工',
    地址: '桃園市蘆竹區中興路97號1樓',
    縣市: '桃園市'
  },
  {
    店號: 138273,
    店名: '千雄',
    地址: '桃園市蘆竹區南崁路二段96號',
    縣市: '桃園市'
  },
  {
    店號: 138538,
    店名: '三光',
    地址: '桃園市中壢區中央西路二段259號259-1號1樓',
    縣市: '桃園市'
  },
  {
    店號: 138608,
    店名: '觀湖',
    地址: '桃園市觀音區濱海路廣興段132號',
    縣市: '桃園市'
  },
  {
    店號: 138642,
    店名: '山興',
    地址: '桃園市龜山區明興街223號225號1樓',
    縣市: '桃園市'
  },
  {
    店號: 138664,
    店名: '樂善',
    地址: '桃園市龜山區文明路131號1樓',
    縣市: '桃園市'
  },
  {
    店號: 138712,
    店名: '崴盛',
    地址: '桃園市桃園區慈文路51號;正康三街284號',
    縣市: '桃園市'
  },
  {
    店號: 138790,
    店名: '瑞豐',
    地址: '桃園市楊梅區瑞原里民富路三段22號24號',
    縣市: '桃園市'
  },
  {
    店號: 138963,
    店名: '新中北',
    地址: '桃園市中壢區新中北路1018-1號1樓',
    縣市: '桃園市'
  },
  {
    店號: 138985,
    店名: '辰興',
    地址: '桃園市桃園區大興西路一段178號1樓新埔五街83號85號1樓',
    縣市: '桃園市'
  },
  {
    店號: 139069,
    店名: '觀埔',
    地址: '桃園市觀音區藍埔里新華路一段488號',
    縣市: '桃園市'
  },
  {
    店號: 139210,
    店名: '瑞元',
    地址: '桃園市蘆竹區長春路87號',
    縣市: '桃園市'
  },
  {
    店號: 139287,
    店名: '翁京',
    地址: '桃園市平鎮區中豐路南勢二段118號',
    縣市: '桃園市'
  },
  {
    店號: 141187,
    店名: '楊功',
    地址: '桃園市楊梅區瑞溪路二段162號1樓',
    縣市: '桃園市'
  },
  {
    店號: 141235,
    店名: '北原',
    地址: '桃園市中壢區新中北路239號241號1樓',
    縣市: '桃園市'
  },
  {
    店號: 141280,
    店名: '豐彩',
    地址: '桃園市龍潭區中豐路398號1樓',
    縣市: '桃園市'
  },
  {
    店號: 141453,
    店名: '聖央',
    地址: '桃園市中壢區中央西路一段78號1樓',
    縣市: '桃園市'
  },
  {
    店號: 141660,
    店名: '忠敬',
    地址: '桃園市中壢區精忠一街1號1樓',
    縣市: '桃園市'
  },
  {
    店號: 141811,
    店名: '福利國',
    地址: '桃園市桃園區同德六街170號1樓',
    縣市: '桃園市'
  },
  {
    店號: 141970,
    店名: '新龜山',
    地址: '桃園市龜山區萬壽路二段1170號',
    縣市: '桃園市'
  },
  {
    店號: 142124,
    店名: '世傳',
    地址: '桃園市八德區和平路122號126號1樓',
    縣市: '桃園市'
  },
  {
    店號: 142157,
    店名: '新桃林',
    地址: '桃園市桃園區延平路4號6號1樓',
    縣市: '桃園市'
  },
  {
    店號: 142272,
    店名: '高尚',
    地址: '桃園市楊梅區梅高路二段136巷5號',
    縣市: '桃園市'
  },
  {
    店號: 142353,
    店名: '觀富',
    地址: '桃園市觀音區新富路701號1樓',
    縣市: '桃園市'
  },
  {
    店號: 142375,
    店名: '富寓',
    地址: '桃園市龜山區文德路80號82號',
    縣市: '桃園市'
  },
  {
    店號: 142401,
    店名: '龍功',
    地址: '桃園市龍潭區成功路186之1號',
    縣市: '桃園市'
  },
  {
    店號: 142548,
    店名: '海帝',
    地址: '桃園市中壢區元化路307號1樓',
    縣市: '桃園市'
  },
  {
    店號: 142582,
    店名: '智勝',
    地址: '桃園市桃園區桃智路1號3號1樓',
    縣市: '桃園市'
  },
  {
    店號: 142663,
    店名: '謙悅',
    地址: '桃園市桃園區新埔六街58號60號1樓',
    縣市: '桃園市'
  },
  {
    店號: 143356,
    店名: '漢豐',
    地址: '桃園市桃園區漢中街146號1樓',
    縣市: '桃園市'
  },
  {
    店號: 143529,
    店名: '高義',
    地址: '桃園市平鎮區復旦路二段211巷10號1樓',
    縣市: '桃園市'
  },
  {
    店號: 143781,
    店名: '龍潭',
    地址: '桃園市龍潭區東龍路257號259號1樓',
    縣市: '桃園市'
  },
  {
    店號: 144072,
    店名: '鈺朋',
    地址: '桃園市桃園區莊敬路二段105號1樓',
    縣市: '桃園市'
  },
  {
    店號: 144223,
    店名: '龍園',
    地址: '桃園市大溪區石園路615號(營登-桃園市龍潭區中正路佳安段481號)',
    縣市: '桃園市'
  },
  {
    店號: 144267,
    店名: '桃中',
    地址: '桃園市桃園區中正路233號1樓',
    縣市: '桃園市'
  },
  {
    店號: 144728,
    店名: '精材',
    地址: '桃園市中壢區吉林路23號B1樓',
    縣市: '桃園市'
  },
  {
    店號: 144751,
    店名: '鑫帝標',
    地址: '桃園市桃園區龍泉二街65號龍城五街66.68號1樓',
    縣市: '桃園市'
  },
  {
    店號: 144773,
    店名: '森壢',
    地址: '桃園市中壢區新興里2鄰林森路30號1樓',
    縣市: '桃園市'
  },
  {
    店號: 146540,
    店名: '長業',
    地址: '桃園市中壢區長春路23號',
    縣市: '桃園市'
  },
  {
    店號: 147967,
    店名: '上華',
    地址: '桃園市龍潭區中正路上華段6號',
    縣市: '桃園市'
  },
  {
    店號: 148269,
    店名: '冠桃園',
    地址: '桃園市桃園區中泰里國際路一段1179號',
    縣市: '桃園市'
  },
  {
    店號: 148742,
    店名: '吉利',
    地址: '桃園市中壢區吉林二路83巷30號32號34號',
    縣市: '桃園市'
  },
  {
    店號: 148775,
    店名: '華亞',
    地址: '桃園市龜山區文化二路43號',
    縣市: '桃園市'
  },
  {
    店號: 148801,
    店名: '欣高',
    地址: '桃園市楊梅區楊梅里文德路1號1樓梅高路52-9號',
    縣市: '桃園市'
  },
  {
    店號: 149295,
    店名: '航福',
    地址: '桃園市蘆竹區南福街97號99號',
    縣市: '桃園市'
  },
  {
    店號: 149491,
    店名: '勇伯',
    地址: '桃園市八德區東勇北路380號',
    縣市: '桃園市'
  },
  {
    店號: 150907,
    店名: '光北',
    地址: '桃園市桃園區中山北路42號1樓及地下1樓',
    縣市: '桃園市'
  },
  {
    店號: 151025,
    店名: '樂購',
    地址: '桃園市蘆竹區五福一路41號1樓',
    縣市: '桃園市'
  },
  {
    店號: 151058,
    店名: '雙橡園',
    地址: '桃園市大溪區僑愛里介壽路210號',
    縣市: '桃園市'
  },
  {
    店號: 151689,
    店名: '楊昌',
    地址: '桃園市楊梅區楊新北路23號',
    縣市: '桃園市'
  },
  {
    店號: 151771,
    店名: '楊山',
    地址: '桃園市楊梅區中山南路98號100號1樓',
    縣市: '桃園市'
  },
  {
    店號: 151782,
    店名: '健業',
    地址: '桃園市桃園區健行路88號',
    縣市: '桃園市'
  },
  {
    店號: 151900,
    店名: '柏魁',
    地址: '桃園市龜山區振興路1021之1號',
    縣市: '桃園市'
  },
  {
    店號: 152017,
    店名: '瑞揚',
    地址: '桃園市楊梅區新成路97號',
    縣市: '桃園市'
  },
  {
    店號: 152084,
    店名: '鼎桃',
    地址: '桃園市桃園區宏昌六街281號1樓',
    縣市: '桃園市'
  },
  {
    店號: 152109,
    店名: '航宏',
    地址: '桃園市蘆竹區蘆竹里蘆竹街256號一樓',
    縣市: '桃園市'
  },
  {
    店號: 153434,
    店名: '龍科',
    地址: '桃園市龍潭區龍科街228號B1',
    縣市: '桃園市'
  },
  {
    店號: 153445,
    店名: '統文',
    地址: '桃園市龜山區文化七路179號1樓',
    縣市: '桃園市'
  },
  {
    店號: 153467,
    店名: '蘆豐',
    地址: '桃園市蘆竹區南山路二段48號1樓',
    縣市: '桃園市'
  },
  {
    店號: 153478,
    店名: '陸光',
    地址: '桃園市龜山區陸光路83號85號1樓',
    縣市: '桃園市'
  },
  {
    店號: 153490,
    店名: '祥櫂',
    地址: '桃園市龜山區萬壽路二段97號',
    縣市: '桃園市'
  },
  {
    店號: 153515,
    店名: '江海',
    地址: '桃園市大園區中正東路三段343號',
    縣市: '桃園市'
  },
  {
    店號: 153559,
    店名: '創薪',
    地址: '桃園市中壢區龍昌路270號1號',
    縣市: '桃園市'
  },
  {
    店號: 153560,
    店名: '多利',
    地址: '桃園市新屋區中山東路二段760號1樓',
    縣市: '桃園市'
  },
  {
    店號: 153593,
    店名: '元勛',
    地址: '桃園市中壢區晉元路195號1樓',
    縣市: '桃園市'
  },
  {
    店號: 153618,
    店名: '台積Q',
    地址: '桃園市龍潭區龍園六路101號2樓',
    縣市: '桃園市'
  },
  {
    店號: 153995,
    店名: '京利',
    地址: '桃園市平鎮區南京路206號',
    縣市: '桃園市'
  },
  {
    店號: 154024,
    店名: '富寶',
    地址: '桃園市平鎮區新富五街9號1樓',
    縣市: '桃園市'
  },
  {
    店號: 154116,
    店名: '大崙',
    地址: '桃園市中壢區中正路四段35號',
    縣市: '桃園市'
  },
  {
    店號: 154208,
    店名: '玉興',
    地址: '桃園市大園區華興路一段1號1樓.和平西路145號2樓',
    縣市: '桃園市'
  },
  {
    店號: 154677,
    店名: '瓏門',
    地址: '桃園市中壢區龍昌路538號1樓',
    縣市: '桃園市'
  },
  {
    店號: 154725,
    店名: '埔子',
    地址: '桃園市桃園區永安路1040號1040之1號1樓',
    縣市: '桃園市'
  },
  {
    店號: 154736,
    店名: '笙園',
    地址: '桃園市中壢區新生路738號740號742號1樓',
    縣市: '桃園市'
  },
  {
    店號: 154747,
    店名: '東洸',
    地址: '桃園市平鎮區平東路27號東光路16之1號1樓',
    縣市: '桃園市'
  },
  {
    店號: 154895,
    店名: '航海',
    地址: '桃園市蘆竹區南山路一段175之1號1樓',
    縣市: '桃園市'
  },
  {
    店號: 155326,
    店名: '大新',
    地址: '桃園市觀音區大觀路二段65號67號',
    縣市: '桃園市'
  },
  {
    店號: 155337,
    店名: '中天',
    地址: '桃園市中壢區石頭里中和路184號1樓',
    縣市: '桃園市'
  },
  {
    店號: 155359,
    店名: '芯德',
    地址: '桃園市大溪區復興路186號1樓188號1至2樓',
    縣市: '桃園市'
  },
  {
    店號: 155430,
    店名: '大有',
    地址: '桃園市桃園區大有路547號1樓',
    縣市: '桃園市'
  },
  {
    店號: 158358,
    店名: '大中原',
    地址: '桃園市中壢區新中北路151號151-1號一樓',
    縣市: '桃園市'
  },
  {
    店號: 158370,
    店名: '鶯明',
    地址: '桃園市桃園區桃鶯路251號',
    縣市: '桃園市'
  },
  {
    店號: 158543,
    店名: '寶麗',
    地址: '桃園市平鎮區湧安里自由街57號59號61號63號',
    縣市: '桃園市'
  },
  {
    店號: 158750,
    店名: '柏德',
    地址: '桃園市中壢區中北路158號1樓',
    縣市: '桃園市'
  },
  {
    店號: 158967,
    店名: '豐利',
    地址: '桃園市中壢區南園二路63號',
    縣市: '桃園市'
  },
  {
    店號: 159041,
    店名: '金權',
    地址: '桃園市中壢區光明里中央西路二段49號',
    縣市: '桃園市'
  },
  {
    店號: 159063,
    店名: '健行',
    地址: '桃園市中壢區健行路230號1樓',
    縣市: '桃園市'
  },
  {
    店號: 159188,
    店名: '中孝',
    地址: '桃園市中壢區忠孝路248號1樓2樓',
    縣市: '桃園市'
  },
  {
    店號: 159351,
    店名: '新桃府',
    地址: '桃園市桃園區縣府路312號312之1號',
    縣市: '桃園市'
  },
  {
    店號: 159410,
    店名: '凱成',
    地址: '桃園市楊梅區文化街220號222號222-1號',
    縣市: '桃園市'
  },
  {
    店號: 160018,
    店名: '興圓',
    地址: '桃園市八德區長興路76號1樓',
    縣市: '桃園市'
  },
  {
    店號: 160100,
    店名: '達昇',
    地址: '桃園市大園區大觀路525號527號1樓',
    縣市: '桃園市'
  },
  {
    店號: 160155,
    店名: '東勇',
    地址: '桃園市八德區東勇街83號',
    縣市: '桃園市'
  },
  {
    店號: 162922,
    店名: '澄和',
    地址: '桃園市桃園區大業路一段277號1樓',
    縣市: '桃園市'
  },
  {
    店號: 163590,
    店名: '楊興',
    地址: '桃園市楊梅區楊新路三段331號333號',
    縣市: '桃園市'
  },
  {
    店號: 163660,
    店名: '成皇',
    地址: '桃園市桃園區復興路80號',
    縣市: '桃園市'
  },
  {
    店號: 163752,
    店名: '蘆勝',
    地址: '桃園市蘆竹區忠孝西路21號1樓',
    縣市: '桃園市'
  },
  {
    店號: 163763,
    店名: '宏龍',
    地址: '桃園市龍潭區中原路二段393號1樓',
    縣市: '桃園市'
  },
  {
    店號: 163970,
    店名: '壢都',
    地址: '桃園市中壢區長沙路131號成都路72號',
    縣市: '桃園市'
  },
  {
    店號: 164135,
    店名: '光壢',
    地址: '桃園市中壢區莒光路35號1樓',
    縣市: '桃園市'
  },
  {
    店號: 164607,
    店名: '驊豐',
    地址: '桃園市桃園區建國路101號1樓',
    縣市: '桃園市'
  },
  {
    店號: 164674,
    店名: '興武',
    地址: '桃園市桃園區復興路239之1號1樓;241號1樓',
    縣市: '桃園市'
  },
  {
    店號: 164711,
    店名: '新田園',
    地址: '桃園市大園區新興路62號',
    縣市: '桃園市'
  },
  {
    店號: 165024,
    店名: '福瑞',
    地址: '桃園市中壢區信義里福州路201號',
    縣市: '桃園市'
  },
  {
    店號: 165046,
    店名: '易仕',
    地址: '桃園市龍潭區中豐路695巷2-1號',
    縣市: '桃園市'
  },
  {
    店號: 165105,
    店名: '捷安',
    地址: '桃園市八德區興豐路689號1樓',
    縣市: '桃園市'
  },
  {
    店號: 165219,
    店名: '成達',
    地址: '桃園市平鎮區育達路136號',
    縣市: '桃園市'
  },
  {
    店號: 165529,
    店名: '學屋',
    地址: '桃園市中壢區民族路三段402號406號',
    縣市: '桃園市'
  },
  {
    店號: 165884,
    店名: '大椿',
    地址: '桃園市桃園區春日路1193號1樓',
    縣市: '桃園市'
  },
  {
    店號: 166429,
    店名: '長運',
    地址: '桃園市龜山區長青路7號C棟B1樓',
    縣市: '桃園市'
  },
  {
    店號: 166463,
    店名: '藝德',
    地址: '桃園市桃園區同德十一街98號100號',
    縣市: '桃園市'
  },
  {
    店號: 166485,
    店名: '環興',
    地址: '桃園市平鎮區環南路188號1 樓',
    縣市: '桃園市'
  },
  {
    店號: 166496,
    店名: '富證',
    地址: '桃園市楊梅區中正路80號82號1樓',
    縣市: '桃園市'
  },
  {
    店號: 166670,
    店名: '日日興',
    地址: '桃園市新屋區中山西路一段280巷20號',
    縣市: '桃園市'
  },
  {
    店號: 166681,
    店名: '富亨',
    地址: '桃園市龜山區文青路206號208號210號1樓',
    縣市: '桃園市'
  },
  {
    店號: 166773,
    店名: '廣隆',
    地址: '桃園市八德區廣興路195號',
    縣市: '桃園市'
  },
  {
    店號: 166887,
    店名: '城邑',
    地址: '桃園市大園區高鐵北路二段186號188號1樓',
    縣市: '桃園市'
  },
  {
    店號: 166935,
    店名: '豐德',
    地址: '桃園市八德區永豐路605號1樓',
    縣市: '桃園市'
  },
  {
    店號: 167145,
    店名: '金富多',
    地址: '桃園市桃園區寶慶路470號1樓',
    縣市: '桃園市'
  },
  {
    店號: 167341,
    店名: '成龍',
    地址: '桃園市中壢區龍岡路三段192號194號196號1樓',
    縣市: '桃園市'
  },
  {
    店號: 167363,
    店名: '瑞星',
    地址: '桃園市八德區介壽路二段616號618號1樓',
    縣市: '桃園市'
  },
  {
    店號: 167396,
    店名: '福國',
    地址: '桃園市八德區福國北街48號50號1樓',
    縣市: '桃園市'
  },
  {
    店號: 167503,
    店名: '觀湘',
    地址: '桃園市觀音區忠孝路767號1樓',
    縣市: '桃園市'
  },
  {
    店號: 167514,
    店名: '自強一',
    地址: '桃園市中壢區自強一路65號67號69號',
    縣市: '桃園市'
  },
  {
    店號: 167536,
    店名: '尚國',
    地址: '桃園市桃園區國強一街218號220號1樓',
    縣市: '桃園市'
  },
  {
    店號: 167628,
    店名: '振裕',
    地址: '桃園市八德區福德一路54號',
    縣市: '桃園市'
  },
  {
    店號: 167639,
    店名: '福龍',
    地址: '桃園市平鎮區福龍路一段556號',
    縣市: '桃園市'
  },
  {
    店號: 167695,
    店名: '鳳儀',
    地址: '桃園市蘆竹區南崁路二段285號1樓',
    縣市: '桃園市'
  },
  {
    店號: 167879,
    店名: '富勝',
    地址: '桃園市龜山區文學路250號1樓',
    縣市: '桃園市'
  },
  {
    店號: 169820,
    店名: '武青',
    地址: '桃園市大園區五青路287號289號1樓',
    縣市: '桃園市'
  },
  {
    店號: 170462,
    店名: '新貴中',
    地址: '桃園市平鎮區新貴里中豐路一段98號1樓',
    縣市: '桃園市'
  },
  {
    店號: 170956,
    店名: '新虎山',
    地址: '桃園市桃園區成功路三段50號52號1樓',
    縣市: '桃園市'
  },
  {
    店號: 171339,
    店名: '瓏慈',
    地址: '桃園市中壢區龍慈路712號716號718號1樓',
    縣市: '桃園市'
  },
  {
    店號: 171694,
    店名: '正麗',
    地址: '桃園市桃園區莊一街11號13號1樓',
    縣市: '桃園市'
  },
  {
    店號: 171753,
    店名: '新桃行',
    地址: '桃園市桃園區力行路7號',
    縣市: '桃園市'
  },
  {
    店號: 173678,
    店名: '正康',
    地址: '桃園市桃園區民光路49號',
    縣市: '桃園市'
  },
  {
    店號: 173818,
    店名: '忠新',
    地址: '桃園市大溪區大鶯路1539-1號',
    縣市: '桃園市'
  },
  {
    店號: 173896,
    店名: '頭寮',
    地址: '桃園市大溪區復興路一段902之1及906號1樓',
    縣市: '桃園市'
  },
  {
    店號: 174132,
    店名: '德隆',
    地址: '桃園市八德區永豐路408號410號1樓',
    縣市: '桃園市'
  },
  {
    店號: 174338,
    店名: '嘉美',
    地址: '桃園市蘆竹區大新路454.456號1樓',
    縣市: '桃園市'
  },
  {
    店號: 174501,
    店名: '志廣',
    地址: '桃園市中壢區志廣路107號109號1樓2樓',
    縣市: '桃園市'
  },
  {
    店號: 174671,
    店名: '鎮宮',
    地址: '桃園市平鎮區中山路233號235號237號1樓',
    縣市: '桃園市'
  },
  {
    店號: 174774,
    店名: '廣城',
    地址: '桃園市平鎮區廣達里廣平街20號24號1樓',
    縣市: '桃園市'
  },
  {
    店號: 174800,
    店名: '觀濤',
    地址: '桃園市觀音區樹林里民權路1號',
    縣市: '桃園市'
  },
  {
    店號: 174914,
    店名: '內海',
    地址: '桃園市大園區民生路183號1樓',
    縣市: '桃園市'
  },
  {
    店號: 174936,
    店名: '莊正',
    地址: '桃園市桃園區莊二街148號1樓',
    縣市: '桃園市'
  },
  {
    店號: 179562,
    店名: '八德介',
    地址: '桃園市八德區介壽路二段216號218號1樓',
    縣市: '桃園市'
  },
  {
    店號: 179584,
    店名: '桃醫',
    地址: '桃園市桃園區中山路1492號',
    縣市: '桃園市'
  },
  {
    店號: 179676,
    店名: '北勢',
    地址: '桃園市新屋區中山東路一段745號',
    縣市: '桃園市'
  },
  {
    店號: 179997,
    店名: '高萱',
    地址: '桃園市中壢區高鐵南路二段369號1樓',
    縣市: '桃園市'
  },
  {
    店號: 180001,
    店名: '環埔',
    地址: '桃園市中壢區領航北路一段281號1樓',
    縣市: '桃園市'
  },
  {
    店號: 180089,
    店名: '亮亞',
    地址: '桃園市蘆竹區大福路189號',
    縣市: '桃園市'
  },
  {
    店號: 180115,
    店名: '慈中',
    地址: '桃園市桃園區中正路820號1樓2樓',
    縣市: '桃園市'
  },
  {
    店號: 180207,
    店名: '興榮珍',
    地址: '桃園市中壢區興仁路二段200之1號;198巷1之3號1樓',
    縣市: '桃園市'
  },
  {
    店號: 180252,
    店名: '美光一',
    地址: '桃園市龜山區復興三路667號一廠5樓',
    縣市: '桃園市'
  },
  {
    店號: 180285,
    店名: '千富',
    地址: '桃園市蘆竹區長安路二段220號222號1樓',
    縣市: '桃園市'
  },
  {
    店號: 180377,
    店名: '萬龍',
    地址: '桃園市龜山區萬壽路一段307號309號1樓',
    縣市: '桃園市'
  },
  {
    店號: 180470,
    店名: '尚群',
    地址: '桃園市八德區中山路181號',
    縣市: '桃園市'
  },
  {
    店號: 180481,
    店名: '福厚',
    地址: '桃園市八德區興仁里建德路229號',
    縣市: '桃園市'
  },
  {
    店號: 180573,
    店名: '國力',
    地址: '桃園市桃園區國際路二段426號428號1樓',
    縣市: '桃園市'
  },
  {
    店號: 180609,
    店名: '青禾',
    地址: '桃園市中壢區高鐵站前西路二段96號1樓',
    縣市: '桃園市'
  },
  {
    店號: 180735,
    店名: '建發',
    地址: '桃園市龜山區南上里8鄰民生北路一段516號1樓',
    縣市: '桃園市'
  },
  {
    店號: 180975,
    店名: '興豐',
    地址: '桃園市八德區興豐路418號',
    縣市: '桃園市'
  },
  {
    店號: 181026,
    店名: '榮躍',
    地址: '桃園市中壢區榮民南路462號464號',
    縣市: '桃園市'
  },
  {
    店號: 181141,
    店名: '桃捷',
    地址: '桃園市蘆竹區南山路三段98號100號1樓2樓',
    縣市: '桃園市'
  },
  {
    店號: 181222,
    店名: '東凌',
    地址: '桃園市八德區中正路112號116號',
    縣市: '桃園市'
  },
  {
    店號: 181462,
    店名: '航明',
    地址: '桃園市蘆竹區南山路二段497號1樓',
    縣市: '桃園市'
  },
  {
    店號: 181509,
    店名: '遠雄',
    地址: '桃園市大園區航翔路5之7號1樓',
    縣市: '桃園市'
  },
  {
    店號: 181554,
    店名: '盛烽',
    地址: '桃園市新屋區梅高路三段310之6號',
    縣市: '桃園市'
  },
  {
    店號: 182188,
    店名: '新武陵',
    地址: '桃園市桃園區上海路82號84號江南八街49號',
    縣市: '桃園市'
  },
  {
    店號: 182225,
    店名: '迎和',
    地址: '桃園市八德區金和路52號',
    縣市: '桃園市'
  },
  {
    店號: 182384,
    店名: '榮豐',
    地址: '桃園市八德區興豐路2168號',
    縣市: '桃園市'
  },
  {
    店號: 182487,
    店名: '寶勇',
    地址: '桃園市平鎮區湧光路455號457號459號1樓',
    縣市: '桃園市'
  },
  {
    店號: 182580,
    店名: '銅鑼圈',
    地址: '桃園市龍潭區中豐路高平段402之1號1樓',
    縣市: '桃園市'
  },
  {
    店號: 182775,
    店名: '航林',
    地址: '桃園市大園區三民路二段626號1樓',
    縣市: '桃園市'
  },
  {
    店號: 182801,
    店名: '南山北',
    地址: '桃園市蘆竹區南山北路二段426號1樓',
    縣市: '桃園市'
  },
  {
    店號: 182823,
    店名: '富丞',
    地址: '桃園市蘆竹區中正北路599號',
    縣市: '桃園市'
  },
  {
    店號: 182834,
    店名: '緯華',
    地址: '桃園市龜山區文化二路34巷14弄12號14號1樓',
    縣市: '桃園市'
  },
  {
    店號: 182889,
    店名: '映竹',
    地址: '桃園市蘆竹區南竹路四段250號1樓',
    縣市: '桃園市'
  },
  {
    店號: 182937,
    店名: '美家',
    地址: '桃園市中壢區中北路34號36號1樓',
    縣市: '桃園市'
  },
  {
    店號: 183044,
    店名: '進三廠',
    地址: '桃園市蘆竹區長榮路168號4樓',
    縣市: '桃園市'
  },
  {
    店號: 183251,
    店名: '羿龍',
    地址: '桃園市中壢區龍慈路283號1樓',
    縣市: '桃園市'
  },
  {
    店號: 183273,
    店名: '貴族',
    地址: '桃園市桃園區南平路306號1樓',
    縣市: '桃園市'
  },
  {
    店號: 183527,
    店名: '振陞',
    地址: '桃園市龜山區振興路1301號1樓',
    縣市: '桃園市'
  },
  {
    店號: 183583,
    店名: '湖海',
    地址: '桃園市蘆竹區濱海路一段335號337號1樓',
    縣市: '桃園市'
  },
  {
    店號: 183653,
    店名: '桃全',
    地址: '桃園市桃園區中正路342號1樓2樓',
    縣市: '桃園市'
  },
  {
    店號: 183745,
    店名: '凱利',
    地址: '桃園市平鎮區延平路三段413號415號417號1樓',
    縣市: '桃園市'
  },
  {
    店號: 183974,
    店名: '萬能科',
    地址: '桃園市中壢區萬能路1之2號1樓',
    縣市: '桃園市'
  },
  {
    店號: 184014,
    店名: '市正',
    地址: '桃園市桃園區縣府路88之1號1樓2樓',
    縣市: '桃園市'
  },
  {
    店號: 184058,
    店名: '合利',
    地址: '桃園市楊梅區楊湖路二段910號912號914號',
    縣市: '桃園市'
  },
  {
    店號: 184232,
    店名: '星宇',
    地址: '桃園市桃園區永安路739號1樓',
    縣市: '桃園市'
  },
  {
    店號: 184287,
    店名: '航站南',
    地址: '桃園市大園區航站南路15號B1樓',
    縣市: '桃園市'
  },
  {
    店號: 184298,
    店名: '航站北',
    地址: '桃園市大園區航站南路15號B1樓',
    縣市: '桃園市'
  },
  {
    店號: 184449,
    店名: '立揚',
    地址: '桃園市桃園區正光路116號1樓',
    縣市: '桃園市'
  },
  {
    店號: 184601,
    店名: '技嘉',
    地址: '桃園市平鎮區南平路180之1號',
    縣市: '桃園市'
  },
  {
    店號: 184612,
    店名: '凌雲',
    地址: '桃園市龍潭區中豐路上林段358-1號',
    縣市: '桃園市'
  },
  {
    店號: 184922,
    店名: '新九揚',
    地址: '桃園市龜山區復興一路264號1樓',
    縣市: '桃園市'
  },
  {
    店號: 185109,
    店名: '新壢智',
    地址: '桃園市中壢區興仁路二段57號1樓',
    縣市: '桃園市'
  },
  {
    店號: 185291,
    店名: '萬壽',
    地址: '桃園市龜山區萬壽路二段1057號1樓',
    縣市: '桃園市'
  },
  {
    店號: 185431,
    店名: '桃匯',
    地址: '桃園市桃園區國際路二段557號559號1樓',
    縣市: '桃園市'
  },
  {
    店號: 185855,
    店名: '愿景',
    地址: '桃園市龜山區文化一路42號',
    縣市: '桃園市'
  },
  {
    店號: 185981,
    店名: '新楊埔',
    地址: '桃園市楊梅區中興路47號1樓新興街66號1樓',
    縣市: '桃園市'
  },
  {
    店號: 186021,
    店名: '東正',
    地址: '桃園市平鎮區平東路661號',
    縣市: '桃園市'
  },
  {
    店號: 186250,
    店名: '工業',
    地址: '桃園市中壢區吉林路131號1樓',
    縣市: '桃園市'
  },
  {
    店號: 186283,
    店名: '宏義',
    地址: '桃園市龜山區萬壽路一段378號380號1樓',
    縣市: '桃園市'
  },
  {
    店號: 186962,
    店名: '新達豐',
    地址: '桃園市桃園區延平路202號;大豐路194號',
    縣市: '桃園市'
  },
  {
    店號: 187002,
    店名: '巴頓',
    地址: '桃園市龜山區龍壽里萬壽路一段492號1樓',
    縣市: '桃園市'
  },
  {
    店號: 187301,
    店名: '新鎮興',
    地址: '桃園市平鎮區中興路平鎮段349號351號353號',
    縣市: '桃園市'
  },
  {
    店號: 187378,
    店名: '新雙安',
    地址: '桃園市桃園區安樂街48號50號1樓;安東街56號1樓',
    縣市: '桃園市'
  },
  {
    店號: 187390,
    店名: '八德建',
    地址: '桃園市八德區建國路165號',
    縣市: '桃園市'
  },
  {
    店號: 187585,
    店名: '鐵鎮',
    地址: '桃園市大園區中正東路二段428號',
    縣市: '桃園市'
  },
  {
    店號: 187633,
    店名: '曜駿',
    地址: '桃園市龍潭區中興路292號1樓',
    縣市: '桃園市'
  },
  {
    店號: 187725,
    店名: '湯華',
    地址: '桃園市中壢區中華路一段745號747號749號1樓',
    縣市: '桃園市'
  },
  {
    店號: 187873,
    店名: '富竹',
    地址: '桃園市蘆竹區南竹路二段313號1樓',
    縣市: '桃園市'
  },
  {
    店號: 187987,
    店名: '益志',
    地址: '桃園市桃園區樹仁三街102號',
    縣市: '桃園市'
  },
  {
    店號: 188038,
    店名: '城邦',
    地址: '桃園市桃園區樹仁三街81號83號85號1樓',
    縣市: '桃園市'
  },
  {
    店號: 188511,
    店名: '民新',
    地址: '桃園市大園區民生南路167號',
    縣市: '桃園市'
  },
  {
    店號: 188566,
    店名: '民生北',
    地址: '桃園市龜山區民生北路一段54號1樓',
    縣市: '桃園市'
  },
  {
    店號: 188968,
    店名: '華薪',
    地址: '桃園市中壢區新中北路二段179號181號',
    縣市: '桃園市'
  },
  {
    店號: 189031,
    店名: '園頂',
    地址: '桃園市大溪區公園路111號115號',
    縣市: '桃園市'
  },
  {
    店號: 189097,
    店名: '航榮',
    地址: '桃園市蘆竹區南崁路二段473號',
    縣市: '桃園市'
  },
  {
    店號: 189101,
    店名: '新龍壽',
    地址: '桃園市桃園區龍壽街20號',
    縣市: '桃園市'
  },
  {
    店號: 189156,
    店名: '領航',
    地址: '桃園市中壢區領航北路二段239號1樓',
    縣市: '桃園市'
  },
  {
    店號: 189798,
    店名: '同德',
    地址: '桃園市桃園區中埔二街150號',
    縣市: '桃園市'
  },
  {
    店號: 189927,
    店名: '成豐',
    地址: '桃園市中壢區元化路197巷3號1樓',
    縣市: '桃園市'
  },
  {
    店號: 190352,
    店名: '壢和',
    地址: '桃園市中壢區中和路114號',
    縣市: '桃園市'
  },
  {
    店號: 190776,
    店名: '宏亞',
    地址: '桃園市桃園區中平路102號',
    縣市: '桃園市'
  },
  {
    店號: 190798,
    店名: '鎮豐',
    地址: '桃園市平鎮區南豐路99號',
    縣市: '桃園市'
  },
  {
    店號: 190857,
    店名: '華龍',
    地址: '桃園市龜山區萬壽路一段292號1樓龍華街2巷6號B1',
    縣市: '桃園市'
  },
  {
    店號: 192794,
    店名: '五福',
    地址: '桃園市蘆竹區五福一路202號1樓',
    縣市: '桃園市'
  },
  {
    店號: 192901,
    店名: '芮霖',
    地址: '桃園市蘆竹區中興路536之1號',
    縣市: '桃園市'
  },
  {
    店號: 192923,
    店名: '華壢',
    地址: '桃園市中壢區中華路一段288號290號1樓',
    縣市: '桃園市'
  },
  {
    店號: 192990,
    店名: '國仁',
    地址: '桃園市八德區建國路250號256號',
    縣市: '桃園市'
  },
  {
    店號: 193269,
    店名: '大錢站',
    地址: '桃園市桃園區中華路5號1樓2樓',
    縣市: '桃園市'
  },
  {
    店號: 193306,
    店名: '水美',
    地址: '桃園市楊梅區楊新路二段70號',
    縣市: '桃園市'
  },
  {
    店號: 193454,
    店名: '桃遠百',
    地址: '桃園市桃園區中正路20號B1樓',
    縣市: '桃園市'
  },
  {
    店號: 193498,
    店名: '禾安',
    地址: '桃園市平鎮區平德路295號1樓',
    縣市: '桃園市'
  },
  {
    店號: 193580,
    店名: '蘆愛',
    地址: '桃園市蘆竹區仁愛路一段464之1號',
    縣市: '桃園市'
  },
  {
    店號: 193605,
    店名: '大益',
    地址: '桃園市觀音區濱海路大潭段22號',
    縣市: '桃園市'
  },
  {
    店號: 193649,
    店名: '文捷',
    地址: '桃園市龜山區文桃路426號1樓',
    縣市: '桃園市'
  },
  {
    店號: 193845,
    店名: '鑫隆',
    地址: '桃園市楊梅區金龍三路1號3號1樓',
    縣市: '桃園市'
  },
  {
    店號: 193856,
    店名: '莊壢',
    地址: '桃園市中壢區莊敬路199號',
    縣市: '桃園市'
  },
  {
    店號: 194099,
    店名: '廣耘',
    地址: '桃園市平鎮區廣泰路212號1樓',
    縣市: '桃園市'
  },
  {
    店號: 194228,
    店名: '高達',
    地址: '桃園市楊梅區金山街302號1樓',
    縣市: '桃園市'
  },
  {
    店號: 194365,
    店名: '榮福',
    地址: '桃園市中壢區永福路1092號1092-1號1096號1樓',
    縣市: '桃園市'
  },
  {
    店號: 194468,
    店名: '華泰城',
    地址: '桃園市中壢區春德路159號860櫃位',
    縣市: '桃園市'
  },
  {
    店號: 194549,
    店名: '富友',
    地址: '桃園市中壢區中山東路三段419號421號423號1樓',
    縣市: '桃園市'
  },
  {
    店號: 194837,
    店名: '興東',
    地址: '桃園市中壢區中山東路三段226號228號228之1號',
    縣市: '桃園市'
  },
  {
    店號: 194974,
    店名: '松容',
    地址: '桃園市中壢區青溪路一段85號',
    縣市: '桃園市'
  },
  {
    店號: 195047,
    店名: '祥綸',
    地址: '桃園市大園區高鐵北路三段45號',
    縣市: '桃園市'
  },
  {
    店號: 195092,
    店名: '上巴陵',
    地址: '桃園市復興區華陵里10鄰巴崚116號',
    縣市: '桃園市'
  },
  {
    店號: 195313,
    店名: '玄海',
    地址: '桃園市大園區和平西路二段5號',
    縣市: '桃園市'
  },
  {
    店號: 195380,
    店名: '精材三',
    地址: '桃園市中壢區中園路188號B1樓',
    縣市: '桃園市'
  },
  {
    店號: 195391,
    店名: '精材二',
    地址: '桃園市中壢區自強一路8號2樓',
    縣市: '桃園市'
  },
  {
    店號: 195586,
    店名: '欣興',
    地址: '桃園市中壢區新興路226號228號',
    縣市: '桃園市'
  },
  {
    店號: 196257,
    店名: '新捷市',
    地址: '桃園市桃園區龍泉六街49號及龍城一街89號91號',
    縣市: '桃園市'
  },
  {
    店號: 196291,
    店名: '航站五',
    地址: '桃園市大園區航站南路9號5樓',
    縣市: '桃園市'
  },
  {
    店號: 196349,
    店名: '飛揚',
    地址: '桃園市楊梅區中山北路二段58號1樓2樓',
    縣市: '桃園市'
  },
  {
    店號: 196431,
    店名: '威海',
    地址: '桃園市龍潭區中正路三坑段563號1樓',
    縣市: '桃園市'
  },
  {
    店號: 196453,
    店名: '冠興',
    地址: '桃園市觀音區成功路二段1247號',
    縣市: '桃園市'
  },
  {
    店號: 196590,
    店名: '一品苑',
    地址: '桃園市桃園區同德六街103號',
    縣市: '桃園市'
  },
  {
    店號: 196718,
    店名: '桃華',
    地址: '桃園市桃園區南華街106號108號1樓',
    縣市: '桃園市'
  },
  {
    店號: 196958,
    店名: '廣福',
    地址: '桃園市八德區廣福路30號1樓',
    縣市: '桃園市'
  },
  {
    店號: 197087,
    店名: '敏盛',
    地址: '桃園市桃園區經國路168號B1樓',
    縣市: '桃園市'
  },
  {
    店號: 197179,
    店名: '龍運',
    地址: '桃園市龍潭區中正路105號1樓及107巷1號1樓',
    縣市: '桃園市'
  },
  {
    店號: 197308,
    店名: '龍學',
    地址: '桃園市中壢區龍昌路178號1樓',
    縣市: '桃園市'
  },
  {
    店號: 197319,
    店名: '雙嶺',
    地址: '桃園市中壢區松義路111號113號1樓',
    縣市: '桃園市'
  },
  {
    店號: 197478,
    店名: '八勇',
    地址: '桃園市八德區忠勇街197號',
    縣市: '桃園市'
  },
  {
    店號: 197803,
    店名: '大湳',
    地址: '桃園市八德區和平路875-1號',
    縣市: '桃園市'
  },
  {
    店號: 197847,
    店名: '壢福',
    地址: '桃園市中壢區廣州路200號202號1樓',
    縣市: '桃園市'
  },
  {
    店號: 198013,
    店名: '富莊',
    地址: '桃園市中壢區莊敬路141號',
    縣市: '桃園市'
  },
  {
    店號: 198080,
    店名: '新尊爵',
    地址: '桃園市龜山區復興三路139號141號143號145號1樓',
    縣市: '桃園市'
  },
  {
    店號: 198242,
    店名: '高竹',
    地址: '桃園市蘆竹區大竹北路737號',
    縣市: '桃園市'
  },
  {
    店號: 198482,
    店名: '高民',
    地址: '桃園市平鎮區延平路二段214號1樓',
    縣市: '桃園市'
  },
  {
    店號: 198529,
    店名: '盧奉',
    地址: '桃園市蘆竹區奉化路25號27號1樓',
    縣市: '桃園市'
  },
  {
    店號: 198688,
    店名: '桃民',
    地址: '桃園市桃園區民族路79號1樓',
    縣市: '桃園市'
  },
  {
    店號: 198714,
    店名: '富源',
    地址: '桃園市觀音區富源里57之1號2號',
    縣市: '桃園市'
  },
  {
    店號: 198792,
    店名: '欣國榮',
    地址: '桃園市桃園區經國路860號1樓',
    縣市: '桃園市'
  },
  {
    店號: 198828,
    店名: '登冠',
    地址: '桃園市龜山區文化二路52巷53號一樓',
    縣市: '桃園市'
  },
  {
    店號: 199359,
    店名: '頂社',
    地址: '桃園市蘆竹區山林路三段170-2號',
    縣市: '桃園市'
  },
  {
    店號: 199360,
    店名: '上興',
    地址: '桃園市蘆竹區上興路251號253號1樓',
    縣市: '桃園市'
  },
  {
    店號: 199430,
    店名: '桃農',
    地址: '桃園市桃園區萬壽路三段111號113號115號1樓',
    縣市: '桃園市'
  },
  {
    店號: 199599,
    店名: '民越',
    地址: '桃園市桃園區大有路141號143號',
    縣市: '桃園市'
  },
  {
    店號: 199603,
    店名: '鑫旺',
    地址: '桃園市中壢區興安二街1號1樓興仁路二段116號1樓',
    縣市: '桃園市'
  },
  {
    店號: 199636,
    店名: '壢達',
    地址: '桃園市平鎮區環南路231-5號1樓',
    縣市: '桃園市'
  },
  {
    店號: 200011,
    店名: '福鶯',
    地址: '桃園市龜山區山鶯路155號1樓',
    縣市: '桃園市'
  },
  {
    店號: 200103,
    店名: '醫林',
    地址: '桃園市龜山區長庚醫護新村80號B1樓',
    縣市: '桃園市'
  },
  {
    店號: 200217,
    店名: '驛光',
    地址: '桃園市中壢區新興路124號1樓2樓',
    縣市: '桃園市'
  },
  {
    店號: 200228,
    店名: '三沅',
    地址: '桃園市楊梅區三民北路88號1樓',
    縣市: '桃園市'
  },
  {
    店號: 200262,
    店名: '興鑽',
    地址: '桃園市蘆竹區中興路188號',
    縣市: '桃園市'
  },
  {
    店號: 200321,
    店名: '庚亞',
    地址: '桃園市龜山區復興一路150號1樓',
    縣市: '桃園市'
  },
  {
    店號: 200365,
    店名: '埔溪',
    地址: '桃園市大溪區埔頂路二段310號312號1樓',
    縣市: '桃園市'
  },
  {
    店號: 200734,
    店名: '崴信',
    地址: '桃園市桃園區信光路22號1樓',
    縣市: '桃園市'
  },
  {
    店號: 200996,
    店名: '廣華',
    地址: '桃園市龜山區文化三路386號1樓',
    縣市: '桃園市'
  },
  {
    店號: 201597,
    店名: '聖保祿',
    地址: '桃園市桃園區福安里建新街68號',
    縣市: '桃園市'
  },
  {
    店號: 202073,
    店名: '景茂',
    地址: '桃園市蘆竹區南山路一段391號',
    縣市: '桃園市'
  },
  {
    店號: 202176,
    店名: '塘園',
    地址: '桃園市中壢區領航北路二段208號公園路二段208號',
    縣市: '桃園市'
  },
  {
    店號: 202338,
    店名: '新樺',
    地址: '桃園市新屋區中華南路一段379號381號',
    縣市: '桃園市'
  },
  {
    店號: 202349,
    店名: '富名',
    地址: '桃園市楊梅區中山北路二段449號1樓',
    縣市: '桃園市'
  },
  {
    店號: 202383,
    店名: '台達五',
    地址: '桃園市中壢區東園路16號 2樓',
    縣市: '桃園市'
  },
  {
    店號: 202475,
    店名: '壢美',
    地址: '桃園市中壢區中美路39號1樓及建國北路55號1樓',
    縣市: '桃園市'
  },
  {
    店號: 202486,
    店名: '箱根',
    地址: '桃園市桃園區南平路416號418號1樓',
    縣市: '桃園市'
  },
  {
    店號: 206558,
    店名: '庚院',
    地址: '桃園市龜山區文化二路11之5號1樓',
    縣市: '桃園市'
  },
  {
    店號: 206592,
    店名: '復麗',
    地址: '桃園市桃園區復興路162號1樓',
    縣市: '桃園市'
  },
  {
    店號: 206743,
    店名: '新晨',
    地址: '桃園市大園區國際路一段187號',
    縣市: '桃園市'
  },
  {
    店號: 206950,
    店名: '社子',
    地址: '桃園市新屋區中興路1532之1號1樓',
    縣市: '桃園市'
  },
  {
    店號: 206972,
    店名: '欣民',
    地址: '桃園市中壢區民權路三段985號',
    縣市: '桃園市'
  },
  {
    店號: 206983,
    店名: '揚金',
    地址: '桃園市平鎮區金陵路二段288號',
    縣市: '桃園市'
  },
  {
    店號: 207001,
    店名: '大智湧',
    地址: '桃園市八德區大智路11號13號1樓2樓',
    縣市: '桃園市'
  },
  {
    店號: 207539,
    店名: '電通市',
    地址: '桃園市蘆竹區南山路一段27號29號1樓',
    縣市: '桃園市'
  },
  {
    店號: 207757,
    店名: '高和',
    地址: '桃園市大溪區仁和路二段8號',
    縣市: '桃園市'
  },
  {
    店號: 207827,
    店名: '青峰',
    地址: '桃園市大園區中山南路2段603號',
    縣市: '桃園市'
  },
  {
    店號: 207872,
    店名: '靖立',
    地址: '桃園市八德區豐德一路17號豐田一路83號',
    縣市: '桃園市'
  },
  {
    店號: 207920,
    店名: '公力',
    地址: '桃園市大園區中正東路一段708之1號',
    縣市: '桃園市'
  },
  {
    店號: 208015,
    店名: '新新明',
    地址: '桃園市中壢區民族路208號1樓',
    縣市: '桃園市'
  },
  {
    店號: 208130,
    店名: '福州一',
    地址: '桃園市中壢區福州一街102號1樓',
    縣市: '桃園市'
  },
  {
    店號: 208381,
    店名: '高蓉',
    地址: '桃園市大園區高鐵北路三段96號1樓',
    縣市: '桃園市'
  },
  {
    店號: 208521,
    店名: '成高',
    地址: '桃園市桃園區成功路三段8號1樓',
    縣市: '桃園市'
  },
  {
    店號: 208679,
    店名: '勁賀',
    地址: '桃園市蘆竹區光明路二段139號',
    縣市: '桃園市'
  },
  {
    店號: 208680,
    店名: '有成',
    地址: '桃園市桃園區大有路6號1樓',
    縣市: '桃園市'
  },
  {
    店號: 208808,
    店名: '程豪',
    地址: '桃園市觀音區福祥街157號163號1樓',
    縣市: '桃園市'
  },
  {
    店號: 208923,
    店名: '龍逸',
    地址: '桃園市龍潭區民族路372號374號1樓',
    縣市: '桃園市'
  },
  {
    店號: 209834,
    店名: '福倉',
    地址: '桃園市桃園區正光路425號1樓427號1樓',
    縣市: '桃園市'
  },
  {
    店號: 209889,
    店名: '銘仁堂',
    地址: '桃園市龍潭區民生路139號1樓',
    縣市: '桃園市'
  },
  {
    店號: 210085,
    店名: '芸珈',
    地址: '桃園市龜山區民生北路一段203號',
    縣市: '桃園市'
  },
  {
    店號: 210236,
    店名: '觀芳',
    地址: '桃園市觀音區成功路二段903號1樓2樓',
    縣市: '桃園市'
  },
  {
    店號: 210373,
    店名: '富騰',
    地址: '桃園市龜山區文青路219號1樓',
    縣市: '桃園市'
  },
  {
    店號: 210443,
    店名: '鋒彩',
    地址: '桃園市中壢區中正路1439之1號',
    縣市: '桃園市'
  },
  {
    店號: 210454,
    店名: '長林',
    地址: '桃園市龜山區復興街5號地下層',
    縣市: '桃園市'
  },
  {
    店號: 210498,
    店名: '吉翔',
    地址: '桃園市蘆竹區吉林路130號1樓',
    縣市: '桃園市'
  },
  {
    店號: 210502,
    店名: '欣欣',
    地址: '桃園市龜山區萬壽路二段1280號1樓',
    縣市: '桃園市'
  },
  {
    店號: 210579,
    店名: '升榮',
    地址: '桃園市龜山區文化三路81巷1號1樓',
    縣市: '桃園市'
  },
  {
    店號: 210605,
    店名: '大湧',
    地址: '桃園市八德區東勇二路111號',
    縣市: '桃園市'
  },
  {
    店號: 210672,
    店名: '龍汶',
    地址: '桃園市中壢區龍文街33巷2號6號1樓',
    縣市: '桃園市'
  },
  {
    店號: 210786,
    店名: '樂欣',
    地址: '桃園市蘆竹區長興路二段28號30號1樓',
    縣市: '桃園市'
  },
  {
    店號: 210845,
    店名: '大權',
    地址: '桃園市桃園區大同路43號1樓B1樓',
    縣市: '桃園市'
  },
  {
    店號: 210948,
    店名: '愛山林',
    地址: '桃園市蘆竹區山林路一段297號',
    縣市: '桃園市'
  },
  {
    店號: 210982,
    店名: '竹邑',
    地址: '桃園市蘆竹區大新路197號199號1樓',
    縣市: '桃園市'
  },
  {
    店號: 211011,
    店名: '高進',
    地址: '桃園市中壢區環北路196號',
    縣市: '桃園市'
  },
  {
    店號: 211033,
    店名: '承晨',
    地址: '桃園市中壢區民權路五段65號1樓',
    縣市: '桃園市'
  },
  {
    店號: 211055,
    店名: '工園',
    地址: '桃園市中壢區西園路27號西園路25巷5號1樓',
    縣市: '桃園市'
  },
  {
    店號: 211217,
    店名: '央大',
    地址: '桃園市平鎮區民族路三段275號高雙路3號',
    縣市: '桃園市'
  },
  {
    店號: 211479,
    店名: '千藝',
    地址: '桃園市桃園區同德六街1號',
    縣市: '桃園市'
  },
  {
    店號: 211941,
    店名: '新震',
    地址: '桃園市觀音區新生路171號',
    縣市: '桃園市'
  },
  {
    店號: 212221,
    店名: '慈豐',
    地址: '桃園市桃園區慈文路975號',
    縣市: '桃園市'
  },
  {
    店號: 212276,
    店名: '布拉格',
    地址: '桃園市大園區拔子林一路137號拔子林三路6號',
    縣市: '桃園市'
  },
  {
    店號: 212313,
    店名: '佶林',
    地址: '桃園市中壢區吉林路128之11號1樓',
    縣市: '桃園市'
  },
  {
    店號: 212335,
    店名: '京采',
    地址: '桃園市桃園區延平路289號1樓',
    縣市: '桃園市'
  },
  {
    店號: 212586,
    店名: '鴻華',
    地址: '桃園市觀音區四維路162號1樓',
    縣市: '桃園市'
  },
  {
    店號: 212597,
    店名: '青航',
    地址: '桃園市中壢區領航北路二段60號、民權路四段309號1樓',
    縣市: '桃園市'
  },
  {
    店號: 213888,
    店名: '北崁',
    地址: '桃園市蘆竹區中正路85號87號89號1樓',
    縣市: '桃園市'
  },
  {
    店號: 213969,
    店名: '水龍吟',
    地址: '桃園市龍潭區中原路一段506號1樓',
    縣市: '桃園市'
  },
  {
    店號: 214238,
    店名: '庚大',
    地址: '桃園市龜山區文化一路259號B1樓',
    縣市: '桃園市'
  },
  {
    店號: 214261,
    店名: '宏宇',
    地址: '桃園市平鎮區金陵路二段104號',
    縣市: '桃園市'
  },
  {
    店號: 214294,
    店名: '元翔',
    地址: '桃園市蘆竹區六福路247巷2-1號',
    縣市: '桃園市'
  },
  {
    店號: 214434,
    店名: '勇利',
    地址: '桃園市龜山區文化一路86-6號',
    縣市: '桃園市'
  },
  {
    店號: 214489,
    店名: '源盛',
    地址: '桃園市桃園區國聖一街188號1樓;宏昌十二街587號1樓',
    縣市: '桃園市'
  },
  {
    店號: 214537,
    店名: '航祥',
    地址: '桃園市大園區三民路一段785號1樓',
    縣市: '桃園市'
  },
  {
    店號: 214618,
    店名: '影華',
    地址: '桃園市中壢區九和一街20號1樓',
    縣市: '桃園市'
  },
  {
    店號: 214777,
    店名: '龍袖',
    地址: '桃園市桃園區龍安街143號1樓',
    縣市: '桃園市'
  },
  {
    店號: 215116,
    店名: '蘆順',
    地址: '桃園市蘆竹區奉化路168號170號172號1樓',
    縣市: '桃園市'
  },
  {
    店號: 215356,
    店名: '泉僑',
    地址: '桃園市龍潭區文化路12-3號',
    縣市: '桃園市'
  },
  {
    店號: 215367,
    店名: '揚善',
    地址: '桃園市楊梅區中山北路一段23號25號1樓',
    縣市: '桃園市'
  },
  {
    店號: 215600,
    店名: '翁和',
    地址: '桃園市大溪區仁文里介壽路1151號1153號1樓',
    縣市: '桃園市'
  },
  {
    店號: 215873,
    店名: '國藝',
    地址: '桃園市桃園區南平路185號187號1樓',
    縣市: '桃園市'
  },
  {
    店號: 215954,
    店名: '新元',
    地址: '桃園市中壢區新生路232號234號',
    縣市: '桃園市'
  },
  {
    店號: 216245,
    店名: '福僑',
    地址: '桃園市八德區廣福路162號164號1樓',
    縣市: '桃園市'
  },
  {
    店號: 216360,
    店名: '觀成',
    地址: '桃園市觀音區成功路一段557號559號1樓',
    縣市: '桃園市'
  },
  {
    店號: 216407,
    店名: '埔民',
    地址: '桃園市桃園區民生路535號1樓',
    縣市: '桃園市'
  },
  {
    店號: 216418,
    店名: '達義',
    地址: '桃園市平鎮區義民路199號1樓',
    縣市: '桃園市'
  },
  {
    店號: 216500,
    店名: '縣北',
    地址: '桃園市桃園區中山北路136號1樓',
    縣市: '桃園市'
  },
  {
    店號: 216533,
    店名: '民 笙',
    地址: '桃園市桃園區民生路287號289號',
    縣市: '桃園市'
  },
  {
    店號: 216555,
    店名: '輕井澤',
    地址: '桃園市桃園區大業路一段355號357號一樓',
    縣市: '桃園市'
  },
  {
    店號: 216810,
    店名: '德沅',
    地址: '桃園市八德區介壽路二段455號',
    縣市: '桃園市'
  },
  {
    店號: 217019,
    店名: '成德',
    地址: '桃園市平鎮區承德路2號4號1樓',
    縣市: '桃園市'
  },
  {
    店號: 217020,
    店名: '龍政',
    地址: '桃園市龍潭區中正路162號',
    縣市: '桃園市'
  },
  {
    店號: 217031,
    店名: '大園港',
    地址: '桃園市大園區大觀路1088號',
    縣市: '桃園市'
  },
  {
    店號: 217145,
    店名: '順舜',
    地址: '桃園市蘆竹區南順六街22號24號26號',
    縣市: '桃園市'
  },
  {
    店號: 217466,
    店名: '龍東',
    地址: '桃園市中壢區龍東路138號140號1樓',
    縣市: '桃園市'
  },
  {
    店號: 227636,
    店名: '國匯',
    地址: '桃園市桃園區經國路801號',
    縣市: '桃園市'
  },
  {
    店號: 227751,
    店名: '興聖',
    地址: '桃園市中壢區新生路二段48號1樓',
    縣市: '桃園市'
  },
  {
    店號: 227957,
    店名: '國悅',
    地址: '桃園市桃園區天祥七街101號103號',
    縣市: '桃園市'
  },
  {
    店號: 228042,
    店名: '永誠',
    地址: '桃園市楊梅區永美路385-9號1樓2樓',
    縣市: '桃園市'
  },
  {
    店號: 228053,
    店名: '兆沅',
    地址: '桃園市龍潭區中豐路77之1號',
    縣市: '桃園市'
  },
  {
    店號: 228086,
    店名: '美利堅',
    地址: '桃園市楊梅區青山五街25號1樓',
    縣市: '桃園市'
  },
  {
    店號: 228248,
    店名: '平昌',
    地址: '桃園市桃園區中平路167號1+2樓',
    縣市: '桃園市'
  },
  {
    店號: 228318,
    店名: '上青',
    地址: '桃園市蘆竹區中山路12之2號1樓',
    縣市: '桃園市'
  },
  {
    店號: 228547,
    店名: '振聲',
    地址: '桃園市桃園區復興路389號1樓',
    縣市: '桃園市'
  },
  {
    店號: 228569,
    店名: '金汲',
    地址: '桃園市桃園區力行路385巷11號13號1樓',
    縣市: '桃園市'
  },
  {
    店號: 228628,
    店名: '觀岷',
    地址: '桃園市觀音區民生路65號1樓',
    縣市: '桃園市'
  },
  {
    店號: 228662,
    店名: '湧強',
    地址: '桃園市桃園區自強路215號1樓',
    縣市: '桃園市'
  },
  {
    店號: 228857,
    店名: '千賀',
    地址: '桃園市中壢區月桃路246號248號',
    縣市: '桃園市'
  },
  {
    店號: 228891,
    店名: '華樂',
    地址: '桃園市龜山區華亞三路195號197號1樓',
    縣市: '桃園市'
  },
  {
    店號: 228949,
    店名: '鑫海',
    地址: '桃園市蘆竹區龍安街二段1007號1樓',
    縣市: '桃園市'
  },
  {
    店號: 229148,
    店名: '凌華科',
    地址: '桃園市龜山區華亞一路68號1樓',
    縣市: '桃園市'
  },
  {
    店號: 229159,
    店名: '富敦',
    地址: '桃園市龜山區樂學三路83號1樓',
    縣市: '桃園市'
  },
  {
    店號: 229207,
    店名: '隆陞',
    地址: '桃園市龜山區頂湖路25號27號1樓',
    縣市: '桃園市'
  },
  {
    店號: 229229,
    店名: '統讚',
    地址: '桃園市中壢區龍江路58號1樓',
    縣市: '桃園市'
  },
  {
    店號: 229252,
    店名: '民安',
    地址: '桃園市桃園區民安路84號忠五路169號',
    縣市: '桃園市'
  },
  {
    店號: 229551,
    店名: '超級郡',
    地址: '桃園市中壢區松信路36號38號',
    縣市: '桃園市'
  },
  {
    店號: 229609,
    店名: '洪圳',
    地址: '桃園市平鎮區洪圳路326號1樓',
    縣市: '桃園市'
  },
  {
    店號: 229698,
    店名: '環匯',
    地址: '桃園市中壢區高鐵南路二段352號3樓',
    縣市: '桃園市'
  },
  {
    店號: 229894,
    店名: '立京',
    地址: '桃園市中壢區五族二街66號68號1樓',
    縣市: '桃園市'
  },
  {
    店號: 229908,
    店名: '鎮翊',
    地址: '桃園市平鎮區中豐路南勢一段173號1樓 南東路1-1號1樓',
    縣市: '桃園市'
  },
  {
    店號: 230045,
    店名: '忠貞',
    地址: '桃園市平鎮區中山路63之3號63之5號',
    縣市: '桃園市'
  },
  {
    店號: 230218,
    店名: '桃誠',
    地址: '桃園市八德區公園路160號',
    縣市: '桃園市'
  },
  {
    店號: 230322,
    店名: '慈安',
    地址: '桃園市桃園區永安路511號513號1樓',
    縣市: '桃園市'
  },
  {
    店號: 230517,
    店名: '靖欣',
    地址: '桃園市八德區中興街42號興仁路46號48號',
    縣市: '桃園市'
  },
  {
    店號: 230780,
    店名: '濰坊',
    地址: '桃園市觀音區大觀路一段293號1樓',
    縣市: '桃園市'
  },
  {
    店號: 230920,
    店名: '高青',
    地址: '桃園市大園區大成路一段2號1樓',
    縣市: '桃園市'
  },
  {
    店號: 231071,
    店名: '森豪',
    地址: '桃園市八德區東勇北路295之1號',
    縣市: '桃園市'
  },
  {
    店號: 231288,
    店名: '鑫豐洲',
    地址: '桃園市八德區豐德路577號建德路20號',
    縣市: '桃園市'
  },
  {
    店號: 231406,
    店名: '君匯',
    地址: '桃園市大園區園航路411號413號1樓',
    縣市: '桃園市'
  },
  {
    店號: 231532,
    店名: '中科院',
    地址: '桃園市龍潭區佳安里中正路佳安段481號2樓',
    縣市: '桃園市'
  },
  {
    店號: 231772,
    店名: '凰舞',
    地址: '桃園市楊梅區萬大路116巷59號',
    縣市: '桃園市'
  },
  {
    店號: 232030,
    店名: '耀興',
    地址: '桃園市蘆竹區南山路二段328號330號1樓',
    縣市: '桃園市'
  },
  {
    店號: 232203,
    店名: '北林',
    地址: '桃園市大園區大成路二段127號129號1樓2樓',
    縣市: '桃園市'
  },
  {
    店號: 232317,
    店名: '合禾',
    地址: '桃園市桃園區溫州一路302號306號1樓2樓',
    縣市: '桃園市'
  },
  {
    店號: 236814,
    店名: '復強',
    地址: '桃園市中壢區自強六路53號復華街212號1樓',
    縣市: '桃園市'
  },
  {
    店號: 236951,
    店名: '聖民',
    地址: '桃園市桃園區民生路208號一樓',
    縣市: '桃園市'
  },
  {
    店號: 237116,
    店名: '祥崁',
    地址: '桃園市龜山區南祥路41號43號45號1樓',
    縣市: '桃園市'
  },
  {
    店號: 237127,
    店名: '錦欣',
    地址: '桃園市蘆竹區南竹路一段63號1樓',
    縣市: '桃園市'
  },
  {
    店號: 237541,
    店名: '民鑽',
    地址: '桃園市桃園區民生路57號1樓',
    縣市: '桃園市'
  },
  {
    店號: 237677,
    店名: '新劉興',
    地址: '桃園市大溪區南興里永昌路320號',
    縣市: '桃園市'
  },
  {
    店號: 237770,
    店名: '千山',
    地址: '桃園市桃園區縣府路212號216號',
    縣市: '桃園市'
  },
  {
    店號: 237976,
    店名: '新宏國',
    地址: '桃園市八德區中華路292號294號1樓',
    縣市: '桃園市'
  },
  {
    店號: 238142,
    店名: '禾臣',
    地址: '桃園市龍潭區高平里高楊北路1號',
    縣市: '桃園市'
  },
  {
    店號: 238223,
    店名: '德力',
    地址: '桃園市八德區大福里介壽路一段134號136號',
    縣市: '桃園市'
  },
  {
    店號: 238290,
    店名: '內厝五',
    地址: '桃園市大園區中興路二段359巷9弄3號',
    縣市: '桃園市'
  },
  {
    店號: 238315,
    店名: '擎天',
    地址: '桃園市桃園區桃鶯路50號52號1樓',
    縣市: '桃園市'
  },
  {
    店號: 238968,
    店名: '廣泰',
    地址: '桃園市平鎮區廣泰路130號132號',
    縣市: '桃園市'
  },
  {
    店號: 239031,
    店名: '國邦',
    地址: '桃園市蘆竹區忠孝西路206號1樓',
    縣市: '桃園市'
  },
  {
    店號: 239330,
    店名: '同華',
    地址: '桃園市龍潭區中正里龍華路396號1樓',
    縣市: '桃園市'
  },
  {
    店號: 239444,
    店名: '明揚',
    地址: '桃園市平鎮區延平路二段76號',
    縣市: '桃園市'
  },
  {
    店號: 239606,
    店名: '松柏林',
    地址: '桃園市八德區介壽路二段685巷50弄2號1樓',
    縣市: '桃園市'
  },
  {
    店號: 239798,
    店名: '楊昇',
    地址: '桃園市楊梅區校前路241號',
    縣市: '桃園市'
  },
  {
    店號: 239802,
    店名: '廣懋',
    地址: '桃園市八德區廣福路578號',
    縣市: '桃園市'
  },
  {
    店號: 240086,
    店名: '君富',
    地址: '桃園市桃園區富國路555號1樓',
    縣市: '桃園市'
  },
  {
    店號: 240215,
    店名: '龍欣',
    地址: '桃園市龍潭區中興路257號259號',
    縣市: '桃園市'
  },
  {
    店號: 240248,
    店名: '寶山街',
    地址: '桃園市桃園區寶山街280號1樓',
    縣市: '桃園市'
  },
  {
    店號: 240282,
    店名: '吉豐',
    地址: '桃園市中壢區長沙路8號10號1樓',
    縣市: '桃園市'
  },
  {
    店號: 240396,
    店名: '冠廷',
    地址: '桃園市龜山區南美里南上路332號1F',
    縣市: '桃園市'
  },
  {
    店號: 240592,
    店名: '德享',
    地址: '桃園市平鎮區南勢里14鄰中豐路南勢二段377號379號381號',
    縣市: '桃園市'
  },
  {
    店號: 240776,
    店名: '中慈',
    地址: '桃園市桃園區中正三街411號1樓',
    縣市: '桃園市'
  },
  {
    店號: 241023,
    店名: '文仁',
    地址: '桃園市桃園區延壽街9號11號1樓',
    縣市: '桃園市'
  },
  {
    店號: 241067,
    店名: '鑽石',
    地址: '桃園市龍潭區八德里梅龍路23鄰139號141號1樓',
    縣市: '桃園市'
  },
  {
    店號: 241252,
    店名: '宏太',
    地址: '桃園市桃園區桃鶯路384-9號384-10號1樓',
    縣市: '桃園市'
  },
  {
    店號: 241355,
    店名: '德興',
    地址: '桃園市平鎮區德育路二段3號1樓振興路12號1樓',
    縣市: '桃園市'
  },
  {
    店號: 241366,
    店名: '元化',
    地址: '桃園市中壢區元化路1-1號',
    縣市: '桃園市'
  },
  {
    店號: 241481,
    店名: '國祥',
    地址: '桃園市桃園區自強里經國路685號',
    縣市: '桃園市'
  },
  {
    店號: 241492,
    店名: '環宇',
    地址: '桃園市中壢區自強15鄰環中東路8號',
    縣市: '桃園市'
  },
  {
    店號: 241517,
    店名: '龍池',
    地址: '桃園市龍潭區中豐路上林段187號189號1樓',
    縣市: '桃園市'
  },
  {
    店號: 249119,
    店名: '丰順',
    地址: '桃園市平鎮區中豐路一段281之1號1樓',
    縣市: '桃園市'
  },
  {
    店號: 249371,
    店名: '弘揚',
    地址: '桃園市中壢區弘揚路47號1樓',
    縣市: '桃園市'
  },
  {
    店號: 249430,
    店名: '萬鑫',
    地址: '桃園市楊梅區民富路三段828號830號1樓',
    縣市: '桃園市'
  },
  {
    店號: 249474,
    店名: '國門',
    地址: '桃園市桃園區春日路1486號1484號',
    縣市: '桃園市'
  },
  {
    店號: 249485,
    店名: '經國一',
    地址: '桃園市桃園區經國路838號1樓',
    縣市: '桃園市'
  },
  {
    店號: 249522,
    店名: '上賀',
    地址: '桃園市蘆竹區光明路一段100號',
    縣市: '桃園市'
  },
  {
    店號: 249566,
    店名: '三元',
    地址: '桃園市桃園區大業路一段54號56號1樓',
    縣市: '桃園市'
  },
  {
    店號: 249614,
    店名: '龍南',
    地址: '桃園市平鎮區龍南路348號',
    縣市: '桃園市'
  },
  {
    店號: 249692,
    店名: '同銘',
    地址: '桃園市龜山區大同路212號1樓',
    縣市: '桃園市'
  },
  {
    店號: 249717,
    店名: '禾豐',
    地址: '桃園市桃園區秀山路95號1樓',
    縣市: '桃園市'
  },
  {
    店號: 249762,
    店名: '大成',
    地址: '桃園市楊梅區梅山西街10號',
    縣市: '桃園市'
  },
  {
    店號: 249876,
    店名: '尊品',
    地址: '桃園市桃園區建國路41-1號1樓',
    縣市: '桃園市'
  },
  {
    店號: 250049,
    店名: '雙假',
    地址: '桃園市桃園區大有路660號1樓之2',
    縣市: '桃園市'
  },
  {
    店號: 250050,
    店名: '壽興',
    地址: '桃園市龜山區中興路一段73號1樓',
    縣市: '桃園市'
  },
  {
    店號: 250234,
    店名: '蓮花',
    地址: '桃園市楊梅區青山一街2號2-1號1樓',
    縣市: '桃園市'
  },
  {
    店號: 250267,
    店名: '航園',
    地址: '桃園市大園區中正東路102號',
    縣市: '桃園市'
  },
  {
    店號: 250278,
    店名: '山林',
    地址: '桃園市蘆竹區海山路407號409號411號',
    縣市: '桃園市'
  },
  {
    店號: 250485,
    店名: '詠康',
    地址: '桃園市桃園區長春路37號39號1樓',
    縣市: '桃園市'
  },
  {
    店號: 250544,
    店名: '鑫騰龍',
    地址: '桃園市龜山區萬壽路一段156.158號1樓',
    縣市: '桃園市'
  },
  {
    店號: 250658,
    店名: '大楊',
    地址: '桃園市楊梅區楊湖路一段90號92號94號1樓',
    縣市: '桃園市'
  },
  {
    店號: 250681,
    店名: '百吉',
    地址: '桃園市大溪區復興路二段35號',
    縣市: '桃園市'
  },
  {
    店號: 250717,
    店名: '百年',
    地址: '桃園市龍潭區烏樹林里中豐路317號１樓',
    縣市: '桃園市'
  },
  {
    店號: 250809,
    店名: '慶福',
    地址: '桃園市中壢區同慶路277號1樓',
    縣市: '桃園市'
  },
  {
    店號: 250843,
    店名: '常楓',
    地址: '桃園市龜山區光峰路221號1樓',
    縣市: '桃園市'
  },
  {
    店號: 250865,
    店名: '仁善',
    地址: '桃園市大溪區埔頂路二段183號',
    縣市: '桃園市'
  },
  {
    店號: 250946,
    店名: '關爺',
    地址: '桃園市平鎮區南東路376號1樓',
    縣市: '桃園市'
  },
  {
    店號: 250980,
    店名: '金學',
    地址: '桃園市桃園區國際一路121號',
    縣市: '桃園市'
  },
  {
    店號: 250991,
    店名: '興源',
    地址: '桃園市桃園區大興西路二段82號1樓',
    縣市: '桃園市'
  },
  {
    店號: 251008,
    店名: '觀工',
    地址: '桃園市觀音區成功路一段525號527號529號1F',
    縣市: '桃園市'
  },
  {
    店號: 251053,
    店名: '新昇',
    地址: '桃園市中壢區新生路四段28.30號1樓',
    縣市: '桃園市'
  },
  {
    店號: 251134,
    店名: '有家',
    地址: '桃園市桃園區大有路457號459號1樓',
    縣市: '桃園市'
  },
  {
    店號: 251260,
    店名: '皓倫',
    地址: '桃園市平鎮區振興西路70號72號1樓',
    縣市: '桃園市'
  },
  {
    店號: 844745,
    店名: '大溪',
    地址: '桃園市大溪區中央路152號',
    縣市: '桃園市'
  },
  {
    店號: 846707,
    店名: '環民',
    地址: '桃園市中壢區環西路2號',
    縣市: '桃園市'
  },
  {
    店號: 850762,
    店名: '山鶯',
    地址: '桃園市龜山區山鶯路372號',
    縣市: '桃園市'
  },
  {
    店號: 860301,
    店名: '蘆竹',
    地址: '桃園市蘆竹區山腳里南山路三段306號308號',
    縣市: '桃園市'
  },
  {
    店號: 864462,
    店名: '航空',
    地址: '桃園市蘆竹區中正路304號',
    縣市: '桃園市'
  },
  {
    店號: 864886,
    店名: '假日',
    地址: '桃園市桃園區大有路560號1樓',
    縣市: '桃園市'
  },
  {
    店號: 866158,
    店名: '新屋',
    地址: '桃園市新屋區新生里12鄰中山路367號369號371號',
    縣市: '桃園市'
  },
  {
    店號: 870788,
    店名: '國安',
    地址: '桃園市桃園區經國路405號',
    縣市: '桃園市'
  },
  {
    店號: 870917,
    店名: '觀園',
    地址: '桃園市大園區大觀路604號606號',
    縣市: '桃園市'
  },
  {
    店號: 871079,
    店名: '機場',
    地址: '桃園市大園區三民路二段110號112號',
    縣市: '桃園市'
  },
  {
    店號: 874012,
    店名: '麻園',
    地址: '桃園市八德區介壽路二段360號362號',
    縣市: '桃園市'
  },
  {
    店號: 874506,
    店名: '桃朋',
    地址: '桃園市桃園區大興西路二段1號1樓',
    縣市: '桃園市'
  },
  {
    店號: 874942,
    店名: '國揚',
    地址: '桃園市桃園區經國路242號',
    縣市: '桃園市'
  },
  {
    店號: 875370,
    店名: '寶楊',
    地址: '桃園市楊梅區中山北路二段113號',
    縣市: '桃園市'
  },
  {
    店號: 875484,
    店名: '站行',
    地址: '桃園市中壢區新興路162號',
    縣市: '桃園市'
  },
  {
    店號: 881940,
    店名: '新坡',
    地址: '桃園市觀音區中山路二段663號',
    縣市: '桃園市'
  },
  {
    店號: 882172,
    店名: '國僑',
    地址: '桃園市八德區建國路1075號',
    縣市: '桃園市'
  },
  {
    店號: 882404,
    店名: '文福',
    地址: '桃園市桃園區文中路747號',
    縣市: '桃園市'
  },
  {
    店號: 882622,
    店名: '雙慶',
    地址: '桃園市桃園區安慶街84號86號',
    縣市: '桃園市'
  },
  {
    店號: 882862,
    店名: '成章',
    地址: '桃園市中壢區成章二街192號',
    縣市: '桃園市'
  },
  {
    店號: 886646,
    店名: '正同',
    地址: '桃園市龍潭區中正里15鄰中正路472號474號',
    縣市: '桃園市'
  },
  {
    店號: 887100,
    店名: '桃龍',
    地址: '桃園市桃園區龍安街79號81號',
    縣市: '桃園市'
  },
  {
    店號: 892320,
    店名: '大崗',
    地址: '桃園市龜山區大崗里17鄰大湖41之2號',
    縣市: '桃園市'
  },
  {
    店號: 892984,
    店名: '觀昌',
    地址: '桃園市觀音區中山路9巷19號1樓中山路21號23號1樓',
    縣市: '桃園市'
  },
  {
    店號: 892995,
    店名: '裕達',
    地址: '桃園市平鎮區育達路160號',
    縣市: '桃園市'
  },
  {
    店號: 893840,
    店名: '蘆山',
    地址: '桃園市蘆竹區中山路152號154號156號一樓',
    縣市: '桃園市'
  },
  {
    店號: 894418,
    店名: '惠祥',
    地址: '桃園市中壢區榮安一街293號',
    縣市: '桃園市'
  },
  {
    店號: 895651,
    店名: '貴林',
    地址: '桃園市龜山區樂善里15鄰文明路43號',
    縣市: '桃園市'
  },
  {
    店號: 901802,
    店名: '嘉福',
    地址: '桃園市大溪區員林路二段359之1號',
    縣市: '桃園市'
  },
  {
    店號: 902034,
    店名: '景旭',
    地址: '桃園市蘆竹區大新路852號854號之1樓',
    縣市: '桃園市'
  },
  {
    店號: 903484,
    店名: '政群',
    地址: '桃園市中壢區中園路二段138號',
    縣市: '桃園市'
  },
  {
    店號: 904018,
    店名: '財春',
    地址: '桃園市龜山區振興路636號638號',
    縣市: '桃園市'
  },
  {
    店號: 910817,
    店名: '金磚',
    地址: '桃園市平鎮區新富里新富二街18號20號',
    縣市: '桃園市'
  },
  {
    店號: 912352,
    店名: '奇采',
    地址: '桃園市中壢區興仁路三段115號1樓',
    縣市: '桃園市'
  },
  {
    店號: 912709,
    店名: '科學城',
    地址: '桃園市中壢區中北路二段206號',
    縣市: '桃園市'
  },
  {
    店號: 913012,
    店名: '長陽',
    地址: '桃園市桃園區長沙街90號1樓',
    縣市: '桃園市'
  },
  {
    店號: 913159,
    店名: '王子',
    地址: '桃園市中壢區三光路130號1樓',
    縣市: '桃園市'
  },
  {
    店號: 913540,
    店名: '梅獅',
    地址: '桃園市楊梅區瑞塘里梅獅路二段231號',
    縣市: '桃園市'
  },
  {
    店號: 915122,
    店名: '南崁',
    地址: '桃園市蘆竹區南崁路156號',
    縣市: '桃園市'
  },
  {
    店號: 916136,
    店名: '鎮光',
    地址: '桃園市平鎮區湧光里中豐路山頂段206號208號1樓',
    縣市: '桃園市'
  },
  {
    店號: 920227,
    店名: '祥佑',
    地址: '桃園市桃園區寶慶路176號',
    縣市: '桃園市'
  },
  {
    店號: 920906,
    店名: '開立',
    地址: '桃園市平鎮區廣仁里新光路19號21號',
    縣市: '桃園市'
  },
  {
    店號: 920962,
    店名: '富先',
    地址: '桃園市楊梅區萬大路111號113號',
    縣市: '桃園市'
  },
  {
    店號: 921437,
    店名: '萬能',
    地址: '桃園市中壢區萬能路1號',
    縣市: '桃園市'
  },
  {
    店號: 921471,
    店名: '益壽',
    地址: '桃園市桃園區延壽街169號171號',
    縣市: '桃園市'
  },
  {
    店號: 922474,
    店名: '八角店',
    地址: '桃園市蘆竹區大竹路5號',
    縣市: '桃園市'
  },
  {
    店號: 922485,
    店名: '比利',
    地址: '桃園市平鎮區上海路161號',
    縣市: '桃園市'
  },
  {
    店號: 922555,
    店名: '龍潭友',
    地址: '桃園市龍潭區三和里新和路1號',
    縣市: '桃園市'
  },
  {
    店號: 922625,
    店名: '環福',
    地址: '桃園市中壢區普忠路213號',
    縣市: '桃園市'
  },
  {
    店號: 923569,
    店名: '庚林',
    地址: '桃園市龜山區頂湖路123號B2',
    縣市: '桃園市'
  },
  {
    店號: 924528,
    店名: '楊陳',
    地址: '桃園市楊梅區環東路497號499號1樓',
    縣市: '桃園市'
  },
  {
    店號: 924573,
    店名: '嶺頂',
    地址: '桃園市龜山區萬壽路二段6巷35號',
    縣市: '桃園市'
  },
  {
    店號: 924654,
    店名: '士香',
    地址: '桃園市大溪區員林路一段228號',
    縣市: '桃園市'
  },
  {
    店號: 924986,
    店名: '明光',
    地址: '桃園市八德區中華路157號',
    縣市: '桃園市'
  },
  {
    店號: 930121,
    店名: '憲訓',
    地址: '桃園市龜山區文化三路1-1號',
    縣市: '桃園市'
  },
  {
    店號: 930925,
    店名: '高安',
    地址: '桃園市平鎮區民族路三段95號',
    縣市: '桃園市'
  },
  {
    店號: 931456,
    店名: '德勇',
    地址: '桃園市八德區大勇里忠勇街365號',
    縣市: '桃園市'
  },
  {
    店號: 932150,
    店名: '養生村',
    地址: '桃園市龜山區長青路2號A棟',
    縣市: '桃園市'
  },
  {
    店號: 932426,
    店名: '山民',
    地址: '桃園市龜山區三民路100號',
    縣市: '桃園市'
  },
  {
    店號: 933016,
    店名: '苙佑',
    地址: '桃園市楊梅區梅高路133號',
    縣市: '桃園市'
  },
  {
    店號: 933050,
    店名: '埔頂',
    地址: '桃園市大溪區仁愛里埔頂路一段468號',
    縣市: '桃園市'
  },
  {
    店號: 934695,
    店名: '夜市',
    地址: '桃園市中壢區中央西路二段125號',
    縣市: '桃園市'
  },
  {
    店號: 935089,
    店名: '福神',
    地址: '桃園市中壢區福德路79號81號',
    縣市: '桃園市'
  },
  {
    店號: 940058,
    店名: '國豐',
    地址: '桃園市桃園區國豐六街25號',
    縣市: '桃園市'
  },
  {
    店號: 940106,
    店名: '世紀廣',
    地址: '桃園市中壢區興南里新生路182號',
    縣市: '桃園市'
  },
  {
    店號: 941132,
    店名: '錦坎',
    地址: '桃園市蘆竹區南崁路一段76號78號',
    縣市: '桃園市'
  },
  {
    店號: 941338,
    店名: '吉富',
    地址: '桃園市八德區白鷺里永豐南路72號',
    縣市: '桃園市'
  },
  {
    店號: 941752,
    店名: '仁冠',
    地址: '桃園市大溪區仁和路二段319號321號',
    縣市: '桃園市'
  },
  {
    店號: 942032,
    店名: '園山',
    地址: '桃園市大園區民族街1號',
    縣市: '桃園市'
  },
  {
    店號: 942102,
    店名: '金沅',
    地址: '桃園市平鎮區東勢里金陵路五段255號',
    縣市: '桃園市'
  },
  {
    店號: 942113,
    店名: '茗安',
    地址: '桃園市八德區陸光街45號',
    縣市: '桃園市'
  },
  {
    店號: 942216,
    店名: '龜山廣',
    地址: '桃園市龜山區文化二路211號',
    縣市: '桃園市'
  },
  {
    店號: 942401,
    店名: '楊民',
    地址: '桃園市楊梅區三民北路177號',
    縣市: '桃園市'
  },
  {
    店號: 943895,
    店名: '臻愛',
    地址: '桃園市桃園區大業路一段152號',
    縣市: '桃園市'
  },
  {
    店號: 943954,
    店名: '冠成',
    地址: '桃園市八德區重慶街172號',
    縣市: '桃園市'
  },
  {
    店號: 944197,
    店名: '華愛',
    地址: '桃園市中壢區華美一路132號136號1樓',
    縣市: '桃園市'
  },
  {
    店號: 944544,
    店名: '東懋',
    地址: '桃園市大園區和平西路一段272號274號',
    縣市: '桃園市'
  },
  {
    店號: 944566,
    店名: '福音',
    地址: '桃園市觀音區新生路1467之1號1樓五福三街83號1樓',
    縣市: '桃園市'
  },
  {
    店號: 944717,
    店名: '耀康',
    地址: '桃園市中壢區溪洲街267巷1號一樓',
    縣市: '桃園市'
  },
  {
    店號: 948650,
    店名: '金凱旋',
    地址: '桃園市桃園區壽昌街20巷45號47號',
    縣市: '桃園市'
  },
  {
    店號: 951036,
    店名: '蘆坎',
    地址: '桃園市蘆竹區南崁里南華一街142號一樓',
    縣市: '桃園市'
  },
  {
    店號: 951162,
    店名: '高正',
    地址: '桃園市中壢區中正路三段134號136號一樓',
    縣市: '桃園市'
  },
  {
    店號: 951597,
    店名: '興美',
    地址: '桃園市中壢區興國路85號87號一樓',
    縣市: '桃園市'
  },
  {
    店號: 952143,
    店名: '廣文',
    地址: '桃園市平鎮區復興里文化街241號',
    縣市: '桃園市'
  },
  {
    店號: 952279,
    店名: '竹盈',
    地址: '桃園市蘆竹區大竹里大新路133號1-3樓',
    縣市: '桃園市'
  },
  {
    店號: 952327,
    店名: '蘆航',
    地址: '桃園市蘆竹區南興里南昌路18號1樓',
    縣市: '桃園市'
  },
  {
    店號: 952707,
    店名: '新龍鄉',
    地址: '桃園市龍潭區民族路168號170號172號1樓',
    縣市: '桃園市'
  },
  {
    店號: 952981,
    店名: '瑋特',
    地址: '桃園市平鎮區延平路三段246號248號一樓',
    縣市: '桃園市'
  },
  {
    店號: 953870,
    店名: '盧興',
    地址: '桃園市蘆竹區內展里長興路三段231號1樓',
    縣市: '桃園市'
  },
  {
    店號: 953917,
    店名: '瑞員',
    地址: '桃園市大溪區員林路三段157號1樓',
    縣市: '桃園市'
  },
  {
    店號: 954622,
    店名: '新屋中',
    地址: '桃園市新屋區中華路357號1樓',
    縣市: '桃園市'
  },
  {
    店號: 954699,
    店名: '義展',
    地址: '桃園市八德區義勇街151號151-1號1樓',
    縣市: '桃園市'
  },
  {
    店號: 954895,
    店名: '新康莊',
    地址: '桃園市大溪區復興路31號1樓',
    縣市: '桃園市'
  },
  {
    店號: 957034,
    店名: '新壢揚',
    地址: '桃園市中壢區中山路138號',
    縣市: '桃園市'
  },
  {
    店號: 957377,
    店名: '龍行',
    地址: '桃園市桃園區力行路156號1樓',
    縣市: '桃園市'
  },
  {
    店號: 957388,
    店名: '新德鴻',
    地址: '桃園市桃園區永福西街111號113號',
    縣市: '桃園市'
  },
  {
    店號: 957768,
    店名: '光峰',
    地址: '桃園市龜山區楓樹里光峰路296號298號一樓',
    縣市: '桃園市'
  },
  {
    店號: 958015,
    店名: '海和',
    地址: '桃園市中壢區六和路66號68號',
    縣市: '桃園市'
  },
  {
    店號: 963327,
    店名: '冠吾',
    地址: '桃園市桃園區中正路455號',
    縣市: '桃園市'
  },
  {
    店號: 963350,
    店名: '龍翔',
    地址: '桃園市中壢區普義路175號175之1號',
    縣市: '桃園市'
  },
  {
    店號: 963408,
    店名: '富邑',
    地址: '桃園市桃園區龍祥里龍泉五街82號龍祥街98號',
    縣市: '桃園市'
  },
  {
    店號: 963626,
    店名: '家權',
    地址: '桃園市中壢區民權路二段98號',
    縣市: '桃園市'
  },
  {
    店號: 965378,
    店名: '豐亞',
    地址: '桃園市中壢區民族路六段232號236號1樓',
    縣市: '桃園市'
  },
  {
    店號: 965758,
    店名: '龍美',
    地址: '桃園市龍潭區民豐路3號4號5號1樓',
    縣市: '桃園市'
  },
  {
    店號: 965965,
    店名: '聖興',
    地址: '桃園市龍潭區聖亭路186號1樓',
    縣市: '桃園市'
  },
  {
    店號: 966038,
    店名: '景碩一',
    地址: '桃園市新屋區中華路1245號3樓',
    縣市: '桃園市'
  },
  {
    店號: 966083,
    店名: '景碩新',
    地址: '桃園市新屋區中華路810號1樓',
    縣市: '桃園市'
  },
  {
    店號: 967097,
    店名: '埔東',
    地址: '桃園市大園區埔心里中正東路一段165號1樓',
    縣市: '桃園市'
  },
  {
    店號: 967145,
    店名: '高山頂',
    地址: '桃園市楊梅區幼獅路二段297-1號',
    縣市: '桃園市'
  },
  {
    店號: 967271,
    店名: '高欣',
    地址: '桃園市中壢區領航南路二段208號1樓',
    縣市: '桃園市'
  },
  {
    店號: 968137,
    店名: '觀喜',
    地址: '桃園市觀音區中山路一段1159號之1號',
    縣市: '桃園市'
  },
  {
    店號: 968160,
    店名: '萬興',
    地址: '桃園市中壢區月眉路二段357號1樓部份',
    縣市: '桃園市'
  },
  {
    店號: 968919,
    店名: '楊崧',
    地址: '桃園市平鎮區復旦路二段123-5;123-6號1樓',
    縣市: '桃園市'
  },
  {
    店號: 970624,
    店名: '龍侑',
    地址: '桃園市平鎮區龍德路8號1樓;龍福路1號1樓',
    縣市: '桃園市'
  },
  {
    店號: 970635,
    店名: '統上',
    地址: '桃園市中壢區新中北路465號1樓',
    縣市: '桃園市'
  },
  {
    店號: 971616,
    店名: '新長明',
    地址: '桃園市龜山區復興一路62號1樓',
    縣市: '桃園市'
  },
  {
    店號: 972310,
    店名: '忠湖',
    地址: '桃園市龜山區忠義路二段630號',
    縣市: '桃園市'
  },
  {
    店號: 972608,
    店名: '紹福',
    地址: '桃園市龍潭區五福街210號',
    縣市: '桃園市'
  },
  {
    店號: 973036,
    店名: '新友達',
    地址: '桃園市龍潭區三和里新和路1號B棟7樓',
    縣市: '桃園市'
  },
  {
    店號: 976389,
    店名: '新大興',
    地址: '桃園市桃園區大興西路二段253號1樓',
    縣市: '桃園市'
  },
  {
    店號: 977164,
    店名: '興龍',
    地址: '桃園市龜山區新路里中興路366-6號1樓2樓',
    縣市: '桃園市'
  },
  {
    店號: 977614,
    店名: '正湧',
    地址: '桃園市平鎮區正義路82號1樓',
    縣市: '桃園市'
  },
  {
    店號: 977991,
    店名: '蜜鄰',
    地址: '桃園市桃園區龍壽街96號98號',
    縣市: '桃園市'
  },
  {
    店號: 981037,
    店名: '新光信',
    地址: '桃園市桃園區中正路612號',
    縣市: '桃園市'
  },
  {
    店號: 982063,
    店名: '正神',
    地址: '桃園市中壢區成章一街10號12號1樓2樓',
    縣市: '桃園市'
  },
  {
    店號: 982144,
    店名: '宏達電',
    地址: '桃園市桃園區興華路23號',
    縣市: '桃園市'
  },
  {
    店號: 982214,
    店名: '鑫華夏',
    地址: '桃園市龜山區文化二路28-1號28-2號28-3號1樓',
    縣市: '桃園市'
  },
  {
    店號: 982557,
    店名: '駿躍',
    地址: '桃園市楊梅區環南路132號1樓',
    縣市: '桃園市'
  },
  {
    店號: 982890,
    店名: '欣富晟',
    地址: '桃園市觀音區草漯里大觀路二段312-1號',
    縣市: '桃園市'
  },
  {
    店號: 985143,
    店名: '華亞文',
    地址: '桃園市龜山區文化一路86之55號',
    縣市: '桃園市'
  },
  {
    店號: 985408,
    店名: '龍潭佳',
    地址: '桃園市龍潭區中正路三坑段776號1樓',
    縣市: '桃園市'
  },
  {
    店號: 985877,
    店名: '金鋒',
    地址: '桃園市中壢區金鋒四街50巷2號1樓',
    縣市: '桃園市'
  },
  {
    店號: 987862,
    店名: '昇宏',
    地址: '桃園市桃園區大業路二段111號之2',
    縣市: '桃園市'
  },
  {
    店號: 987910,
    店名: '維瀚',
    地址: '桃園市桃園區中埔六街36號1樓',
    縣市: '桃園市'
  },
  {
    店號: 987976,
    店名: '廣智',
    地址: '桃園市龜山區復興一路392-1號',
    縣市: '桃園市'
  },
  {
    店號: 988278,
    店名: '內柵',
    地址: '桃園市大溪區康莊路三段20號',
    縣市: '桃園市'
  },
  {
    店號: 988289,
    店名: '桃金',
    地址: '桃園市桃園區金門2街83號及93號',
    縣市: '桃園市'
  },
  {
    店號: 989064,
    店名: '仕新',
    地址: '桃園市中壢區日新路112號',
    縣市: '桃園市'
  },
  {
    店號: 990400,
    店名: '金平',
    地址: '桃園市平鎮區東勢里金陵路四段485號1樓',
    縣市: '桃園市'
  },
  {
    店號: 990422,
    店名: '友達電',
    地址: '桃園市龜山區華亞二路189號B1',
    縣市: '桃園市'
  },
  {
    店號: 991300,
    店名: '瑞家',
    地址: '桃園市桃園區三民路三段84號86號1樓',
    縣市: '桃園市'
  },
  {
    店號: 991595,
    店名: '新中華',
    地址: '桃園市中壢區中華路二段328號',
    縣市: '桃園市'
  },
  {
    店號: 992211,
    店名: '江園',
    地址: '桃園市大園區中正東路三段620號',
    縣市: '桃園市'
  },
  {
    店號: 992462,
    店名: '富有',
    地址: '桃園市桃園區富國路656號',
    縣市: '桃園市'
  },
  {
    店號: 992510,
    店名: '台茂城',
    地址: '桃園市蘆竹區南崁路一段112號2樓',
    縣市: '桃園市'
  },
  {
    店號: 992657,
    店名: '鎮業',
    地址: '桃園市平鎮區南豐路238號240號1樓',
    縣市: '桃園市'
  },
  {
    店號: 992716,
    店名: '忠愛莊',
    地址: '桃園市觀音區忠愛路一段90號92號1樓',
    縣市: '桃園市'
  },
  {
    店號: 992738,
    店名: '汶興',
    地址: '桃園市龜山區頂興路31-1號1樓',
    縣市: '桃園市'
  },
  {
    店號: 992831,
    店名: '星寶',
    地址: '桃園市桃園區大業路一段426號1樓',
    縣市: '桃園市'
  },
  {
    店號: 993502,
    店名: '航竹',
    地址: '桃園市蘆竹區大竹路408號',
    縣市: '桃園市'
  },
  {
    店號: 996475,
    店名: '德僑',
    地址: '桃園市八德區豐德路31號1樓',
    縣市: '桃園市'
  },
  {
    店號: 997515,
    店名: '豐訊',
    地址: '桃園市平鎮區中豐路山頂段479號',
    縣市: '桃園市'
  },
  {
    店號: 997870,
    店名: '泰昌',
    地址: '桃園市桃園區泰昌三街51-6號',
    縣市: '桃園市'
  },
  {
    店號: 110105,
    店名: '篤明',
    地址: '新竹市東區林森路184號',
    縣市: '新竹市'
  },
  {
    店號: 112466,
    店名: '聖華',
    地址: '新竹市北區西濱路一段399號',
    縣市: '新竹市'
  },
  {
    店號: 113218,
    店名: '華鑫',
    地址: '新竹市香山區五福路二段725、727、729號1樓',
    縣市: '新竹市'
  },
  {
    店號: 118589,
    店名: '關東',
    地址: '新竹市東區金山里光復路一段187、189號1樓',
    縣市: '新竹市'
  },
  {
    店號: 118730,
    店名: '竹陵',
    地址: '新竹市北區東大路二段174號',
    縣市: '新竹市'
  },
  {
    店號: 120010,
    店名: '冠盈',
    地址: '新竹市北區西濱路一段286號',
    縣市: '新竹市'
  },
  {
    店號: 120962,
    店名: '耀明',
    地址: '新竹市東區南大路521號1樓',
    縣市: '新竹市'
  },
  {
    店號: 121150,
    店名: '宏欣',
    地址: '新竹市東區金山街152號156號1樓',
    縣市: '新竹市'
  },
  {
    店號: 121415,
    店名: '交大',
    地址: '新竹市東區大學路1001號(第二餐廳)',
    縣市: '新竹市'
  },
  {
    店號: 122706,
    店名: '厚稼',
    地址: '新竹市北區鐵道路二段280號',
    縣市: '新竹市'
  },
  {
    店號: 122979,
    店名: '明瑚',
    地址: '新竹市東區明湖路410號1樓',
    縣市: '新竹市'
  },
  {
    店號: 123190,
    店名: '寶豐',
    地址: '新竹市東區高峰路536巷58號之1',
    縣市: '新竹市'
  },
  {
    店號: 123411,
    店名: '松邑',
    地址: '新竹市香山區牛埔南路2號',
    縣市: '新竹市'
  },
  {
    店號: 124621,
    店名: '雅新',
    地址: '新竹市北區湳雅街154號',
    縣市: '新竹市'
  },
  {
    店號: 126410,
    店名: '聯電T',
    地址: '新竹市東區力行二路3號7樓',
    縣市: '新竹市'
  },
  {
    店號: 126524,
    店名: '香江',
    地址: '新竹市香山區中華路六段428-430號',
    縣市: '新竹市'
  },
  {
    店號: 130833,
    店名: '泰一',
    地址: '新竹市東區中華路二段668號',
    縣市: '新竹市'
  },
  {
    店號: 130925,
    店名: '岦湖',
    地址: '新竹市香山區內湖路138號1樓',
    縣市: '新竹市'
  },
  {
    店號: 130936,
    店名: '東埔',
    地址: '新竹市香山區牛埔路146號',
    縣市: '新竹市'
  },
  {
    店號: 131386,
    店名: '建盛',
    地址: '新竹市東區建中一路52號1樓',
    縣市: '新竹市'
  },
  {
    店號: 132297,
    店名: '空軍',
    地址: '新竹市北區中正路385號387號1樓',
    縣市: '新竹市'
  },
  {
    店號: 135861,
    店名: '保忠',
    地址: '新竹市東區忠孝路1號',
    縣市: '新竹市'
  },
  {
    店號: 136152,
    店名: '宏光',
    地址: '新竹市北區光華一街29號1樓',
    縣市: '新竹市'
  },
  {
    店號: 137030,
    店名: '新竹民',
    地址: '新竹市東區民族路114號116號1樓',
    縣市: '新竹市'
  },
  {
    店號: 137694,
    店名: '智邦',
    地址: '新竹市東區科學工業園區研新三路1號',
    縣市: '新竹市'
  },
  {
    店號: 138158,
    店名: '大遠百',
    地址: '新竹市東區西門街105號',
    縣市: '新竹市'
  },
  {
    店號: 141590,
    店名: '竹高',
    地址: '新竹市東區東山街17號19號21號1樓',
    縣市: '新竹市'
  },
  {
    店號: 141855,
    店名: '新站',
    地址: '新竹市東區榮光里林森路7號中華路二段458號',
    縣市: '新竹市'
  },
  {
    店號: 142010,
    店名: '育賢',
    地址: '新竹市東區南大路611號613號1樓',
    縣市: '新竹市'
  },
  {
    店號: 142629,
    店名: '金山六',
    地址: '新竹市東區金山六街51號1樓',
    縣市: '新竹市'
  },
  {
    店號: 143806,
    店名: '埔竹',
    地址: '新竹市東區埔頂二路148號1樓',
    縣市: '新竹市'
  },
  {
    店號: 143828,
    店名: '新豪康',
    地址: '新竹市香山區元培街371號1樓',
    縣市: '新竹市'
  },
  {
    店號: 149170,
    店名: '民富',
    地址: '新竹市北區新民里西大路642號',
    縣市: '新竹市'
  },
  {
    店號: 149181,
    店名: '海天',
    地址: '新竹市香山區海埔路136號',
    縣市: '新竹市'
  },
  {
    店號: 150723,
    店名: '新大',
    地址: '新竹市北區東大路三段2號',
    縣市: '新竹市'
  },
  {
    店號: 150767,
    店名: '佳香',
    地址: '新竹市香山區中華路六段六十之一、六十之二號1樓',
    縣市: '新竹市'
  },
  {
    店號: 151656,
    店名: '香圃',
    地址: '新竹市香山區牛埔東路253號1樓',
    縣市: '新竹市'
  },
  {
    店號: 154666,
    店名: '關圓',
    地址: '新竹市東區關東路56號1樓',
    縣市: '新竹市'
  },
  {
    店號: 154828,
    店名: '青草湖',
    地址: '新竹市東區明湖里明湖路3鄰1012-1號',
    縣市: '新竹市'
  },
  {
    店號: 155131,
    店名: '富首',
    地址: '新竹市東區慈濟路230號1樓',
    縣市: '新竹市'
  },
  {
    店號: 155142,
    店名: '高灃',
    地址: '新竹市東區高翠路331號1樓',
    縣市: '新竹市'
  },
  {
    店號: 155197,
    店名: '風城',
    地址: '新竹市東區民權路181號1樓',
    縣市: '新竹市'
  },
  {
    店號: 155290,
    店名: '東妮',
    地址: '新竹市北區東大路三段718號720號1樓',
    縣市: '新竹市'
  },
  {
    店號: 155647,
    店名: '千甲',
    地址: '新竹市東區千甲路235號',
    縣市: '新竹市'
  },
  {
    店號: 164467,
    店名: '竹灣',
    地址: '新竹市北區客雃里延平路一段252號1樓',
    縣市: '新竹市'
  },
  {
    店號: 164962,
    店名: '清大',
    地址: '新竹市東區光復路二段101號',
    縣市: '新竹市'
  },
  {
    店號: 165851,
    店名: '矽導',
    地址: '新竹市東區力行一路1號',
    縣市: '新竹市'
  },
  {
    店號: 166348,
    店名: '雙民',
    地址: '新竹市東區民族路205號1樓',
    縣市: '新竹市'
  },
  {
    店號: 167444,
    店名: '隆華',
    地址: '新竹市香山區中華路五段193號1樓',
    縣市: '新竹市'
  },
  {
    店號: 167994,
    店名: '菄大',
    地址: '新竹市北區東大路四段258.260號1樓',
    縣市: '新竹市'
  },
  {
    店號: 170853,
    店名: '晏丞',
    地址: '新竹市東區振興路50號1樓',
    縣市: '新竹市'
  },
  {
    店號: 173922,
    店名: '竹光',
    地址: '新竹市北區文雅里18鄰竹光路123號',
    縣市: '新竹市'
  },
  {
    店號: 174176,
    店名: '竹森',
    地址: '新竹市北區光華東街105.107號',
    縣市: '新竹市'
  },
  {
    店號: 179654,
    店名: '宏遠',
    地址: '新竹市東區金山十五街1號1樓',
    縣市: '新竹市'
  },
  {
    店號: 180090,
    店名: '文清',
    地址: '新竹市東區建功路49號1.2樓',
    縣市: '新竹市'
  },
  {
    店號: 180263,
    店名: '鎵華',
    地址: '新竹市香山區中華路六段131.133.135號1樓',
    縣市: '新竹市'
  },
  {
    店號: 180403,
    店名: '竹博',
    地址: '新竹市東區民生路226號',
    縣市: '新竹市'
  },
  {
    店號: 181233,
    店名: '明泰科',
    地址: '新竹市東區力行七路8號B1樓',
    縣市: '新竹市'
  },
  {
    店號: 181439,
    店名: '磐石',
    地址: '新竹市北區西大路740號1樓',
    縣市: '新竹市'
  },
  {
    店號: 181749,
    店名: '欽天',
    地址: '新竹市北區成德路123號',
    縣市: '新竹市'
  },
  {
    店號: 181820,
    店名: '力成捌',
    地址: '新竹市東區力行三路15號6樓',
    縣市: '新竹市'
  },
  {
    店號: 184025,
    店名: '新悅',
    地址: '新竹市北區經國路二段188號190號1樓',
    縣市: '新竹市'
  },
  {
    店號: 184520,
    店名: 'GRC',
    地址: '新竹市東區工業東三路1號1樓',
    縣市: '新竹市'
  },
  {
    店號: 185257,
    店名: '藍海',
    地址: '新竹市東區關新路21號1樓',
    縣市: '新竹市'
  },
  {
    店號: 187183,
    店名: '豪運',
    地址: '新竹市香山區香北路181號183號',
    縣市: '新竹市'
  },
  {
    店號: 187323,
    店名: '聯電B',
    地址: '新竹市東區力行二路3號B1',
    縣市: '新竹市'
  },
  {
    店號: 188463,
    店名: '新雅竹',
    地址: '新竹市北區湳雅街255號',
    縣市: '新竹市'
  },
  {
    店號: 189606,
    店名: '竹運',
    地址: '新竹市東區中華路二段471號',
    縣市: '新竹市'
  },
  {
    店號: 192705,
    店名: '金鑫',
    地址: '新竹市東區金城一路50-9號',
    縣市: '新竹市'
  },
  {
    店號: 193122,
    店名: '北大門',
    地址: '新竹市北區北門街96號1樓',
    縣市: '新竹市'
  },
  {
    店號: 194619,
    店名: '寶捷',
    地址: '新竹市東區田美三街35號',
    縣市: '新竹市'
  },
  {
    店號: 194815,
    店名: '東珈',
    地址: '新竹市香山區中華路五段156號',
    縣市: '新竹市'
  },
  {
    店號: 195140,
    店名: '聯發D',
    地址: '新竹市東區力行三路11號',
    縣市: '新竹市'
  },
  {
    店號: 197526,
    店名: '科技城',
    地址: '新竹市東區工業東四路42號',
    縣市: '新竹市'
  },
  {
    店號: 197582,
    店名: '俊友',
    地址: '新竹市東區林森路81號',
    縣市: '新竹市'
  },
  {
    店號: 198699,
    店名: '聯發科',
    地址: '新竹市東區篤行一路1號',
    縣市: '新竹市'
  },
  {
    店號: 200147,
    店名: '東民',
    地址: '新竹市東區忠孝路149號',
    縣市: '新竹市'
  },
  {
    店號: 200435,
    店名: '緯創',
    地址: '新竹市東區新安路5號3樓之1',
    縣市: '新竹市'
  },
  {
    店號: 201807,
    店名: '科有',
    地址: '新竹市東區光復路一段531巷70-1號',
    縣市: '新竹市'
  },
  {
    店號: 201830,
    店名: '科管',
    地址: '新竹市東區新安路2號',
    縣市: '新竹市'
  },
  {
    店號: 202268,
    店名: '育英',
    地址: '新竹市北區育英里15鄰四維路53號1樓.西門街212號1樓',
    縣市: '新竹市'
  },
  {
    店號: 207285,
    店名: '頂福',
    地址: '新竹市香山區中山路622號626號',
    縣市: '新竹市'
  },
  {
    店號: 208761,
    店名: '聯發E',
    地址: '新竹市東區篤行路5號',
    縣市: '新竹市'
  },
  {
    店號: 210731,
    店名: '金橋',
    地址: '新竹市東區光復路一段89巷115.117.119號',
    縣市: '新竹市'
  },
  {
    店號: 211859,
    店名: '水水',
    地址: '新竹市東區水源街69號1樓',
    縣市: '新竹市'
  },
  {
    店號: 212151,
    店名: '添功',
    地址: '新竹市北區中山路436號',
    縣市: '新竹市'
  },
  {
    店號: 213604,
    店名: '新馬偕',
    地址: '新竹市東區光復路二段690號1樓',
    縣市: '新竹市'
  },
  {
    店號: 215194,
    店名: '新唐',
    地址: '新竹市東區研新三路4號2樓',
    縣市: '新竹市'
  },
  {
    店號: 215242,
    店名: '鳳美',
    地址: '新竹市東區中華路二段64號',
    縣市: '新竹市'
  },
  {
    店號: 215910,
    店名: '迎竹',
    地址: '新竹市東區大學路1001-2號',
    縣市: '新竹市'
  },
  {
    店號: 216175,
    店名: '華耀',
    地址: '新竹市香山區明德路1號1樓',
    縣市: '新竹市'
  },
  {
    店號: 216197,
    店名: '禾雅',
    地址: '新竹市東區鐵道路一段66號',
    縣市: '新竹市'
  },
  {
    店號: 216614,
    店名: '璟觀',
    地址: '新竹市香山區景觀大道830號1樓',
    縣市: '新竹市'
  },
  {
    店號: 216625,
    店名: '竹科',
    地址: '新竹市東區埔頂路8號',
    縣市: '新竹市'
  },
  {
    店號: 228433,
    店名: '東新',
    地址: '新竹市東區東新路86號',
    縣市: '新竹市'
  },
  {
    店號: 228732,
    店名: '閑古',
    地址: '新竹市香山區閑谷街27號.29號1樓',
    縣市: '新竹市'
  },
  {
    店號: 228961,
    店名: '豪順',
    地址: '新竹市香山區香山里瑞光街23號',
    縣市: '新竹市'
  },
  {
    店號: 229218,
    店名: '金士頓',
    地址: '新竹市東區力行一路1-5號B1樓',
    縣市: '新竹市'
  },
  {
    店號: 231129,
    店名: '巨城',
    地址: '新竹市東區中央路276號1、2樓',
    縣市: '新竹市'
  },
  {
    店號: 231200,
    店名: '武陵',
    地址: '新竹市北區武陵路63號1樓',
    縣市: '新竹市'
  },
  {
    店號: 231897,
    店名: '福大',
    地址: '新竹市香山鄉茄苳里五福路二段728號',
    縣市: '新竹市'
  },
  {
    店號: 233309,
    店名: '鴻川谷',
    地址: '新竹市東區埔頂二路101號',
    縣市: '新竹市'
  },
  {
    店號: 236755,
    店名: '金采',
    地址: '新竹市北區金雅路62號',
    縣市: '新竹市'
  },
  {
    店號: 237013,
    店名: '富盛',
    地址: '新竹市北區經國路2段346、348號1樓',
    縣市: '新竹市'
  },
  {
    店號: 238119,
    店名: '華國',
    地址: '新竹市東區中華路一段107號109號',
    縣市: '新竹市'
  },
  {
    店號: 238131,
    店名: '東香',
    地址: '新竹市香山區頂埔路2號',
    縣市: '新竹市'
  },
  {
    店號: 239673,
    店名: '關新',
    地址: '新竹市東區關新路179號1樓',
    縣市: '新竹市'
  },
  {
    店號: 240101,
    店名: '正御',
    地址: '新竹市北區中正路309號1+B1樓',
    縣市: '新竹市'
  },
  {
    店號: 240190,
    店名: '梅竹',
    地址: '新竹市東區光明里14鄰大學路56號58號60號',
    縣市: '新竹市'
  },
  {
    店號: 240488,
    店名: '南衫',
    地址: '新竹市東區南大路123.125號',
    縣市: '新竹市'
  },
  {
    店號: 241274,
    店名: '新揚',
    地址: '新竹市東區民生路149號151號153號1樓',
    縣市: '新竹市'
  },
  {
    店號: 249164,
    店名: '復全',
    地址: '新竹市東區新莊里長春街11.13號1樓',
    縣市: '新竹市'
  },
  {
    店號: 249810,
    店名: '東中',
    地址: '新竹市北區東門街194號1+B1樓',
    縣市: '新竹市'
  },
  {
    店號: 249821,
    店名: '竹城',
    地址: '新竹市北區西門里中山路100號',
    縣市: '新竹市'
  },
  {
    店號: 249832,
    店名: '恆新',
    地址: '新竹市北區民富里7鄰北大路342號',
    縣市: '新竹市'
  },
  {
    店號: 249946,
    店名: '水擇',
    地址: '新竹市北區水田里中正路194號',
    縣市: '新竹市'
  },
  {
    店號: 250016,
    店名: '公學',
    地址: '新竹市東區建功一路93號',
    縣市: '新竹市'
  },
  {
    店號: 250337,
    店名: '竹揚',
    地址: '新竹市東區文華里北大路38號',
    縣市: '新竹市'
  },
  {
    店號: 250511,
    店名: '金功',
    地址: '新竹市東區建功二路2號及6號1樓',
    縣市: '新竹市'
  },
  {
    店號: 250913,
    店名: '自興',
    地址: '新竹市東區自由路69號',
    縣市: '新竹市'
  },
  {
    店號: 250924,
    店名: '竹醫',
    地址: '新竹市東區鐵道路二段9號1樓',
    縣市: '新竹市'
  },
  {
    店號: 251248,
    店名: '科園',
    地址: '新竹市東區科學園路45號',
    縣市: '新竹市'
  },
  {
    店號: 852724,
    店名: '孟竹',
    地址: '新竹市東區軍功里16鄰建新路26號1樓',
    縣市: '新竹市'
  },
  {
    店號: 864808,
    店名: '城北',
    地址: '新竹市北區城北街43號',
    縣市: '新竹市'
  },
  {
    店號: 874609,
    店名: '高清',
    地址: '新竹市東區建功里建功路6號1樓',
    縣市: '新竹市'
  },
  {
    店號: 902849,
    店名: '台積-1',
    地址: '新竹市東區力行六路8號',
    縣市: '新竹市'
  },
  {
    店號: 920032,
    店名: '千久',
    地址: '新竹市東區民主路154號156號',
    縣市: '新竹市'
  },
  {
    店號: 920216,
    店名: '翊銘',
    地址: '新竹市東區新莊街182號186號',
    縣市: '新竹市'
  },
  {
    店號: 921046,
    店名: '鑫昌',
    地址: '新竹市東區復興路34號1樓',
    縣市: '新竹市'
  },
  {
    店號: 922566,
    店名: '新竹友',
    地址: '新竹市東區科學園區力行二路1號',
    縣市: '新竹市'
  },
  {
    店號: 922577,
    店名: '友達五',
    地址: '新竹市東區力行路23號6樓',
    縣市: '新竹市'
  },
  {
    店號: 924919,
    店名: '學英',
    地址: '新竹市東區學府路37號',
    縣市: '新竹市'
  },
  {
    店號: 932183,
    店名: '祥園',
    地址: '新竹市香山區牛埔北路50號',
    縣市: '新竹市'
  },
  {
    店號: 932862,
    店名: '福盛',
    地址: '新竹市北區鐵道路三段2號',
    縣市: '新竹市'
  },
  {
    店號: 941914,
    店名: '新親仁',
    地址: '新竹市東區親仁里仁愛街30號1樓',
    縣市: '新竹市'
  },
  {
    店號: 942191,
    店名: '佑忠',
    地址: '新竹市東區忠孝路430號432號',
    縣市: '新竹市'
  },
  {
    店號: 942917,
    店名: '宏府',
    地址: '新竹市東區學府路164號',
    縣市: '新竹市'
  },
  {
    店號: 943046,
    店名: '新竹建',
    地址: '新竹市東區建華街2號1樓',
    縣市: '新竹市'
  },
  {
    店號: 943600,
    店名: '新竹延',
    地址: '新竹市香山區延平路二段82號84號',
    縣市: '新竹市'
  },
  {
    店號: 944326,
    店名: '天湖',
    地址: '新竹市東區明湖路180號',
    縣市: '新竹市'
  },
  {
    店號: 946241,
    店名: '香山',
    地址: '新竹市香山區牛埔路447號',
    縣市: '新竹市'
  },
  {
    店號: 947635,
    店名: '香華',
    地址: '新竹市香山區中華路四段602號604號',
    縣市: '新竹市'
  },
  {
    店號: 950033,
    店名: '盛天',
    地址: '新竹市北區延平路三段545號',
    縣市: '新竹市'
  },
  {
    店號: 951678,
    店名: '里客',
    地址: '新竹市東區民族路7號1樓',
    縣市: '新竹市'
  },
  {
    店號: 953478,
    店名: '新世界',
    地址: '新竹市北區中正路121號',
    縣市: '新竹市'
  },
  {
    店號: 957687,
    店名: '大潤',
    地址: '新竹市北區湳雅里22鄰湳雅街46號',
    縣市: '新竹市'
  },
  {
    店號: 970451,
    店名: '世界先',
    地址: '新竹市東區力行路9號2樓',
    縣市: '新竹市'
  },
  {
    店號: 972240,
    店名: '鑫八廠',
    地址: '新竹市東區力行路25號2樓',
    縣市: '新竹市'
  },
  {
    店號: 972262,
    店名: '煙波',
    地址: '新竹市東區明湖路967號1樓',
    縣市: '新竹市'
  },
  {
    店號: 976688,
    店名: '正國',
    地址: '新竹市北區中正路286之1號一樓',
    縣市: '新竹市'
  },
  {
    店號: 980735,
    店名: '鑫旭升',
    地址: '新竹市東區東南街98號1樓',
    縣市: '新竹市'
  },
  {
    店號: 980791,
    店名: '東環',
    地址: '新竹市東區東門街36號1樓',
    縣市: '新竹市'
  },
  {
    店號: 985796,
    店名: '海寶',
    地址: '新竹市北區海濱里榮濱路1號',
    縣市: '新竹市'
  },
  {
    店號: 985866,
    店名: '世達',
    地址: '新竹市北區延平路一段159號1樓',
    縣市: '新竹市'
  },
  {
    店號: 991056,
    店名: '聯電F',
    地址: '新竹市東區力行六路3號B1樓',
    縣市: '新竹市'
  },
  {
    店號: 991067,
    店名: '聯電E',
    地址: '新竹市東區力行路17號7樓',
    縣市: '新竹市'
  },
  {
    店號: 991506,
    店名: '新勝',
    地址: '新竹市東區東光路75號1樓',
    縣市: '新竹市'
  },
  {
    店號: 992864,
    店名: '金山街',
    地址: '新竹市東區金山街30號1樓',
    縣市: '新竹市'
  },
  {
    店號: 993786,
    店名: '揚明',
    地址: '新竹市東區新安路7號',
    縣市: '新竹市'
  },
  {
    店號: 996660,
    店名: '東品',
    地址: '新竹市東區食品路146號1樓',
    縣市: '新竹市'
  },
  {
    店號: 110699,
    店名: '耕新',
    地址: '新竹縣湖口鄉成功路276號',
    縣市: '新竹縣'
  },
  {
    店號: 112802,
    店名: '六家',
    地址: '新竹縣竹北市福興東路二段105號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 121459,
    店名: '新康',
    地址: '新竹縣新豐鄉松林村7鄰康樂路一段216號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 121460,
    店名: '冠華',
    地址: '新竹縣新豐鄉忠孝村員山148之2號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 122038,
    店名: '宇軒',
    地址: '新竹縣竹北市勝利二路85號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 122290,
    店名: '台積P6',
    地址: '新竹縣寶山鄉新竹科學園區園區二路166號',
    縣市: '新竹縣'
  },
  {
    店號: 122603,
    店名: '首璽',
    地址: '新竹縣竹北市自強六街13號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 123189,
    店名: '嘉豐',
    地址: '新竹縣竹北市嘉豐北路76號78號',
    縣市: '新竹縣'
  },
  {
    店號: 123352,
    店名: '明新',
    地址: '新竹縣新豐鄉新興路7號',
    縣市: '新竹縣'
  },
  {
    店號: 123363,
    店名: '湖口',
    地址: '新竹縣湖口鄉中正路一段36號',
    縣市: '新竹縣'
  },
  {
    店號: 124687,
    店名: '飛凰',
    地址: '新竹縣芎林鄉富林路二段729號',
    縣市: '新竹縣'
  },
  {
    店號: 126340,
    店名: '新豐新',
    地址: '新竹縣新豐鄉新庄路383號',
    縣市: '新竹縣'
  },
  {
    店號: 126672,
    店名: '四重埔',
    地址: '新竹縣竹東鎮中興路一段157號',
    縣市: '新竹縣'
  },
  {
    店號: 127343,
    店名: '豐鈴',
    地址: '新竹縣湖口鄉安宅四街2號',
    縣市: '新竹縣'
  },
  {
    店號: 127402,
    店名: '華盛',
    地址: '新竹縣竹北市新社里華興街68號',
    縣市: '新竹縣'
  },
  {
    店號: 130338,
    店名: '台積電',
    地址: '新竹縣寶山鄉研新二路6號',
    縣市: '新竹縣'
  },
  {
    店號: 130475,
    店名: '關西',
    地址: '新竹縣關西鎮正義路286-1號',
    縣市: '新竹縣'
  },
  {
    店號: 130707,
    店名: '菄族',
    地址: '新竹縣竹東鎮民族路66號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 131098,
    店名: '十興',
    地址: '新竹縣竹北市莊敬北路130號',
    縣市: '新竹縣'
  },
  {
    店號: 131272,
    店名: '寶雅',
    地址: '新竹縣寶山鄉大崎村大雅路二段103巷15號',
    縣市: '新竹縣'
  },
  {
    店號: 131456,
    店名: '竹崙',
    地址: '新竹縣竹北市中華路153號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 131629,
    店名: '竹東',
    地址: '新竹縣竹東鎮學前路29號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 131755,
    店名: '鑫力成',
    地址: '新竹縣湖口鄉大同路10號6樓',
    縣市: '新竹縣'
  },
  {
    店號: 132356,
    店名: '埔義',
    地址: '新竹縣新埔鎮下寮里義民路三段317號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 136576,
    店名: '新縣福',
    地址: '新竹縣竹北市縣政二路414號416號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 137524,
    店名: '冠宇',
    地址: '新竹縣新豐鄉忠孝路1號',
    縣市: '新竹縣'
  },
  {
    店號: 137535,
    店名: '埔田',
    地址: '新竹縣新埔鎮中正路5號7號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 141556,
    店名: '達陞',
    地址: '新竹縣湖口鄉中山路一段537號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 141659,
    店名: '石光',
    地址: '新竹縣關西鎮石光里石岡子252號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 141718,
    店名: '豐鼎',
    地址: '新竹縣湖口鄉光復東路8號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 142098,
    店名: '縣汶',
    地址: '新竹縣竹北市縣政二路233號235號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 142515,
    店名: '竹北中',
    地址: '新竹縣竹北市中華路881號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 142559,
    店名: '博明',
    地址: '新竹縣竹北市博愛街235號237號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 142928,
    店名: '華科',
    地址: '新竹縣橫山鄉橫山村9鄰中豐路一段100號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 143552,
    店名: '台積',
    地址: '新竹縣寶山鄉園區二路168號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 143817,
    店名: '國碩',
    地址: '新竹縣湖口鄉工業一路3號5樓',
    縣市: '新竹縣'
  },
  {
    店號: 144739,
    店名: '縣科',
    地址: '新竹縣竹北市縣政二路南段103號',
    縣市: '新竹縣'
  },
  {
    店號: 144843,
    店名: '崠豪',
    地址: '新竹縣竹東鎮東林路103號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 144865,
    店名: '東宏',
    地址: '新竹縣竹東鎮中正路217號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 149310,
    店名: '文樂',
    地址: '新竹縣湖口鄉文化路55號',
    縣市: '新竹縣'
  },
  {
    店號: 149701,
    店名: '縣運',
    地址: '新竹縣竹北市莊敬南路21號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 153537,
    店名: '強利',
    地址: '新竹縣竹北市自強北路111號',
    縣市: '新竹縣'
  },
  {
    店號: 154002,
    店名: '文元',
    地址: '新竹縣竹北市台元二街1號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 154013,
    店名: '新埔',
    地址: '新竹縣新埔鎮中正路221號',
    縣市: '新竹縣'
  },
  {
    店號: 154080,
    店名: '積七',
    地址: '新竹縣寶山鄉園區二路170號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 154943,
    店名: '欣樂',
    地址: '新竹縣新豐鄉康樂路一段358號',
    縣市: '新竹縣'
  },
  {
    店號: 155429,
    店名: '東融',
    地址: '新竹縣竹東鎮中興路二段148號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 155599,
    店名: '德和',
    地址: '新竹縣湖口鄉德興路216號218號',
    縣市: '新竹縣'
  },
  {
    店號: 158082,
    店名: '隘口',
    地址: '新竹縣竹北市隘口二路27號',
    縣市: '新竹縣'
  },
  {
    店號: 158831,
    店名: '家興',
    地址: '新竹縣竹北市嘉豐五路二段168號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 161125,
    店名: '園區',
    地址: '新竹縣寶山鄉園區三路1號',
    縣市: '新竹縣'
  },
  {
    店號: 161181,
    店名: '竹豐',
    地址: '新竹縣竹東鎮中豐路三段93號95號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 164504,
    店名: '上員',
    地址: '新竹縣竹東鎮光明路538巷25號',
    縣市: '新竹縣'
  },
  {
    店號: 165002,
    店名: '富正',
    地址: '新竹縣竹東鎮東寧路一段261號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 165013,
    店名: '昌春',
    地址: '新竹縣竹東鎮長春路三段26號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 165208,
    店名: '強鹿',
    地址: '新竹縣竹北市自強北路256號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 165493,
    店名: '明采',
    地址: '新竹縣竹北市光明一路158號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 166854,
    店名: '埔和',
    地址: '新竹縣新豐鄉埔和村埔頂281之1號',
    縣市: '新竹縣'
  },
  {
    店號: 167606,
    店名: '埔昌',
    地址: '新竹縣新埔鎮義民路一段92號',
    縣市: '新竹縣'
  },
  {
    店號: 167765,
    店名: '晨寶',
    地址: '新竹縣湖口鄉三民南路117號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 169842,
    店名: '明大',
    地址: '新竹縣新豐鄉松林村新興路1號',
    縣市: '新竹縣'
  },
  {
    店號: 169886,
    店名: '湖口廠',
    地址: '新竹縣湖口鄉八德路三段30號',
    縣市: '新竹縣'
  },
  {
    店號: 171351,
    店名: '新湖工',
    地址: '新竹縣湖口鄉中華路54號',
    縣市: '新竹縣'
  },
  {
    店號: 173807,
    店名: '聯新',
    地址: '新竹縣竹北市中正西路602號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 174327,
    店名: '強興',
    地址: '新竹縣竹北市自強北路223號',
    縣市: '新竹縣'
  },
  {
    店號: 180322,
    店名: '采虹',
    地址: '新竹縣竹北市勝利八街一段345.347號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 180399,
    店名: '隘心',
    地址: '新竹縣竹北市興隆路五段151號',
    縣市: '新竹縣'
  },
  {
    店號: 180528,
    店名: '騰達',
    地址: '新竹縣橫山鄉中豐路二段211號',
    縣市: '新竹縣'
  },
  {
    店號: 181059,
    店名: '東興',
    地址: '新竹縣竹東鎮北興路一段468號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 181602,
    店名: '大硯',
    地址: '新竹縣竹北市文興路311號',
    縣市: '新竹縣'
  },
  {
    店號: 181691,
    店名: '宥昌',
    地址: '新竹縣芎林鄉文富街100號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 181738,
    店名: '璞玉',
    地址: '新竹縣竹北市東興路二段39號',
    縣市: '新竹縣'
  },
  {
    店號: 181819,
    店名: '力成玖',
    地址: '新竹縣湖口鄉文化路4號B1樓',
    縣市: '新竹縣'
  },
  {
    店號: 181831,
    店名: '景碩',
    地址: '新竹縣新豐鄉建興路二段526號行政棟3樓',
    縣市: '新竹縣'
  },
  {
    店號: 182018,
    店名: '晨星科',
    地址: '新竹縣竹北市台元街18號7樓之1',
    縣市: '新竹縣'
  },
  {
    店號: 182720,
    店名: '縣政府',
    地址: '新竹縣竹北市光明六路10號',
    縣市: '新竹縣'
  },
  {
    店號: 182971,
    店名: '力成三',
    地址: '新竹縣湖口鄉大同路15之1號6樓',
    縣市: '新竹縣'
  },
  {
    店號: 183343,
    店名: '進一廠',
    地址: '新竹縣寶山鄉園區三路123號',
    縣市: '新竹縣'
  },
  {
    店號: 183985,
    店名: '加勝',
    地址: '新竹縣竹北市勝利八街二段63.65號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 186593,
    店名: '仁智',
    地址: '新竹縣湖口鄉仁和路38號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 186607,
    店名: '新瓦屋',
    地址: '新竹縣竹北市文興路一段172.176號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 187091,
    店名: '湖崗',
    地址: '新竹縣湖口鄉中山路二段430號',
    縣市: '新竹縣'
  },
  {
    店號: 188865,
    店名: '商華',
    地址: '新竹縣竹東鎮東寧路三段25號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 188979,
    店名: '東鑽',
    地址: '新竹縣竹東鎮北興路三段517號519號',
    縣市: '新竹縣'
  },
  {
    店號: 190721,
    店名: '中德',
    地址: '新竹縣北埔鄉北埔村中山路42號一樓',
    縣市: '新竹縣'
  },
  {
    店號: 193007,
    店名: '埔嵩',
    地址: '新竹縣新埔鎮田新路292號296號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 193144,
    店名: '員道',
    地址: '新竹縣竹東鎮員山路218之1號',
    縣市: '新竹縣'
  },
  {
    店號: 193487,
    店名: '豐富',
    地址: '新竹縣竹北市復興三路一段105號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 193627,
    店名: '乾坤科',
    地址: '新竹縣寶山鄉研發二路2號B1樓',
    縣市: '新竹縣'
  },
  {
    店號: 193904,
    店名: '大勝',
    地址: '新竹縣竹北市勝利十一路101號',
    縣市: '新竹縣'
  },
  {
    店號: 195287,
    店名: '星都心',
    地址: '新竹縣竹東鎮光明路182號186號',
    縣市: '新竹縣'
  },
  {
    店號: 195346,
    店名: '洪興',
    地址: '新竹縣峨眉鄉峨眉村1鄰8-8號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 195818,
    店名: '碩禾科',
    地址: '新竹縣湖口鄉自強路18號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 198415,
    店名: '禾遠',
    地址: '新竹縣竹北市莊敬五街13號',
    縣市: '新竹縣'
  },
  {
    店號: 199429,
    店名: '竹樺',
    地址: '新竹縣竹北市華興街298號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 200125,
    店名: '義山',
    地址: '新竹縣竹北市十興路318號.新瀧一街6號',
    縣市: '新竹縣'
  },
  {
    店號: 207573,
    店名: '啟碁',
    地址: '新竹縣寶山鄉園區二路20號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 209203,
    店名: '豐沛',
    地址: '新竹縣橫山鄉中豐路一段21號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 209443,
    店名: '家利',
    地址: '新竹縣湖口鄉民生街465巷3號',
    縣市: '新竹縣'
  },
  {
    店號: 209513,
    店名: '五峰鄉',
    地址: '新竹縣五峰鄉大隘村12鄰五峰246之3號(臨)',
    縣市: '新竹縣'
  },
  {
    店號: 209823,
    店名: '東睿',
    地址: '新竹縣竹東鎮北興路三段446號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 209982,
    店名: '湖貫',
    地址: '新竹縣湖口鄉新興路486號',
    縣市: '新竹縣'
  },
  {
    店號: 210029,
    店名: '學府居',
    地址: '新竹縣新豐鄉學府街45號47號',
    縣市: '新竹縣'
  },
  {
    店號: 210063,
    店名: '銓國',
    地址: '新竹縣竹北市中正西路244.246號',
    縣市: '新竹縣'
  },
  {
    店號: 210306,
    店名: '鹿禾',
    地址: '新竹縣竹北市莊敬南路118號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 210487,
    店名: '日和',
    地址: '新竹縣竹北市文興路二段150號.高鐵二路51號',
    縣市: '新竹縣'
  },
  {
    店號: 210797,
    店名: '昌樂',
    地址: '新竹縣竹北市環科一路13號',
    縣市: '新竹縣'
  },
  {
    店號: 210801,
    店名: '印月',
    地址: '新竹縣竹北市科大一路140號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 211099,
    店名: '環鑫',
    地址: '新竹縣竹北市環北路五段61號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 212210,
    店名: '仁順',
    地址: '新竹縣湖口鄉仁和路130號132號134號',
    縣市: '新竹縣'
  },
  {
    店號: 212553,
    店名: '台博',
    地址: '新竹縣竹北市泰和里中和街10號',
    縣市: '新竹縣'
  },
  {
    店號: 213693,
    店名: '北泰',
    地址: '新竹縣竹北市中正西路132號134號',
    縣市: '新竹縣'
  },
  {
    店號: 213958,
    店名: '鐵興',
    地址: '新竹縣竹北市嘉豐六路二段16號.18號.12號部分',
    縣市: '新竹縣'
  },
  {
    店號: 214021,
    店名: '新北竹',
    地址: '新竹縣竹北市博愛街358.360號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 214227,
    店名: '府樂',
    地址: '新竹縣竹北市縣政九路80號一樓',
    縣市: '新竹縣'
  },
  {
    店號: 215002,
    店名: '羅湖',
    地址: '新竹縣湖口鄉成功路1092號',
    縣市: '新竹縣'
  },
  {
    店號: 215828,
    店名: '金廣福',
    地址: '新竹縣北埔鄉南興街135號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 216234,
    店名: '王爺',
    地址: '新竹縣湖口鄉中山路一段790號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 216588,
    店名: '中新',
    地址: '新竹縣竹北市中正西路389號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 216784,
    店名: '竹北',
    地址: '新竹縣竹北市中正東路194號',
    縣市: '新竹縣'
  },
  {
    店號: 228156,
    店名: '福崙',
    地址: '新竹縣竹北市福興路705號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 228178,
    店名: '沅均',
    地址: '新竹縣湖口鄉光復東路120之1號',
    縣市: '新竹縣'
  },
  {
    店號: 228938,
    店名: '禾笙',
    地址: '新竹縣竹北市中山路45.47.49號',
    縣市: '新竹縣'
  },
  {
    店號: 229724,
    店名: '長政',
    地址: '新竹縣竹東鎮中正路15號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 230470,
    店名: '湖大',
    地址: '新竹縣湖口鄉東興村10鄰中山路三段358號臨',
    縣市: '新竹縣'
  },
  {
    店號: 230894,
    店名: '埔山',
    地址: '新竹縣新埔鎮文山路犁頭山段936號',
    縣市: '新竹縣'
  },
  {
    店號: 231060,
    店名: '湖鏡',
    地址: '新竹縣湖口鄉八德路二段9號',
    縣市: '新竹縣'
  },
  {
    店號: 231473,
    店名: '鳳杉',
    地址: '新竹縣竹北市長青路二段251-1號臨',
    縣市: '新竹縣'
  },
  {
    店號: 233181,
    店名: '旺矽',
    地址: '新竹縣竹北市泰和路155號5樓',
    縣市: '新竹縣'
  },
  {
    店號: 233516,
    店名: '緯創舍',
    地址: '新竹縣寶山鄉雙新村明湖五街11號',
    縣市: '新竹縣'
  },
  {
    店號: 236582,
    店名: 'P8廠 2',
    地址: '新竹縣寶山鄉科環路168號 B3樓',
    縣市: '新竹縣'
  },
  {
    店號: 236892,
    店名: '文嘉',
    地址: '新竹縣竹北市文興路一段398號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 236906,
    店名: '竹杉',
    地址: '新竹縣竹北市中山路303號(臨)',
    縣市: '新竹縣'
  },
  {
    店號: 237817,
    店名: '忠平',
    地址: '新竹縣湖口鄉中平路一段271號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 237828,
    店名: '家安',
    地址: '新竹縣竹北市嘉興路168巷2號',
    縣市: '新竹縣'
  },
  {
    店號: 238061,
    店名: '鳳山綺',
    地址: '新竹縣湖口鄉勝利路二段254號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 238108,
    店名: '東鐵',
    地址: '新竹縣竹北市隘口三街231號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 238201,
    店名: '竹永',
    地址: '新竹縣竹東鎮仁愛里北興路二段185號187號',
    縣市: '新竹縣'
  },
  {
    店號: 238636,
    店名: '嘉家',
    地址: '新竹縣竹北市嘉豐十一路一段30號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 239064,
    店名: '朝陽',
    地址: '新竹縣竹東鎮朝陽路70號72號74號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 239318,
    店名: '光揚',
    地址: '新竹縣竹北市光明六路247號249號251號一樓',
    縣市: '新竹縣'
  },
  {
    店號: 240178,
    店名: '斗崙',
    地址: '新竹縣竹北市光明十一路188號190號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 240189,
    店名: '銘豐',
    地址: '新竹縣竹北市嘉豐五路一段1號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 240271,
    店名: '寶山',
    地址: '新竹縣竹東鎮中興路三段173號',
    縣市: '新竹縣'
  },
  {
    店號: 240525,
    店名: '寶謙',
    地址: '新竹縣寶山鄉有謙路2.6號',
    縣市: '新竹縣'
  },
  {
    店號: 240628,
    店名: '源冠',
    地址: '新竹縣新豐鄉尚仁街92號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 241506,
    店名: '裝甲',
    地址: '新竹縣湖口鄉勝利路二段93號94號95號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 249359,
    店名: '新台元',
    地址: '新竹縣竹北市台元街26-5號',
    縣市: '新竹縣'
  },
  {
    店號: 249360,
    店名: '新新豐',
    地址: '新竹縣新豐鄉新興路177號179號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 250197,
    店名: '新安村',
    地址: '新竹縣竹北市博愛街515號',
    縣市: '新竹縣'
  },
  {
    店號: 250625,
    店名: '湖山',
    地址: '新竹縣湖口鄉中山路三段489號',
    縣市: '新竹縣'
  },
  {
    店號: 250636,
    店名: '源晟',
    地址: '新竹縣湖口鄉新興路628號630號',
    縣市: '新竹縣'
  },
  {
    店號: 863458,
    店名: '醫湖',
    地址: '新竹縣湖口鄉孝勢里忠孝路20號22號',
    縣市: '新竹縣'
  },
  {
    店號: 871976,
    店名: '光春',
    地址: '新竹縣竹東鎮長春路三段253號',
    縣市: '新竹縣'
  },
  {
    店號: 883315,
    店名: '飛利浦',
    地址: '新竹縣竹北市中華路548號550號',
    縣市: '新竹縣'
  },
  {
    店號: 893655,
    店名: '埔中',
    地址: '新竹縣新埔鎮中正路617號619號621號',
    縣市: '新竹縣'
  },
  {
    店號: 910437,
    店名: '橫山',
    地址: '新竹縣橫山鄉中豐路二段122號',
    縣市: '新竹縣'
  },
  {
    店號: 910703,
    店名: '源威',
    地址: '新竹縣湖口鄉光華路666號1F',
    縣市: '新竹縣'
  },
  {
    店號: 910806,
    店名: '三立',
    地址: '新竹縣湖口鄉湖鏡村八德路一段718號',
    縣市: '新竹縣'
  },
  {
    店號: 911876,
    店名: '新關中',
    地址: '新竹縣關西鎮中興路17號',
    縣市: '新竹縣'
  },
  {
    店號: 912617,
    店名: '情友',
    地址: '新竹縣寶山鄉雙溪村寶新路一段2號',
    縣市: '新竹縣'
  },
  {
    店號: 912765,
    店名: '東亭',
    地址: '新竹縣竹東鎮和江街2號6號',
    縣市: '新竹縣'
  },
  {
    店號: 912927,
    店名: '台積二',
    地址: '新竹縣寶山鄉園區三路121號B1',
    縣市: '新竹縣'
  },
  {
    店號: 912938,
    店名: '台積三',
    地址: '新竹縣寶山鄉研新一路9號',
    縣市: '新竹縣'
  },
  {
    店號: 914037,
    店名: '豐興',
    地址: '新竹縣新豐鄉建興路一段128號',
    縣市: '新竹縣'
  },
  {
    店號: 920917,
    店名: '內灣',
    地址: '新竹縣橫山鄉內灣村20號',
    縣市: '新竹縣'
  },
  {
    店號: 922751,
    店名: '源泰',
    地址: '新竹縣湖口鄉中興街174-176號',
    縣市: '新竹縣'
  },
  {
    店號: 923226,
    店名: '鹿家',
    地址: '新竹縣竹北市自強南路136號',
    縣市: '新竹縣'
  },
  {
    店號: 929187,
    店名: '泰鑫',
    地址: '新竹縣竹北市新泰路31號一樓',
    縣市: '新竹縣'
  },
  {
    店號: 941121,
    店名: '員崠',
    地址: '新竹縣竹東鎮東峰路336號',
    縣市: '新竹縣'
  },
  {
    店號: 944588,
    店名: '鳳岡',
    地址: '新竹縣竹北市長青路一段388號390號',
    縣市: '新竹縣'
  },
  {
    店號: 947381,
    店名: '東豐',
    地址: '新竹縣竹東鎮東寧里東寧路一段1號',
    縣市: '新竹縣'
  },
  {
    店號: 947738,
    店名: '統賀',
    地址: '新竹縣竹北市中正東路67號69號',
    縣市: '新竹縣'
  },
  {
    店號: 952811,
    店名: '博祐',
    地址: '新竹縣竹北市博愛街25-1號',
    縣市: '新竹縣'
  },
  {
    店號: 953489,
    店名: '宏橋',
    地址: '新竹縣湖口鄉工業一路7號7-1號7-2號',
    縣市: '新竹縣'
  },
  {
    店號: 953607,
    店名: '大矽谷',
    地址: '新竹縣芎林鄉三民路279號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 953696,
    店名: '盟創',
    地址: '新竹縣寶山鄉創新二路6號',
    縣市: '新竹縣'
  },
  {
    店號: 958956,
    店名: '東福',
    地址: '新竹縣竹東鎮中豐路二段245號',
    縣市: '新竹縣'
  },
  {
    店號: 962977,
    店名: '新庄子',
    地址: '新竹縣新豐鄉建興路二段752號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 965932,
    店名: '飛鳳',
    地址: '新竹縣芎林鄉富林路二段556號',
    縣市: '新竹縣'
  },
  {
    店號: 966865,
    店名: '新湖中',
    地址: '新竹縣湖口鄉中正村中正路二段235號',
    縣市: '新竹縣'
  },
  {
    店號: 967282,
    店名: '新高湖',
    地址: '新竹縣新豐鄉新興路403號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 967961,
    店名: '竹興',
    地址: '新竹縣竹東鎮中興路四段650號',
    縣市: '新竹縣'
  },
  {
    店號: 971340,
    店名: '馬武督',
    地址: '新竹縣關西鎮中豐新路2-1號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 977315,
    店名: '新薪荷',
    地址: '新竹縣竹北市三民路243號245號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 988038,
    店名: '世豊',
    地址: '新竹縣新豐鄉建興路一段173號175號一樓',
    縣市: '新竹縣'
  },
  {
    店號: 988337,
    店名: '湖安',
    地址: '新竹縣湖口鄉光復東路395號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 990710,
    店名: '力成科',
    地址: '新竹縣湖口鄉大同路26號6樓',
    縣市: '新竹縣'
  },
  {
    店號: 990846,
    店名: '力成貳',
    地址: '新竹縣湖口鄉三民路7號B1',
    縣市: '新竹縣'
  },
  {
    店號: 990880,
    店名: '晨希',
    地址: '新竹縣湖口鄉榮光路617號',
    縣市: '新竹縣'
  },
  {
    店號: 991078,
    店名: '聯電S',
    地址: '新竹縣寶山鄉雙溪村研新一路16號3樓',
    縣市: '新竹縣'
  },
  {
    店號: 991089,
    店名: '芎林',
    地址: '新竹縣芎林鄉文山路529號531號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 992233,
    店名: '富林',
    地址: '新竹縣芎林鄉富林路三段239號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 997847,
    店名: '沐庭',
    地址: '新竹縣竹北市光明六路106號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 999957,
    店名: '新縣政',
    地址: '新竹縣竹北市光明九路12號1樓',
    縣市: '新竹縣'
  },
  {
    店號: 110758,
    店名: '頭屋',
    地址: '苗栗縣頭屋鄉尖豐路118號120號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 111854,
    店名: '布洛瓦',
    地址: '苗栗縣竹南鎮科東三路12號',
    縣市: '苗栗縣'
  },
  {
    店號: 112857,
    店名: '永和山',
    地址: '苗栗縣頭份市水源路206號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 113137,
    店名: '珊湖',
    地址: '苗栗縣頭份市中正三路271號1樓及親民路1號3號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 115867,
    店名: '鑫正發',
    地址: '苗栗縣苗栗市正發路196號',
    縣市: '苗栗縣'
  },
  {
    店號: 116169,
    店名: '竹南和',
    地址: '苗栗縣竹南鎮大埔里和興路191-1號',
    縣市: '苗栗縣'
  },
  {
    店號: 116480,
    店名: '豪麥',
    地址: '苗栗縣卓蘭鎮中山路48號之4',
    縣市: '苗栗縣'
  },
  {
    店號: 118028,
    店名: '苗鑫',
    地址: '苗栗縣苗栗市國華路1092號',
    縣市: '苗栗縣'
  },
  {
    店號: 120401,
    店名: '鈞吉',
    地址: '苗栗縣頭份市成功里11鄰建國路198號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 120537,
    店名: '弘運',
    地址: '苗栗縣竹南鎮守法街3-2號3-3號3-5號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 121080,
    店名: '龍宸',
    地址: '苗栗縣竹南鎮營盤里博愛街367號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 121367,
    店名: '貞豪',
    地址: '苗栗縣頭份市永貞路一段128號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 121552,
    店名: '新華',
    地址: '苗栗縣頭份市中華路755號及民生街2號',
    縣市: '苗栗縣'
  },
  {
    店號: 122658,
    店名: '田野',
    地址: '苗栗縣南庄鄉員林村下員林2鄰68-10號',
    縣市: '苗栗縣'
  },
  {
    店號: 123422,
    店名: '中群',
    地址: '苗栗縣頭份市中正路319號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 130121,
    店名: '鑫龍',
    地址: '苗栗縣後龍鎮中山路53號',
    縣市: '苗栗縣'
  },
  {
    店號: 130512,
    店名: '龍日',
    地址: '苗栗縣後龍鎮溪洲里七鄰勝利路60之1號',
    縣市: '苗栗縣'
  },
  {
    店號: 130855,
    店名: '館源',
    地址: '苗栗縣苗栗市水源里11鄰水流娘15-3號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 130958,
    店名: '興德',
    地址: '苗栗縣頭份市文化街172號八德二路292號 1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 131353,
    店名: '新和苑',
    地址: '苗栗縣苑裡鎮苑南里為公路4鄰16之1號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 137557,
    店名: '國豪',
    地址: '苗栗縣竹南鎮延平路170號',
    縣市: '苗栗縣'
  },
  {
    店號: 137638,
    店名: '客庄',
    地址: '苗栗縣苑裡鎮客庄里客庄90-20號',
    縣市: '苗栗縣'
  },
  {
    店號: 138516,
    店名: '新苑',
    地址: '苗栗縣苑裡鎮苑北里為公路70號',
    縣市: '苗栗縣'
  },
  {
    店號: 138837,
    店名: '廣沅',
    地址: '苗栗縣竹南鎮公義里公義路1683號1685號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 141143,
    店名: '象山',
    地址: '苗栗縣頭屋鄉象山村象山路239之1號',
    縣市: '苗栗縣'
  },
  {
    店號: 141154,
    店名: '大大',
    地址: '苗栗縣公館鄉大同路160號162號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 142397,
    店名: '頭興',
    地址: '苗栗縣頭份市中央路228號230號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 143367,
    店名: '苗栗',
    地址: '苗栗縣苗栗市民族路99號101號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 144854,
    店名: '建鑫',
    地址: '苗栗縣頭份市建國路86號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 148720,
    店名: '宏恩',
    地址: '苗栗縣頭份市中正路2號',
    縣市: '苗栗縣'
  },
  {
    店號: 153607,
    店名: '新雪霸',
    地址: '苗栗縣大湖鄉富興村1鄰水尾39號',
    縣市: '苗栗縣'
  },
  {
    店號: 155315,
    店名: '正合',
    地址: '苗栗縣頭份市中正一路58號1F',
    縣市: '苗栗縣'
  },
  {
    店號: 155533,
    店名: '東館',
    地址: '苗栗縣公館鄉五谷村12鄰71之1號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 158727,
    店名: '大銅',
    地址: '苗栗縣銅鑼鄉銅鑼村中正路6之25號',
    縣市: '苗栗縣'
  },
  {
    店號: 160203,
    店名: '頤和',
    地址: '苗栗縣苗栗市中正路55號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 164331,
    店名: '栗華',
    地址: '苗栗縣苗栗市中華路78號',
    縣市: '苗栗縣'
  },
  {
    店號: 164515,
    店名: '三灣',
    地址: '苗栗縣三灣鄉中正路255號與文化街13號',
    縣市: '苗栗縣'
  },
  {
    店號: 165242,
    店名: '苗谷',
    地址: '苗栗縣公館鄉五谷村200號',
    縣市: '苗栗縣'
  },
  {
    店號: 166290,
    店名: '苗栗高',
    地址: '苗栗縣後龍鎮新東路468號',
    縣市: '苗栗縣'
  },
  {
    店號: 166315,
    店名: '科七',
    地址: '苗栗縣竹南鎮科專七路396號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 167329,
    店名: '新卓蘭',
    地址: '苗栗縣卓蘭鎮興南街318號',
    縣市: '苗栗縣'
  },
  {
    店號: 167684,
    店名: '酒莊',
    地址: '苗栗縣大湖鄉富興村9鄰八寮灣2之11號',
    縣市: '苗栗縣'
  },
  {
    店號: 170554,
    店名: '頭份',
    地址: '苗栗縣頭份市中正路232號',
    縣市: '苗栗縣'
  },
  {
    店號: 173634,
    店名: '龍仁',
    地址: '苗栗縣頭份市中華路968-974號',
    縣市: '苗栗縣'
  },
  {
    店號: 174589,
    店名: '貞永',
    地址: '苗栗縣頭份市永貞路二段1號',
    縣市: '苗栗縣'
  },
  {
    店號: 175076,
    店名: '統寶',
    地址: '苗栗縣竹南鎮科中路12號B2',
    縣市: '苗栗縣'
  },
  {
    店號: 180104,
    店名: '龍躍',
    地址: '苗栗縣苗栗市新川里圓墩路28號',
    縣市: '苗栗縣'
  },
  {
    店號: 180344,
    店名: '大千',
    地址: '苗栗縣苗栗市中正路903號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 181037,
    店名: '通高',
    地址: '苗栗縣通霄鎮內湖里12鄰烏眉路308號',
    縣市: '苗栗縣'
  },
  {
    店號: 181679,
    店名: '圳營',
    地址: '苗栗縣竹南鎮中正路114號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 182351,
    店名: '光南',
    地址: '苗栗縣竹南鎮照南里光復路342號',
    縣市: '苗栗縣'
  },
  {
    店號: 182694,
    店名: '苗龍',
    地址: '苗栗縣後龍鎮造豐路333號',
    縣市: '苗栗縣'
  },
  {
    店號: 183918,
    店名: '科南',
    地址: '苗栗縣竹南鎮大埔里1鄰科學路243號',
    縣市: '苗栗縣'
  },
  {
    店號: 184128,
    店名: '造橋鄉',
    地址: '苗栗縣造橋鄉造橋村平仁路105-1號',
    縣市: '苗栗縣'
  },
  {
    店號: 184368,
    店名: '科星',
    地址: '苗栗縣竹南鎮科專七路393號',
    縣市: '苗栗縣'
  },
  {
    店號: 188049,
    店名: '龍庄',
    地址: '苗栗縣後龍鎮大庄里成功路207號',
    縣市: '苗栗縣'
  },
  {
    店號: 188142,
    店名: '群創',
    地址: '苗栗縣竹南鎮頂埔里科學路160號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 192635,
    店名: '苑景',
    地址: '苗栗縣苑裡鎮山柑里九鄰山柑92之7號',
    縣市: '苗栗縣'
  },
  {
    店號: 192808,
    店名: '大南庄',
    地址: '苗栗縣南庄鄉南江村5鄰東江75-3號',
    縣市: '苗栗縣'
  },
  {
    店號: 194114,
    店名: '新頭高',
    地址: '苗栗縣頭份市中華路1186號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 195221,
    店名: '源聖',
    地址: '苗栗縣苗栗市文發路177號.177之1號',
    縣市: '苗栗縣'
  },
  {
    店號: 195656,
    店名: '銅鑼',
    地址: '苗栗縣銅鑼鄉銅鑼村中正路177、179、181號',
    縣市: '苗栗縣'
  },
  {
    店號: 196729,
    店名: '西湖鄉',
    地址: '苗栗縣西湖鄉金獅村2鄰金獅26-2號',
    縣市: '苗栗縣'
  },
  {
    店號: 196730,
    店名: '和田',
    地址: '苗栗縣苑裡鎮新復里8鄰120-1號',
    縣市: '苗栗縣'
  },
  {
    店號: 198851,
    店名: '為公',
    地址: '苗栗縣苗栗市嘉盛里25鄰為公路584號',
    縣市: '苗栗縣'
  },
  {
    店號: 199278,
    店名: '環竹',
    地址: '苗栗縣竹南鎮環市路一段16號',
    縣市: '苗栗縣'
  },
  {
    店號: 200169,
    店名: '東踕',
    地址: '苗栗縣頭份市上埔里12鄰沙埔40號',
    縣市: '苗栗縣'
  },
  {
    店號: 200310,
    店名: '龍旺',
    地址: '苗栗縣頭份市自強路117號',
    縣市: '苗栗縣'
  },
  {
    店號: 202109,
    店名: '源栗',
    地址: '苗栗縣苗栗市水源里14鄰中正路1402號',
    縣市: '苗栗縣'
  },
  {
    店號: 207067,
    店名: '海口',
    地址: '苗栗縣竹南鎮明勝路491-1號',
    縣市: '苗栗縣'
  },
  {
    店號: 207584,
    店名: '通苑',
    地址: '苗栗縣通霄鎮中山路42號',
    縣市: '苗栗縣'
  },
  {
    店號: 208129,
    店名: '華星',
    地址: '苗栗縣苗栗市福星里國華路276號.276-1號及278號',
    縣市: '苗栗縣'
  },
  {
    店號: 208196,
    店名: '尚順',
    地址: '苗栗縣頭份市東民五街1號和3號',
    縣市: '苗栗縣'
  },
  {
    店號: 208392,
    店名: '龍陽',
    地址: '苗栗縣頭份市光華北路150號',
    縣市: '苗栗縣'
  },
  {
    店號: 208750,
    店名: '于義',
    地址: '苗栗縣竹南鎮公義路1098號',
    縣市: '苗栗縣'
  },
  {
    店號: 208864,
    店名: '沅丞',
    地址: '苗栗縣竹南鎮公義里友義路67號',
    縣市: '苗栗縣'
  },
  {
    店號: 208875,
    店名: '鈱鎙',
    地址: '苗栗縣頭份市田寮里14鄰民族路501.503號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 209258,
    店名: '銅高',
    地址: '苗栗縣銅鑼鄉新興路2-26號',
    縣市: '苗栗縣'
  },
  {
    店號: 209317,
    店名: '社苓',
    地址: '苗栗縣苑裡鎮社苓里12鄰131-4號',
    縣市: '苗栗縣'
  },
  {
    店號: 209557,
    店名: '公館鄉',
    地址: '苗栗縣公館鄉玉泉村玉泉29-1號',
    縣市: '苗栗縣'
  },
  {
    店號: 210269,
    店名: '白沙墩',
    地址: '苗栗縣通霄鎮白東里2鄰9號',
    縣市: '苗栗縣'
  },
  {
    店號: 211790,
    店名: '鈺米',
    地址: '苗栗縣苑裡鎮山柑里山柑12-2號',
    縣市: '苗栗縣'
  },
  {
    店號: 211871,
    店名: '苗公',
    地址: '苗栗縣苗栗市青苗里至公路12號',
    縣市: '苗栗縣'
  },
  {
    店號: 211985,
    店名: '潘桃',
    地址: '苗栗縣頭份市成功里6鄰信東路280號',
    縣市: '苗栗縣'
  },
  {
    店號: 211996,
    店名: '忠正',
    地址: '苗栗縣頭份市中正路41-1號',
    縣市: '苗栗縣'
  },
  {
    店號: 212380,
    店名: '千晴',
    地址: '苗栗縣三義鄉西湖村伯公坑178號',
    縣市: '苗栗縣'
  },
  {
    店號: 212542,
    店名: '新昌隆',
    地址: '苗栗縣頭份市昌隆一街31.33號',
    縣市: '苗栗縣'
  },
  {
    店號: 215378,
    店名: '苗勝',
    地址: '苗栗縣苗栗市勝利里中正路1045號.勝利路316號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 215596,
    店名: '泰安',
    地址: '苗栗縣泰安鄉錦水村圓墩83-2號',
    縣市: '苗栗縣'
  },
  {
    店號: 215666,
    店名: '真開',
    地址: '苗栗縣竹南鎮大厝里開元路412號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 215965,
    店名: '東尚',
    地址: '苗栗縣頭份市東民路163號及和平路251號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 227706,
    店名: '沿山道',
    地址: '苗栗縣公館鄉尖山村尖山244-9號',
    縣市: '苗栗縣'
  },
  {
    店號: 227739,
    店名: '苑裡',
    地址: '苗栗縣苑裡鎮房裡里13鄰北房8-9號',
    縣市: '苗栗縣'
  },
  {
    店號: 227968,
    店名: '原康',
    地址: '苗栗縣苑裡鎮大同路16號',
    縣市: '苗栗縣'
  },
  {
    店號: 229182,
    店名: '新港庄',
    地址: '苗栗縣後龍鎮新民里中心路122.122-1.122-2.122-3號',
    縣市: '苗栗縣'
  },
  {
    店號: 229702,
    店名: '新獅潭',
    地址: '苗栗縣獅潭鄉新店村新店22-5號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 229827,
    店名: '新苗治',
    地址: '苗栗縣苗栗市北苗里自治路68號',
    縣市: '苗栗縣'
  },
  {
    店號: 229953,
    店名: '利興',
    地址: '苗栗縣頭份市成功里中興路769號',
    縣市: '苗栗縣'
  },
  {
    店號: 230414,
    店名: '延平',
    地址: '苗栗縣竹南鎮照南里15鄰延平路63巷1號',
    縣市: '苗栗縣'
  },
  {
    店號: 232063,
    店名: 'AP6',
    地址: '苗栗縣竹南鎮大埔里科專七路2號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 232122,
    店名: '銘德',
    地址: '苗栗縣頭屋鄉明德村明德路72-1號1.2樓',
    縣市: '苗栗縣'
  },
  {
    店號: 236685,
    店名: '龍鳳',
    地址: '苗栗縣竹南鎮龍鳳里龍江街25號',
    縣市: '苗栗縣'
  },
  {
    店號: 237002,
    店名: '福華',
    地址: '苗栗縣苗栗市福星里中華路273.275.277號',
    縣市: '苗栗縣'
  },
  {
    店號: 239363,
    店名: '天文',
    地址: '苗栗縣竹南鎮天文路176號',
    縣市: '苗栗縣'
  },
  {
    店號: 239514,
    店名: '仟翔',
    地址: '苗栗縣竹南鎮龍山路二段275號',
    縣市: '苗栗縣'
  },
  {
    店號: 240640,
    店名: '銅利',
    地址: '苗栗縣銅鑼鄉中興路2號',
    縣市: '苗栗縣'
  },
  {
    店號: 249463,
    店名: '龍昇',
    地址: '苗栗縣竹南鎮龍山路二段120號',
    縣市: '苗栗縣'
  },
  {
    店號: 249980,
    店名: '竹南建',
    地址: '苗栗縣竹南鎮龍鳳里龍山路一段162號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 250315,
    店名: '瑛才',
    地址: '苗栗縣苗栗市英才路109號',
    縣市: '苗栗縣'
  },
  {
    店號: 250326,
    店名: '大山',
    地址: '苗栗縣後龍鎮大山里龍文路6號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 251112,
    店名: '象上',
    地址: '苗栗縣頭屋鄉象山村象山路176號',
    縣市: '苗栗縣'
  },
  {
    店號: 870766,
    店名: '三義',
    地址: '苗栗縣三義鄉中正路118號',
    縣市: '苗栗縣'
  },
  {
    店號: 873020,
    店名: '菁英',
    地址: '苗栗縣大湖鄉明湖村中正路107號',
    縣市: '苗栗縣'
  },
  {
    店號: 873215,
    店名: '龍邦',
    地址: '苗栗縣三義鄉勝興村水美街315之8號9號',
    縣市: '苗栗縣'
  },
  {
    店號: 882080,
    店名: '慶竹',
    地址: '苗栗縣竹南鎮民族路82號民權路47號',
    縣市: '苗栗縣'
  },
  {
    店號: 882563,
    店名: '通霄',
    地址: '苗栗縣通霄鎮中正路19號',
    縣市: '苗栗縣'
  },
  {
    店號: 910116,
    店名: '煥日',
    地址: '苗栗縣頭份市新華里中正一路554號556號',
    縣市: '苗栗縣'
  },
  {
    店號: 911647,
    店名: '白沙屯',
    地址: '苗栗縣通霄鎮白東里白東100號',
    縣市: '苗栗縣'
  },
  {
    店號: 913034,
    店名: '育大',
    地址: '苗栗縣造橋鄉學府路100號',
    縣市: '苗栗縣'
  },
  {
    店號: 921552,
    店名: '海福',
    地址: '苗栗縣竹南鎮明勝路318號',
    縣市: '苗栗縣'
  },
  {
    店號: 921769,
    店名: '通館',
    地址: '苗栗縣通霄鎮通西里中山路10號',
    縣市: '苗栗縣'
  },
  {
    店號: 923167,
    店名: '大坪',
    地址: '苗栗縣造橋鄉大西一街100號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 923835,
    店名: '館南',
    地址: '苗栗縣公館鄉通明街68號',
    縣市: '苗栗縣'
  },
  {
    店號: 924470,
    店名: '信東',
    地址: '苗栗縣頭份市忠孝里12鄰信東路158號',
    縣市: '苗栗縣'
  },
  {
    店號: 931825,
    店名: '尖豐',
    地址: '苗栗縣頭份市尖山里尖豐路320巷316號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 932105,
    店名: '山腳',
    地址: '苗栗縣苑裡鎮山腳里七鄰山腳157號',
    縣市: '苗栗縣'
  },
  {
    店號: 933164,
    店名: '淇丞',
    地址: '苗栗縣頭份市建國路二段128號',
    縣市: '苗栗縣'
  },
  {
    店號: 941925,
    店名: '館福',
    地址: '苗栗縣公館鄉館南村館南路216-2號',
    縣市: '苗栗縣'
  },
  {
    店號: 942364,
    店名: '新裕龍',
    地址: '苗栗縣後龍鎮中華路52-8號',
    縣市: '苗栗縣'
  },
  {
    店號: 943909,
    店名: '昶誼',
    地址: '苗栗縣頭份市後庄里幼英街131號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 950284,
    店名: '新南庄',
    地址: '苗栗縣南庄鄉西村中正路7號9號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 951612,
    店名: '豪榮',
    地址: '苗栗縣苗栗市南勢里豪榮1號',
    縣市: '苗栗縣'
  },
  {
    店號: 951863,
    店名: '龍詮',
    地址: '苗栗縣竹南鎮山佳里龍山路三段305號',
    縣市: '苗栗縣'
  },
  {
    店號: 952626,
    店名: '苗碩',
    地址: '苗栗縣苗栗市維新里新東街219號',
    縣市: '苗栗縣'
  },
  {
    店號: 953272,
    店名: '田馨',
    地址: '苗栗縣苑裡鎮田心里田心段36之3號',
    縣市: '苗栗縣'
  },
  {
    店號: 958819,
    店名: '後庄',
    地址: '苗栗縣頭份市中央路603-605號',
    縣市: '苗栗縣'
  },
  {
    店號: 963073,
    店名: '龍坑',
    地址: '苗栗縣後龍鎮龍坑里16鄰156號之10',
    縣市: '苗栗縣'
  },
  {
    店號: 963187,
    店名: '晟乾',
    地址: '苗栗縣竹南鎮仁愛路902號',
    縣市: '苗栗縣'
  },
  {
    店號: 966636,
    店名: '金金',
    地址: '苗栗縣通霄鎮內湖里17鄰內湖165-8號',
    縣市: '苗栗縣'
  },
  {
    店號: 967662,
    店名: '真樂',
    地址: '苗栗縣苗栗市玉清路329號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 971410,
    店名: '鈺田',
    地址: '苗栗縣苑裡鎮山柑里2-2號',
    縣市: '苗栗縣'
  },
  {
    店號: 980827,
    店名: '得意',
    地址: '苗栗縣頭份市蟠桃里德義路13鄰81號',
    縣市: '苗栗縣'
  },
  {
    店號: 981510,
    店名: '慶丞',
    地址: '苗栗縣頭份市合興里信義路14鄰381號',
    縣市: '苗栗縣'
  },
  {
    店號: 982281,
    店名: '新苗中',
    地址: '苗栗縣苗栗市府前路120號',
    縣市: '苗栗縣'
  },
  {
    店號: 991296,
    店名: '展宏',
    地址: '苗栗縣竹南鎮中華路169號171號1樓',
    縣市: '苗栗縣'
  },
  {
    店號: 993085,
    店名: '苗豐',
    地址: '苗栗縣苗栗市為公路167-1號',
    縣市: '苗栗縣'
  },
  {
    店號: 997973,
    店名: '通宏',
    地址: '苗栗縣通霄鎮通西里中正路83之5號',
    縣市: '苗栗縣'
  },
  {
    店號: 110035,
    店名: '一勝',
    地址: '台中市大肚區福山村沙田路一段432-1號',
    縣市: '台中市'
  },
  {
    店號: 110172,
    店名: '樂東',
    地址: '台中市東區東英路331號',
    縣市: '台中市'
  },
  {
    店號: 110736,
    店名: '東園',
    地址: '台中市烏日區溪南路一段375號',
    縣市: '台中市'
  },
  {
    店號: 110884,
    店名: '桂冠',
    地址: '台中市西屯區四川路120號1樓',
    縣市: '台中市'
  },
  {
    店號: 110987,
    店名: '淡溝',
    地址: '台中市北區淡溝里民權路361號1樓',
    縣市: '台中市'
  },
  {
    店號: 111142,
    店名: '漢溪',
    地址: '台中市東區十甲東路575號1樓',
    縣市: '台中市'
  },
  {
    店號: 111212,
    店名: '軍福',
    地址: '台中市北屯區軍功路一段500號',
    縣市: '台中市'
  },
  {
    店號: 111393,
    店名: '嶺中',
    地址: '台中市南屯區永春南路58號',
    縣市: '台中市'
  },
  {
    店號: 111485,
    店名: '熱陽',
    地址: '台中市北屯區熱河路二段217號',
    縣市: '台中市'
  },
  {
    店號: 111717,
    店名: '鎮權',
    地址: '台中市沙鹿區鎮南路二段107號109號',
    縣市: '台中市'
  },
  {
    店號: 111865,
    店名: '東泰',
    地址: '台中市東勢區東蘭路41-5號',
    縣市: '台中市'
  },
  {
    店號: 111876,
    店名: '倍沅',
    地址: '台中市神岡區中山路473號',
    縣市: '台中市'
  },
  {
    店號: 111979,
    店名: '喬城',
    地址: '台中市大里區大智路567號',
    縣市: '台中市'
  },
  {
    店號: 112134,
    店名: '后興',
    地址: '台中市后里區甲后路一段1202號1樓',
    縣市: '台中市'
  },
  {
    店號: 112145,
    店名: '中興嶺',
    地址: '台中市新社區中興嶺170之2號1樓',
    縣市: '台中市'
  },
  {
    店號: 112190,
    店名: '寶慶',
    地址: '台中市西屯區逢甲里西屯路二段256巷8、10號1樓',
    縣市: '台中市'
  },
  {
    店號: 112204,
    店名: '興城',
    地址: '台中市大里區塗城路765號',
    縣市: '台中市'
  },
  {
    店號: 112237,
    店名: '詠權',
    地址: '台中市南區五權南路527號',
    縣市: '台中市'
  },
  {
    店號: 112570,
    店名: '環雅',
    地址: '台中市大雅區雅環路二段320號一樓',
    縣市: '台中市'
  },
  {
    店號: 112639,
    店名: '美村',
    地址: '台中市西區美村路一段542號546號',
    縣市: '台中市'
  },
  {
    店號: 112651,
    店名: '科安',
    地址: '台中市西屯區國安一路105號107號109號一樓',
    縣市: '台中市'
  },
  {
    店號: 113001,
    店名: '港強',
    地址: '台中市西屯區福科路295號一樓',
    縣市: '台中市'
  },
  {
    店號: 113252,
    店名: '后里廠',
    地址: '台中市后里區馬場路1號',
    縣市: '台中市'
  },
  {
    店號: 113333,
    店名: '翁子',
    地址: '台中市豐原區豐勢路一段669號一樓',
    縣市: '台中市'
  },
  {
    店號: 113425,
    店名: '富仁',
    地址: '台中市東區富榮街2號1樓',
    縣市: '台中市'
  },
  {
    店號: 113595,
    店名: '神洲',
    地址: '台中市神岡區國豐路一段88號1樓',
    縣市: '台中市'
  },
  {
    店號: 113997,
    店名: '易鴻',
    地址: '台中市霧峰區柳豐路422號1樓',
    縣市: '台中市'
  },
  {
    店號: 114048,
    店名: '福寶',
    地址: '台中市北屯區陳平路50號52號1樓',
    縣市: '台中市'
  },
  {
    店號: 114152,
    店名: '鄉林夏',
    地址: '台中市西區忠明南路117號1樓',
    縣市: '台中市'
  },
  {
    店號: 114369,
    店名: '天佑',
    地址: '台中市西屯區中工二路196號198號1樓',
    縣市: '台中市'
  },
  {
    店號: 114624,
    店名: '佳積',
    地址: '台中市大雅區科雅六路1號',
    縣市: '台中市'
  },
  {
    店號: 114691,
    店名: '環太',
    地址: '台中市大雅區雅環路一段330號',
    縣市: '台中市'
  },
  {
    店號: 115926,
    店名: '航發',
    地址: '台中市西屯區河南路二段242號',
    縣市: '台中市'
  },
  {
    店號: 116505,
    店名: '弘光',
    地址: '台中市沙鹿區晉江里台灣大道六段1018號',
    縣市: '台中市'
  },
  {
    店號: 116756,
    店名: '新甲后',
    地址: '台中市外埔區甲后路三段1025號',
    縣市: '台中市'
  },
  {
    店號: 116790,
    店名: '甜心',
    地址: '台中市豐原區圓環東路168、172號1樓',
    縣市: '台中市'
  },
  {
    店號: 117830,
    店名: '興春',
    地址: '台中市南屯區永春東路96號',
    縣市: '台中市'
  },
  {
    店號: 118497,
    店名: '中川',
    地址: '台中市西屯區台灣大道二段938號940號',
    縣市: '台中市'
  },
  {
    店號: 118545,
    店名: '興學',
    地址: '台中市南區學府路64號',
    縣市: '台中市'
  },
  {
    店號: 118659,
    店名: '精業',
    地址: '台中市西區精誠路41號之6之7',
    縣市: '台中市'
  },
  {
    店號: 118969,
    店名: '光輝',
    地址: '台中市南區美村路二段79號81號1F',
    縣市: '台中市'
  },
  {
    店號: 119652,
    店名: '中醫',
    地址: '台中市北區育德路13號',
    縣市: '台中市'
  },
  {
    店號: 119803,
    店名: '豐鑫',
    地址: '台中市豐原區向陽路276號',
    縣市: '台中市'
  },
  {
    店號: 120146,
    店名: '瑞聯',
    地址: '台中市西屯區福科路890號1樓',
    縣市: '台中市'
  },
  {
    店號: 120157,
    店名: '蔣公',
    地址: '台中市大甲區蔣公路221號',
    縣市: '台中市'
  },
  {
    店號: 120168,
    店名: '尚仁',
    地址: '台中市西屯區上仁街139號',
    縣市: '台中市'
  },
  {
    店號: 120179,
    店名: '港中',
    地址: '台中市梧棲區中央路一段666之28號',
    縣市: '台中市'
  },
  {
    店號: 120582,
    店名: '潭榮',
    地址: '台中市潭子區榮興街19號1樓21巷1號21巷3號1樓',
    縣市: '台中市'
  },
  {
    店號: 120847,
    店名: '烏日',
    地址: '台中市烏日區新興路247號',
    縣市: '台中市'
  },
  {
    店號: 120939,
    店名: '忠權',
    地址: '台中市北區忠明路426號1樓',
    縣市: '台中市'
  },
  {
    店號: 121286,
    店名: '科邦',
    地址: '台中市大雅區科雅一路8號5樓',
    縣市: '台中市'
  },
  {
    店號: 121301,
    店名: '廣洽',
    地址: '台中市龍井區西濱路三段247號',
    縣市: '台中市'
  },
  {
    店號: 121345,
    店名: '鈦譜',
    地址: '台中市龍井區龍門路48之15號',
    縣市: '台中市'
  },
  {
    店號: 122197,
    店名: '逢大二',
    地址: '台中市西屯區福星北路98號1樓',
    縣市: '台中市'
  },
  {
    店號: 122418,
    店名: '福廣',
    地址: '台中市大雅區中山路1號3號5號1樓',
    縣市: '台中市'
  },
  {
    店號: 122809,
    店名: '豐村',
    地址: '台中市豐原區南村里豐東路412號416號1樓',
    縣市: '台中市'
  },
  {
    店號: 122913,
    店名: '通山',
    地址: '台中市大雅區永和路11號18號',
    縣市: '台中市'
  },
  {
    店號: 123086,
    店名: '龍田',
    地址: '台中市龍井區田中里臨港東路一段75號',
    縣市: '台中市'
  },
  {
    店號: 123248,
    店名: '樹廣',
    地址: '台中市太平區樹德路98-9號',
    縣市: '台中市'
  },
  {
    店號: 123293,
    店名: '新社',
    地址: '台中市新社區興社街四段27之1號',
    縣市: '台中市'
  },
  {
    店號: 123569,
    店名: '尚晉',
    地址: '台中市太平區新平路三段1號1樓',
    縣市: '台中市'
  },
  {
    店號: 125118,
    店名: '晉豐',
    地址: '台中市豐原區西勢路425號',
    縣市: '台中市'
  },
  {
    店號: 125314,
    店名: '鹿心',
    地址: '台中市沙鹿區興仁里四平街58號',
    縣市: '台中市'
  },
  {
    店號: 126306,
    店名: '一江橋',
    地址: '台中市太平區東平路1號',
    縣市: '台中市'
  },
  {
    店號: 126720,
    店名: '天仁',
    地址: '台中市沙鹿區斗抵里沙田路17之19號',
    縣市: '台中市'
  },
  {
    店號: 127066,
    店名: '玉豐',
    地址: '台中市大里區東榮路483號',
    縣市: '台中市'
  },
  {
    店號: 127077,
    店名: '頭張',
    地址: '台中市潭子區家福里頭張路一段31號',
    縣市: '台中市'
  },
  {
    店號: 127583,
    店名: '興大',
    地址: '台中市南區國光路301號',
    縣市: '台中市'
  },
  {
    店號: 127929,
    店名: '立夫',
    地址: '台中市北區邱厝里學士路95號１樓',
    縣市: '台中市'
  },
  {
    店號: 128380,
    店名: '中友',
    地址: '台中市北區育才北路74號76號',
    縣市: '台中市'
  },
  {
    店號: 128553,
    店名: '甘肅',
    地址: '台中市西屯區甘肅路二段22號',
    縣市: '台中市'
  },
  {
    店號: 128690,
    店名: '逢廣',
    地址: '台中市西屯區文華路170號172號1樓',
    縣市: '台中市'
  },
  {
    店號: 128829,
    店名: '福星',
    地址: '台中市西屯區福星路580號',
    縣市: '台中市'
  },
  {
    店號: 129246,
    店名: '青海',
    地址: '台中市西屯區青海路一段1號',
    縣市: '台中市'
  },
  {
    店號: 130235,
    店名: '興生',
    地址: '台中市大里區大里路95號97號1樓',
    縣市: '台中市'
  },
  {
    店號: 130408,
    店名: '潭陽',
    地址: '台中市潭子區圓通南路2號1樓',
    縣市: '台中市'
  },
  {
    店號: 130420,
    店名: '文津',
    地址: '台中市北區天津路二段138之10號之11號',
    縣市: '台中市'
  },
  {
    店號: 130486,
    店名: '港藝',
    地址: '台中市清水區中社路19號',
    縣市: '台中市'
  },
  {
    店號: 130800,
    店名: '海濱',
    地址: '台中市清水區中華路429號',
    縣市: '台中市'
  },
  {
    店號: 130811,
    店名: '台火',
    地址: '台中市南區高工路355號1樓',
    縣市: '台中市'
  },
  {
    店號: 131021,
    店名: '潭北',
    地址: '台中市潭子區福潭路645.647.649號',
    縣市: '台中市'
  },
  {
    店號: 131032,
    店名: '潭勝',
    地址: '台中市潭子區勝利路101號103號',
    縣市: '台中市'
  },
  {
    店號: 131087,
    店名: '國光',
    地址: '台中市大里區國光路二段257號',
    縣市: '台中市'
  },
  {
    店號: 131135,
    店名: '昌鴻',
    地址: '台中市北區賴厝里山西路一段48號',
    縣市: '台中市'
  },
  {
    店號: 131180,
    店名: '豐贊',
    地址: '台中市豐原區豐勢路二段979號1樓',
    縣市: '台中市'
  },
  {
    店號: 131250,
    店名: '龍合',
    地址: '台中市龍井區中華路一段36號',
    縣市: '台中市'
  },
  {
    店號: 131283,
    店名: '大茅埔',
    地址: '台中市東勢區東關路五段617號1樓',
    縣市: '台中市'
  },
  {
    店號: 131308,
    店名: '東侑',
    地址: '台中市北屯區東山路一段396號1樓',
    縣市: '台中市'
  },
  {
    店號: 131397,
    店名: '瀋陽',
    地址: '台中市北屯區瀋陽路一段104號1樓',
    縣市: '台中市'
  },
  {
    店號: 131711,
    店名: '惠文',
    地址: '台中市南屯區河南路四段226號228號1樓',
    縣市: '台中市'
  },
  {
    店號: 131951,
    店名: '四德',
    地址: '台中市霧峰區四德里四德路525之2號',
    縣市: '台中市'
  },
  {
    店號: 131962,
    店名: '吉宏',
    地址: '台中市烏日區九德里20鄰中華路593號',
    縣市: '台中市'
  },
  {
    店號: 132068,
    店名: '親旺',
    地址: '台中市大肚區沙田路一段929號',
    縣市: '台中市'
  },
  {
    店號: 132459,
    店名: '豐三民',
    地址: '台中市豐原區三民路38號1樓',
    縣市: '台中市'
  },
  {
    店號: 132563,
    店名: '連河',
    地址: '台中市北屯區河北路二段218之1號1樓',
    縣市: '台中市'
  },
  {
    店號: 132758,
    店名: '中投',
    地址: '台中市霧峰區中投西路二段388號',
    縣市: '台中市'
  },
  {
    店號: 132851,
    店名: '新平',
    地址: '台中市太平區永平路一段105號107號1樓',
    縣市: '台中市'
  },
  {
    店號: 132921,
    店名: '健興',
    地址: '台中市北區健行路354號',
    縣市: '台中市'
  },
  {
    店號: 135551,
    店名: '鼎站',
    地址: '台中市中區建國路202號',
    縣市: '台中市'
  },
  {
    店號: 136130,
    店名: '大時代',
    地址: '台中市南區工學路55號57號',
    縣市: '台中市'
  },
  {
    店號: 136174,
    店名: '錦新',
    地址: '台中市北區錦新街70-2號70-3號及一中街136-2號136-6號',
    縣市: '台中市'
  },
  {
    店號: 136336,
    店名: '保誠',
    地址: '台中市西區五權路2-104號及貴和街222號',
    縣市: '台中市'
  },
  {
    店號: 136510,
    店名: '上楓樹',
    地址: '台中市南屯區中和里黎明路一段263號',
    縣市: '台中市'
  },
  {
    店號: 136886,
    店名: '鑫巴黎',
    地址: '台中市北屯區崇德路二段199號1樓',
    縣市: '台中市'
  },
  {
    店號: 137845,
    店名: '義和',
    地址: '台中市大甲區中山路一段492號',
    縣市: '台中市'
  },
  {
    店號: 138088,
    店名: '光興',
    地址: '台中市太平區興隆里12鄰光興路1632號',
    縣市: '台中市'
  },
  {
    店號: 138228,
    店名: '昌順',
    地址: '台中市北屯區北屯路439之16號1樓',
    縣市: '台中市'
  },
  {
    店號: 139139,
    店名: '斗抵',
    地址: '台中市沙鹿區沙田路43-12號',
    縣市: '台中市'
  },
  {
    店號: 139298,
    店名: '新文化',
    地址: '台中市西區中美街283號',
    縣市: '台中市'
  },
  {
    店號: 141291,
    店名: '新仁',
    地址: '台中市龍井區新興路40之3之3號1樓',
    縣市: '台中市'
  },
  {
    店號: 141316,
    店名: '豐王',
    地址: '台中市豐原區三豐路二段496號1樓',
    縣市: '台中市'
  },
  {
    店號: 141730,
    店名: '金大安',
    地址: '台中市大安區中山南路241號1樓',
    縣市: '台中市'
  },
  {
    店號: 142191,
    店名: '新越',
    地址: '台中市西屯區台灣大道三段301號11樓',
    縣市: '台中市'
  },
  {
    店號: 142216,
    店名: '豐科',
    地址: '台中市豐原區豐原大道七段381號1樓',
    縣市: '台中市'
  },
  {
    店號: 142320,
    店名: '大秀',
    地址: '台中市清水區五權路328號',
    縣市: '台中市'
  },
  {
    店號: 142478,
    店名: '美光',
    地址: '台中市后里區三豐路四段369號',
    縣市: '台中市'
  },
  {
    店號: 142766,
    店名: '東關',
    地址: '台中市東勢區東關路七段191號、新盛街2號1樓',
    縣市: '台中市'
  },
  {
    店號: 142799,
    店名: '光隆',
    地址: '台中市太平區光興路707號',
    縣市: '台中市'
  },
  {
    店號: 142973,
    店名: '玉門',
    地址: '台中市西屯區西屯路三段166之92號1樓',
    縣市: '台中市'
  },
  {
    店號: 142984,
    店名: '隆心',
    地址: '台中市西屯區文心路二段566號',
    縣市: '台中市'
  },
  {
    店號: 143002,
    店名: '明道二',
    地址: '台中市烏日區中山路一段497號地下室1樓',
    縣市: '台中市'
  },
  {
    店號: 143068,
    店名: '精明',
    地址: '台中市西區精誠路15號',
    縣市: '台中市'
  },
  {
    店號: 143220,
    店名: '西苑',
    地址: '台中市西屯區福星路112號1樓',
    縣市: '台中市'
  },
  {
    店號: 143301,
    店名: '金甲后',
    地址: '台中市大甲區甲后路五段360號',
    縣市: '台中市'
  },
  {
    店號: 143378,
    店名: '育鑫',
    地址: '台中市太平區樹孝路490號',
    縣市: '台中市'
  },
  {
    店號: 144038,
    店名: '醫德',
    地址: '台中市北區大德街87號1樓',
    縣市: '台中市'
  },
  {
    店號: 144061,
    店名: '中勇',
    地址: '台中市南屯區忠勇路105之27號1樓',
    縣市: '台中市'
  },
  {
    店號: 144555,
    店名: '星河',
    地址: '台中市沙鹿區鹿峰里中山路646號',
    縣市: '台中市'
  },
  {
    店號: 144887,
    店名: '興昌',
    地址: '台中市北屯區興安路二段62號1樓',
    縣市: '台中市'
  },
  {
    店號: 145031,
    店名: '元百',
    地址: '台中市大里區成功路512號516號',
    縣市: '台中市'
  },
  {
    店號: 145053,
    店名: '大聖',
    地址: '台中市梧棲區草湳里臨港路三段351號',
    縣市: '台中市'
  },
  {
    店號: 146997,
    店名: '朝科大',
    地址: '台中市霧峰區吉峰東路168號宿舍大樓',
    縣市: '台中市'
  },
  {
    店號: 147945,
    店名: '理想',
    地址: '台中市龍井區國際街155號157號159號1樓',
    縣市: '台中市'
  },
  {
    店號: 148351,
    店名: '篤行',
    地址: '台中市北區篤行路120號122號',
    縣市: '台中市'
  },
  {
    店號: 148915,
    店名: '墩業',
    地址: '台中市南屯區大墩路717-5號',
    縣市: '台中市'
  },
  {
    店號: 149033,
    店名: '德毅',
    地址: '台中市北區尊賢街9號',
    縣市: '台中市'
  },
  {
    店號: 149103,
    店名: '福康',
    地址: '台中市西屯區福林里福康路33號',
    縣市: '台中市'
  },
  {
    店號: 149114,
    店名: '逢大一',
    地址: '台中市西屯區文華路100號1樓',
    縣市: '台中市'
  },
  {
    店號: 149608,
    店名: '成興',
    地址: '台中市中區成功路271號1樓',
    縣市: '台中市'
  },
  {
    店號: 150745,
    店名: '聚懋',
    地址: '台中市南屯區大墩路287號289號一樓',
    縣市: '台中市'
  },
  {
    店號: 150790,
    店名: '松竹',
    地址: '台中市北屯區昌平路二段11-1號',
    縣市: '台中市'
  },
  {
    店號: 150815,
    店名: '庚樺',
    地址: '台中市北區崇德路一段143之2號',
    縣市: '台中市'
  },
  {
    店號: 150952,
    店名: '宥辰',
    地址: '台中市大里區立新街350號',
    縣市: '台中市'
  },
  {
    店號: 151069,
    店名: '沙鹿中',
    地址: '台中市沙鹿區中山路198號',
    縣市: '台中市'
  },
  {
    店號: 151140,
    店名: '義興',
    地址: '台中市南區復興路一段128號',
    縣市: '台中市'
  },
  {
    店號: 151302,
    店名: '興悅',
    地址: '台中市北區金華里進德北路160號162號',
    縣市: '台中市'
  },
  {
    店號: 151405,
    店名: '大運通',
    地址: '台中市潭子區復興路一段16號18號',
    縣市: '台中市'
  },
  {
    店號: 151508,
    店名: '亞和',
    地址: '台中市大雅區中山北路410號',
    縣市: '台中市'
  },
  {
    店號: 151520,
    店名: '東村',
    地址: '台中市太平區東村路200號',
    縣市: '台中市'
  },
  {
    店號: 151586,
    店名: '社和',
    地址: '台中市新社區中和街五段115號1樓',
    縣市: '台中市'
  },
  {
    店號: 151690,
    店名: '大連',
    地址: '台中市北屯區大連路一段40號1樓',
    縣市: '台中市'
  },
  {
    店號: 151818,
    店名: '鹿興',
    地址: '台中市沙鹿區向上路七段1號',
    縣市: '台中市'
  },
  {
    店號: 152028,
    店名: '昌陽',
    地址: '台中市北屯區昌平路一段264號',
    縣市: '台中市'
  },
  {
    店號: 153582,
    店名: '栗豐',
    地址: '台中市神岡區承德路219號',
    縣市: '台中市'
  },
  {
    店號: 153630,
    店名: '新峰',
    地址: '台中市霧峰區吉峰路153號',
    縣市: '台中市'
  },
  {
    店號: 153722,
    店名: '新里',
    地址: '台中市大里區中興路二段480號',
    縣市: '台中市'
  },
  {
    店號: 154138,
    店名: '吉峰',
    地址: '台中市霧峰區德泰街9號',
    縣市: '台中市'
  },
  {
    店號: 154493,
    店名: '新禾',
    地址: '台中市神岡區和睦路一段363號',
    縣市: '台中市'
  },
  {
    店號: 154622,
    店名: '東儷',
    地址: '台中市西屯區臺灣大道四段1727號',
    縣市: '台中市'
  },
  {
    店號: 154633,
    店名: '管院',
    地址: '台中市西屯區臺灣大道四段1727號',
    縣市: '台中市'
  },
  {
    店號: 154644,
    店名: '益風',
    地址: '台中市西區精誠路107號',
    縣市: '台中市'
  },
  {
    店號: 154806,
    店名: '港埠',
    地址: '台中市梧棲區港埠路一段989號',
    縣市: '台中市'
  },
  {
    店號: 155038,
    店名: '鑫權勝',
    地址: '台中市南屯區五權西路二段882號',
    縣市: '台中市'
  },
  {
    店號: 155049,
    店名: '新忠貞',
    地址: '台中市沙鹿區東大路二段1587號',
    縣市: '台中市'
  },
  {
    店號: 155050,
    店名: '新北屯',
    地址: '台中市北屯區太原路三段516號1樓',
    縣市: '台中市'
  },
  {
    店號: 155153,
    店名: '吉得堡',
    地址: '台中市梧棲區中興路121號',
    縣市: '台中市'
  },
  {
    店號: 155267,
    店名: '大都會',
    地址: '台中市西屯區惠來路二段238之1號1樓',
    縣市: '台中市'
  },
  {
    店號: 155304,
    店名: '朝陽大',
    地址: '台中市霧峰區吉峰東路74號',
    縣市: '台中市'
  },
  {
    店號: 155463,
    店名: '恩光站',
    地址: '台中市西屯區環中路一段2490號',
    縣市: '台中市'
  },
  {
    店號: 155603,
    店名: '粵西',
    地址: '台中市東勢區東坑路62號1樓',
    縣市: '台中市'
  },
  {
    店號: 158624,
    店名: '大進',
    地址: '台中市南屯區五權西路二段185號',
    縣市: '台中市'
  },
  {
    店號: 158668,
    店名: '華美',
    地址: '台中市西屯區西屯路二段19號19之1號21號',
    縣市: '台中市'
  },
  {
    店號: 158761,
    店名: '萬峰',
    地址: '台中市霧峰區中正路146-20號',
    縣市: '台中市'
  },
  {
    店號: 158808,
    店名: '歐風',
    地址: '台中市西屯區惠民路199號',
    縣市: '台中市'
  },
  {
    店號: 158842,
    店名: '錦花',
    地址: '台中市中區光復路127號',
    縣市: '台中市'
  },
  {
    店號: 158978,
    店名: '健太',
    地址: '台中市北屯區太原路三段1138號',
    縣市: '台中市'
  },
  {
    店號: 159029,
    店名: '惠宇',
    地址: '台中市南屯區向上南路一段167之1號',
    縣市: '台中市'
  },
  {
    店號: 159030,
    店名: '興府',
    地址: '台中市大雅區學府路51號',
    縣市: '台中市'
  },
  {
    店號: 159111,
    店名: '逢甲',
    地址: '台中市西屯區西屯路二段272之3號之4號1樓',
    縣市: '台中市'
  },
  {
    店號: 159395,
    店名: '鑫港醫',
    地址: '台中市西屯區台灣大道四段1650號1樓',
    縣市: '台中市'
  },
  {
    店號: 160199,
    店名: '久豐',
    地址: '台中市后里區三光路36號',
    縣市: '台中市'
  },
  {
    店號: 160225,
    店名: '豐泰',
    地址: '台中市豐原區豐勢路二段396號',
    縣市: '台中市'
  },
  {
    店號: 160236,
    店名: '大甲東',
    地址: '台中市外埔區甲后路五段15號',
    縣市: '台中市'
  },
  {
    店號: 162966,
    店名: '昌平',
    地址: '台中市北屯區昌平路一段70號',
    縣市: '台中市'
  },
  {
    店號: 163523,
    店名: '新市政',
    地址: '台中市西屯區臺灣大道三段99號1樓',
    縣市: '台中市'
  },
  {
    店號: 163693,
    店名: '蔗園',
    地址: '台中市大肚區遊園路一段143號',
    縣市: '台中市'
  },
  {
    店號: 164146,
    店名: '富由',
    地址: '台中市東區自由路三段169-1號',
    縣市: '台中市'
  },
  {
    店號: 164571,
    店名: '富麗',
    地址: '台中市東區十甲里十甲路397號',
    縣市: '台中市'
  },
  {
    店號: 164582,
    店名: '新振興',
    地址: '台中市東區十甲東路217號',
    縣市: '台中市'
  },
  {
    店號: 164869,
    店名: '潭富',
    地址: '台中市潭子區中山路二段585之1號',
    縣市: '台中市'
  },
  {
    店號: 164995,
    店名: '峰資',
    地址: '台中市霧峰區樹仁路26號',
    縣市: '台中市'
  },
  {
    店號: 165035,
    店名: '新永大',
    地址: '台中市大里區大明路340號1樓',
    縣市: '台中市'
  },
  {
    店號: 165057,
    店名: '科博館',
    地址: '台中市北區淡溝里博館路92號1樓',
    縣市: '台中市'
  },
  {
    店號: 165161,
    店名: '媽祖',
    地址: '台中市大甲區光明路1號',
    縣市: '台中市'
  },
  {
    店號: 165194,
    店名: '新興陽',
    地址: '台中市北屯區平田里興安路一段289號1樓',
    縣市: '台中市'
  },
  {
    店號: 165600,
    店名: '龍峰',
    地址: '台中市龍井區向上路六段298號',
    縣市: '台中市'
  },
  {
    店號: 165817,
    店名: '九德',
    地址: '台中市烏日區九德村中華路43.45.47號1樓',
    縣市: '台中市'
  },
  {
    店號: 165862,
    店名: '王田',
    地址: '台中市大肚區沙田路一段386號',
    縣市: '台中市'
  },
  {
    店號: 166212,
    店名: '雅樂',
    地址: '台中市北屯區松竹路二段88號',
    縣市: '台中市'
  },
  {
    店號: 166267,
    店名: '逢學',
    地址: '台中市西屯區文華路100號',
    縣市: '台中市'
  },
  {
    店號: 166337,
    店名: '豐河',
    地址: '台中市南屯區向上路二段376號',
    縣市: '台中市'
  },
  {
    店號: 166533,
    店名: '智光',
    地址: '台中市梧棲區大智路一段525號1樓',
    縣市: '台中市'
  },
  {
    店號: 166669,
    店名: '奇積',
    地址: '台中市西屯區新科路1號',
    縣市: '台中市'
  },
  {
    店號: 166902,
    店名: '亞大醫',
    地址: '台中市霧峰區福新路222號B1樓',
    縣市: '台中市'
  },
  {
    店號: 167086,
    店名: '元保',
    地址: '台中市北區進化北路413號1樓',
    縣市: '台中市'
  },
  {
    店號: 167237,
    店名: '金格',
    地址: '台中市北屯區松竹路一段965號1樓',
    縣市: '台中市'
  },
  {
    店號: 167248,
    店名: '育智',
    地址: '台中市太平區育賢路520號',
    縣市: '台中市'
  },
  {
    店號: 167721,
    店名: '福林',
    地址: '台中市西屯區福林路31巷150號',
    縣市: '台中市'
  },
  {
    店號: 167776,
    店名: '崇金',
    地址: '台中市北屯區崇德路三段195號',
    縣市: '台中市'
  },
  {
    店號: 167868,
    店名: '惠中',
    地址: '台中市南屯區黎明路二段425號1樓',
    縣市: '台中市'
  },
  {
    店號: 170233,
    店名: '第一廣',
    地址: '台中市中區台灣大道一段35號',
    縣市: '台中市'
  },
  {
    店號: 170451,
    店名: '金興',
    地址: '台中市太平區新興路312號',
    縣市: '台中市'
  },
  {
    店號: 170635,
    店名: '美群',
    地址: '台中市大里區美群路60號',
    縣市: '台中市'
  },
  {
    店號: 170783,
    店名: '龍井',
    地址: '台中市龍井區遊園南路210號',
    縣市: '台中市'
  },
  {
    店號: 171498,
    店名: '中清',
    地址: '台中市北屯區中清路二段340號',
    縣市: '台中市'
  },
  {
    店號: 174349,
    店名: '勤科大',
    地址: '台中市太平區坪林里中山路二段57號',
    縣市: '台中市'
  },
  {
    店號: 174372,
    店名: '雅潭',
    地址: '台中市大雅區學府路209號',
    縣市: '台中市'
  },
  {
    店號: 174394,
    店名: '康泰',
    地址: '台中市豐原區安康路34、36、38號1樓',
    縣市: '台中市'
  },
  {
    店號: 174408,
    店名: '平興',
    地址: '台中市北屯區遼寧路一段120號',
    縣市: '台中市'
  },
  {
    店號: 174431,
    店名: '旱溪東',
    地址: '台中市太平區中山路四段235號',
    縣市: '台中市'
  },
  {
    店號: 174545,
    店名: '大肚',
    地址: '台中市大肚區沙田路二段740號',
    縣市: '台中市'
  },
  {
    店號: 174604,
    店名: '長德',
    地址: '台中市太平區長億里永成北路125號',
    縣市: '台中市'
  },
  {
    店號: 174626,
    店名: '忠福',
    地址: '台中市西區忠明南路192號',
    縣市: '台中市'
  },
  {
    店號: 174855,
    店名: '昌旺',
    地址: '台中市北屯區昌平路二段12之16號',
    縣市: '台中市'
  },
  {
    店號: 174877,
    店名: '港臻',
    地址: '台中市梧棲區文昌路333號',
    縣市: '台中市'
  },
  {
    店號: 174903,
    店名: '精科',
    地址: '台中市南屯區嶺東路368號',
    縣市: '台中市'
  },
  {
    店號: 175010,
    店名: '國校',
    地址: '台中市北屯區國校巷16號',
    縣市: '台中市'
  },
  {
    店號: 175054,
    店名: '大明',
    地址: '台中市大里區中興路二段833號835號及中興路二段祥興一巷2號',
    縣市: '台中市'
  },
  {
    店號: 177441,
    店名: '亞太',
    地址: '台中市北區中清路一段506、508號',
    縣市: '台中市'
  },
  {
    店號: 177522,
    店名: '進合',
    地址: '台中市北區進化路328號',
    縣市: '台中市'
  },
  {
    店號: 179621,
    店名: '太明',
    地址: '台中市烏日區太明路136號',
    縣市: '台中市'
  },
  {
    店號: 179920,
    店名: '一中',
    地址: '台中市北區一中街98號1樓',
    縣市: '台中市'
  },
  {
    店號: 180045,
    店名: '潭厝',
    地址: '台中市潭子區環中東路一段5號',
    縣市: '台中市'
  },
  {
    店號: 180137,
    店名: '賢和',
    地址: '台中市北屯區景賢路230號',
    縣市: '台中市'
  },
  {
    店號: 180230,
    店名: '遠百',
    地址: '台中市西屯區台灣大道三段251號10樓',
    縣市: '台中市'
  },
  {
    店號: 180274,
    店名: '漢翔',
    地址: '台中市西屯區福星北路59號',
    縣市: '台中市'
  },
  {
    店號: 180333,
    店名: '大仁',
    地址: '台中市梧棲區頂寮里28鄰大仁路二段71號',
    縣市: '台中市'
  },
  {
    店號: 180436,
    店名: '欣浩',
    地址: '台中市清水區五權路121號',
    縣市: '台中市'
  },
  {
    店號: 180469,
    店名: '豐積',
    地址: '台中市大雅區科雅西路5號B2樓',
    縣市: '台中市'
  },
  {
    店號: 180517,
    店名: '大貿',
    地址: '台中市西屯區中平路279號',
    縣市: '台中市'
  },
  {
    店號: 180551,
    店名: '港務',
    地址: '台中市梧棲區中和里15鄰中橫一路12號',
    縣市: '台中市'
  },
  {
    店號: 180632,
    店名: '環山',
    地址: '台中市和平區中興路三段64-5號.64-6號',
    縣市: '台中市'
  },
  {
    店號: 180827,
    店名: '鑫工三',
    地址: '台中市西屯區中工三路123.125號1樓',
    縣市: '台中市'
  },
  {
    店號: 180964,
    店名: '嶺寶',
    地址: '台中市南屯區忠勇路23-12號1樓',
    縣市: '台中市'
  },
  {
    店號: 181244,
    店名: '明興',
    地址: '台中市南區忠明南路929號',
    縣市: '台中市'
  },
  {
    店號: 181255,
    店名: '美德',
    地址: '台中市北區民權路472號1樓466巷1.3號1樓',
    縣市: '台中市'
  },
  {
    店號: 181314,
    店名: '大金',
    地址: '台中市大里區中興路一段255號',
    縣市: '台中市'
  },
  {
    店號: 181381,
    店名: '大立光',
    地址: '台中市南屯區精科路13號4樓',
    縣市: '台中市'
  },
  {
    店號: 181565,
    店名: '世界',
    地址: '台中市東區十甲路202號',
    縣市: '台中市'
  },
  {
    店號: 181624,
    店名: '興惠',
    地址: '台中市南區國光路250號',
    縣市: '台中市'
  },
  {
    店號: 181772,
    店名: '北勢東',
    地址: '台中市沙鹿區北勢東路507之8號9號',
    縣市: '台中市'
  },
  {
    店號: 181956,
    店名: '逢科',
    地址: '台中市西屯區青海路二段556號',
    縣市: '台中市'
  },
  {
    店號: 182199,
    店名: '保康',
    地址: '台中市豐原區保康路160號',
    縣市: '台中市'
  },
  {
    店號: 182270,
    店名: '鑫德',
    地址: '台中市太平區新興路85-1號',
    縣市: '台中市'
  },
  {
    店號: 182328,
    店名: '康勢',
    地址: '台中市霧峰區豐正路648號',
    縣市: '台中市'
  },
  {
    店號: 182339,
    店名: '權旺',
    地址: '台中市南屯區五權西路二段812號',
    縣市: '台中市'
  },
  {
    店號: 182410,
    店名: '惠馨',
    地址: '台中市南屯區大墩南路332.336號',
    縣市: '台中市'
  },
  {
    店號: 182421,
    店名: '中展館',
    地址: '台中市烏日區中山路三段1-1號',
    縣市: '台中市'
  },
  {
    店號: 182432,
    店名: '榮田',
    地址: '台中市烏日區三榮路二段199號',
    縣市: '台中市'
  },
  {
    店號: 182557,
    店名: '太舜',
    地址: '台中市潭子區潭興路二段350號1樓',
    縣市: '台中市'
  },
  {
    店號: 182616,
    店名: '川越',
    地址: '台中市北屯區昌平東六路121號',
    縣市: '台中市'
  },
  {
    店號: 182764,
    店名: '新榮',
    地址: '台中市大里區東榮路552號',
    縣市: '台中市'
  },
  {
    店號: 182867,
    店名: '曾厝',
    地址: '台中市霧峰區振興街32.36.38號',
    縣市: '台中市'
  },
  {
    店號: 183170,
    店名: '梨山',
    地址: '台中市和平區中正路6號1樓',
    縣市: '台中市'
  },
  {
    店號: 183217,
    店名: '賴厝',
    地址: '台中市北區漢口路四段102號1樓.地下樓',
    縣市: '台中市'
  },
  {
    店號: 183365,
    店名: '英荃',
    地址: '台中市清水區中山路39.41.43號',
    縣市: '台中市'
  },
  {
    店號: 183424,
    店名: '港昌',
    地址: '台中市梧棲區港埠路一段986號',
    縣市: '台中市'
  },
  {
    店號: 183479,
    店名: '鏵智',
    地址: '台中市梧棲區中華路二段351號',
    縣市: '台中市'
  },
  {
    店號: 183550,
    店名: '壹盛',
    地址: '台中市南區忠孝路166號',
    縣市: '台中市'
  },
  {
    店號: 183675,
    店名: '聯鑫',
    地址: '台中市中區建國路143.145號',
    縣市: '台中市'
  },
  {
    店號: 184106,
    店名: '龍億',
    地址: '台中市龍井區沙田路五段143號',
    縣市: '台中市'
  },
  {
    店號: 184195,
    店名: '三景',
    地址: '台中市梧棲區臺灣大道十段168號(第1930號櫃位)',
    縣市: '台中市'
  },
  {
    店號: 184221,
    店名: '祥順東',
    地址: '台中市北屯區祥順東路一段2號',
    縣市: '台中市'
  },
  {
    店號: 184243,
    店名: '浤雅',
    地址: '台中市大雅區中清路四段737號',
    縣市: '台中市'
  },
  {
    店號: 184302,
    店名: '富宇',
    地址: '台中市北屯區建和路二段273.275號',
    縣市: '台中市'
  },
  {
    店號: 184335,
    店名: '幼勝',
    地址: '台中市大甲區中山路二段920之21號之22號之23號之25號之26號',
    縣市: '台中市'
  },
  {
    店號: 184357,
    店名: '后里棧',
    地址: '台中市后里區馬場路300號B1樓',
    縣市: '台中市'
  },
  {
    店號: 184852,
    店名: '順天',
    地址: '台中市大甲區順天路154號',
    縣市: '台中市'
  },
  {
    店號: 185006,
    店名: '新美',
    地址: '台中市大甲區經國路329號',
    縣市: '台中市'
  },
  {
    店號: 185419,
    店名: '東海',
    地址: '台中市龍井區台灣大道五段3巷43號45號1樓',
    縣市: '台中市'
  },
  {
    店號: 185497,
    店名: '豐樂',
    地址: '台中市北屯區崇德路三段608號',
    縣市: '台中市'
  },
  {
    店號: 185958,
    店名: '大將作',
    地址: '台中市西區英才路410號',
    縣市: '台中市'
  },
  {
    店號: 186571,
    店名: '福漢',
    地址: '台中市西屯區何福里漢口路二段112號112-1號',
    縣市: '台中市'
  },
  {
    店號: 186674,
    店名: '美生',
    地址: '台中市西區美村路一段54號',
    縣市: '台中市'
  },
  {
    店號: 186685,
    店名: '瑞陽',
    地址: '台中市南屯區河南路四段442號446號1,2樓',
    縣市: '台中市'
  },
  {
    店號: 186700,
    店名: '民主',
    地址: '台中市南區復興路三段322號324號326號',
    縣市: '台中市'
  },
  {
    店號: 186881,
    店名: '展騰',
    地址: '台中市西屯區台灣大道三段688號690號',
    縣市: '台中市'
  },
  {
    店號: 186906,
    店名: '廣裕',
    地址: '台中市大雅區中山路145號',
    縣市: '台中市'
  },
  {
    店號: 187079,
    店名: '權美',
    地址: '台中市西區美村路一段736號',
    縣市: '台中市'
  },
  {
    店號: 187080,
    店名: '元宏',
    地址: '台中市烏日區溪南路一段722號',
    縣市: '台中市'
  },
  {
    店號: 187312,
    店名: '坑口',
    地址: '台中市霧峰區中正路563號',
    縣市: '台中市'
  },
  {
    店號: 187448,
    店名: '權貴',
    地址: '台中市南區五權南路189號',
    縣市: '台中市'
  },
  {
    店號: 187747,
    店名: '瑞興',
    地址: '台中市豐原區中正路499號',
    縣市: '台中市'
  },
  {
    店號: 188290,
    店名: '中龍',
    地址: '台中市龍井區麗水里中南一路一段7號1樓',
    縣市: '台中市'
  },
  {
    店號: 188441,
    店名: '新樹孝',
    地址: '台中市太平區樹孝路48號50號1樓',
    縣市: '台中市'
  },
  {
    店號: 188740,
    店名: '中城',
    地址: '台中市大里區中興路一段328號',
    縣市: '台中市'
  },
  {
    店號: 188924,
    店名: '隆恩',
    地址: '台中市西屯區大墩十八街116號1樓',
    縣市: '台中市'
  },
  {
    店號: 189020,
    店名: '遊園',
    地址: '台中市大肚區遊園路二段146號1樓',
    縣市: '台中市'
  },
  {
    店號: 189042,
    店名: '東寶',
    地址: '台中市潭子區昌平路三段152號',
    縣市: '台中市'
  },
  {
    店號: 189112,
    店名: '喀哩',
    地址: '台中市烏日區溪南路二段380號1樓',
    縣市: '台中市'
  },
  {
    店號: 189307,
    店名: '新西屯',
    地址: '台中市西屯區西屯路二段281-3號281-4號',
    縣市: '台中市'
  },
  {
    店號: 190606,
    店名: '潭欣',
    地址: '台中市潭子區福潭路622號1樓',
    縣市: '台中市'
  },
  {
    店號: 192820,
    店名: '保雅',
    地址: '台中市沙鹿區屏西路55號',
    縣市: '台中市'
  },
  {
    店號: 192842,
    店名: '后旺',
    地址: '台中市后里區甲后路二段742號一樓',
    縣市: '台中市'
  },
  {
    店號: 192967,
    店名: '神采',
    地址: '台中市神岡區中山路773號',
    縣市: '台中市'
  },
  {
    店號: 193155,
    店名: '順太',
    地址: '台中市北屯區太順路112號1樓',
    縣市: '台中市'
  },
  {
    店號: 193281,
    店名: '鑫大立',
    地址: '台中市南屯區精科路11號2樓',
    縣市: '台中市'
  },
  {
    店號: 193638,
    店名: '甲渭',
    地址: '台中市大甲區中山路二段905之12號',
    縣市: '台中市'
  },
  {
    店號: 193694,
    店名: '泰安一',
    地址: '台中市后里區安眉路113號',
    縣市: '台中市'
  },
  {
    店號: 193708,
    店名: '泰安綻',
    地址: '台中市后里區九甲七路400號',
    縣市: '台中市'
  },
  {
    店號: 193719,
    店名: '泰安二',
    地址: '台中市后里區安眉路113號',
    縣市: '台中市'
  },
  {
    店號: 193720,
    店名: '泰安三',
    地址: '台中市后里區九甲七路400號',
    縣市: '台中市'
  },
  {
    店號: 193797,
    店名: '君悅',
    地址: '台中市北屯區軍福十三路68號',
    縣市: '台中市'
  },
  {
    店號: 193982,
    店名: '逢星',
    地址: '台中市西屯區福星路651-8號',
    縣市: '台中市'
  },
  {
    店號: 193993,
    店名: '和平',
    地址: '台中市和平區東關路三段161之2號',
    縣市: '台中市'
  },
  {
    店號: 194262,
    店名: '豐竹',
    地址: '台中市大里區健民路97號',
    縣市: '台中市'
  },
  {
    店號: 194446,
    店名: '禾康',
    地址: '台中市神岡區三民路630號1樓',
    縣市: '台中市'
  },
  {
    店號: 194561,
    店名: '晞寶',
    地址: '台中市大雅區昌平路四段556號',
    縣市: '台中市'
  },
  {
    店號: 194620,
    店名: '平和',
    地址: '台中市沙鹿區平等路100號',
    縣市: '台中市'
  },
  {
    店號: 194804,
    店名: '鑫文山',
    地址: '台中市南屯區文山路20號和22號',
    縣市: '台中市'
  },
  {
    店號: 194826,
    店名: '新繼光',
    地址: '台中市中區繼光街64號一樓',
    縣市: '台中市'
  },
  {
    店號: 194848,
    店名: '大邁',
    地址: '台中市大雅區大林路275號',
    縣市: '台中市'
  },
  {
    店號: 195184,
    店名: '漢展',
    地址: '台中市東區自由路四段436號',
    縣市: '台中市'
  },
  {
    店號: 195254,
    店名: '逢吉',
    地址: '台中市西屯區西安街275號',
    縣市: '台中市'
  },
  {
    店號: 195368,
    店名: '豐年',
    地址: '台中市太平區環太東路345號',
    縣市: '台中市'
  },
  {
    店號: 195450,
    店名: '逢美',
    地址: '台中市西屯區烈美街98號',
    縣市: '台中市'
  },
  {
    店號: 195933,
    店名: '三和',
    地址: '台中市烏日區三榮路一段558號',
    縣市: '台中市'
  },
  {
    店號: 195999,
    店名: '建丞',
    地址: '台中市南區建成路1683號1樓',
    縣市: '台中市'
  },
  {
    店號: 196154,
    店名: '龍竹',
    地址: '台中市龍井區竹坑里沙田路四段316號',
    縣市: '台中市'
  },
  {
    店號: 196338,
    店名: '中醫五',
    地址: '台中市北區學士路2號',
    縣市: '台中市'
  },
  {
    店號: 196419,
    店名: '振福',
    地址: '台中市太平區振福路361巷6號1樓',
    縣市: '台中市'
  },
  {
    店號: 196774,
    店名: '超贊',
    地址: '台中市南區高工路202號1樓',
    縣市: '台中市'
  },
  {
    店號: 196969,
    店名: '超億',
    地址: '台中市西區公益路126號',
    縣市: '台中市'
  },
  {
    店號: 197021,
    店名: '北庄',
    地址: '台中市北屯區后庄北路221-1號',
    縣市: '台中市'
  },
  {
    店號: 197065,
    店名: '佳茂',
    地址: '台中市潭子區中山路一段17號1樓',
    縣市: '台中市'
  },
  {
    店號: 197076,
    店名: '新中工',
    地址: '台中市西屯區工業區一路58之1號',
    縣市: '台中市'
  },
  {
    店號: 197216,
    店名: '富強',
    地址: '台中市北區國強街142號及天祥街100號1樓',
    縣市: '台中市'
  },
  {
    店號: 197320,
    店名: '豐光',
    地址: '台中市豐原區中山路581號583號',
    縣市: '台中市'
  },
  {
    店號: 197456,
    店名: '港安',
    地址: '台中市西屯區西屯路三段179之9號',
    縣市: '台中市'
  },
  {
    店號: 197674,
    店名: '宜寧',
    地址: '台中市南區東興路一段21號1樓',
    縣市: '台中市'
  },
  {
    店號: 197917,
    店名: '工站',
    地址: '台中市南屯區五權西路三段350號',
    縣市: '台中市'
  },
  {
    店號: 198356,
    店名: '山莊',
    地址: '台中市霧峰區中正路650號1樓',
    縣市: '台中市'
  },
  {
    店號: 198460,
    店名: '梧汊港',
    地址: '台中市清水區北堤路30號',
    縣市: '台中市'
  },
  {
    店號: 198563,
    店名: '吉仕多',
    地址: '台中市太平區樹德路255號',
    縣市: '台中市'
  },
  {
    店號: 198633,
    店名: '新清水',
    地址: '台中市清水區五權路16號1樓、民有路1號1樓',
    縣市: '台中市'
  },
  {
    店號: 198725,
    店名: '巧聖',
    地址: '台中市大里區西榮里益民路二段137號',
    縣市: '台中市'
  },
  {
    店號: 198895,
    店名: '衛道',
    地址: '台中市北區進化北路378-6號',
    縣市: '台中市'
  },
  {
    店號: 199083,
    店名: '丰太',
    地址: '台中市太平區永豐路351號1樓',
    縣市: '台中市'
  },
  {
    店號: 199289,
    店名: '廣環',
    地址: '台中市西屯區環中路二段698號',
    縣市: '台中市'
  },
  {
    店號: 199304,
    店名: '精站',
    地址: '台中市南屯區向上路五段289號',
    縣市: '台中市'
  },
  {
    店號: 199902,
    店名: '超學',
    地址: '台中市北區進化北路327號與325號1樓',
    縣市: '台中市'
  },
  {
    店號: 199924,
    店名: '原義',
    地址: '台中市西屯區忠義街80號',
    縣市: '台中市'
  },
  {
    店號: 200022,
    店名: '軟體',
    地址: '台中市大里區東湖里中山路131號',
    縣市: '台中市'
  },
  {
    店號: 200099,
    店名: '昌進',
    地址: '台中市南屯區大進街387號1樓.大墩十二街151號1樓',
    縣市: '台中市'
  },
  {
    店號: 200273,
    店名: '神圳',
    地址: '台中市神岡區厚生路66-1號',
    縣市: '台中市'
  },
  {
    店號: 200387,
    店名: '七綻',
    地址: '台中市北屯區文心路四段57號',
    縣市: '台中市'
  },
  {
    店號: 200516,
    店名: '興安',
    地址: '台中市沙鹿區興安路25-1號1樓',
    縣市: '台中市'
  },
  {
    店號: 200701,
    店名: '欣花園',
    地址: '台中市北屯區華美西街二段478號',
    縣市: '台中市'
  },
  {
    店號: 201346,
    店名: '潭秀',
    地址: '台中市潭子區雅潭路一段60號62號64號1樓',
    縣市: '台中市'
  },
  {
    店號: 201771,
    店名: '汶莊',
    地址: '台中市北區中清路一段102號1樓',
    縣市: '台中市'
  },
  {
    店號: 201852,
    店名: '墩富',
    地址: '台中市南屯區大墩路572號',
    縣市: '台中市'
  },
  {
    店號: 201977,
    店名: '逢華',
    地址: '台中市西屯區文華路10-7號',
    縣市: '台中市'
  },
  {
    店號: 202408,
    店名: '豐梅',
    地址: '台中市石岡區豐勢路460號1樓',
    縣市: '台中市'
  },
  {
    店號: 206606,
    店名: '美豐',
    地址: '台中市后里區三豐路五段128號',
    縣市: '台中市'
  },
  {
    店號: 206709,
    店名: '博一',
    地址: '台中市北區英才路388號388之1號及博館一街37號',
    縣市: '台中市'
  },
  {
    店號: 206798,
    店名: '建日',
    地址: '台中市烏日區建國路419號',
    縣市: '台中市'
  },
  {
    店號: 206891,
    店名: '后科',
    地址: '台中市后里區內東路306號',
    縣市: '台中市'
  },
  {
    店號: 206927,
    店名: '浤淶',
    地址: '台中市大雅區中清路四段408號',
    縣市: '台中市'
  },
  {
    店號: 206961,
    店名: '旭日',
    地址: '台中市北區五權路272.274.276號與太平路221號',
    縣市: '台中市'
  },
  {
    店號: 207159,
    店名: '北忠',
    地址: '台中市沙鹿區北勢東路806號',
    縣市: '台中市'
  },
  {
    店號: 207182,
    店名: '河南',
    地址: '台中市西屯區河南路二段443號',
    縣市: '台中市'
  },
  {
    店號: 207274,
    店名: '樂河',
    地址: '台中市北屯區軍和街457號1樓和461號1樓2樓',
    縣市: '台中市'
  },
  {
    店號: 207388,
    店名: '景大和',
    地址: '台中市北屯區景賢路191號',
    縣市: '台中市'
  },
  {
    店號: 207470,
    店名: '微笑',
    地址: '台中市北區育樂街66.68號一樓及夾層',
    縣市: '台中市'
  },
  {
    店號: 207779,
    店名: '晶材',
    地址: '台中市后里區后科路二段335號',
    縣市: '台中市'
  },
  {
    店號: 208037,
    店名: '環禹',
    地址: '台中市大雅區雅環路二段126號',
    縣市: '台中市'
  },
  {
    店號: 208048,
    店名: '金西屯',
    地址: '台中市西屯區西屯路三段79-33號',
    縣市: '台中市'
  },
  {
    店號: 208107,
    店名: '弘大',
    地址: '台中市沙鹿區晉武路9號',
    縣市: '台中市'
  },
  {
    店號: 208288,
    店名: '大晉',
    地址: '台中市沙鹿區東晉路133號',
    縣市: '台中市'
  },
  {
    店號: 208325,
    店名: '東蘭',
    地址: '台中市東勢區東蘭路194號',
    縣市: '台中市'
  },
  {
    店號: 208598,
    店名: '新福',
    地址: '台中市霧峰區新厝路481號',
    縣市: '台中市'
  },
  {
    店號: 208624,
    店名: '潮貴',
    地址: '台中市西屯區朝馬路158號1樓',
    縣市: '台中市'
  },
  {
    店號: 208635,
    店名: '健勝',
    地址: '台中市北區健行路701號',
    縣市: '台中市'
  },
  {
    店號: 208897,
    店名: '新丁台',
    地址: '台中市霧峰區四德路477-2號477-2-1號',
    縣市: '台中市'
  },
  {
    店號: 209096,
    店名: '泉富',
    地址: '台中市潭子區中山路一段57號1樓',
    縣市: '台中市'
  },
  {
    店號: 209225,
    店名: '月湖',
    地址: '台中市后里區公安路147-15號',
    縣市: '台中市'
  },
  {
    店號: 209373,
    店名: '大唐',
    地址: '台中市北屯區大連北街98號1樓',
    縣市: '台中市'
  },
  {
    店號: 209546,
    店名: '鹿成',
    地址: '台中市沙鹿區光華路394.396號1樓',
    縣市: '台中市'
  },
  {
    店號: 209591,
    店名: '藍鵲',
    地址: '台中市大雅區永和路112-26號',
    縣市: '台中市'
  },
  {
    店號: 209672,
    店名: '北陽',
    地址: '台中市豐原區北陽路288號',
    縣市: '台中市'
  },
  {
    店號: 209683,
    店名: '后宥',
    地址: '台中市后里區甲后路一段955號',
    縣市: '台中市'
  },
  {
    店號: 209720,
    店名: '朝富',
    地址: '台中市西屯區朝富路2號1樓',
    縣市: '台中市'
  },
  {
    店號: 209764,
    店名: '文銧',
    地址: '台中市沙鹿區斗潭路230號1樓',
    縣市: '台中市'
  },
  {
    店號: 209786,
    店名: '興中街',
    地址: '台中市新社區興中街90-11號',
    縣市: '台中市'
  },
  {
    店號: 209878,
    店名: '軍榮',
    地址: '台中市北屯區軍榮一街90號1樓',
    縣市: '台中市'
  },
  {
    店號: 210030,
    店名: '哈魚',
    地址: '台中市南屯區環中路四段6號',
    縣市: '台中市'
  },
  {
    店號: 210052,
    店名: '康順',
    地址: '台中市霧峰區吉峰路85號',
    縣市: '台中市'
  },
  {
    店號: 210395,
    店名: '東苑',
    地址: '台中市龍井區台灣大道五段3巷62弄81號',
    縣市: '台中市'
  },
  {
    店號: 210627,
    店名: '大里杙',
    地址: '台中市大里區大里路510號',
    縣市: '台中市'
  },
  {
    店號: 210889,
    店名: '正勤',
    地址: '台中市西屯區黎明路三段539-3號.539-5號',
    縣市: '台中市'
  },
  {
    店號: 210890,
    店名: '鎮瀾',
    地址: '台中市大甲區大甲里鎮瀾街102號',
    縣市: '台中市'
  },
  {
    店號: 210937,
    店名: '富亦',
    地址: '台中市南屯區公益路二段939號1樓和龍富路四段552號1樓',
    縣市: '台中市'
  },
  {
    店號: 210971,
    店名: '中蔗',
    地址: '台中市大肚區中蔗路39號',
    縣市: '台中市'
  },
  {
    店號: 211125,
    店名: '三社',
    地址: '台中市神岡區三社路256號',
    縣市: '台中市'
  },
  {
    店號: 211158,
    店名: '育立',
    地址: '台中市太平區育賢路282號',
    縣市: '台中市'
  },
  {
    店號: 211527,
    店名: '吉泰來',
    地址: '台中市霧峰區中正路583號',
    縣市: '台中市'
  },
  {
    店號: 211538,
    店名: '豐社',
    地址: '台中市豐原區社皮里社皮路78號',
    縣市: '台中市'
  },
  {
    店號: 211583,
    店名: '松站',
    地址: '台中市北屯區松竹路一段1386號1388號',
    縣市: '台中市'
  },
  {
    店號: 211826,
    店名: '中醫大',
    地址: '台中市北屯區經貿路一段110號',
    縣市: '台中市'
  },
  {
    店號: 211860,
    店名: '愛心',
    地址: '台中市大里區愛心路43號',
    縣市: '台中市'
  },
  {
    店號: 211882,
    店名: '智復',
    地址: '台中市東區復興路四段210號1.2樓.地下層',
    縣市: '台中市'
  },
  {
    店號: 212209,
    店名: '文豐',
    地址: '台中市南屯區文心南五路ㄧ段319號',
    縣市: '台中市'
  },
  {
    店號: 212302,
    店名: '春安',
    地址: '台中市南屯區嶺東南路165號',
    縣市: '台中市'
  },
  {
    店號: 213578,
    店名: '新學和',
    地址: '台中市南區學府路70號70-1號72號1樓',
    縣市: '台中市'
  },
  {
    店號: 213877,
    店名: '遠平',
    地址: '台中市北屯區北平路三段75-4號75-5號',
    縣市: '台中市'
  },
  {
    店號: 214168,
    店名: '中農',
    地址: '台中市東區台中路195號197號199號',
    縣市: '台中市'
  },
  {
    店號: 214250,
    店名: '高工',
    地址: '台中市南區高工路168號1樓',
    縣市: '台中市'
  },
  {
    店號: 214412,
    店名: '友達光',
    地址: '台中市西屯區中科路1號',
    縣市: '台中市'
  },
  {
    店號: 214652,
    店名: '三中',
    地址: '台中市西區忠明路54-1號1樓、博館路231號233號235號237號1樓',
    縣市: '台中市'
  },
  {
    店號: 214663,
    店名: '鑫廣',
    地址: '台中市南區福順里忠明南路787號',
    縣市: '台中市'
  },
  {
    店號: 214755,
    店名: '潭濟',
    地址: '台中市潭子區豐興路一段88號B1樓',
    縣市: '台中市'
  },
  {
    店號: 214788,
    店名: '明義',
    地址: '台中市西區明義街6號',
    縣市: '台中市'
  },
  {
    店號: 215183,
    店名: '軍建',
    地址: '台中市北屯區軍福十三路198號',
    縣市: '台中市'
  },
  {
    店號: 215275,
    店名: '市鑫',
    地址: '台中市中區自由路二段9號1樓',
    縣市: '台中市'
  },
  {
    店號: 215286,
    店名: '無尾熊',
    地址: '台中市南區德富路73號75號1樓',
    縣市: '台中市'
  },
  {
    店號: 215301,
    店名: '鑫友達',
    地址: '台中市西屯區中科路1號',
    縣市: '台中市'
  },
  {
    店號: 215312,
    店名: '友達宿',
    地址: '台中市西屯區科雅路2號',
    縣市: '台中市'
  },
  {
    店號: 215747,
    店名: '盛民興',
    地址: '台中市太平區中山路二段366號366-1號368號',
    縣市: '台中市'
  },
  {
    店號: 215987,
    店名: '環東',
    地址: '台中市北屯區東山路一段306-1號1.2樓及環中東路二段268號1樓',
    縣市: '台中市'
  },
  {
    店號: 216049,
    店名: '奕慶',
    地址: '台中市北區五權路387號及五常街13號15號',
    縣市: '台中市'
  },
  {
    店號: 216577,
    店名: '欣三豐',
    地址: '台中市豐原區源豐路89、93、95號1樓',
    縣市: '台中市'
  },
  {
    店號: 216762,
    店名: '瑞彬',
    地址: '台中市豐原區西安街68號',
    縣市: '台中市'
  },
  {
    店號: 216773,
    店名: '梧棲',
    地址: '台中市梧棲區台灣大道八段960號,962號1樓',
    縣市: '台中市'
  },
  {
    店號: 216795,
    店名: '松佑',
    地址: '台中市北屯區松竹五路二段22號1樓',
    縣市: '台中市'
  },
  {
    店號: 216854,
    店名: '工權',
    地址: '台中市南屯區工業區十八路31-1號',
    縣市: '台中市'
  },
  {
    店號: 216887,
    店名: '詠豐',
    地址: '台中市南屯區永春東路1230號',
    縣市: '台中市'
  },
  {
    店號: 216898,
    店名: '向興',
    地址: '台中市西區向上路一段95號',
    縣市: '台中市'
  },
  {
    店號: 216902,
    店名: '權大',
    地址: '台中市西區五權西路一段271號1樓2樓',
    縣市: '台中市'
  },
  {
    店號: 216913,
    店名: '樂群',
    地址: '台中市西區林森路80號及樂群街81號',
    縣市: '台中市'
  },
  {
    店號: 217156,
    店名: '向勝',
    地址: '台中市西區東興路三段57號',
    縣市: '台中市'
  },
  {
    店號: 217167,
    店名: '雅津',
    地址: '台中市北區天津路二段9號.11號',
    縣市: '台中市'
  },
  {
    店號: 217178,
    店名: '平西',
    地址: '台中市北區陜西路107號109號',
    縣市: '台中市'
  },
  {
    店號: 217189,
    店名: '陜西',
    地址: '台中市北區陜西路48號48之1號1樓',
    縣市: '台中市'
  },
  {
    店號: 217293,
    店名: '熊貓',
    地址: '台中市南屯區向上南路一段325號1樓',
    縣市: '台中市'
  },
  {
    店號: 217396,
    店名: '西屯重',
    地址: '台中市西屯區西屯路二段95之25號,95之26號1樓',
    縣市: '台中市'
  },
  {
    店號: 217422,
    店名: '五權',
    地址: '台中市西區南屯路一段60號62號64號',
    縣市: '台中市'
  },
  {
    店號: 217455,
    店名: '景和',
    地址: '台中市北屯區太原路三段907號',
    縣市: '台中市'
  },
  {
    店號: 227924,
    店名: '神全',
    地址: '台中市神岡區豐洲路1556號',
    縣市: '台中市'
  },
  {
    店號: 227935,
    店名: '甲旺',
    地址: '台中市大甲區經國路2076號',
    縣市: '台中市'
  },
  {
    店號: 227980,
    店名: '飛翔',
    地址: '台中市清水區和睦路三段238號',
    縣市: '台中市'
  },
  {
    店號: 227991,
    店名: '蘋果',
    地址: '台中市大里區善化路155號',
    縣市: '台中市'
  },
  {
    店號: 228134,
    店名: '榮春',
    地址: '台中市豐原區圓環西路92號',
    縣市: '台中市'
  },
  {
    店號: 228204,
    店名: '后成',
    地址: '台中市后里區成功路231巷2號',
    縣市: '台中市'
  },
  {
    店號: 228341,
    店名: '茂華',
    地址: '台中市大甲區蔣公路170號1樓',
    縣市: '台中市'
  },
  {
    店號: 228363,
    店名: '豐市',
    地址: '台中市西屯區市政路396號',
    縣市: '台中市'
  },
  {
    店號: 228444,
    店名: '逢大路',
    地址: '台中市西屯區逢大路13號1樓',
    縣市: '台中市'
  },
  {
    店號: 228466,
    店名: '新中榮',
    地址: '台中市西屯區台灣大道四段1650號',
    縣市: '台中市'
  },
  {
    店號: 228499,
    店名: '墩十九',
    地址: '台中市西屯區大墩19街186號',
    縣市: '台中市'
  },
  {
    店號: 228754,
    店名: '靜大',
    地址: '台中市沙鹿區晉文路45.47號1樓',
    縣市: '台中市'
  },
  {
    店號: 228798,
    店名: '豐嶟',
    地址: '台中市豐原區豐科路53號',
    縣市: '台中市'
  },
  {
    店號: 228813,
    店名: '阿罩霧',
    地址: '台中市霧峰區中正路815號',
    縣市: '台中市'
  },
  {
    店號: 228846,
    店名: '祥興',
    地址: '台中市大里區祥興路551號',
    縣市: '台中市'
  },
  {
    店號: 228950,
    店名: '奕樂',
    地址: '台中市西區民生北路100號1樓及民權路217巷17號1樓',
    縣市: '台中市'
  },
  {
    店號: 229012,
    店名: '興祥',
    地址: '台中市烏日區興祥街189號',
    縣市: '台中市'
  },
  {
    店號: 229034,
    店名: '連強',
    地址: '台中市梧棲區自強一街76號',
    縣市: '台中市'
  },
  {
    店號: 229045,
    店名: '豐洲路',
    地址: '台中市神岡區豐洲路656號',
    縣市: '台中市'
  },
  {
    店號: 229089,
    店名: '雅合',
    地址: '台中市北屯區松義街132、136號1樓及夾層',
    縣市: '台中市'
  },
  {
    店號: 229090,
    店名: '樹義',
    地址: '台中市南區福田三街156號1樓',
    縣市: '台中市'
  },
  {
    店號: 229115,
    店名: '霧工',
    地址: '台中市霧峰區霧工一路58.60號',
    縣市: '台中市'
  },
  {
    店號: 229126,
    店名: '園臻',
    地址: '台中市烏日區三榮路一段111號',
    縣市: '台中市'
  },
  {
    店號: 229193,
    店名: '望景',
    地址: '台中市西屯區科園三路1號1樓之1',
    縣市: '台中市'
  },
  {
    店號: 229377,
    店名: '夏督',
    地址: '台中市西屯區寧夏路170號',
    縣市: '台中市'
  },
  {
    店號: 229399,
    店名: '樂樂',
    地址: '台中市太平區東平路422、430號1樓',
    縣市: '台中市'
  },
  {
    店號: 229506,
    店名: '約恩雅',
    地址: '台中市大雅區民生路一段100號',
    縣市: '台中市'
  },
  {
    店號: 229539,
    店名: '育見',
    地址: '台中市太平區育賢路321.323號',
    縣市: '台中市'
  },
  {
    店號: 229573,
    店名: '新茄投',
    地址: '台中市龍井區茄投路66-2號',
    縣市: '台中市'
  },
  {
    店號: 229621,
    店名: '美晶',
    地址: '台中市后里區后科南路88號1樓',
    縣市: '台中市'
  },
  {
    店號: 229643,
    店名: '僑隆興',
    地址: '台中市烏日區中山路三段180號',
    縣市: '台中市'
  },
  {
    店號: 229654,
    店名: '日進',
    地址: '台中市西區梅川西路二段33號1樓',
    縣市: '台中市'
  },
  {
    店號: 229665,
    店名: '欣廟東',
    地址: '台中市豐原區中正路131.133號',
    縣市: '台中市'
  },
  {
    店號: 229768,
    店名: '同貿',
    地址: '台中市北屯區中清路二段1187號1.2樓',
    縣市: '台中市'
  },
  {
    店號: 229838,
    店名: '共和國',
    地址: '台中市烏日區高鐵一路299號1樓',
    縣市: '台中市'
  },
  {
    店號: 229850,
    店名: '鑫建德',
    地址: '台中市東區建德街174.176.178.180號',
    縣市: '台中市'
  },
  {
    店號: 230001,
    店名: '逢辰',
    地址: '台中市西屯區西屯路二段260-18號1樓',
    縣市: '台中市'
  },
  {
    店號: 230104,
    店名: '百惠',
    地址: '台中市西屯區台灣大道三段182號1.2樓',
    縣市: '台中市'
  },
  {
    店號: 230193,
    店名: '松賀',
    地址: '台中市北屯區松茂里松山街148號1樓和地下層',
    縣市: '台中市'
  },
  {
    店號: 230333,
    店名: '站前',
    地址: '台中市烏日區站區二路181號、183號',
    縣市: '台中市'
  },
  {
    店號: 230425,
    店名: '樂平',
    地址: '台中市太平區東平路773號1樓',
    縣市: '台中市'
  },
  {
    店號: 230492,
    店名: '亞旺',
    地址: '台中市大雅區中清東路240號',
    縣市: '台中市'
  },
  {
    店號: 230539,
    店名: '新通豪',
    地址: '台中市北區漢口路三段101號',
    縣市: '台中市'
  },
  {
    店號: 230595,
    店名: '立和',
    地址: '台中市東區立德街47、49、51、53號',
    縣市: '台中市'
  },
  {
    店號: 230779,
    店名: '成科',
    地址: '台中市西屯區成都路221、223號',
    縣市: '台中市'
  },
  {
    店號: 230850,
    店名: '花樂',
    地址: '台中市石岡區豐勢路1111號1樓',
    縣市: '台中市'
  },
  {
    店號: 230942,
    店名: '鴨姆寮',
    地址: '台中市梧棲區永興路一段588巷28號1樓',
    縣市: '台中市'
  },
  {
    店號: 231026,
    店名: '富久',
    地址: '台中市北屯區南興路1052.1056號1樓',
    縣市: '台中市'
  },
  {
    店號: 231037,
    店名: '立功',
    地址: '台中市太平區育才路446.448.450號',
    縣市: '台中市'
  },
  {
    店號: 231107,
    店名: '永春',
    地址: '台中市南屯區永春東七路629號',
    縣市: '台中市'
  },
  {
    店號: 231211,
    店名: '甲尚',
    地址: '台中市大甲區武陵里興安路263號1樓',
    縣市: '台中市'
  },
  {
    店號: 231255,
    店名: '路思義',
    地址: '台中市西屯區台灣大道四段1727號1樓',
    縣市: '台中市'
  },
  {
    店號: 231336,
    店名: '美芯',
    地址: '台中市后里區三豐路四段369號1樓',
    縣市: '台中市'
  },
  {
    店號: 231370,
    店名: '潭旺',
    地址: '台中市潭子區人和路39號',
    縣市: '台中市'
  },
  {
    店號: 231392,
    店名: '維樂',
    地址: '台中市太平區溪州西路98號',
    縣市: '台中市'
  },
  {
    店號: 231440,
    店名: '文雅',
    地址: '台中市梧棲區文匯街66號',
    縣市: '台中市'
  },
  {
    店號: 231624,
    店名: '郡寶',
    地址: '台中市潭子區大富路一段7號1.2號',
    縣市: '台中市'
  },
  {
    店號: 231668,
    店名: '湧順',
    地址: '台中市北屯區樹孝路666號',
    縣市: '台中市'
  },
  {
    店號: 231819,
    店名: '新家',
    地址: '台中市大里區新仁路一段71-2號.71-3號',
    縣市: '台中市'
  },
  {
    店號: 231912,
    店名: '豐旺',
    地址: '台中市豐原區豐北街325.327.329號1樓',
    縣市: '台中市'
  },
  {
    店號: 231934,
    店名: '漢口',
    地址: '台中市西屯區漢口路一段22.24號1樓',
    縣市: '台中市'
  },
  {
    店號: 232007,
    店名: '東戰',
    地址: '台中市東區東門路121.123號1樓',
    縣市: '台中市'
  },
  {
    店號: 232328,
    店名: '嶺春',
    地址: '台中市南屯區永春北路53號1樓',
    縣市: '台中市'
  },
  {
    店號: 232498,
    店名: '智惠',
    地址: '台中市西屯區智惠街52號1樓',
    縣市: '台中市'
  },
  {
    店號: 232708,
    店名: '綠川',
    地址: '台中市中區成功路35.37號、綠川東街84號',
    縣市: '台中市'
  },
  {
    店號: 232926,
    店名: '昌東',
    地址: '台中市北屯區昌平路一段17.17-1.17-2號',
    縣市: '台中市'
  },
  {
    店號: 236630,
    店名: '裕元',
    地址: '台中市西屯區安和路168號',
    縣市: '台中市'
  },
  {
    店號: 236641,
    店名: '后庄',
    地址: '台中市北屯區后庄里后庄路141號1樓',
    縣市: '台中市'
  },
  {
    店號: 236652,
    店名: '軍松',
    地址: '台中市北屯區松竹五路199號1樓',
    縣市: '台中市'
  },
  {
    店號: 236663,
    店名: '逢貿',
    地址: '台中市西屯區黎明路三段1218號',
    縣市: '台中市'
  },
  {
    店號: 236674,
    店名: '逢德',
    地址: '台中市西屯區青海路二段321號323號',
    縣市: '台中市'
  },
  {
    店號: 236939,
    店名: '瑞盟',
    地址: '台中市西屯區福雅路143-1號',
    縣市: '台中市'
  },
  {
    店號: 237585,
    店名: '虹博',
    地址: '台中市西區博館路185號',
    縣市: '台中市'
  },
  {
    店號: 237633,
    店名: '秋紅谷',
    地址: '台中市西屯區朝富路30號32號1樓',
    縣市: '台中市'
  },
  {
    店號: 237747,
    店名: '鑫中華',
    地址: '台中市中區中華路一段153.155號一樓157號一二樓',
    縣市: '台中市'
  },
  {
    店號: 237769,
    店名: '鑫鑽',
    地址: '台中市南屯區文心南三路663號',
    縣市: '台中市'
  },
  {
    店號: 237965,
    店名: '新童',
    地址: '台中市梧棲區台灣大道八段699號',
    縣市: '台中市'
  },
  {
    店號: 238430,
    店名: '市民',
    地址: '台中市西區公益路157號',
    縣市: '台中市'
  },
  {
    店號: 238614,
    店名: '內鑫',
    地址: '台中市大里區東昇里新仁路二段92號',
    縣市: '台中市'
  },
  {
    店號: 238717,
    店名: '親親',
    地址: '台中市北區錦洲里北屯路14號.14-2號.14-3號1樓',
    縣市: '台中市'
  },
  {
    店號: 238728,
    店名: '文華',
    地址: '台中市西屯區寧夏路232號',
    縣市: '台中市'
  },
  {
    店號: 238795,
    店名: '仁化',
    地址: '台中市大里區仁化路657號',
    縣市: '台中市'
  },
  {
    店號: 238924,
    店名: '百祐',
    地址: '台中市南區美村路二段188號190號1樓',
    縣市: '台中市'
  },
  {
    店號: 238946,
    店名: '向美',
    地址: '台中市西區美村路一段302之1號302之7號',
    縣市: '台中市'
  },
  {
    店號: 239112,
    店名: '逢明',
    地址: '台中市西屯區黎明路三段158號',
    縣市: '台中市'
  },
  {
    店號: 239525,
    店名: '上誠',
    地址: '台中市西區向上路一段381號383號385號',
    縣市: '台中市'
  },
  {
    店號: 239710,
    店名: '東展',
    地址: '台中市東勢區南平里豐勢路336號',
    縣市: '台中市'
  },
  {
    店號: 239868,
    店名: '昌和',
    地址: '台中市北屯區東山路一段146之39號',
    縣市: '台中市'
  },
  {
    店號: 239983,
    店名: '博吉',
    地址: '台中市北屯區東光路786號1樓',
    縣市: '台中市'
  },
  {
    店號: 240112,
    店名: '圓通南',
    地址: '台中市潭子區潭陽里圓通南路239號',
    縣市: '台中市'
  },
  {
    店號: 240293,
    店名: '東加',
    地址: '台中市北屯區東山路一段185號',
    縣市: '台中市'
  },
  {
    店號: 240606,
    店名: '瑞城',
    地址: '台中市大里區瑞城一街1號',
    縣市: '台中市'
  },
  {
    店號: 240662,
    店名: '忠明義',
    地址: '台中市西區忠明南路16號16之1號18號1樓',
    縣市: '台中市'
  },
  {
    店號: 240673,
    店名: '同榮',
    地址: '台中市北屯區同榮路161號1樓',
    縣市: '台中市'
  },
  {
    店號: 240891,
    店名: '黎明東',
    地址: '台中市南屯區黎明東街22號',
    縣市: '台中市'
  },
  {
    店號: 241056,
    店名: '福上',
    地址: '台中市西屯區河南路二段71號1樓',
    縣市: '台中市'
  },
  {
    店號: 241126,
    店名: '生活',
    地址: '台中市南區復興路二段71巷70號1樓及忠明南路730巷17號1樓',
    縣市: '台中市'
  },
  {
    店號: 241182,
    店名: '大鋒',
    地址: '台中市潭子區大豐一路439號1樓',
    縣市: '台中市'
  },
  {
    店號: 241229,
    店名: '一路發',
    地址: '台中市清水區鰲峰路580號之15',
    縣市: '台中市'
  },
  {
    店號: 241241,
    店名: '新國光',
    地址: '台中市南區國光路82及84號;愛國街67及69號',
    縣市: '台中市'
  },
  {
    店號: 241296,
    店名: '豐采',
    地址: '台中市南屯區黎明路二段504、506、506-1號',
    縣市: '台中市'
  },
  {
    店號: 241447,
    店名: '大東家',
    地址: '台中市南區新榮里復興路三段138、140號',
    縣市: '台中市'
  },
  {
    店號: 249038,
    店名: '鎮揚',
    地址: '台中市沙鹿區南陽路439號',
    縣市: '台中市'
  },
  {
    店號: 249197,
    店名: '南屯',
    地址: '台中市南屯區南屯路二段570號',
    縣市: '台中市'
  },
  {
    店號: 249201,
    店名: '興福',
    地址: '台中市南區復興路二段175之1之2號',
    縣市: '台中市'
  },
  {
    店號: 249278,
    店名: '欣東勢',
    地址: '台中市東勢區上新里第一橫街153、155號1樓和三民街2號1樓',
    縣市: '台中市'
  },
  {
    店號: 249418,
    店名: '溪洲',
    地址: '台中市太平區新平路二段221號1樓',
    縣市: '台中市'
  },
  {
    店號: 249441,
    店名: '民府',
    地址: '台中市西區四維街22-1號24號',
    縣市: '台中市'
  },
  {
    店號: 249647,
    店名: '豐環',
    地址: '台中市豐原區豐原大道一段370號',
    縣市: '台中市'
  },
  {
    店號: 249795,
    店名: '科雅',
    地址: '台中市西屯區福雅路571-1號',
    縣市: '台中市'
  },
  {
    店號: 249809,
    店名: '福雅',
    地址: '台中市西屯區福雅路338號',
    縣市: '台中市'
  },
  {
    店號: 249902,
    店名: '三豐路',
    地址: '台中市豐原區三豐路二段289號',
    縣市: '台中市'
  },
  {
    店號: 250094,
    店名: '京達',
    地址: '台中市豐原區中正路805號',
    縣市: '台中市'
  },
  {
    店號: 250120,
    店名: '寶昇',
    地址: '台中市北屯區北屯路224之1號',
    縣市: '台中市'
  },
  {
    店號: 250175,
    店名: '大榮',
    地址: '台中市太平區中興東路189號191號',
    縣市: '台中市'
  },
  {
    店號: 250186,
    店名: '豐華',
    地址: '台中市北區崇德里進化北路148號1樓及榮華街121號1樓',
    縣市: '台中市'
  },
  {
    店號: 250245,
    店名: '上安',
    地址: '台中市西屯區至善路61號',
    縣市: '台中市'
  },
  {
    店號: 250418,
    店名: '文心',
    地址: '台中市西屯區文心路三段76號',
    縣市: '台中市'
  },
  {
    店號: 250577,
    店名: '聯信',
    地址: '台中市南區建成路1107號1樓',
    縣市: '台中市'
  },
  {
    店號: 250669,
    店名: '清康',
    地址: '台中市清水區中山路106號',
    縣市: '台中市'
  },
  {
    店號: 250739,
    店名: '竹探',
    地址: '台中市北屯區松竹路三段676-1號',
    縣市: '台中市'
  },
  {
    店號: 251411,
    店名: '鈞泰',
    地址: '台中市北屯區太原路三段1112之1號1120之1號1樓',
    縣市: '台中市'
  },
  {
    店號: 791573,
    店名: '永進',
    地址: '台中市北區進化北路297號',
    縣市: '台中市'
  },
  {
    店號: 800125,
    店名: '豐東',
    地址: '台中市豐原區豐東路218號',
    縣市: '台中市'
  },
  {
    店號: 810018,
    店名: '草湖',
    地址: '台中市大里區中興路一段11之6號11之7號1樓東南路1號1樓',
    縣市: '台中市'
  },
  {
    店號: 822642,
    店名: '雙行',
    地址: '台中市北區雙十路二段47號',
    縣市: '台中市'
  },
  {
    店號: 831598,
    店名: '童醫',
    地址: '台中市沙鹿區成功東街1號',
    縣市: '台中市'
  },
  {
    店號: 832030,
    店名: '新墩',
    地址: '台中市西屯區大墩路901號',
    縣市: '台中市'
  },
  {
    店號: 840488,
    店名: '第一',
    地址: '台中市太平區新福里中山路四段112、112-1.112-2號1樓',
    縣市: '台中市'
  },
  {
    店號: 842325,
    店名: '中棲',
    地址: '台中市沙鹿區台灣大道七段259號',
    縣市: '台中市'
  },
  {
    店號: 844192,
    店名: '靜宜',
    地址: '台中市沙鹿區鎮南路二段293號',
    縣市: '台中市'
  },
  {
    店號: 845612,
    店名: '新立德',
    地址: '台中市東區復興路四段4號台中路45號',
    縣市: '台中市'
  },
  {
    店號: 846109,
    店名: '育仁',
    地址: '台中市北區進化路583號',
    縣市: '台中市'
  },
  {
    店號: 846486,
    店名: '向心',
    地址: '台中市南屯區大墩6街284號',
    縣市: '台中市'
  },
  {
    店號: 852067,
    店名: '順大',
    地址: '台中市大甲區中山路一段1085號',
    縣市: '台中市'
  },
  {
    店號: 852425,
    店名: '昌大',
    地址: '台中市北屯區大連路二段283號',
    縣市: '台中市'
  },
  {
    店號: 854258,
    店名: '向上',
    地址: '台中市南屯區黎明路二段193號',
    縣市: '台中市'
  },
  {
    店號: 854661,
    店名: '大全',
    地址: '台中市西區公館路136號138號',
    縣市: '台中市'
  },
  {
    店號: 854742,
    店名: '豐信',
    地址: '台中市豐原區復興路75號信義街77號',
    縣市: '台中市'
  },
  {
    店號: 860541,
    店名: '復慶',
    地址: '台中市南區樹義里大慶街二段5-2號',
    縣市: '台中市'
  },
  {
    店號: 860644,
    店名: '日出',
    地址: '台中市大甲區孟春里通天路168號',
    縣市: '台中市'
  },
  {
    店號: 862330,
    店名: '社口',
    地址: '台中市神岡區社口里8鄰中山路736號',
    縣市: '台中市'
  },
  {
    店號: 863218,
    店名: '巨龍',
    地址: '台中市龍井區中央路三段51號',
    縣市: '台中市'
  },
  {
    店號: 863447,
    店名: '鼎好',
    地址: '台中市烏日區中山路二段289號',
    縣市: '台中市'
  },
  {
    店號: 863632,
    店名: '昌盛',
    地址: '台中市北屯區昌平路二段45號之8及45號之9',
    縣市: '台中市'
  },
  {
    店號: 863975,
    店名: '精美',
    地址: '台中市太平區中平里精美路1號',
    縣市: '台中市'
  },
  {
    店號: 865100,
    店名: '新北平',
    地址: '台中市北區北平路二段96號',
    縣市: '台中市'
  },
  {
    店號: 865384,
    店名: '新五廊',
    地址: '台中市西區民生路155號一樓',
    縣市: '台中市'
  },
  {
    店號: 865502,
    店名: '逢福',
    地址: '台中市西屯區黎明路三段348號',
    縣市: '台中市'
  },
  {
    店號: 865823,
    店名: '后綜',
    地址: '台中市后里區甲后路一段349、351號1樓',
    縣市: '台中市'
  },
  {
    店號: 870401,
    店名: '水景',
    地址: '台中市北屯區東山路一段212號',
    縣市: '台中市'
  },
  {
    店號: 872957,
    店名: '樂業',
    地址: '台中市東區樂業路259號',
    縣市: '台中市'
  },
  {
    店號: 874296,
    店名: '益民',
    地址: '台中市大里區東興里10鄰大明路238號',
    縣市: '台中市'
  },
  {
    店號: 874458,
    店名: '隆安',
    地址: '台中市西屯區大隆路56號1樓',
    縣市: '台中市'
  },
  {
    店號: 875093,
    店名: '合作',
    地址: '台中市北區自強一街1號',
    縣市: '台中市'
  },
  {
    店號: 875141,
    店名: '月眉',
    地址: '台中市后里區民生路226.228號1樓',
    縣市: '台中市'
  },
  {
    店號: 880718,
    店名: '清中',
    地址: '台中市清水區北寧里董公街56號',
    縣市: '台中市'
  },
  {
    店號: 880822,
    店名: '大峰',
    地址: '台中市大里區大峰路167號',
    縣市: '台中市'
  },
  {
    店號: 881663,
    店名: '宜昌',
    地址: '台中市太平區宜昌路400號',
    縣市: '台中市'
  },
  {
    店號: 881814,
    店名: '水豐',
    地址: '台中市豐原區鐮村路462號',
    縣市: '台中市'
  },
  {
    店號: 883326,
    店名: '新豐民',
    地址: '台中市豐原區三民路93號1樓',
    縣市: '台中市'
  },
  {
    店號: 883902,
    店名: '豐洲',
    地址: '台中市神岡區五權路63號',
    縣市: '台中市'
  },
  {
    店號: 883913,
    店名: '新豐田',
    地址: '台中市豐原區豐南街145號',
    縣市: '台中市'
  },
  {
    店號: 885539,
    店名: '安龍',
    地址: '台中市西區五權路2-12號2-13號1樓',
    縣市: '台中市'
  },
  {
    店號: 885780,
    店名: '東里',
    地址: '台中市大里區大里路295號',
    縣市: '台中市'
  },
  {
    店號: 886129,
    店名: '朝馬',
    地址: '台中市西屯區黎明路二段1010號',
    縣市: '台中市'
  },
  {
    店號: 886130,
    店名: '學士',
    地址: '台中市北區學士路163號165號',
    縣市: '台中市'
  },
  {
    店號: 886174,
    店名: '海德堡',
    地址: '台中市南屯區向心南路928號930號',
    縣市: '台中市'
  },
  {
    店號: 886392,
    店名: '豐后',
    地址: '台中市豐原區三豐路二段186、188號1樓',
    縣市: '台中市'
  },
  {
    店號: 886680,
    店名: '鹿鼎',
    地址: '台中市沙鹿區台灣大道七段812號1樓',
    縣市: '台中市'
  },
  {
    店號: 887029,
    店名: '忠太',
    地址: '台中市北區太原路一段492號地下1層和忠明八街1號1樓',
    縣市: '台中市'
  },
  {
    店號: 890036,
    店名: '葫蘆墩',
    地址: '台中市豐原區水源路127-1號',
    縣市: '台中市'
  },
  {
    店號: 890416,
    店名: '太隆',
    地址: '台中市太平區德隆里工業路148號150號',
    縣市: '台中市'
  },
  {
    店號: 890483,
    店名: '新霧峰',
    地址: '台中市霧峰區中正路916號',
    縣市: '台中市'
  },
  {
    店號: 890704,
    店名: '立新',
    地址: '台中市大里區立仁路142號',
    縣市: '台中市'
  },
  {
    店號: 890944,
    店名: '清泉崗',
    地址: '台中市沙鹿區中清路六段259號',
    縣市: '台中市'
  },
  {
    店號: 891132,
    店名: '丹聯',
    地址: '台中市沙鹿區中山路田尾巷3號4號5號',
    縣市: '台中市'
  },
  {
    店號: 891361,
    店名: '雅昌',
    地址: '台中市北區中清路一段569號',
    縣市: '台中市'
  },
  {
    店號: 891501,
    店名: '龍祥',
    地址: '台中市龍井區沙田路四段636號',
    縣市: '台中市'
  },
  {
    店號: 891671,
    店名: '櫻花',
    地址: '台中市西屯區櫻花路111號',
    縣市: '台中市'
  },
  {
    店號: 891682,
    店名: '豐碩',
    地址: '台中市大雅區中清路四段46號',
    縣市: '台中市'
  },
  {
    店號: 891903,
    店名: '墩陽',
    地址: '台中市南屯區大墩10街254號1樓',
    縣市: '台中市'
  },
  {
    店號: 891914,
    店名: '茂陽',
    地址: '台中市豐原區南陽路299之8號299之9號',
    縣市: '台中市'
  },
  {
    店號: 893046,
    店名: '榮晉',
    地址: '台中市潭子區頭張路二段2號',
    縣市: '台中市'
  },
  {
    店號: 893150,
    店名: '寶利旺',
    地址: '台中市后里區三豐路三段887號1樓',
    縣市: '台中市'
  },
  {
    店號: 893231,
    店名: '嘟嘟',
    地址: '台中市北區興進路60號',
    縣市: '台中市'
  },
  {
    店號: 893345,
    店名: '新仁華',
    地址: '台中市大里區仁化路460.462號',
    縣市: '台中市'
  },
  {
    店號: 893596,
    店名: '台紙',
    地址: '台中市大肚區沙田路二段645號',
    縣市: '台中市'
  },
  {
    店號: 893725,
    店名: '京泰',
    地址: '台中市豐原區成功路195號.西勢路98號',
    縣市: '台中市'
  },
  {
    店號: 893851,
    店名: '新勤益',
    地址: '台中市太平區中山路一段217號',
    縣市: '台中市'
  },
  {
    店號: 895695,
    店名: '太平',
    地址: '台中市太平區中興路171號',
    縣市: '台中市'
  },
  {
    店號: 896274,
    店名: '逢源',
    地址: '台中市西屯區逢甲路162號之5',
    縣市: '台中市'
  },
  {
    店號: 900175,
    店名: '福茂',
    地址: '台中市西屯區西屯路三段148-30號',
    縣市: '台中市'
  },
  {
    店號: 900359,
    店名: '后東',
    地址: '台中市后里區甲后路一段101號1樓',
    縣市: '台中市'
  },
  {
    店號: 900430,
    店名: '雙喜',
    地址: '台中市大雅區中山北路167號',
    縣市: '台中市'
  },
  {
    店號: 900887,
    店名: '漢成',
    地址: '台中市西屯區漢成四街2號',
    縣市: '台中市'
  },
  {
    店號: 900898,
    店名: '龍津',
    地址: '台中市龍井區三德里中央路二段4號',
    縣市: '台中市'
  },
  {
    店號: 901525,
    店名: '紅億',
    地址: '台中市太平區光興路572號576號',
    縣市: '台中市'
  },
  {
    店號: 901536,
    店名: '工一',
    地址: '台中市西屯區工業區一路98-32號1樓',
    縣市: '台中市'
  },
  {
    店號: 901846,
    店名: '敦煌',
    地址: '台中市北屯區敦化路一段473號1樓',
    縣市: '台中市'
  },
  {
    店號: 902757,
    店名: '華生',
    地址: '台中市西區民生路517號',
    縣市: '台中市'
  },
  {
    店號: 903255,
    店名: '墩隆',
    地址: '台中市西屯區大墩路966號',
    縣市: '台中市'
  },
  {
    店號: 903288,
    店名: '京展',
    地址: '台中市豐原區中正路858號1樓',
    縣市: '台中市'
  },
  {
    店號: 903303,
    店名: '上楓',
    地址: '台中市大雅區民生路三段523號',
    縣市: '台中市'
  },
  {
    店號: 903831,
    店名: '日南',
    地址: '台中市大甲區日南里青年路130號',
    縣市: '台中市'
  },
  {
    店號: 905424,
    店名: '大道',
    地址: '台中市大里區仁化里至善路188號',
    縣市: '台中市'
  },
  {
    店號: 905527,
    店名: '權興',
    地址: '台中市南屯區五權西路二段62號',
    縣市: '台中市'
  },
  {
    店號: 908320,
    店名: '詠德',
    地址: '台中市梧棲區大智路二段385號',
    縣市: '台中市'
  },
  {
    店號: 909080,
    店名: '大維',
    地址: '台中市梧棲區四維路73號',
    縣市: '台中市'
  },
  {
    店號: 909149,
    店名: '萬文',
    地址: '台中市南屯區黎明路一段1033號',
    縣市: '台中市'
  },
  {
    店號: 910079,
    店名: '全利',
    地址: '台中市太平區樹孝路338號',
    縣市: '台中市'
  },
  {
    店號: 910736,
    店名: '百達',
    地址: '台中市大雅區中清路三段721號',
    縣市: '台中市'
  },
  {
    店號: 910770,
    店名: '台中港',
    地址: '台中市梧棲區台灣大道九段301號1樓',
    縣市: '台中市'
  },
  {
    店號: 910998,
    店名: '逢運',
    地址: '台中市北屯區雷中街95號',
    縣市: '台中市'
  },
  {
    店號: 911290,
    店名: '頂橋',
    地址: '台中市南區興大路338號340號',
    縣市: '台中市'
  },
  {
    店號: 911670,
    店名: '南北通',
    地址: '台中市北屯區同榮里環中路一段1686號',
    縣市: '台中市'
  },
  {
    店號: 912363,
    店名: '新育才',
    地址: '台中市北區三民路三段116號',
    縣市: '台中市'
  },
  {
    店號: 912606,
    店名: '矽品',
    地址: '台中市潭子區大豐路三段188號190號',
    縣市: '台中市'
  },
  {
    店號: 912732,
    店名: '模範',
    地址: '台中市西區模範街34巷1號',
    縣市: '台中市'
  },
  {
    店號: 912743,
    店名: '福田',
    地址: '台中市南區文心南路883、885號1樓',
    縣市: '台中市'
  },
  {
    店號: 913643,
    店名: '福明',
    地址: '台中市東區進化路170號1樓',
    縣市: '台中市'
  },
  {
    店號: 916206,
    店名: '新東峰',
    地址: '台中市北區東光路340號',
    縣市: '台中市'
  },
  {
    店號: 920261,
    店名: '向權',
    地址: '台中市南屯區五權西路二段412號1樓',
    縣市: '台中市'
  },
  {
    店號: 920892,
    店名: '南美',
    地址: '台中市南區南平路182號',
    縣市: '台中市'
  },
  {
    店號: 921013,
    店名: '大坑',
    地址: '台中市北屯區橫坑巷28-1號',
    縣市: '台中市'
  },
  {
    店號: 921116,
    店名: '鄉林',
    地址: '台中市南屯區大業路177號',
    縣市: '台中市'
  },
  {
    店號: 921459,
    店名: '新大億',
    地址: '台中市太平區大興路151號151-1號',
    縣市: '台中市'
  },
  {
    店號: 921758,
    店名: '聯順',
    地址: '台中市西屯區福聯里福順路898號900號',
    縣市: '台中市'
  },
  {
    店號: 921770,
    店名: '昌興',
    地址: '台中市清水區新興路238號文昌街12-1號',
    縣市: '台中市'
  },
  {
    店號: 922304,
    店名: '新豐興',
    地址: '台中市豐原區東勢里中興路57號',
    縣市: '台中市'
  },
  {
    店號: 922728,
    店名: '頂尖',
    地址: '台中市沙鹿區北勢東路617號619號',
    縣市: '台中市'
  },
  {
    店號: 923307,
    店名: '光園',
    地址: '台中市東區東光園路142號',
    縣市: '台中市'
  },
  {
    店號: 923558,
    店名: '新石岡',
    地址: '台中市石岡區明德路118號',
    縣市: '台中市'
  },
  {
    店號: 924539,
    店名: '關連',
    地址: '台中市梧棲區臨港路三段70.72號',
    縣市: '台中市'
  },
  {
    店號: 924850,
    店名: '栗林',
    地址: '台中市潭子區祥和路169號171號',
    縣市: '台中市'
  },
  {
    店號: 931098,
    店名: '松東',
    地址: '台中市北屯區松竹路三段125號',
    縣市: '台中市'
  },
  {
    店號: 931294,
    店名: '新墩興',
    地址: '台中市南屯區東興路二段98號1樓',
    縣市: '台中市'
  },
  {
    店號: 931423,
    店名: '巧竹',
    地址: '台中市清水區海濱里臨港路五段828、830號1樓',
    縣市: '台中市'
  },
  {
    店號: 933223,
    店名: '高美祿',
    地址: '台中市清水區高美路190號1樓',
    縣市: '台中市'
  },
  {
    店號: 935632,
    店名: '益華',
    地址: '台中市北區健行路49號',
    縣市: '台中市'
  },
  {
    店號: 936185,
    店名: '東富',
    地址: '台中市大里區東榮路282號',
    縣市: '台中市'
  },
  {
    店號: 940483,
    店名: '金典',
    地址: '台中市西區健行路1046、1046-1、1046-2號1樓',
    縣市: '台中市'
  },
  {
    店號: 940575,
    店名: '祐瑄',
    地址: '台中市沙鹿區光華路502號506號',
    縣市: '台中市'
  },
  {
    店號: 941028,
    店名: '新民高',
    地址: '台中市北區金龍里三民路三段289號',
    縣市: '台中市'
  },
  {
    店號: 941039,
    店名: '新民國',
    地址: '台中市北區金龍里三民路三段289號',
    縣市: '台中市'
  },
  {
    店號: 941464,
    店名: '潭慶',
    地址: '台中市潭子區大豐路三段123號',
    縣市: '台中市'
  },
  {
    店號: 942087,
    店名: '潭德',
    地址: '台中市潭子區崇德路五段489號',
    縣市: '台中市'
  },
  {
    店號: 942283,
    店名: '雅興',
    地址: '台中市大雅區雅潭路四段81號',
    縣市: '台中市'
  },
  {
    店號: 943091,
    店名: '國安國',
    地址: '台中市西屯區國安一路208巷1號',
    縣市: '台中市'
  },
  {
    店號: 943390,
    店名: '校友會',
    地址: '台中市西屯區台灣大道四段1727號1樓',
    縣市: '台中市'
  },
  {
    店號: 943851,
    店名: '直興',
    地址: '台中市豐原區水源路695號',
    縣市: '台中市'
  },
  {
    店號: 944245,
    店名: '潭寶',
    地址: '台中市潭子區潭興路三段51號',
    縣市: '台中市'
  },
  {
    店號: 944418,
    店名: '詠珊',
    地址: '台中市梧棲區大智路1017號',
    縣市: '台中市'
  },
  {
    店號: 944511,
    店名: '漢華',
    地址: '台中市北區漢口路五段60號62號66號1樓',
    縣市: '台中市'
  },
  {
    店號: 944692,
    店名: '神寶',
    地址: '台中市神岡區中正路100號',
    縣市: '台中市'
  },
  {
    店號: 946584,
    店名: '豐春',
    地址: '台中市南屯區文心南路100號',
    縣市: '台中市'
  },
  {
    店號: 946850,
    店名: '永隆',
    地址: '台中市大里區大明路457號',
    縣市: '台中市'
  },
  {
    店號: 950170,
    店名: '承軒',
    地址: '台中市神岡區民生路48之7號8號9號',
    縣市: '台中市'
  },
  {
    店號: 950251,
    店名: '福豐',
    地址: '台中市后里區福美路17號',
    縣市: '台中市'
  },
  {
    店號: 950295,
    店名: '松強',
    地址: '台中市北屯區松安里崇德六路一段47號',
    縣市: '台中市'
  },
  {
    店號: 950321,
    店名: '弘新',
    地址: '台中市梧棲區永興路一段112號',
    縣市: '台中市'
  },
  {
    店號: 950963,
    店名: '雅典',
    地址: '台中市南區三民西路377號西川一路1號',
    縣市: '台中市'
  },
  {
    店號: 951069,
    店名: '丰瑞',
    地址: '台中市北屯區四民里四平路563號',
    縣市: '台中市'
  },
  {
    店號: 951298,
    店名: '后寶',
    地址: '台中市后里區三豐路三段415.417號',
    縣市: '台中市'
  },
  {
    店號: 951324,
    店名: '沙鹿光',
    地址: '台中市沙鹿區沙田路115號',
    縣市: '台中市'
  },
  {
    店號: 951405,
    店名: '安河',
    地址: '台中市西屯區河南路二段14號',
    縣市: '台中市'
  },
  {
    店號: 951586,
    店名: '萳陽',
    地址: '台中市豐原區南陽路480號',
    縣市: '台中市'
  },
  {
    店號: 951737,
    店名: '大安港',
    地址: '台中市大甲區大安港路118號',
    縣市: '台中市'
  },
  {
    店號: 952121,
    店名: '雅神',
    地址: '台中市大雅區昌平路四段286號',
    縣市: '台中市'
  },
  {
    店號: 952246,
    店名: '潭豐',
    地址: '台中市潭子區崇德路四段250之1號',
    縣市: '台中市'
  },
  {
    店號: 952316,
    店名: '光大國',
    地址: '台中市北區文莊里日興街180號1樓',
    縣市: '台中市'
  },
  {
    店號: 953076,
    店名: '綠點',
    地址: '台中市大雅區神林路一段300號302號',
    縣市: '台中市'
  },
  {
    店號: 953098,
    店名: '新春社',
    地址: '台中市南屯區永春南路136號138號',
    縣市: '台中市'
  },
  {
    店號: 953342,
    店名: '菁埔',
    地址: '台中市清水區中央北路1號',
    縣市: '台中市'
  },
  {
    店號: 953755,
    店名: '東洲',
    地址: '台中市豐原區豐原大道七段488號',
    縣市: '台中市'
  },
  {
    店號: 954138,
    店名: '豐原道',
    地址: '台中市豐原區水源路307號',
    縣市: '台中市'
  },
  {
    店號: 954220,
    店名: '潭興',
    地址: '台中市潭子區豐興路一段593號595號',
    縣市: '台中市'
  },
  {
    店號: 954389,
    店名: '彩豐',
    地址: '台中市后里區三豐路五段551號1樓',
    縣市: '台中市'
  },
  {
    店號: 954585,
    店名: '樹王',
    地址: '台中市大里區文心南路1252號',
    縣市: '台中市'
  },
  {
    店號: 954758,
    店名: '薰衣草',
    地址: '台中市新社區協中街169之1號',
    縣市: '台中市'
  },
  {
    店號: 954792,
    店名: '鎮欣',
    地址: '台中市沙鹿區北勢里鎮南路二段368號',
    縣市: '台中市'
  },
  {
    店號: 956581,
    店名: '錦中',
    地址: '台中市北區三民路三段258號',
    縣市: '台中市'
  },
  {
    店號: 957931,
    店名: '逢盛',
    地址: '台中市西屯區福星路330號',
    縣市: '台中市'
  },
  {
    店號: 958277,
    店名: '進德',
    地址: '台中市東區自由路三段226號及進德路77號',
    縣市: '台中市'
  },
  {
    店號: 958831,
    店名: '墩南',
    地址: '台中市南屯區南屯路二段210、212號1樓',
    縣市: '台中市'
  },
  {
    店號: 959340,
    店名: '奇晉',
    地址: '台中市神岡區豐洲路469號1樓',
    縣市: '台中市'
  },
  {
    店號: 960487,
    店名: '潮洋',
    地址: '台中市西屯區市政路596號',
    縣市: '台中市'
  },
  {
    店號: 962715,
    店名: '台麗',
    地址: '台中市西區五權路119號',
    縣市: '台中市'
  },
  {
    店號: 962988,
    店名: '神林',
    地址: '台中市大雅區神林南路144號',
    縣市: '台中市'
  },
  {
    店號: 965242,
    店名: '清峰',
    地址: '台中市清水區中華路330號、鰲峰路173-3號',
    縣市: '台中市'
  },
  {
    店號: 965312,
    店名: '文嶺',
    地址: '台中市南屯區嶺東路806號',
    縣市: '台中市'
  },
  {
    店號: 965356,
    店名: '松潭',
    地址: '台中市北屯區軍功路二段183號1樓',
    縣市: '台中市'
  },
  {
    店號: 966175,
    店名: '中台禾',
    地址: '台中市北屯區太原路三段1505號',
    縣市: '台中市'
  },
  {
    店號: 966810,
    店名: '永源村',
    地址: '台中市新社區東山街88-29號30號',
    縣市: '台中市'
  },
  {
    店號: 966913,
    店名: '后冠',
    地址: '台中市后里區民生路1號',
    縣市: '台中市'
  },
  {
    店號: 967123,
    店名: '宸騰',
    地址: '台中市西屯區上石路201號',
    縣市: '台中市'
  },
  {
    店號: 967352,
    店名: '育成',
    地址: '台中市霧峰區樹仁路161-1及161-2號',
    縣市: '台中市'
  },
  {
    店號: 967422,
    店名: '逢喜',
    地址: '台中市西屯區逢甲路247號',
    縣市: '台中市'
  },
  {
    店號: 967569,
    店名: '新光德',
    地址: '台中市烏日區信義街162號1樓',
    縣市: '台中市'
  },
  {
    店號: 967709,
    店名: '甜園',
    地址: '台中市潭子區豐栗路9號',
    縣市: '台中市'
  },
  {
    店號: 967765,
    店名: '瑞慶',
    地址: '台中市豐原區豐原大道三段261號',
    縣市: '台中市'
  },
  {
    店號: 967776,
    店名: '新亞大',
    地址: '台中市霧峰區中正路473號475號',
    縣市: '台中市'
  },
  {
    店號: 967927,
    店名: '榮泉',
    地址: '台中市烏日區中山路三段1007號',
    縣市: '台中市'
  },
  {
    店號: 967950,
    店名: '亞洲一',
    地址: '台中市霧峰區柳豐路500號',
    縣市: '台中市'
  },
  {
    店號: 968517,
    店名: '雅勝',
    地址: '台中市大雅區雅潭路四段491號',
    縣市: '台中市'
  },
  {
    店號: 968528,
    店名: '永在',
    地址: '台中市大甲區日南里黎明路3之21號1樓',
    縣市: '台中市'
  },
  {
    店號: 968621,
    店名: '華太',
    地址: '台中市北區中華路二段137號',
    縣市: '台中市'
  },
  {
    店號: 968838,
    店名: '鑫井源',
    地址: '台中市龍井區沙田路六段323號',
    縣市: '台中市'
  },
  {
    店號: 969026,
    店名: '東英',
    地址: '台中市東區自由路四段339號',
    縣市: '台中市'
  },
  {
    店號: 970565,
    店名: '中湖',
    地址: '台中市大里區中興路一段292之11及292之12號',
    縣市: '台中市'
  },
  {
    店號: 970808,
    店名: '潭春',
    地址: '台中市潭子區東寶里大豐路二段1號1樓',
    縣市: '台中市'
  },
  {
    店號: 970864,
    店名: '鑫華新',
    地址: '台中市中區中華里中華路一段75號77號及民族路218號',
    縣市: '台中市'
  },
  {
    店號: 971041,
    店名: '大衛',
    地址: '台中市大里區國中路276號',
    縣市: '台中市'
  },
  {
    店號: 971188,
    店名: '大洲',
    地址: '台中市神岡區大洲路299之1號',
    縣市: '台中市'
  },
  {
    店號: 971328,
    店名: '鑫工和',
    地址: '台中市西屯區協和里工業區三十八路30號1樓',
    縣市: '台中市'
  },
  {
    店號: 971476,
    店名: '鹿維',
    地址: '台中市沙鹿區北勢東路330號',
    縣市: '台中市'
  },
  {
    店號: 971742,
    店名: '東泓',
    地址: '台中市東區東門里東門路140號',
    縣市: '台中市'
  },
  {
    店號: 971926,
    店名: '鈺英',
    地址: '台中市大甲區育英路283號',
    縣市: '台中市'
  },
  {
    店號: 971959,
    店名: '保屏',
    地址: '台中市沙鹿區向上路七段132號',
    縣市: '台中市'
  },
  {
    店號: 971971,
    店名: '新政',
    地址: '台中市大甲區信義路193號',
    縣市: '台中市'
  },
  {
    店號: 972468,
    店名: '新北庄',
    地址: '台中市神岡區北庄里中山路1320-3號',
    縣市: '台中市'
  },
  {
    店號: 972745,
    店名: '新平智',
    地址: '台中市東區新庄里大智路49號',
    縣市: '台中市'
  },
  {
    店號: 972929,
    店名: '新豐寶',
    地址: '台中市豐原區中山路143-2號1樓',
    縣市: '台中市'
  },
  {
    店號: 976736,
    店名: '龍新',
    地址: '台中市龍井區新興路18號1樓',
    縣市: '台中市'
  },
  {
    店號: 977061,
    店名: '大鵬',
    地址: '台中市西屯區長安路二段125號',
    縣市: '台中市'
  },
  {
    店號: 977256,
    店名: '建智',
    地址: '台中市東區建成路668號',
    縣市: '台中市'
  },
  {
    店號: 977360,
    店名: '寧夏',
    地址: '台中市西屯區寧夏路105號',
    縣市: '台中市'
  },
  {
    店號: 977500,
    店名: '逢仁',
    地址: '台中市西屯區青海路二段262號',
    縣市: '台中市'
  },
  {
    店號: 978293,
    店名: '鰲峰',
    地址: '台中市清水區鰲峰路22號',
    縣市: '台中市'
  },
  {
    店號: 978374,
    店名: '新庄',
    地址: '台中市龍井區台灣大道五段232號236號1樓',
    縣市: '台中市'
  },
  {
    店號: 978617,
    店名: '新德化',
    地址: '台中市北區德化街660號',
    縣市: '台中市'
  },
  {
    店號: 980207,
    店名: '新堤',
    地址: '台中市大里區立德里甲堤南路71號',
    縣市: '台中市'
  },
  {
    店號: 980322,
    店名: '墩正',
    地址: '台中市南屯區溝墘里大墩十一街330號1樓',
    縣市: '台中市'
  },
  {
    店號: 980816,
    店名: '億承',
    地址: '台中市清水區民和路二段195號',
    縣市: '台中市'
  },
  {
    店號: 981196,
    店名: '豐肚',
    地址: '台中市大肚區社腳里沙田路一段916號',
    縣市: '台中市'
  },
  {
    店號: 981325,
    店名: '后糖',
    地址: '台中市后里區甲后路二段363號',
    縣市: '台中市'
  },
  {
    店號: 981657,
    店名: '豐尚',
    地址: '台中市豐原區豐勢路二段680號一樓',
    縣市: '台中市'
  },
  {
    店號: 982225,
    店名: '慶樹',
    地址: '台中市南區樹德里大慶街二段36號',
    縣市: '台中市'
  },
  {
    店號: 982292,
    店名: '新豐喜',
    地址: '台中市豐原區南陽路127號1樓',
    縣市: '台中市'
  },
  {
    店號: 982339,
    店名: '欣谷關',
    地址: '台中市和平區東關路一段135-2號1樓',
    縣市: '台中市'
  },
  {
    店號: 982351,
    店名: '鑫和睦',
    地址: '台中市神岡區神清路266號268號及福成路56-1號',
    縣市: '台中市'
  },
  {
    店號: 982568,
    店名: '鑫佳慶',
    地址: '台中市太平區大源二街1號1F',
    縣市: '台中市'
  },
  {
    店號: 988061,
    店名: '東風',
    地址: '台中市龍井區遠東街3號',
    縣市: '台中市'
  },
  {
    店號: 988267,
    店名: '松豪',
    地址: '台中市北屯區四平路218號',
    縣市: '台中市'
  },
  {
    店號: 990329,
    店名: '欣東雲',
    地址: '台中市東勢區第五橫街28號及三民街165號',
    縣市: '台中市'
  },
  {
    店號: 991159,
    店名: '天星',
    地址: '台中市北屯區東山路二段77之8、77之9、77之10號1樓',
    縣市: '台中市'
  },
  {
    店號: 991355,
    店名: '東義',
    地址: '台中市北區北平路二段141號1樓',
    縣市: '台中市'
  },
  {
    店號: 991805,
    店名: '聯華',
    地址: '台中市中區公園路13號',
    縣市: '台中市'
  },
  {
    店號: 991861,
    店名: '長億',
    地址: '台中市南區工學路108號',
    縣市: '台中市'
  },
  {
    店號: 991942,
    店名: '崇尚',
    地址: '台中市北屯區崇德路二段450號1樓',
    縣市: '台中市'
  },
  {
    店號: 991975,
    店名: '青河',
    地址: '台中市北屯區青島路三段155號1樓',
    縣市: '台中市'
  },
  {
    店號: 992222,
    店名: '豐勇',
    地址: '台中市豐原區三豐路一段155.157.159號1樓',
    縣市: '台中市'
  },
  {
    店號: 992358,
    店名: '港區',
    地址: '台中市梧棲區安仁里文化路二段2鄰55號1樓',
    縣市: '台中市'
  },
  {
    店號: 992406,
    店名: '明道一',
    地址: '台中市烏日區中山路一段497號(蠡海大樓)',
    縣市: '台中市'
  },
  {
    店號: 992543,
    店名: '俊國',
    地址: '台中市西屯區永福路40巷5號7號1樓',
    縣市: '台中市'
  },
  {
    店號: 992794,
    店名: '學園',
    地址: '台中市龍井區台灣大道五段3巷62弄21號1樓',
    縣市: '台中市'
  },
  {
    店號: 992808,
    店名: '熱天',
    地址: '台中市北屯區天津路四段68號1樓',
    縣市: '台中市'
  },
  {
    店號: 993018,
    店名: '新象',
    地址: '台中市北屯區中清路二段776號778號',
    縣市: '台中市'
  },
  {
    店號: 993096,
    店名: '精田',
    地址: '台中市南屯區黎明路一段142號',
    縣市: '台中市'
  },
  {
    店號: 993122,
    店名: '功興',
    地址: '台中市太平區建興路47號',
    縣市: '台中市'
  },
  {
    店號: 993498,
    店名: '豐慶',
    地址: '台中市西屯區甘肅路一段196號及198號1樓',
    縣市: '台中市'
  },
  {
    店號: 993591,
    店名: '婷婷',
    地址: '台中市北區學士路67號69號1樓',
    縣市: '台中市'
  },
  {
    店號: 993708,
    店名: '精中',
    地址: '台中市太平區太平一街220號',
    縣市: '台中市'
  },
  {
    店號: 996291,
    店名: '萬寶',
    地址: '台中市北屯區中清路二段567號一樓',
    縣市: '台中市'
  },
  {
    店號: 996752,
    店名: '新豐功',
    地址: '台中市南屯區豐樂里永春東路860號',
    縣市: '台中市'
  },
  {
    店號: 998013,
    店名: '修平',
    地址: '台中市大里區工業二路100號',
    縣市: '台中市'
  },
  {
    店號: 110367,
    店名: '儒林',
    地址: '彰化縣二林鎮北平里仁愛路11鄰425號',
    縣市: '彰化縣'
  },
  {
    店號: 110459,
    店名: '員昌',
    地址: '彰化縣員林市黎明里12鄰南昌路70號72號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 112215,
    店名: '員林',
    地址: '彰化縣員林市忠孝里4鄰員東路二段417號',
    縣市: '彰化縣'
  },
  {
    店號: 112385,
    店名: '大陽',
    地址: '彰化縣彰化市延平里大埔路405號',
    縣市: '彰化縣'
  },
  {
    店號: 112949,
    店名: '頂番',
    地址: '彰化縣鹿港鎮頂草路一段61號',
    縣市: '彰化縣'
  },
  {
    店號: 113403,
    店名: '王功',
    地址: '彰化縣芳苑鄉王功村3鄰芳漢路王功段544號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 113816,
    店名: '金福興',
    地址: '彰化縣福興鄉員鹿路二段198號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 116767,
    店名: '口庄',
    地址: '彰化縣花壇鄉中山路二段649號651號',
    縣市: '彰化縣'
  },
  {
    店號: 118822,
    店名: '新安可',
    地址: '彰化縣溪湖鎮西環路373號',
    縣市: '彰化縣'
  },
  {
    店號: 119098,
    店名: '源益',
    地址: '彰化縣二林鎮斗苑路四段720號',
    縣市: '彰化縣'
  },
  {
    店號: 120319,
    店名: '伸濱',
    地址: '彰化縣伸港鄉新港路425號',
    縣市: '彰化縣'
  },
  {
    店號: 120320,
    店名: '彰泰',
    地址: '彰化縣彰化市安平街58號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 120478,
    店名: '員農',
    地址: '彰化縣員林市萬年里員水路二段19鄰433號',
    縣市: '彰化縣'
  },
  {
    店號: 120490,
    店名: '彰馬',
    地址: '彰化縣彰化市彰馬路246號之5',
    縣市: '彰化縣'
  },
  {
    店號: 121219,
    店名: '芳苑',
    地址: '彰化縣芳苑鄉後寮村斗苑路頂後段7號',
    縣市: '彰化縣'
  },
  {
    店號: 121471,
    店名: '彰工',
    地址: '彰化縣彰化市復興里進德路11號13號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 122153,
    店名: '福環',
    地址: '彰化縣福興鄉同安村員鹿路一段439號',
    縣市: '彰化縣'
  },
  {
    店號: 122175,
    店名: '和峰',
    地址: '彰化縣和美鎮山犁里道周路6鄰279號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 122278,
    店名: '社集',
    地址: '彰化縣社頭鄉員集路一段臨351號',
    縣市: '彰化縣'
  },
  {
    店號: 122304,
    店名: '湳港',
    地址: '彰化縣永靖鄉港西村中山路一段842號',
    縣市: '彰化縣'
  },
  {
    店號: 126535,
    店名: '員埔',
    地址: '彰化縣埔心鄉員鹿路二段248.250號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 126731,
    店名: '員東',
    地址: '彰化縣員林市三和里大同路一段8鄰238號',
    縣市: '彰化縣'
  },
  {
    店號: 126742,
    店名: '新桃源',
    地址: '彰化縣彰化市卦山里公園路一段335號',
    縣市: '彰化縣'
  },
  {
    店號: 127413,
    店名: '和輝',
    地址: '彰化縣和美鎮鎮平里彰草路二段臨448號',
    縣市: '彰化縣'
  },
  {
    店號: 130877,
    店名: '員慶',
    地址: '彰化縣員林市山腳路一段386號',
    縣市: '彰化縣'
  },
  {
    店號: 131227,
    店名: '湖貴',
    地址: '彰化縣溪湖鎮西寮里員鹿路四段7號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 131722,
    店名: '挖子',
    地址: '彰化縣二林鎮華崙里二溪路七段195號197號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 131733,
    店名: '日新',
    地址: '彰化縣福興鄉番婆村彰鹿路六段547號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 132231,
    店名: '和美',
    地址: '彰化縣和美鎮和頭路189號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 132301,
    店名: '長沙',
    地址: '彰化縣花壇鄉中正路130號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 132367,
    店名: '締寶',
    地址: '彰化縣彰化市金馬路一段358號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 132611,
    店名: '三春',
    地址: '彰化縣花壇鄉彰員路一段臨551號',
    縣市: '彰化縣'
  },
  {
    店號: 137878,
    店名: '品冠',
    地址: '彰化縣員林市新生路278號',
    縣市: '彰化縣'
  },
  {
    店號: 137889,
    店名: '彰辭',
    地址: '彰化縣彰化市忠孝里辭修路292號',
    縣市: '彰化縣'
  },
  {
    店號: 138468,
    店名: '彰強',
    地址: '彰化縣彰化市五權里自強南路80-11號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 138686,
    店名: '巨航',
    地址: '彰化縣伸港鄉新港村中興路一段355號',
    縣市: '彰化縣'
  },
  {
    店號: 138848,
    店名: '大竹',
    地址: '彰化縣彰化市大竹里彰南路二段181號',
    縣市: '彰化縣'
  },
  {
    店號: 138996,
    店名: '伸東',
    地址: '彰化縣伸港鄉七嘉村中華路519號',
    縣市: '彰化縣'
  },
  {
    店號: 140069,
    店名: '得利',
    地址: '彰化縣彰化市中華西路212號',
    縣市: '彰化縣'
  },
  {
    店號: 142238,
    店名: '鹿鑫',
    地址: '彰化縣鹿港鎮復興路289號291號293號',
    縣市: '彰化縣'
  },
  {
    店號: 142674,
    店名: '彰寶',
    地址: '彰化縣彰化市介壽北路82號',
    縣市: '彰化縣'
  },
  {
    店號: 142722,
    店名: '斗金',
    地址: '彰化縣北斗鎮中正路57號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 142803,
    店名: '秀發',
    地址: '彰化縣秀水鄉番花路臨558之7號',
    縣市: '彰化縣'
  },
  {
    店號: 143138,
    店名: '豐昌',
    地址: '彰化縣員林市永昌街86號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 144016,
    店名: '秀傳',
    地址: '彰化縣彰化市中山路一段546號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 144050,
    店名: '成發',
    地址: '彰化縣彰化市彰水路177號',
    縣市: '彰化縣'
  },
  {
    店號: 144588,
    店名: '斗苑',
    地址: '彰化縣埤頭鄉斗苑東路588號',
    縣市: '彰化縣'
  },
  {
    店號: 150789,
    店名: '光政',
    地址: '彰化縣北斗鎮光復路208號',
    縣市: '彰化縣'
  },
  {
    店號: 150941,
    店名: '永靖',
    地址: '彰化縣永靖鄉永坡路2號',
    縣市: '彰化縣'
  },
  {
    店號: 154655,
    店名: '鹿東',
    地址: '彰化縣福興鄉中正路224號',
    縣市: '彰化縣'
  },
  {
    店號: 155278,
    店名: '曉陽',
    地址: '彰化縣彰化市民族路341號343號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 155474,
    店名: '埔新',
    地址: '彰化縣埔心鄉員鹿路一段145號',
    縣市: '彰化縣'
  },
  {
    店號: 158299,
    店名: '彰化',
    地址: '彰化縣彰化市長樂里中正路二段41號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 160029,
    店名: '二溪',
    地址: '彰化縣溪湖鎮二溪路一段369號',
    縣市: '彰化縣'
  },
  {
    店號: 160030,
    店名: '彰陽',
    地址: '彰化縣彰化市中正路一段75號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 160063,
    店名: '員勝',
    地址: '彰化縣員林市育英路131號',
    縣市: '彰化縣'
  },
  {
    店號: 164205,
    店名: '芬草',
    地址: '彰化縣芬園鄉茄荖村芬草路一段607號',
    縣市: '彰化縣'
  },
  {
    店號: 164283,
    店名: '福山',
    地址: '彰化縣彰化市福東街2號；彰南路一段466號',
    縣市: '彰化縣'
  },
  {
    店號: 164548,
    店名: '明道站',
    地址: '彰化縣溪州鄉中山路四段627號',
    縣市: '彰化縣'
  },
  {
    店號: 164652,
    店名: '內安',
    地址: '彰化縣田中鎮碧峰里中南路二段562號564號566號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 164928,
    店名: '村東',
    地址: '彰化縣大村鄉山腳路92之8號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 165356,
    店名: '鹿和',
    地址: '彰化縣鹿港鎮鹿和路一段271、273、275號',
    縣市: '彰化縣'
  },
  {
    店號: 165367,
    店名: '鹿港',
    地址: '彰化縣鹿港鎮中山路257號',
    縣市: '彰化縣'
  },
  {
    店號: 165459,
    店名: '芬園',
    地址: '彰化縣芬園鄉彰南路四段172號及光復路6號',
    縣市: '彰化縣'
  },
  {
    店號: 166289,
    店名: '向福',
    地址: '彰化縣溪湖鎮大溪路二段140號',
    縣市: '彰化縣'
  },
  {
    店號: 166452,
    店名: '和新',
    地址: '彰化縣和美鎮彰新路五段臨396號',
    縣市: '彰化縣'
  },
  {
    店號: 166555,
    店名: '桂花',
    地址: '彰化縣鹿港鎮鹿東路150號1+2樓',
    縣市: '彰化縣'
  },
  {
    店號: 169635,
    店名: '和美仁',
    地址: '彰化縣和美鎮鹿和路六段臨22號',
    縣市: '彰化縣'
  },
  {
    店號: 175098,
    店名: '田尾',
    地址: '彰化縣田尾鄉光復路二段752號',
    縣市: '彰化縣'
  },
  {
    店號: 175102,
    店名: '和全',
    地址: '彰化縣和美鎮竹營里美寮路二段390號',
    縣市: '彰化縣'
  },
  {
    店號: 177050,
    店名: '崙北',
    地址: '彰化縣彰化市中央路232號234號',
    縣市: '彰化縣'
  },
  {
    店號: 179942,
    店名: '社腳',
    地址: '彰化縣社頭鄉湳雅村山腳路三段525號',
    縣市: '彰化縣'
  },
  {
    店號: 180159,
    店名: '明城',
    地址: '彰化縣大城鄉東城村北平路76號',
    縣市: '彰化縣'
  },
  {
    店號: 180171,
    店名: '欣二林',
    地址: '彰化縣二林鎮大成路一段236號',
    縣市: '彰化縣'
  },
  {
    店號: 180931,
    店名: '秀鑫',
    地址: '彰化縣秀水鄉番花路101號',
    縣市: '彰化縣'
  },
  {
    店號: 181657,
    店名: '合興',
    地址: '彰化縣埤頭鄉斗苑西路406號',
    縣市: '彰化縣'
  },
  {
    店號: 181761,
    店名: '永冠',
    地址: '彰化縣永靖鄉永北村西門路142號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 181886,
    店名: '溪東',
    地址: '彰化縣溪湖鎮員鹿路一段403號',
    縣市: '彰化縣'
  },
  {
    店號: 182395,
    店名: '新彰成',
    地址: '彰化縣彰化市太平街89號',
    縣市: '彰化縣'
  },
  {
    店號: 182513,
    店名: '智慶',
    地址: '彰化縣大村鄉大智路一段197號',
    縣市: '彰化縣'
  },
  {
    店號: 183136,
    店名: '芬農',
    地址: '彰化縣芬園鄉彰南路四段337號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 183240,
    店名: '員大',
    地址: '彰化縣員林市員大路一段374號',
    縣市: '彰化縣'
  },
  {
    店號: 184265,
    店名: '彰溪',
    地址: '彰化縣溪湖鎮彰水路二段臨555號',
    縣市: '彰化縣'
  },
  {
    店號: 184519,
    店名: '員全',
    地址: '彰化縣埔心鄉員林大道七段22號',
    縣市: '彰化縣'
  },
  {
    店號: 187150,
    店名: '真愛',
    地址: '彰化縣員林市大同路二段2號',
    縣市: '彰化縣'
  },
  {
    店號: 187404,
    店名: '新社頭',
    地址: '彰化縣社頭鄉員集路二段279號',
    縣市: '彰化縣'
  },
  {
    店號: 187459,
    店名: '新龍邸',
    地址: '彰化縣彰化市光南里中興路109號',
    縣市: '彰化縣'
  },
  {
    店號: 188337,
    店名: '和東',
    地址: '彰化縣和美鎮愛德路27號',
    縣市: '彰化縣'
  },
  {
    店號: 190824,
    店名: '金東山',
    地址: '彰化縣員林市南東里山腳路四段1號3號',
    縣市: '彰化縣'
  },
  {
    店號: 190879,
    店名: '彰美',
    地址: '彰化縣和美鎮彰美路三段385號387號',
    縣市: '彰化縣'
  },
  {
    店號: 192680,
    店名: '本鈿',
    地址: '彰化縣花壇鄉文德村彰員路二段臨1138號',
    縣市: '彰化縣'
  },
  {
    店號: 192691,
    店名: '樂有',
    地址: '彰化縣埔鹽鄉大有村員鹿路三段臨139號之9',
    縣市: '彰化縣'
  },
  {
    店號: 192716,
    店名: '糖友',
    地址: '彰化縣和美鎮中圍里彰新路三段臨368號',
    縣市: '彰化縣'
  },
  {
    店號: 193948,
    店名: '彰欣',
    地址: '彰化縣彰化市彰興路一段臨528號',
    縣市: '彰化縣'
  },
  {
    店號: 194066,
    店名: '彰北',
    地址: '彰化縣彰化市建國東路258號',
    縣市: '彰化縣'
  },
  {
    店號: 194251,
    店名: '和冠',
    地址: '彰化縣和美鎮彰新路六段臨566號',
    縣市: '彰化縣'
  },
  {
    店號: 194273,
    店名: '頂王',
    地址: '彰化縣鹿港鎮頭崙里7鄰頂草路二段135號',
    縣市: '彰化縣'
  },
  {
    店號: 195117,
    店名: '花海',
    地址: '彰化縣花壇鄉長春村彰員路一段280號',
    縣市: '彰化縣'
  },
  {
    店號: 195597,
    店名: '金旺',
    地址: '彰化縣彰化市延平路536號',
    縣市: '彰化縣'
  },
  {
    店號: 195874,
    店名: '管興',
    地址: '彰化縣福興鄉沿海路三段286號',
    縣市: '彰化縣'
  },
  {
    店號: 196143,
    店名: '禾順',
    地址: '彰化縣線西鄉沿海路一段849巷10號',
    縣市: '彰化縣'
  },
  {
    店號: 196235,
    店名: '兆福',
    地址: '彰化縣彰化市一德南路2號、彰南路三段400號',
    縣市: '彰化縣'
  },
  {
    店號: 196866,
    店名: '七六埔',
    地址: '彰化縣埔心鄉員埔路1192號',
    縣市: '彰化縣'
  },
  {
    店號: 197537,
    店名: '秀安',
    地址: '彰化縣秀水鄉安溪村彰鹿路19號',
    縣市: '彰化縣'
  },
  {
    店號: 198943,
    店名: '埔成',
    地址: '彰化縣埔心鄉中正路一段137號139號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 199016,
    店名: '品客',
    地址: '彰化縣大村鄉中山路一段86號',
    縣市: '彰化縣'
  },
  {
    店號: 199120,
    店名: '和港',
    地址: '彰化縣和美鎮和港路552號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 199452,
    店名: '新員民',
    地址: '彰化縣員林市三民街20號',
    縣市: '彰化縣'
  },
  {
    店號: 199843,
    店名: '彰政',
    地址: '彰化縣彰化市中正路二段113號115號117號119號',
    縣市: '彰化縣'
  },
  {
    店號: 200055,
    店名: '兆溢',
    地址: '彰化縣彰化市崙美路246號',
    縣市: '彰化縣'
  },
  {
    店號: 200170,
    店名: '辭修',
    地址: '彰化縣彰化市辭修路508號',
    縣市: '彰化縣'
  },
  {
    店號: 200343,
    店名: '興工',
    地址: '彰化縣埤頭鄉崙腳村4鄰彰水路二段946號',
    縣市: '彰化縣'
  },
  {
    店號: 200354,
    店名: '舊舍',
    地址: '彰化縣社頭鄉松竹村3鄰社石路937號',
    縣市: '彰化縣'
  },
  {
    店號: 200468,
    店名: '北圓',
    地址: '彰化縣北斗鎮中華路91.93號',
    縣市: '彰化縣'
  },
  {
    店號: 200985,
    店名: '二水',
    地址: '彰化縣二水鄉員集路4段6.8.10號',
    縣市: '彰化縣'
  },
  {
    店號: 202213,
    店名: '鳴人',
    地址: '彰化縣鹿港鎮鹿和路四段347號',
    縣市: '彰化縣'
  },
  {
    店號: 202361,
    店名: '鹿濱',
    地址: '彰化縣鹿港鎮彰濱五路二段臨406、臨408、臨410號',
    縣市: '彰化縣'
  },
  {
    店號: 206846,
    店名: '佳嘉',
    地址: '彰化縣北斗鎮七星里13鄰五權路臨176號',
    縣市: '彰化縣'
  },
  {
    店號: 207816,
    店名: '興鳳',
    地址: '彰化縣埤頭鄉斗苑東路731號',
    縣市: '彰化縣'
  },
  {
    店號: 208141,
    店名: '彰南',
    地址: '彰化縣彰化市竹巷里彰南路四段臨421號',
    縣市: '彰化縣'
  },
  {
    店號: 208347,
    店名: '薪永樂',
    地址: '彰化縣彰化市民族路494.496號',
    縣市: '彰化縣'
  },
  {
    店號: 208451,
    店名: '諺東',
    地址: '彰化縣和美鎮彰美路二段臨236號',
    縣市: '彰化縣'
  },
  {
    店號: 208462,
    店名: '二八水',
    地址: '彰化縣二水鄉員集路三段488號',
    縣市: '彰化縣'
  },
  {
    店號: 208934,
    店名: '花博',
    地址: '彰化縣溪州鄉中央路三段263號.265號.267號',
    縣市: '彰化縣'
  },
  {
    店號: 209351,
    店名: '建寶莊',
    地址: '彰化縣彰化市延平里埔陽街280號',
    縣市: '彰化縣'
  },
  {
    店號: 209753,
    店名: '風車',
    地址: '彰化縣鹿港鎮彰濱五路二段76號',
    縣市: '彰化縣'
  },
  {
    店號: 209775,
    店名: '花都',
    地址: '彰化縣田尾鄉民生路一段586號',
    縣市: '彰化縣'
  },
  {
    店號: 210247,
    店名: '員宿',
    地址: '彰化縣員林市中山路一段756號',
    縣市: '彰化縣'
  },
  {
    店號: 210258,
    店名: '員基',
    地址: '彰化縣員林市莒光路456號',
    縣市: '彰化縣'
  },
  {
    店號: 210719,
    店名: '柑竹',
    地址: '彰化縣和美鎮竹圍里彰新路四段臨245號',
    縣市: '彰化縣'
  },
  {
    店號: 211228,
    店名: '新溪州',
    地址: '彰化縣溪州鄉中山路三段436號',
    縣市: '彰化縣'
  },
  {
    店號: 211675,
    店名: '紫騰',
    地址: '彰化縣埔心鄉員鹿路三段338號',
    縣市: '彰化縣'
  },
  {
    店號: 212416,
    店名: 'ㄚ樺',
    地址: '彰化縣二林鎮中央南街48巷12號',
    縣市: '彰化縣'
  },
  {
    店號: 213899,
    店名: '福鹿',
    地址: '彰化縣福興鄉彰鹿路七段652.654號',
    縣市: '彰化縣'
  },
  {
    店號: 215493,
    店名: '安豐',
    地址: '彰化縣彰化市南安里彰鹿路166號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 215552,
    店名: '秀鴻',
    地址: '彰化縣秀水鄉埔崙村民生街960號',
    縣市: '彰化縣'
  },
  {
    店號: 216164,
    店名: '員成',
    地址: '彰化縣員林市中山路二段214.216號',
    縣市: '彰化縣'
  },
  {
    店號: 217374,
    店名: '彰基',
    地址: '彰化縣二林鎮大成路一段571號',
    縣市: '彰化縣'
  },
  {
    店號: 228031,
    店名: '禾群',
    地址: '彰化縣鹿港鎮永康路71號',
    縣市: '彰化縣'
  },
  {
    店號: 228123,
    店名: '金廣興',
    地址: '彰化縣社頭鄉中山路一段766號',
    縣市: '彰化縣'
  },
  {
    店號: 229078,
    店名: '金墩',
    地址: '彰化縣花壇鄉花壇村23鄰花南路臨558號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 229403,
    店名: '彰濱',
    地址: '彰化縣鹿港鎮彰濱五路二段369號',
    縣市: '彰化縣'
  },
  {
    店號: 230274,
    店名: '普賢',
    地址: '彰化縣永靖鄉中山路三段238號',
    縣市: '彰化縣'
  },
  {
    店號: 231118,
    店名: '睿奇',
    地址: '彰化縣員林市和平街18號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 231314,
    店名: '昱品',
    地址: '彰化縣埔鹽鄉員鹿路一段118號',
    縣市: '彰化縣'
  },
  {
    店號: 231495,
    店名: '海豐',
    地址: '彰化縣田尾鄉中正路三段78號1.2樓',
    縣市: '彰化縣'
  },
  {
    店號: 231646,
    店名: '嘉佃',
    地址: '彰化縣和美鎮彰和路三段202號',
    縣市: '彰化縣'
  },
  {
    店號: 231886,
    店名: '新鑫',
    地址: '彰化縣二林鎮二溪路三段295號',
    縣市: '彰化縣'
  },
  {
    店號: 236995,
    店名: '新大埔',
    地址: '彰化縣彰化市延平里大埔路540號542號',
    縣市: '彰化縣'
  },
  {
    店號: 237035,
    店名: '巨林',
    地址: '彰化縣彰化市中山路一段286號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 237057,
    店名: '家樂福',
    地址: '彰化縣彰化市茄苳路一段276號',
    縣市: '彰化縣'
  },
  {
    店號: 237873,
    店名: '附育',
    地址: '彰化縣彰化市中山路三段229號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 239097,
    店名: '埤頭',
    地址: '彰化縣埤頭鄉合興村彰水路三段5鄰537號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 239123,
    店名: '鹿工',
    地址: '彰化縣鹿港鎮鹿工南一路5號',
    縣市: '彰化縣'
  },
  {
    店號: 239190,
    店名: '火車頭',
    地址: '彰化縣彰化市長樂里中正路一段536號538號',
    縣市: '彰化縣'
  },
  {
    店號: 239204,
    店名: '三民',
    地址: '彰化縣彰化市三民路341號',
    縣市: '彰化縣'
  },
  {
    店號: 239259,
    店名: '秀水',
    地址: '彰化縣秀水鄉文化街31號',
    縣市: '彰化縣'
  },
  {
    店號: 241300,
    店名: '花壇',
    地址: '彰化縣花壇鄉中山路2段1、3、5號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 241322,
    店名: '寶斗',
    地址: '彰化縣北斗鎮復興路281號',
    縣市: '彰化縣'
  },
  {
    店號: 249094,
    店名: '易順',
    地址: '彰化縣社頭鄉員集路四段697號',
    縣市: '彰化縣'
  },
  {
    店號: 249315,
    店名: '彰泳',
    地址: '彰化縣彰化市永安街388號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 249407,
    店名: '鑫彰安',
    地址: '彰化縣彰化市中正路二段611號',
    縣市: '彰化縣'
  },
  {
    店號: 249784,
    店名: '和線',
    地址: '彰化縣和美鎮嘉犁里線東路二段722號',
    縣市: '彰化縣'
  },
  {
    店號: 250795,
    店名: '功湖',
    地址: '彰化縣芳苑鄉建平村二溪路草二段372號',
    縣市: '彰化縣'
  },
  {
    店號: 845472,
    店名: '溪湖',
    地址: '彰化縣溪湖鎮彰水路三段105號107號109號',
    縣市: '彰化縣'
  },
  {
    店號: 875369,
    店名: '彰和',
    地址: '彰化縣彰化市民族路163號',
    縣市: '彰化縣'
  },
  {
    店號: 882839,
    店名: '湖北',
    地址: '彰化縣溪湖鎮彰水路四段79號',
    縣市: '彰化縣'
  },
  {
    店號: 883762,
    店名: '新香珍',
    地址: '彰化縣福興鄉彰水路56號58號60號',
    縣市: '彰化縣'
  },
  {
    店號: 887177,
    店名: '民生',
    地址: '彰化縣彰化市華山路27號',
    縣市: '彰化縣'
  },
  {
    店號: 888549,
    店名: '葉大',
    地址: '彰化縣大村鄉學府路168號',
    縣市: '彰化縣'
  },
  {
    店號: 892560,
    店名: '埔鹽',
    地址: '彰化縣埔鹽鄉彰水路二段36號',
    縣市: '彰化縣'
  },
  {
    店號: 904133,
    店名: '德美',
    地址: '彰化縣和美鎮德美路700號',
    縣市: '彰化縣'
  },
  {
    店號: 909552,
    店名: '員家',
    地址: '彰化縣員林市中正路75號',
    縣市: '彰化縣'
  },
  {
    店號: 913274,
    店名: '彰醫',
    地址: '彰化縣埔心鄉舊館村中興路1號',
    縣市: '彰化縣'
  },
  {
    店號: 920711,
    店名: '伸港',
    地址: '彰化縣伸港鄉中山路190號192號',
    縣市: '彰化縣'
  },
  {
    店號: 921161,
    店名: '東芳',
    地址: '彰化縣彰化市東芳里永芳路199號',
    縣市: '彰化縣'
  },
  {
    店號: 922245,
    店名: '創新',
    地址: '彰化縣鹿港鎮順興里復興路595號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 922511,
    店名: '美溪',
    地址: '彰化縣溪湖鎮大溪路二段451號',
    縣市: '彰化縣'
  },
  {
    店號: 922809,
    店名: '鶴鳴',
    地址: '彰化縣秀水鄉鶴鳴村彰鹿路362號',
    縣市: '彰化縣'
  },
  {
    店號: 922898,
    店名: '新大村',
    地址: '彰化縣大村鄉中正西路331號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 924609,
    店名: '芳林',
    地址: '彰化縣芳苑鄉斗苑路156號之1',
    縣市: '彰化縣'
  },
  {
    店號: 931179,
    店名: '太子哈',
    地址: '彰化縣彰化市泰和中街72號',
    縣市: '彰化縣'
  },
  {
    店號: 931238,
    店名: '薪世麥',
    地址: '彰化縣花壇鄉長沙村彰員路二段550號552號',
    縣市: '彰化縣'
  },
  {
    店號: 931618,
    店名: '金順利',
    地址: '彰化縣埤頭鄉和豐村斗苑東路87號89號',
    縣市: '彰化縣'
  },
  {
    店號: 931700,
    店名: '智富',
    地址: '彰化縣彰化市萬安里長順街170號',
    縣市: '彰化縣'
  },
  {
    店號: 932002,
    店名: '兆詠',
    地址: '彰化縣彰化市台鳳里一德南路252號',
    縣市: '彰化縣'
  },
  {
    店號: 932194,
    店名: '秀中',
    地址: '彰化縣秀水鄉安東村中山路251號',
    縣市: '彰化縣'
  },
  {
    店號: 940232,
    店名: '社員',
    地址: '彰化縣社頭鄉員集路三段16號',
    縣市: '彰化縣'
  },
  {
    店號: 941660,
    店名: '中圳',
    地址: '彰化縣北斗鎮中和里斗中路319號',
    縣市: '彰化縣'
  },
  {
    店號: 941903,
    店名: '村尚',
    地址: '彰化縣大村鄉中山路二段357號357-2號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 941970,
    店名: '勝全',
    地址: '彰化縣彰化市林森路205號',
    縣市: '彰化縣'
  },
  {
    店號: 950583,
    店名: '東崎',
    地址: '彰化縣鹿港鎮東崎里彰鹿路五段7號',
    縣市: '彰化縣'
  },
  {
    店號: 951128,
    店名: '彰德',
    地址: '彰化縣彰化市香山里彰南路二段510號',
    縣市: '彰化縣'
  },
  {
    店號: 952062,
    店名: '和卿',
    地址: '彰化縣和美鎮和南里和卿路193號',
    縣市: '彰化縣'
  },
  {
    店號: 952350,
    店名: '鹿秀',
    地址: '彰化縣鹿港鎮鹿工路6號',
    縣市: '彰化縣'
  },
  {
    店號: 952578,
    店名: '美皇',
    地址: '彰化縣大村鄉山腳路72號',
    縣市: '彰化縣'
  },
  {
    店號: 953032,
    店名: '梅州里',
    地址: '彰化縣田中鎮中州路二段372號',
    縣市: '彰化縣'
  },
  {
    店號: 953467,
    店名: '田正',
    地址: '彰化縣田尾鄉中山路一段191號',
    縣市: '彰化縣'
  },
  {
    店號: 953629,
    店名: '群茂',
    地址: '彰化縣二林鎮斗苑路四段159號',
    縣市: '彰化縣'
  },
  {
    店號: 953744,
    店名: '管嶼',
    地址: '彰化縣福興鄉沿海路三段69號',
    縣市: '彰化縣'
  },
  {
    店號: 953881,
    店名: '鹿棋',
    地址: '彰化縣鹿港鎮溝墘里鹿和路三段438號',
    縣市: '彰化縣'
  },
  {
    店號: 954459,
    店名: '新百川',
    地址: '彰化縣員林市莒光路379號',
    縣市: '彰化縣'
  },
  {
    店號: 959317,
    店名: '惠明',
    地址: '彰化縣員林市惠明街51號',
    縣市: '彰化縣'
  },
  {
    店號: 961941,
    店名: '秀工',
    地址: '彰化縣秀水鄉彰水路二段795-1號',
    縣市: '彰化縣'
  },
  {
    店號: 963121,
    店名: '伸冠',
    地址: '彰化縣伸港鄉大同村中興路二段316號',
    縣市: '彰化縣'
  },
  {
    店號: 965563,
    店名: '昇沅',
    地址: '彰化縣福興鄉福南村沿海路四段750號',
    縣市: '彰化縣'
  },
  {
    店號: 966016,
    店名: '欣兆陽',
    地址: '彰化縣彰化市向陽里向陽街205及207號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 966072,
    店名: '台化',
    地址: '彰化縣彰化市復興里中山路三段306號',
    縣市: '彰化縣'
  },
  {
    店號: 966577,
    店名: '新員高',
    地址: '彰化縣溪湖鎮員鹿路一段101號',
    縣市: '彰化縣'
  },
  {
    店號: 966935,
    店名: '彰興',
    地址: '彰化縣埤頭鄉興農村彰水路四段168號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 967019,
    店名: '大員山',
    地址: '彰化縣員林市中山路一段300號',
    縣市: '彰化縣'
  },
  {
    店號: 967363,
    店名: '員鹿',
    地址: '彰化縣溪湖鎮員鹿路二段臨130號',
    縣市: '彰化縣'
  },
  {
    店號: 967400,
    店名: '鹿寶',
    地址: '彰化縣鹿港鎮彰頂路17號',
    縣市: '彰化縣'
  },
  {
    店號: 967916,
    店名: '沓澤',
    地址: '彰化縣彰化市彰美路一段206號208號',
    縣市: '彰化縣'
  },
  {
    店號: 968506,
    店名: '龍舟',
    地址: '彰化縣福興鄉福興村龍舟路15號',
    縣市: '彰化縣'
  },
  {
    店號: 968610,
    店名: '順心',
    地址: '彰化縣埔心鄉中山路145號147號149號',
    縣市: '彰化縣'
  },
  {
    店號: 968997,
    店名: '路口厝',
    地址: '彰化縣埤頭鄉中和村彰水路一段臨325號',
    縣市: '彰化縣'
  },
  {
    店號: 970026,
    店名: '加吉利',
    地址: '彰化縣田中鎮中正路276號',
    縣市: '彰化縣'
  },
  {
    店號: 970691,
    店名: '金佳旺',
    地址: '彰化縣社頭鄉中山路一段516號',
    縣市: '彰化縣'
  },
  {
    店號: 971155,
    店名: '鹿正',
    地址: '彰化縣鹿港鎮中正路556號',
    縣市: '彰化縣'
  },
  {
    店號: 971199,
    店名: '新竹塘',
    地址: '彰化縣竹塘鄉竹五路臨2號',
    縣市: '彰化縣'
  },
  {
    店號: 971535,
    店名: '祿靖',
    地址: '彰化縣永靖鄉中山路二段435號437號',
    縣市: '彰化縣'
  },
  {
    店號: 971627,
    店名: '彰苑',
    地址: '彰化縣北斗鎮斗苑路二段298之2號',
    縣市: '彰化縣'
  },
  {
    店號: 971731,
    店名: '和鎮',
    地址: '彰化縣和美鎮和線路323號',
    縣市: '彰化縣'
  },
  {
    店號: 972170,
    店名: '鹿慶',
    地址: '彰化縣鹿港鎮慶安街116號',
    縣市: '彰化縣'
  },
  {
    店號: 977371,
    店名: '田中',
    地址: '彰化縣田中鎮福安路144號146號',
    縣市: '彰化縣'
  },
  {
    店號: 978525,
    店名: '附工',
    地址: '彰化縣彰化市工校街21號',
    縣市: '彰化縣'
  },
  {
    店號: 981923,
    店名: '糖廉',
    地址: '彰化縣和美鎮糖友一街2號',
    縣市: '彰化縣'
  },
  {
    店號: 982373,
    店名: '好修',
    地址: '彰化縣埔鹽鄉員鹿路二段95號',
    縣市: '彰化縣'
  },
  {
    店號: 990835,
    店名: '新靜修',
    地址: '彰化縣員林市靜修路77號之4',
    縣市: '彰化縣'
  },
  {
    店號: 991160,
    店名: '新勝利',
    地址: '彰化縣和美鎮鹿和路六段402之2號',
    縣市: '彰化縣'
  },
  {
    店號: 991838,
    店名: '家和',
    地址: '彰化縣員林市大饒里員集路二段216號',
    縣市: '彰化縣'
  },
  {
    店號: 992783,
    店名: '博愛',
    地址: '彰化縣彰化市光南里南校街132及130之1號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 993465,
    店名: '線西',
    地址: '彰化縣線西鄉寓埔村沿海路一段892號',
    縣市: '彰化縣'
  },
  {
    店號: 993812,
    店名: '巨峰',
    地址: '彰化縣彰化市天祥路359號',
    縣市: '彰化縣'
  },
  {
    店號: 993823,
    店名: '宇勝',
    地址: '彰化縣彰化市崙平里崙平北路22號',
    縣市: '彰化縣'
  },
  {
    店號: 997836,
    店名: '鎮安',
    地址: '彰化縣大村鄉大溪路7-4號1樓',
    縣市: '彰化縣'
  },
  {
    店號: 110297,
    店名: '油車',
    地址: '雲林縣二崙鄉油車村文化路9號1樓',
    縣市: '雲林縣'
  },
  {
    店號: 110600,
    店名: '冬念',
    地址: '雲林縣虎尾鎮埒內里林森路一段9鄰39號',
    縣市: '雲林縣'
  },
  {
    店號: 110611,
    店名: '富來',
    地址: '雲林縣西螺鎮新豐里13鄰新社320-8號',
    縣市: '雲林縣'
  },
  {
    店號: 110839,
    店名: '虎威',
    地址: '雲林縣虎尾鎮光復路122號1樓及成和街2號1樓',
    縣市: '雲林縣'
  },
  {
    店號: 112558,
    店名: '夏恩',
    地址: '雲林縣虎尾鎮立仁里復興路137號',
    縣市: '雲林縣'
  },
  {
    店號: 113296,
    店名: '東宇',
    地址: '雲林縣斗六市文化路538號540號1樓',
    縣市: '雲林縣'
  },
  {
    店號: 114808,
    店名: '晟安',
    地址: '雲林縣莿桐鄉饒平村饒平路2之2號',
    縣市: '雲林縣'
  },
  {
    店號: 115878,
    店名: '新台西',
    地址: '雲林縣台西鄉海南村民族路16-7號1樓',
    縣市: '雲林縣'
  },
  {
    店號: 121828,
    店名: '晟泰',
    地址: '雲林縣虎尾鎮光復路521號',
    縣市: '雲林縣'
  },
  {
    店號: 126568,
    店名: '斗高',
    地址: '雲林縣斗南鎮小東里17鄰大業路86號',
    縣市: '雲林縣'
  },
  {
    店號: 128254,
    店名: '欣怡',
    地址: '雲林縣斗南鎮南昌里中山路79號',
    縣市: '雲林縣'
  },
  {
    店號: 128265,
    店名: '新宗行',
    地址: '雲林縣虎尾鎮林森路二段240號1樓',
    縣市: '雲林縣'
  },
  {
    店號: 128634,
    店名: '真嘉',
    地址: '雲林縣斗南鎮南昌西路1號',
    縣市: '雲林縣'
  },
  {
    店號: 130202,
    店名: '永昌',
    地址: '雲林縣斗六市中山路269號',
    縣市: '雲林縣'
  },
  {
    店號: 131858,
    店名: '宇宸',
    地址: '雲林縣虎尾鎮清雲路770號',
    縣市: '雲林縣'
  },
  {
    店號: 131917,
    店名: '新東立',
    地址: '雲林縣斗六市成功路286號288號290號',
    縣市: '雲林縣'
  },
  {
    店號: 132024,
    店名: '李斯特',
    地址: '雲林縣虎尾鎮興南里竹圍60號',
    縣市: '雲林縣'
  },
  {
    店號: 138804,
    店名: '環科大',
    地址: '雲林縣斗六市鎮南路1221號1樓',
    縣市: '雲林縣'
  },
  {
    店號: 144153,
    店名: '豐樺',
    地址: '雲林縣西螺鎮福興里中山路70號1樓',
    縣市: '雲林縣'
  },
  {
    店號: 151081,
    店名: '五條港',
    地址: '雲林縣台西鄉五港路420-1號',
    縣市: '雲林縣'
  },
  {
    店號: 153766,
    店名: '保庄',
    地址: '雲林縣斗六市明德北路三段285號',
    縣市: '雲林縣'
  },
  {
    店號: 153951,
    店名: '大埤',
    地址: '雲林縣大埤鄉南和村6鄰民生路32號',
    縣市: '雲林縣'
  },
  {
    店號: 158613,
    店名: '元長',
    地址: '雲林縣元長鄉長南村7鄰中山路32號.32-2號1F',
    縣市: '雲林縣'
  },
  {
    店號: 170716,
    店名: '雲龍',
    地址: '雲林縣斗六市龍潭路14-1號',
    縣市: '雲林縣'
  },
  {
    店號: 170875,
    店名: '東億',
    地址: '雲林縣虎尾鎮光明路3號',
    縣市: '雲林縣'
  },
  {
    店號: 174154,
    店名: '朱丹灣',
    地址: '雲林縣斗六市西平路362號',
    縣市: '雲林縣'
  },
  {
    店號: 174246,
    店名: '東尊',
    地址: '雲林縣虎尾鎮惠來里142-3號',
    縣市: '雲林縣'
  },
  {
    店號: 174958,
    店名: '水林',
    地址: '雲林縣水林鄉水南村水林路157號159號',
    縣市: '雲林縣'
  },
  {
    店號: 182627,
    店名: '豐鎮',
    地址: '雲林縣西螺鎮平和南路352號',
    縣市: '雲林縣'
  },
  {
    店號: 182993,
    店名: '宗聖',
    地址: '雲林縣北港鎮大同路511-1號',
    縣市: '雲林縣'
  },
  {
    店號: 184380,
    店名: '虎欣',
    地址: '雲林縣虎尾鎮林森路一段287.289.293號',
    縣市: '雲林縣'
  },
  {
    店號: 184863,
    店名: '四湖',
    地址: '雲林縣四湖鄉四湖村中山東路113號',
    縣市: '雲林縣'
  },
  {
    店號: 185475,
    店名: '成苑',
    地址: '雲林縣斗六市莊敬路345號',
    縣市: '雲林縣'
  },
  {
    店號: 185486,
    店名: '欣苑',
    地址: '雲林縣斗六市莊敬路345號1樓',
    縣市: '雲林縣'
  },
  {
    店號: 189226,
    店名: '朝天宮',
    地址: '雲林縣北港鎮東華里中山路150號',
    縣市: '雲林縣'
  },
  {
    店號: 190835,
    店名: '保長',
    地址: '雲林縣斗六市雲林路二段76號1樓',
    縣市: '雲林縣'
  },
  {
    店號: 193292,
    店名: '福懋興',
    地址: '雲林縣斗六市石榴路317號',
    縣市: '雲林縣'
  },
  {
    店號: 194907,
    店名: '頂豐',
    地址: '雲林縣斗六市榴南里斗工十路62號',
    縣市: '雲林縣'
  },
  {
    店號: 195461,
    店名: '羅威',
    地址: '雲林縣崙背鄉羅厝村東興路168-1號.168-2號',
    縣市: '雲林縣'
  },
  {
    店號: 195944,
    店名: '昶景',
    地址: '雲林縣古坑鄉東和村文化路145號',
    縣市: '雲林縣'
  },
  {
    店號: 196383,
    店名: '虎真',
    地址: '雲林縣虎尾鎮穎川里頂南398號',
    縣市: '雲林縣'
  },
  {
    店號: 196475,
    店名: '樹子腳',
    地址: '雲林縣莿桐鄉和平路28號',
    縣市: '雲林縣'
  },
  {
    店號: 196604,
    店名: '斗六明',
    地址: '雲林縣斗六市明德路101號.103號',
    縣市: '雲林縣'
  },
  {
    店號: 196741,
    店名: '萬中',
    地址: '雲林縣斗六市溪洲里中南路290巷1-1號',
    縣市: '雲林縣'
  },
  {
    店號: 196992,
    店名: '土庫',
    地址: '雲林縣土庫鎮建國路150號1樓',
    縣市: '雲林縣'
  },
  {
    店號: 197571,
    店名: '雲醫',
    地址: '雲林縣斗六市雲林路二段627號',
    縣市: '雲林縣'
  },
  {
    店號: 199142,
    店名: '工專',
    地址: '雲林縣虎尾鎮中正路307號',
    縣市: '雲林縣'
  },
  {
    店號: 199337,
    店名: '雲桐',
    地址: '雲林縣莿桐鄉莿桐村中山路70號72號1樓',
    縣市: '雲林縣'
  },
  {
    店號: 200332,
    店名: '永業',
    地址: '雲林縣西螺鎮振興里振興215號',
    縣市: '雲林縣'
  },
  {
    店號: 200398,
    店名: '大琬',
    地址: '雲林縣大埤鄉中正路19號',
    縣市: '雲林縣'
  },
  {
    店號: 206581,
    店名: '上慶',
    地址: '雲林縣斗六市漢口路190.192號',
    縣市: '雲林縣'
  },
  {
    店號: 206662,
    店名: '元祖',
    地址: '雲林縣元長鄉中山路4-100號',
    縣市: '雲林縣'
  },
  {
    店號: 207562,
    店名: '麥中',
    地址: '雲林縣麥寮鄉麥豐村中山路437巷1號',
    縣市: '雲林縣'
  },
  {
    店號: 208071,
    店名: '鑫崙',
    地址: '雲林縣斗南鎮新崙路65之1號',
    縣市: '雲林縣'
  },
  {
    店號: 208554,
    店名: '豆油',
    地址: '雲林縣西螺鎮振興里振興55-3號',
    縣市: '雲林縣'
  },
  {
    店號: 208886,
    店名: '湖東',
    地址: '雲林縣口湖鄉中正路一段136號',
    縣市: '雲林縣'
  },
  {
    店號: 209410,
    店名: '名采',
    地址: '雲林縣斗南鎮中山路30.30-1號',
    縣市: '雲林縣'
  },
  {
    店號: 209579,
    店名: '大北勢',
    地址: '雲林縣斗六市長平路7-32號',
    縣市: '雲林縣'
  },
  {
    店號: 210133,
    店名: '虎爺',
    地址: '雲林縣虎尾鎮學府路39號',
    縣市: '雲林縣'
  },
  {
    店號: 210661,
    店名: '棒球場',
    地址: '雲林縣斗六市斗六三路6號',
    縣市: '雲林縣'
  },
  {
    店號: 211907,
    店名: '圓真',
    地址: '雲林縣虎尾鎮信義路52號及三民路93號',
    縣市: '雲林縣'
  },
  {
    店號: 215426,
    店名: '大屯',
    地址: '雲林縣虎尾鎮西屯里大屯349號',
    縣市: '雲林縣'
  },
  {
    店號: 227946,
    店名: '晟家',
    地址: '雲林縣斗六市長安西路1之5號',
    縣市: '雲林縣'
  },
  {
    店號: 228400,
    店名: '儒虎',
    地址: '雲林縣虎尾鎮新吉里新吉30之5號',
    縣市: '雲林縣'
  },
  {
    店號: 230551,
    店名: '麥福',
    地址: '雲林縣麥寮鄉台塑工業園區1號',
    縣市: '雲林縣'
  },
  {
    店號: 231266,
    店名: '褒旺',
    地址: '雲林縣褒忠鄉中正路456之1號',
    縣市: '雲林縣'
  },
  {
    店號: 231635,
    店名: '冬美',
    地址: '雲林縣虎尾鎮民權路2-3號',
    縣市: '雲林縣'
  },
  {
    店號: 231831,
    店名: '大茄苳',
    地址: '雲林縣西螺鎮大新210之3號1樓',
    縣市: '雲林縣'
  },
  {
    店號: 237714,
    店名: '聖淳',
    地址: '雲林縣四湖鄉四湖村15鄰環湖東路1號',
    縣市: '雲林縣'
  },
  {
    店號: 238049,
    店名: '星鑫',
    地址: '雲林縣口湖鄉崙東村中山路96-6號',
    縣市: '雲林縣'
  },
  {
    店號: 238544,
    店名: '昕美',
    地址: '雲林縣斗六市民生路170號',
    縣市: '雲林縣'
  },
  {
    店號: 241333,
    店名: '口湖',
    地址: '雲林縣口湖鄉中正路一段222號',
    縣市: '雲林縣'
  },
  {
    店號: 241377,
    店名: '劍湖',
    地址: '雲林縣古坑鄉永昌村永興路145號',
    縣市: '雲林縣'
  },
  {
    店號: 249153,
    店名: '二崙',
    地址: '雲林縣二崙鄉崙東村中山路一段269號',
    縣市: '雲林縣'
  },
  {
    店號: 249577,
    店名: '新安慶',
    地址: '雲林縣虎尾鎮民主路52-1號',
    縣市: '雲林縣'
  },
  {
    店號: 250810,
    店名: '星月',
    地址: '雲林縣口湖鄉福安路26-3號',
    縣市: '雲林縣'
  },
  {
    店號: 251558,
    店名: '詠順',
    地址: '雲林縣斗六市鎮北路229號',
    縣市: '雲林縣'
  },
  {
    店號: 830698,
    店名: '富盟',
    地址: '雲林縣斗六市文化路304號306號',
    縣市: '雲林縣'
  },
  {
    店號: 850119,
    店名: '北港',
    地址: '雲林縣北港鎮民主路106號',
    縣市: '雲林縣'
  },
  {
    店號: 863551,
    店名: '麥寮',
    地址: '雲林縣麥寮鄉麥津村中山路196號',
    縣市: '雲林縣'
  },
  {
    店號: 870870,
    店名: '長旺',
    地址: '雲林縣東勢鄉東勢東路84號',
    縣市: '雲林縣'
  },
  {
    店號: 871839,
    店名: '崙背',
    地址: '雲林縣崙背鄉南光路3號',
    縣市: '雲林縣'
  },
  {
    店號: 872522,
    店名: '興平',
    地址: '雲林縣西螺鎮中興里延平路418號420號',
    縣市: '雲林縣'
  },
  {
    店號: 873400,
    店名: '民樂',
    地址: '雲林縣北港鎮華勝里28鄰民樂路39號',
    縣市: '雲林縣'
  },
  {
    店號: 880567,
    店名: '福懋',
    地址: '雲林縣斗六市石榴路196之1號',
    縣市: '雲林縣'
  },
  {
    店號: 881386,
    店名: '快來',
    地址: '雲林縣麥寮鄉橋頭村橋頭路234號',
    縣市: '雲林縣'
  },
  {
    店號: 890793,
    店名: '六輕',
    地址: '雲林縣麥寮鄉中興村仁德西路二段567號1樓',
    縣市: '雲林縣'
  },
  {
    店號: 896045,
    店名: '斗六',
    地址: '雲林縣斗六市大同路41號',
    縣市: '雲林縣'
  },
  {
    店號: 901684,
    店名: '馬光',
    地址: '雲林縣土庫鎮南平里馬光路69號',
    縣市: '雲林縣'
  },
  {
    店號: 920478,
    店名: '山好',
    地址: '雲林縣斗六市崙峰里仁義路52號1樓',
    縣市: '雲林縣'
  },
  {
    店號: 920489,
    店名: '好家庭',
    地址: '雲林縣斗六市榴中里工業路69號',
    縣市: '雲林縣'
  },
  {
    店號: 921068,
    店名: '新湖',
    地址: '雲林縣虎尾鎮林森路二段475號',
    縣市: '雲林縣'
  },
  {
    店號: 922027,
    店名: '春流',
    地址: '雲林縣斗六市梅林里梅林路446號1樓',
    縣市: '雲林縣'
  },
  {
    店號: 931962,
    店名: '褒忠',
    地址: '雲林縣褒忠鄉中正路99號1樓',
    縣市: '雲林縣'
  },
  {
    店號: 932437,
    店名: '大美',
    地址: '雲林縣莿桐鄉大美村大美53號1樓',
    縣市: '雲林縣'
  },
  {
    店號: 942146,
    店名: '坤麟',
    地址: '雲林縣斗六市社口里大學路二段579號',
    縣市: '雲林縣'
  },
  {
    店號: 943367,
    店名: '雲南',
    地址: '雲林縣斗南鎮中興路160號',
    縣市: '雲林縣'
  },
  {
    店號: 943747,
    店名: '和心',
    地址: '雲林縣西螺鎮河南里埔心路113-3號',
    縣市: '雲林縣'
  },
  {
    店號: 950860,
    店名: '育北',
    地址: '雲林縣斗六市明德北路一段110號',
    縣市: '雲林縣'
  },
  {
    店號: 951922,
    店名: '麥鄉',
    地址: '雲林縣麥寮鄉中興路78-3號',
    縣市: '雲林縣'
  },
  {
    店號: 952349,
    店名: '永茂',
    地址: '雲林縣麥寮鄉中興村豐安路951號1樓',
    縣市: '雲林縣'
  },
  {
    店號: 952545,
    店名: '崙多',
    地址: '雲林縣崙背鄉東明村正義路194號',
    縣市: '雲林縣'
  },
  {
    店號: 953445,
    店名: '虎大',
    地址: '雲林縣虎尾鎮工專路156號',
    縣市: '雲林縣'
  },
  {
    店號: 954297,
    店名: '新古坑',
    地址: '雲林縣古坑鄉中山路201號',
    縣市: '雲林縣'
  },
  {
    店號: 958635,
    店名: '富登',
    地址: '雲林縣麥寮鄉施厝村239號',
    縣市: '雲林縣'
  },
  {
    店號: 963062,
    店名: '景雄',
    地址: '雲林縣斗六市虎溪里西平路521號',
    縣市: '雲林縣'
  },
  {
    店號: 967525,
    店名: '新林內',
    地址: '雲林縣林內鄉中正路373號375號',
    縣市: '雲林縣'
  },
  {
    店號: 968115,
    店名: '北英',
    地址: '雲林縣北港鎮華勝里華勝路212號',
    縣市: '雲林縣'
  },
  {
    店號: 968229,
    店名: '福懋科',
    地址: '雲林縣斗六市河南街319號',
    縣市: '雲林縣'
  },
  {
    店號: 968665,
    店名: '安榮',
    地址: '雲林縣崙背鄉豐榮村1鄰豐榮32之3號',
    縣市: '雲林縣'
  },
  {
    店號: 968676,
    店名: '虎高',
    地址: '雲林縣虎尾鎮延平里3鄰中南34之26號',
    縣市: '雲林縣'
  },
  {
    店號: 968816,
    店名: '星光',
    地址: '雲林縣西螺鎮公正路15號',
    縣市: '雲林縣'
  },
  {
    店號: 969060,
    店名: '麥豐',
    地址: '雲林縣麥寮鄉新興路27之5號',
    縣市: '雲林縣'
  },
  {
    店號: 969071,
    店名: '三勝',
    地址: '雲林縣麥寮鄉三盛村仁德西路一段21號1樓',
    縣市: '雲林縣'
  },
  {
    店號: 971096,
    店名: '晟業',
    地址: '雲林縣斗六市萬年路592號',
    縣市: '雲林縣'
  },
  {
    店號: 971568,
    店名: '後安',
    地址: '雲林縣麥寮鄉後安村後安路201之13號',
    縣市: '雲林縣'
  },
  {
    店號: 972114,
    店名: '寶宏',
    地址: '雲林縣斗南鎮文昌路99號',
    縣市: '雲林縣'
  },
  {
    店號: 972505,
    店名: '崙中',
    地址: '雲林縣崙背鄉南陽村中山路489號',
    縣市: '雲林縣'
  },
  {
    店號: 980045,
    店名: '于滿',
    地址: '雲林縣斗南鎮延平路二段581號1樓',
    縣市: '雲林縣'
  },
  {
    店號: 982432,
    店名: '新莿桐',
    地址: '雲林縣莿桐鄉莿桐村中正路62-2號',
    縣市: '雲林縣'
  },
  {
    店號: 982650,
    店名: '宜梧',
    地址: '雲林縣口湖鄉梧南村光明路31號1樓',
    縣市: '雲林縣'
  },
  {
    店號: 990396,
    店名: '鑫斗商',
    地址: '雲林縣斗六市中華路207號209號1樓',
    縣市: '雲林縣'
  },
  {
    店號: 990466,
    店名: '凱瑄',
    地址: '雲林縣斗南鎮西岐里大同路135號1樓',
    縣市: '雲林縣'
  },
  {
    店號: 991920,
    店名: '廣濟',
    地址: '雲林縣古坑鄉東和村廣濟路78號78之1號',
    縣市: '雲林縣'
  },
  {
    店號: 997906,
    店名: '晟興',
    地址: '雲林縣林內鄉九芎村大同路20號',
    縣市: '雲林縣'
  },
  {
    店號: 998080,
    店名: '七崁',
    地址: '雲林縣西螺鎮建興路163號1樓',
    縣市: '雲林縣'
  },
  {
    店號: 998116,
    店名: '元東',
    地址: '雲林縣元長鄉下寮村東興路28號1樓',
    縣市: '雲林縣'
  },
  {
    店號: 110079,
    店名: '竹秀',
    地址: '南投縣竹山鎮集山路二段58號',
    縣市: '南投縣'
  },
  {
    店號: 110208,
    店名: '集寶',
    地址: '南投縣集集鎮八張街75號',
    縣市: '南投縣'
  },
  {
    店號: 110219,
    店名: '國寶',
    地址: '南投縣草屯鎮中正路557之26號',
    縣市: '南投縣'
  },
  {
    店號: 111005,
    店名: '前山',
    地址: '南投縣竹山鎮集山路三段1089號',
    縣市: '南投縣'
  },
  {
    店號: 111544,
    店名: '向日葵',
    地址: '南投縣草屯鎮芬草路三段219-1號',
    縣市: '南投縣'
  },
  {
    店號: 113687,
    店名: '六合',
    地址: '南投縣水里鄉民生路175號1樓',
    縣市: '南投縣'
  },
  {
    店號: 114680,
    店名: '恆吉',
    地址: '南投縣埔里鎮南興街172號',
    縣市: '南投縣'
  },
  {
    店號: 120261,
    店名: '埔德',
    地址: '南投縣埔里鎮仁愛路450之2號1樓',
    縣市: '南投縣'
  },
  {
    店號: 121091,
    店名: '愛蘭',
    地址: '南投縣埔里鎮鐵山路36號1樓',
    縣市: '南投縣'
  },
  {
    店號: 121574,
    店名: '福元',
    地址: '南投縣草屯鎮中正路885號1樓',
    縣市: '南投縣'
  },
  {
    店號: 121736,
    店名: '草鞋鐓',
    地址: '南投縣草屯鎮中正路344之30號',
    縣市: '南投縣'
  },
  {
    店號: 122441,
    店名: '水社',
    地址: '南投縣魚池鄉中興路32之3號1樓',
    縣市: '南投縣'
  },
  {
    店號: 124540,
    店名: '狀元',
    地址: '南投縣竹山鎮大明路500號',
    縣市: '南投縣'
  },
  {
    店號: 126292,
    店名: '埔惠',
    地址: '南投縣埔里鎮大城里中山路三段546號1樓',
    縣市: '南投縣'
  },
  {
    店號: 126351,
    店名: '鑫永安',
    地址: '南投縣草屯鎮御史里登輝路558號',
    縣市: '南投縣'
  },
  {
    店號: 126764,
    店名: '祖祠',
    地址: '南投縣南投市祖祠路16-4號',
    縣市: '南投縣'
  },
  {
    店號: 127538,
    店名: '國泰',
    地址: '南投縣草屯鎮中正路636號1樓及和興街93號1樓',
    縣市: '南投縣'
  },
  {
    店號: 131825,
    店名: '日月潭',
    地址: '南投縣魚池鄉水社村中山路118號',
    縣市: '南投縣'
  },
  {
    店號: 132161,
    店名: '竹寶',
    地址: '南投縣竹山鎮延正里延正路45之30號1樓',
    縣市: '南投縣'
  },
  {
    店號: 136370,
    店名: '清境',
    地址: '南投縣仁愛鄉定遠新村26之1號',
    縣市: '南投縣'
  },
  {
    店號: 137823,
    店名: '長崗',
    地址: '南投縣南投市南崗二路581號',
    縣市: '南投縣'
  },
  {
    店號: 138011,
    店名: '信義鄉',
    地址: '南投縣信義鄉明德村玉山路82-2號',
    縣市: '南投縣'
  },
  {
    店號: 139070,
    店名: '水里',
    地址: '南投縣水里鄉中山路一段63號',
    縣市: '南投縣'
  },
  {
    店號: 141615,
    店名: '和雅',
    地址: '南投縣鹿谷鄉廣興村中正一路225號',
    縣市: '南投縣'
  },
  {
    店號: 144212,
    店名: '龍揚',
    地址: '南投縣埔里鎮樹人路221之2號',
    縣市: '南投縣'
  },
  {
    店號: 151645,
    店名: '龍辰',
    地址: '南投縣南投市中學西路61號',
    縣市: '南投縣'
  },
  {
    店號: 153652,
    店名: '恩泉',
    地址: '南投縣仁愛鄉南豐村中正路88附1號',
    縣市: '南投縣'
  },
  {
    店號: 153663,
    店名: '埔灃',
    地址: '南投縣埔里鎮中山路二段108號中華路184之2號',
    縣市: '南投縣'
  },
  {
    店號: 154530,
    店名: '鴻寶',
    地址: '南投縣草屯鎮民權西路221號',
    縣市: '南投縣'
  },
  {
    店號: 155289,
    店名: '鑫潭',
    地址: '南投縣埔里鎮中山路四段97之1.97之2號',
    縣市: '南投縣'
  },
  {
    店號: 155441,
    店名: '鳳凰谷',
    地址: '南投縣鹿谷鄉中正路三段63號',
    縣市: '南投縣'
  },
  {
    店號: 160144,
    店名: '集利',
    地址: '南投縣集集鎮吳厝里民生路65-1號',
    縣市: '南投縣'
  },
  {
    店號: 163501,
    店名: '樂天',
    地址: '南投縣南投市南陽路476號',
    縣市: '南投縣'
  },
  {
    店號: 164191,
    店名: '龍泰',
    地址: '南投縣草屯鎮碧興路一段798-1號',
    縣市: '南投縣'
  },
  {
    店號: 164401,
    店名: '名間',
    地址: '南投縣名間鄉彰南路71之5號',
    縣市: '南投縣'
  },
  {
    店號: 164412,
    店名: '雅集',
    地址: '南投縣名間鄉員集路137號',
    縣市: '南投縣'
  },
  {
    店號: 174017,
    店名: '猴探井',
    地址: '南投縣南投市八德路600之1號',
    縣市: '南投縣'
  },
  {
    店號: 179908,
    店名: '中心園',
    地址: '南投縣埔里鎮中山路一段427號1樓',
    縣市: '南投縣'
  },
  {
    店號: 181303,
    店名: '合廣',
    地址: '南投縣草屯鎮碧山路307.309號',
    縣市: '南投縣'
  },
  {
    店號: 183332,
    店名: '京鑫',
    地址: '南投縣草屯鎮中正路483號',
    縣市: '南投縣'
  },
  {
    店號: 187518,
    店名: '鹿山',
    地址: '南投縣竹山鎮延祥里集山路三段73號',
    縣市: '南投縣'
  },
  {
    店號: 187828,
    店名: '福新',
    地址: '南投縣草屯鎮虎山路495號497號',
    縣市: '南投縣'
  },
  {
    店號: 188348,
    店名: '鑫魚池',
    地址: '南投縣魚池鄉魚池街799號',
    縣市: '南投縣'
  },
  {
    店號: 192646,
    店名: '育溪',
    地址: '南投縣埔里鎮安七街89-1號',
    縣市: '南投縣'
  },
  {
    店號: 193074,
    店名: '鑫驛',
    地址: '南投縣埔里鎮中山路四段106號',
    縣市: '南投縣'
  },
  {
    店號: 193085,
    店名: '穀昌',
    地址: '南投縣名間鄉彰南路450號',
    縣市: '南投縣'
  },
  {
    店號: 193971,
    店名: '鈺興',
    地址: '南投縣竹山鎮集山路三段912.914號',
    縣市: '南投縣'
  },
  {
    店號: 195357,
    店名: '龍星',
    地址: '南投縣草屯鎮復興里碧山路731之5號',
    縣市: '南投縣'
  },
  {
    店號: 195782,
    店名: '欣鑫',
    地址: '南投縣南投市仁和路26號',
    縣市: '南投縣'
  },
  {
    店號: 196006,
    店名: '埔安',
    地址: '南投縣埔里鎮西安路一段409-1號',
    縣市: '南投縣'
  },
  {
    店號: 196372,
    店名: '墩煌',
    地址: '南投縣草屯鎮芬草路三段36號',
    縣市: '南投縣'
  },
  {
    店號: 196408,
    店名: '鄉親寮',
    地址: '南投縣中寮鄉永安街79之1號1樓',
    縣市: '南投縣'
  },
  {
    店號: 200295,
    店名: '鑫中潭',
    地址: '南投縣魚池鄉新城村通文巷6之28號',
    縣市: '南投縣'
  },
  {
    店號: 200424,
    店名: '莘鑫',
    地址: '南投縣南投市中興路221號',
    縣市: '南投縣'
  },
  {
    店號: 202040,
    店名: '大庄',
    地址: '南投縣名間鄉大庄村南田路142之12號',
    縣市: '南投縣'
  },
  {
    店號: 207931,
    店名: '寶棧',
    地址: '南投縣竹山鎮保甲路10號',
    縣市: '南投縣'
  },
  {
    店號: 209384,
    店名: '御新',
    地址: '南投縣草屯鎮中正路1397-6號',
    縣市: '南投縣'
  },
  {
    店號: 210638,
    店名: '寶順',
    地址: '南投縣竹山鎮江西路1-37號',
    縣市: '南投縣'
  },
  {
    店號: 213947,
    店名: '南投',
    地址: '南投縣南投市民族路289、291、293號中山街143號1.2樓',
    縣市: '南投縣'
  },
  {
    店號: 215529,
    店名: '京埔',
    地址: '南投縣草屯鎮南埔里中正路254-10號',
    縣市: '南投縣'
  },
  {
    店號: 228695,
    店名: '芳美',
    地址: '南投縣南投市中興路413號',
    縣市: '南投縣'
  },
  {
    店號: 230447,
    店名: '世翊',
    地址: '南投縣埔里鎮和平東路223號',
    縣市: '南投縣'
  },
  {
    店號: 231679,
    店名: '鑫台一',
    地址: '南投縣埔里鎮中山路一段176號',
    縣市: '南投縣'
  },
  {
    店號: 231680,
    店名: '茶鄉',
    地址: '南投縣名間鄉彰南路335之8號',
    縣市: '南投縣'
  },
  {
    店號: 233332,
    店名: '水信',
    地址: '南投縣水里鄉水信路二段149號',
    縣市: '南投縣'
  },
  {
    店號: 238784,
    店名: '豐詳',
    地址: '南投縣南投市民族路66、68號1樓',
    縣市: '南投縣'
  },
  {
    店號: 240695,
    店名: '中翔',
    地址: '南投縣埔里鎮中正路704號',
    縣市: '南投縣'
  },
  {
    店號: 240721,
    店名: '合立',
    地址: '南投縣南投市營北里向陽路101號',
    縣市: '南投縣'
  },
  {
    店號: 882079,
    店名: '龍寶',
    地址: '南投縣水里鄉民權路170號',
    縣市: '南投縣'
  },
  {
    店號: 894315,
    店名: '龍巳',
    地址: '南投縣南投市東山路408號',
    縣市: '南投縣'
  },
  {
    店號: 898351,
    店名: '南崗',
    地址: '南投縣南投市民族路515號及南崗一路387號',
    縣市: '南投縣'
  },
  {
    店號: 900614,
    店名: '新鹿谷',
    地址: '南投縣鹿谷鄉仁義路148號',
    縣市: '南投縣'
  },
  {
    店號: 901776,
    店名: '東東',
    地址: '南投縣埔里鎮忠孝路138-140號',
    縣市: '南投縣'
  },
  {
    店號: 902562,
    店名: '佳軒',
    地址: '南投縣魚池鄉魚池街350號',
    縣市: '南投縣'
  },
  {
    店號: 913229,
    店名: '中營',
    地址: '南投縣南投市中華路130號',
    縣市: '南投縣'
  },
  {
    店號: 913355,
    店名: '新國姓',
    地址: '南投縣國姓鄉國姓村中興路301號',
    縣市: '南投縣'
  },
  {
    店號: 922290,
    店名: '和育',
    地址: '南投縣竹山鎮大智路57號',
    縣市: '南投縣'
  },
  {
    店號: 923466,
    店名: '豐億',
    地址: '南投縣南投市彰南路一段573號',
    縣市: '南投縣'
  },
  {
    店號: 923765,
    店名: '見晴園',
    地址: '南投縣仁愛鄉大同村定遠新村路18-1號',
    縣市: '南投縣'
  },
  {
    店號: 931168,
    店名: '社寮',
    地址: '南投縣竹山鎮集山路一段2051號',
    縣市: '南投縣'
  },
  {
    店號: 931180,
    店名: '常春藤',
    地址: '南投縣南投市工業路33號',
    縣市: '南投縣'
  },
  {
    店號: 932367,
    店名: '埔慶',
    地址: '南投縣埔里鎮中山路三段168號170號',
    縣市: '南投縣'
  },
  {
    店號: 940092,
    店名: '詠旭',
    地址: '南投縣南投市彰南路一段1031-2號1樓',
    縣市: '南投縣'
  },
  {
    店號: 941741,
    店名: '瑞峰',
    地址: '南投縣水里鄉北埔村中山路一段540號',
    縣市: '南投縣'
  },
  {
    店號: 950561,
    店名: '竹山大',
    地址: '南投縣竹山鎮中山里自強路176號',
    縣市: '南投縣'
  },
  {
    店號: 954415,
    店名: '合心',
    地址: '南投縣名間鄉中山村彰南路218-32號',
    縣市: '南投縣'
  },
  {
    店號: 954596,
    店名: '登瀛',
    地址: '南投縣草屯鎮新庄里博愛路1012號',
    縣市: '南投縣'
  },
  {
    店號: 958691,
    店名: '佑民',
    地址: '南投縣草屯鎮太平路一段221號',
    縣市: '南投縣'
  },
  {
    店號: 966832,
    店名: '稻豐',
    地址: '南投縣草屯鎮新豐路351號',
    縣市: '南投縣'
  },
  {
    店號: 969037,
    店名: '伊達邵',
    地址: '南投縣魚池鄉日月村義勇街89號',
    縣市: '南投縣'
  },
  {
    店號: 970510,
    店名: '富嘉',
    地址: '南投縣仁愛鄉仁和路223-1號',
    縣市: '南投縣'
  },
  {
    店號: 970716,
    店名: '宏旺',
    地址: '南投縣南投市復興路38號',
    縣市: '南投縣'
  },
  {
    店號: 972804,
    店名: '小瑞士',
    地址: '南投縣仁愛鄉定遠新村28號',
    縣市: '南投縣'
  },
  {
    店號: 977577,
    店名: '敦和',
    地址: '南投縣草屯鎮仁愛街197號199號1樓',
    縣市: '南投縣'
  },
  {
    店號: 977706,
    店名: '豐登',
    地址: '南投縣埔里鎮枇杷里中正路183-23號',
    縣市: '南投縣'
  },
  {
    店號: 981222,
    店名: '和社',
    地址: '南投縣信義鄉同和巷8號1樓',
    縣市: '南投縣'
  },
  {
    店號: 981956,
    店名: '唯鑫',
    地址: '南投縣南投市南崗三路8號2樓',
    縣市: '南投縣'
  },
  {
    店號: 982306,
    店名: '勝財興',
    地址: '南投縣埔里鎮榮光路1-11號',
    縣市: '南投縣'
  },
  {
    店號: 992956,
    店名: '霧社',
    地址: '南投縣仁愛鄉仁和路43號45號1樓',
    縣市: '南投縣'
  },
  {
    店號: 993052,
    店名: '埔佑',
    地址: '南投縣埔里鎮中華路116號1樓',
    縣市: '南投縣'
  },
  {
    店號: 993203,
    店名: '中銘',
    地址: '南投縣埔里鎮西安路一段104號',
    縣市: '南投縣'
  },
  {
    店號: 993672,
    店名: '康壽',
    地址: '南投縣南投市復興路311號1樓',
    縣市: '南投縣'
  },
  {
    店號: 113023,
    店名: '梅北',
    地址: '嘉義縣梅山鄉梅北村中山路437號',
    縣市: '嘉義縣'
  },
  {
    店號: 114587,
    店名: '太保',
    地址: '嘉義縣太保市後潭里後潭408-7號408-8號一樓',
    縣市: '嘉義縣'
  },
  {
    店號: 120308,
    店名: '蒜頭',
    地址: '嘉義縣六腳鄉蒜頭村1鄰蒜頭1-18號',
    縣市: '嘉義縣'
  },
  {
    店號: 120445,
    店名: '水頭',
    地址: '嘉義縣水上鄉水上村中正路171號173號',
    縣市: '嘉義縣'
  },
  {
    店號: 120951,
    店名: '布袋',
    地址: '嘉義縣布袋鎮興中里14鄰上海路177號',
    縣市: '嘉義縣'
  },
  {
    店號: 121253,
    店名: '世川',
    地址: '嘉義縣水上鄉內溪村中義路992號1樓',
    縣市: '嘉義縣'
  },
  {
    店號: 121611,
    店名: '朴天',
    地址: '嘉義縣朴子市中正里開元路18鄰161號165號',
    縣市: '嘉義縣'
  },
  {
    店號: 121666,
    店名: '彩虹',
    地址: '嘉義縣中埔鄉隆興村3鄰汴頭60號',
    縣市: '嘉義縣'
  },
  {
    店號: 122511,
    店名: '友樂',
    地址: '嘉義縣民雄鄉雙福村建國路二段146之61號1樓',
    縣市: '嘉義縣'
  },
  {
    店號: 122728,
    店名: '宮前',
    地址: '嘉義縣新港鄉宮前村新民路24鄰252號附1',
    縣市: '嘉義縣'
  },
  {
    店號: 123134,
    店名: '祥和',
    地址: '嘉義縣太保市太保里太保46-1號',
    縣市: '嘉義縣'
  },
  {
    店號: 124562,
    店名: '暘民',
    地址: '嘉義縣水上鄉寬士村崎子頭159-15號1樓',
    縣市: '嘉義縣'
  },
  {
    店號: 124573,
    店名: '頂六',
    地址: '嘉義縣中埔鄉金蘭村頂山門41-2號1樓',
    縣市: '嘉義縣'
  },
  {
    店號: 130165,
    店名: '新港',
    地址: '嘉義縣新港鄉宮前村中山路72巷1號.中山路74號',
    縣市: '嘉義縣'
  },
  {
    店號: 130523,
    店名: '嘉埔',
    地址: '嘉義縣大埔鄉大埔村大埔276號之6壹樓',
    縣市: '嘉義縣'
  },
  {
    店號: 131009,
    店名: '二竹',
    地址: '嘉義縣義竹鄉仁里村423號',
    縣市: '嘉義縣'
  },
  {
    店號: 132091,
    店名: '豐收',
    地址: '嘉義縣民雄鄉豐收村大學路二段291號',
    縣市: '嘉義縣'
  },
  {
    店號: 137731,
    店名: '溪口',
    地址: '嘉義縣溪口鄉坪頂村中正東路1號1樓',
    縣市: '嘉義縣'
  },
  {
    店號: 141420,
    店名: '漁人',
    地址: '嘉義縣東石鄉猿樹村東石205-1號',
    縣市: '嘉義縣'
  },
  {
    店號: 141431,
    店名: '布鹽',
    地址: '嘉義縣布袋鎮新厝里13鄰新厝仔67之1號',
    縣市: '嘉義縣'
  },
  {
    店號: 142227,
    店名: '義竹',
    地址: '嘉義縣義竹鄉六桂村2鄰義竹156之1號',
    縣市: '嘉義縣'
  },
  {
    店號: 142696,
    店名: '金大義',
    地址: '嘉義縣中埔鄉和美村大義路416號',
    縣市: '嘉義縣'
  },
  {
    店號: 151254,
    店名: '鳳專',
    地址: '嘉義縣民雄鄉建國路二段99號97-7號',
    縣市: '嘉義縣'
  },
  {
    店號: 153733,
    店名: '神木',
    地址: '嘉義縣阿里山鄉中正村3號2樓',
    縣市: '嘉義縣'
  },
  {
    店號: 154839,
    店名: '誠穩',
    地址: '嘉義縣大林鎮中坑里南華路一段55號B1F',
    縣市: '嘉義縣'
  },
  {
    店號: 162379,
    店名: '嘉樂',
    地址: '嘉義縣民雄鄉東榮村文化路36號1樓',
    縣市: '嘉義縣'
  },
  {
    店號: 163567,
    店名: '泉翔',
    地址: '嘉義縣朴子市大葛里嘉朴路西段121號',
    縣市: '嘉義縣'
  },
  {
    店號: 165965,
    店名: '年代',
    地址: '嘉義縣中埔鄉中華路863號',
    縣市: '嘉義縣'
  },
  {
    店號: 166913,
    店名: '諸羅山',
    地址: '嘉義縣朴子市祥和三路西段97號1樓',
    縣市: '嘉義縣'
  },
  {
    店號: 167318,
    店名: '愛樂',
    地址: '嘉義縣民雄鄉福樂村埤角547號',
    縣市: '嘉義縣'
  },
  {
    店號: 170761,
    店名: '灣橋',
    地址: '嘉義縣竹崎鄉灣橋村221號',
    縣市: '嘉義縣'
  },
  {
    店號: 173689,
    店名: '石棹',
    地址: '嘉義縣竹崎鄉中和村石棹22之27號',
    縣市: '嘉義縣'
  },
  {
    店號: 179757,
    店名: '阿里山',
    地址: '嘉義縣阿里山鄉中山村南阿里山55號',
    縣市: '嘉義縣'
  },
  {
    店號: 179850,
    店名: '水牛厝',
    地址: '嘉義縣太保市中山路一段210號',
    縣市: '嘉義縣'
  },
  {
    店號: 180610,
    店名: '奉天宮',
    地址: '嘉義縣新港鄉中山路33號.35號',
    縣市: '嘉義縣'
  },
  {
    店號: 180805,
    店名: '錚大',
    地址: '嘉義縣民雄鄉文隆村11鄰鴨母?85號',
    縣市: '嘉義縣'
  },
  {
    店號: 182498,
    店名: '朴子橋',
    地址: '嘉義縣六腳鄉正義村大橋頭190-2號',
    縣市: '嘉義縣'
  },
  {
    店號: 182731,
    店名: '合泰',
    地址: '嘉義縣大林鎮大美里19鄰大智一街1號',
    縣市: '嘉義縣'
  },
  {
    店號: 183446,
    店名: '北雄',
    地址: '嘉義縣水上鄉粗溪村中山路二段381號',
    縣市: '嘉義縣'
  },
  {
    店號: 183664,
    店名: '布龍',
    地址: '嘉義縣布袋鎮龍江路1號1樓',
    縣市: '嘉義縣'
  },
  {
    店號: 185763,
    店名: '嘉太',
    地址: '嘉義縣太保市北港路二段190號',
    縣市: '嘉義縣'
  },
  {
    店號: 192989,
    店名: '雲梯',
    地址: '嘉義縣梅山鄉太平村下坑仔5.6.7號',
    縣市: '嘉義縣'
  },
  {
    店號: 193889,
    店名: '柳子林',
    地址: '嘉義縣水上鄉柳林村柳子林50-98號1樓',
    縣市: '嘉義縣'
  },
  {
    店號: 194952,
    店名: '源山',
    地址: '嘉義縣中埔鄉同仁村同仁1-20號1樓',
    縣市: '嘉義縣'
  },
  {
    店號: 196213,
    店名: '江宸',
    地址: '嘉義縣民雄鄉興中村江厝店1之32號1樓',
    縣市: '嘉義縣'
  },
  {
    店號: 208657,
    店名: '埔暉',
    地址: '嘉義縣中埔鄉和美村中山路五段450號',
    縣市: '嘉義縣'
  },
  {
    店號: 209292,
    店名: '民真',
    地址: '嘉義縣民雄鄉民新路188號',
    縣市: '嘉義縣'
  },
  {
    店號: 209454,
    店名: '溫莎',
    地址: '嘉義縣民雄鄉神農路129之10號',
    縣市: '嘉義縣'
  },
  {
    店號: 209650,
    店名: '寬士村',
    地址: '嘉義縣水上鄉寬士村崎子頭29-35號',
    縣市: '嘉義縣'
  },
  {
    店號: 210096,
    店名: '栗子崙',
    地址: '嘉義縣東石鄉西崙村栗子崙191.193號',
    縣市: '嘉義縣'
  },
  {
    店號: 210203,
    店名: '故宮',
    地址: '嘉義縣太保市東勢里故宮大道779號1樓',
    縣市: '嘉義縣'
  },
  {
    店號: 211273,
    店名: '民雄',
    地址: '嘉義縣民雄鄉民權路42-20號1樓',
    縣市: '嘉義縣'
  },
  {
    店號: 211619,
    店名: '麻太',
    地址: '嘉義縣太保市過溝里6鄰過溝52-14號',
    縣市: '嘉義縣'
  },
  {
    店號: 211697,
    店名: '朴子',
    地址: '嘉義縣朴子市中興路139號',
    縣市: '嘉義縣'
  },
  {
    店號: 213671,
    店名: '北回',
    地址: '嘉義縣水上鄉回歸村中山路三段167號',
    縣市: '嘉義縣'
  },
  {
    店號: 229469,
    店名: '錚多',
    地址: '嘉義縣民雄鄉鎮北村建國路一段1020-2853號',
    縣市: '嘉義縣'
  },
  {
    店號: 229791,
    店名: '秀宸',
    地址: '嘉義縣民雄鄉秀林村1鄰東義6之12號1樓',
    縣市: '嘉義縣'
  },
  {
    店號: 229883,
    店名: '嘉朴',
    地址: '嘉義縣朴子市大鄉里大慷榔253-23號',
    縣市: '嘉義縣'
  },
  {
    店號: 230540,
    店名: '隆興',
    地址: '嘉義縣中埔鄉隆興村汴頭1-80號',
    縣市: '嘉義縣'
  },
  {
    店號: 233549,
    店名: '朴站',
    地址: '嘉義縣朴子市平和路11-1號1樓',
    縣市: '嘉義縣'
  },
  {
    店號: 236870,
    店名: '長朴',
    地址: '嘉義縣朴子市仁和里嘉朴路西段6-7號1樓',
    縣市: '嘉義縣'
  },
  {
    店號: 239042,
    店名: '番路',
    地址: '嘉義縣番路鄉下坑村菜公店92號',
    縣市: '嘉義縣'
  },
  {
    店號: 239053,
    店名: '巃頭',
    地址: '嘉義縣番路鄉公田村龍頭18號',
    縣市: '嘉義縣'
  },
  {
    店號: 240961,
    店名: '中正大',
    地址: '嘉義縣民雄鄉三興村大學路一段421號',
    縣市: '嘉義縣'
  },
  {
    店號: 249898,
    店名: '翁聚德',
    地址: '嘉義縣中埔鄉和睦村司公部4-20號1樓',
    縣市: '嘉義縣'
  },
  {
    店號: 250005,
    店名: '真美',
    地址: '嘉義縣梅山鄉梅北村006鄰新興路279號',
    縣市: '嘉義縣'
  },
  {
    店號: 841001,
    店名: '中埔',
    地址: '嘉義縣中埔鄉和美村中山路五段856號',
    縣市: '嘉義縣'
  },
  {
    店號: 863757,
    店名: '配天',
    地址: '嘉義縣朴子市大同路212號',
    縣市: '嘉義縣'
  },
  {
    店號: 871345,
    店名: '英巧',
    地址: '嘉義縣民雄鄉西安村西安路37號.39號1樓',
    縣市: '嘉義縣'
  },
  {
    店號: 871725,
    店名: '水上',
    地址: '嘉義縣水上鄉中興路378號380號',
    縣市: '嘉義縣'
  },
  {
    店號: 882138,
    店名: '興南',
    地址: '嘉義縣民雄鄉興南村15鄰頭橋557之45',
    縣市: '嘉義縣'
  },
  {
    店號: 896713,
    店名: '民城',
    地址: '嘉義縣民雄鄉東榮村四鄰建國路一段134號',
    縣市: '嘉義縣'
  },
  {
    店號: 900119,
    店名: '過溝',
    地址: '嘉義縣布袋鎮中安里19鄰11號',
    縣市: '嘉義縣'
  },
  {
    店號: 902230,
    店名: '中洋子',
    地址: '嘉義縣新港鄉中洋村後厝子1-33號',
    縣市: '嘉義縣'
  },
  {
    店號: 910828,
    店名: '中庄',
    地址: '嘉義縣水上鄉中庄村69號',
    縣市: '嘉義縣'
  },
  {
    店號: 912798,
    店名: '嘉禎',
    地址: '嘉義縣新港鄉菜公村7鄰菜公厝64號附6',
    縣市: '嘉義縣'
  },
  {
    店號: 921242,
    店名: '嘉港',
    地址: '嘉義縣新港鄉福德路116號116-1號',
    縣市: '嘉義縣'
  },
  {
    店號: 930497,
    店名: '合豐',
    地址: '嘉義縣中埔鄉中埔村169號1樓',
    縣市: '嘉義縣'
  },
  {
    店號: 940324,
    店名: '民工',
    地址: '嘉義縣民雄鄉北斗村北勢子73-55號1樓',
    縣市: '嘉義縣'
  },
  {
    店號: 941224,
    店名: '布新',
    地址: '嘉義縣布袋鎮中正路63號',
    縣市: '嘉義縣'
  },
  {
    店號: 942227,
    店名: '梅林',
    地址: '嘉義縣大林鎮忠孝路713號715號1樓',
    縣市: '嘉義縣'
  },
  {
    店號: 942618,
    店名: '妙禎',
    地址: '嘉義縣大林鎮中坑里南華路一段55號B1(南華大學學慧樓)',
    縣市: '嘉義縣'
  },
  {
    店號: 944005,
    店名: '祥壹',
    地址: '嘉義縣太保市祥和一路東段29號',
    縣市: '嘉義縣'
  },
  {
    店號: 944016,
    店名: '奮起湖',
    地址: '嘉義縣竹崎鄉中和村12鄰奮起湖178-1號',
    縣市: '嘉義縣'
  },
  {
    店號: 944382,
    店名: '嘉崎',
    地址: '嘉義縣竹崎鄉中山路111號',
    縣市: '嘉義縣'
  },
  {
    店號: 950686,
    店名: '東石',
    地址: '嘉義縣東石鄉永屯村35附18號',
    縣市: '嘉義縣'
  },
  {
    店號: 950952,
    店名: '六腳',
    地址: '嘉義縣六腳鄉蘇厝村蘇厝寮153-6號',
    縣市: '嘉義縣'
  },
  {
    店號: 951265,
    店名: '保祥',
    地址: '嘉義縣太保市祥和三路東段226號',
    縣市: '嘉義縣'
  },
  {
    店號: 952394,
    店名: '上龍',
    地址: '嘉義縣水上鄉龍德村十一指厝75-90號',
    縣市: '嘉義縣'
  },
  {
    店號: 952590,
    店名: '溪旺',
    地址: '嘉義縣溪口鄉溪西村中正路8鄰229-1號',
    縣市: '嘉義縣'
  },
  {
    店號: 953847,
    店名: '保新',
    地址: '嘉義縣太保市舊埤里1鄰新埤5-16號',
    縣市: '嘉義縣'
  },
  {
    店號: 967020,
    店名: '新塭',
    地址: '嘉義縣布袋鎮復興里12鄰新塭147-3號',
    縣市: '嘉義縣'
  },
  {
    店號: 967260,
    店名: '大埔美',
    地址: '嘉義縣大林鎮過溪里過溪1號',
    縣市: '嘉義縣'
  },
  {
    店號: 968311,
    店名: '雲海',
    地址: '嘉義縣中埔鄉隆興村十字路233號',
    縣市: '嘉義縣'
  },
  {
    店號: 970509,
    店名: '嘉大',
    地址: '嘉義縣民雄鄉文隆村鴨母水土1-92號',
    縣市: '嘉義縣'
  },
  {
    店號: 970657,
    店名: '大木康',
    地址: '嘉義縣朴子市大鄉里1鄰大(木康)榔179之4號',
    縣市: '嘉義縣'
  },
  {
    店號: 970679,
    店名: '朴中',
    地址: '嘉義縣朴子市博厚里開元路282號',
    縣市: '嘉義縣'
  },
  {
    店號: 972103,
    店名: '倖福',
    地址: '嘉義縣民雄鄉大崎村十四甲17-10號1樓',
    縣市: '嘉義縣'
  },
  {
    店號: 972620,
    店名: '新竹崎',
    地址: '嘉義縣竹崎鄉和平村田寮段98號',
    縣市: '嘉義縣'
  },
  {
    店號: 972701,
    店名: '新冠林',
    地址: '嘉義縣大林鎮新興街113號',
    縣市: '嘉義縣'
  },
  {
    店號: 980908,
    店名: '嘉保',
    地址: '嘉義縣太保市麻寮里北港路二段511號',
    縣市: '嘉義縣'
  },
  {
    店號: 982188,
    店名: '新兆軒',
    地址: '嘉義縣水上鄉民生村忠孝街149號151號',
    縣市: '嘉義縣'
  },
  {
    店號: 990488,
    店名: '大林',
    地址: '嘉義縣大林鎮西林里仁愛路23號25號27號1樓',
    縣市: '嘉義縣'
  },
  {
    店號: 990983,
    店名: '嘉庚',
    地址: '嘉義縣朴子市仁和里嘉朴路西段8號',
    縣市: '嘉義縣'
  },
  {
    店號: 991997,
    店名: '梅鄉',
    地址: '嘉義縣梅山鄉梅南村中山路125號1樓',
    縣市: '嘉義縣'
  },
  {
    店號: 992141,
    店名: '鹿草',
    地址: '嘉義縣鹿草鄉西井村20鄰鹿草路215、217號1樓',
    縣市: '嘉義縣'
  },
  {
    店號: 997733,
    店名: '慈苑',
    地址: '嘉義縣大林鎮平林里6鄰下潭底23-5號',
    縣市: '嘉義縣'
  },
  {
    店號: 110426,
    店名: '資砡',
    地址: '嘉義市西區港坪里玉山路422號',
    縣市: '嘉義市'
  },
  {
    店號: 111500,
    店名: '嘉府',
    地址: '嘉義市東區民權路194號196號198號',
    縣市: '嘉義市'
  },
  {
    店號: 112503,
    店名: '嘉雅',
    地址: '嘉義市東區大雅路二段421號1樓',
    縣市: '嘉義市'
  },
  {
    店號: 116262,
    店名: '精城',
    地址: '嘉義市東區圳頭里林森東路720號',
    縣市: '嘉義市'
  },
  {
    店號: 130154,
    店名: '東嘉院',
    地址: '嘉義市東區忠孝路642號(嘉義基督教醫院門診大樓內)',
    縣市: '嘉義市'
  },
  {
    店號: 131560,
    店名: '八大',
    地址: '嘉義市西區保福里八德路237號',
    縣市: '嘉義市'
  },
  {
    店號: 137786,
    店名: '嘉德',
    地址: '嘉義市西區八德路73號',
    縣市: '嘉義市'
  },
  {
    店號: 137797,
    店名: '新嘉醫',
    地址: '嘉義市西區福全里北港路309號',
    縣市: '嘉義市'
  },
  {
    店號: 141501,
    店名: '香湖',
    地址: '嘉義市西區香湖里文化路8鄰700號',
    縣市: '嘉義市'
  },
  {
    店號: 141512,
    店名: '北社尾',
    地址: '嘉義市西區北湖里北社尾路165號附1',
    縣市: '嘉義市'
  },
  {
    店號: 144201,
    店名: '秋園',
    地址: '嘉義市西區新民路681號',
    縣市: '嘉義市'
  },
  {
    店號: 149826,
    店名: '新嘉商',
    地址: '嘉義市東區民權路72號1樓',
    縣市: '嘉義市'
  },
  {
    店號: 151461,
    店名: '鈺順',
    地址: '嘉義市西區新榮路35巷20號1樓',
    縣市: '嘉義市'
  },
  {
    店號: 165482,
    店名: '嘉坪',
    地址: '嘉義市西區大同路455號1樓',
    縣市: '嘉義市'
  },
  {
    店號: 166500,
    店名: '秀泰',
    地址: '嘉義市西區國華里文化路293號1樓及2樓',
    縣市: '嘉義市'
  },
  {
    店號: 171188,
    店名: '新車店',
    地址: '嘉義市西區福民里南京路462號1樓',
    縣市: '嘉義市'
  },
  {
    店號: 180023,
    店名: '嘉林',
    地址: '嘉義市東區林森東路950號',
    縣市: '嘉義市'
  },
  {
    店號: 180780,
    店名: '嘉義大',
    地址: '嘉義市東區學府路300號1樓',
    縣市: '嘉義市'
  },
  {
    店號: 180791,
    店名: '嘉潭',
    地址: '嘉義市東區學府路300號1樓',
    縣市: '嘉義市'
  },
  {
    店號: 182742,
    店名: '安捷',
    地址: '嘉義市西區保安里保安一路301.303號1樓',
    縣市: '嘉義市'
  },
  {
    店號: 182926,
    店名: '湖康',
    地址: '嘉義市西區湖內里湖子內路195號1樓',
    縣市: '嘉義市'
  },
  {
    店號: 184885,
    店名: '新瑞鴻',
    地址: '嘉義市西區文化里民族路456號458號1樓',
    縣市: '嘉義市'
  },
  {
    店號: 185453,
    店名: '嘉上',
    地址: '嘉義市西區車店里上海路147號1樓',
    縣市: '嘉義市'
  },
  {
    店號: 187965,
    店名: '立宣',
    地址: '嘉義市東區立仁路120號',
    縣市: '嘉義市'
  },
  {
    店號: 192750,
    店名: '湖興',
    地址: '嘉義市東區興安里24鄰興美六路368號1樓',
    縣市: '嘉義市'
  },
  {
    店號: 195128,
    店名: '大統',
    地址: '嘉義市西區西平里博愛路二段696號1樓',
    縣市: '嘉義市'
  },
  {
    店號: 195531,
    店名: '嘉驛',
    地址: '嘉義市西區書院里中山路534號1樓',
    縣市: '嘉義市'
  },
  {
    店號: 196202,
    店名: '國華',
    地址: '嘉義市西區國華里國華街283號1樓.2樓',
    縣市: '嘉義市'
  },
  {
    店號: 199935,
    店名: '桃城',
    地址: '嘉義市西區北興街456號',
    縣市: '嘉義市'
  },
  {
    店號: 206639,
    店名: '富砡',
    地址: '嘉義市西區劉厝路221-1號、223號1樓',
    縣市: '嘉義市'
  },
  {
    店號: 206732,
    店名: '新嘉友',
    地址: '嘉義市西區福全里友愛路222.222-1號',
    縣市: '嘉義市'
  },
  {
    店號: 209915,
    店名: '嘉愛',
    地址: '嘉義市西區仁愛路212號',
    縣市: '嘉義市'
  },
  {
    店號: 211240,
    店名: '四圍',
    地址: '嘉義市西區福安里竹圍路190號',
    縣市: '嘉義市'
  },
  {
    店號: 217411,
    店名: '嘉北',
    地址: '嘉義市西區保安里興達路331號',
    縣市: '嘉義市'
  },
  {
    店號: 232801,
    店名: '臻暉',
    地址: '嘉義市東區民族路101號',
    縣市: '嘉義市'
  },
  {
    店號: 236881,
    店名: '回家',
    地址: '嘉義市西區中山路518號及林森西路580號',
    縣市: '嘉義市'
  },
  {
    店號: 238441,
    店名: '嘉西',
    地址: '嘉義市西區大溪里北港路13鄰597號',
    縣市: '嘉義市'
  },
  {
    店號: 249049,
    店名: '軍暉',
    地址: '嘉義市東區軍輝路60號',
    縣市: '嘉義市'
  },
  {
    店號: 249326,
    店名: '義東',
    地址: '嘉義市東區東義路85號',
    縣市: '嘉義市'
  },
  {
    店號: 250027,
    店名: '嘉榮',
    地址: '嘉義市西區自強街34,36號1樓',
    縣市: '嘉義市'
  },
  {
    店號: 250555,
    店名: '元福',
    地址: '嘉義市東區王田里林森東路288號',
    縣市: '嘉義市'
  },
  {
    店號: 250692,
    店名: '新嘉勝',
    地址: '嘉義市西區博愛路一段419、421號及北興街148號150號152號',
    縣市: '嘉義市'
  },
  {
    店號: 254535,
    店名: '嘉和',
    地址: '嘉義市東區中山路169號171號173號',
    縣市: '嘉義市'
  },
  {
    店號: 844882,
    店名: '彌陀',
    地址: '嘉義市東區芳安路1號1F',
    縣市: '嘉義市'
  },
  {
    店號: 854498,
    店名: '台林',
    地址: '嘉義市東區新生路723號',
    縣市: '嘉義市'
  },
  {
    店號: 874355,
    店名: '垂楊',
    地址: '嘉義市西區垂楊里仁愛路315號',
    縣市: '嘉義市'
  },
  {
    店號: 880154,
    店名: '嘉洋',
    地址: '嘉義市西區民生南路600號',
    縣市: '嘉義市'
  },
  {
    店號: 888136,
    店名: '嘉華',
    地址: '嘉義市西區仁愛路415號417號',
    縣市: '嘉義市'
  },
  {
    店號: 909323,
    店名: '嘉工',
    地址: '嘉義市東區彌陀路240號',
    縣市: '嘉義市'
  },
  {
    店號: 912639,
    店名: '嘉達',
    地址: '嘉義市西區保安里四維路18鄰302號',
    縣市: '嘉義市'
  },
  {
    店號: 914174,
    店名: '蘭潭',
    地址: '嘉義市東區大雅路二段573號575號',
    縣市: '嘉義市'
  },
  {
    店號: 923020,
    店名: '嘉賓',
    地址: '嘉義市西區新西里垂楊路611號',
    縣市: '嘉義市'
  },
  {
    店號: 932895,
    店名: '湖子內',
    地址: '嘉義市西區湖內里南京路124號',
    縣市: '嘉義市'
  },
  {
    店號: 941095,
    店名: '保愛',
    地址: '嘉義市西區新厝里捌鄰友愛路711號',
    縣市: '嘉義市'
  },
  {
    店號: 947679,
    店名: '嘉高',
    地址: '嘉義市西區北港路1062號',
    縣市: '嘉義市'
  },
  {
    店號: 951070,
    店名: '新嘉基',
    地址: '嘉義市東區頂庄里忠孝路650號(嘉義基督教醫院門診大樓外)',
    縣市: '嘉義市'
  },
  {
    店號: 951601,
    店名: '嘉文',
    地址: '嘉義市東區盧厝里文雅街211號',
    縣市: '嘉義市'
  },
  {
    店號: 967318,
    店名: '博元',
    地址: '嘉義市西區博愛路二段572號',
    縣市: '嘉義市'
  },
  {
    店號: 971580,
    店名: '新大業',
    地址: '嘉義市東區安寮里24鄰吳鳳南路194號',
    縣市: '嘉義市'
  },
  {
    店號: 972125,
    店名: '嘉英',
    地址: '嘉義市東區荖藤里忠孝北街206號',
    縣市: '嘉義市'
  },
  {
    店號: 980034,
    店名: '嘉永',
    地址: '嘉義市西區育英里民生南路129號131號1樓',
    縣市: '嘉義市'
  },
  {
    店號: 981107,
    店名: '新港坪',
    地址: '嘉義市西區玉山路203號',
    縣市: '嘉義市'
  },
  {
    店號: 981624,
    店名: '新嘉院',
    地址: '嘉義市東區忠孝路539號1樓(嘉義基督教醫院住院大樓內)',
    縣市: '嘉義市'
  },
  {
    店號: 982454,
    店名: '新嘉家',
    地址: '嘉義市東區宣信里和平路103號1樓',
    縣市: '嘉義市'
  },
  {
    店號: 990248,
    店名: '旭豐',
    地址: '嘉義市東區溪興街107號109號1樓',
    縣市: '嘉義市'
  },
  {
    店號: 992819,
    店名: '圓環',
    地址: '嘉義市西區北杏里文化路155之2號1樓',
    縣市: '嘉義市'
  },
  {
    店號: 993834,
    店名: '光彩',
    地址: '嘉義市西區民生北路182號184號1樓',
    縣市: '嘉義市'
  },
  {
    店號: 111153,
    店名: '大埕',
    地址: '台南市七股區大珵里272號1樓',
    縣市: '台南市'
  },
  {
    店號: 111809,
    店名: '榮譽',
    地址: '台南市東區榮譽街86號86-1號1樓',
    縣市: '台南市'
  },
  {
    店號: 111821,
    店名: '新國',
    地址: '台南市新營區大宏里民治東路1號1樓2樓',
    縣市: '台南市'
  },
  {
    店號: 112075,
    店名: '財神',
    地址: '台南市東區中華東路二段171-177號',
    縣市: '台南市'
  },
  {
    店號: 112422,
    店名: '晶圓',
    地址: '台南市善化區南科北路1-1號(P3廠)',
    縣市: '台南市'
  },
  {
    店號: 112525,
    店名: '新北中',
    地址: '台南市佳里區延平路195號',
    縣市: '台南市'
  },
  {
    店號: 113126,
    店名: '山上',
    地址: '台南市山上區南洲337-3號',
    縣市: '台南市'
  },
  {
    店號: 113193,
    店名: '崇祐',
    地址: '台南市東區崇成里崇明路561號1樓',
    縣市: '台南市'
  },
  {
    店號: 113931,
    店名: '新北',
    地址: '台南市新營區民治路228號1樓',
    縣市: '台南市'
  },
  {
    店號: 114222,
    店名: '南都',
    地址: '台南市南區金華路一段27號1樓',
    縣市: '台南市'
  },
  {
    店號: 114532,
    店名: '白河',
    地址: '台南市白河區永安里17鄰國泰路101號',
    縣市: '台南市'
  },
  {
    店號: 114705,
    店名: '鹽生',
    地址: '台南市鹽水區南門路1號',
    縣市: '台南市'
  },
  {
    店號: 116181,
    店名: '灣中',
    地址: '台南市永康區大灣路62號',
    縣市: '台南市'
  },
  {
    店號: 116620,
    店名: '歡雅',
    地址: '台南市鹽水區歡雅里26號',
    縣市: '台南市'
  },
  {
    店號: 116734,
    店名: '鄭子寮',
    地址: '台南市北區成德里38鄰北成路442號',
    縣市: '台南市'
  },
  {
    店號: 116826,
    店名: '太子宮',
    地址: '台南市新營區太北里太子宮142-34號',
    縣市: '台南市'
  },
  {
    店號: 117520,
    店名: '東都',
    地址: '台南市北區成功路140號',
    縣市: '台南市'
  },
  {
    店號: 118338,
    店名: '豐生',
    地址: '台南市歸仁區看東里中山路一段301號',
    縣市: '台南市'
  },
  {
    店號: 118660,
    店名: '東城',
    地址: '台南市東區中華東路二段293號',
    縣市: '台南市'
  },
  {
    店號: 119696,
    店名: '湖華',
    地址: '台南市中西區西湖街3號',
    縣市: '台南市'
  },
  {
    店號: 120087,
    店名: '新麻豆',
    地址: '台南市麻豆區榖興里11鄰中山路11號',
    縣市: '台南市'
  },
  {
    店號: 120386,
    店名: '東森',
    地址: '台南市北區林森路三段76號78號',
    縣市: '台南市'
  },
  {
    店號: 120397,
    店名: '佳龍',
    地址: '台南市佳里區建南里勝利路216號1樓',
    縣市: '台南市'
  },
  {
    店號: 121035,
    店名: '安北',
    地址: '台南市安南區安中路一段546號552號',
    縣市: '台南市'
  },
  {
    店號: 121172,
    店名: '新工',
    地址: '台南市柳營區東昇里中山西路一段2號1樓',
    縣市: '台南市'
  },
  {
    店號: 121688,
    店名: '西勢',
    地址: '台南市永康區西勢里富強路一段304號',
    縣市: '台南市'
  },
  {
    店號: 121769,
    店名: '永一',
    地址: '台南市永康區正強街221號1樓',
    縣市: '台南市'
  },
  {
    店號: 122131,
    店名: '佳文',
    地址: '台南市佳里區佳西路215號1樓',
    縣市: '台南市'
  },
  {
    店號: 122500,
    店名: '昜昇',
    地址: '台南市安平區安北路12-1號1樓',
    縣市: '台南市'
  },
  {
    店號: 122588,
    店名: '新蓮鄉',
    地址: '台南市白河區永安里大德街150號1樓',
    縣市: '台南市'
  },
  {
    店號: 123112,
    店名: '北育',
    地址: '台南市北區成德里北安路一段189號',
    縣市: '台南市'
  },
  {
    店號: 123156,
    店名: '水仙宮',
    地址: '台南市中西區水仙里民權路三段87號1樓',
    縣市: '台南市'
  },
  {
    店號: 124676,
    店名: '崇原',
    地址: '台南市東山區東原里24鄰前大埔191號1樓',
    縣市: '台南市'
  },
  {
    店號: 126993,
    店名: '善安',
    地址: '台南市安定區蘇林里7號',
    縣市: '台南市'
  },
  {
    店號: 127022,
    店名: '天公',
    地址: '台南市中西區忠義路二段109號',
    縣市: '台南市'
  },
  {
    店號: 129213,
    店名: '南醫',
    地址: '台南市中西區民族路二段76號之13',
    縣市: '台南市'
  },
  {
    店號: 130110,
    店名: '林鳳營',
    地址: '台南市六甲區中社里林鳳營111-8號1樓',
    縣市: '台南市'
  },
  {
    店號: 130280,
    店名: '和善',
    地址: '台南市中西區藥王里民族路三段6鄰277號1樓',
    縣市: '台南市'
  },
  {
    店號: 130626,
    店名: '社頂',
    地址: '台南市新市區大社里大社710號1樓',
    縣市: '台南市'
  },
  {
    店號: 130671,
    店名: '鈺勝',
    地址: '台南市北區小東路307巷75號77號1樓',
    縣市: '台南市'
  },
  {
    店號: 130970,
    店名: '裕文',
    地址: '台南市東區裕學路1號',
    縣市: '台南市'
  },
  {
    店號: 130992,
    店名: '知母義',
    地址: '台南市新化區知義里知母義15號之20一樓',
    縣市: '台南市'
  },
  {
    店號: 131113,
    店名: '東橋',
    地址: '台南市永康區東橋一路28號',
    縣市: '台南市'
  },
  {
    店號: 131423,
    店名: '土定富',
    地址: '台南市南區田寮里大成路二段86號88號',
    縣市: '台南市'
  },
  {
    店號: 131630,
    店名: '永科',
    地址: '台南市永康區新樹里3鄰中山北路634巷7號',
    縣市: '台南市'
  },
  {
    店號: 132253,
    店名: '樂豐',
    地址: '台南市南區新都路460號',
    縣市: '台南市'
  },
  {
    店號: 132390,
    店名: '新家專',
    地址: '台南市永康區鹽行里中正路12鄰545號1樓',
    縣市: '台南市'
  },
  {
    店號: 132482,
    店名: '七甲',
    地址: '台南市六甲區六甲里中正路321之1號',
    縣市: '台南市'
  },
  {
    店號: 132596,
    店名: '將軍',
    地址: '台南市將軍區長榮里長榮29之2號',
    縣市: '台南市'
  },
  {
    店號: 132644,
    店名: '群創C',
    地址: '台南市善化區南科八路12號B1',
    縣市: '台南市'
  },
  {
    店號: 132688,
    店名: '奇美實',
    地址: '台南市仁德區三甲里59-1號',
    縣市: '台南市'
  },
  {
    店號: 132862,
    店名: '菁寮',
    地址: '台南市後壁區墨林里346號',
    縣市: '台南市'
  },
  {
    店號: 132910,
    店名: '成醫',
    地址: '台南市北區小東路35號(成大醫院門診一樓)',
    縣市: '台南市'
  },
  {
    店號: 133016,
    店名: '新P5',
    地址: '台南市善化區南科九路17號(P5P6廠O棟)',
    縣市: '台南市'
  },
  {
    店號: 136015,
    店名: '正新',
    地址: '台南市永康區甲頂里大武街33號',
    縣市: '台南市'
  },
  {
    店號: 136598,
    店名: '南門城',
    地址: '台南市中西區南門路229號1樓',
    縣市: '台南市'
  },
  {
    店號: 136978,
    店名: '善文',
    地址: '台南市善化區中山路518號',
    縣市: '台南市'
  },
  {
    店號: 137122,
    店名: '育德',
    地址: '台南市北區民德路87號',
    縣市: '台南市'
  },
  {
    店號: 137801,
    店名: '南德',
    地址: '台南市南區中華南路二段101之1號',
    縣市: '台南市'
  },
  {
    店號: 138022,
    店名: '南科大',
    地址: '台南市永康區中正路529號',
    縣市: '台南市'
  },
  {
    店號: 138066,
    店名: '文五',
    地址: '台南市安平區國平里文平路217號',
    縣市: '台南市'
  },
  {
    店號: 138251,
    店名: '淵中',
    地址: '台南市安南區安中路三段435號437號',
    縣市: '台南市'
  },
  {
    店號: 138387,
    店名: '華園',
    地址: '台南市北區北門里公園南路71號',
    縣市: '台南市'
  },
  {
    店號: 138675,
    店名: '後營',
    地址: '台南市西港區營西里1號',
    縣市: '台南市'
  },
  {
    店號: 139335,
    店名: '大五',
    地址: '台南市中西區法華里大同路一段218號220號',
    縣市: '台南市'
  },
  {
    店號: 140519,
    店名: '安平',
    地址: '台南市安平區安平路99號',
    縣市: '台南市'
  },
  {
    店號: 141578,
    店名: '高大',
    地址: '台南市新市區銘傳街87號89號1樓',
    縣市: '台南市'
  },
  {
    店號: 141800,
    店名: '大忠',
    地址: '台南市南區大忠里中華南路一段178號',
    縣市: '台南市'
  },
  {
    店號: 141914,
    店名: '蔦松',
    地址: '台南市永康區中正北路431號433號',
    縣市: '台南市'
  },
  {
    店號: 142308,
    店名: '康永',
    地址: '台南市永康區永康里永平街120號',
    縣市: '台南市'
  },
  {
    店號: 142537,
    店名: '新圓',
    地址: '台南市新營區忠政里中正路2鄰121號',
    縣市: '台南市'
  },
  {
    店號: 143079,
    店名: '瀚宇',
    地址: '台南市新市區南科二路35號1樓',
    縣市: '台南市'
  },
  {
    店號: 143231,
    店名: '新樹人',
    地址: '台南市善化區光文里中山路143-2號',
    縣市: '台南市'
  },
  {
    店號: 143312,
    店名: '永龍',
    地址: '台南市永康區埔園里中山路398號',
    縣市: '台南市'
  },
  {
    店號: 143389,
    店名: '期建',
    地址: '台南市安平區文平里建平路277號',
    縣市: '台南市'
  },
  {
    店號: 143840,
    店名: '大潭',
    地址: '台南市歸仁區大潭里長榮路一段320巷11號',
    縣市: '台南市'
  },
  {
    店號: 143851,
    店名: '子龍',
    地址: '台南市佳里區子龍里1鄰子良廟3-1號',
    縣市: '台南市'
  },
  {
    店號: 143862,
    店名: '南龍',
    地址: '台南市佳里區建南里安南路22鄰256號',
    縣市: '台南市'
  },
  {
    店號: 143884,
    店名: '臻鈺',
    地址: '台南市永康區勝利里18鄰勝學路226號',
    縣市: '台南市'
  },
  {
    店號: 144131,
    店名: '五王',
    地址: '台南市永康區中華二路146號1樓',
    縣市: '台南市'
  },
  {
    店號: 144197,
    店名: '安興',
    地址: '台南市永康區北灣里20鄰北興路51號',
    縣市: '台南市'
  },
  {
    店號: 144979,
    店名: '東澓',
    地址: '台南市東區富農街一段167號1樓',
    縣市: '台南市'
  },
  {
    店號: 144980,
    店名: '自由',
    地址: '台南市東區和平里自由路二段37號',
    縣市: '台南市'
  },
  {
    店號: 146252,
    店名: '南瀛',
    地址: '台南市永康區鹽行里中正路299號',
    縣市: '台南市'
  },
  {
    店號: 146953,
    店名: '新海佃',
    地址: '台南市安南區海佃路一段239號一樓',
    縣市: '台南市'
  },
  {
    店號: 147266,
    店名: '清美',
    地址: '台南市新化區協興里中山路624號626號1樓',
    縣市: '台南市'
  },
  {
    店號: 148487,
    店名: '新東灣',
    地址: '台南市永康區民族路186號188號1樓',
    縣市: '台南市'
  },
  {
    店號: 149044,
    店名: '華東',
    地址: '台南市永康區中華路472號',
    縣市: '台南市'
  },
  {
    店號: 149550,
    店名: '永華東',
    地址: '台南市安平區永華路二段210號',
    縣市: '台南市'
  },
  {
    店號: 150848,
    店名: '鹽金',
    地址: '台南市鹽水區義稠里8鄰義稠110之19號',
    縣市: '台南市'
  },
  {
    店號: 150882,
    店名: '全興',
    地址: '台南市南區新樂路72號',
    縣市: '台南市'
  },
  {
    店號: 150985,
    店名: '茄拔',
    地址: '台南市善化區嘉北里13鄰352號',
    縣市: '台南市'
  },
  {
    店號: 151243,
    店名: '安傑',
    地址: '台南市安南區頂安里北安路二段480號1樓',
    縣市: '台南市'
  },
  {
    店號: 151357,
    店名: '德航',
    地址: '台南市仁德區大同路三段202號',
    縣市: '台南市'
  },
  {
    店號: 151494,
    店名: '臻品',
    地址: '台南市永康區三合里中山東路117號119號1樓',
    縣市: '台南市'
  },
  {
    店號: 151597,
    店名: '長益',
    地址: '台南市仁德區土庫里太子路233號',
    縣市: '台南市'
  },
  {
    店號: 151977,
    店名: '大營',
    地址: '台南市新市區大營里136-1號',
    縣市: '台南市'
  },
  {
    店號: 153744,
    店名: '學甲',
    地址: '台南市學甲區仁得里華宗路321號',
    縣市: '台南市'
  },
  {
    店號: 153755,
    店名: 'P7廠',
    地址: '台南市善化區南關里三抱竹路1號',
    縣市: '台南市'
  },
  {
    店號: 153777,
    店名: '永玉',
    地址: '台南市永康區龍潭里永明街175號',
    縣市: '台南市'
  },
  {
    店號: 153803,
    店名: '省新',
    地址: '台南市新市區永就里9鄰中山路180號1樓',
    縣市: '台南市'
  },
  {
    店號: 153939,
    店名: '宜翔',
    地址: '台南市柳營區中埕里中山西路二段10鄰61號',
    縣市: '台南市'
  },
  {
    店號: 153940,
    店名: '邦品廠',
    地址: '台南市善化區環西路二段3號',
    縣市: '台南市'
  },
  {
    店號: 153973,
    店名: '修齊',
    地址: '台南市北區成功路54號',
    縣市: '台南市'
  },
  {
    店號: 154998,
    店名: '白金',
    地址: '台南市永康區復國一路357號',
    縣市: '台南市'
  },
  {
    店號: 155119,
    店名: '大通',
    地址: '台南市歸仁區和平北街32號',
    縣市: '台南市'
  },
  {
    店號: 155164,
    店名: '復康',
    地址: '台南市永康區二王里忠孝路429巷15弄6號',
    縣市: '台南市'
  },
  {
    店號: 155234,
    店名: '總頭寮',
    地址: '台南市安南區長溪路二段416號',
    縣市: '台南市'
  },
  {
    店號: 158820,
    店名: '西濱',
    地址: '台南市南區中華南路二段317號319號',
    縣市: '台南市'
  },
  {
    店號: 159133,
    店名: '晶越',
    地址: '台南市中西區西門路一段658號B2',
    縣市: '台南市'
  },
  {
    店號: 160052,
    店名: '加吉吉',
    地址: '台南市安南區新順里培安路155號',
    縣市: '台南市'
  },
  {
    店號: 160351,
    店名: '康平',
    地址: '台南市安平區健康三街81號',
    縣市: '台南市'
  },
  {
    店號: 162014,
    店名: '新康華',
    地址: '台南市永康區大橋二街38號',
    縣市: '台南市'
  },
  {
    店號: 163785,
    店名: '和緯',
    地址: '台南市北區成功里和緯路二段252號',
    縣市: '台南市'
  },
  {
    店號: 163969,
    店名: '郡王',
    地址: '台南市中西區府前路一段144號',
    縣市: '台南市'
  },
  {
    店號: 164489,
    店名: '學成',
    地址: '台南市學甲區慈生里中正路296號',
    縣市: '台南市'
  },
  {
    店號: 164700,
    店名: '信雄',
    地址: '台南市永康區南台街1號',
    縣市: '台南市'
  },
  {
    店號: 164766,
    店名: '忠勇',
    地址: '台南市永康區成功里小東路4鄰637號1樓',
    縣市: '台南市'
  },
  {
    店號: 165079,
    店名: '西港',
    地址: '台南市西港區西港里中山路366-1號',
    縣市: '台南市'
  },
  {
    店號: 165127,
    店名: '怡平',
    地址: '台南市安平區文平路462號1樓',
    縣市: '台南市'
  },
  {
    店號: 165138,
    店名: '新東',
    地址: '台南市東區林森路二段84號',
    縣市: '台南市'
  },
  {
    店號: 165149,
    店名: '小北',
    地址: '台南市北區西門路四段455號',
    縣市: '台南市'
  },
  {
    店號: 165264,
    店名: '東龍',
    地址: '台南市東區東門路一段362號',
    縣市: '台南市'
  },
  {
    店號: 165471,
    店名: '立登',
    地址: '台南市歸仁區民生北路106號',
    縣市: '台南市'
  },
  {
    店號: 165677,
    店名: '赤崁',
    地址: '台南市中西區民族路二段331號',
    縣市: '台南市'
  },
  {
    店號: 165699,
    店名: '仙草埔',
    地址: '台南市白河區仙草里仙草6之30號',
    縣市: '台南市'
  },
  {
    店號: 166061,
    店名: '裕豐',
    地址: '台南市東區東門路二段289、291、293號1樓',
    縣市: '台南市'
  },
  {
    店號: 166407,
    店名: '時尚',
    地址: '台南市永康區鹽洲里仁愛街19號21號1樓',
    縣市: '台南市'
  },
  {
    店號: 166957,
    店名: '南台',
    地址: '台南市永康區南台街1號1樓',
    縣市: '台南市'
  },
  {
    店號: 166979,
    店名: '素心',
    地址: '台南市仁德區中山路258號260號',
    縣市: '台南市'
  },
  {
    店號: 167019,
    店名: '新六廠',
    地址: '台南市善化區南科北路1號1樓',
    縣市: '台南市'
  },
  {
    店號: 167020,
    店名: 'P1廠',
    地址: '台南市善化區南科北路1之1號1樓',
    縣市: '台南市'
  },
  {
    店號: 167134,
    店名: '綜合',
    地址: '台南市中西區水仙里民生路二段26號28號1樓',
    縣市: '台南市'
  },
  {
    店號: 167215,
    店名: '南茂',
    地址: '台南市新市區南科七路5號2樓',
    縣市: '台南市'
  },
  {
    店號: 167525,
    店名: '聯電',
    地址: '台南市新市區南科三路57號',
    縣市: '台南市'
  },
  {
    店號: 167569,
    店名: '九份子',
    地址: '台南市安南區國安里九份子大道6號1樓',
    縣市: '台南市'
  },
  {
    店號: 167798,
    店名: '趣淘',
    地址: '台南市楠西區密枝里密枝102之5號1樓',
    縣市: '台南市'
  },
  {
    店號: 167802,
    店名: '新天地',
    地址: '台南市柳營區太康里22鄰201-10號',
    縣市: '台南市'
  },
  {
    店號: 167835,
    店名: '興灣',
    地址: '台南市永康區南灣里大灣東路63號1樓',
    縣市: '台南市'
  },
  {
    店號: 167891,
    店名: '康西',
    地址: '台南市永康區永大路二段440號',
    縣市: '台南市'
  },
  {
    店號: 167916,
    店名: '伍鈺',
    地址: '台南市永康區永華路406號408號',
    縣市: '台南市'
  },
  {
    店號: 167983,
    店名: '安期',
    地址: '台南市安平區慶平路60號62號',
    縣市: '台南市'
  },
  {
    店號: 169875,
    店名: '好巧',
    地址: '台南市永康區安康里中華西街152號',
    縣市: '台南市'
  },
  {
    店號: 171177,
    店名: '建華',
    地址: '台南市南區文華里中華西路一段438號',
    縣市: '台南市'
  },
  {
    店號: 171214,
    店名: '大灣',
    地址: '台南市永康區大灣路951號',
    縣市: '台南市'
  },
  {
    店號: 171708,
    店名: '明珠',
    地址: '台南市中西區公正里民族路二段53號',
    縣市: '台南市'
  },
  {
    店號: 173564,
    店名: '府醫',
    地址: '台南市中西區赤崁里中山路125號',
    縣市: '台南市'
  },
  {
    店號: 173690,
    店名: '聯晶',
    地址: '台南市新市區豐華里南科二路18號7樓',
    縣市: '台南市'
  },
  {
    店號: 173885,
    店名: '帝標',
    地址: '台南市東區龍山街109號111號',
    縣市: '台南市'
  },
  {
    店號: 174110,
    店名: '文賢',
    地址: '台南市北區文賢路1116號',
    縣市: '台南市'
  },
  {
    店號: 174567,
    店名: '安學',
    地址: '台南市安南區南興里12鄰公學路五段685號一樓',
    縣市: '台南市'
  },
  {
    店號: 174693,
    店名: '東發',
    地址: '台南市東區中華東路三段379號',
    縣市: '台南市'
  },
  {
    店號: 177371,
    店名: '丹比',
    地址: '台南市北區西門路四段332號334號1樓',
    縣市: '台南市'
  },
  {
    店號: 179573,
    店名: '代天府',
    地址: '台南市北門區鯤江里976號',
    縣市: '台南市'
  },
  {
    店號: 179768,
    店名: '大瑩',
    地址: '台南市仁德區二行里中正西路347號1樓',
    縣市: '台南市'
  },
  {
    店號: 179805,
    店名: '康橋',
    地址: '台南市永康區中山南路12-5號',
    縣市: '台南市'
  },
  {
    店號: 179931,
    店名: '群創B',
    地址: '台南市善化區南關里南科八路12號B1樓',
    縣市: '台南市'
  },
  {
    店號: 179986,
    店名: '安同',
    地址: '台南市安南區同安路235號',
    縣市: '台南市'
  },
  {
    店號: 180425,
    店名: '南應大',
    地址: '台南市永康區鹽行里中正七街27.29號1樓',
    縣市: '台南市'
  },
  {
    店號: 180458,
    店名: '海裕',
    地址: '台南市北區雙安里海安路三段219巷5號1樓',
    縣市: '台南市'
  },
  {
    店號: 180621,
    店名: '仁發',
    地址: '台南市永康區東橋里東橋六街61號',
    縣市: '台南市'
  },
  {
    店號: 180757,
    店名: '文成',
    地址: '台南市北區文元里文成路775號',
    縣市: '台南市'
  },
  {
    店號: 180872,
    店名: '成大',
    地址: '台南市北區勝利路138號B1樓',
    縣市: '台南市'
  },
  {
    店號: 181277,
    店名: '三舍',
    地址: '台南市新市區三舍里三舍55號',
    縣市: '台南市'
  },
  {
    店號: 181495,
    店名: '康健',
    地址: '台南市北區北門路三段49號',
    縣市: '台南市'
  },
  {
    店號: 181532,
    店名: '真新',
    地址: '台南市麻豆區油車里油車24之1號',
    縣市: '台南市'
  },
  {
    店號: 181598,
    店名: '東楨',
    地址: '台南市白河區永安里新興路507號一樓',
    縣市: '台南市'
  },
  {
    店號: 182362,
    店名: '永成',
    地址: '台南市南區佛壇里明興路1322號1樓',
    縣市: '台南市'
  },
  {
    店號: 182502,
    店名: '新安發',
    地址: '台南市安定區安加里安定407號',
    縣市: '台南市'
  },
  {
    店號: 182546,
    店名: '辰佳',
    地址: '台南市永康區永大路二段11號',
    縣市: '台南市'
  },
  {
    店號: 182568,
    店名: '力大',
    地址: '台南市東區生產路508號',
    縣市: '台南市'
  },
  {
    店號: 183181,
    店名: '南化',
    地址: '台南市南化區南化里128號1樓',
    縣市: '台南市'
  },
  {
    店號: 183516,
    店名: '真潭',
    地址: '台南市歸仁區大潭里中正南路三段22號',
    縣市: '台南市'
  },
  {
    店號: 183734,
    店名: '立青',
    地址: '台南市歸仁區南保里民權南路108號',
    縣市: '台南市'
  },
  {
    店號: 183778,
    店名: '佳立',
    地址: '台南市佳里區佳東路361號',
    縣市: '台南市'
  },
  {
    店號: 184036,
    店名: '善良',
    地址: '台南市善化區中正路385號1樓',
    縣市: '台南市'
  },
  {
    店號: 184438,
    店名: '威保',
    地址: '台南市關廟區南雄路一段851號1樓',
    縣市: '台南市'
  },
  {
    店號: 184667,
    店名: '北安',
    地址: '台南市北區公園路599-11號',
    縣市: '台南市'
  },
  {
    店號: 185305,
    店名: '大欣',
    地址: '台南市北區和緯路五段76號',
    縣市: '台南市'
  },
  {
    店號: 186216,
    店名: '永勝',
    地址: '台南市永康區六合里中華二路320號1樓',
    縣市: '台南市'
  },
  {
    店號: 186858,
    店名: '新奇美',
    地址: '台南市永康區甲頂路18、20號',
    縣市: '台南市'
  },
  {
    店號: 187208,
    店名: '鹽水',
    地址: '台南市鹽水區中正路35號',
    縣市: '台南市'
  },
  {
    店號: 187219,
    店名: '鳳凰',
    地址: '台南市安南區北安路二段122號',
    縣市: '台南市'
  },
  {
    店號: 187231,
    店名: '仁興',
    地址: '台南市歸仁區南保里大德路307號',
    縣市: '台南市'
  },
  {
    店號: 187242,
    店名: '善和',
    地址: '台南市善化區坐駕里大成路319號',
    縣市: '台南市'
  },
  {
    店號: 187253,
    店名: '郡豐',
    地址: '台南市安平區郡平路307號',
    縣市: '台南市'
  },
  {
    店號: 187736,
    店名: '仁義',
    地址: '台南市仁德區中正路二段1052號',
    縣市: '台南市'
  },
  {
    店號: 188061,
    店名: '群創三',
    地址: '台南市新市區環西路二段2號1樓(群創三廠)',
    縣市: '台南市'
  },
  {
    店號: 188072,
    店名: '群創五',
    地址: '台南市新市區環西路二段2號1樓(群創五廠)',
    縣市: '台南市'
  },
  {
    店號: 188164,
    店名: '安昌',
    地址: '台南市安南區塭南里安昌街101號',
    縣市: '台南市'
  },
  {
    店號: 188474,
    店名: '富里',
    地址: '台南市安南區安富里府安路五段154號155號156號',
    縣市: '台南市'
  },
  {
    店號: 188496,
    店名: '新黎明',
    地址: '台南市麻豆區興國路40-10號',
    縣市: '台南市'
  },
  {
    店號: 188773,
    店名: '鼎富',
    地址: '台南市關廟區南花里中正路881號',
    縣市: '台南市'
  },
  {
    店號: 188810,
    店名: '建平',
    地址: '台南市安平區建平七街689號',
    縣市: '台南市'
  },
  {
    店號: 188887,
    店名: '荷韻',
    地址: '台南市白河區河東里9鄰冀萁湖122-35號',
    縣市: '台南市'
  },
  {
    店號: 188980,
    店名: '鼎利',
    地址: '台南市關廟區南雄路二段210號',
    縣市: '台南市'
  },
  {
    店號: 188991,
    店名: '鼎亨',
    地址: '台南市東區德東街101號',
    縣市: '台南市'
  },
  {
    店號: 189019,
    店名: '永福',
    地址: '台南市中西區永福路二段65號1樓',
    縣市: '台南市'
  },
  {
    店號: 190813,
    店名: '小東',
    地址: '台南市東區小東路256號',
    縣市: '台南市'
  },
  {
    店號: 192783,
    店名: '唯勝',
    地址: '台南市中西區民權路三段150號一樓',
    縣市: '台南市'
  },
  {
    店號: 192819,
    店名: '和慶',
    地址: '台南市安南區安中路一段701巷33.35號',
    縣市: '台南市'
  },
  {
    店號: 192978,
    店名: '長安營',
    地址: '台南市仁德區保仁路195號(營區內)',
    縣市: '台南市'
  },
  {
    店號: 193199,
    店名: '喬興',
    地址: '台南市西港區慶安里新興街8-77.8-78號',
    縣市: '台南市'
  },
  {
    店號: 193432,
    店名: '黎營',
    地址: '台南市麻豆區井東里磚子井141-21號1樓',
    縣市: '台南市'
  },
  {
    店號: 193568,
    店名: '北園',
    地址: '台南市北區北園街6號之6, 1樓',
    縣市: '台南市'
  },
  {
    店號: 193616,
    店名: 'F18',
    地址: '台南市安定區北園二路8號1樓',
    縣市: '台南市'
  },
  {
    店號: 193867,
    店名: '陽光城',
    地址: '台南市善化區蓮潭里9鄰陽光大道198號1樓',
    縣市: '台南市'
  },
  {
    店號: 194088,
    店名: '衛國',
    地址: '台南市東區林森路二段192巷24弄5號.7號',
    縣市: '台南市'
  },
  {
    店號: 194284,
    店名: '沐東風',
    地址: '台南市東區德昌路58號',
    縣市: '台南市'
  },
  {
    店號: 194321,
    店名: '安醫',
    地址: '台南市安南區州南里12鄰長和路二段66號B1',
    縣市: '台南市'
  },
  {
    店號: 194343,
    店名: '裕孝',
    地址: '台南市東區裕農路888號1樓',
    縣市: '台南市'
  },
  {
    店號: 194608,
    店名: '華立',
    地址: '台南市仁德區仁義里中清路208號',
    縣市: '台南市'
  },
  {
    店號: 194745,
    店名: '奇佳',
    地址: '台南市新化區信義路373號1樓',
    縣市: '台南市'
  },
  {
    店號: 194929,
    店名: '金昇',
    地址: '台南市南區金華路二段341號',
    縣市: '台南市'
  },
  {
    店號: 194963,
    店名: '成商',
    地址: '台南市東區大學里勝利路118號1、2樓',
    縣市: '台南市'
  },
  {
    店號: 194996,
    店名: '台江',
    地址: '台南市安南區安中路二段140號1樓',
    縣市: '台南市'
  },
  {
    店號: 195014,
    店名: '上鈺',
    地址: '台南市南區大成路一段128號1樓',
    縣市: '台南市'
  },
  {
    店號: 195243,
    店名: '聖安',
    地址: '台南市安南區安中路六段850號1樓',
    縣市: '台南市'
  },
  {
    店號: 195298,
    店名: '天期',
    地址: '台南市安平區國平路198號1樓',
    縣市: '台南市'
  },
  {
    店號: 195988,
    店名: '大世紀',
    地址: '台南市東區自由路三段108號1樓',
    縣市: '台南市'
  },
  {
    店號: 196176,
    店名: '三麗',
    地址: '台南市新化區協興里正新路305號1樓',
    縣市: '台南市'
  },
  {
    店號: 197146,
    店名: '明和',
    地址: '台南市南區中華西路一段89號',
    縣市: '台南市'
  },
  {
    店號: 197294,
    店名: '北站',
    地址: '台南市仁德區中洲村中洲路1巷200號1樓',
    縣市: '台南市'
  },
  {
    店號: 197618,
    店名: '華康',
    地址: '台南市永康區中華路10巷2號1樓、中華路8-7號1樓',
    縣市: '台南市'
  },
  {
    店號: 197928,
    店名: '鎮山',
    地址: '台南市中西區西湖里湖美街10號',
    縣市: '台南市'
  },
  {
    店號: 198219,
    店名: '雙鈺',
    地址: '台南市永康區永華路399號1樓',
    縣市: '台南市'
  },
  {
    店號: 198253,
    店名: '闔平',
    地址: '台南市安南區府安路五段98巷56弄33號',
    縣市: '台南市'
  },
  {
    店號: 198437,
    店名: '塭內',
    地址: '台南市佳里區塭內里塭子內12-1號',
    縣市: '台南市'
  },
  {
    店號: 198552,
    店名: '台南蔡',
    地址: '台南市永康區中正南路628號',
    縣市: '台南市'
  },
  {
    店號: 198600,
    店名: '崇學',
    地址: '台南市東區崇善路168號',
    縣市: '台南市'
  },
  {
    店號: 198747,
    店名: '福耀',
    地址: '台南市東區崇明路377號377-1號',
    縣市: '台南市'
  },
  {
    店號: 198769,
    店名: '夢公園',
    地址: '台南市學甲區中山路187號1樓',
    縣市: '台南市'
  },
  {
    店號: 198770,
    店名: '新新樓',
    地址: '台南市東區東門里前鋒路16號1樓',
    縣市: '台南市'
  },
  {
    店號: 198921,
    店名: '鼎鑫',
    地址: '台南市關廟區中山路二段27號1樓',
    縣市: '台南市'
  },
  {
    店號: 199027,
    店名: '新市',
    地址: '台南市新市區華興街48號1樓',
    縣市: '台南市'
  },
  {
    店號: 199050,
    店名: '長和',
    地址: '台南市安南區長和一街39號',
    縣市: '台南市'
  },
  {
    店號: 199119,
    店名: '工館',
    地址: '台南市永康區崑大路195號',
    縣市: '台南市'
  },
  {
    店號: 199131,
    店名: '東和',
    地址: '台南市東區東安路291號293號1樓',
    縣市: '台南市'
  },
  {
    店號: 199348,
    店名: '安東',
    地址: '台南市安南區安和路一段308號1樓',
    縣市: '台南市'
  },
  {
    店號: 199511,
    店名: '崑教',
    地址: '台南市永康區崑大路195號',
    縣市: '台南市'
  },
  {
    店號: 199533,
    店名: '府城',
    地址: '台南市安平區永華路二段532號',
    縣市: '台南市'
  },
  {
    店號: 199577,
    店名: '安運',
    地址: '台南市安平區平安里華平路742號1樓',
    縣市: '台南市'
  },
  {
    店號: 199658,
    店名: '金都',
    地址: '台南市南區金華路一段235號1樓',
    縣市: '台南市'
  },
  {
    店號: 200284,
    店名: '鑫歐洲',
    地址: '台南市永康區埔園街339號',
    縣市: '台南市'
  },
  {
    店號: 202051,
    店名: '18廠B',
    地址: '台南市安定區蘇林里北園二路8號',
    縣市: '台南市'
  },
  {
    店號: 202202,
    店名: '家園',
    地址: '台南市仁德區長興路77之1號.83號',
    縣市: '台南市'
  },
  {
    店號: 202394,
    店名: '奇美博',
    地址: '台南市仁德區文華路二段66號',
    縣市: '台南市'
  },
  {
    店號: 206857,
    店名: '潭頂',
    地址: '台南市新市區潭頂里潭頂400號',
    縣市: '台南市'
  },
  {
    店號: 206868,
    店名: '龍橋',
    地址: '台南市永康區烏竹里7鄰龍橋街406號',
    縣市: '台南市'
  },
  {
    店號: 206905,
    店名: '飛鳥',
    地址: '台南市善化區文光里建國路386號1樓',
    縣市: '台南市'
  },
  {
    店號: 207078,
    店名: '學信',
    地址: '台南市學甲區明宜里信義路50號1樓',
    縣市: '台南市'
  },
  {
    店號: 207263,
    店名: '橋富',
    地址: '台南市永康區大橋二街130、132號',
    縣市: '台南市'
  },
  {
    店號: 207595,
    店名: '荻亞',
    地址: '台南市中西區朝陽里中山路153號1樓',
    縣市: '台南市'
  },
  {
    店號: 207883,
    店名: '嘉倫',
    地址: '台南市西港區中山路469之8號',
    縣市: '台南市'
  },
  {
    店號: 208118,
    店名: '梅花',
    地址: '台南市楠西區楠西里中正路176號前面',
    縣市: '台南市'
  },
  {
    店號: 208428,
    店名: '勝堉',
    地址: '台南市東區育樂街1號',
    縣市: '台南市'
  },
  {
    店號: 208543,
    店名: '安西',
    地址: '台南市安南區安中路一段136號',
    縣市: '台南市'
  },
  {
    店號: 208646,
    店名: '夏興',
    地址: '台南市南區夏林路258號1樓',
    縣市: '台南市'
  },
  {
    店號: 208831,
    店名: '朝日',
    地址: '台南市善化區蓮潭里龍目井路433.435號1樓',
    縣市: '台南市'
  },
  {
    店號: 208978,
    店名: '星辰',
    地址: '台南市新化區全興里竹子腳178號',
    縣市: '台南市'
  },
  {
    店號: 209085,
    店名: '華億',
    地址: '台南市仁德區文華路三段432.436號',
    縣市: '台南市'
  },
  {
    店號: 209281,
    店名: '果毅',
    地址: '台南市柳營區果毅里果毅後14-1號1樓',
    縣市: '台南市'
  },
  {
    店號: 209395,
    店名: '大嘉瑩',
    地址: '台南市仁德區二仁路一段124.126號',
    縣市: '台南市'
  },
  {
    店號: 209535,
    店名: '高吉',
    地址: '台南市新市區新和里中正路193號',
    縣市: '台南市'
  },
  {
    店號: 209948,
    店名: '東利',
    地址: '台南市歸仁區南保里文化街三段47號1樓',
    縣市: '台南市'
  },
  {
    店號: 210074,
    店名: '光賢',
    地址: '台南市中西區中華西路二段600號600-1號1.2樓',
    縣市: '台南市'
  },
  {
    店號: 210144,
    店名: '長源',
    地址: '台南市北區長榮路四段181號',
    縣市: '台南市'
  },
  {
    店號: 210317,
    店名: '永高',
    地址: '台南市永康區鹽興里中正北路185號',
    縣市: '台南市'
  },
  {
    店號: 210340,
    店名: '明安',
    地址: '台南市安南區工業二路166號',
    縣市: '台南市'
  },
  {
    店號: 210568,
    店名: '鑫永康',
    地址: '台南市永康區中華路617-1號',
    縣市: '台南市'
  },
  {
    店號: 210904,
    店名: '嘉營',
    地址: '台南市仁德區中正路一段73號',
    縣市: '台南市'
  },
  {
    店號: 211239,
    店名: '立昌',
    地址: '台南市歸仁區中山路三段370號',
    縣市: '台南市'
  },
  {
    店號: 211284,
    店名: '佳成',
    地址: '台南市佳里區興化里佳里興570-51號1樓',
    縣市: '台南市'
  },
  {
    店號: 211365,
    店名: '凱旋',
    地址: '台南市東區怡東路111號1樓',
    縣市: '台南市'
  },
  {
    店號: 211572,
    店名: '新營',
    地址: '台南市新營區復興路642號',
    縣市: '台南市'
  },
  {
    店號: 211712,
    店名: '永燕',
    地址: '台南市永康區中山南路518號',
    縣市: '台南市'
  },
  {
    店號: 211893,
    店名: '佳東',
    地址: '台南市佳里區進學路7號1樓',
    縣市: '台南市'
  },
  {
    店號: 212106,
    店名: '六甲頂',
    地址: '台南市永康區尚頂里中正南路325號1樓',
    縣市: '台南市'
  },
  {
    店號: 212140,
    店名: '紅瓦厝',
    地址: '台南市歸仁區大成路211號1樓',
    縣市: '台南市'
  },
  {
    店號: 212254,
    店名: '土定里',
    地址: '台南市南區永成路三段319號1樓',
    縣市: '台南市'
  },
  {
    店號: 212298,
    店名: '華勇',
    地址: '台南市永康區華興街122號1、2樓',
    縣市: '台南市'
  },
  {
    店號: 212346,
    店名: '德欽',
    地址: '台南市仁德區後壁里德南路3鄰92號',
    縣市: '台南市'
  },
  {
    店號: 212405,
    店名: '學東',
    地址: '台南市安南區公學路六段679號1樓',
    縣市: '台南市'
  },
  {
    店號: 212449,
    店名: '善農',
    地址: '台南市善化區中山路243號1樓',
    縣市: '台南市'
  },
  {
    店號: 212472,
    店名: '尊南',
    地址: '台南市南區尊南街268.270號',
    縣市: '台南市'
  },
  {
    店號: 213796,
    店名: '康興',
    地址: '台南市永康區中華路196號1樓',
    縣市: '台南市'
  },
  {
    店號: 213925,
    店名: '常興',
    地址: '台南市仁德區中正路三段701號',
    縣市: '台南市'
  },
  {
    店號: 214191,
    店名: '新醫',
    地址: '台南市新營區民權里民權路96號96-1號1樓',
    縣市: '台南市'
  },
  {
    店號: 214401,
    店名: '新興',
    地址: '台南市南區光明里新興路6鄰529號531號1樓',
    縣市: '台南市'
  },
  {
    店號: 214490,
    店名: '新興運',
    地址: '台南市新化區護國里中山路211號',
    縣市: '台南市'
  },
  {
    店號: 214847,
    店名: '南站',
    地址: '台南市仁德區中洲村中洲路1巷220號1樓',
    縣市: '台南市'
  },
  {
    店號: 215231,
    店名: '新大港',
    地址: '台南市北區大和里大港街140號1樓2樓',
    縣市: '台南市'
  },
  {
    店號: 215323,
    店名: '加賀',
    地址: '台南市歸仁區大廟里大廟一街1號',
    縣市: '台南市'
  },
  {
    店號: 215404,
    店名: '富裕',
    地址: '台南市東區後甲里裕農路657號1樓',
    縣市: '台南市'
  },
  {
    店號: 216658,
    店名: '東勝',
    地址: '台南市東山區東山里235號',
    縣市: '台南市'
  },
  {
    店號: 216809,
    店名: '海寮',
    地址: '台南市安定區海寮里海寮街8號',
    縣市: '台南市'
  },
  {
    店號: 216843,
    店名: '橋鈺',
    地址: '台南市永康區東橋七路369號1樓',
    縣市: '台南市'
  },
  {
    店號: 217101,
    店名: '環安',
    地址: '台南市安南區長和路二段12巷272號',
    縣市: '台南市'
  },
  {
    店號: 217134,
    店名: '西門',
    地址: '台南市北區西門路四段132號',
    縣市: '台南市'
  },
  {
    店號: 217363,
    店名: '億載',
    地址: '台南市東區大同路二段95-3號',
    縣市: '台南市'
  },
  {
    店號: 217499,
    店名: '新永健',
    地址: '台南市中西區健康路一段346號',
    縣市: '台南市'
  },
  {
    店號: 227681,
    店名: '花田',
    地址: '台南市歸仁區中正北路二段130號1樓',
    縣市: '台南市'
  },
  {
    店號: 227717,
    店名: '煒達',
    地址: '台南市北區育德路491號1.2樓',
    縣市: '台南市'
  },
  {
    店號: 228215,
    店名: '集福',
    地址: '台南市中西區金華路四段194號與信義街60巷6號',
    縣市: '台南市'
  },
  {
    店號: 228640,
    店名: '丞芯',
    地址: '台南市南區萬年七街380號',
    縣市: '台南市'
  },
  {
    店號: 229285,
    店名: '永臻',
    地址: '台南市永康區中山東路59號',
    縣市: '台南市'
  },
  {
    店號: 229436,
    店名: '南建平',
    地址: '台南市安平區建平路19、21、23號1樓',
    縣市: '台南市'
  },
  {
    店號: 229447,
    店名: '青青',
    地址: '台南市北區和緯路五段278號1樓',
    縣市: '台南市'
  },
  {
    店號: 229528,
    店名: '日通',
    地址: '台南市北區東興路二段47號1樓',
    縣市: '台南市'
  },
  {
    店號: 229713,
    店名: '愛佳',
    地址: '台南市佳里區仁愛路269號1樓',
    縣市: '台南市'
  },
  {
    店號: 229735,
    店名: '安科',
    地址: '台南市安定區嘉同里六塊寮10-13.10-15號',
    縣市: '台南市'
  },
  {
    店號: 229986,
    店名: '竹篙厝',
    地址: '台南市東區仁和路126號1樓',
    縣市: '台南市'
  },
  {
    店號: 230012,
    店名: '水交社',
    地址: '台南市南區西門路一段292、296號',
    縣市: '台南市'
  },
  {
    店號: 230263,
    店名: '易京',
    地址: '台南市安南區頂安里北安路三段400-1號',
    縣市: '台南市'
  },
  {
    店號: 230300,
    店名: '高發',
    地址: '台南市歸仁區高發二路371.373號',
    縣市: '台南市'
  },
  {
    店號: 230458,
    店名: '明倫',
    地址: '台南市中西區金華路三段88號1.2樓',
    縣市: '台南市'
  },
  {
    店號: 230481,
    店名: '新真愛',
    地址: '台南市永康區東橋六街208號1樓',
    縣市: '台南市'
  },
  {
    店號: 230665,
    店名: '興文',
    地址: '台南市仁德區中正路二段508號1樓',
    縣市: '台南市'
  },
  {
    店號: 230698,
    店名: '水道',
    地址: '台南市山上區山上里249、249-1、249-2號',
    縣市: '台南市'
  },
  {
    店號: 230805,
    店名: '大葆',
    地址: '台南市永康區?行里正南五街311號',
    縣市: '台南市'
  },
  {
    店號: 231093,
    店名: '興功',
    地址: '台南市仁德區民安路一段423、425號1樓',
    縣市: '台南市'
  },
  {
    店號: 231358,
    店名: '東金',
    地址: '台南市東山區新東路一段19號1樓',
    縣市: '台南市'
  },
  {
    店號: 231554,
    店名: '南三井',
    地址: '台南市歸仁區歸仁大道101號1樓',
    縣市: '台南市'
  },
  {
    店號: 231761,
    店名: '府城市',
    地址: '台南市安平區永華路二段6號1樓',
    縣市: '台南市'
  },
  {
    店號: 231794,
    店名: '內庄',
    地址: '台南市大內區內庄172-8號1樓',
    縣市: '台南市'
  },
  {
    店號: 231853,
    店名: '文硯',
    地址: '台南市安平區文平路278號1.2樓',
    縣市: '台南市'
  },
  {
    店號: 232052,
    店名: '盛馨',
    地址: '台南市東區府連路351號1樓.353號1樓',
    縣市: '台南市'
  },
  {
    店號: 232306,
    店名: '恆豪',
    地址: '台南市永康區中正南路432號1樓',
    縣市: '台南市'
  },
  {
    店號: 232373,
    店名: '東萬',
    地址: '台南市東區中華東路三段141號1樓',
    縣市: '台南市'
  },
  {
    店號: 233310,
    店名: '東山站',
    地址: '台南市東山區科里里枋子林74-6號',
    縣市: '台南市'
  },
  {
    店號: 236869,
    店名: '城中',
    地址: '台南市安南區安中路六段599號601號',
    縣市: '台南市'
  },
  {
    店號: 237046,
    店名: '香洋',
    地址: '台南市關廟區香洋里中山路一段203號1樓',
    縣市: '台南市'
  },
  {
    店號: 237493,
    店名: '新南科',
    地址: '台南市新市區南科三路17、19號1樓(台南科學工業區)',
    縣市: '台南市'
  },
  {
    店號: 237921,
    店名: '席悅',
    地址: '台南市東區東光里東興路41號1樓',
    縣市: '台南市'
  },
  {
    店號: 238120,
    店名: '遠專',
    地址: '台南市新市區永就里中華路53巷9號',
    縣市: '台南市'
  },
  {
    店號: 238153,
    店名: '裕信',
    地址: '台南市東區裕信路352號',
    縣市: '台南市'
  },
  {
    店號: 238175,
    店名: '林頂',
    地址: '台南市仁德區中山路155號',
    縣市: '台南市'
  },
  {
    店號: 238647,
    店名: '裕興',
    地址: '台南市東區復興里裕文路76號1樓',
    縣市: '台南市'
  },
  {
    店號: 239396,
    店名: '南英',
    地址: '台南市中西區永福路一段30號32號1, 2樓',
    縣市: '台南市'
  },
  {
    店號: 239880,
    店名: '港達',
    地址: '台南市安定區港口里245-10號1樓',
    縣市: '台南市'
  },
  {
    店號: 239938,
    店名: '安南',
    地址: '台南市安南區安和路四段520號',
    縣市: '台南市'
  },
  {
    店號: 240042,
    店名: '松美',
    地址: '台南市善化區小新里成功路2-2號',
    縣市: '台南市'
  },
  {
    店號: 240097,
    店名: '奇蹟',
    地址: '台南市永康區永大路三段299號',
    縣市: '台南市'
  },
  {
    店號: 240400,
    店名: '麻佳',
    地址: '台南市麻豆區苓子林17-13號',
    縣市: '台南市'
  },
  {
    店號: 240514,
    店名: '歸仁',
    地址: '台南市歸仁區中山路二段60號',
    縣市: '台南市'
  },
  {
    店號: 240813,
    店名: '新佳興',
    地址: '台南市佳里區東寧里文化路196號1樓',
    縣市: '台南市'
  },
  {
    店號: 240994,
    店名: '永強',
    地址: '台南市永康區埔園里中正路102號',
    縣市: '台南市'
  },
  {
    店號: 241012,
    店名: '國銨',
    地址: '台南市安南區國安街111號113號',
    縣市: '台南市'
  },
  {
    店號: 241230,
    店名: '新新善',
    地址: '台南市新市區復興路59號61號63號一樓',
    縣市: '台南市'
  },
  {
    店號: 241562,
    店名: '善成',
    地址: '台南市善化區中正路386號',
    縣市: '台南市'
  },
  {
    店號: 249588,
    店名: '文南',
    地址: '台南市南區健康路二段268-1、270號',
    縣市: '台南市'
  },
  {
    店號: 249728,
    店名: '龍華',
    地址: '台南市永康區烏竹里自強路825-1號',
    縣市: '台南市'
  },
  {
    店號: 249739,
    店名: '欣大林',
    地址: '台南市南區大同路二段136巷3號1樓',
    縣市: '台南市'
  },
  {
    店號: 250441,
    店名: '德緯',
    地址: '台南市北區成德里育德二路20鄰308號',
    縣市: '台南市'
  },
  {
    店號: 250588,
    店名: '長榮大',
    地址: '台南市歸仁區長大路1號(長榮大學內第4宿舍B1)',
    縣市: '台南市'
  },
  {
    店號: 250854,
    店名: '慶平',
    地址: '台南市安平區慶平路235號1樓',
    縣市: '台南市'
  },
  {
    店號: 251190,
    店名: '愷傑',
    地址: '台南市永康區中正北路122號',
    縣市: '台南市'
  },
  {
    店號: 780827,
    店名: '和順',
    地址: '台南市安南區安和路五段166號',
    縣市: '台南市'
  },
  {
    店號: 791241,
    店名: '佳里',
    地址: '台南市佳里區光復路197號197-1號',
    縣市: '台南市'
  },
  {
    店號: 822169,
    店名: '公園',
    地址: '台南市北區公園路1072-1號2號3號',
    縣市: '台南市'
  },
  {
    店號: 822790,
    店名: '崇明',
    地址: '台南市東區林森路一段184號',
    縣市: '台南市'
  },
  {
    店號: 833055,
    店名: '長寧',
    地址: '台南市東區長榮路三段12號',
    縣市: '台南市'
  },
  {
    店號: 842060,
    店名: '武聖',
    地址: '台南市中西區武聖路47號49號',
    縣市: '台南市'
  },
  {
    店號: 845597,
    店名: '安中',
    地址: '台南市安南區安中路一段711號',
    縣市: '台南市'
  },
  {
    店號: 846659,
    店名: '仁德',
    地址: '台南市仁德區中山路497、499、501號1樓',
    縣市: '台南市'
  },
  {
    店號: 851064,
    店名: '伍誼',
    地址: '台南市歸仁區復興路162之1號',
    縣市: '台南市'
  },
  {
    店號: 854557,
    店名: '一心',
    地址: '台南市東區中華東路一段24號',
    縣市: '台南市'
  },
  {
    店號: 855055,
    店名: '公平',
    地址: '台南市北區公園路694號',
    縣市: '台南市'
  },
  {
    店號: 860448,
    店名: '森田',
    地址: '台南市東區東門里東門路一段199號',
    縣市: '台南市'
  },
  {
    店號: 860459,
    店名: '柳營',
    地址: '台南市柳營區士林里柳營路二段1號3號',
    縣市: '台南市'
  },
  {
    店號: 860688,
    店名: '立人',
    地址: '台南市北區和順里西門路三段81號',
    縣市: '台南市'
  },
  {
    店號: 861544,
    店名: '嘉南',
    地址: '台南市仁德區二行里二仁路一段151號',
    縣市: '台南市'
  },
  {
    店號: 863252,
    店名: '六甲',
    地址: '台南市六甲區六甲里22鄰中正路552號',
    縣市: '台南市'
  },
  {
    店號: 864668,
    店名: '夏林',
    地址: '台南市南區夏林路134-1號134-2號',
    縣市: '台南市'
  },
  {
    店號: 865535,
    店名: '北門',
    地址: '台南市東區北門路一段310號,312號',
    縣市: '台南市'
  },
  {
    店號: 865797,
    店名: '大恩',
    地址: '台南市南區大同路二段692.694號及國民路2號',
    縣市: '台南市'
  },
  {
    店號: 870272,
    店名: '新銀',
    地址: '台南市新營區中山路140號',
    縣市: '台南市'
  },
  {
    店號: 871596,
    店名: '玉山',
    地址: '台南市永康區永明街97號',
    縣市: '台南市'
  },
  {
    店號: 871714,
    店名: '隆田',
    地址: '台南市官田區隆田里14鄰文化街130號',
    縣市: '台南市'
  },
  {
    店號: 871747,
    店名: '聖賢',
    地址: '台南市北區大豐里文賢路315號',
    縣市: '台南市'
  },
  {
    店號: 872360,
    店名: '玉井',
    地址: '台南市玉井區中正路54號',
    縣市: '台南市'
  },
  {
    店號: 873363,
    店名: '港龍',
    地址: '台南市安定區港南里163號',
    縣市: '台南市'
  },
  {
    店號: 874399,
    店名: '大橋',
    地址: '台南市永康區大橋里中華路747號',
    縣市: '台南市'
  },
  {
    店號: 874757,
    店名: '市醫',
    地址: '台南市東區崇德路685號687號',
    縣市: '台南市'
  },
  {
    店號: 880165,
    店名: '那菝',
    地址: '台南市新化區那菝林241號',
    縣市: '台南市'
  },
  {
    店號: 880419,
    店名: '古都',
    地址: '台南市東區仁和路133號',
    縣市: '台南市'
  },
  {
    店號: 880811,
    店名: '騰揮',
    地址: '台南市歸仁區中正南路一段110號',
    縣市: '台南市'
  },
  {
    店號: 881308,
    店名: '超順',
    地址: '台南市學甲區中正路143號',
    縣市: '台南市'
  },
  {
    店號: 882552,
    店名: '慶安',
    地址: '台南市西港區慶安里新興街25-2號',
    縣市: '台南市'
  },
  {
    店號: 883256,
    店名: '總安',
    地址: '台南市安南區安和路四段9號',
    縣市: '台南市'
  },
  {
    店號: 883898,
    店名: '本原',
    地址: '台南市安南區海佃路四段2號',
    縣市: '台南市'
  },
  {
    店號: 885115,
    店名: '新進',
    地址: '台南市新營區中正路33之14號15號',
    縣市: '台南市'
  },
  {
    店號: 885997,
    店名: '千福',
    地址: '台南市中西區大涼里中華西路二段36號',
    縣市: '台南市'
  },
  {
    店號: 886325,
    店名: '友愛',
    地址: '台南市中西區友愛街197之199號',
    縣市: '台南市'
  },
  {
    店號: 886668,
    店名: '崇道',
    地址: '台南市東區崇善路571號',
    縣市: '台南市'
  },
  {
    店號: 890324,
    店名: '文炳',
    地址: '台南市永康區南台街1號',
    縣市: '台南市'
  },
  {
    店號: 891213,
    店名: '德南',
    地址: '台南市仁德區中正路二段224號',
    縣市: '台南市'
  },
  {
    店號: 892179,
    店名: '鈺華',
    地址: '台南市永康區崑南里37鄰大仁街220號',
    縣市: '台南市'
  },
  {
    店號: 893792,
    店名: '永復',
    地址: '台南市永康區復華里復華一街2號',
    縣市: '台南市'
  },
  {
    店號: 894407,
    店名: '立興',
    地址: '台南市南區灣裡路265號',
    縣市: '台南市'
  },
  {
    店號: 895721,
    店名: '尚頂',
    地址: '台南市永康區中正南路314號',
    縣市: '台南市'
  },
  {
    店號: 895857,
    店名: '開山',
    地址: '台南市中西區開山路245號',
    縣市: '台南市'
  },
  {
    店號: 896333,
    店名: '頂美',
    地址: '台南市中西區西和路1號3號',
    縣市: '台南市'
  },
  {
    店號: 901466,
    店名: '喜樹',
    地址: '台南市南區喜東里10鄰明興路732號',
    縣市: '台南市'
  },
  {
    店號: 902159,
    店名: '詠文',
    地址: '台南市永康區網寮里6鄰永二街202號',
    縣市: '台南市'
  },
  {
    店號: 902779,
    店名: '八甲',
    地址: '台南市歸仁區八甲里中正北路一段194號',
    縣市: '台南市'
  },
  {
    店號: 903152,
    店名: '後壁',
    地址: '台南市後壁區後壁里後壁71號',
    縣市: '台南市'
  },
  {
    店號: 903392,
    店名: '永正',
    地址: '台南市永康區永康里中山南路537號',
    縣市: '台南市'
  },
  {
    店號: 903439,
    店名: '七股',
    地址: '台南市七股區七股里14鄰154-1號',
    縣市: '台南市'
  },
  {
    店號: 905136,
    店名: '體育',
    地址: '台南市中西區健康路一段166號',
    縣市: '台南市'
  },
  {
    店號: 905343,
    店名: '精工',
    地址: '台南市永康區中正北路735號',
    縣市: '台南市'
  },
  {
    店號: 905963,
    店名: '保正',
    地址: '台南市仁德區中正路一段529號',
    縣市: '台南市'
  },
  {
    店號: 906726,
    店名: '公道',
    地址: '台南市南區夏林路1-16號、1-17號',
    縣市: '台南市'
  },
  {
    店號: 910323,
    店名: '好萊富',
    地址: '台南市新營區南紙里太子路191號',
    縣市: '台南市'
  },
  {
    店號: 910334,
    店名: '清新',
    地址: '台南市新化區武安里中正路321號',
    縣市: '台南市'
  },
  {
    店號: 910976,
    店名: '庭園',
    地址: '台南市永康區埔園里龍國街77號',
    縣市: '台南市'
  },
  {
    店號: 911256,
    店名: '祥安',
    地址: '台南市安南區大安街58.60.62.64號1樓',
    縣市: '台南市'
  },
  {
    店號: 912097,
    店名: '安富',
    地址: '台南市安南區安富街343號',
    縣市: '台南市'
  },
  {
    店號: 912400,
    店名: '本安',
    地址: '台南市安南區淵東里安中路三段360號1樓',
    縣市: '台南市'
  },
  {
    店號: 915203,
    店名: '長榮',
    地址: '台南市東區長榮路三段139號',
    縣市: '台南市'
  },
  {
    店號: 916516,
    店名: '東敬',
    地址: '台南市東區莊敬路90號1樓;東平路35-1號,35-2號1樓',
    縣市: '台南市'
  },
  {
    店號: 921518,
    店名: '逢安',
    地址: '台南市安南區海西里海中街73號',
    縣市: '台南市'
  },
  {
    店號: 921655,
    店名: '南鯤鯓',
    地址: '台南市北門區鯤江里841-1號',
    縣市: '台南市'
  },
  {
    店號: 922670,
    店名: '詠信',
    地址: '台南市永康區復華七街68號',
    縣市: '台南市'
  },
  {
    店號: 922821,
    店名: '永大春',
    地址: '台南市永康區中山北路431號',
    縣市: '台南市'
  },
  {
    店號: 923547,
    店名: '南藝',
    地址: '台南市官田區大崎里66號',
    縣市: '台南市'
  },
  {
    店號: 923868,
    店名: '安新',
    地址: '台南市安南區長溪路三段399號1樓',
    縣市: '台南市'
  },
  {
    店號: 928829,
    店名: '埔園',
    地址: '台南市永康區中山路90號',
    縣市: '台南市'
  },
  {
    店號: 930796,
    店名: '同發',
    地址: '台南市安平區安北路170-3號1樓',
    縣市: '台南市'
  },
  {
    店號: 931272,
    店名: '六發',
    地址: '台南市歸仁區六甲里中正南路一段1020號',
    縣市: '台南市'
  },
  {
    店號: 931386,
    店名: '鹽行',
    地址: '台南市永康區鹽洲里鹽洲二街83號',
    縣市: '台南市'
  },
  {
    店號: 931478,
    店名: '麻新',
    地址: '台南市麻豆區中正路289號',
    縣市: '台南市'
  },
  {
    店號: 931489,
    店名: '蓮營',
    地址: '台南市後壁區福安里200號',
    縣市: '台南市'
  },
  {
    店號: 931559,
    店名: '德發',
    地址: '台南市仁德區中正路三段42號',
    縣市: '台南市'
  },
  {
    店號: 931836,
    店名: '上營',
    地址: '台南市下營區中營里1286號',
    縣市: '台南市'
  },
  {
    店號: 932714,
    店名: '安佃',
    地址: '台南市安南區海佃路四段548號',
    縣市: '台南市'
  },
  {
    店號: 932884,
    店名: '興農',
    地址: '台南市善化區興農路4號',
    縣市: '台南市'
  },
  {
    店號: 934732,
    店名: '國平',
    地址: '台南市安平區平通里國平路381號',
    縣市: '台南市'
  },
  {
    店號: 935735,
    店名: '豐盛',
    地址: '台南市北區勝利路192號194號',
    縣市: '台南市'
  },
  {
    店號: 935779,
    店名: '致聖',
    地址: '台南市東區北門路二段12號',
    縣市: '台南市'
  },
  {
    店號: 936484,
    店名: '武德',
    地址: '台南市中西區青年路134號',
    縣市: '台南市'
  },
  {
    店號: 940254,
    店名: '怡安',
    地址: '台南市安南區安和路二段27號之2',
    縣市: '台南市'
  },
  {
    店號: 941062,
    店名: '東江',
    地址: '台南市永康區尚頂里23鄰南台街43號1樓',
    縣市: '台南市'
  },
  {
    店號: 941419,
    店名: '新憲',
    地址: '台南市新營區埤寮里中正路530號',
    縣市: '台南市'
  },
  {
    店號: 941693,
    店名: '新東育',
    地址: '台南市東區大學路西段53號1樓2樓',
    縣市: '台南市'
  },
  {
    店號: 941936,
    店名: '高長',
    地址: '台南市新市區新和里仁愛街171號',
    縣市: '台南市'
  },
  {
    店號: 942548,
    店名: '中洲',
    地址: '台南市仁德區中洲 276之17號1樓',
    縣市: '台南市'
  },
  {
    店號: 942607,
    店名: '烏山頭',
    地址: '台南市官田區湖山里98-4號98-5號',
    縣市: '台南市'
  },
  {
    店號: 942652,
    店名: '六分寮',
    地址: '台南市善化區田寮里六分寮74-1號74-2號',
    縣市: '台南市'
  },
  {
    店號: 943002,
    店名: '科工',
    地址: '台南市安南區鹽田里鹽田路2號',
    縣市: '台南市'
  },
  {
    店號: 943208,
    店名: '仁灣',
    地址: '台南市永康區大仁街11巷1號',
    縣市: '台南市'
  },
  {
    店號: 943666,
    店名: '正旺',
    地址: '台南市南區明興路917號',
    縣市: '台南市'
  },
  {
    店號: 943714,
    店名: '道成',
    地址: '台南市北區北門路二段500號',
    縣市: '台南市'
  },
  {
    店號: 943884,
    店名: '保東',
    地址: '台南市關廟區關新路二段7號',
    縣市: '台南市'
  },
  {
    店號: 944278,
    店名: '康榮',
    地址: '台南市北區實踐里北門路三段2號',
    縣市: '台南市'
  },
  {
    店號: 944555,
    店名: '鈺善',
    地址: '台南市白河區昇安里1鄰三間厝2-56號',
    縣市: '台南市'
  },
  {
    店號: 944577,
    店名: '本興',
    地址: '台南市安南區公學路四段180號',
    縣市: '台南市'
  },
  {
    店號: 944658,
    店名: '奇勝',
    地址: '台南市仁德區新田里勝利路139號',
    縣市: '台南市'
  },
  {
    店號: 946193,
    店名: '慶東',
    地址: '台南市東區青年路416號',
    縣市: '台南市'
  },
  {
    店號: 946643,
    店名: '國宅',
    地址: '台南市南區新興路441號',
    縣市: '台南市'
  },
  {
    店號: 947912,
    店名: '祥發',
    地址: '台南市東區裕豐街187號189號191號1樓',
    縣市: '台南市'
  },
  {
    店號: 950273,
    店名: '好富',
    地址: '台南市東區富強里裕農路320號',
    縣市: '台南市'
  },
  {
    店號: 950538,
    店名: '文安',
    地址: '台南市仁德區文賢路一段576號',
    縣市: '台南市'
  },
  {
    店號: 950620,
    店名: '永嘉',
    地址: '台南市永康區二王路139號',
    縣市: '台南市'
  },
  {
    店號: 950974,
    店名: '立東',
    地址: '台南市東區東門路三段220號',
    縣市: '台南市'
  },
  {
    店號: 951483,
    店名: '雋鈺',
    地址: '台南市永康區西灣里永華路157號',
    縣市: '台南市'
  },
  {
    店號: 951760,
    店名: '將富',
    地址: '台南市將軍區將富里49之八號',
    縣市: '台南市'
  },
  {
    店號: 951830,
    店名: '華醫',
    地址: '台南市仁德區民安路一段115號',
    縣市: '台南市'
  },
  {
    店號: 951874,
    店名: '牛墟',
    地址: '台南市善化區什乃里什乃190號',
    縣市: '台南市'
  },
  {
    店號: 951966,
    店名: '仁伯',
    地址: '台南市仁德區後壁里德安路188號',
    縣市: '台南市'
  },
  {
    店號: 952280,
    店名: '創意',
    地址: '台南市永康區鹽行里中正二街268號',
    縣市: '台南市'
  },
  {
    店號: 953191,
    店名: '常勝',
    地址: '台南市北區長榮里長勝路1號',
    縣市: '台南市'
  },
  {
    店號: 954183,
    店名: '麻善',
    地址: '台南市麻豆區晉江里民權路10-1號',
    縣市: '台南市'
  },
  {
    店號: 954312,
    店名: '新墘',
    地址: '台南市新市區港墘里民族路118號',
    縣市: '台南市'
  },
  {
    店號: 954448,
    店名: '新新復',
    地址: '台南市新營區新進路二段466號',
    縣市: '台南市'
  },
  {
    店號: 958602,
    店名: '德光',
    地址: '台南市東區崇德路269號',
    縣市: '台南市'
  },
  {
    店號: 958967,
    店名: '新化',
    地址: '台南市新化區中正路557號',
    縣市: '台南市'
  },
  {
    店號: 962771,
    店名: '吉吉好',
    地址: '台南市東區崇德路670號',
    縣市: '台南市'
  },
  {
    店號: 962863,
    店名: '湖美',
    地址: '台南市北區大豐里27鄰中華北路一段143號',
    縣市: '台南市'
  },
  {
    店號: 965057,
    店名: '長溪',
    地址: '台南市安南區安慶里長溪路一段307號',
    縣市: '台南市'
  },
  {
    店號: 965105,
    店名: '淵安',
    地址: '台南市安南區海佃路三段163號',
    縣市: '台南市'
  },
  {
    店號: 965264,
    店名: '裕平',
    地址: '台南市東區關聖里裕信路177號1樓',
    縣市: '台南市'
  },
  {
    店號: 965345,
    店名: '小腳腿',
    地址: '台南市柳營區重溪里義士路一段938號',
    縣市: '台南市'
  },
  {
    店號: 965600,
    店名: '麻中',
    地址: '台南市麻豆區南勢里南勢36-205號',
    縣市: '台南市'
  },
  {
    店號: 965611,
    店名: '遠德',
    地址: '台南市新化區北勢里中正路1211號',
    縣市: '台南市'
  },
  {
    店號: 965633,
    店名: '安高',
    地址: '台南市安定區港尾里港子尾37-28號',
    縣市: '台南市'
  },
  {
    店號: 966061,
    店名: '車讚',
    地址: '台南市關廟區北花里中正路517號',
    縣市: '台南市'
  },
  {
    店號: 966212,
    店名: '鹽新',
    地址: '台南市鹽水區橋南里忠孝路93號',
    縣市: '台南市'
  },
  {
    店號: 966290,
    店名: '安安',
    地址: '台南市安南區安明路四段260-70號',
    縣市: '台南市'
  },
  {
    店號: 966957,
    店名: '仁大',
    地址: '台南市仁德區太子里太子路120號122號',
    縣市: '台南市'
  },
  {
    店號: 966991,
    店名: '鹽信',
    地址: '台南市永康區正南一街148號',
    縣市: '台南市'
  },
  {
    店號: 967086,
    店名: '二鎮',
    地址: '台南市官田區二區里工社西街25巷81號',
    縣市: '台南市'
  },
  {
    店號: 967570,
    店名: '永愛',
    地址: '台南市永康區北灣里文賢街80-1號',
    縣市: '台南市'
  },
  {
    店號: 967581,
    店名: '保華',
    地址: '台南市仁德區成功里崇德路88號',
    縣市: '台南市'
  },
  {
    店號: 967639,
    店名: '仁文',
    地址: '台南市東區仁和路57-7號59號1樓',
    縣市: '台南市'
  },
  {
    店號: 967673,
    店名: '桂田',
    地址: '台南市永康區鹽行里新行街251號一樓',
    縣市: '台南市'
  },
  {
    店號: 967891,
    店名: '虎尾寮',
    地址: '台南市仁德區仁德里文德路157號',
    縣市: '台南市'
  },
  {
    店號: 967938,
    店名: '新正賢',
    地址: '台南市仁德區保安里中正路一段209號',
    縣市: '台南市'
  },
  {
    店號: 968104,
    店名: '華平',
    地址: '台南市安平區健康路三段242號',
    縣市: '台南市'
  },
  {
    店號: 968263,
    店名: '新曾文',
    地址: '台南市麻豆區東角里興中路177號179號',
    縣市: '台南市'
  },
  {
    店號: 968780,
    店名: '鯤鯓',
    地址: '台南市南區南都里鯤鯓路20號',
    縣市: '台南市'
  },
  {
    店號: 968805,
    店名: '新永華',
    地址: '台南市中西區永華路一段248號1樓',
    縣市: '台南市'
  },
  {
    店號: 969015,
    店名: '新同安',
    地址: '台南市安南區理想里海佃路二段432號',
    縣市: '台南市'
  },
  {
    店號: 970174,
    店名: '鈺廣',
    地址: '台南市永康區大灣里民族路409號一樓',
    縣市: '台南市'
  },
  {
    店號: 970255,
    店名: '欣奇',
    地址: '台南市新營區新東里東興路236號',
    縣市: '台南市'
  },
  {
    店號: 970266,
    店名: '新凱',
    地址: '台南市新市區社內里12之5號',
    縣市: '台南市'
  },
  {
    店號: 970277,
    店名: '新大內',
    地址: '台南市大內區石城里石子瀨122之153號',
    縣市: '台南市'
  },
  {
    店號: 970358,
    店名: '麻學',
    地址: '台南市麻豆區大山里8鄰大山腳1之80號',
    縣市: '台南市'
  },
  {
    店號: 970819,
    店名: '安立',
    地址: '台南市安南區安中路四段150號',
    縣市: '台南市'
  },
  {
    店號: 971018,
    店名: '關聖',
    地址: '台南市關廟區南雄路一段471號',
    縣市: '台南市'
  },
  {
    店號: 971465,
    店名: '善營',
    地址: '台南市善化區小新里成功路173之1號',
    縣市: '台南市'
  },
  {
    店號: 971487,
    店名: '新吉',
    地址: '台南市安定區新吉里新吉126之12_126之13號',
    縣市: '台南市'
  },
  {
    店號: 971498,
    店名: '少觀',
    地址: '台南市南區大林路113號',
    縣市: '台南市'
  },
  {
    店號: 971878,
    店名: '楠西',
    地址: '台南市楠西區鹿田里11鄰油車61號之10',
    縣市: '台南市'
  },
  {
    店號: 973014,
    店名: '新運河',
    地址: '台南市中西區府前路二段239號1樓',
    縣市: '台南市'
  },
  {
    店號: 978558,
    店名: '慶國',
    地址: '台南市安平區慶平路531號',
    縣市: '台南市'
  },
  {
    店號: 980126,
    店名: '新安順',
    地址: '台南市安南區安和路三段55-1號57號1樓',
    縣市: '台南市'
  },
  {
    店號: 980296,
    店名: '大目降',
    地址: '台南市新化區正新路233號',
    縣市: '台南市'
  },
  {
    店號: 980838,
    店名: '新雙新',
    地址: '台南市新市區永就里中山路227號1樓',
    縣市: '台南市'
  },
  {
    店號: 981602,
    店名: '豐平',
    地址: '台南市安平區平豐路430號1樓',
    縣市: '台南市'
  },
  {
    店號: 982096,
    店名: '新朝琴',
    地址: '台南市鹽水區岸內里朝琴路143號1樓',
    縣市: '台南市'
  },
  {
    店號: 982236,
    店名: '新府緯',
    地址: '台南市南區西門路一段553號1樓',
    縣市: '台南市'
  },
  {
    店號: 982443,
    店名: '寶園',
    地址: '台南市北區元寶里北園街78號78-1號78-2號78-3號1樓',
    縣市: '台南市'
  },
  {
    店號: 982889,
    店名: '新玉馥',
    地址: '台南市玉井區玉田里中山路97號1樓',
    縣市: '台南市'
  },
  {
    店號: 985822,
    店名: '國民',
    地址: '台南市南區國民路152號1樓',
    縣市: '台南市'
  },
  {
    店號: 988223,
    店名: '新郡安',
    地址: '台南市安南區溪北里安和路一段105號1樓',
    縣市: '台南市'
  },
  {
    店號: 990042,
    店名: '新海成',
    地址: '台南市北區海安路三段2號1樓',
    縣市: '台南市'
  },
  {
    店號: 990075,
    店名: '東科',
    地址: '台南市新市區三舍里大順三路125號1樓',
    縣市: '台南市'
  },
  {
    店號: 990156,
    店名: '新佳忠',
    地址: '台南市佳里區安西里忠孝路212號1樓',
    縣市: '台南市'
  },
  {
    店號: 990167,
    店名: '新下營',
    地址: '台南市下營區下營里中山路一段46號48號1樓',
    縣市: '台南市'
  },
  {
    店號: 990271,
    店名: '新裕新',
    地址: '台南市新營區新進路二段90號1樓',
    縣市: '台南市'
  },
  {
    店號: 990499,
    店名: '三村',
    地址: '台南市永康區鹽行里仁愛街68號70號1樓',
    縣市: '台南市'
  },
  {
    店號: 990905,
    店名: '康樂',
    地址: '台南市中西區安海里康樂街223號1樓',
    縣市: '台南市'
  },
  {
    店號: 991643,
    店名: '崇華',
    地址: '台南市東區崇善路259號1樓',
    縣市: '台南市'
  },
  {
    店號: 991849,
    店名: '新科',
    地址: '台南市新市區新市里中興街162號1樓',
    縣市: '台南市'
  },
  {
    店號: 993351,
    店名: '雙永',
    地址: '台南市永康區永大一路60號1樓',
    縣市: '台南市'
  },
  {
    店號: 993384,
    店名: '樹谷',
    地址: '台南市新市區中心路2號1樓',
    縣市: '台南市'
  },
  {
    店號: 996718,
    店名: '東凱',
    地址: '台南市東區東安路102號',
    縣市: '台南市'
  },
  {
    店號: 997504,
    店名: '府安',
    地址: '台南市安南區溪東里北安路二段59號61號',
    縣市: '台南市'
  },
  {
    店號: 997995,
    店名: '瓏埔',
    地址: '台南市永康區龍埔街108號',
    縣市: '台南市'
  },
  {
    店號: 110068,
    店名: '鳳文',
    地址: '高雄市鳳山區文英里文衡路50號1樓',
    縣市: '高雄市'
  },
  {
    店號: 110769,
    店名: '信賢',
    地址: '高雄市新興區南港里七賢一路432號1樓',
    縣市: '高雄市'
  },
  {
    店號: 111382,
    店名: '圓興',
    地址: '高雄市旗山區旗甲路二段373號1樓',
    縣市: '高雄市'
  },
  {
    店號: 111739,
    店名: '勵志',
    地址: '高雄市岡山區筧橋路12號16號1樓',
    縣市: '高雄市'
  },
  {
    店號: 111832,
    店名: '新後昌',
    地址: '高雄市楠梓區錦屏里後昌路115號1樓',
    縣市: '高雄市'
  },
  {
    店號: 111843,
    店名: '學源',
    地址: '高雄市前鎮區三多二路437號439號441號441-1號1樓',
    縣市: '高雄市'
  },
  {
    店號: 112053,
    店名: '神農',
    地址: '高雄市林園區廣應里王公路341號343號',
    縣市: '高雄市'
  },
  {
    店號: 112260,
    店名: '新楠梓',
    地址: '高雄市楠梓區中陽里楠梓新路188號188-1號1樓',
    縣市: '高雄市'
  },
  {
    店號: 113090,
    店名: '統崙',
    地址: '高雄市鳳山區中民里中崙四路6號8號1樓',
    縣市: '高雄市'
  },
  {
    店號: 113481,
    店名: '復中',
    地址: '高雄市苓雅區興中一路138號',
    縣市: '高雄市'
  },
  {
    店號: 113768,
    店名: '大樹',
    地址: '高雄市大樹區樣腳里中興東路7號9號11號13號',
    縣市: '高雄市'
  },
  {
    店號: 114196,
    店名: '鼓波',
    地址: '高雄市鼓山區臨海二路45-1號1樓鼓波街43號1樓',
    縣市: '高雄市'
  },
  {
    店號: 114200,
    店名: '路好',
    地址: '高雄市路竹區大社路162號',
    縣市: '高雄市'
  },
  {
    店號: 114233,
    店名: '上芸',
    地址: '高雄市林園區西溪路133-30號',
    縣市: '高雄市'
  },
  {
    店號: 114602,
    店名: '港后',
    地址: '高雄市小港區平和路156號',
    縣市: '高雄市'
  },
  {
    店號: 115889,
    店名: '武漢',
    地址: '高雄市苓雅區武漢街72號',
    縣市: '高雄市'
  },
  {
    店號: 115904,
    店名: '元隆',
    地址: '高雄市三民區正興里建元路58號1及2樓',
    縣市: '高雄市'
  },
  {
    店號: 115960,
    店名: '臨廣',
    地址: '高雄市前鎮區新生路248-45號',
    縣市: '高雄市'
  },
  {
    店號: 116608,
    店名: '觀亭',
    地址: '高雄市內門區觀亭里南屏路78號',
    縣市: '高雄市'
  },
  {
    店號: 116745,
    店名: '義發',
    地址: '高雄市大寮區義發路7號',
    縣市: '高雄市'
  },
  {
    店號: 117726,
    店名: '宏明',
    地址: '高雄市三民區本和里大福街211號1樓',
    縣市: '高雄市'
  },
  {
    店號: 118741,
    店名: '新漢北',
    地址: '高雄市小港區漢民路132號134號1樓',
    縣市: '高雄市'
  },
  {
    店號: 119618,
    店名: '達勇',
    地址: '高雄市三民區九如二路345-1號',
    縣市: '高雄市'
  },
  {
    店號: 120250,
    店名: '秀昌',
    地址: '高雄市楠梓區後昌路858之2號1樓',
    縣市: '高雄市'
  },
  {
    店號: 120674,
    店名: '夢時代',
    地址: '高雄市前鎮區中華五路789號B2樓',
    縣市: '高雄市'
  },
  {
    店號: 121873,
    店名: '中都',
    地址: '高雄市三民區力行路248號',
    縣市: '高雄市'
  },
  {
    店號: 121965,
    店名: '客宭',
    地址: '高雄市鹽埕區建國四路312號',
    縣市: '高雄市'
  },
  {
    店號: 122485,
    店名: '來家',
    地址: '高雄市鳳山區新強里崗山北街36號38號1樓',
    縣市: '高雄市'
  },
  {
    店號: 122625,
    店名: '仁富',
    地址: '高雄市岡山區大仁路138號',
    縣市: '高雄市'
  },
  {
    店號: 123374,
    店名: '六龜',
    地址: '高雄市六龜區義寶里光復路98號',
    縣市: '高雄市'
  },
  {
    店號: 123385,
    店名: '實大',
    地址: '高雄市內門區內南里大學路200號',
    縣市: '高雄市'
  },
  {
    店號: 124610,
    店名: '得富',
    地址: '高雄市仁武區八卦里八德西路246號',
    縣市: '高雄市'
  },
  {
    店號: 126362,
    店名: '七老爺',
    地址: '高雄市鳳山區正義里鳳甲路491號493號',
    縣市: '高雄市'
  },
  {
    店號: 127099,
    店名: '愛萣',
    地址: '高雄市茄萣區仁愛路二段157號159號161號',
    縣市: '高雄市'
  },
  {
    店號: 127376,
    店名: '八卦寮',
    地址: '高雄市仁武區大灣里八德南路497號499號1樓',
    縣市: '高雄市'
  },
  {
    店號: 127712,
    店名: '欣重文',
    地址: '高雄市左營區重愛路308號310號1樓文天路128號1樓',
    縣市: '高雄市'
  },
  {
    店號: 128612,
    店名: '華堂',
    地址: '高雄市苓雅區廣澤里文橫二路41號',
    縣市: '高雄市'
  },
  {
    店號: 129040,
    店名: '德祥',
    地址: '高雄市楠梓區翠屏里德賢路246號',
    縣市: '高雄市'
  },
  {
    店號: 129198,
    店名: '明星',
    地址: '高雄市新興區自立二路146號',
    縣市: '高雄市'
  },
  {
    店號: 130084,
    店名: '鎮興',
    地址: '高雄市前鎮區鎮興路170號',
    縣市: '高雄市'
  },
  {
    店號: 130246,
    店名: '尚義',
    地址: '高雄市新興區中正二路218號',
    縣市: '高雄市'
  },
  {
    店號: 130279,
    店名: '雄站',
    地址: '高雄市三民區港東里建國二路269號271號',
    縣市: '高雄市'
  },
  {
    店號: 130545,
    店名: '青雅',
    地址: '高雄市苓雅區青年一路6之8及6之9號',
    縣市: '高雄市'
  },
  {
    店號: 131102,
    店名: '桂安',
    地址: '高雄市小港區孔鳳路557號',
    縣市: '高雄市'
  },
  {
    店號: 131319,
    店名: '大坪頂',
    地址: '高雄市小港區坪頂里大平路192號196號1樓',
    縣市: '高雄市'
  },
  {
    店號: 131478,
    店名: '惠民',
    地址: '高雄市楠梓區翠屏里惠民路88號1樓',
    縣市: '高雄市'
  },
  {
    店號: 131489,
    店名: '中民',
    地址: '高雄市燕巢區中民路712號714號',
    縣市: '高雄市'
  },
  {
    店號: 131582,
    店名: '仁樂',
    地址: '高雄市仁武區仁武里仁和街36號',
    縣市: '高雄市'
  },
  {
    店號: 131696,
    店名: '路科',
    地址: '高雄市路竹區社南里大社路42號42之1號46號1樓',
    縣市: '高雄市'
  },
  {
    店號: 131766,
    店名: '五里林',
    地址: '高雄市橋頭區東林里里林東路20號',
    縣市: '高雄市'
  },
  {
    店號: 132138,
    店名: '鼎貴',
    地址: '高雄市三民區鼎貴路146號1樓',
    縣市: '高雄市'
  },
  {
    店號: 132183,
    店名: '新高榮',
    地址: '高雄市左營區福山里榮總路175號1樓',
    縣市: '高雄市'
  },
  {
    店號: 132873,
    店名: '康德',
    地址: '高雄市前鎮區鎮興路8號1樓',
    縣市: '高雄市'
  },
  {
    店號: 135001,
    店名: '瑞福',
    地址: '高雄市左營區裕誠路285號',
    縣市: '高雄市'
  },
  {
    店號: 135274,
    店名: '林德',
    地址: '高雄市苓雅區林南里林德街37號1樓',
    縣市: '高雄市'
  },
  {
    店號: 135746,
    店名: '新保泰',
    地址: '高雄市鳳山區鎮南里龍成路242-1號',
    縣市: '高雄市'
  },
  {
    店號: 135964,
    店名: '港東',
    地址: '高雄市三民區建國二路233號',
    縣市: '高雄市'
  },
  {
    店號: 136004,
    店名: '南華',
    地址: '高雄市鳳山區五甲二路232號',
    縣市: '高雄市'
  },
  {
    店號: 136266,
    店名: '旗海',
    地址: '高雄市旗津區中洲三路579號',
    縣市: '高雄市'
  },
  {
    店號: 136288,
    店名: '工協',
    地址: '高雄市鳳山區埤頂里建國路一段79號1樓',
    縣市: '高雄市'
  },
  {
    店號: 136532,
    店名: '翠屏',
    地址: '高雄市大社區中山路344號346號',
    縣市: '高雄市'
  },
  {
    店號: 136657,
    店名: '美澄',
    地址: '高雄市鳳山區文山里八德路二段116號',
    縣市: '高雄市'
  },
  {
    店號: 136680,
    店名: '鎮昌',
    地址: '高雄市前鎮區鎮海里鎮海路17號1樓',
    縣市: '高雄市'
  },
  {
    店號: 136727,
    店名: '新東專',
    地址: '高雄市湖內區湖東里中山路一段229號',
    縣市: '高雄市'
  },
  {
    店號: 136749,
    店名: '孔鳳',
    地址: '高雄市小港區孔宅里高鳳路332號',
    縣市: '高雄市'
  },
  {
    店號: 137041,
    店名: '高昇',
    地址: '高雄市苓雅區中華四路64號',
    縣市: '高雄市'
  },
  {
    店號: 137616,
    店名: '新鼎吉',
    地址: '高雄市三民區明誠一路381號383號1樓',
    縣市: '高雄市'
  },
  {
    店號: 138561,
    店名: '瑞蓁',
    地址: '高雄市湖內區海埔里信義路4號',
    縣市: '高雄市'
  },
  {
    店號: 138871,
    店名: '彌進',
    地址: '高雄市彌陀區彌陀里進學路33號',
    縣市: '高雄市'
  },
  {
    店號: 139092,
    店名: '鈦旺',
    地址: '高雄市大社區中山路261號',
    縣市: '高雄市'
  },
  {
    店號: 140209,
    店名: '重愛',
    地址: '高雄市左營區民族一路987號',
    縣市: '高雄市'
  },
  {
    店號: 141165,
    店名: '梓聖',
    地址: '高雄市楠梓區瑞屏路80之5號之6號之7號1樓',
    縣市: '高雄市'
  },
  {
    店號: 141637,
    店名: '澄合',
    地址: '高雄市仁武區仁光路165號1樓',
    縣市: '高雄市'
  },
  {
    店號: 142319,
    店名: '鼓山',
    地址: '高雄市鼓山區鼓山二路125之1號127號127之1號1樓',
    縣市: '高雄市'
  },
  {
    店號: 142412,
    店名: '高應大',
    地址: '高雄市燕巢區深中路58號1樓',
    縣市: '高雄市'
  },
  {
    店號: 142711,
    店名: '好鄰居',
    地址: '高雄市內門區內門里內門99之19號',
    縣市: '高雄市'
  },
  {
    店號: 143161,
    店名: '鑫省岡',
    地址: '高雄市岡山區台上里成功路82號1樓',
    縣市: '高雄市'
  },
  {
    店號: 143563,
    店名: '松旅',
    地址: '高雄市小港區山明里松信路88號1樓',
    縣市: '高雄市'
  },
  {
    店號: 143600,
    店名: '新衙',
    地址: '高雄市前鎮區草衙一路41號43號',
    縣市: '高雄市'
  },
  {
    店號: 143909,
    店名: '中仁',
    地址: '高雄市苓雅區興中二路38號1樓',
    縣市: '高雄市'
  },
  {
    店號: 143921,
    店名: '智由',
    地址: '高雄市三民區德智里熱河一街190號192號',
    縣市: '高雄市'
  },
  {
    店號: 144898,
    店名: '天后',
    地址: '高雄市前鎮區后平路87號1樓',
    縣市: '高雄市'
  },
  {
    店號: 146872,
    店名: '南屏',
    地址: '高雄市左營區新下里華夏路256號',
    縣市: '高雄市'
  },
  {
    店號: 148063,
    店名: '春陽',
    地址: '高雄市三民區寶珠里正忠路246號',
    縣市: '高雄市'
  },
  {
    店號: 148225,
    店名: '慶華',
    地址: '高雄市前鎮區光華二路395號',
    縣市: '高雄市'
  },
  {
    店號: 148535,
    店名: '文康',
    地址: '高雄市左營區新光里文康路156號1樓',
    縣市: '高雄市'
  },
  {
    店號: 148661,
    店名: '新鳳松',
    地址: '高雄市鳥松區鳥松里大仁北路2號1樓',
    縣市: '高雄市'
  },
  {
    店號: 148878,
    店名: '東林',
    地址: '高雄市林園區東林西路154號',
    縣市: '高雄市'
  },
  {
    店號: 149136,
    店名: '本元',
    地址: '高雄市三民區建工路317號319號',
    縣市: '高雄市'
  },
  {
    店號: 149387,
    店名: '昌富',
    地址: '高雄市三民區大豐一路151號153號',
    縣市: '高雄市'
  },
  {
    店號: 149516,
    店名: '建強',
    地址: '高雄市三民區建國三路437號',
    縣市: '高雄市'
  },
  {
    店號: 150701,
    店名: '辰皓',
    地址: '高雄市路竹區國昌路312號',
    縣市: '高雄市'
  },
  {
    店號: 151173,
    店名: '吉遠',
    地址: '高雄市三民區安東里吉林街271號',
    縣市: '高雄市'
  },
  {
    店號: 151324,
    店名: '仁慈',
    地址: '高雄市仁武區仁慈里仁慈路169號1樓',
    縣市: '高雄市'
  },
  {
    店號: 151829,
    店名: '華輝',
    地址: '高雄市燕巢區橫山里橫山路59號',
    縣市: '高雄市'
  },
  {
    店號: 151922,
    店名: '環球',
    地址: '高雄市路竹區環球路201之27號',
    縣市: '高雄市'
  },
  {
    店號: 153858,
    店名: '京明',
    地址: '高雄市前鎮區瑞北路54號1樓及B1',
    縣市: '高雄市'
  },
  {
    店號: 153870,
    店名: '宏亮',
    地址: '高雄市小港區宏亮里山明路445號447號壹+貳樓',
    縣市: '高雄市'
  },
  {
    店號: 153881,
    店名: '石潭',
    地址: '高雄市岡山區石潭路258號',
    縣市: '高雄市'
  },
  {
    店號: 153906,
    店名: '尚賀',
    地址: '高雄市仁武區赤山里仁雄路87號1樓',
    縣市: '高雄市'
  },
  {
    店號: 154046,
    店名: '大阪',
    地址: '高雄市三民區建國三路28號30號1樓',
    縣市: '高雄市'
  },
  {
    店號: 154552,
    店名: '中鋼會',
    地址: '高雄市前鎮區忠純里忠勤路23號1樓',
    縣市: '高雄市'
  },
  {
    店號: 154574,
    店名: '日明',
    地址: '高雄市楠梓區楠梓加工出口區第二園區研發路66號3樓',
    縣市: '高雄市'
  },
  {
    店號: 154699,
    店名: '夏義',
    地址: '高雄市左營區福山里華夏路1453號1樓',
    縣市: '高雄市'
  },
  {
    店號: 154792,
    店名: '榮總一',
    地址: '高雄市左營區大中一路386號',
    縣市: '高雄市'
  },
  {
    店號: 154954,
    店名: '沿海',
    地址: '高雄市小港區康莊路178之1號1樓',
    縣市: '高雄市'
  },
  {
    店號: 155407,
    店名: '鳳來',
    地址: '高雄市鳳山區鳳甲路2號',
    縣市: '高雄市'
  },
  {
    店號: 155485,
    店名: '樹科',
    地址: '高雄市燕巢區橫山路90之1號',
    縣市: '高雄市'
  },
  {
    店號: 155669,
    店名: '富田',
    地址: '高雄市林園區林園北路477號1樓',
    縣市: '高雄市'
  },
  {
    店號: 158381,
    店名: '仁美',
    地址: '高雄市鳥松區學堂路18號20號',
    縣市: '高雄市'
  },
  {
    店號: 158484,
    店名: '進學',
    地址: '高雄市左營區左營大路491-1號491-2號491-3號',
    縣市: '高雄市'
  },
  {
    店號: 158679,
    店名: '瑞崗',
    地址: '高雄市前鎮區瑞昌里瑞隆路310號312號',
    縣市: '高雄市'
  },
  {
    店號: 158897,
    店名: '美珍',
    地址: '高雄市鼓山區明誠四路23號',
    縣市: '高雄市'
  },
  {
    店號: 158901,
    店名: '高鳳',
    地址: '高雄市鳳山區忠義里中山西路398號400號',
    縣市: '高雄市'
  },
  {
    店號: 159007,
    店名: '孟新',
    地址: '高雄市左營區自由三路292號',
    縣市: '高雄市'
  },
  {
    店號: 159018,
    店名: '大順',
    地址: '高雄市苓雅區大順三路76號1樓',
    縣市: '高雄市'
  },
  {
    店號: 159074,
    店名: '長興',
    地址: '高雄市前金區瑞源路68號70號72號',
    縣市: '高雄市'
  },
  {
    店號: 159096,
    店名: '維雄',
    地址: '高雄市苓雅區和平一路100號',
    縣市: '高雄市'
  },
  {
    店號: 159247,
    店名: '松興',
    地址: '高雄市小港區松山里高鳳路34-3號34-4號34-5號34-6號',
    縣市: '高雄市'
  },
  {
    店號: 159281,
    店名: '建楠',
    地址: '高雄市楠梓區中陽里建楠路139號',
    縣市: '高雄市'
  },
  {
    店號: 160328,
    店名: '金宏',
    地址: '高雄市小港區順苓里宏平路501號',
    縣市: '高雄市'
  },
  {
    店號: 161491,
    店名: '黃埔',
    地址: '高雄市鳳山區鎮東里光遠路73號',
    縣市: '高雄市'
  },
  {
    店號: 161608,
    店名: '寶民',
    地址: '高雄市三民區寶民里正義路337號',
    縣市: '高雄市'
  },
  {
    店號: 162667,
    店名: '長生',
    地址: '高雄市前金區五福三路54號',
    縣市: '高雄市'
  },
  {
    店號: 162726,
    店名: '仁東',
    地址: '高雄市岡山區大仁北路175號1樓',
    縣市: '高雄市'
  },
  {
    店號: 162896,
    店名: '博河',
    地址: '高雄市三民區熱河二街17號',
    縣市: '高雄市'
  },
  {
    店號: 162933,
    店名: '新盛心',
    地址: '高雄市前鎮區一心二路208號',
    縣市: '高雄市'
  },
  {
    店號: 163475,
    店名: '竹滬',
    地址: '高雄市路竹區華正路390號',
    縣市: '高雄市'
  },
  {
    店號: 163718,
    店名: '燕巢',
    地址: '高雄市燕巢區西燕里中民路612號',
    縣市: '高雄市'
  },
  {
    店號: 164423,
    店名: '德昌',
    地址: '高雄市左營區菜公里文自路236號238號',
    縣市: '高雄市'
  },
  {
    店號: 164526,
    店名: '鳳埤',
    地址: '高雄市鳳山區過埤里過埤路170號',
    縣市: '高雄市'
  },
  {
    店號: 165080,
    店名: '大林蒲',
    地址: '高雄市小港區鳳林路181號',
    縣市: '高雄市'
  },
  {
    店號: 165275,
    店名: '開封',
    地址: '高雄市大寮區大寮路688號',
    縣市: '高雄市'
  },
  {
    店號: 165518,
    店名: '太湖',
    地址: '高雄市湖內區中正路二段158號1樓',
    縣市: '高雄市'
  },
  {
    店號: 165736,
    店名: '新茄萣',
    地址: '高雄市茄萣區茄萣路二段403號1樓',
    縣市: '高雄市'
  },
  {
    店號: 165758,
    店名: '岡燕',
    地址: '高雄市岡山區岡山路264號1樓',
    縣市: '高雄市'
  },
  {
    店號: 165895,
    店名: '新灣',
    地址: '高雄市苓雅區自強三路3號12樓之6.7.8',
    縣市: '高雄市'
  },
  {
    店號: 165910,
    店名: '鼎中',
    地址: '高雄市三民區鼎中路735號737號1樓',
    縣市: '高雄市'
  },
  {
    店號: 166762,
    店名: '博仁',
    地址: '高雄市前金區五福三路97之1號1樓',
    縣市: '高雄市'
  },
  {
    店號: 166784,
    店名: '好正義',
    地址: '高雄市苓雅區正義路195號197號1樓',
    縣市: '高雄市'
  },
  {
    店號: 166810,
    店名: '皓東',
    地址: '高雄市三民區本武里大豐二路489號',
    縣市: '高雄市'
  },
  {
    店號: 166924,
    店名: '美賢',
    地址: '高雄市鼓山區美術東四路430號',
    縣市: '高雄市'
  },
  {
    店號: 167499,
    店名: '華鳳',
    地址: '高雄市鳳山區北昌路10號',
    縣市: '高雄市'
  },
  {
    店號: 167547,
    店名: '欣清心',
    地址: '高雄市楠梓區清豐二路16號',
    縣市: '高雄市'
  },
  {
    店號: 169831,
    店名: '重義',
    地址: '高雄市鹽埕區五福四路83號',
    縣市: '高雄市'
  },
  {
    店號: 170026,
    店名: '新昌',
    地址: '高雄市左營區光輝里後昌路637號639號1樓',
    縣市: '高雄市'
  },
  {
    店號: 170129,
    店名: '清漢',
    地址: '高雄市新興區德望里民生一路154號1樓',
    縣市: '高雄市'
  },
  {
    店號: 170266,
    店名: '明榮',
    地址: '高雄市鼓山區明誠里明華路204號',
    縣市: '高雄市'
  },
  {
    店號: 170532,
    店名: '亮宏',
    地址: '高雄市鳳山區文德里文衡路558號1樓',
    縣市: '高雄市'
  },
  {
    店號: 170808,
    店名: '廣東',
    地址: '高雄市苓雅區四維二路94之21號',
    縣市: '高雄市'
  },
  {
    店號: 171018,
    店名: '鑫漢王',
    地址: '高雄市鹽埕區港都里五福四路265號1樓',
    縣市: '高雄市'
  },
  {
    店號: 171270,
    店名: '晴朗',
    地址: '高雄市苓雅區晴朗里復興二路162號',
    縣市: '高雄市'
  },
  {
    店號: 171513,
    店名: '孝豐',
    地址: '高雄市三民區覺民路238號240號',
    縣市: '高雄市'
  },
  {
    店號: 171579,
    店名: '富凱',
    地址: '高雄市鳳山區新富路385號1樓',
    縣市: '高雄市'
  },
  {
    店號: 173863,
    店名: '凹仔底',
    地址: '高雄市左營區新上里裕誠路448號',
    縣市: '高雄市'
  },
  {
    店號: 173900,
    店名: '仁心',
    地址: '高雄市仁武區考潭里仁心路198-1號1樓',
    縣市: '高雄市'
  },
  {
    店號: 174187,
    店名: '興達港',
    地址: '高雄市茄萣區崎漏里民治路188號',
    縣市: '高雄市'
  },
  {
    店號: 174235,
    店名: '華中',
    地址: '高雄市路竹區竹南里中華路124號',
    縣市: '高雄市'
  },
  {
    店號: 174361,
    店名: '園中',
    地址: '高雄市林園區中門里中門路15-1號',
    縣市: '高雄市'
  },
  {
    店號: 174729,
    店名: '樺鑫',
    地址: '高雄市小港區中安路739號',
    縣市: '高雄市'
  },
  {
    店號: 177108,
    店名: '重惠',
    地址: '高雄市左營區福山里華夏路1152號1樓',
    縣市: '高雄市'
  },
  {
    店號: 177201,
    店名: '武勝',
    地址: '高雄市苓雅區武廟路55號55之1號57號1.2樓59號2樓',
    縣市: '高雄市'
  },
  {
    店號: 177256,
    店名: '藍昌',
    地址: '高雄市楠梓區建昌里後昌路1185號1187號1189號1樓',
    縣市: '高雄市'
  },
  {
    店號: 177290,
    店名: '鑫永年',
    地址: '高雄市三民區安康里九如一路877號',
    縣市: '高雄市'
  },
  {
    店號: 177544,
    店名: '鳳麟',
    地址: '高雄市林園區東林里鳳林路一段169號1樓',
    縣市: '高雄市'
  },
  {
    店號: 177555,
    店名: '順德',
    地址: '高雄市鼓山區龍子里大順一路860號1樓',
    縣市: '高雄市'
  },
  {
    店號: 179735,
    店名: '鼎上',
    地址: '高雄市三民區鼎中路160號1樓',
    縣市: '高雄市'
  },
  {
    店號: 179816,
    店名: '學安',
    地址: '高雄市楠梓區藍田路816號',
    縣市: '高雄市'
  },
  {
    店號: 180300,
    店名: '鳳凌',
    地址: '高雄市鳳山區中山路223.225.227號',
    縣市: '高雄市'
  },
  {
    店號: 180849,
    店名: '明月',
    地址: '高雄市楠梓區楠梓加工區第二園區創意北路1號',
    縣市: '高雄市'
  },
  {
    店號: 180908,
    店名: '日星',
    地址: '高雄市楠梓區德賢路88號',
    縣市: '高雄市'
  },
  {
    店號: 180919,
    店名: '祥嘉',
    地址: '高雄市楠梓區立民路33號',
    縣市: '高雄市'
  },
  {
    店號: 181484,
    店名: '柳橋',
    地址: '高雄市岡山區後協里仁壽路248號',
    縣市: '高雄市'
  },
  {
    店號: 181521,
    店名: '展穫',
    地址: '高雄市阿蓮區中正路897號',
    縣市: '高雄市'
  },
  {
    店號: 181587,
    店名: '雄航',
    地址: '高雄市小港區山東里中山四路2號1樓',
    縣市: '高雄市'
  },
  {
    店號: 181990,
    店名: '梓官',
    地址: '高雄市梓官區和平路278號1樓',
    縣市: '高雄市'
  },
  {
    店號: 182281,
    店名: '後驛',
    地址: '高雄市三民區安和里察哈爾一街148號1樓',
    縣市: '高雄市'
  },
  {
    店號: 182476,
    店名: '光泰',
    地址: '高雄市鳳山區光復路65號1樓(B室)1樓部分',
    縣市: '高雄市'
  },
  {
    店號: 182591,
    店名: '米妃',
    地址: '高雄市仁武區文武里中華路327-1號',
    縣市: '高雄市'
  },
  {
    店號: 182890,
    店名: '鳳中',
    地址: '高雄市三民區建國三路285號1樓',
    縣市: '高雄市'
  },
  {
    店號: 182904,
    店名: '人田',
    地址: '高雄市鼓山區美術東二路7號',
    縣市: '高雄市'
  },
  {
    店號: 183206,
    店名: '澄清湖',
    地址: '高雄市鳳山區青年路二段596號.598巷2.4號1.2樓',
    縣市: '高雄市'
  },
  {
    店號: 183262,
    店名: '建榮',
    地址: '高雄市鼓山區建榮路180號1樓',
    縣市: '高雄市'
  },
  {
    店號: 183387,
    店名: '正發',
    地址: '高雄市大寮區會社里鳳林三路421號',
    縣市: '高雄市'
  },
  {
    店號: 183549,
    店名: '群創八',
    地址: '高雄市路竹區路科十路11號1樓',
    縣市: '高雄市'
  },
  {
    店號: 183712,
    店名: '安合',
    地址: '高雄市楠梓區藍昌路420號',
    縣市: '高雄市'
  },
  {
    店號: 184900,
    店名: '文慈',
    地址: '高雄市左營區福山里重愛路63號65號67號1樓',
    縣市: '高雄市'
  },
  {
    店號: 185040,
    店名: '福海',
    地址: '高雄市苓雅區三多一路239號1樓',
    縣市: '高雄市'
  },
  {
    店號: 185198,
    店名: '得合',
    地址: '高雄市仁武區八德西路1660號',
    縣市: '高雄市'
  },
  {
    店號: 185202,
    店名: '榮夏',
    地址: '高雄市鼓山區華榮路387號1樓',
    縣市: '高雄市'
  },
  {
    店號: 185512,
    店名: '立文',
    地址: '高雄市左營區新上里立文路77號1樓',
    縣市: '高雄市'
  },
  {
    店號: 185693,
    店名: '愛之船',
    地址: '高雄市前金區河東路165號1樓',
    縣市: '高雄市'
  },
  {
    店號: 185752,
    店名: '博瑞',
    地址: '高雄市鳳山區瑞興里博愛路221號223號',
    縣市: '高雄市'
  },
  {
    店號: 185800,
    店名: '大輔',
    地址: '高雄市苓雅區正心里輔仁路333號341號1樓',
    縣市: '高雄市'
  },
  {
    店號: 185914,
    店名: '科工館',
    地址: '高雄市三民區安發里平等路91號93號',
    縣市: '高雄市'
  },
  {
    店號: 186098,
    店名: '宏順',
    地址: '高雄市苓雅區三多一路108.110號',
    縣市: '高雄市'
  },
  {
    店號: 186294,
    店名: '萬應',
    地址: '高雄市苓雅區四維四路190-1號',
    縣市: '高雄市'
  },
  {
    店號: 186308,
    店名: '新鼎祥',
    地址: '高雄市三民區鼎泰里民族一路543巷25號1樓',
    縣市: '高雄市'
  },
  {
    店號: 186375,
    店名: '鳳駿',
    地址: '高雄市鳳山區北門里鳳松路108.110.112號1樓',
    縣市: '高雄市'
  },
  {
    店號: 186397,
    店名: '新本館',
    地址: '高雄市三民區大裕路119號',
    縣市: '高雄市'
  },
  {
    店號: 186456,
    店名: '強泥',
    地址: '高雄市苓雅區自強三路2.6號新光路72.74號',
    縣市: '高雄市'
  },
  {
    店號: 186582,
    店名: '銀光',
    地址: '高雄市苓雅區林圍里光華一路263號',
    縣市: '高雄市'
  },
  {
    店號: 186618,
    店名: '重信',
    地址: '高雄市左營區文川路195號.重建路2號',
    縣市: '高雄市'
  },
  {
    店號: 187493,
    店名: '名言',
    地址: '高雄市小港區鳳森里鳳林路2-18號',
    縣市: '高雄市'
  },
  {
    店號: 187770,
    店名: '金潭',
    地址: '高雄市林園區中厝路125號127號',
    縣市: '高雄市'
  },
  {
    店號: 187851,
    店名: '金山角',
    地址: '高雄市大寮區會社里1鄰鳳林三路1之10號',
    縣市: '高雄市'
  },
  {
    店號: 188393,
    店名: '橋鄰',
    地址: '高雄市橋頭區仕隆里成功南路151號1樓',
    縣市: '高雄市'
  },
  {
    店號: 188429,
    店名: '德中',
    地址: '高雄市楠梓區中和里德中路8號1樓',
    縣市: '高雄市'
  },
  {
    店號: 188625,
    店名: '坎城',
    地址: '高雄市三民區十全一路183號',
    縣市: '高雄市'
  },
  {
    店號: 188658,
    店名: '安華',
    地址: '高雄市左營區明華一路126號',
    縣市: '高雄市'
  },
  {
    店號: 188739,
    店名: '德庄',
    地址: '高雄市大寮區中庄里八德路69號71號73號',
    縣市: '高雄市'
  },
  {
    店號: 188795,
    店名: '華仁',
    地址: '高雄市岡山區仁壽里仁壽路106號',
    縣市: '高雄市'
  },
  {
    店號: 189008,
    店名: '永安',
    地址: '高雄市永安區永安里永安路34號',
    縣市: '高雄市'
  },
  {
    店號: 190019,
    店名: '青文',
    地址: '高雄市鳳山區文衡里文衡路343號',
    縣市: '高雄市'
  },
  {
    店號: 190673,
    店名: '鑫領千',
    地址: '高雄市三民區民族一路94號1+2樓96號1樓',
    縣市: '高雄市'
  },
  {
    店號: 192565,
    店名: '維仁',
    地址: '高雄市岡山區維仁路79號',
    縣市: '高雄市'
  },
  {
    店號: 192598,
    店名: '豐園',
    地址: '高雄市左營區新上里新庄仔路828.830.832.834號',
    縣市: '高雄市'
  },
  {
    店號: 192864,
    店名: '貝殼',
    地址: '高雄市旗津區復興里旗津三路356.358號',
    縣市: '高雄市'
  },
  {
    店號: 193029,
    店名: '美麗島',
    地址: '高雄市新興區中山一路115號(美麗島站內)',
    縣市: '高雄市'
  },
  {
    店號: 193096,
    店名: '百事達',
    地址: '高雄市左營區左營大路155號',
    縣市: '高雄市'
  },
  {
    店號: 193465,
    店名: '生態園',
    地址: '高雄市左營區博愛三路378.380號',
    縣市: '高雄市'
  },
  {
    店號: 193753,
    店名: '名湖',
    地址: '高雄市仁武區八德東路490號',
    縣市: '高雄市'
  },
  {
    店號: 193823,
    店名: '京吉',
    地址: '高雄市仁武區京吉三路103號',
    縣市: '高雄市'
  },
  {
    店號: 194309,
    店名: '方城市',
    地址: '高雄市三民區文濱路22號',
    縣市: '高雄市'
  },
  {
    店號: 194516,
    店名: '瑞賢',
    地址: '高雄市新興區民族二路90號',
    縣市: '高雄市'
  },
  {
    店號: 194778,
    店名: '美朵',
    地址: '高雄市鼓山區美術東四路132號136號1樓',
    縣市: '高雄市'
  },
  {
    店號: 195069,
    店名: '樂仁',
    地址: '高雄市苓雅區樂仁路116號',
    縣市: '高雄市'
  },
  {
    店號: 195427,
    店名: '鳳捷',
    地址: '高雄市大寮區萬丹路151-1號',
    縣市: '高雄市'
  },
  {
    店號: 195542,
    店名: '雄鼎',
    地址: '高雄市仁武區仁雄路346號1樓,348號1-2樓',
    縣市: '高雄市'
  },
  {
    店號: 195667,
    店名: '岡好',
    地址: '高雄市岡山區岡山路612、612-2號1樓',
    縣市: '高雄市'
  },
  {
    店號: 196486,
    店名: '崛星',
    地址: '高雄市新興區五福二路209.211號',
    縣市: '高雄市'
  },
  {
    店號: 196512,
    店名: '路飛',
    地址: '高雄市路竹區竹東里中山路465號',
    縣市: '高雄市'
  },
  {
    店號: 196556,
    店名: '星海灣',
    地址: '高雄市前鎮區中山二路180號及林森三路1號',
    縣市: '高雄市'
  },
  {
    店號: 197238,
    店名: '好事登',
    地址: '高雄市楠梓區鳳楠路235號朝明路233號',
    縣市: '高雄市'
  },
  {
    店號: 197250,
    店名: '慶昌',
    地址: '高雄市楠梓區後昌路722號',
    縣市: '高雄市'
  },
  {
    店號: 197423,
    店名: '正達',
    地址: '高雄市新興區中正三路45號1樓',
    縣市: '高雄市'
  },
  {
    店號: 197548,
    店名: '新元嘉',
    地址: '高雄市林園區港嘴里沿海路三段237號',
    縣市: '高雄市'
  },
  {
    店號: 197881,
    店名: '信科',
    地址: '高雄市左營區重信路601號',
    縣市: '高雄市'
  },
  {
    店號: 197939,
    店名: '星展',
    地址: '高雄市三民區天祥一路88號',
    縣市: '高雄市'
  },
  {
    店號: 197951,
    店名: '雅慶',
    地址: '高雄市苓雅區同慶里同慶路88號90號',
    縣市: '高雄市'
  },
  {
    店號: 198002,
    店名: '德民',
    地址: '高雄市楠梓區海專路400號',
    縣市: '高雄市'
  },
  {
    店號: 198035,
    店名: '玉堂',
    地址: '高雄市左營區曾子路1號',
    縣市: '高雄市'
  },
  {
    店號: 198161,
    店名: '仁雄',
    地址: '高雄市仁武區仁雄路6之11號1樓',
    縣市: '高雄市'
  },
  {
    店號: 198172,
    店名: '光尚',
    地址: '高雄市苓雅區光華一路226號',
    縣市: '高雄市'
  },
  {
    店號: 198390,
    店名: '甲誠',
    地址: '高雄市鳳山區三誠路76.78.80號',
    縣市: '高雄市'
  },
  {
    店號: 198459,
    店名: '新崙',
    地址: '高雄市鳳山區中崙路501.503.505號',
    縣市: '高雄市'
  },
  {
    店號: 198644,
    店名: '彌盛',
    地址: '高雄市彌陀區中正路246號',
    縣市: '高雄市'
  },
  {
    店號: 198806,
    店名: '維新',
    地址: '高雄市永安區維新路121號',
    縣市: '高雄市'
  },
  {
    店號: 198965,
    店名: '常德',
    地址: '高雄市楠梓區清豐里常德路287號',
    縣市: '高雄市'
  },
  {
    店號: 199005,
    店名: '路嘉',
    地址: '高雄市路竹區後鄉路37號1樓之1.2',
    縣市: '高雄市'
  },
  {
    店號: 199326,
    店名: '中芸',
    地址: '高雄市林園區中芸里鳳芸二路57號1樓及鳳芸路3號1樓',
    縣市: '高雄市'
  },
  {
    店號: 199588,
    店名: '嘉好',
    地址: '高雄市梓官區嘉展路370號',
    縣市: '高雄市'
  },
  {
    店號: 200077,
    店名: '民瑞',
    地址: '高雄市前鎮區中山三路106號108號110號1樓',
    縣市: '高雄市'
  },
  {
    店號: 200239,
    店名: '春秋閣',
    地址: '高雄市左營區勝利路110號',
    縣市: '高雄市'
  },
  {
    店號: 200240,
    店名: '瓊林',
    地址: '高雄市燕巢區安招路1059號1樓',
    縣市: '高雄市'
  },
  {
    店號: 200527,
    店名: '合行',
    地址: '高雄市路竹區大同路168.170.170-1號',
    縣市: '高雄市'
  },
  {
    店號: 200882,
    店名: '愛河',
    地址: '高雄市前金區博孝里河東路8號1樓',
    縣市: '高雄市'
  },
  {
    店號: 200918,
    店名: '高美',
    地址: '高雄市鼓山區龍水里美術東二路181號',
    縣市: '高雄市'
  },
  {
    店號: 201092,
    店名: '臨海',
    地址: '高雄市鼓山區臨海二路8號',
    縣市: '高雄市'
  },
  {
    店號: 201162,
    店名: '裕東',
    地址: '高雄市鼓山區裕誠路1946號1樓',
    縣市: '高雄市'
  },
  {
    店號: 201221,
    店名: '華社',
    地址: '高雄市大社區中華路16-66號1.2樓',
    縣市: '高雄市'
  },
  {
    店號: 201324,
    店名: '興陽',
    地址: '高雄市苓雅區復興二路22號',
    縣市: '高雄市'
  },
  {
    店號: 201380,
    店名: '旗廟',
    地址: '高雄市旗津區永安里廟前路12號1樓',
    縣市: '高雄市'
  },
  {
    店號: 201494,
    店名: '中央公',
    地址: '高雄市前金區中山一路11號(中央公園站內)',
    縣市: '高雄市'
  },
  {
    店號: 201519,
    店名: '群弘益',
    地址: '高雄市岡山區碧紅里中山北路2號',
    縣市: '高雄市'
  },
  {
    店號: 201542,
    店名: '彩虹市',
    地址: '高雄市左營區菜公里高鐵路115號1樓',
    縣市: '高雄市'
  },
  {
    店號: 201900,
    店名: '復橫',
    地址: '高雄市新興區復興一路28號30號32號1樓',
    縣市: '高雄市'
  },
  {
    店號: 202132,
    店名: '金富',
    地址: '高雄市楠梓區金和街170號',
    縣市: '高雄市'
  },
  {
    店號: 202165,
    店名: '協和',
    地址: '高雄市鳳山區自由路229號2樓231號1樓2樓',
    縣市: '高雄市'
  },
  {
    店號: 202305,
    店名: '愛仁',
    地址: '高雄市新興區五福二路43號1樓2樓45號1樓2樓',
    縣市: '高雄市'
  },
  {
    店號: 206754,
    店名: '蓮潭',
    地址: '高雄市左營區店仔頂路23.25號',
    縣市: '高雄市'
  },
  {
    店號: 206813,
    店名: '新前鋒',
    地址: '高雄市鼓山區九如四路1999.2001號',
    縣市: '高雄市'
  },
  {
    店號: 206880,
    店名: '赤山',
    地址: '高雄市仁武區仁孝路368號1樓',
    縣市: '高雄市'
  },
  {
    店號: 207296,
    店名: '楠鎮',
    地址: '高雄市楠梓區加昌路600-11號1樓',
    縣市: '高雄市'
  },
  {
    店號: 207458,
    店名: '勇忠',
    地址: '高雄市仁武區仁勇路30號1樓',
    縣市: '高雄市'
  },
  {
    店號: 207469,
    店名: '瑞高',
    地址: '高雄市前鎮區崗山中街255.257號一樓',
    縣市: '高雄市'
  },
  {
    店號: 207481,
    店名: '甲智',
    地址: '高雄市鳳山區甲智路103號',
    縣市: '高雄市'
  },
  {
    店號: 207492,
    店名: '展奇',
    地址: '高雄市鳳山區青年路2段169號1.2樓',
    縣市: '高雄市'
  },
  {
    店號: 207654,
    店名: '高昌',
    地址: '高雄市楠梓區創新路615號',
    縣市: '高雄市'
  },
  {
    店號: 207687,
    店名: '高第一',
    地址: '高雄市楠梓區創新路950號1樓',
    縣市: '高雄市'
  },
  {
    店號: 207698,
    店名: '文漾',
    地址: '高雄市新興區文橫二路164-1號.164-2號',
    縣市: '高雄市'
  },
  {
    店號: 207838,
    店名: '瑞中',
    地址: '高雄市前鎮區崗山中街99之5號',
    縣市: '高雄市'
  },
  {
    店號: 207849,
    店名: '金順',
    地址: '高雄市大社區金龍路380號',
    縣市: '高雄市'
  },
  {
    店號: 207894,
    店名: '盛合',
    地址: '高雄市楠梓區藍田里藍田路72號1樓',
    縣市: '高雄市'
  },
  {
    店號: 207942,
    店名: '建志',
    地址: '高雄市三民區建工路462號一樓',
    縣市: '高雄市'
  },
  {
    店號: 208059,
    店名: '新兆湘',
    地址: '高雄市岡山區介壽路78號',
    縣市: '高雄市'
  },
  {
    店號: 208093,
    店名: '瑞順',
    地址: '高雄市鳳山區瑞興路216號1樓',
    縣市: '高雄市'
  },
  {
    店號: 208185,
    店名: '寶軒',
    地址: '高雄市岡山區仁壽南路100號1樓',
    縣市: '高雄市'
  },
  {
    店號: 208303,
    店名: '鳳儀',
    地址: '高雄市鳳山區頂庄路209號',
    縣市: '高雄市'
  },
  {
    店號: 208336,
    店名: '克強',
    地址: '高雄市苓雅區自強三路156號',
    縣市: '高雄市'
  },
  {
    店號: 208532,
    店名: '文龍',
    地址: '高雄市鳳山區文龍東路199號',
    縣市: '高雄市'
  },
  {
    店號: 208613,
    店名: '興國',
    地址: '高雄市三民區建國二路123號1樓',
    縣市: '高雄市'
  },
  {
    店號: 208749,
    店名: '鳳雄',
    地址: '高雄市燕巢區鳳雄里鳳旗路26-1號',
    縣市: '高雄市'
  },
  {
    店號: 208783,
    店名: '富都',
    地址: '高雄市三民區力行路83.85號',
    縣市: '高雄市'
  },
  {
    店號: 208820,
    店名: '清華',
    地址: '高雄市三民區義華路92號',
    縣市: '高雄市'
  },
  {
    店號: 208989,
    店名: '四季春',
    地址: '高雄市楠梓區鳳楠路82號1樓',
    縣市: '高雄市'
  },
  {
    店號: 208990,
    店名: '龍平',
    地址: '高雄市鳳山區文平街210號',
    縣市: '高雄市'
  },
  {
    店號: 209144,
    店名: '武嶺',
    地址: '高雄市苓雅區武嶺街66號一樓',
    縣市: '高雄市'
  },
  {
    店號: 209188,
    店名: '瑞隆',
    地址: '高雄市前鎮區瑞隆路382.384號1.2樓',
    縣市: '高雄市'
  },
  {
    店號: 209199,
    店名: '路新',
    地址: '高雄市路竹區環球路77-5號',
    縣市: '高雄市'
  },
  {
    店號: 209487,
    店名: '晉興',
    地址: '高雄市楠梓區惠心街80號1樓',
    縣市: '高雄市'
  },
  {
    店號: 209638,
    店名: '光漢',
    地址: '高雄市小港區漢民路755.757號一樓.二樓',
    縣市: '高雄市'
  },
  {
    店號: 209937,
    店名: '侑群',
    地址: '高雄市橋頭區甲昌路227號',
    縣市: '高雄市'
  },
  {
    店號: 209971,
    店名: '靜月',
    地址: '高雄市內門區大學路200號',
    縣市: '高雄市'
  },
  {
    店號: 210409,
    店名: '平等',
    地址: '高雄市三民區九如一路805號',
    縣市: '高雄市'
  },
  {
    店號: 210410,
    店名: '光化',
    地址: '高雄市鼓山區鼓山二路33號',
    縣市: '高雄市'
  },
  {
    店號: 210421,
    店名: '銀川',
    地址: '高雄市鼓山區鼓山三路8-25號1樓',
    縣市: '高雄市'
  },
  {
    店號: 210524,
    店名: '武昌',
    地址: '高雄市苓雅區武昌路77號1樓79號1樓2樓',
    縣市: '高雄市'
  },
  {
    店號: 210683,
    店名: '德龍',
    地址: '高雄市大寮區八德路197號1樓2樓199號',
    縣市: '高雄市'
  },
  {
    店號: 210708,
    店名: '森之丘',
    地址: '高雄市橋頭區橋新七路1號1樓',
    縣市: '高雄市'
  },
  {
    店號: 210959,
    店名: '龍順',
    地址: '高雄市鼓山區龍德路87號',
    縣市: '高雄市'
  },
  {
    店號: 211000,
    店名: '文恩',
    地址: '高雄市左營區福山里自由四路496號',
    縣市: '高雄市'
  },
  {
    店號: 211103,
    店名: '社旺',
    地址: '高雄市大社區大社路30-29號',
    縣市: '高雄市'
  },
  {
    店號: 211114,
    店名: '觀月',
    地址: '高雄市田寮區月球路34-6號',
    縣市: '高雄市'
  },
  {
    店號: 211321,
    店名: '南衙',
    地址: '高雄市前鎮區南衙路47號',
    縣市: '高雄市'
  },
  {
    店號: 211446,
    店名: '肯娣',
    地址: '高雄市岡山區壽華路6號1樓',
    縣市: '高雄市'
  },
  {
    店號: 211480,
    店名: '大強',
    地址: '高雄市鳳山區新強里大明路193號',
    縣市: '高雄市'
  },
  {
    店號: 211664,
    店名: '享順',
    地址: '高雄市鼓山區明華路335號337號',
    縣市: '高雄市'
  },
  {
    店號: 211734,
    店名: '華文',
    地址: '高雄市苓雅區文橫二路2號與文橫二路二巷2號',
    縣市: '高雄市'
  },
  {
    店號: 211778,
    店名: '迦恩',
    地址: '高雄市鳳山區中山東路192巷86號',
    縣市: '高雄市'
  },
  {
    店號: 212003,
    店名: '新博如',
    地址: '高雄市三民區博愛一路1號',
    縣市: '高雄市'
  },
  {
    店號: 212014,
    店名: '蓮馨',
    地址: '高雄市阿蓮區和平路136號',
    縣市: '高雄市'
  },
  {
    店號: 212058,
    店名: '桂誠',
    地址: '高雄市小港區桂園路70號',
    縣市: '高雄市'
  },
  {
    店號: 212162,
    店名: '桃源',
    地址: '高雄市桃源區桃源里北進巷43-1號',
    縣市: '高雄市'
  },
  {
    店號: 212184,
    店名: '昱廣',
    地址: '高雄市左營區自由二路398號1樓400號1樓402號1樓',
    縣市: '高雄市'
  },
  {
    店號: 212368,
    店名: '合莊',
    地址: '高雄市新興區六合二路37號',
    縣市: '高雄市'
  },
  {
    店號: 213556,
    店名: '順苓',
    地址: '高雄市小港區漢民路381號',
    縣市: '高雄市'
  },
  {
    店號: 213741,
    店名: '祥裕',
    地址: '高雄市鼓山區明誠里裕誠路1610號1612號',
    縣市: '高雄市'
  },
  {
    店號: 213800,
    店名: '軟科',
    地址: '高雄市前鎮區復興四路10之1號',
    縣市: '高雄市'
  },
  {
    店號: 213811,
    店名: '大社',
    地址: '高雄市大社區翠屏里三民路304號',
    縣市: '高雄市'
  },
  {
    店號: 213822,
    店名: '左運',
    地址: '高雄市左營區高鐵路107號B1',
    縣市: '高雄市'
  },
  {
    店號: 213970,
    店名: '亞新灣',
    地址: '高雄市前鎮區林森四路255號',
    縣市: '高雄市'
  },
  {
    店號: 214009,
    店名: '延慶',
    地址: '高雄市三民區中民里永年街48號50號52號1樓',
    縣市: '高雄市'
  },
  {
    店號: 214032,
    店名: '鳳仁',
    地址: '高雄市鳳山區鳳仁路174號',
    縣市: '高雄市'
  },
  {
    店號: 214205,
    店名: '樂民',
    地址: '高雄市楠梓區加昌里壽民路60號1樓',
    縣市: '高雄市'
  },
  {
    店號: 214216,
    店名: '光武',
    地址: '高雄市三民區寶德里覺民路338號',
    縣市: '高雄市'
  },
  {
    店號: 214272,
    店名: '鑫程',
    地址: '高雄市岡山區程香里大德二路61號1樓',
    縣市: '高雄市'
  },
  {
    店號: 214342,
    店名: '中義',
    地址: '高雄市新興區六合一路27號',
    縣市: '高雄市'
  },
  {
    店號: 214423,
    店名: '雙興',
    地址: '高雄市三民區正興路1號3號',
    縣市: '高雄市'
  },
  {
    店號: 214593,
    店名: '源隆',
    地址: '高雄市大寮區永芳里進學路103號1樓',
    縣市: '高雄市'
  },
  {
    店號: 214630,
    店名: '正仁',
    地址: '高雄市新興區中正三路84號1樓',
    縣市: '高雄市'
  },
  {
    店號: 215057,
    店名: '昶林',
    地址: '高雄市岡山區仁壽里公園西路三段131號133號',
    縣市: '高雄市'
  },
  {
    店號: 215138,
    店名: '球場',
    地址: '高雄市鳥松區本館路196號1樓',
    縣市: '高雄市'
  },
  {
    店號: 215220,
    店名: '一揚',
    地址: '高雄市路竹區國昌路1號',
    縣市: '高雄市'
  },
  {
    店號: 215781,
    店名: '永泰',
    地址: '高雄市苓雅區苓雅二路243號',
    縣市: '高雄市'
  },
  {
    店號: 215806,
    店名: '九曲堂',
    地址: '高雄市大樹區久堂里城隍巷15-8號',
    縣市: '高雄市'
  },
  {
    店號: 216256,
    店名: '仕豐',
    地址: '高雄市橋頭區仕豐路61號1樓',
    縣市: '高雄市'
  },
  {
    店號: 216278,
    店名: '好事達',
    地址: '高雄市大社區保社里旗楠路71號',
    縣市: '高雄市'
  },
  {
    店號: 216452,
    店名: '新仁政',
    地址: '高雄市苓雅區仁政里青年一路299號301號303號1樓',
    縣市: '高雄市'
  },
  {
    店號: 216474,
    店名: '新崛江',
    地址: '高雄市新興區振成里新田路114號',
    縣市: '高雄市'
  },
  {
    店號: 216511,
    店名: '美庄',
    地址: '高雄市大寮區後庄村成功路43號',
    縣市: '高雄市'
  },
  {
    店號: 216728,
    店名: '大民',
    地址: '高雄市大社區三民路213號',
    縣市: '高雄市'
  },
  {
    店號: 216751,
    店名: '正成',
    地址: '高雄市前鎮區成功二路62號',
    縣市: '高雄市'
  },
  {
    店號: 216832,
    店名: '學高',
    地址: '高雄市楠梓區藍田路962.966號',
    縣市: '高雄市'
  },
  {
    店號: 216957,
    店名: '鳳陽',
    地址: '高雄市鳳山區鳳林路97號1樓',
    縣市: '高雄市'
  },
  {
    店號: 216968,
    店名: '潮欣',
    地址: '高雄市大寮區潮寮里華中南路275號',
    縣市: '高雄市'
  },
  {
    店號: 216979,
    店名: '坪高',
    地址: '高雄市小港區高坪二十二路321號',
    縣市: '高雄市'
  },
  {
    店號: 216980,
    店名: '鑫寶華',
    地址: '高雄市三民區九如一路126號128號130號',
    縣市: '高雄市'
  },
  {
    店號: 217086,
    店名: '海音',
    地址: '高雄市苓雅區海邊路48.48-1.48-2號',
    縣市: '高雄市'
  },
  {
    店號: 217097,
    店名: '慶豐',
    地址: '高雄市鼓山區慶豐街1號',
    縣市: '高雄市'
  },
  {
    店號: 217226,
    店名: '麗景',
    地址: '高雄市楠梓區清豐里旗楠路891號1樓',
    縣市: '高雄市'
  },
  {
    店號: 217329,
    店名: '榮耀',
    地址: '高雄市左營區福山里民族一路1014號1樓',
    縣市: '高雄市'
  },
  {
    店號: 217503,
    店名: '大發',
    地址: '高雄市大寮區振成里鳳林三路322號324號1樓',
    縣市: '高雄市'
  },
  {
    店號: 217514,
    店名: '前中',
    地址: '高雄市大寮區自由路1號',
    縣市: '高雄市'
  },
  {
    店號: 228189,
    店名: '營銓',
    地址: '高雄市左營區重和路226號',
    縣市: '高雄市'
  },
  {
    店號: 228237,
    店名: '新長澄',
    地址: '高雄市鳥松區大埤路123號',
    縣市: '高雄市'
  },
  {
    店號: 228536,
    店名: '超全',
    地址: '高雄市鳳山區海洋一路31號1樓',
    縣市: '高雄市'
  },
  {
    店號: 228606,
    店名: '那瑪夏',
    地址: '高雄市那瑪夏區達卡努瓦里秀嶺巷205-1號',
    縣市: '高雄市'
  },
  {
    店號: 228617,
    店名: '傑森',
    地址: '高雄市苓雅區林森二路19號1樓',
    縣市: '高雄市'
  },
  {
    店號: 228651,
    店名: '苓民',
    地址: '高雄市小港區漢民路219號1樓',
    縣市: '高雄市'
  },
  {
    店號: 228743,
    店名: '文化',
    地址: '高雄市苓雅區五福一路77號1樓',
    縣市: '高雄市'
  },
  {
    店號: 228905,
    店名: '新田',
    地址: '高雄市新興區新田路144號1樓2樓144之1號1樓2樓',
    縣市: '高雄市'
  },
  {
    店號: 229137,
    店名: '王公',
    地址: '高雄市林園區頂厝里田厝路2-1號1樓',
    縣市: '高雄市'
  },
  {
    店號: 229241,
    店名: '彌安',
    地址: '高雄市彌陀區文安路1-1號1樓1-2號1樓',
    縣市: '高雄市'
  },
  {
    店號: 229263,
    店名: '其美',
    地址: '高雄市小港區其美街81號1樓83號1樓83號2樓',
    縣市: '高雄市'
  },
  {
    店號: 229300,
    店名: '連興',
    地址: '高雄市三民區大連街336號1樓',
    縣市: '高雄市'
  },
  {
    店號: 229414,
    店名: '哨臨',
    地址: '高雄市鼓山區臨海二路52號1樓52-1號1樓',
    縣市: '高雄市'
  },
  {
    店號: 229562,
    店名: '鑫巨蛋',
    地址: '高雄市左營區至真路305號1樓2樓',
    縣市: '高雄市'
  },
  {
    店號: 229919,
    店名: '總圖',
    地址: '高雄市前鎮區中華五路1421號',
    縣市: '高雄市'
  },
  {
    店號: 229942,
    店名: '得永',
    地址: '高雄市仁武區八德西路1870-1號1樓',
    縣市: '高雄市'
  },
  {
    店號: 229975,
    店名: '義明',
    地址: '高雄市三民區義華路169號',
    縣市: '高雄市'
  },
  {
    店號: 230115,
    店名: '崗埔',
    地址: '高雄市岡山區華崗里華崗路150號',
    縣市: '高雄市'
  },
  {
    店號: 230311,
    店名: '百君',
    地址: '高雄市前鎮區瑞竹里籬仔內路19號',
    縣市: '高雄市'
  },
  {
    店號: 230377,
    店名: '萬達',
    地址: '高雄市橋頭區經武路60號1樓2樓',
    縣市: '高雄市'
  },
  {
    店號: 230632,
    店名: '瑞盈',
    地址: '高雄市前鎮區瑞北路95號1樓',
    縣市: '高雄市'
  },
  {
    店號: 230702,
    店名: '興庄',
    地址: '高雄市大寮區民族路429號1樓',
    縣市: '高雄市'
  },
  {
    店號: 230791,
    店名: '茂林',
    地址: '高雄市茂林區茂林巷12-6號',
    縣市: '高雄市'
  },
  {
    店號: 230975,
    店名: '惠豐',
    地址: '高雄市楠梓區壽豐路517號519號521號',
    縣市: '高雄市'
  },
  {
    店號: 230997,
    店名: '幸福川',
    地址: '高雄市前金區自強一路149號1樓2樓',
    縣市: '高雄市'
  },
  {
    店號: 231152,
    店名: '福賜',
    地址: '高雄市鼓山區美明路88號',
    縣市: '高雄市'
  },
  {
    店號: 231196,
    店名: '久旺',
    地址: '高雄市大樹區九曲里新鎮路1號1樓',
    縣市: '高雄市'
  },
  {
    店號: 231576,
    店名: '富農',
    地址: '高雄市鼓山區南屏路857號',
    縣市: '高雄市'
  },
  {
    店號: 231602,
    店名: '重德',
    地址: '高雄市左營區政德路585號',
    縣市: '高雄市'
  },
  {
    店號: 231820,
    店名: '竹圍東',
    地址: '高雄市岡山區竹圍東街93號1樓',
    縣市: '高雄市'
  },
  {
    店號: 231842,
    店名: '重福',
    地址: '高雄市左營區重愛路215號',
    縣市: '高雄市'
  },
  {
    店號: 232074,
    店名: '路邦',
    地址: '高雄市路竹區路科五路35號1樓',
    縣市: '高雄市'
  },
  {
    店號: 232144,
    店名: '太子城',
    地址: '高雄市楠梓區楠梓路263號265號267號',
    縣市: '高雄市'
  },
  {
    店號: 232694,
    店名: '鳳邑',
    地址: '高雄市鳳山區維新路97號光明路111號',
    縣市: '高雄市'
  },
  {
    店號: 232753,
    店名: '新後勁',
    地址: '高雄市楠梓區後昌路139-1號',
    縣市: '高雄市'
  },
  {
    店號: 232867,
    店名: '華泰電',
    地址: '高雄市楠梓區中三街9號B2樓',
    縣市: '高雄市'
  },
  {
    店號: 236836,
    店名: '阿蓮',
    地址: '高雄市阿蓮區中山路15號17號19號',
    縣市: '高雄市'
  },
  {
    店號: 236940,
    店名: '華民',
    地址: '高雄市左營區民族一路1084號',
    縣市: '高雄市'
  },
  {
    店號: 237024,
    店名: '新加昌',
    地址: '高雄市楠梓區加昌路275.277號',
    縣市: '高雄市'
  },
  {
    店號: 237079,
    店名: '哈囉',
    地址: '高雄市左營區左營大路676號1樓2樓678號1樓',
    縣市: '高雄市'
  },
  {
    店號: 237390,
    店名: '天山',
    地址: '高雄市前鎮區一心一路406號',
    縣市: '高雄市'
  },
  {
    店號: 237622,
    店名: '泰豐',
    地址: '高雄市前鎮區瑞隆里永豐路1號1樓保泰路353號1樓',
    縣市: '高雄市'
  },
  {
    店號: 237703,
    店名: '山福',
    地址: '高雄市左營區重愛路168號1樓',
    縣市: '高雄市'
  },
  {
    店號: 237806,
    店名: '復興',
    地址: '高雄市前鎮區復興三路150號1樓',
    縣市: '高雄市'
  },
  {
    店號: 237839,
    店名: '新聖明',
    地址: '高雄市前鎮區英明路一號',
    縣市: '高雄市'
  },
  {
    店號: 237884,
    店名: '海青',
    地址: '高雄市鼓山區青海路641號1樓',
    縣市: '高雄市'
  },
  {
    店號: 237987,
    店名: '岡農',
    地址: '高雄市岡山區壽天里公園東路154號',
    縣市: '高雄市'
  },
  {
    店號: 237998,
    店名: '安生',
    地址: '高雄市三民區十全一路74號',
    縣市: '高雄市'
  },
  {
    店號: 238005,
    店名: '藏美',
    地址: '高雄市鼓山區光榮里西藏街6號1樓',
    縣市: '高雄市'
  },
  {
    店號: 238164,
    店名: '新海勝',
    地址: '高雄市左營區翠華路601巷122,126號',
    縣市: '高雄市'
  },
  {
    店號: 238256,
    店名: '長權',
    地址: '高雄市前鎮區民權二路380號1樓',
    縣市: '高雄市'
  },
  {
    店號: 238267,
    店名: '鎮陽',
    地址: '高雄市前鎮區鎮陽里前鎮街278號280號',
    縣市: '高雄市'
  },
  {
    店號: 238393,
    店名: '勝利',
    地址: '高雄市左營區勝利路123號125號1樓',
    縣市: '高雄市'
  },
  {
    店號: 238407,
    店名: '廟東',
    地址: '高雄市左營區左營大路340號',
    縣市: '高雄市'
  },
  {
    店號: 238452,
    店名: '新球庭',
    地址: '高雄市新興區林森一路162號',
    縣市: '高雄市'
  },
  {
    店號: 238588,
    店名: '新上明',
    地址: '高雄市左營區明誠二路318.320號',
    縣市: '高雄市'
  },
  {
    店號: 238751,
    店名: '鳳明',
    地址: '高雄市大寮區新厝里鳳林二路160號',
    縣市: '高雄市'
  },
  {
    店號: 238773,
    店名: '華榮',
    地址: '高雄市鼓山區明倫路149號',
    縣市: '高雄市'
  },
  {
    店號: 238810,
    店名: '美南',
    地址: '高雄市鼓山區龍水二路1.3號',
    縣市: '高雄市'
  },
  {
    店號: 238821,
    店名: '天健',
    地址: '高雄市新興區中山一路279號',
    縣市: '高雄市'
  },
  {
    店號: 238887,
    店名: '正心',
    地址: '高雄市苓雅區正大里輔仁路145號1樓',
    縣市: '高雄市'
  },
  {
    店號: 239101,
    店名: '園東',
    地址: '高雄市林園區東林西路1號3號5號',
    縣市: '高雄市'
  },
  {
    店號: 239178,
    店名: '元茗',
    地址: '高雄市路竹區中正路172號172之1號',
    縣市: '高雄市'
  },
  {
    店號: 239189,
    店名: '旗津',
    地址: '高雄市旗津區海岸路9號',
    縣市: '高雄市'
  },
  {
    店號: 239282,
    店名: '永益',
    地址: '高雄市小港區民益路46號1樓及2樓',
    縣市: '高雄市'
  },
  {
    店號: 239422,
    店名: '新如東',
    地址: '高雄市三民區九如二路86號1樓',
    縣市: '高雄市'
  },
  {
    店號: 239477,
    店名: '鑫愛群',
    地址: '高雄市前鎮區復興三路435號437號',
    縣市: '高雄市'
  },
  {
    店號: 239536,
    店名: '鑫建昌',
    地址: '高雄市楠梓區建昌里右昌街148號',
    縣市: '高雄市'
  },
  {
    店號: 239709,
    店名: '鼎瑞',
    地址: '高雄市三民區鼎泰里裕誠路56號',
    縣市: '高雄市'
  },
  {
    店號: 240008,
    店名: '龍城',
    地址: '高雄市三民區寶安里建興路51號53號1樓',
    縣市: '高雄市'
  },
  {
    店號: 240053,
    店名: '鳳城',
    地址: '高雄市鳳山區杭州西街111號1樓',
    縣市: '高雄市'
  },
  {
    店號: 240064,
    店名: '忠純',
    地址: '高雄市前鎮區忠純里中華五路969巷6號1樓',
    縣市: '高雄市'
  },
  {
    店號: 240156,
    店名: '誠美',
    地址: '高雄市鼓山區龍子里裕誠路2080號',
    縣市: '高雄市'
  },
  {
    店號: 240307,
    店名: '嘉興',
    地址: '高雄市岡山區嘉興路151號1.2樓',
    縣市: '高雄市'
  },
  {
    店號: 240422,
    店名: '東泥',
    地址: '高雄市苓雅區意誠里三多四路93號',
    縣市: '高雄市'
  },
  {
    店號: 240684,
    店名: '獅甲',
    地址: '高雄市前鎮區忠純里中華五路997號正勤路106號1樓',
    縣市: '高雄市'
  },
  {
    店號: 240732,
    店名: '天虹',
    地址: '高雄市鳳山區鎮南里五甲二路744號',
    縣市: '高雄市'
  },
  {
    店號: 240835,
    店名: '鳳南',
    地址: '高雄市鳳山區二甲里鳳南一路25號27號',
    縣市: '高雄市'
  },
  {
    店號: 240846,
    店名: '龍鎮',
    地址: '高雄市鳳山區龍成路58.60.62號',
    縣市: '高雄市'
  },
  {
    店號: 240857,
    店名: '善志',
    地址: '高雄市鳳山區善志街27號',
    縣市: '高雄市'
  },
  {
    店號: 240880,
    店名: '仁忠',
    地址: '高雄市林園區仁愛路129.131.133號',
    縣市: '高雄市'
  },
  {
    店號: 241104,
    店名: '新道明',
    地址: '高雄市苓雅區建國一路211號213號',
    縣市: '高雄市'
  },
  {
    店號: 241285,
    店名: '太華',
    地址: '高雄市前金區成功一路455之1號',
    縣市: '高雄市'
  },
  {
    店號: 241388,
    店名: '鼎強',
    地址: '高雄市三民區鼎金後路432號1樓',
    縣市: '高雄市'
  },
  {
    店號: 241458,
    店名: '新憲德',
    地址: '高雄市前鎮區瑞隆路619號',
    縣市: '高雄市'
  },
  {
    店號: 241470,
    店名: '昭明',
    地址: '高雄市大寮區義仁里鳳林一路51巷5號1樓',
    縣市: '高雄市'
  },
  {
    店號: 241540,
    店名: '都會',
    地址: '高雄市楠梓區惠豐里德民路115號',
    縣市: '高雄市'
  },
  {
    店號: 249016,
    店名: '文信',
    地址: '高雄市鼓山區明誠里南屏路527號529號',
    縣市: '高雄市'
  },
  {
    店號: 249027,
    店名: '豐創',
    地址: '高雄市楠梓區創新路76號78號80號1樓',
    縣市: '高雄市'
  },
  {
    店號: 249050,
    店名: '友福',
    地址: '高雄市仁武區灣內里鳳仁路95之15號',
    縣市: '高雄市'
  },
  {
    店號: 249120,
    店名: '富慶',
    地址: '高雄市左營區富民路65號一.二樓',
    縣市: '高雄市'
  },
  {
    店號: 249131,
    店名: '晉學',
    地址: '高雄市楠梓區大學西路815.817號',
    縣市: '高雄市'
  },
  {
    店號: 249223,
    店名: '新盛',
    地址: '高雄市前金區草江里七賢二路193號193-1號193-2號1樓',
    縣市: '高雄市'
  },
  {
    店號: 249256,
    店名: '尚讚',
    地址: '高雄市仁武區仁雄路97-3號1樓',
    縣市: '高雄市'
  },
  {
    店號: 249290,
    店名: '瑞竹',
    地址: '高雄市鳳山區中山東路209-1及209-2號1樓',
    縣市: '高雄市'
  },
  {
    店號: 249304,
    店名: '理馨',
    地址: '高雄市三民區明吉路9號',
    縣市: '高雄市'
  },
  {
    店號: 249393,
    店名: '武營',
    地址: '高雄市苓雅區武營路433號',
    縣市: '高雄市'
  },
  {
    店號: 249555,
    店名: '龍客',
    地址: '高雄市前金區大同二路1號',
    縣市: '高雄市'
  },
  {
    店號: 249751,
    店名: '仁峰',
    地址: '高雄市岡山區壽峰里前峰路152號之1一樓',
    縣市: '高雄市'
  },
  {
    店號: 249887,
    店名: '三隆',
    地址: '高雄市大寮區光明路二段810號1F',
    縣市: '高雄市'
  },
  {
    店號: 250131,
    店名: '新隆豐',
    地址: '高雄市橋頭區仕隆里隆豐路275號',
    縣市: '高雄市'
  },
  {
    店號: 250142,
    店名: '河堤',
    地址: '高雄市三民區鼎泰里河堤路510號',
    縣市: '高雄市'
  },
  {
    店號: 250164,
    店名: '文建',
    地址: '高雄市鳳山區文福里文化西路35號1樓文建街179號2樓',
    縣市: '高雄市'
  },
  {
    店號: 250212,
    店名: '藍田',
    地址: '高雄市楠梓區藍昌路379號1樓',
    縣市: '高雄市'
  },
  {
    店號: 250382,
    店名: '雙德',
    地址: '高雄市楠梓區翠屏里德惠路66號1樓',
    縣市: '高雄市'
  },
  {
    店號: 250522,
    店名: '台塑',
    地址: '高雄市仁武區竹後里水管路189號191號',
    縣市: '高雄市'
  },
  {
    店號: 250599,
    店名: '美藝',
    地址: '高雄市鼓山區龍水里美術東二路103號1樓',
    縣市: '高雄市'
  },
  {
    店號: 250821,
    店名: '惠心',
    地址: '高雄市楠梓區惠民里高楠公路1764之1號',
    縣市: '高雄市'
  },
  {
    店號: 250876,
    店名: '霖園',
    地址: '高雄市林園區鳳林路一段2號1樓',
    縣市: '高雄市'
  },
  {
    店號: 250979,
    店名: '駁藝',
    地址: '高雄市鹽埕區大勇路29號',
    縣市: '高雄市'
  },
  {
    店號: 251031,
    店名: '鳳屏',
    地址: '高雄市大寮區鳳屏一路564號566號',
    縣市: '高雄市'
  },
  {
    店號: 251101,
    店名: '國勝',
    地址: '高雄市左營區富國路112號116號1樓',
    縣市: '高雄市'
  },
  {
    店號: 251178,
    店名: '國城',
    地址: '高雄市三民區自立一路68號70號',
    縣市: '高雄市'
  },
  {
    店號: 251237,
    店名: '華豐',
    地址: '高雄市鼓山區華豐里裕誠路1160號明倫路138號',
    縣市: '高雄市'
  },
  {
    店號: 251259,
    店名: '鳳新',
    地址: '高雄市鳳山區新康街241號243號245號1樓',
    縣市: '高雄市'
  },
  {
    店號: 251488,
    店名: '文昌',
    地址: '高雄市新興區六合路117號',
    縣市: '高雄市'
  },
  {
    店號: 254513,
    店名: '高苑',
    地址: '高雄市路竹區中山路1821號',
    縣市: '高雄市'
  },
  {
    店號: 831554,
    店名: '旗山',
    地址: '高雄市旗山區中山路72號',
    縣市: '高雄市'
  },
  {
    店號: 832915,
    店名: '鹽埕',
    地址: '高雄市鹽埕區大仁路137號139號1樓瀨南街172號1樓',
    縣市: '高雄市'
  },
  {
    店號: 833000,
    店名: '美田',
    地址: '高雄市苓雅區林森二路79號',
    縣市: '高雄市'
  },
  {
    店號: 833594,
    店名: '自強',
    地址: '高雄市前金區自強二路39號',
    縣市: '高雄市'
  },
  {
    店號: 844893,
    店名: '民強',
    地址: '高雄市鼓山區九如四路706號708號710號712號',
    縣市: '高雄市'
  },
  {
    店號: 854443,
    店名: '中東',
    地址: '高雄市鳳山區中山東路88號',
    縣市: '高雄市'
  },
  {
    店號: 854971,
    店名: '鼎力',
    地址: '高雄市三民區天祥一路124號',
    縣市: '高雄市'
  },
  {
    店號: 855239,
    店名: '嫩江',
    地址: '高雄市三民區嫩江街101號',
    縣市: '高雄市'
  },
  {
    店號: 855295,
    店名: '宏平',
    地址: '高雄市小港區宏平路390號392號',
    縣市: '高雄市'
  },
  {
    店號: 861061,
    店名: '后安',
    地址: '高雄市前鎮區草衙里后安路146號',
    縣市: '高雄市'
  },
  {
    店號: 862190,
    店名: '安冠',
    地址: '高雄市三民區莊敬路289號',
    縣市: '高雄市'
  },
  {
    店號: 864107,
    店名: '覺民',
    地址: '高雄市三民區覺民路113號115號',
    縣市: '高雄市'
  },
  {
    店號: 865421,
    店名: '博正',
    地址: '高雄市左營區忠言路174號',
    縣市: '高雄市'
  },
  {
    店號: 865513,
    店名: '武慶',
    地址: '高雄市鳳山區五武漢里武慶二路52號54號',
    縣市: '高雄市'
  },
  {
    店號: 865627,
    店名: '寶成',
    地址: '高雄市新興區青年一路220號',
    縣市: '高雄市'
  },
  {
    店號: 871828,
    店名: '新建',
    地址: '高雄市鹽埕區建國四路175號',
    縣市: '高雄市'
  },
  {
    店號: 872005,
    店名: '山頂',
    地址: '高雄市大寮區內厝路219號',
    縣市: '高雄市'
  },
  {
    店號: 874104,
    店名: '桂陽',
    地址: '高雄市小港區桂陽路255號1號257巷1號1樓',
    縣市: '高雄市'
  },
  {
    店號: 874610,
    店名: '大洋',
    地址: '高雄市鳳山區大明路142號144號',
    縣市: '高雄市'
  },
  {
    店號: 875440,
    店名: '合平',
    地址: '高雄市苓雅區安祥里六合路60號',
    縣市: '高雄市'
  },
  {
    店號: 875602,
    店名: '賢明',
    地址: '高雄市前鎮區竹內里賢明路3號5號',
    縣市: '高雄市'
  },
  {
    店號: 880394,
    店名: '泰毅',
    地址: '高雄市旗山區太平里旗南一路121號',
    縣市: '高雄市'
  },
  {
    店號: 881685,
    店名: '校和',
    地址: '高雄市楠梓區軍校路658號',
    縣市: '高雄市'
  },
  {
    店號: 885838,
    店名: '文東',
    地址: '高雄市前金區新田路226號228號',
    縣市: '高雄市'
  },
  {
    店號: 892135,
    店名: '華崇',
    地址: '高雄市左營區華夏路672號',
    縣市: '高雄市'
  },
  {
    店號: 892308,
    店名: '英明',
    地址: '高雄市苓雅區英明路190號1樓',
    縣市: '高雄市'
  },
  {
    店號: 892375,
    店名: '鼎復',
    地址: '高雄市三民區鼎山街566-3號',
    縣市: '高雄市'
  },
  {
    店號: 893312,
    店名: '強民',
    地址: '高雄市小港區小港路182號',
    縣市: '高雄市'
  },
  {
    店號: 895880,
    店名: '新立寧',
    地址: '高雄市三民區自立一路287號289號291號1樓',
    縣市: '高雄市'
  },
  {
    店號: 895938,
    店名: '高雄',
    地址: '高雄市前鎮區復興三路116號',
    縣市: '高雄市'
  },
  {
    店號: 895949,
    店名: '港口',
    地址: '高雄市小港區港口里平和路77號',
    縣市: '高雄市'
  },
  {
    店號: 896001,
    店名: '建福',
    地址: '高雄市苓雅區五福里建國一路208號',
    縣市: '高雄市'
  },
  {
    店號: 896481,
    店名: '加群',
    地址: '高雄市楠梓區加昌里40鄰樂群路153號155號1樓',
    縣市: '高雄市'
  },
  {
    店號: 896492,
    店名: '達仁',
    地址: '高雄市三民區吉林街68號',
    縣市: '高雄市'
  },
  {
    店號: 896698,
    店名: '大德',
    地址: '高雄市三民區寶玉里大豐二路348號',
    縣市: '高雄市'
  },
  {
    店號: 896997,
    店名: '中雅',
    地址: '高雄市苓雅區中山二路463號',
    縣市: '高雄市'
  },
  {
    店號: 897886,
    店名: '森鴻',
    地址: '高雄市岡山區大德一路160號',
    縣市: '高雄市'
  },
  {
    店號: 900197,
    店名: '歐士盟',
    地址: '高雄市楠梓區右昌街619號',
    縣市: '高雄市'
  },
  {
    店號: 900577,
    店名: '青建',
    地址: '高雄市鳳山區文福里建國路三段295號',
    縣市: '高雄市'
  },
  {
    店號: 902229,
    店名: '寶來',
    地址: '高雄市六龜區寶來里中正路84號86號',
    縣市: '高雄市'
  },
  {
    店號: 902333,
    店名: '雲崗',
    地址: '高雄市左營區明華一路236號',
    縣市: '高雄市'
  },
  {
    店號: 902425,
    店名: '鳳東',
    地址: '高雄市鳳山區和德里中山路63號',
    縣市: '高雄市'
  },
  {
    店號: 902735,
    店名: '如龍',
    地址: '高雄市三民區九如一路446號448號臥龍路67號',
    縣市: '高雄市'
  },
  {
    店號: 903901,
    店名: '新永光',
    地址: '高雄市旗山區南洲里旗南二路91之1號',
    縣市: '高雄市'
  },
  {
    店號: 904041,
    店名: '心日',
    地址: '高雄市前鎮區忠誠路213號',
    縣市: '高雄市'
  },
  {
    店號: 906335,
    店名: '鳳曹',
    地址: '高雄市鳳山區曹公里曹公路59號',
    縣市: '高雄市'
  },
  {
    店號: 909194,
    店名: '揚揚',
    地址: '高雄市前鎮區民權里鄭和路67號1F',
    縣市: '高雄市'
  },
  {
    店號: 909518,
    店名: '翠峰',
    地址: '高雄市左營區翠峰路34號',
    縣市: '高雄市'
  },
  {
    店號: 911108,
    店名: '新林眾',
    地址: '高雄市旗山區延平一路78-1號',
    縣市: '高雄市'
  },
  {
    店號: 911555,
    店名: '德新',
    地址: '高雄市前鎮區仁愛里新衙路83號85號',
    縣市: '高雄市'
  },
  {
    店號: 911636,
    店名: '興壇',
    地址: '高雄市美濃區中壇里忠孝路一段1號',
    縣市: '高雄市'
  },
  {
    店號: 911854,
    店名: '旗鳳',
    地址: '高雄市燕巢區鳳雄里鳳旗路167號169號',
    縣市: '高雄市'
  },
  {
    店號: 912145,
    店名: '昶玖',
    地址: '高雄市鼓山區九如四路927號929號931號1樓',
    縣市: '高雄市'
  },
  {
    店號: 913067,
    店名: '廣昌',
    地址: '高雄市楠梓區廣昌里廣昌街140號',
    縣市: '高雄市'
  },
  {
    店號: 913193,
    店名: '正美',
    地址: '高雄市美濃區泰安里中正路一段21號23號',
    縣市: '高雄市'
  },
  {
    店號: 913584,
    店名: '利明',
    地址: '高雄市岡山區壽峰里前峰路80號',
    縣市: '高雄市'
  },
  {
    店號: 914244,
    店名: '蓮山',
    地址: '高雄市阿蓮區民生路92號',
    縣市: '高雄市'
  },
  {
    店號: 914347,
    店名: '興達',
    地址: '高雄市茄萣區茄萣路一段350號',
    縣市: '高雄市'
  },
  {
    店號: 916402,
    店名: '達家',
    地址: '高雄市前鎮區草衙里草衙二路407號',
    縣市: '高雄市'
  },
  {
    店號: 920582,
    店名: '新新賢',
    地址: '高雄市新興區開平里七賢一路268號270號',
    縣市: '高雄市'
  },
  {
    店號: 921172,
    店名: '家恩',
    地址: '高雄市仁武區中華路46號',
    縣市: '高雄市'
  },
  {
    店號: 922267,
    店名: '上德',
    地址: '高雄市前鎮區草衙里草衙二路299號299-1號',
    縣市: '高雄市'
  },
  {
    店號: 922496,
    店名: '明仁',
    地址: '高雄市三民區鼎泰里明仁路8號',
    縣市: '高雄市'
  },
  {
    店號: 922500,
    店名: '崗正',
    地址: '高雄市前鎮區瑞平里公正路25號',
    縣市: '高雄市'
  },
  {
    店號: 923662,
    店名: '永仁',
    地址: '高雄市仁武區八卦里永仁街436號',
    縣市: '高雄市'
  },
  {
    店號: 928597,
    店名: '前金',
    地址: '高雄市前金區自強二路172號',
    縣市: '高雄市'
  },
  {
    店號: 928612,
    店名: '大港埔',
    地址: '高雄市新興區東坡里大同一路81號83號',
    縣市: '高雄市'
  },
  {
    店號: 929028,
    店名: '大富',
    地址: '高雄市左營區大順一路278號280號',
    縣市: '高雄市'
  },
  {
    店號: 930062,
    店名: '建泰',
    地址: '高雄市鳳山區誠義路2號',
    縣市: '高雄市'
  },
  {
    店號: 930660,
    店名: '宏華',
    地址: '高雄市小港區松舍里漢民路829號',
    縣市: '高雄市'
  },
  {
    店號: 932172,
    店名: '路園',
    地址: '高雄市路竹區下坑里太平路342-2號',
    縣市: '高雄市'
  },
  {
    店號: 932965,
    店名: '新統興',
    地址: '高雄市三民區黃興路151號',
    縣市: '高雄市'
  },
  {
    店號: 932976,
    店名: '鼎新',
    地址: '高雄市三民區鼎新路82號86號88號1樓',
    縣市: '高雄市'
  },
  {
    店號: 935621,
    店名: '建武',
    地址: '高雄市鳳山區武松里建國路二段2號',
    縣市: '高雄市'
  },
  {
    店號: 935768,
    店名: '內惟',
    地址: '高雄市鼓山區九如四路1432號1434號',
    縣市: '高雄市'
  },
  {
    店號: 935816,
    店名: '市賢',
    地址: '高雄市前金區市中一路242號',
    縣市: '高雄市'
  },
  {
    店號: 935883,
    店名: '德賢',
    地址: '高雄市楠梓區翠屏里德賢路594號596號',
    縣市: '高雄市'
  },
  {
    店號: 941051,
    店名: '京富',
    地址: '高雄市仁武區八卦里八德南路382號1樓',
    縣市: '高雄市'
  },
  {
    店號: 941198,
    店名: '正修',
    地址: '高雄市鳥松區鳥松里澄清路840號',
    縣市: '高雄市'
  },
  {
    店號: 942755,
    店名: '翔富',
    地址: '高雄市鳳山區文德里濱山街12號1樓',
    縣市: '高雄市'
  },
  {
    店號: 942847,
    店名: '俊瑋',
    地址: '高雄市鳳山區忠義里光復路一段193號',
    縣市: '高雄市'
  },
  {
    店號: 944360,
    店名: '月美',
    地址: '高雄市杉林區月眉里清水路46號46號之1.48號1樓',
    縣市: '高雄市'
  },
  {
    店號: 946207,
    店名: '益昌',
    地址: '高雄市三民區九如二路582號',
    縣市: '高雄市'
  },
  {
    店號: 946458,
    店名: '大義',
    地址: '高雄市三民區大昌二路123號123-1號',
    縣市: '高雄市'
  },
  {
    店號: 946997,
    店名: '新大豐',
    地址: '高雄市三民區正忠路259號',
    縣市: '高雄市'
  },
  {
    店號: 947244,
    店名: '甲圍',
    地址: '高雄市橋頭區甲北里甲圍路71號',
    縣市: '高雄市'
  },
  {
    店號: 948708,
    店名: '興村',
    地址: '高雄市新興區五福二路92號',
    縣市: '高雄市'
  },
  {
    店號: 950387,
    店名: '溪埔',
    地址: '高雄市大樹區溪埔里溪埔路369號370號',
    縣市: '高雄市'
  },
  {
    店號: 950479,
    店名: '千湖',
    地址: '高雄市湖內區葉厝里保生路135號137號',
    縣市: '高雄市'
  },
  {
    店號: 950480,
    店名: '北岡山',
    地址: '高雄市岡山區灣裡里岡山北路150號',
    縣市: '高雄市'
  },
  {
    店號: 950664,
    店名: '台興',
    地址: '高雄市岡山區台上里嘉新東路136號',
    縣市: '高雄市'
  },
  {
    店號: 950697,
    店名: '新鎮',
    地址: '高雄市大樹區九曲里九曲路99號',
    縣市: '高雄市'
  },
  {
    店號: 951782,
    店名: '文自',
    地址: '高雄市左營區菜公里文自路512-1號',
    縣市: '高雄市'
  },
  {
    店號: 951988,
    店名: '盛田',
    地址: '高雄市楠梓區享平里興楠路326號',
    縣市: '高雄市'
  },
  {
    店號: 952741,
    店名: '元昌',
    地址: '高雄市楠梓區國昌里德民路900號902號',
    縣市: '高雄市'
  },
  {
    店號: 952822,
    店名: '仁馨',
    地址: '高雄市梓官區梓義里中崙路287號',
    縣市: '高雄市'
  },
  {
    店號: 952969,
    店名: '重和',
    地址: '高雄市左營區福山里自由四路171號',
    縣市: '高雄市'
  },
  {
    店號: 953065,
    店名: '雄鎮',
    地址: '高雄市前鎮區東一街7號',
    縣市: '高雄市'
  },
  {
    店號: 953869,
    店名: '牛潮埔',
    地址: '高雄市鳳山區鎮北里鳳北路60之17號',
    縣市: '高雄市'
  },
  {
    店號: 953940,
    店名: '博真',
    地址: '高雄市左營區新中里博愛三路16號',
    縣市: '高雄市'
  },
  {
    店號: 954208,
    店名: '米奇',
    地址: '高雄市大寮區大寮里大寮路903號',
    縣市: '高雄市'
  },
  {
    店號: 954378,
    店名: '維洲',
    地址: '高雄市岡山區本洲里本洲路350-5號',
    縣市: '高雄市'
  },
  {
    店號: 954530,
    店名: '蕙馨',
    地址: '高雄市阿蓮區阿蓮里中正路188-8號',
    縣市: '高雄市'
  },
  {
    店號: 954666,
    店名: '湖慧',
    地址: '高雄市湖內區中山路一段540-1號',
    縣市: '高雄市'
  },
  {
    店號: 954781,
    店名: '安招',
    地址: '高雄市燕巢區安招里安東街380號',
    縣市: '高雄市'
  },
  {
    店號: 956167,
    店名: '鳳和',
    地址: '高雄市鳳山區中和里自由路204號206號',
    縣市: '高雄市'
  },
  {
    店號: 956477,
    店名: '灣勝',
    地址: '高雄市三民區新民路101號103號105號',
    縣市: '高雄市'
  },
  {
    店號: 958440,
    店名: '港瑞',
    地址: '高雄市小港區小港里小港路77號',
    縣市: '高雄市'
  },
  {
    店號: 960007,
    店名: '港新',
    地址: '高雄市三民區建國一路417號',
    縣市: '高雄市'
  },
  {
    店號: 960029,
    店名: '仁勇',
    地址: '高雄市鹽埕區大公路二號',
    縣市: '高雄市'
  },
  {
    店號: 960133,
    店名: '亞新',
    地址: '高雄市楠梓區樂群路76號',
    縣市: '高雄市'
  },
  {
    店號: 960731,
    店名: '寶盛',
    地址: '高雄市三民區覺民路579號',
    縣市: '高雄市'
  },
  {
    店號: 960764,
    店名: '瑞正',
    地址: '高雄市前鎮區瑞興里瑞北路157號159號',
    縣市: '高雄市'
  },
  {
    店號: 963349,
    店名: '政德',
    地址: '高雄市左營區政德路130號132號1F',
    縣市: '高雄市'
  },
  {
    店號: 965231,
    店名: '程香',
    地址: '高雄市岡山區後紅里大仁南路133號',
    縣市: '高雄市'
  },
  {
    店號: 966119,
    店名: '宏文',
    地址: '高雄市小港區泰山里宏平路83-2號',
    縣市: '高雄市'
  },
  {
    店號: 966359,
    店名: '順屏',
    地址: '高雄市鼓山區龍子里大順一路825號',
    縣市: '高雄市'
  },
  {
    店號: 966533,
    店名: '旗盟',
    地址: '高雄市旗山區大德里延平一路710-1號',
    縣市: '高雄市'
  },
  {
    店號: 966902,
    店名: '久昌',
    地址: '高雄市楠梓區久昌里盛昌街26,28號',
    縣市: '高雄市'
  },
  {
    店號: 966980,
    店名: '北嶺',
    地址: '高雄市路竹區北嶺里中山南路221號',
    縣市: '高雄市'
  },
  {
    店號: 967237,
    店名: '森和',
    地址: '高雄市鳳山區南和里16鄰林森路203號',
    縣市: '高雄市'
  },
  {
    店號: 967503,
    店名: '正港',
    地址: '高雄市梓官區智蚵里中正路186號',
    縣市: '高雄市'
  },
  {
    店號: 967606,
    店名: '東敏',
    地址: '高雄市湖內區湖東里東方路103-1號103-2號',
    縣市: '高雄市'
  },
  {
    店號: 968067,
    店名: '龍肚',
    地址: '高雄市美濃區龍山里中華路58號1樓',
    縣市: '高雄市'
  },
  {
    店號: 968458,
    店名: '赤東',
    地址: '高雄市梓官區赤東里赤崁南路95號95-1號1F',
    縣市: '高雄市'
  },
  {
    店號: 968757,
    店名: '荖濃',
    地址: '高雄市六龜區荖濃里南橫路45號1F',
    縣市: '高雄市'
  },
  {
    店號: 968908,
    店名: '友情',
    地址: '高雄市岡山區大遼里大遼路122-3號',
    縣市: '高雄市'
  },
  {
    店號: 970299,
    店名: '柯達',
    地址: '高雄市美濃區中正路二段819號821號1樓',
    縣市: '高雄市'
  },
  {
    店號: 970462,
    店名: '新宏昌',
    地址: '高雄市楠梓區裕昌里右昌街468號1樓',
    縣市: '高雄市'
  },
  {
    店號: 970761,
    店名: '沅興',
    地址: '高雄市三民區正興里正興路121號123號',
    縣市: '高雄市'
  },
  {
    店號: 970886,
    店名: '新舍東',
    地址: '高雄市梓官區大舍里大舍南路2號1樓',
    縣市: '高雄市'
  },
  {
    店號: 970945,
    店名: '新旗聖',
    地址: '高雄市旗津區中洲二路83號85號',
    縣市: '高雄市'
  },
  {
    店號: 970956,
    店名: '亞熱帶',
    地址: '高雄市梓官區典寶里大舍南路175號',
    縣市: '高雄市'
  },
  {
    店號: 971085,
    店名: '先鋒',
    地址: '高雄市左營區介壽路247號249號1樓',
    縣市: '高雄市'
  },
  {
    店號: 971339,
    店名: '桂德',
    地址: '高雄市小港區桂林里中安路428號',
    縣市: '高雄市'
  },
  {
    店號: 971502,
    店名: '新三華',
    地址: '高雄市新興區中東里復興一路72號1樓',
    縣市: '高雄市'
  },
  {
    店號: 971557,
    店名: '翔盛',
    地址: '高雄市鳥松區水土埔里神農路479號',
    縣市: '高雄市'
  },
  {
    店號: 971708,
    店名: '雄捷',
    地址: '高雄市前鎮區中山二路268號B1(高雄捷運R8站)',
    縣市: '高雄市'
  },
  {
    店號: 972158,
    店名: '田金',
    地址: '高雄市小港區山明里水秀路59號',
    縣市: '高雄市'
  },
  {
    店號: 972309,
    店名: '展欣',
    地址: '高雄市茄萣區嘉安里仁愛路三段120號',
    縣市: '高雄市'
  },
  {
    店號: 972516,
    店名: '新旗美',
    地址: '高雄市旗山區東平里延平二路136號',
    縣市: '高雄市'
  },
  {
    店號: 973117,
    店名: '巨漢',
    地址: '高雄市左營區新下里新莊一路350號',
    縣市: '高雄市'
  },
  {
    店號: 978123,
    店名: '仕隆',
    地址: '高雄市橋頭區白樹里32鄰白樹路53號',
    縣市: '高雄市'
  },
  {
    店號: 979089,
    店名: '柴山',
    地址: '高雄市鼓山區鼓山三路49號51號',
    縣市: '高雄市'
  },
  {
    店號: 980229,
    店名: '新旺淇',
    地址: '高雄市三民區建國三路169號1樓',
    縣市: '高雄市'
  },
  {
    店號: 980252,
    店名: '鳳頂',
    地址: '高雄市鳳山區過埤里鳳頂路285號1樓',
    縣市: '高雄市'
  },
  {
    店號: 980403,
    店名: '高銀',
    地址: '高雄市新興區六合一路158號',
    縣市: '高雄市'
  },
  {
    店號: 980702,
    店名: '月光山',
    地址: '高雄市美濃區泰安里泰安路59號',
    縣市: '高雄市'
  },
  {
    店號: 981015,
    店名: '新甲仙',
    地址: '高雄市甲仙區西安里文化路56號58號1樓',
    縣市: '高雄市'
  },
  {
    店號: 981026,
    店名: '新新甲',
    地址: '高雄市鳳山區海洋里海洋二路57號59號1樓',
    縣市: '高雄市'
  },
  {
    店號: 981093,
    店名: '新光和',
    地址: '高雄市前鎮區鄭和南路307號309號',
    縣市: '高雄市'
  },
  {
    店號: 981211,
    店名: '新景有',
    地址: '高雄市苓雅區福德三路170號1樓',
    縣市: '高雄市'
  },
  {
    店號: 981509,
    店名: '益慶',
    地址: '高雄市大寮區河堤路1段139號',
    縣市: '高雄市'
  },
  {
    店號: 981613,
    店名: '鑫博',
    地址: '高雄市鼓山區明誠里博愛二路345號1樓',
    縣市: '高雄市'
  },
  {
    店號: 981820,
    店名: '鑫明莊',
    地址: '高雄市新興區六合二路24號',
    縣市: '高雄市'
  },
  {
    店號: 982317,
    店名: '旗皇',
    地址: '高雄市旗津區中華里旗津三路900巷1號3號',
    縣市: '高雄市'
  },
  {
    店號: 982502,
    店名: '欣福誠',
    地址: '高雄市鳳山區五福里五甲三路75號77號1樓',
    縣市: '高雄市'
  },
  {
    店號: 982694,
    店名: '三福',
    地址: '高雄市仁武區仁武里中正路175號1樓',
    縣市: '高雄市'
  },
  {
    店號: 990097,
    店名: '新上緯',
    地址: '高雄市岡山區嘉興里嘉興路340號',
    縣市: '高雄市'
  },
  {
    店號: 990134,
    店名: '興安邦',
    地址: '高雄市三民區安邦里察哈爾二街83號1樓.85號1樓',
    縣市: '高雄市'
  },
  {
    店號: 990237,
    店名: '農神',
    地址: '高雄市鼓山區龍子里神農路183號185號1樓',
    縣市: '高雄市'
  },
  {
    店號: 990570,
    店名: '海科大',
    地址: '高雄市楠梓區海專路143號145號1樓',
    縣市: '高雄市'
  },
  {
    店號: 990662,
    店名: '興仁',
    地址: '高雄市鳳山區興仁里五甲一路204號206號1樓',
    縣市: '高雄市'
  },
  {
    店號: 990732,
    店名: '文衡',
    地址: '高雄市鳳山區文衡里八德路305號1樓',
    縣市: '高雄市'
  },
  {
    店號: 991171,
    店名: '新有光',
    地址: '高雄市三民區有光路123號.125號.127號',
    縣市: '高雄市'
  },
  {
    店號: 991285,
    店名: '正文',
    地址: '高雄市苓雅區正大里建國一路125號125-1號1樓',
    縣市: '高雄市'
  },
  {
    店號: 991528,
    店名: '竹中',
    地址: '高雄市前鎮區和平二路242號1樓',
    縣市: '高雄市'
  },
  {
    店號: 991573,
    店名: '觀音',
    地址: '高雄市大社區大新路111號金龍路316號318號',
    縣市: '高雄市'
  },
  {
    店號: 992761,
    店名: '永芳',
    地址: '高雄市大寮區永芳里萬丹路630號',
    縣市: '高雄市'
  },
  {
    店號: 993177,
    店名: '永久',
    地址: '高雄市旗山區延平一路446號1樓',
    縣市: '高雄市'
  },
  {
    店號: 993317,
    店名: '德文',
    地址: '高雄市鳳山區文山里八德路197號',
    縣市: '高雄市'
  },
  {
    店號: 996280,
    店名: '登發',
    地址: '高雄市仁武區八卦里八德南路65號',
    縣市: '高雄市'
  },
  {
    店號: 996349,
    店名: '長青',
    地址: '高雄市鳥松區大智路5號7號1樓',
    縣市: '高雄市'
  },
  {
    店號: 996589,
    店名: '海新',
    地址: '高雄市鳳山區國隆里新富路590巷13號15號',
    縣市: '高雄市'
  },
  {
    店號: 996682,
    店名: '青盛',
    地址: '高雄市前金區大同一路268號1樓',
    縣市: '高雄市'
  },
  {
    店號: 996899,
    店名: '建興',
    地址: '高雄市新興區七賢二路86號',
    縣市: '高雄市'
  },
  {
    店號: 998091,
    店名: '傳生',
    地址: '高雄市阿蓮區中正路407號',
    縣市: '高雄市'
  },
  {
    店號: 110253,
    店名: '僑德',
    地址: '屏東縣枋寮鄉安樂村中山路143號145號147號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 110275,
    店名: '家的',
    地址: '屏東縣恆春鎮城南里中正路67號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 110530,
    店名: '廣大',
    地址: '屏東縣屏東市仁愛里廣東路561號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 110895,
    店名: '公華',
    地址: '屏東縣屏東市龍華里龍華路152號156號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 111957,
    店名: '長治',
    地址: '屏東縣長治鄉新潭村長興路13號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 112307,
    店名: '社上',
    地址: '屏東縣萬丹鄉社中村社皮路三段246號248號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 112787,
    店名: '滿州',
    地址: '屏東縣滿州鄉滿州村中山路56號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 114130,
    店名: '恆春',
    地址: '屏東縣恆春鎮網紗里省北路45號47號49號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 115915,
    店名: '新楓港',
    地址: '屏東縣枋山鄉楓港村舊庄路51之2號3號4號',
    縣市: '屏東縣'
  },
  {
    店號: 116789,
    店名: '鎮海',
    地址: '屏東縣東港鎮鎮海里鎮海路1-100號',
    縣市: '屏東縣'
  },
  {
    店號: 119331,
    店名: '隆德',
    地址: '屏東縣潮州鎮永春里興隆路157-2號',
    縣市: '屏東縣'
  },
  {
    店號: 119641,
    店名: '咚咚',
    地址: '屏東縣恆春鎮墾丁里墾丁路333號',
    縣市: '屏東縣'
  },
  {
    店號: 119685,
    店名: '丹榮',
    地址: '屏東縣萬丹鄉萬全村丹榮路625號',
    縣市: '屏東縣'
  },
  {
    店號: 120973,
    店名: '欣佳和',
    地址: '屏東縣萬巒鄉佳和村佳興路38之9號',
    縣市: '屏東縣'
  },
  {
    店號: 121138,
    店名: '內埔',
    地址: '屏東縣內埔鄉內田村光明路224號226號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 122382,
    店名: '白燈塔',
    地址: '屏東縣琉球鄉三民區大福村中正路303之2號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 122810,
    店名: '三多利',
    地址: '屏東縣九如鄉大坵村九如路三段56號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 123271,
    店名: '日日春',
    地址: '屏東縣恆春鎮城北里中正路193號',
    縣市: '屏東縣'
  },
  {
    店號: 126269,
    店名: '崇蘭',
    地址: '屏東縣屏東市潭漧里廣東路1588號1590號',
    縣市: '屏東縣'
  },
  {
    店號: 126395,
    店名: '新潭',
    地址: '屏東縣長治鄉新潭村長興路326號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 128999,
    店名: '永大',
    地址: '屏東縣屏東市大武路122號124號',
    縣市: '屏東縣'
  },
  {
    店號: 130291,
    店名: '永盛',
    地址: '屏東縣鹽埔鄉鹽中村勝利路81之3號',
    縣市: '屏東縣'
  },
  {
    店號: 131238,
    店名: '社皮',
    地址: '屏東縣萬丹鄉大昌路552號556號',
    縣市: '屏東縣'
  },
  {
    店號: 131331,
    店名: '頭目',
    地址: '屏東縣三地門鄉三地村中正路二段3號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 131412,
    店名: '鼎東',
    地址: '屏東縣東港鎮興東里中正路二段491號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 132600,
    店名: '彭城',
    地址: '屏東縣潮州鎮潮州路512-3號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 135676,
    店名: '信億',
    地址: '屏東縣麟洛鄉麟蹄村中山路166號166-1號166-2號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 136255,
    店名: '崇武',
    地址: '屏東縣屏東市崇武里華盛街5-6號',
    縣市: '屏東縣'
  },
  {
    店號: 136750,
    店名: '新豐榮',
    地址: '屏東縣屏東市豐源里廣東路86號',
    縣市: '屏東縣'
  },
  {
    店號: 137605,
    店名: '安泰',
    地址: '屏東縣東港鎮興東里中正路一段206號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 137627,
    店名: '愛買',
    地址: '屏東縣屏東市清溪里清寧街2號',
    縣市: '屏東縣'
  },
  {
    店號: 141257,
    店名: '船帆石',
    地址: '屏東縣恆春鎮船帆路720號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 142180,
    店名: '長春',
    地址: '屏東縣東港鎮興東里長春一路95號',
    縣市: '屏東縣'
  },
  {
    店號: 142386,
    店名: '萬巒',
    地址: '屏東縣萬巒鄉萬和村中正路52號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 151807,
    店名: '新埤',
    地址: '屏東縣新埤鄉新埤村中正路72號',
    縣市: '屏東縣'
  },
  {
    店號: 155452,
    店名: '鹽洲',
    地址: '屏東縣新園鄉共和村光復路1號',
    縣市: '屏東縣'
  },
  {
    店號: 159409,
    店名: '新自孝',
    地址: '屏東縣屏東市北勢里自由路476號壹樓',
    縣市: '屏東縣'
  },
  {
    店號: 165378,
    店名: '同勝',
    地址: '屏東縣屏東市潭墘里大同北路1號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 166005,
    店名: '廣得亨',
    地址: '屏東縣萬丹鄉 廈北村 南北路二段289號',
    縣市: '屏東縣'
  },
  {
    店號: 166108,
    店名: '萬金',
    地址: '屏東縣萬巒鄉萬金村萬興路18號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 166625,
    店名: '恆北',
    地址: '屏東縣恆春鎮網紗里省北路374-3號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 167662,
    店名: '東山河',
    地址: '屏東縣屏東市機場北路500號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 167743,
    店名: '海豚灣',
    地址: '屏東縣枋山鄉坊山村中山路三段61-3號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 167961,
    店名: '涼山',
    地址: '屏東縣內埔鄉新展路22號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 170288,
    店名: '林邊',
    地址: '屏東縣林邊鄉仁和里中山路275號277號',
    縣市: '屏東縣'
  },
  {
    店號: 171030,
    店名: '新樂興',
    地址: '屏東縣屏東市興樂里杭州街30號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 174109,
    店名: '堡勤',
    地址: '屏東縣屏東市新生里復興南路一段370號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 174291,
    店名: '維軒',
    地址: '屏東縣枋寮鄉人和村中山路二段143號',
    縣市: '屏東縣'
  },
  {
    店號: 174811,
    店名: '崙上',
    地址: '屏東縣長治鄉崙上村中興路372-2號',
    縣市: '屏東縣'
  },
  {
    店號: 179610,
    店名: '繁華',
    地址: '屏東縣長治鄉繁華村水源路71.71-1號',
    縣市: '屏東縣'
  },
  {
    店號: 179698,
    店名: '白沙灣',
    地址: '屏東縣恆春鎮大光里砂尾路38之6號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 180311,
    店名: '守福',
    地址: '屏東縣九如鄉九如路三段450號',
    縣市: '屏東縣'
  },
  {
    店號: 181129,
    店名: '新中勝',
    地址: '屏東縣內埔鄉龍潭村昭勝路13.15號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 181266,
    店名: '墾丁',
    地址: '屏東縣恆春鎮墾丁里墾丁路78號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 182786,
    店名: '花瓶岩',
    地址: '屏東縣琉球鄉本福村中山路51-5號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 183077,
    店名: '多多利',
    地址: '屏東縣九如鄉九如路三段85號',
    縣市: '屏東縣'
  },
  {
    店號: 183561,
    店名: '楓港',
    地址: '屏東縣枋山鄉楓港村舊庄路21-3.21-4.21-5.21-6號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 183952,
    店名: '學廣',
    地址: '屏東縣內埔鄉內埔村廣濟路2-6號',
    縣市: '屏東縣'
  },
  {
    店號: 184173,
    店名: '鵝鑾鼻',
    地址: '屏東縣恆春鎮鵝鑾里鵝鑾路245.247.249.257號',
    縣市: '屏東縣'
  },
  {
    店號: 186504,
    店名: '東隆',
    地址: '屏東縣東港鎮頂中里延平路107號',
    縣市: '屏東縣'
  },
  {
    店號: 186777,
    店名: '鵬權',
    地址: '屏東縣潮州鎮永春里光春路139號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 187840,
    店名: '翔發',
    地址: '屏東縣萬丹鄉萬後村西環路637號',
    縣市: '屏東縣'
  },
  {
    店號: 188153,
    店名: '瑞廣',
    地址: '屏東縣屏東市一心里廣東南路88-15號',
    縣市: '屏東縣'
  },
  {
    店號: 188234,
    店名: '念楨',
    地址: '屏東縣內埔鄉黎明村黎東路221號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 188256,
    店名: '佳冬',
    地址: '屏東縣佳冬鄉賴家村佳和路1號',
    縣市: '屏東縣'
  },
  {
    店號: 188360,
    店名: '新東勢',
    地址: '屏東縣內埔鄉東勢村大同路三段2號6號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 188603,
    店名: '廣正',
    地址: '屏東縣屏東市北興里中正路443號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 188647,
    店名: '合生',
    地址: '屏東縣潮州鎮中正路1號',
    縣市: '屏東縣'
  },
  {
    店號: 188821,
    店名: '鹽埔',
    地址: '屏東縣鹽埔鄉維新路134-3號136號',
    縣市: '屏東縣'
  },
  {
    店號: 188832,
    店名: '里宬',
    地址: '屏東縣里港鄉鐵店村鐵店路17-1號',
    縣市: '屏東縣'
  },
  {
    店號: 188843,
    店名: '加祿堂',
    地址: '屏東縣枋山鄉加祿村加祿路155號',
    縣市: '屏東縣'
  },
  {
    店號: 189134,
    店名: '廣吉',
    地址: '屏東縣屏東市廣東路991之1,991之2號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 192587,
    店名: '和興',
    地址: '屏東縣屏東市復興南路一段153.155號1樓.和生路一段900號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 192738,
    店名: '瑞光',
    地址: '屏東縣屏東市瑞光里民生東路58-2號',
    縣市: '屏東縣'
  },
  {
    店號: 194295,
    店名: '華敬',
    地址: '屏東縣屏東市中正里華正路12號1樓.14號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 195276,
    店名: '崁鼎',
    地址: '屏東縣崁頂鄉崁頂村中正路135.137.139號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 195472,
    店名: '大街',
    地址: '屏東縣恆春鎮墾丁里墾丁路225.227號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 198998,
    店名: '清順',
    地址: '屏東縣潮州鎮光華里光華路153號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 200491,
    店名: '興長安',
    地址: '屏東縣屏東市光復路352號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 201151,
    店名: '金樹',
    地址: '屏東縣屏東市仁愛路16號',
    縣市: '屏東縣'
  },
  {
    店號: 201461,
    店名: '欣欣鼎',
    地址: '屏東縣屏東市崇蘭里自由路666號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 202198,
    店名: '滿豐',
    地址: '屏東縣車城鄉尖山路37號',
    縣市: '屏東縣'
  },
  {
    店號: 202279,
    店名: '有魚',
    地址: '屏東縣恆春鎮砂尾路16-65號',
    縣市: '屏東縣'
  },
  {
    店號: 207609,
    店名: '潮維',
    地址: '屏東縣潮州鎮三共里四維路201號',
    縣市: '屏東縣'
  },
  {
    店號: 208004,
    店名: '聯勝',
    地址: '屏東縣南州鄉壽元村大同路6號',
    縣市: '屏東縣'
  },
  {
    店號: 208277,
    店名: '仙隆',
    地址: '屏東縣新園鄉仙吉路9-2號',
    縣市: '屏東縣'
  },
  {
    店號: 208314,
    店名: '恆好',
    地址: '屏東縣恆春鎮恆南路70-1號',
    縣市: '屏東縣'
  },
  {
    店號: 208509,
    店名: '林美',
    地址: '屏東縣林邊鄉中林路295號',
    縣市: '屏東縣'
  },
  {
    店號: 208565,
    店名: '僑勇',
    地址: '屏東縣枋寮鄉隆山村中山路92-2號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 208691,
    店名: '欣來義',
    地址: '屏東縣新埤鄉萬安路4-2號',
    縣市: '屏東縣'
  },
  {
    店號: 209018,
    店名: '農科',
    地址: '屏東縣長治鄉德和村農科路23號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 209801,
    店名: '元盛',
    地址: '屏東縣屏東市瑞光路二段456號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 210041,
    店名: '萬利',
    地址: '屏東縣萬丹鄉新鐘村萬新路15鄰277號',
    縣市: '屏東縣'
  },
  {
    店號: 211136,
    店名: '霧台',
    地址: '屏東縣霧台鄉神山巷15號',
    縣市: '屏東縣'
  },
  {
    店號: 211505,
    店名: '上發',
    地址: '屏東縣萬丹鄉南北路二段608號',
    縣市: '屏東縣'
  },
  {
    店號: 212531,
    店名: '東源',
    地址: '屏東縣東港鎮水源路118號',
    縣市: '屏東縣'
  },
  {
    店號: 214010,
    店名: '新輔英',
    地址: '屏東縣東港鎮興台里中山路3號',
    縣市: '屏東縣'
  },
  {
    店號: 214124,
    店名: '屏棧',
    地址: '屏東縣屏東市崇智里光復路45號',
    縣市: '屏東縣'
  },
  {
    店號: 216131,
    店名: '屏基',
    地址: '屏東縣屏東市大連路60號',
    縣市: '屏東縣'
  },
  {
    店號: 216740,
    店名: '永發',
    地址: '屏東縣屏東市永安里復興路258號',
    縣市: '屏東縣'
  },
  {
    店號: 216946,
    店名: '屏鵝',
    地址: '屏東縣恆春鎮恆南路6-6號',
    縣市: '屏東縣'
  },
  {
    店號: 228455,
    店名: '裕田',
    地址: '屏東縣里港鄉玉田路65-3號65-5號65-6號65-7號',
    縣市: '屏東縣'
  },
  {
    店號: 229104,
    店名: '北葉',
    地址: '屏東縣瑪家鄉北葉村風景1-1號',
    縣市: '屏東縣'
  },
  {
    店號: 229333,
    店名: '雙琉',
    地址: '屏東縣獅子鄉草埔六巷23-1號',
    縣市: '屏東縣'
  },
  {
    店號: 229816,
    店名: '轉好運',
    地址: '屏東縣內埔鄉成功路251號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 230056,
    店名: '潮昇',
    地址: '屏東縣潮州鎮三和里朝昇路316號',
    縣市: '屏東縣'
  },
  {
    店號: 230089,
    店名: '大幅',
    地址: '屏東縣竹田鄉連成路26號',
    縣市: '屏東縣'
  },
  {
    店號: 230171,
    店名: '隆山',
    地址: '屏東縣枋寮鄉中正大路412號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 230528,
    店名: '北勢頭',
    地址: '屏東縣屏東市自由路445號',
    縣市: '屏東縣'
  },
  {
    店號: 232742,
    店名: '華僑',
    地址: '屏東縣東港鎮朝隆路16-1號18號',
    縣市: '屏東縣'
  },
  {
    店號: 232856,
    店名: '勝星',
    地址: '屏東縣屏東市中山路61-13號',
    縣市: '屏東縣'
  },
  {
    店號: 233114,
    店名: '北勝',
    地址: '屏東縣內埔鄉北寧路142號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 237862,
    店名: '里農',
    地址: '屏東縣里港鄉大平村中山路3號',
    縣市: '屏東縣'
  },
  {
    店號: 238050,
    店名: '廣豐',
    地址: '屏東縣屏東市大連里廣東路280號280-1號',
    縣市: '屏東縣'
  },
  {
    店號: 238474,
    店名: '博勝',
    地址: '屏東縣屏東市博愛路263號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 238485,
    店名: '昭勝',
    地址: '屏東縣內埔鄉龍潭村昭勝路216號218號220號',
    縣市: '屏東縣'
  },
  {
    店號: 238762,
    店名: '雅客',
    地址: '屏東縣恆春鎮墾丁里墾丁路166號',
    縣市: '屏東縣'
  },
  {
    店號: 239293,
    店名: '光榮',
    地址: '屏東縣屏東市信義路73之6 號73之7 號75號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 239617,
    店名: '國站',
    地址: '屏東縣屏東市中山路1.3號一樓',
    縣市: '屏東縣'
  },
  {
    店號: 239891,
    店名: '英順',
    地址: '屏東縣潮州鎮介壽路145號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 239905,
    店名: '瑞屏',
    地址: '屏東縣長治鄉香楊村瑞光路一段749號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 239950,
    店名: '山和',
    地址: '屏東縣潮州鎮三和里延平路89號',
    縣市: '屏東縣'
  },
  {
    店號: 240868,
    店名: '和武',
    地址: '屏東縣屏東市和生路二段342號',
    縣市: '屏東縣'
  },
  {
    店號: 249061,
    店名: '欣昌隆',
    地址: '屏東縣佳冬鄉昌隆村大豐路680號',
    縣市: '屏東縣'
  },
  {
    店號: 249603,
    店名: '統棒',
    地址: '屏東縣屏東市永安里棒球路45號',
    縣市: '屏東縣'
  },
  {
    店號: 250153,
    店名: '青允',
    地址: '屏東縣萬巒鄉新置村新隆路75號',
    縣市: '屏東縣'
  },
  {
    店號: 250371,
    店名: '林興',
    地址: '屏東縣林邊鄉中山路312號',
    縣市: '屏東縣'
  },
  {
    店號: 250566,
    店名: '歸來',
    地址: '屏東縣屏東市和生路一段107-3號',
    縣市: '屏東縣'
  },
  {
    店號: 854351,
    店名: '厚生',
    地址: '屏東縣屏東市和平路2號',
    縣市: '屏東縣'
  },
  {
    店號: 860057,
    店名: '新園',
    地址: '屏東縣新園鄉興龍村14鄰南興路319號',
    縣市: '屏東縣'
  },
  {
    店號: 861430,
    店名: '順越',
    地址: '屏東縣內埔鄉南寧路19、21號',
    縣市: '屏東縣'
  },
  {
    店號: 864587,
    店名: '潭墘',
    地址: '屏東縣屏東市勝利路224號',
    縣市: '屏東縣'
  },
  {
    店號: 870711,
    店名: '香楊',
    地址: '屏東縣屏東市瑞光里香楊巷59-12號',
    縣市: '屏東縣'
  },
  {
    店號: 880349,
    店名: '里港',
    地址: '屏東縣里港鄉永春村中山路46號',
    縣市: '屏東縣'
  },
  {
    店號: 882219,
    店名: '南彎',
    地址: '屏東縣恆春鎮南灣里南灣路122號',
    縣市: '屏東縣'
  },
  {
    店號: 883278,
    店名: '家家福',
    地址: '屏東縣春日鄉七佳村自強一路14號',
    縣市: '屏東縣'
  },
  {
    店號: 892113,
    店名: '小琉球',
    地址: '屏東縣琉球鄉本福村民生路61號',
    縣市: '屏東縣'
  },
  {
    店號: 900186,
    店名: '後壁湖',
    地址: '屏東縣恆春鎮南灣里南光路2號',
    縣市: '屏東縣'
  },
  {
    店號: 903794,
    店名: '南州',
    地址: '屏東縣南州鄉溪南村三民路171號',
    縣市: '屏東縣'
  },
  {
    店號: 904214,
    店名: '埔豐',
    地址: '屏東縣內埔鄉豐田村中正路291號',
    縣市: '屏東縣'
  },
  {
    店號: 910677,
    店名: '吉春',
    地址: '屏東縣恆春鎮山腳里環城南路60號',
    縣市: '屏東縣'
  },
  {
    店號: 913182,
    店名: '翊聖',
    地址: '屏東縣屏東市崇蘭里崇蘭路98-24號',
    縣市: '屏東縣'
  },
  {
    店號: 914211,
    店名: '公裕',
    地址: '屏東縣屏東市北興里廣東路818號',
    縣市: '屏東縣'
  },
  {
    店號: 914233,
    店名: '屏生',
    地址: '屏東縣屏東市瑞光里民生路33號',
    縣市: '屏東縣'
  },
  {
    店號: 920401,
    店名: '玉光',
    地址: '屏東縣佳冬鄉玉光村中山路67號69號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 923857,
    店名: '鑫泰山',
    地址: '屏東縣高樹鄉泰山村產業路73號',
    縣市: '屏東縣'
  },
  {
    店號: 930659,
    店名: '學興',
    地址: '屏東縣內埔鄉和興村學人路590.592號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 933245,
    店名: '頭前溪',
    地址: '屏東縣屏東市前進里清進巷150號',
    縣市: '屏東縣'
  },
  {
    店號: 934466,
    店名: '車城',
    地址: '屏東縣車城鄉福安村中山路76號',
    縣市: '屏東縣'
  },
  {
    店號: 934684,
    店名: '高樹',
    地址: '屏東縣高樹鄉興中路193號195號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 940807,
    店名: '招英',
    地址: '屏東縣高樹鄉南興路74之3號',
    縣市: '屏東縣'
  },
  {
    店號: 942180,
    店名: '薇豐',
    地址: '屏東縣屏東市大連里豐年街1號',
    縣市: '屏東縣'
  },
  {
    店號: 942777,
    店名: '里中',
    地址: '屏東縣里港鄉三部村三和路119-1號',
    縣市: '屏東縣'
  },
  {
    店號: 942869,
    店名: '竹田',
    地址: '屏東縣竹田鄉中正路84號86號',
    縣市: '屏東縣'
  },
  {
    店號: 950848,
    店名: '友井',
    地址: '屏東縣潮州鎮三共里北門路2號6號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 950859,
    店名: '昱昇',
    地址: '屏東縣車城鄉溫泉村溫泉路125號',
    縣市: '屏東縣'
  },
  {
    店號: 951704,
    店名: '億財富',
    地址: '屏東縣東港鎮新勝里光復路二段77號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 952110,
    店名: '萬新',
    地址: '屏東縣萬丹鄉新鐘村萬新路342號',
    縣市: '屏東縣'
  },
  {
    店號: 952729,
    店名: '新德蕙',
    地址: '屏東縣屏東市大連里興豐路193號',
    縣市: '屏東縣'
  },
  {
    店號: 963017,
    店名: '合家宜',
    地址: '屏東縣屏東市三山里海豐街7-12號',
    縣市: '屏東縣'
  },
  {
    店號: 965552,
    店名: '麟洛',
    地址: '屏東縣麟洛鄉麟趾村中山路519-5號',
    縣市: '屏東縣'
  },
  {
    店號: 966614,
    店名: '南北棧',
    地址: '屏東縣枋山鄉枋山村中山路三段38號',
    縣市: '屏東縣'
  },
  {
    店號: 970369,
    店名: '水門',
    地址: '屏東縣內埔鄉水門村忠孝路289號',
    縣市: '屏東縣'
  },
  {
    店號: 970598,
    店名: '萬惠',
    地址: '屏東縣萬丹鄉萬丹路一段21號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 971351,
    店名: '東寧',
    地址: '屏東縣九如鄉東寧村東寧路225號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 971524,
    店名: '新枋寮',
    地址: '屏東縣枋寮鄉枋寮村中興路7號1樓2樓',
    縣市: '屏東縣'
  },
  {
    店號: 972697,
    店名: '五房',
    地址: '屏東縣新園鄉五房村五房路721號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 982052,
    店名: '屏科大',
    地址: '屏東縣內埔鄉中林村中林路1號3號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 990112,
    店名: '欣仙吉',
    地址: '屏東縣新園鄉仙吉路128號130號132號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 990503,
    店名: '囍洋洋',
    地址: '屏東縣萬丹鄉萬丹路一段366號368號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 990868,
    店名: '新潮',
    地址: '屏東縣潮州鎮新榮里中山路121號123號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 992026,
    店名: '壽元',
    地址: '屏東縣南州鄉壽元村勝利路5-15號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 992060,
    店名: '大鵬灣',
    地址: '屏東縣東港鎮船頭里船頭路26-33號26-35號1樓',
    縣市: '屏東縣'
  },
  {
    店號: 992277,
    店名: '保鑫',
    地址: '屏東縣車城鄉新街村保新路71號',
    縣市: '屏東縣'
  },
  {
    店號: 997618,
    店名: '壽比',
    地址: '屏東縣內埔鄉老埤村壽比路348號',
    縣市: '屏東縣'
  },
  {
    店號: 110677,
    店名: '池上',
    地址: '台東縣池上鄉大埔村中山路64號1樓',
    縣市: '台東縣'
  },
  {
    店號: 120685,
    店名: '東太陽',
    地址: '台東縣台東市中華路二段753號1樓',
    縣市: '台東縣'
  },
  {
    店號: 122795,
    店名: '東遊季',
    地址: '台東縣卑南鄉溫泉路388號',
    縣市: '台東縣'
  },
  {
    店號: 122957,
    店名: '關山',
    地址: '台東縣關山鎮和平路4號4之1號1樓',
    縣市: '台東縣'
  },
  {
    店號: 126339,
    店名: '新鹿野',
    地址: '台東縣鹿野鄉鹿野村中華路一段430號',
    縣市: '台東縣'
  },
  {
    店號: 127033,
    店名: '東博',
    地址: '台東縣台東市民權里中正路414號418號',
    縣市: '台東縣'
  },
  {
    店號: 131685,
    店名: '東廣',
    地址: '台東縣台東市傳廣路496號498號1樓',
    縣市: '台東縣'
  },
  {
    店號: 132806,
    店名: '正東',
    地址: '台東縣台東市中華路一段372號',
    縣市: '台東縣'
  },
  {
    店號: 138077,
    店名: '東輝',
    地址: '台東縣台東市正氣北路389號',
    縣市: '台東縣'
  },
  {
    店號: 142825,
    店名: '東馳',
    地址: '台東縣池上鄉中東三路46號1樓',
    縣市: '台東縣'
  },
  {
    店號: 142892,
    店名: '蘭嶼',
    地址: '台東縣蘭嶼鄉椰油村椰油296之12號',
    縣市: '台東縣'
  },
  {
    店號: 143895,
    店名: '東大',
    地址: '台東縣台東市大學路二段369號',
    縣市: '台東縣'
  },
  {
    店號: 150826,
    店名: '長濱',
    地址: '台東縣長濱鄉長濱村長濱路2-5號',
    縣市: '台東縣'
  },
  {
    店號: 151232,
    店名: '利嘉',
    地址: '台東縣台東市新園里中興路六段667號1樓',
    縣市: '台東縣'
  },
  {
    店號: 153928,
    店名: '大武',
    地址: '台東縣大武鄉復興路124號126號128號1樓',
    縣市: '台東縣'
  },
  {
    店號: 154057,
    店名: '東和美',
    地址: '台東縣太麻里鄉三和村大中寮路68之6號',
    縣市: '台東縣'
  },
  {
    店號: 154585,
    店名: '東亮',
    地址: '台東縣台東市連航路88巷31號33號35號1樓',
    縣市: '台東縣'
  },
  {
    店號: 155005,
    店名: '東喜',
    地址: '台東縣台東市興安路一段197號1樓',
    縣市: '台東縣'
  },
  {
    店號: 160188,
    店名: '仁毅',
    地址: '台東縣台東市馬蘭里新生路680號682號684號1樓',
    縣市: '台東縣'
  },
  {
    店號: 160258,
    店名: '東昇',
    地址: '台東縣台東市鐵花里中華路一段542號1樓',
    縣市: '台東縣'
  },
  {
    店號: 163796,
    店名: '金倫',
    地址: '台東縣太麻里鄉金崙村金崙路262號262-1號',
    縣市: '台東縣'
  },
  {
    店號: 163958,
    店名: '初鹿',
    地址: '台東縣卑南鄉明峰村忠孝路164號166號168號',
    縣市: '台東縣'
  },
  {
    店號: 166382,
    店名: '東糖',
    地址: '台東縣台東市中興路二段360號1樓',
    縣市: '台東縣'
  },
  {
    店號: 167754,
    店名: '東清灣',
    地址: '台東縣蘭嶼鄉東清村東清路7號',
    縣市: '台東縣'
  },
  {
    店號: 173852,
    店名: '欣功',
    地址: '台東縣成功鎮三民里大同路70號',
    縣市: '台東縣'
  },
  {
    店號: 174615,
    店名: '卑南',
    地址: '台東縣台東市南榮里更生路1267號',
    縣市: '台東縣'
  },
  {
    店號: 180702,
    店名: '東安',
    地址: '台東縣台東市杭州街288號1樓',
    縣市: '台東縣'
  },
  {
    店號: 180724,
    店名: '東星',
    地址: '台東縣台東市正氣路159.159-1號1樓',
    縣市: '台東縣'
  },
  {
    店號: 181015,
    店名: '三越',
    地址: '台東縣台東市中華路一段169.171.173號1樓及169號2樓',
    縣市: '台東縣'
  },
  {
    店號: 184379,
    店名: '睿豐',
    地址: '台東縣台東市大和路8-1.16-1號一樓',
    縣市: '台東縣'
  },
  {
    店號: 193878,
    店名: '香蘭',
    地址: '台東縣太麻里鄉太麻里街575號',
    縣市: '台東縣'
  },
  {
    店號: 200538,
    店名: '米鄉',
    地址: '台東縣池上鄉福原村中山路241號',
    縣市: '台東縣'
  },
  {
    店號: 202246,
    店名: '豐喜',
    地址: '台東縣台東市豐年里連航路3號',
    縣市: '台東縣'
  },
  {
    店號: 207908,
    店名: '東基',
    地址: '台東縣台東市開封街350號1樓',
    縣市: '台東縣'
  },
  {
    店號: 209845,
    店名: '都歷',
    地址: '台東縣成功鎮都歷路179號',
    縣市: '台東縣'
  },
  {
    店號: 209959,
    店名: '達武',
    地址: '台東縣達仁鄉安朔村復興路21號及21-1號',
    縣市: '台東縣'
  },
  {
    店號: 211402,
    店名: '天喜',
    地址: '台東縣台東市光明路190.192號',
    縣市: '台東縣'
  },
  {
    店號: 230034,
    店名: '開漢',
    地址: '台東縣台東市開封街760號1樓',
    縣市: '台東縣'
  },
  {
    店號: 232100,
    店名: '初來',
    地址: '台東縣海端鄉海端村初來11之1號',
    縣市: '台東縣'
  },
  {
    店號: 232605,
    店名: '金剛',
    地址: '台東縣長濱鄉長濱村長光58之1號',
    縣市: '台東縣'
  },
  {
    店號: 239352,
    店名: '新太麻',
    地址: '台東縣太麻里鄉泰和村外環路128號1樓',
    縣市: '台東縣'
  },
  {
    店號: 249005,
    店名: '東偕',
    地址: '台東縣台東市長沙街303巷1號',
    縣市: '台東縣'
  },
  {
    店號: 249533,
    店名: '享溫馨',
    地址: '台東縣台東市中正里中正路308號1樓',
    縣市: '台東縣'
  },
  {
    店號: 249854,
    店名: '綠島',
    地址: '台東縣綠島鄉南寮村南寮路139號',
    縣市: '台東縣'
  },
  {
    店號: 250201,
    店名: '東佳',
    地址: '台東縣台東市長沙街178號180號182號',
    縣市: '台東縣'
  },
  {
    店號: 872599,
    店名: '東航',
    地址: '台東縣台東市民生里更生路270號1F',
    縣市: '台東縣'
  },
  {
    店號: 888099,
    店名: '東漢',
    地址: '台東縣台東市正氣北路182號',
    縣市: '台東縣'
  },
  {
    店號: 892962,
    店名: '都蘭',
    地址: '台東縣東河鄉都蘭村都蘭155樓157號1樓',
    縣市: '台東縣'
  },
  {
    店號: 902296,
    店名: '吉川',
    地址: '台東縣台東市中華路二段272號1樓274號1樓2樓276號1樓',
    縣市: '台東縣'
  },
  {
    店號: 914141,
    店名: '東定',
    地址: '台東縣台東市豐田里中興路四段406號',
    縣市: '台東縣'
  },
  {
    店號: 921231,
    店名: '東京',
    地址: '台東縣台東市卑南里更生北路196號198號',
    縣市: '台東縣'
  },
  {
    店號: 932998,
    店名: '冠美',
    地址: '台東縣台東市豐榮里仁昌街148號',
    縣市: '台東縣'
  },
  {
    店號: 940472,
    店名: '尚武',
    地址: '台東縣大武鄉尚武村環港路3號',
    縣市: '台東縣'
  },
  {
    店號: 952833,
    店名: '東河',
    地址: '台東縣東河鄉東河村南東河263號1樓',
    縣市: '台東縣'
  },
  {
    店號: 954574,
    店名: '東樂',
    地址: '台東縣台東市山西路一段330號',
    縣市: '台東縣'
  },
  {
    店號: 968078,
    店名: '新南王',
    地址: '台東縣台東市更生北路675號677號',
    縣市: '台東縣'
  },
  {
    店號: 970071,
    店名: '成貞',
    地址: '台東縣台東市豐年里中興路三段399號1樓',
    縣市: '台東縣'
  },
  {
    店號: 978101,
    店名: '欣東旺',
    地址: '台東縣成功鎮忠仁里中華路76號1樓',
    縣市: '台東縣'
  },
  {
    店號: 987736,
    店名: '知本',
    地址: '台東縣台東市建興里知本路四段2號',
    縣市: '台東縣'
  },
  {
    店號: 991665,
    店名: '富岡',
    地址: '台東縣台東市富岡里吉林路二段668號1樓',
    縣市: '台東縣'
  },
  {
    店號: 997652,
    店名: '東捷',
    地址: '台東縣台東市豐榮里豐盛路1號',
    縣市: '台東縣'
  },
  {
    店號: 110312,
    店名: '林田山',
    地址: '花蓮縣鳳林鎮長橋里長橋路108號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 110415,
    店名: '豐濱',
    地址: '花蓮縣豐濱鄉三民村三民路61號65號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 111980,
    店名: '花農',
    地址: '花蓮縣花蓮市建國路236號238號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 112824,
    店名: '馬太鞍',
    地址: '花蓮縣光復鄉中山路一段125號',
    縣市: '花蓮縣'
  },
  {
    店號: 113056,
    店名: '蓮慶',
    地址: '花蓮縣花蓮市林森路160號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 113665,
    店名: '蓮慈',
    地址: '花蓮縣花蓮市中山路一段7號9號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 114288,
    店名: '崇德盈',
    地址: '花蓮縣秀林鄉崇德95-6號',
    縣市: '花蓮縣'
  },
  {
    店號: 116354,
    店名: '玉明',
    地址: '花蓮縣玉里鎮泰昌里中山路二段135號',
    縣市: '花蓮縣'
  },
  {
    店號: 116413,
    店名: '興玉',
    地址: '花蓮縣玉里鎮興國路二段23號',
    縣市: '花蓮縣'
  },
  {
    店號: 120272,
    店名: '星潭',
    地址: '花蓮縣花蓮市華西121-9及121-10及121-11號',
    縣市: '花蓮縣'
  },
  {
    店號: 120995,
    店名: '思瑀',
    地址: '花蓮縣花蓮市建國路二段862號及866號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 121057,
    店名: '吉野',
    地址: '花蓮縣花蓮市中正路65號1樓2樓',
    縣市: '花蓮縣'
  },
  {
    店號: 122027,
    店名: '上美崙',
    地址: '花蓮縣花蓮市府前路298號298之1號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 122935,
    店名: '豐川',
    地址: '花蓮縣花蓮市富強路214號216號',
    縣市: '花蓮縣'
  },
  {
    店號: 126661,
    店名: '八悅',
    地址: '花蓮縣壽豐鄉平和村中華路二段215號',
    縣市: '花蓮縣'
  },
  {
    店號: 131836,
    店名: '蓮圓',
    地址: '花蓮縣花蓮市中山路891號893號',
    縣市: '花蓮縣'
  },
  {
    店號: 132345,
    店名: '吉昌',
    地址: '花蓮縣吉安鄉吉安路一段114號',
    縣市: '花蓮縣'
  },
  {
    店號: 138745,
    店名: '蓮莊',
    地址: '花蓮縣新城鄉北埔村光復路462號',
    縣市: '花蓮縣'
  },
  {
    店號: 138941,
    店名: '精舍',
    地址: '花蓮縣新城鄉康樂村康樂路286號288號',
    縣市: '花蓮縣'
  },
  {
    店號: 151014,
    店名: '蓮昌',
    地址: '花蓮縣花蓮市建國路二段298號',
    縣市: '花蓮縣'
  },
  {
    店號: 151276,
    店名: '蓮恆',
    地址: '花蓮縣吉安鄉北昌村建國路一段51號',
    縣市: '花蓮縣'
  },
  {
    店號: 151287,
    店名: '新廉瀚',
    地址: '花蓮縣新城鄉新興路28號30號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 151737,
    店名: '蓮陽',
    地址: '花蓮縣吉安鄉吉安村中山路三段2號',
    縣市: '花蓮縣'
  },
  {
    店號: 151759,
    店名: '北埔',
    地址: '花蓮縣新城鄉北埔路282號',
    縣市: '花蓮縣'
  },
  {
    店號: 153375,
    店名: '玉里',
    地址: '花蓮縣玉里鎮中山路二段90號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 155511,
    店名: '鳳悅',
    地址: '花蓮縣鳳林鎮信義路216號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 165507,
    店名: '瑞權',
    地址: '花蓮縣瑞穗鄉瑞北路30之2號',
    縣市: '花蓮縣'
  },
  {
    店號: 166522,
    店名: '富集',
    地址: '花蓮縣花蓮市國富里富國路32號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 166821,
    店名: '豐坪',
    地址: '花蓮縣壽豐鄉豐坪村豐坪路二段5之1號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 173748,
    店名: '蓮安',
    地址: '花蓮縣吉安鄉中華路二段5號',
    縣市: '花蓮縣'
  },
  {
    店號: 174305,
    店名: '樂合',
    地址: '花蓮縣玉里鎮樂合里新民路13-1號',
    縣市: '花蓮縣'
  },
  {
    店號: 174350,
    店名: '愛民',
    地址: '花蓮縣花蓮市民國路22號',
    縣市: '花蓮縣'
  },
  {
    店號: 174899,
    店名: '讚福',
    地址: '花蓮縣花蓮市國聯五路55號',
    縣市: '花蓮縣'
  },
  {
    店號: 181288,
    店名: '玉富',
    地址: '花蓮縣玉里鎮大同路214號及光復路184號',
    縣市: '花蓮縣'
  },
  {
    店號: 183457,
    店名: '國盛',
    地址: '花蓮縣花蓮市國民九街56號58號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 184829,
    店名: '富泰',
    地址: '花蓮縣花蓮市國聯一路55號',
    縣市: '花蓮縣'
  },
  {
    店號: 188289,
    店名: '愛田',
    地址: '花蓮縣吉安鄉建國路一段200號.202號',
    縣市: '花蓮縣'
  },
  {
    店號: 193775,
    店名: '興富',
    地址: '花蓮縣富里鄉中山路61號',
    縣市: '花蓮縣'
  },
  {
    店號: 194239,
    店名: '加灣',
    地址: '花蓮縣秀林鄉景美村加灣178之20號',
    縣市: '花蓮縣'
  },
  {
    店號: 195036,
    店名: '金秀和',
    地址: '花蓮縣花蓮市和平路597號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 196165,
    店名: '海星',
    地址: '花蓮縣新城鄉嘉新路63巷1號',
    縣市: '花蓮縣'
  },
  {
    店號: 196626,
    店名: '吉華',
    地址: '花蓮縣吉安鄉中華路二段172號',
    縣市: '花蓮縣'
  },
  {
    店號: 198297,
    店名: '文瑞',
    地址: '花蓮縣壽豐鄉中山路222號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 198862,
    店名: '華原',
    地址: '花蓮縣花蓮市中華路426號',
    縣市: '花蓮縣'
  },
  {
    店號: 199371,
    店名: '新福興',
    地址: '花蓮縣吉安鄉福興村吉安路三段78號80號82號福興路236號',
    縣市: '花蓮縣'
  },
  {
    店號: 206949,
    店名: '蓮和',
    地址: '花蓮縣秀林鄉和平村和平263號(台泥和平廠)',
    縣市: '花蓮縣'
  },
  {
    店號: 207540,
    店名: '達基力',
    地址: '花蓮縣秀林鄉崇德村海濱3號3之1號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 208060,
    店名: '門諾',
    地址: '花蓮縣花蓮市民權路115號117號',
    縣市: '花蓮縣'
  },
  {
    店號: 210270,
    店名: '知卡宣',
    地址: '花蓮縣吉安鄉海岸路469號',
    縣市: '花蓮縣'
  },
  {
    店號: 210993,
    店名: '福原',
    地址: '花蓮縣花蓮市中原路328號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 212391,
    店名: '權營',
    地址: '花蓮縣花蓮市民權路25之1號25之2號25之3號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 215105,
    店名: '蓮發',
    地址: '花蓮縣新城鄉北埔村7鄰北埔路172號',
    縣市: '花蓮縣'
  },
  {
    店號: 216083,
    店名: '吉濱',
    地址: '花蓮縣吉安鄉南濱路一段651號',
    縣市: '花蓮縣'
  },
  {
    店號: 217123,
    店名: '蓮冠',
    地址: '花蓮縣花蓮市中山路426號',
    縣市: '花蓮縣'
  },
  {
    店號: 228019,
    店名: '天合',
    地址: '花蓮縣瑞穗鄉溫泉路二段308號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 228075,
    店名: '文景',
    地址: '花蓮縣吉安鄉中山路二段73號75號1樓昌隆一街48號50號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 228330,
    店名: '嘉里',
    地址: '花蓮縣新城鄉嘉里路110號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 229805,
    店名: '蓮興',
    地址: '花蓮縣花蓮市東興路369號371號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 230388,
    店名: '林榮',
    地址: '花蓮縣鳳林鎮兆豐路699號',
    縣市: '花蓮縣'
  },
  {
    店號: 230953,
    店名: '萬榮',
    地址: '花蓮縣萬榮鄉萬榮162-1、162-2號',
    縣市: '花蓮縣'
  },
  {
    店號: 231185,
    店名: '卓溪',
    地址: '花蓮縣卓溪鄉卓溪村中正57-6號',
    縣市: '花蓮縣'
  },
  {
    店號: 232111,
    店名: '玉仁',
    地址: '花蓮縣玉里鎮光復路5號7號9號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 233295,
    店名: '鑫源',
    地址: '花蓮縣吉安鄉中山路三段232號236號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 236858,
    店名: '蓮富',
    地址: '花蓮縣光復鄉中正路一段90號1樓中山路二段250號252號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 240879,
    店名: '花道',
    地址: '花蓮縣花蓮市中正路563號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 249681,
    店名: '天祥',
    地址: '花蓮縣秀林鄉富世村天祥17之1號',
    縣市: '花蓮縣'
  },
  {
    店號: 249773,
    店名: '蓮權',
    地址: '花蓮縣花蓮市民權路136號138號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 251064,
    店名: '名品',
    地址: '花蓮縣花蓮市國富里十三鄰莊敬路72號1樓國富十街1之1號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 866310,
    店名: '蓮吉',
    地址: '花蓮縣吉安鄉中山路三段423號',
    縣市: '花蓮縣'
  },
  {
    店號: 872382,
    店名: '蓮美',
    地址: '花蓮縣花蓮市中美路209號',
    縣市: '花蓮縣'
  },
  {
    店號: 872740,
    店名: '蓮讚',
    地址: '花蓮縣花蓮市國聯里國聯三路16號18號',
    縣市: '花蓮縣'
  },
  {
    店號: 873385,
    店名: '蓮嘉',
    地址: '花蓮縣新城鄉嘉里村嘉里路155號157號',
    縣市: '花蓮縣'
  },
  {
    店號: 880073,
    店名: '太魯閣',
    地址: '花蓮縣秀林鄉富世村富世路152號152-1號',
    縣市: '花蓮縣'
  },
  {
    店號: 880671,
    店名: '志學',
    地址: '花蓮縣壽豐鄉志學村7鄰中山路三段6號',
    縣市: '花蓮縣'
  },
  {
    店號: 881951,
    店名: '鳳林',
    地址: '花蓮縣鳳林鎮鳳禮里中正路二段143號145號',
    縣市: '花蓮縣'
  },
  {
    店號: 891420,
    店名: '慈濟',
    地址: '花蓮縣花蓮市中央路三段808號810號',
    縣市: '花蓮縣'
  },
  {
    店號: 900072,
    店名: '東海岸',
    地址: '花蓮縣吉安鄉海岸路252號254號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 902469,
    店名: '璞石閣',
    地址: '花蓮縣玉里鎮中山路一段96號',
    縣市: '花蓮縣'
  },
  {
    店號: 910965,
    店名: '新蓮信',
    地址: '花蓮縣花蓮市中美路186號',
    縣市: '花蓮縣'
  },
  {
    店號: 912972,
    店名: '慈勝',
    地址: '花蓮縣吉安鄉自強路52號',
    縣市: '花蓮縣'
  },
  {
    店號: 920320,
    店名: '仁禮',
    地址: '花蓮縣吉安鄉南埔八街223號',
    縣市: '花蓮縣'
  },
  {
    店號: 920342,
    店名: '讚蓮',
    地址: '花蓮縣花蓮市富吉路2號',
    縣市: '花蓮縣'
  },
  {
    店號: 923019,
    店名: '稻香',
    地址: '花蓮縣吉安鄉吉興路二段46號48號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 923134,
    店名: '統軒',
    地址: '花蓮縣花蓮市公園路7-1號',
    縣市: '花蓮縣'
  },
  {
    店號: 923293,
    店名: '瑞繐',
    地址: '花蓮縣瑞穗鄉中山路一段17號19號',
    縣市: '花蓮縣'
  },
  {
    店號: 932529,
    店名: '尚美',
    地址: '花蓮縣花蓮市中興路71號',
    縣市: '花蓮縣'
  },
  {
    店號: 943725,
    店名: '長勝',
    地址: '花蓮縣花蓮市中美路83-1號83-2號',
    縣市: '花蓮縣'
  },
  {
    店號: 943987,
    店名: '富鄉',
    地址: '花蓮縣富里鄉中山路167號',
    縣市: '花蓮縣'
  },
  {
    店號: 950723,
    店名: '華廈',
    地址: '花蓮縣花蓮市民享里府前路638號640號',
    縣市: '花蓮縣'
  },
  {
    店號: 952637,
    店名: '南濱',
    地址: '花蓮縣吉安鄉南濱路一段116號',
    縣市: '花蓮縣'
  },
  {
    店號: 954437,
    店名: '祥祐',
    地址: '花蓮縣新城鄉順安村北三棧119之6號',
    縣市: '花蓮縣'
  },
  {
    店號: 954817,
    店名: '吉海',
    地址: '花蓮縣吉安鄉海岸路683號',
    縣市: '花蓮縣'
  },
  {
    店號: 959177,
    店名: '如意',
    地址: '花蓮縣花蓮市中美路37號',
    縣市: '花蓮縣'
  },
  {
    店號: 966739,
    店名: '德安一',
    地址: '花蓮縣花蓮市德安一街307號',
    縣市: '花蓮縣'
  },
  {
    店號: 966968,
    店名: '好家園',
    地址: '花蓮縣花蓮市國聯一路2號2-1號',
    縣市: '花蓮縣'
  },
  {
    店號: 967558,
    店名: '富翔',
    地址: '花蓮縣吉安鄉東昌村海岸路77號',
    縣市: '花蓮縣'
  },
  {
    店號: 968551,
    店名: '新蓮盈',
    地址: '花蓮縣吉安鄉建國路二段285號1F',
    縣市: '花蓮縣'
  },
  {
    店號: 968850,
    店名: '姐妹',
    地址: '花蓮縣吉安鄉吉安路五段262之1號1F',
    縣市: '花蓮縣'
  },
  {
    店號: 977924,
    店名: '新壽豐',
    地址: '花蓮縣壽豐鄉中山路五段131號',
    縣市: '花蓮縣'
  },
  {
    店號: 978260,
    店名: '泰雅',
    地址: '花蓮縣秀林鄉和平村和平街156號',
    縣市: '花蓮縣'
  },
  {
    店號: 980137,
    店名: '鑫盈佳',
    地址: '花蓮縣花蓮市林森路258號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 981738,
    店名: '鑫花蓮',
    地址: '花蓮縣花蓮市中正路383號385號',
    縣市: '花蓮縣'
  },
  {
    店號: 987747,
    店名: '蓮成',
    地址: '花蓮縣花蓮市中華路283之1號',
    縣市: '花蓮縣'
  },
  {
    店號: 991827,
    店名: '蓮華',
    地址: '花蓮縣花蓮市民生里中山路183號185號1樓',
    縣市: '花蓮縣'
  },
  {
    店號: 111201,
    店名: '徠一',
    地址: '宜蘭縣羅東鎮培英路98號100號',
    縣市: '宜蘭縣'
  },
  {
    店號: 112341,
    店名: '健神',
    地址: '宜蘭縣宜蘭市神農路二段8號10號',
    縣市: '宜蘭縣'
  },
  {
    店號: 112938,
    店名: '圓達',
    地址: '宜蘭縣礁溪鄉礁溪路七段65號69號',
    縣市: '宜蘭縣'
  },
  {
    店號: 113399,
    店名: '伍富',
    地址: '宜蘭縣宜蘭市女中路三段26-6號26-7號26-8號',
    縣市: '宜蘭縣'
  },
  {
    店號: 120456,
    店名: '羅高',
    地址: '宜蘭縣羅東鎮公正路357號359號',
    縣市: '宜蘭縣'
  },
  {
    店號: 122120,
    店名: '騰豪',
    地址: '宜蘭縣宜蘭市大坡路二段215號217號',
    縣市: '宜蘭縣'
  },
  {
    店號: 123008,
    店名: '噶瑪蘭',
    地址: '宜蘭縣頭城鎮復興路58號',
    縣市: '宜蘭縣'
  },
  {
    店號: 123396,
    店名: '新梗枋',
    地址: '宜蘭縣頭城鎮濱海路三段323號',
    縣市: '宜蘭縣'
  },
  {
    店號: 128106,
    店名: '集翔',
    地址: '宜蘭縣羅東鎮集翔里中正路147號',
    縣市: '宜蘭縣'
  },
  {
    店號: 128117,
    店名: '駿隆',
    地址: '宜蘭縣礁溪鄉中山路一段175號',
    縣市: '宜蘭縣'
  },
  {
    店號: 130316,
    店名: '新馬',
    地址: '宜蘭縣蘇澳鎮海山西路489號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 130730,
    店名: '壯五',
    地址: '宜蘭縣宜蘭市東港路3號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 131320,
    店名: '羅結',
    地址: '宜蘭縣五結鄉五結路三段493號',
    縣市: '宜蘭縣'
  },
  {
    店號: 132699,
    店名: '新月',
    地址: '宜蘭縣宜蘭市民權路二段38巷6號',
    縣市: '宜蘭縣'
  },
  {
    店號: 132817,
    店名: '孝威',
    地址: '宜蘭縣五結鄉傳藝路一段369號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 132895,
    店名: '滿冠',
    地址: '宜蘭縣宜蘭市新興路68號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 137753,
    店名: '泉發',
    地址: '宜蘭縣礁溪鄉礁溪路三段302號306號',
    縣市: '宜蘭縣'
  },
  {
    店號: 139209,
    店名: '五結',
    地址: '宜蘭縣五結鄉五結路二段393號395號397號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 141523,
    店名: '員泰',
    地址: '宜蘭縣宜蘭市泰山路33之3號33之4號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 152095,
    店名: '馥華',
    地址: '宜蘭縣宜蘭市東港路30-22號',
    縣市: '宜蘭縣'
  },
  {
    店號: 154390,
    店名: '纘祥',
    地址: '宜蘭縣頭城鎮民鋒路18號20號',
    縣市: '宜蘭縣'
  },
  {
    店號: 154541,
    店名: '金玉',
    地址: '宜蘭縣南澳鄉蘇花路二段165號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 154987,
    店名: '新復興',
    地址: '宜蘭縣宜蘭市復興路二段49號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 164076,
    店名: '豆腐岬',
    地址: '宜蘭縣蘇澳鎮南寧路41號.42號42-1號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 164984,
    店名: '羅東',
    地址: '宜蘭縣羅東鎮公正路197號',
    縣市: '宜蘭縣'
  },
  {
    店號: 165345,
    店名: '昱成',
    地址: '宜蘭縣五結鄉中正路一段174號176號',
    縣市: '宜蘭縣'
  },
  {
    店號: 165437,
    店名: '礁溪',
    地址: '宜蘭縣礁溪鄉礁溪路四段85號87號',
    縣市: '宜蘭縣'
  },
  {
    店號: 165932,
    店名: '農專',
    地址: '宜蘭縣宜蘭市神農路一段96號98號',
    縣市: '宜蘭縣'
  },
  {
    店號: 167824,
    店名: '泉湧',
    地址: '宜蘭縣礁溪鄉玉石村溫泉路15鄰85號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 174383,
    店名: '佳美',
    地址: '宜蘭縣五結鄉中正路二段127號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 180218,
    店名: '全美',
    地址: '宜蘭縣壯圍鄉美城村大福路三段1號5號',
    縣市: '宜蘭縣'
  },
  {
    店號: 180296,
    店名: '冬森',
    地址: '宜蘭縣冬山鄉冬山路100之1號',
    縣市: '宜蘭縣'
  },
  {
    店號: 181923,
    店名: '深溝',
    地址: '宜蘭縣員山鄉惠民路207號',
    縣市: '宜蘭縣'
  },
  {
    店號: 183505,
    店名: '壯志',
    地址: '宜蘭縣壯圍鄉中央路二段311號',
    縣市: '宜蘭縣'
  },
  {
    店號: 183608,
    店名: '金桔',
    地址: '宜蘭縣礁溪鄉玉龍路二段417號',
    縣市: '宜蘭縣'
  },
  {
    店號: 183686,
    店名: '員泉',
    地址: '宜蘭縣員山鄉溫泉路1之27號1之28號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 183815,
    店名: '蜡藝館',
    地址: '宜蘭縣蘇澳鎮海山西路500號',
    縣市: '宜蘭縣'
  },
  {
    店號: 184003,
    店名: '富達',
    地址: '宜蘭縣頭城鎮青雲路一段225號227號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 184117,
    店名: '內成',
    地址: '宜蘭縣員山鄉員山路二段264號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 187932,
    店名: '馬賽',
    地址: '宜蘭縣蘇澳鎮永榮里馬賽路151號',
    縣市: '宜蘭縣'
  },
  {
    店號: 187998,
    店名: '振盟',
    地址: '宜蘭縣蘇澳鎮蘇濱路二段302號',
    縣市: '宜蘭縣'
  },
  {
    店號: 189628,
    店名: '省宜',
    地址: '宜蘭縣宜蘭市新民路159號161號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 192543,
    店名: '廣達',
    地址: '宜蘭縣冬山鄉廣興路166號168號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 195025,
    店名: '泰勝',
    地址: '宜蘭縣大同鄉泰雅路一段34號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 195265,
    店名: '頭城',
    地址: '宜蘭縣頭城鎮青雲路三段96號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 195494,
    店名: '東道',
    地址: '宜蘭縣宜蘭市東港路一段575號',
    縣市: '宜蘭縣'
  },
  {
    店號: 196671,
    店名: '永義',
    地址: '宜蘭縣冬山鄉義成路三段195號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 196855,
    店名: '侯成',
    地址: '宜蘭縣蘇澳鎮福德路463號465號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 199164,
    店名: '心蓮',
    地址: '宜蘭縣宜蘭市泰山路212號',
    縣市: '宜蘭縣'
  },
  {
    店號: 199407,
    店名: '南澳',
    地址: '宜蘭縣蘇澳鎮南強里蘇花路二段328號',
    縣市: '宜蘭縣'
  },
  {
    店號: 199555,
    店名: '佳旺',
    地址: '宜蘭縣宜蘭市舊城東路47號',
    縣市: '宜蘭縣'
  },
  {
    店號: 199566,
    店名: '麗騰',
    地址: '宜蘭縣三星鄉三星路一段586號',
    縣市: '宜蘭縣'
  },
  {
    店號: 200181,
    店名: '易安',
    地址: '宜蘭縣五結鄉五結中路二段377號379號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 200756,
    店名: '新聖母',
    地址: '宜蘭縣羅東鎮中正南路160號(聖母醫院內)',
    縣市: '宜蘭縣'
  },
  {
    店號: 201036,
    店名: '新羅興',
    地址: '宜蘭縣羅東鎮興東路23之2號1樓2樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 202327,
    店名: '永九',
    地址: '宜蘭縣冬山鄉冬山路三段249號',
    縣市: '宜蘭縣'
  },
  {
    店號: 208439,
    店名: '安農',
    地址: '宜蘭縣冬山鄉長春路128號',
    縣市: '宜蘭縣'
  },
  {
    店號: 208945,
    店名: '壯美',
    地址: '宜蘭縣壯圍鄉美功路一段40巷1號',
    縣市: '宜蘭縣'
  },
  {
    店號: 209133,
    店名: '蘇澳',
    地址: '宜蘭縣蘇澳鎮中山路一段66號',
    縣市: '宜蘭縣'
  },
  {
    店號: 209926,
    店名: '蘭雲',
    地址: '宜蘭縣頭城鎮青雲路三段315號317號',
    縣市: '宜蘭縣'
  },
  {
    店號: 209960,
    店名: '上義',
    地址: '宜蘭縣三星鄉上將路三段559號',
    縣市: '宜蘭縣'
  },
  {
    店號: 210926,
    店名: '蘇花',
    地址: '宜蘭縣南澳鄉南澳村蘇花路二段433號',
    縣市: '宜蘭縣'
  },
  {
    店號: 211088,
    店名: '縣府',
    地址: '宜蘭縣宜蘭市中山路一段366號368號370號',
    縣市: '宜蘭縣'
  },
  {
    店號: 211457,
    店名: '承莊',
    地址: '宜蘭縣宜蘭市中山路五段148號',
    縣市: '宜蘭縣'
  },
  {
    店號: 211745,
    店名: '五興',
    地址: '宜蘭縣五結鄉五結路三段258號',
    縣市: '宜蘭縣'
  },
  {
    店號: 211815,
    店名: '美宜',
    地址: '宜蘭縣壯圍鄉大福路三段362號1樓362號2樓之1',
    縣市: '宜蘭縣'
  },
  {
    店號: 216038,
    店名: '同慶',
    地址: '宜蘭縣宜蘭市中山路三段203號205號207號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 217042,
    店名: '三星',
    地址: '宜蘭縣三星鄉義德村三星路五段228號',
    縣市: '宜蘭縣'
  },
  {
    店號: 217064,
    店名: '樸隱',
    地址: '宜蘭縣三星鄉大隱村三星路二段25鄰13號',
    縣市: '宜蘭縣'
  },
  {
    店號: 217075,
    店名: '詠淇',
    地址: '宜蘭縣冬山鄉香和村冬山路一段725號',
    縣市: '宜蘭縣'
  },
  {
    店號: 228097,
    店名: '天送埤',
    地址: '宜蘭縣三星鄉三星路七段208號',
    縣市: '宜蘭縣'
  },
  {
    店號: 228145,
    店名: '永鎮',
    地址: '宜蘭縣壯圍鄉壯濱路四段373號373之1號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 229344,
    店名: '上將',
    地址: '宜蘭縣三星鄉上將路一段381號',
    縣市: '宜蘭縣'
  },
  {
    店號: 230344,
    店名: '泉和',
    地址: '宜蘭縣礁溪鄉礁溪路四段150號156號',
    縣市: '宜蘭縣'
  },
  {
    店號: 231222,
    店名: '蘇濱',
    地址: '宜蘭縣蘇澳鎮蘇濱路三段61號63號65號',
    縣市: '宜蘭縣'
  },
  {
    店號: 231738,
    店名: '五源',
    地址: '宜蘭縣五結鄉五結路二段332號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 231875,
    店名: '南山',
    地址: '宜蘭縣大同鄉南山村泰雅路七段220號',
    縣市: '宜蘭縣'
  },
  {
    店號: 232177,
    店名: '韌性',
    地址: '宜蘭縣礁溪鄉礁溪路二段49號51號',
    縣市: '宜蘭縣'
  },
  {
    店號: 236700,
    店名: '潤霖',
    地址: '宜蘭縣羅東鎮公正路136號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 236711,
    店名: '宜莊',
    地址: '宜蘭縣宜蘭市光復路26號',
    縣市: '宜蘭縣'
  },
  {
    店號: 236722,
    店名: '利陶',
    地址: '宜蘭縣羅東鎮興東南路188號',
    縣市: '宜蘭縣'
  },
  {
    店號: 240259,
    店名: '家燕',
    地址: '宜蘭縣頭城鎮青雲路二段230號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 240433,
    店名: '詮祥',
    地址: '宜蘭縣頭城鎮中山區青雲路三段238號240號',
    縣市: '宜蘭縣'
  },
  {
    店號: 240444,
    店名: '欣銓',
    地址: '宜蘭縣羅東鎮興東路263之1號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 241218,
    店名: '校舍',
    地址: '宜蘭縣宜蘭市校舍路25號',
    縣市: '宜蘭縣'
  },
  {
    店號: 249452,
    店名: '金站',
    地址: '宜蘭縣羅東鎮公正路31號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 249913,
    店名: '宜商',
    地址: '宜蘭縣宜蘭市延平路39之8號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 250751,
    店名: '聖昌',
    地址: '宜蘭縣羅東鎮站前南路260號262號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 882644,
    店名: '義成',
    地址: '宜蘭縣冬山鄉順安村義成路三段2號',
    縣市: '宜蘭縣'
  },
  {
    店號: 882655,
    店名: '南方澳',
    地址: '宜蘭縣蘇澳鎮江夏路27號',
    縣市: '宜蘭縣'
  },
  {
    店號: 890999,
    店名: '佳怡',
    地址: '宜蘭縣員山鄉員山路一段186號',
    縣市: '宜蘭縣'
  },
  {
    店號: 893895,
    店名: '瑞發',
    地址: '宜蘭縣礁溪鄉德陽路65號',
    縣市: '宜蘭縣'
  },
  {
    店號: 903521,
    店名: '大福',
    地址: '宜蘭縣壯圍鄉大福村壯濱路六段222號',
    縣市: '宜蘭縣'
  },
  {
    店號: 913300,
    店名: '杰昇',
    地址: '宜蘭縣五結鄉二結路107號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 921183,
    店名: '蘇澳港',
    地址: '宜蘭縣蘇澳鎮蘇東中路4號',
    縣市: '宜蘭縣'
  },
  {
    店號: 921297,
    店名: '萬鴻',
    地址: '宜蘭縣員山鄉員山路一段303號305號',
    縣市: '宜蘭縣'
  },
  {
    店號: 923008,
    店名: '同樂',
    地址: '宜蘭縣員山鄉同新路286號',
    縣市: '宜蘭縣'
  },
  {
    店號: 923787,
    店名: '圓鴻',
    地址: '宜蘭縣宜蘭市慈安路40號',
    縣市: '宜蘭縣'
  },
  {
    店號: 930280,
    店名: '嘉融',
    地址: '宜蘭縣礁溪鄉吳沙村礁溪路一段142號',
    縣市: '宜蘭縣'
  },
  {
    店號: 931928,
    店名: '冬山',
    地址: '宜蘭縣冬山鄉冬山路一段984號',
    縣市: '宜蘭縣'
  },
  {
    店號: 932116,
    店名: '永裕',
    地址: '宜蘭縣礁溪鄉中山路二段204號',
    縣市: '宜蘭縣'
  },
  {
    店號: 934514,
    店名: '蘭陽',
    地址: '宜蘭縣宜蘭市中山路二段101號',
    縣市: '宜蘭縣'
  },
  {
    店號: 942238,
    店名: '立昇',
    地址: '宜蘭縣三星鄉大洲村大洲路54之10號1樓上將路2段357號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 951564,
    店名: '壯圍',
    地址: '宜蘭縣壯圍鄉壯五路143之3號',
    縣市: '宜蘭縣'
  },
  {
    店號: 952338,
    店名: '親河',
    地址: '宜蘭縣五結鄉親河路二段289號',
    縣市: '宜蘭縣'
  },
  {
    店號: 962335,
    店名: '權中',
    地址: '宜蘭縣羅東鎮民權路177號',
    縣市: '宜蘭縣'
  },
  {
    店號: 965909,
    店名: '永聖',
    地址: '宜蘭縣礁溪鄉大忠村大忠路120-122號',
    縣市: '宜蘭縣'
  },
  {
    店號: 967167,
    店名: '布蘭其',
    地址: '宜蘭縣五結鄉協和村親河路一段140號',
    縣市: '宜蘭縣'
  },
  {
    店號: 970233,
    店名: '宣宏',
    地址: '宜蘭縣羅東鎮復興路二段257號',
    縣市: '宜蘭縣'
  },
  {
    店號: 977418,
    店名: '宜泰',
    地址: '宜蘭縣羅東鎮公園路100號',
    縣市: '宜蘭縣'
  },
  {
    店號: 981392,
    店名: '湯圍',
    地址: '宜蘭縣礁溪鄉礁溪路五段51號',
    縣市: '宜蘭縣'
  },
  {
    店號: 991115,
    店名: '羅義',
    地址: '宜蘭縣冬山鄉義成路三段361號363號1樓',
    縣市: '宜蘭縣'
  },
  {
    店號: 993476,
    店名: '潤昌',
    地址: '宜蘭縣羅東鎮中山路四段197號199號',
    縣市: '宜蘭縣'
  },
  {
    店號: 993513,
    店名: '聖博',
    地址: '宜蘭縣羅東鎮南昌街53巷6-3號',
    縣市: '宜蘭縣'
  },
  {
    店號: 997537,
    店名: '蘇中',
    地址: '宜蘭縣蘇澳鎮中山路一段263號',
    縣市: '宜蘭縣'
  },
  {
    店號: 132839,
    店名: '馬祖',
    地址: '連江縣南竿鄉介壽村215號1樓',
    縣市: '連江縣'
  },
  {
    店號: 188957,
    店名: '東引',
    地址: '連江縣東引鄉中柳村85與86號1樓',
    縣市: '連江縣'
  },
  {
    店號: 194055,
    店名: '福澳港',
    地址: '連江縣南竿鄉福澳村129號',
    縣市: '連江縣'
  },
  {
    店號: 206617,
    店名: '山隴',
    地址: '連江縣南竿鄉介壽村232號233號284號',
    縣市: '連江縣'
  },
  {
    店號: 208174,
    店名: '芹壁',
    地址: '連江縣北竿鄉芹壁村48號',
    縣市: '連江縣'
  },
  {
    店號: 209029,
    店名: '東莒',
    地址: '連江縣莒光鄉大坪村27號',
    縣市: '連江縣'
  },
  {
    店號: 250223,
    店名: '坪里',
    地址: '連江縣北竿鄉?里村42號1樓',
    縣市: '連江縣'
  },
  {
    店號: 250348,
    店名: '塘岐',
    地址: '連江縣北竿鄉塘岐村219號',
    縣市: '連江縣'
  },
  {
    店號: 950376,
    店名: '南竿',
    地址: '連江縣南竿鄉清水村100號',
    縣市: '連江縣'
  },
  {
    店號: 952512,
    店名: '馬港',
    地址: '連江縣南竿鄉馬祖村中山路58號60號',
    縣市: '連江縣'
  },
  {
    店號: 952523,
    店名: '北竿',
    地址: '連江縣北竿鄉塘岐村中山路191號193號195號',
    縣市: '連江縣'
  },
  {
    店號: 991322,
    店名: '中隴',
    地址: '連江縣南竿鄉介壽村3鄰48-2號',
    縣市: '連江縣'
  },
  {
    店號: 116206,
    店名: '金冠',
    地址: '金門縣金湖鎮環島南路湖前段2號4號',
    縣市: '金門縣'
  },
  {
    店號: 173977,
    店名: '小金',
    地址: '金門縣烈嶼鄉林湖村東林街156號',
    縣市: '金門縣'
  },
  {
    店號: 183871,
    店名: '中蘭',
    地址: '金門縣金沙鎮環島北路三段482號',
    縣市: '金門縣'
  },
  {
    店號: 186146,
    店名: '金生',
    地址: '金門縣金城鎮西門里民生路67.69號',
    縣市: '金門縣'
  },
  {
    店號: 194192,
    店名: '鈦湖',
    地址: '金門縣金湖鎮新市里太湖路二段217號1樓',
    縣市: '金門縣'
  },
  {
    店號: 195508,
    店名: '金門大',
    地址: '金門縣金寧鄉環島北路一段162號',
    縣市: '金門縣'
  },
  {
    店號: 199898,
    店名: '金囍',
    地址: '金門縣金湖鎮復興路115號.115-1號.115-2號.115-3號',
    縣市: '金門縣'
  },
  {
    店號: 208369,
    店名: '金門城',
    地址: '金門縣金城鎮金門城128-6號',
    縣市: '金門縣'
  },
  {
    店號: 210351,
    店名: '金門醫',
    地址: '金門縣金湖鎮復興路2-1號1樓',
    縣市: '金門縣'
  },
  {
    店號: 215091,
    店名: '樂多',
    地址: '金門縣金寧鄉伯玉路二段229號',
    縣市: '金門縣'
  },
  {
    店號: 215792,
    店名: '金民',
    地址: '金門縣金城鎮民生路6號',
    縣市: '金門縣'
  },
  {
    店號: 216326,
    店名: '陽翟',
    地址: '金門縣金沙鎮光前里陽翟新興街23.23-1號',
    縣市: '金門縣'
  },
  {
    店號: 227762,
    店名: '太武山',
    地址: '金門縣金湖鎮太湖路一段29號',
    縣市: '金門縣'
  },
  {
    店號: 237518,
    店名: '金港',
    地址: '金門縣金城鎮西海路一段1號',
    縣市: '金門縣'
  },
  {
    店號: 237851,
    店名: '金央',
    地址: '金門縣金寧鄉伯玉路一段222之8號1樓',
    縣市: '金門縣'
  },
  {
    店號: 239916,
    店名: '金誼',
    地址: '金門縣金城鎮南門里浯江北堤路100號',
    縣市: '金門縣'
  },
  {
    店號: 241263,
    店名: '下埔下',
    地址: '金門縣金寧鄉慈湖路一段69.71號',
    縣市: '金門縣'
  },
  {
    店號: 250108,
    店名: '新山外',
    地址: '金門縣金湖鎮山外里復興西路2號',
    縣市: '金門縣'
  },
  {
    店號: 882921,
    店名: '金亮',
    地址: '金門縣金城鎮民權路73號1F2F75號1F2F光前路85-2號1F85-3號1F',
    縣市: '金門縣'
  },
  {
    店號: 970037,
    店名: '新再發',
    地址: '金門縣金湖鎮復興路8號10號',
    縣市: '金門縣'
  },
  {
    店號: 970059,
    店名: '新沙美',
    地址: '金門縣金沙鎮汶沙里國中路2號',
    縣市: '金門縣'
  },
  {
    店號: 970820,
    店名: '金寧',
    地址: '金門縣金寧鄉環島北路一段711號',
    縣市: '金門縣'
  },
  {
    店號: 981598,
    店名: '金豪',
    地址: '金門縣金城鎮西海路三段1號3號5號1樓',
    縣市: '金門縣'
  },
  {
    店號: 992705,
    店名: '金石',
    地址: '金門縣金城鎮民權路192號196號1樓',
    縣市: '金門縣'
  },
  {
    店號: 113506,
    店名: '揚光',
    地址: '澎湖縣馬公市陽明里中華路175號1樓',
    縣市: '澎湖縣'
  },
  {
    店號: 113883,
    店名: '東衛',
    地址: '澎湖縣馬公市東衛里19鄰9之2號',
    縣市: '澎湖縣'
  },
  {
    店號: 120467,
    店名: '文澳',
    地址: '澎湖縣馬公市文山路53號1樓',
    縣市: '澎湖縣'
  },
  {
    店號: 130095,
    店名: '湖西',
    地址: '澎湖縣湖西鄉湖西村湖西140之1號',
    縣市: '澎湖縣'
  },
  {
    店號: 142869,
    店名: '澎衛',
    地址: '澎湖縣馬公市西衛里光復路408號',
    縣市: '澎湖縣'
  },
  {
    店號: 151391,
    店名: '鎖港',
    地址: '澎湖縣馬公市鎖港里鎖管港段1439號',
    縣市: '澎湖縣'
  },
  {
    店號: 153869,
    店名: '七美',
    地址: '澎湖縣七美鄉南港村南滬50號51號',
    縣市: '澎湖縣'
  },
  {
    店號: 153892,
    店名: '澎文',
    地址: '澎湖縣馬公市東文里文山路282號',
    縣市: '澎湖縣'
  },
  {
    店號: 166740,
    店名: '澎興',
    地址: '澎湖縣馬公市興仁里雙頭掛1之2號',
    縣市: '澎湖縣'
  },
  {
    店號: 181750,
    店名: '馬航',
    地址: '澎湖縣湖西鄉隘門村126之5號1樓(馬公航空站一樓航廈)',
    縣市: '澎湖縣'
  },
  {
    店號: 184140,
    店名: '北岸',
    地址: '澎湖縣馬公市西文里新店路359號1樓',
    縣市: '澎湖縣'
  },
  {
    店號: 188201,
    店名: '跨海',
    地址: '澎湖縣西嶼鄉合界村3-1號',
    縣市: '澎湖縣'
  },
  {
    店號: 194310,
    店名: '航空城',
    地址: '澎湖縣馬公市烏崁里烏崁106-20號',
    縣市: '澎湖縣'
  },
  {
    店號: 195081,
    店名: '講美',
    地址: '澎湖縣白沙鄉講美村78號1樓',
    縣市: '澎湖縣'
  },
  {
    店號: 195483,
    店名: '南洋',
    地址: '澎湖縣馬公市新營路25號1樓',
    縣市: '澎湖縣'
  },
  {
    店號: 202095,
    店名: '西文',
    地址: '澎湖縣馬公市西文里10-3號',
    縣市: '澎湖縣'
  },
  {
    店號: 209476,
    店名: '海藍',
    地址: '澎湖縣馬公市西文澳118-3號',
    縣市: '澎湖縣'
  },
  {
    店號: 228008,
    店名: '澎科大',
    地址: '澎湖縣馬公市六合路300號',
    縣市: '澎湖縣'
  },
  {
    店號: 229366,
    店名: '澎港',
    地址: '澎湖縣馬公市鎖港里292號1樓',
    縣市: '澎湖縣'
  },
  {
    店號: 237932,
    店名: '永興順',
    地址: '澎湖縣湖西鄉隘門34之2號',
    縣市: '澎湖縣'
  },
  {
    店號: 238809,
    店名: '治平',
    地址: '澎湖縣馬公市治平路26-1號',
    縣市: '澎湖縣'
  },
  {
    店號: 880590,
    店名: '澎灣',
    地址: '澎湖縣馬公市中華路56號',
    縣市: '澎湖縣'
  },
  {
    店號: 892571,
    店名: '天人菊',
    地址: '澎湖縣馬公市中央里仁愛路69號',
    縣市: '澎湖縣'
  },
  {
    店號: 900762,
    店名: '西衛',
    地址: '澎湖縣馬公市光榮里光復路297號',
    縣市: '澎湖縣'
  },
  {
    店號: 900795,
    店名: '白沙',
    地址: '澎湖縣白沙鄉赤崁村20鄰大赤崁351號1樓',
    縣市: '澎湖縣'
  },
  {
    店號: 901891,
    店名: '新澎湖',
    地址: '澎湖縣馬公市重慶里民權路98號',
    縣市: '澎湖縣'
  },
  {
    店號: 909574,
    店名: '石泉',
    地址: '澎湖縣馬公市石泉里1-300號',
    縣市: '澎湖縣'
  },
  {
    店號: 922201,
    店名: '文光',
    地址: '澎湖縣馬公市光榮里三多路338號',
    縣市: '澎湖縣'
  },
  {
    店號: 930545,
    店名: '新台澎',
    地址: '澎湖縣馬公市中正路85號',
    縣市: '澎湖縣'
  },
  {
    店號: 941202,
    店名: '澎技',
    地址: '澎湖縣馬公市朝陽里三多路45號',
    縣市: '澎湖縣'
  },
  {
    店號: 941833,
    店名: '井垵',
    地址: '澎湖縣馬公市井垵里1-18號',
    縣市: '澎湖縣'
  },
  {
    店號: 951106,
    店名: '漁翁',
    地址: '澎湖縣西嶼鄉外垵村113號',
    縣市: '澎湖縣'
  },
  {
    店號: 981750,
    店名: '百麗',
    地址: '澎湖縣馬公市東文里新店路463號1號',
    縣市: '澎湖縣'
  },
  {
    店號: 987806,
    店名: '馬公',
    地址: '澎湖縣馬公市光復路59號',
    縣市: '澎湖縣'
  }
]

